/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as UnresponsiveRouteImport } from './routes/unresponsive/route'
import { Route as DashboardRouteImport } from './routes/dashboard/route'
import { Route as AdminDashboardRouteImport } from './routes/admin-dashboard/route'
import { Route as IndexImport } from './routes/index'
import { Route as DashboardIndexImport } from './routes/dashboard/index'
import { Route as AdminDashboardIndexImport } from './routes/admin-dashboard/index'
import { Route as NextSplatImport } from './routes/next.$'
import { Route as DashboardSupportImport } from './routes/dashboard/support'
import { Route as DashboardHomeImport } from './routes/dashboard/home'
import { Route as DashboardUnauthorizedRouteImport } from './routes/dashboard/unauthorized/route'
import { Route as DashboardSettingsRouteImport } from './routes/dashboard/settings/route'
import { Route as DashboardResourcesRouteImport } from './routes/dashboard/resources/route'
import { Route as DashboardReportsRouteImport } from './routes/dashboard/reports/route'
import { Route as DashboardModelsRouteImport } from './routes/dashboard/models/route'
import { Route as DashboardJobsRouteImport } from './routes/dashboard/jobs/route'
import { Route as DashboardDataRouteImport } from './routes/dashboard/data/route'
import { Route as DashboardAlertsRouteImport } from './routes/dashboard/alerts/route'
import { Route as AdminDashboardNotificationsRouteImport } from './routes/admin-dashboard/notifications/route'
import { Route as AdminDashboardJobsRouteImport } from './routes/admin-dashboard/jobs/route'
import { Route as AdminDashboardDomainAuthSettingsRouteImport } from './routes/admin-dashboard/domain-auth-settings/route'
import { Route as AdminDashboardAccountsManagementRouteImport } from './routes/admin-dashboard/accounts-management/route'
import { Route as DashboardSettingsIndexImport } from './routes/dashboard/settings/index'
import { Route as DashboardResourcesIndexImport } from './routes/dashboard/resources/index'
import { Route as DashboardReportsIndexImport } from './routes/dashboard/reports/index'
import { Route as DashboardJobsIndexImport } from './routes/dashboard/jobs/index'
import { Route as DashboardHomeIndexImport } from './routes/dashboard/home/index'
import { Route as DashboardDataIndexImport } from './routes/dashboard/data/index'
import { Route as DashboardRestImport } from './routes/dashboard/[...rest]'
import { Route as DashboardSettingsUserManagementRouteImport } from './routes/dashboard/settings/user-management/route'
import { Route as DashboardSettingsTagsManagementRouteImport } from './routes/dashboard/settings/tags-management/route'
import { Route as DashboardSettingsReportSettingsRouteImport } from './routes/dashboard/settings/report-settings/route'
import { Route as DashboardSettingsRegionsRouteImport } from './routes/dashboard/settings/regions/route'
import { Route as DashboardSettingsQueuesRouteImport } from './routes/dashboard/settings/queues/route'
import { Route as DashboardSettingsPermissionsSettingsDevRouteImport } from './routes/dashboard/settings/permissions-settings-dev/route'
import { Route as DashboardSettingsPermissionsSettingsRouteImport } from './routes/dashboard/settings/permissions-settings/route'
import { Route as DashboardSettingsOverviewRouteImport } from './routes/dashboard/settings/overview/route'
import { Route as DashboardSettingsJobDefaultsRouteImport } from './routes/dashboard/settings/job-defaults/route'
import { Route as DashboardSettingsAlertManagementRouteImport } from './routes/dashboard/settings/alert-management/route'
import { Route as DashboardResourcesSitesRouteImport } from './routes/dashboard/resources/sites/route'
import { Route as DashboardResourcesSiteGroupsRouteImport } from './routes/dashboard/resources/site-groups/route'
import { Route as DashboardResourcesDevicesRouteImport } from './routes/dashboard/resources/devices/route'
import { Route as DashboardResourcesClustersRouteImport } from './routes/dashboard/resources/clusters/route'
import { Route as DashboardReportsCompanionRouteImport } from './routes/dashboard/reports/companion/route'
import { Route as DashboardReportsAnalyticsHubRouteImport } from './routes/dashboard/reports/analytics-hub/route'
import { Route as DashboardReportsReportIdRouteImport } from './routes/dashboard/reports/$reportId/route'
import { Route as DashboardModelsModelIdRouteImport } from './routes/dashboard/models/$modelId/route'
import { Route as DashboardJobsWorkerJobsRouteImport } from './routes/dashboard/jobs/worker-jobs/route'
import { Route as DashboardJobsVideoUploadRouteImport } from './routes/dashboard/jobs/video-upload/route'
import { Route as DashboardJobsTrainingRouteImport } from './routes/dashboard/jobs/training/route'
import { Route as DashboardJobsSyncSamplesRouteImport } from './routes/dashboard/jobs/sync-samples/route'
import { Route as DashboardJobsSampleUploadRouteImport } from './routes/dashboard/jobs/sample-upload/route'
import { Route as DashboardJobsRestartsRouteImport } from './routes/dashboard/jobs/restarts/route'
import { Route as DashboardJobsRecoveryEstimatesRouteImport } from './routes/dashboard/jobs/recovery-estimates/route'
import { Route as DashboardJobsModelsRouteImport } from './routes/dashboard/jobs/models/route'
import { Route as DashboardJobsHeadBlurVideosRouteImport } from './routes/dashboard/jobs/head-blur-videos/route'
import { Route as DashboardJobsHeadBlurImagesRouteImport } from './routes/dashboard/jobs/head-blur-images/route'
import { Route as DashboardJobsDeploymentsRouteImport } from './routes/dashboard/jobs/deployments/route'
import { Route as DashboardJobsDeleteVideosRouteImport } from './routes/dashboard/jobs/delete-videos/route'
import { Route as DashboardJobsDeleteSamplesRouteImport } from './routes/dashboard/jobs/delete-samples/route'
import { Route as DashboardJobsConfigRouteImport } from './routes/dashboard/jobs/config/route'
import { Route as DashboardJobsCatalogUploadRouteImport } from './routes/dashboard/jobs/catalog-upload/route'
import { Route as DashboardJobsCapacityTaggingRouteImport } from './routes/dashboard/jobs/capacity-tagging/route'
import { Route as DashboardJobsCameraCalibrationRouteImport } from './routes/dashboard/jobs/camera-calibration/route'
import { Route as DashboardHomeManagerReportRouteImport } from './routes/dashboard/home/manager-report/route'
import { Route as DashboardDataSessionsRouteImport } from './routes/dashboard/data/sessions/route'
import { Route as DashboardDataPendingRouteImport } from './routes/dashboard/data/pending/route'
import { Route as DashboardDataLabelDistributionRouteImport } from './routes/dashboard/data/label-distribution/route'
import { Route as DashboardDataJsonDataRouteImport } from './routes/dashboard/data/json-data/route'
import { Route as DashboardDataImagesRouteImport } from './routes/dashboard/data/images/route'
import { Route as DashboardDataDatasetsRouteImport } from './routes/dashboard/data/datasets/route'
import { Route as DashboardDataCatalogRouteImport } from './routes/dashboard/data/catalog/route'
import { Route as DashboardDataAnnotationsRouteImport } from './routes/dashboard/data/annotations/route'
import { Route as AdminDashboardNotificationsNotificationIdRouteImport } from './routes/admin-dashboard/notifications/$notificationId/route'
import { Route as AdminDashboardJobsServiceHealthChecksRouteImport } from './routes/admin-dashboard/jobs/service-health-checks/route'
import { Route as AdminDashboardAccountsManagementAccountIdRouteImport } from './routes/admin-dashboard/accounts-management/$accountId/route'
import { Route as DashboardSettingsTagsManagementIndexImport } from './routes/dashboard/settings/tags-management/index'
import { Route as DashboardSettingsQueuesIndexImport } from './routes/dashboard/settings/queues/index'
import { Route as DashboardSettingsAlertManagementIndexImport } from './routes/dashboard/settings/alert-management/index'
import { Route as DashboardModelsModelIdIndexImport } from './routes/dashboard/models/$modelId/index'
import { Route as DashboardJobsWorkerJobsIndexImport } from './routes/dashboard/jobs/worker-jobs/index'
import { Route as DashboardJobsVideoUploadIndexImport } from './routes/dashboard/jobs/video-upload/index'
import { Route as DashboardJobsTrainingIndexImport } from './routes/dashboard/jobs/training/index'
import { Route as DashboardJobsSyncSamplesIndexImport } from './routes/dashboard/jobs/sync-samples/index'
import { Route as DashboardJobsSampleUploadIndexImport } from './routes/dashboard/jobs/sample-upload/index'
import { Route as DashboardJobsRestartsIndexImport } from './routes/dashboard/jobs/restarts/index'
import { Route as DashboardJobsRecoveryEstimatesIndexImport } from './routes/dashboard/jobs/recovery-estimates/index'
import { Route as DashboardJobsModelsIndexImport } from './routes/dashboard/jobs/models/index'
import { Route as DashboardJobsHeadBlurVideosIndexImport } from './routes/dashboard/jobs/head-blur-videos/index'
import { Route as DashboardJobsHeadBlurImagesIndexImport } from './routes/dashboard/jobs/head-blur-images/index'
import { Route as DashboardJobsDeploymentsIndexImport } from './routes/dashboard/jobs/deployments/index'
import { Route as DashboardJobsDeleteVideosIndexImport } from './routes/dashboard/jobs/delete-videos/index'
import { Route as DashboardJobsDeleteSamplesIndexImport } from './routes/dashboard/jobs/delete-samples/index'
import { Route as DashboardJobsConfigIndexImport } from './routes/dashboard/jobs/config/index'
import { Route as DashboardJobsCatalogUploadIndexImport } from './routes/dashboard/jobs/catalog-upload/index'
import { Route as DashboardJobsCapacityTaggingIndexImport } from './routes/dashboard/jobs/capacity-tagging/index'
import { Route as DashboardJobsCameraCalibrationIndexImport } from './routes/dashboard/jobs/camera-calibration/index'
import { Route as DashboardHomeManagerReportIndexImport } from './routes/dashboard/home/manager-report/index'
import { Route as AdminDashboardJobsServiceHealthChecksIndexImport } from './routes/admin-dashboard/jobs/service-health-checks/index'
import { Route as AdminDashboardAccountsManagementAccountIdIndexImport } from './routes/admin-dashboard/accounts-management/$accountId/index'
import { Route as DashboardSettingsUserManagementThumbnailImport } from './routes/dashboard/settings/user-management/thumbnail'
import { Route as DashboardResourcesRestImport } from './routes/dashboard/resources/[...rest]'
import { Route as DashboardDataRestImport } from './routes/dashboard/data/[...rest]'
import { Route as DashboardSettingsUserManagementUserIdRouteImport } from './routes/dashboard/settings/user-management/$userId/route'
import { Route as DashboardSettingsTagsManagementSitesRouteImport } from './routes/dashboard/settings/tags-management/sites/route'
import { Route as DashboardSettingsTagsManagementSessionsRouteImport } from './routes/dashboard/settings/tags-management/sessions/route'
import { Route as DashboardSettingsTagsManagementSamplesRouteImport } from './routes/dashboard/settings/tags-management/samples/route'
import { Route as DashboardSettingsTagsManagementDevicesRouteImport } from './routes/dashboard/settings/tags-management/devices/route'
import { Route as DashboardSettingsTagsManagementClustersRouteImport } from './routes/dashboard/settings/tags-management/clusters/route'
import { Route as DashboardSettingsTagsManagementCatalogRouteImport } from './routes/dashboard/settings/tags-management/catalog/route'
import { Route as DashboardSettingsReportSettingsReportIdRouteImport } from './routes/dashboard/settings/report-settings/$reportId/route'
import { Route as DashboardSettingsQueuesQueueNameRouteImport } from './routes/dashboard/settings/queues/$queueName/route'
import { Route as DashboardSettingsAlertManagementMetricAlertsRouteImport } from './routes/dashboard/settings/alert-management/metric-alerts/route'
import { Route as DashboardSettingsAlertManagementAlertsRouteImport } from './routes/dashboard/settings/alert-management/alerts/route'
import { Route as DashboardSettingsAlertManagementAlertChannelsRouteImport } from './routes/dashboard/settings/alert-management/alert-channels/route'
import { Route as DashboardResourcesSitesSiteIdRouteImport } from './routes/dashboard/resources/sites/$siteId/route'
import { Route as DashboardResourcesSiteGroupsSiteGroupIdRouteImport } from './routes/dashboard/resources/site-groups/$siteGroupId/route'
import { Route as DashboardResourcesDevicesDeviceIdRouteImport } from './routes/dashboard/resources/devices/$deviceId/route'
import { Route as DashboardResourcesClustersClusterIdRouteImport } from './routes/dashboard/resources/clusters/$clusterId/route'
import { Route as DashboardModelsModelIdOverviewRouteImport } from './routes/dashboard/models/$modelId/overview/route'
import { Route as DashboardModelsModelIdMatrixRouteImport } from './routes/dashboard/models/$modelId/matrix/route'
import { Route as DashboardModelsModelIdLabelsRouteImport } from './routes/dashboard/models/$modelId/labels/route'
import { Route as DashboardModelsModelIdDeploymentRouteImport } from './routes/dashboard/models/$modelId/deployment/route'
import { Route as DashboardJobsWorkerJobsScheduleRouteImport } from './routes/dashboard/jobs/worker-jobs/schedule/route'
import { Route as DashboardJobsWorkerJobsJobsRouteImport } from './routes/dashboard/jobs/worker-jobs/jobs/route'
import { Route as DashboardJobsVideoUploadScheduleRouteImport } from './routes/dashboard/jobs/video-upload/schedule/route'
import { Route as DashboardJobsVideoUploadJobsRouteImport } from './routes/dashboard/jobs/video-upload/jobs/route'
import { Route as DashboardJobsVideoUploadAlertsRouteImport } from './routes/dashboard/jobs/video-upload/alerts/route'
import { Route as DashboardJobsTrainingScheduleRouteImport } from './routes/dashboard/jobs/training/schedule/route'
import { Route as DashboardJobsTrainingJobsRouteImport } from './routes/dashboard/jobs/training/jobs/route'
import { Route as DashboardJobsSyncSamplesScheduleRouteImport } from './routes/dashboard/jobs/sync-samples/schedule/route'
import { Route as DashboardJobsSyncSamplesJobsRouteImport } from './routes/dashboard/jobs/sync-samples/jobs/route'
import { Route as DashboardJobsSyncSamplesAlertsRouteImport } from './routes/dashboard/jobs/sync-samples/alerts/route'
import { Route as DashboardJobsSampleUploadScheduleRouteImport } from './routes/dashboard/jobs/sample-upload/schedule/route'
import { Route as DashboardJobsSampleUploadJobsRouteImport } from './routes/dashboard/jobs/sample-upload/jobs/route'
import { Route as DashboardJobsSampleUploadAlertsRouteImport } from './routes/dashboard/jobs/sample-upload/alerts/route'
import { Route as DashboardJobsRestartsScheduleRouteImport } from './routes/dashboard/jobs/restarts/schedule/route'
import { Route as DashboardJobsRestartsJobsRouteImport } from './routes/dashboard/jobs/restarts/jobs/route'
import { Route as DashboardJobsRecoveryEstimatesScheduleRouteImport } from './routes/dashboard/jobs/recovery-estimates/schedule/route'
import { Route as DashboardJobsRecoveryEstimatesJobsRouteImport } from './routes/dashboard/jobs/recovery-estimates/jobs/route'
import { Route as DashboardJobsModelsScheduleRouteImport } from './routes/dashboard/jobs/models/schedule/route'
import { Route as DashboardJobsModelsJobsRouteImport } from './routes/dashboard/jobs/models/jobs/route'
import { Route as DashboardJobsHeadBlurVideosScheduleRouteImport } from './routes/dashboard/jobs/head-blur-videos/schedule/route'
import { Route as DashboardJobsHeadBlurVideosJobsRouteImport } from './routes/dashboard/jobs/head-blur-videos/jobs/route'
import { Route as DashboardJobsHeadBlurImagesScheduleRouteImport } from './routes/dashboard/jobs/head-blur-images/schedule/route'
import { Route as DashboardJobsHeadBlurImagesJobsRouteImport } from './routes/dashboard/jobs/head-blur-images/jobs/route'
import { Route as DashboardJobsDeploymentsScheduleRouteImport } from './routes/dashboard/jobs/deployments/schedule/route'
import { Route as DashboardJobsDeploymentsJobsRouteImport } from './routes/dashboard/jobs/deployments/jobs/route'
import { Route as DashboardJobsDeleteVideosScheduleRouteImport } from './routes/dashboard/jobs/delete-videos/schedule/route'
import { Route as DashboardJobsDeleteVideosJobsRouteImport } from './routes/dashboard/jobs/delete-videos/jobs/route'
import { Route as DashboardJobsDeleteVideosAlertsRouteImport } from './routes/dashboard/jobs/delete-videos/alerts/route'
import { Route as DashboardJobsDeleteSamplesScheduleRouteImport } from './routes/dashboard/jobs/delete-samples/schedule/route'
import { Route as DashboardJobsDeleteSamplesJobsRouteImport } from './routes/dashboard/jobs/delete-samples/jobs/route'
import { Route as DashboardJobsDeleteSamplesAlertsRouteImport } from './routes/dashboard/jobs/delete-samples/alerts/route'
import { Route as DashboardJobsConfigScheduleRouteImport } from './routes/dashboard/jobs/config/schedule/route'
import { Route as DashboardJobsConfigJobsRouteImport } from './routes/dashboard/jobs/config/jobs/route'
import { Route as DashboardJobsCatalogUploadScheduleRouteImport } from './routes/dashboard/jobs/catalog-upload/schedule/route'
import { Route as DashboardJobsCatalogUploadJobsRouteImport } from './routes/dashboard/jobs/catalog-upload/jobs/route'
import { Route as DashboardJobsCapacityTaggingScheduleRouteImport } from './routes/dashboard/jobs/capacity-tagging/schedule/route'
import { Route as DashboardJobsCapacityTaggingJobsRouteImport } from './routes/dashboard/jobs/capacity-tagging/jobs/route'
import { Route as DashboardJobsCameraCalibrationScheduleRouteImport } from './routes/dashboard/jobs/camera-calibration/schedule/route'
import { Route as DashboardJobsCameraCalibrationJobsRouteImport } from './routes/dashboard/jobs/camera-calibration/jobs/route'
import { Route as DashboardJobsCameraCalibrationAlertsRouteImport } from './routes/dashboard/jobs/camera-calibration/alerts/route'
import { Route as DashboardHomeManagerReportSessionIdRouteImport } from './routes/dashboard/home/manager-report/$sessionId/route'
import { Route as DashboardDataSessionsSessionIdRouteImport } from './routes/dashboard/data/sessions/$sessionId/route'
import { Route as DashboardDataLabelDistributionLabelRouteImport } from './routes/dashboard/data/label-distribution/$label/route'
import { Route as DashboardDataJsonDataJsonDataUUIDRouteImport } from './routes/dashboard/data/json-data/$jsonDataUUID/route'
import { Route as DashboardDataImagesImageUUIDRouteImport } from './routes/dashboard/data/images/$imageUUID/route'
import { Route as DashboardDataDatasetsDatasetIdRouteImport } from './routes/dashboard/data/datasets/$datasetId/route'
import { Route as DashboardDataCatalogItemRouteImport } from './routes/dashboard/data/catalog/$item/route'
import { Route as AdminDashboardNotificationsNotificationIdOverviewRouteImport } from './routes/admin-dashboard/notifications/$notificationId/overview/route'
import { Route as AdminDashboardJobsServiceHealthChecksScheduleRouteImport } from './routes/admin-dashboard/jobs/service-health-checks/schedule/route'
import { Route as AdminDashboardJobsServiceHealthChecksJobsRouteImport } from './routes/admin-dashboard/jobs/service-health-checks/jobs/route'
import { Route as AdminDashboardAccountsManagementAccountIdRegionsRouteImport } from './routes/admin-dashboard/accounts-management/$accountId/regions/route'
import { Route as AdminDashboardAccountsManagementAccountIdOverviewRouteImport } from './routes/admin-dashboard/accounts-management/$accountId/overview/route'
import { Route as AdminDashboardAccountsManagementAccountIdOperationalHoursRouteImport } from './routes/admin-dashboard/accounts-management/$accountId/operational-hours/route'
import { Route as DashboardSettingsUserManagementUserIdIndexImport } from './routes/dashboard/settings/user-management/$userId/index'
import { Route as DashboardSettingsReportSettingsReportIdIndexImport } from './routes/dashboard/settings/report-settings/$reportId/index'
import { Route as DashboardSettingsQueuesQueueNameIndexImport } from './routes/dashboard/settings/queues/$queueName/index'
import { Route as DashboardResourcesSitesSiteIdIndexImport } from './routes/dashboard/resources/sites/$siteId/index'
import { Route as DashboardResourcesSiteGroupsSiteGroupIdIndexImport } from './routes/dashboard/resources/site-groups/$siteGroupId/index'
import { Route as DashboardResourcesDevicesDeviceIdIndexImport } from './routes/dashboard/resources/devices/$deviceId/index'
import { Route as DashboardResourcesClustersClusterIdIndexImport } from './routes/dashboard/resources/clusters/$clusterId/index'
import { Route as DashboardModelsModelIdDeploymentIndexImport } from './routes/dashboard/models/$modelId/deployment/index'
import { Route as DashboardHomeManagerReportSessionIdIndexImport } from './routes/dashboard/home/manager-report/$sessionId/index'
import { Route as DashboardDataSessionsSessionIdIndexImport } from './routes/dashboard/data/sessions/$sessionId/index'
import { Route as DashboardDataLabelDistributionLabelIndexImport } from './routes/dashboard/data/label-distribution/$label/index'
import { Route as DashboardDataJsonDataJsonDataUUIDIndexImport } from './routes/dashboard/data/json-data/$jsonDataUUID/index'
import { Route as DashboardDataImagesImageUUIDIndexImport } from './routes/dashboard/data/images/$imageUUID/index'
import { Route as DashboardDataCatalogItemIndexImport } from './routes/dashboard/data/catalog/$item/index'
import { Route as DashboardDataJsonDataJsonDataUUIDOverviewImport } from './routes/dashboard/data/json-data/$jsonDataUUID/overview'
import { Route as DashboardSettingsUserManagementUserIdOverviewRouteImport } from './routes/dashboard/settings/user-management/$userId/overview/route'
import { Route as DashboardSettingsTagsManagementSitesTagIdRouteImport } from './routes/dashboard/settings/tags-management/sites/$tagId/route'
import { Route as DashboardSettingsTagsManagementSessionsTagIdRouteImport } from './routes/dashboard/settings/tags-management/sessions/$tagId/route'
import { Route as DashboardSettingsTagsManagementSamplesTagIdRouteImport } from './routes/dashboard/settings/tags-management/samples/$tagId/route'
import { Route as DashboardSettingsTagsManagementDevicesTagIdRouteImport } from './routes/dashboard/settings/tags-management/devices/$tagId/route'
import { Route as DashboardSettingsTagsManagementClustersTagIdRouteImport } from './routes/dashboard/settings/tags-management/clusters/$tagId/route'
import { Route as DashboardSettingsTagsManagementCatalogTagIdRouteImport } from './routes/dashboard/settings/tags-management/catalog/$tagId/route'
import { Route as DashboardSettingsReportSubscriptionReportIdSubscriptionIdRouteImport } from './routes/dashboard/settings/report-subscription/$reportId/$subscriptionId/route'
import { Route as DashboardSettingsReportSettingsReportIdSubscriptions2RouteImport } from './routes/dashboard/settings/report-settings/$reportId/subscriptions2/route'
import { Route as DashboardSettingsReportSettingsReportIdSendLogRouteImport } from './routes/dashboard/settings/report-settings/$reportId/send-log/route'
import { Route as DashboardSettingsReportSettingsReportIdParametersRouteImport } from './routes/dashboard/settings/report-settings/$reportId/parameters/route'
import { Route as DashboardSettingsReportSettingsReportIdOverviewRouteImport } from './routes/dashboard/settings/report-settings/$reportId/overview/route'
import { Route as DashboardSettingsQueuesQueueNamePendingRouteImport } from './routes/dashboard/settings/queues/$queueName/pending/route'
import { Route as DashboardSettingsQueuesQueueNameFailuresRouteImport } from './routes/dashboard/settings/queues/$queueName/failures/route'
import { Route as DashboardSettingsAlertManagementAlertsAlertIdRouteImport } from './routes/dashboard/settings/alert-management/alerts/$alertId/route'
import { Route as DashboardResourcesSitesSiteIdVersionHistoryRouteImport } from './routes/dashboard/resources/sites/$siteId/version-history/route'
import { Route as DashboardResourcesSitesSiteIdOverviewRouteImport } from './routes/dashboard/resources/sites/$siteId/overview/route'
import { Route as DashboardResourcesSitesSiteIdDevicesRouteImport } from './routes/dashboard/resources/sites/$siteId/devices/route'
import { Route as DashboardResourcesSiteGroupsSiteGroupIdSitesRouteImport } from './routes/dashboard/resources/site-groups/$siteGroupId/sites/route'
import { Route as DashboardResourcesSiteGroupsSiteGroupIdOverviewRouteImport } from './routes/dashboard/resources/site-groups/$siteGroupId/overview/route'
import { Route as DashboardResourcesSiteGroupsSiteGroupIdLabelsRouteImport } from './routes/dashboard/resources/site-groups/$siteGroupId/labels/route'
import { Route as DashboardResourcesDevicesDeviceIdVersionHistoryRouteImport } from './routes/dashboard/resources/devices/$deviceId/version-history/route'
import { Route as DashboardResourcesDevicesDeviceIdSettingsRouteImport } from './routes/dashboard/resources/devices/$deviceId/settings/route'
import { Route as DashboardResourcesDevicesDeviceIdOverviewRouteImport } from './routes/dashboard/resources/devices/$deviceId/overview/route'
import { Route as DashboardResourcesDevicesDeviceIdLogsRouteImport } from './routes/dashboard/resources/devices/$deviceId/logs/route'
import { Route as DashboardResourcesDevicesDeviceIdDiagnosticsRouteImport } from './routes/dashboard/resources/devices/$deviceId/diagnostics/route'
import { Route as DashboardResourcesDevicesDeviceIdDataRouteImport } from './routes/dashboard/resources/devices/$deviceId/data/route'
import { Route as DashboardResourcesDevicesDeviceIdCameraRouteImport } from './routes/dashboard/resources/devices/$deviceId/camera/route'
import { Route as DashboardResourcesClustersClusterIdOverviewRouteImport } from './routes/dashboard/resources/clusters/$clusterId/overview/route'
import { Route as DashboardResourcesClustersClusterIdDevicesRouteImport } from './routes/dashboard/resources/clusters/$clusterId/devices/route'
import { Route as DashboardModelsModelIdDeploymentDevicesRouteImport } from './routes/dashboard/models/$modelId/deployment/devices/route'
import { Route as DashboardModelsModelIdDeploymentClustersRouteImport } from './routes/dashboard/models/$modelId/deployment/clusters/route'
import { Route as DashboardJobsWorkerJobsScheduleScheduledJobIdRouteImport } from './routes/dashboard/jobs/worker-jobs/schedule/$scheduledJobId/route'
import { Route as DashboardJobsWorkerJobsJobsJobIdRouteImport } from './routes/dashboard/jobs/worker-jobs/jobs/$jobId/route'
import { Route as DashboardJobsVideoUploadScheduleScheduledJobIdRouteImport } from './routes/dashboard/jobs/video-upload/schedule/$scheduledJobId/route'
import { Route as DashboardJobsVideoUploadJobsJobIdRouteImport } from './routes/dashboard/jobs/video-upload/jobs/$jobId/route'
import { Route as DashboardJobsTrainingScheduleScheduledJobIdRouteImport } from './routes/dashboard/jobs/training/schedule/$scheduledJobId/route'
import { Route as DashboardJobsTrainingJobsJobIdRouteImport } from './routes/dashboard/jobs/training/jobs/$jobId/route'
import { Route as DashboardJobsSyncSamplesScheduleScheduledJobIdRouteImport } from './routes/dashboard/jobs/sync-samples/schedule/$scheduledJobId/route'
import { Route as DashboardJobsSyncSamplesJobsJobIdRouteImport } from './routes/dashboard/jobs/sync-samples/jobs/$jobId/route'
import { Route as DashboardJobsSampleUploadScheduleScheduledJobIdRouteImport } from './routes/dashboard/jobs/sample-upload/schedule/$scheduledJobId/route'
import { Route as DashboardJobsSampleUploadJobsJobIdRouteImport } from './routes/dashboard/jobs/sample-upload/jobs/$jobId/route'
import { Route as DashboardJobsRestartsScheduleScheduledJobIdRouteImport } from './routes/dashboard/jobs/restarts/schedule/$scheduledJobId/route'
import { Route as DashboardJobsRestartsJobsJobIdRouteImport } from './routes/dashboard/jobs/restarts/jobs/$jobId/route'
import { Route as DashboardJobsRecoveryEstimatesScheduleScheduledJobIdRouteImport } from './routes/dashboard/jobs/recovery-estimates/schedule/$scheduledJobId/route'
import { Route as DashboardJobsRecoveryEstimatesJobsJobIdRouteImport } from './routes/dashboard/jobs/recovery-estimates/jobs/$jobId/route'
import { Route as DashboardJobsModelsScheduleScheduledJobIdRouteImport } from './routes/dashboard/jobs/models/schedule/$scheduledJobId/route'
import { Route as DashboardJobsModelsJobsJobIdRouteImport } from './routes/dashboard/jobs/models/jobs/$jobId/route'
import { Route as DashboardJobsHeadBlurVideosScheduleScheduledJobIdRouteImport } from './routes/dashboard/jobs/head-blur-videos/schedule/$scheduledJobId/route'
import { Route as DashboardJobsHeadBlurVideosJobsJobIdRouteImport } from './routes/dashboard/jobs/head-blur-videos/jobs/$jobId/route'
import { Route as DashboardJobsHeadBlurImagesScheduleScheduledJobIdRouteImport } from './routes/dashboard/jobs/head-blur-images/schedule/$scheduledJobId/route'
import { Route as DashboardJobsHeadBlurImagesJobsJobIdRouteImport } from './routes/dashboard/jobs/head-blur-images/jobs/$jobId/route'
import { Route as DashboardJobsDeploymentsScheduleScheduledJobIdRouteImport } from './routes/dashboard/jobs/deployments/schedule/$scheduledJobId/route'
import { Route as DashboardJobsDeploymentsJobsJobIdRouteImport } from './routes/dashboard/jobs/deployments/jobs/$jobId/route'
import { Route as DashboardJobsDeleteVideosScheduleScheduledJobIdRouteImport } from './routes/dashboard/jobs/delete-videos/schedule/$scheduledJobId/route'
import { Route as DashboardJobsDeleteVideosJobsJobIdRouteImport } from './routes/dashboard/jobs/delete-videos/jobs/$jobId/route'
import { Route as DashboardJobsDeleteSamplesScheduleScheduledJobIdRouteImport } from './routes/dashboard/jobs/delete-samples/schedule/$scheduledJobId/route'
import { Route as DashboardJobsDeleteSamplesJobsJobIdRouteImport } from './routes/dashboard/jobs/delete-samples/jobs/$jobId/route'
import { Route as DashboardJobsConfigScheduleScheduledJobIdRouteImport } from './routes/dashboard/jobs/config/schedule/$scheduledJobId/route'
import { Route as DashboardJobsConfigJobsJobIdRouteImport } from './routes/dashboard/jobs/config/jobs/$jobId/route'
import { Route as DashboardJobsCatalogUploadScheduleScheduledJobIdRouteImport } from './routes/dashboard/jobs/catalog-upload/schedule/$scheduledJobId/route'
import { Route as DashboardJobsCatalogUploadJobsJobIdRouteImport } from './routes/dashboard/jobs/catalog-upload/jobs/$jobId/route'
import { Route as DashboardJobsCapacityTaggingScheduleScheduledJobIdRouteImport } from './routes/dashboard/jobs/capacity-tagging/schedule/$scheduledJobId/route'
import { Route as DashboardJobsCapacityTaggingJobsJobIdRouteImport } from './routes/dashboard/jobs/capacity-tagging/jobs/$jobId/route'
import { Route as DashboardJobsCameraCalibrationScheduleScheduledJobIdRouteImport } from './routes/dashboard/jobs/camera-calibration/schedule/$scheduledJobId/route'
import { Route as DashboardJobsCameraCalibrationJobsJobIdRouteImport } from './routes/dashboard/jobs/camera-calibration/jobs/$jobId/route'
import { Route as DashboardHomeManagerReportSessionIdOverviewRouteImport } from './routes/dashboard/home/manager-report/$sessionId/overview/route'
import { Route as DashboardDataSessionsSessionIdOverviewRouteImport } from './routes/dashboard/data/sessions/$sessionId/overview/route'
import { Route as DashboardDataImagesImageUUIDTransactionDetailsRouteImport } from './routes/dashboard/data/images/$imageUUID/transaction-details/route'
import { Route as DashboardDataImagesImageUUIDOverviewRouteImport } from './routes/dashboard/data/images/$imageUUID/overview/route'
import { Route as DashboardDataImagesImageUUIDAdditionalRouteImport } from './routes/dashboard/data/images/$imageUUID/additional/route'
import { Route as DashboardDataDatasetsDatasetIdSessionsRouteImport } from './routes/dashboard/data/datasets/$datasetId/sessions/route'
import { Route as DashboardDataDatasetsDatasetIdOverviewRouteImport } from './routes/dashboard/data/datasets/$datasetId/overview/route'
import { Route as DashboardDataDatasetsDatasetIdImagesRouteImport } from './routes/dashboard/data/datasets/$datasetId/images/route'
import { Route as DashboardDataCatalogItemPricesRouteImport } from './routes/dashboard/data/catalog/$item/prices/route'
import { Route as DashboardDataCatalogItemLabelsRouteImport } from './routes/dashboard/data/catalog/$item/labels/route'
import { Route as DashboardDataCatalogItemDetailsRouteImport } from './routes/dashboard/data/catalog/$item/details/route'
import { Route as AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdRouteImport } from './routes/admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId/route'
import { Route as AdminDashboardJobsServiceHealthChecksJobsJobIdRouteImport } from './routes/admin-dashboard/jobs/service-health-checks/jobs/$jobId/route'
import { Route as DashboardSettingsQueuesQueueNamePendingIndexRouteImport } from './routes/dashboard/settings/queues/$queueName/pending/$index/route'
import { Route as DashboardSettingsQueuesQueueNameFailuresIndexRouteImport } from './routes/dashboard/settings/queues/$queueName/failures/$index/route'
import { Route as DashboardSettingsTagsManagementSitesTagIdIndexImport } from './routes/dashboard/settings/tags-management/sites/$tagId/index'
import { Route as DashboardSettingsTagsManagementSessionsTagIdIndexImport } from './routes/dashboard/settings/tags-management/sessions/$tagId/index'
import { Route as DashboardSettingsTagsManagementSamplesTagIdIndexImport } from './routes/dashboard/settings/tags-management/samples/$tagId/index'
import { Route as DashboardSettingsTagsManagementDevicesTagIdIndexImport } from './routes/dashboard/settings/tags-management/devices/$tagId/index'
import { Route as DashboardSettingsTagsManagementClustersTagIdIndexImport } from './routes/dashboard/settings/tags-management/clusters/$tagId/index'
import { Route as DashboardSettingsTagsManagementCatalogTagIdIndexImport } from './routes/dashboard/settings/tags-management/catalog/$tagId/index'
import { Route as DashboardSettingsReportSubscriptionReportIdSubscriptionIdIndexImport } from './routes/dashboard/settings/report-subscription/$reportId/$subscriptionId/index'
import { Route as DashboardSettingsAlertManagementMetricAlertsMetricAlertIdIndexImport } from './routes/dashboard/settings/alert-management/metric-alerts/$metricAlertId/index'
import { Route as DashboardSettingsAlertManagementAlertsAlertIdIndexImport } from './routes/dashboard/settings/alert-management/alerts/$alertId/index'
import { Route as DashboardResourcesSitesSiteIdVersionHistoryIndexImport } from './routes/dashboard/resources/sites/$siteId/version-history/index'
import { Route as DashboardResourcesDevicesDeviceIdVersionHistoryIndexImport } from './routes/dashboard/resources/devices/$deviceId/version-history/index'
import { Route as DashboardResourcesDevicesDeviceIdDataIndexImport } from './routes/dashboard/resources/devices/$deviceId/data/index'
import { Route as DashboardJobsWorkerJobsScheduleScheduledJobIdIndexImport } from './routes/dashboard/jobs/worker-jobs/schedule/$scheduledJobId/index'
import { Route as DashboardJobsWorkerJobsJobsJobIdIndexImport } from './routes/dashboard/jobs/worker-jobs/jobs/$jobId/index'
import { Route as DashboardJobsVideoUploadScheduleScheduledJobIdIndexImport } from './routes/dashboard/jobs/video-upload/schedule/$scheduledJobId/index'
import { Route as DashboardJobsVideoUploadJobsJobIdIndexImport } from './routes/dashboard/jobs/video-upload/jobs/$jobId/index'
import { Route as DashboardJobsTrainingScheduleScheduledJobIdIndexImport } from './routes/dashboard/jobs/training/schedule/$scheduledJobId/index'
import { Route as DashboardJobsTrainingJobsJobIdIndexImport } from './routes/dashboard/jobs/training/jobs/$jobId/index'
import { Route as DashboardJobsSyncSamplesScheduleScheduledJobIdIndexImport } from './routes/dashboard/jobs/sync-samples/schedule/$scheduledJobId/index'
import { Route as DashboardJobsSyncSamplesJobsJobIdIndexImport } from './routes/dashboard/jobs/sync-samples/jobs/$jobId/index'
import { Route as DashboardJobsSampleUploadScheduleScheduledJobIdIndexImport } from './routes/dashboard/jobs/sample-upload/schedule/$scheduledJobId/index'
import { Route as DashboardJobsSampleUploadJobsJobIdIndexImport } from './routes/dashboard/jobs/sample-upload/jobs/$jobId/index'
import { Route as DashboardJobsRestartsScheduleScheduledJobIdIndexImport } from './routes/dashboard/jobs/restarts/schedule/$scheduledJobId/index'
import { Route as DashboardJobsRestartsJobsJobIdIndexImport } from './routes/dashboard/jobs/restarts/jobs/$jobId/index'
import { Route as DashboardJobsRecoveryEstimatesScheduleScheduledJobIdIndexImport } from './routes/dashboard/jobs/recovery-estimates/schedule/$scheduledJobId/index'
import { Route as DashboardJobsRecoveryEstimatesJobsJobIdIndexImport } from './routes/dashboard/jobs/recovery-estimates/jobs/$jobId/index'
import { Route as DashboardJobsModelsScheduleScheduledJobIdIndexImport } from './routes/dashboard/jobs/models/schedule/$scheduledJobId/index'
import { Route as DashboardJobsModelsJobsJobIdIndexImport } from './routes/dashboard/jobs/models/jobs/$jobId/index'
import { Route as DashboardJobsHeadBlurVideosScheduleScheduledJobIdIndexImport } from './routes/dashboard/jobs/head-blur-videos/schedule/$scheduledJobId/index'
import { Route as DashboardJobsHeadBlurVideosJobsJobIdIndexImport } from './routes/dashboard/jobs/head-blur-videos/jobs/$jobId/index'
import { Route as DashboardJobsHeadBlurImagesScheduleScheduledJobIdIndexImport } from './routes/dashboard/jobs/head-blur-images/schedule/$scheduledJobId/index'
import { Route as DashboardJobsHeadBlurImagesJobsJobIdIndexImport } from './routes/dashboard/jobs/head-blur-images/jobs/$jobId/index'
import { Route as DashboardJobsDeploymentsScheduleScheduledJobIdIndexImport } from './routes/dashboard/jobs/deployments/schedule/$scheduledJobId/index'
import { Route as DashboardJobsDeploymentsJobsJobIdIndexImport } from './routes/dashboard/jobs/deployments/jobs/$jobId/index'
import { Route as DashboardJobsDeleteVideosScheduleScheduledJobIdIndexImport } from './routes/dashboard/jobs/delete-videos/schedule/$scheduledJobId/index'
import { Route as DashboardJobsDeleteVideosJobsJobIdIndexImport } from './routes/dashboard/jobs/delete-videos/jobs/$jobId/index'
import { Route as DashboardJobsDeleteSamplesScheduleScheduledJobIdIndexImport } from './routes/dashboard/jobs/delete-samples/schedule/$scheduledJobId/index'
import { Route as DashboardJobsDeleteSamplesJobsJobIdIndexImport } from './routes/dashboard/jobs/delete-samples/jobs/$jobId/index'
import { Route as DashboardJobsConfigScheduleScheduledJobIdIndexImport } from './routes/dashboard/jobs/config/schedule/$scheduledJobId/index'
import { Route as DashboardJobsConfigJobsJobIdIndexImport } from './routes/dashboard/jobs/config/jobs/$jobId/index'
import { Route as DashboardJobsCatalogUploadScheduleScheduledJobIdIndexImport } from './routes/dashboard/jobs/catalog-upload/schedule/$scheduledJobId/index'
import { Route as DashboardJobsCatalogUploadJobsJobIdIndexImport } from './routes/dashboard/jobs/catalog-upload/jobs/$jobId/index'
import { Route as DashboardJobsCapacityTaggingScheduleScheduledJobIdIndexImport } from './routes/dashboard/jobs/capacity-tagging/schedule/$scheduledJobId/index'
import { Route as DashboardJobsCapacityTaggingJobsJobIdIndexImport } from './routes/dashboard/jobs/capacity-tagging/jobs/$jobId/index'
import { Route as DashboardJobsCameraCalibrationScheduleScheduledJobIdIndexImport } from './routes/dashboard/jobs/camera-calibration/schedule/$scheduledJobId/index'
import { Route as DashboardJobsCameraCalibrationJobsJobIdIndexImport } from './routes/dashboard/jobs/camera-calibration/jobs/$jobId/index'
import { Route as AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdIndexImport } from './routes/admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId/index'
import { Route as AdminDashboardJobsServiceHealthChecksJobsJobIdIndexImport } from './routes/admin-dashboard/jobs/service-health-checks/jobs/$jobId/index'
import { Route as DashboardSettingsTagsManagementSitesTagIdDetailsRouteImport } from './routes/dashboard/settings/tags-management/sites/$tagId/details/route'
import { Route as DashboardSettingsTagsManagementSessionsTagIdDetailsRouteImport } from './routes/dashboard/settings/tags-management/sessions/$tagId/details/route'
import { Route as DashboardSettingsTagsManagementSamplesTagIdDetailsRouteImport } from './routes/dashboard/settings/tags-management/samples/$tagId/details/route'
import { Route as DashboardSettingsTagsManagementDevicesTagIdDetailsRouteImport } from './routes/dashboard/settings/tags-management/devices/$tagId/details/route'
import { Route as DashboardSettingsTagsManagementClustersTagIdDetailsRouteImport } from './routes/dashboard/settings/tags-management/clusters/$tagId/details/route'
import { Route as DashboardSettingsTagsManagementCatalogTagIdDetailsRouteImport } from './routes/dashboard/settings/tags-management/catalog/$tagId/details/route'
import { Route as DashboardSettingsReportSubscriptionReportIdSubscriptionIdSendHistoryRouteImport } from './routes/dashboard/settings/report-subscription/$reportId/$subscriptionId/send-history/route'
import { Route as DashboardSettingsReportSubscriptionReportIdSubscriptionIdReviewAndApproveRouteImport } from './routes/dashboard/settings/report-subscription/$reportId/$subscriptionId/review-and-approve/route'
import { Route as DashboardSettingsReportSubscriptionReportIdSubscriptionIdOverviewRouteImport } from './routes/dashboard/settings/report-subscription/$reportId/$subscriptionId/overview/route'
import { Route as DashboardSettingsReportSubscriptionReportIdSubscriptionIdEditRouteImport } from './routes/dashboard/settings/report-subscription/$reportId/$subscriptionId/edit/route'
import { Route as DashboardSettingsAlertManagementAlertsAlertIdOverviewRouteImport } from './routes/dashboard/settings/alert-management/alerts/$alertId/overview/route'
import { Route as DashboardResourcesSitesSiteIdVersionHistoryZebraAdapterRouteImport } from './routes/dashboard/resources/sites/$siteId/version-history/zebra-adapter/route'
import { Route as DashboardResourcesSitesSiteIdVersionHistoryTrainerRouteImport } from './routes/dashboard/resources/sites/$siteId/version-history/trainer/route'
import { Route as DashboardResourcesSitesSiteIdVersionHistoryOnScreenAppRouteImport } from './routes/dashboard/resources/sites/$siteId/version-history/on-screen-app/route'
import { Route as DashboardResourcesSitesSiteIdVersionHistoryDetectorRouteImport } from './routes/dashboard/resources/sites/$siteId/version-history/detector/route'
import { Route as DashboardResourcesSitesSiteIdVersionHistoryAgentRouteImport } from './routes/dashboard/resources/sites/$siteId/version-history/agent/route'
import { Route as DashboardResourcesDevicesDeviceIdVersionHistoryZebraAdapterRouteImport } from './routes/dashboard/resources/devices/$deviceId/version-history/zebra-adapter/route'
import { Route as DashboardResourcesDevicesDeviceIdVersionHistoryTrainerRouteImport } from './routes/dashboard/resources/devices/$deviceId/version-history/trainer/route'
import { Route as DashboardResourcesDevicesDeviceIdVersionHistoryOnScreenAppRouteImport } from './routes/dashboard/resources/devices/$deviceId/version-history/on-screen-app/route'
import { Route as DashboardResourcesDevicesDeviceIdVersionHistoryModelsRouteImport } from './routes/dashboard/resources/devices/$deviceId/version-history/models/route'
import { Route as DashboardResourcesDevicesDeviceIdVersionHistoryDetectorRouteImport } from './routes/dashboard/resources/devices/$deviceId/version-history/detector/route'
import { Route as DashboardResourcesDevicesDeviceIdVersionHistoryAgentRouteImport } from './routes/dashboard/resources/devices/$deviceId/version-history/agent/route'
import { Route as DashboardResourcesDevicesDeviceIdDiagnosticsObjectDetectionRouteImport } from './routes/dashboard/resources/devices/$deviceId/diagnostics/object-detection/route'
import { Route as DashboardResourcesDevicesDeviceIdDiagnosticsCustomRouteImport } from './routes/dashboard/resources/devices/$deviceId/diagnostics/custom/route'
import { Route as DashboardResourcesDevicesDeviceIdDiagnosticsClassifierRouteImport } from './routes/dashboard/resources/devices/$deviceId/diagnostics/classifier/route'
import { Route as DashboardResourcesDevicesDeviceIdDataTextJsonRouteImport } from './routes/dashboard/resources/devices/$deviceId/data/text-json/route'
import { Route as DashboardResourcesDevicesDeviceIdDataSessionsRouteImport } from './routes/dashboard/resources/devices/$deviceId/data/sessions/route'
import { Route as DashboardResourcesDevicesDeviceIdDataSamplesRouteImport } from './routes/dashboard/resources/devices/$deviceId/data/samples/route'
import { Route as DashboardJobsWorkerJobsScheduleScheduledJobIdScheduleRouteImport } from './routes/dashboard/jobs/worker-jobs/schedule/$scheduledJobId/schedule/route'
import { Route as DashboardJobsWorkerJobsScheduleScheduledJobIdOverviewRouteImport } from './routes/dashboard/jobs/worker-jobs/schedule/$scheduledJobId/overview/route'
import { Route as DashboardJobsWorkerJobsScheduleScheduledJobIdInputsRouteImport } from './routes/dashboard/jobs/worker-jobs/schedule/$scheduledJobId/inputs/route'
import { Route as DashboardJobsWorkerJobsJobsJobIdOverviewRouteImport } from './routes/dashboard/jobs/worker-jobs/jobs/$jobId/overview/route'
import { Route as DashboardJobsWorkerJobsJobsJobIdDevicesRouteImport } from './routes/dashboard/jobs/worker-jobs/jobs/$jobId/devices/route'
import { Route as DashboardJobsVideoUploadScheduleScheduledJobIdScheduleRouteImport } from './routes/dashboard/jobs/video-upload/schedule/$scheduledJobId/schedule/route'
import { Route as DashboardJobsVideoUploadScheduleScheduledJobIdOverviewRouteImport } from './routes/dashboard/jobs/video-upload/schedule/$scheduledJobId/overview/route'
import { Route as DashboardJobsVideoUploadScheduleScheduledJobIdInputsRouteImport } from './routes/dashboard/jobs/video-upload/schedule/$scheduledJobId/inputs/route'
import { Route as DashboardJobsVideoUploadJobsJobIdOverviewRouteImport } from './routes/dashboard/jobs/video-upload/jobs/$jobId/overview/route'
import { Route as DashboardJobsVideoUploadJobsJobIdDevicesRouteImport } from './routes/dashboard/jobs/video-upload/jobs/$jobId/devices/route'
import { Route as DashboardJobsTrainingScheduleScheduledJobIdScheduleRouteImport } from './routes/dashboard/jobs/training/schedule/$scheduledJobId/schedule/route'
import { Route as DashboardJobsTrainingScheduleScheduledJobIdOverviewRouteImport } from './routes/dashboard/jobs/training/schedule/$scheduledJobId/overview/route'
import { Route as DashboardJobsTrainingScheduleScheduledJobIdInputsRouteImport } from './routes/dashboard/jobs/training/schedule/$scheduledJobId/inputs/route'
import { Route as DashboardJobsTrainingJobsJobIdOverviewRouteImport } from './routes/dashboard/jobs/training/jobs/$jobId/overview/route'
import { Route as DashboardJobsTrainingJobsJobIdMetricsRouteImport } from './routes/dashboard/jobs/training/jobs/$jobId/metrics/route'
import { Route as DashboardJobsTrainingJobsJobIdLabelsRouteImport } from './routes/dashboard/jobs/training/jobs/$jobId/labels/route'
import { Route as DashboardJobsTrainingJobsJobIdDevicesRouteImport } from './routes/dashboard/jobs/training/jobs/$jobId/devices/route'
import { Route as DashboardJobsSyncSamplesScheduleScheduledJobIdScheduleRouteImport } from './routes/dashboard/jobs/sync-samples/schedule/$scheduledJobId/schedule/route'
import { Route as DashboardJobsSyncSamplesScheduleScheduledJobIdOverviewRouteImport } from './routes/dashboard/jobs/sync-samples/schedule/$scheduledJobId/overview/route'
import { Route as DashboardJobsSyncSamplesScheduleScheduledJobIdInputsRouteImport } from './routes/dashboard/jobs/sync-samples/schedule/$scheduledJobId/inputs/route'
import { Route as DashboardJobsSyncSamplesJobsJobIdOverviewRouteImport } from './routes/dashboard/jobs/sync-samples/jobs/$jobId/overview/route'
import { Route as DashboardJobsSyncSamplesJobsJobIdDevicesRouteImport } from './routes/dashboard/jobs/sync-samples/jobs/$jobId/devices/route'
import { Route as DashboardJobsSampleUploadScheduleScheduledJobIdScheduleRouteImport } from './routes/dashboard/jobs/sample-upload/schedule/$scheduledJobId/schedule/route'
import { Route as DashboardJobsSampleUploadScheduleScheduledJobIdOverviewRouteImport } from './routes/dashboard/jobs/sample-upload/schedule/$scheduledJobId/overview/route'
import { Route as DashboardJobsSampleUploadScheduleScheduledJobIdInputsRouteImport } from './routes/dashboard/jobs/sample-upload/schedule/$scheduledJobId/inputs/route'
import { Route as DashboardJobsSampleUploadJobsJobIdOverviewRouteImport } from './routes/dashboard/jobs/sample-upload/jobs/$jobId/overview/route'
import { Route as DashboardJobsSampleUploadJobsJobIdDevicesRouteImport } from './routes/dashboard/jobs/sample-upload/jobs/$jobId/devices/route'
import { Route as DashboardJobsRestartsScheduleScheduledJobIdScheduleRouteImport } from './routes/dashboard/jobs/restarts/schedule/$scheduledJobId/schedule/route'
import { Route as DashboardJobsRestartsScheduleScheduledJobIdOverviewRouteImport } from './routes/dashboard/jobs/restarts/schedule/$scheduledJobId/overview/route'
import { Route as DashboardJobsRestartsJobsJobIdOverviewRouteImport } from './routes/dashboard/jobs/restarts/jobs/$jobId/overview/route'
import { Route as DashboardJobsRestartsJobsJobIdDevicesRouteImport } from './routes/dashboard/jobs/restarts/jobs/$jobId/devices/route'
import { Route as DashboardJobsRecoveryEstimatesScheduleScheduledJobIdScheduleRouteImport } from './routes/dashboard/jobs/recovery-estimates/schedule/$scheduledJobId/schedule/route'
import { Route as DashboardJobsRecoveryEstimatesScheduleScheduledJobIdOverviewRouteImport } from './routes/dashboard/jobs/recovery-estimates/schedule/$scheduledJobId/overview/route'
import { Route as DashboardJobsRecoveryEstimatesScheduleScheduledJobIdInputsRouteImport } from './routes/dashboard/jobs/recovery-estimates/schedule/$scheduledJobId/inputs/route'
import { Route as DashboardJobsRecoveryEstimatesJobsJobIdOverviewRouteImport } from './routes/dashboard/jobs/recovery-estimates/jobs/$jobId/overview/route'
import { Route as DashboardJobsModelsScheduleScheduledJobIdScheduleRouteImport } from './routes/dashboard/jobs/models/schedule/$scheduledJobId/schedule/route'
import { Route as DashboardJobsModelsScheduleScheduledJobIdOverviewRouteImport } from './routes/dashboard/jobs/models/schedule/$scheduledJobId/overview/route'
import { Route as DashboardJobsModelsJobsJobIdOverviewRouteImport } from './routes/dashboard/jobs/models/jobs/$jobId/overview/route'
import { Route as DashboardJobsModelsJobsJobIdDevicesRouteImport } from './routes/dashboard/jobs/models/jobs/$jobId/devices/route'
import { Route as DashboardJobsHeadBlurVideosScheduleScheduledJobIdScheduleRouteImport } from './routes/dashboard/jobs/head-blur-videos/schedule/$scheduledJobId/schedule/route'
import { Route as DashboardJobsHeadBlurVideosScheduleScheduledJobIdOverviewRouteImport } from './routes/dashboard/jobs/head-blur-videos/schedule/$scheduledJobId/overview/route'
import { Route as DashboardJobsHeadBlurVideosScheduleScheduledJobIdInputsRouteImport } from './routes/dashboard/jobs/head-blur-videos/schedule/$scheduledJobId/inputs/route'
import { Route as DashboardJobsHeadBlurVideosJobsJobIdOverviewRouteImport } from './routes/dashboard/jobs/head-blur-videos/jobs/$jobId/overview/route'
import { Route as DashboardJobsHeadBlurVideosJobsJobIdDevicesRouteImport } from './routes/dashboard/jobs/head-blur-videos/jobs/$jobId/devices/route'
import { Route as DashboardJobsHeadBlurImagesScheduleScheduledJobIdScheduleRouteImport } from './routes/dashboard/jobs/head-blur-images/schedule/$scheduledJobId/schedule/route'
import { Route as DashboardJobsHeadBlurImagesScheduleScheduledJobIdOverviewRouteImport } from './routes/dashboard/jobs/head-blur-images/schedule/$scheduledJobId/overview/route'
import { Route as DashboardJobsHeadBlurImagesScheduleScheduledJobIdInputsRouteImport } from './routes/dashboard/jobs/head-blur-images/schedule/$scheduledJobId/inputs/route'
import { Route as DashboardJobsHeadBlurImagesJobsJobIdOverviewRouteImport } from './routes/dashboard/jobs/head-blur-images/jobs/$jobId/overview/route'
import { Route as DashboardJobsHeadBlurImagesJobsJobIdDevicesRouteImport } from './routes/dashboard/jobs/head-blur-images/jobs/$jobId/devices/route'
import { Route as DashboardJobsDeploymentsScheduleScheduledJobIdScheduleRouteImport } from './routes/dashboard/jobs/deployments/schedule/$scheduledJobId/schedule/route'
import { Route as DashboardJobsDeploymentsScheduleScheduledJobIdOverviewRouteImport } from './routes/dashboard/jobs/deployments/schedule/$scheduledJobId/overview/route'
import { Route as DashboardJobsDeploymentsJobsJobIdOverviewRouteImport } from './routes/dashboard/jobs/deployments/jobs/$jobId/overview/route'
import { Route as DashboardJobsDeploymentsJobsJobIdDevicesRouteImport } from './routes/dashboard/jobs/deployments/jobs/$jobId/devices/route'
import { Route as DashboardJobsDeleteVideosScheduleScheduledJobIdScheduleRouteImport } from './routes/dashboard/jobs/delete-videos/schedule/$scheduledJobId/schedule/route'
import { Route as DashboardJobsDeleteVideosScheduleScheduledJobIdOverviewRouteImport } from './routes/dashboard/jobs/delete-videos/schedule/$scheduledJobId/overview/route'
import { Route as DashboardJobsDeleteVideosScheduleScheduledJobIdInputsRouteImport } from './routes/dashboard/jobs/delete-videos/schedule/$scheduledJobId/inputs/route'
import { Route as DashboardJobsDeleteVideosJobsJobIdOverviewRouteImport } from './routes/dashboard/jobs/delete-videos/jobs/$jobId/overview/route'
import { Route as DashboardJobsDeleteVideosJobsJobIdDevicesRouteImport } from './routes/dashboard/jobs/delete-videos/jobs/$jobId/devices/route'
import { Route as DashboardJobsDeleteSamplesScheduleScheduledJobIdScheduleRouteImport } from './routes/dashboard/jobs/delete-samples/schedule/$scheduledJobId/schedule/route'
import { Route as DashboardJobsDeleteSamplesScheduleScheduledJobIdOverviewRouteImport } from './routes/dashboard/jobs/delete-samples/schedule/$scheduledJobId/overview/route'
import { Route as DashboardJobsDeleteSamplesScheduleScheduledJobIdInputsRouteImport } from './routes/dashboard/jobs/delete-samples/schedule/$scheduledJobId/inputs/route'
import { Route as DashboardJobsDeleteSamplesJobsJobIdOverviewRouteImport } from './routes/dashboard/jobs/delete-samples/jobs/$jobId/overview/route'
import { Route as DashboardJobsDeleteSamplesJobsJobIdDevicesRouteImport } from './routes/dashboard/jobs/delete-samples/jobs/$jobId/devices/route'
import { Route as DashboardJobsConfigScheduleScheduledJobIdScheduleRouteImport } from './routes/dashboard/jobs/config/schedule/$scheduledJobId/schedule/route'
import { Route as DashboardJobsConfigScheduleScheduledJobIdOverviewRouteImport } from './routes/dashboard/jobs/config/schedule/$scheduledJobId/overview/route'
import { Route as DashboardJobsConfigJobsJobIdOverviewRouteImport } from './routes/dashboard/jobs/config/jobs/$jobId/overview/route'
import { Route as DashboardJobsConfigJobsJobIdDevicesRouteImport } from './routes/dashboard/jobs/config/jobs/$jobId/devices/route'
import { Route as DashboardJobsCatalogUploadScheduleScheduledJobIdScheduleRouteImport } from './routes/dashboard/jobs/catalog-upload/schedule/$scheduledJobId/schedule/route'
import { Route as DashboardJobsCatalogUploadScheduleScheduledJobIdOverviewRouteImport } from './routes/dashboard/jobs/catalog-upload/schedule/$scheduledJobId/overview/route'
import { Route as DashboardJobsCatalogUploadScheduleScheduledJobIdLabelsRouteImport } from './routes/dashboard/jobs/catalog-upload/schedule/$scheduledJobId/labels/route'
import { Route as DashboardJobsCatalogUploadJobsJobIdOverviewRouteImport } from './routes/dashboard/jobs/catalog-upload/jobs/$jobId/overview/route'
import { Route as DashboardJobsCatalogUploadJobsJobIdLabelsRouteImport } from './routes/dashboard/jobs/catalog-upload/jobs/$jobId/labels/route'
import { Route as DashboardJobsCatalogUploadJobsJobIdDevicesRouteImport } from './routes/dashboard/jobs/catalog-upload/jobs/$jobId/devices/route'
import { Route as DashboardJobsCapacityTaggingScheduleScheduledJobIdScheduleRouteImport } from './routes/dashboard/jobs/capacity-tagging/schedule/$scheduledJobId/schedule/route'
import { Route as DashboardJobsCapacityTaggingScheduleScheduledJobIdOverviewRouteImport } from './routes/dashboard/jobs/capacity-tagging/schedule/$scheduledJobId/overview/route'
import { Route as DashboardJobsCapacityTaggingScheduleScheduledJobIdInputsRouteImport } from './routes/dashboard/jobs/capacity-tagging/schedule/$scheduledJobId/inputs/route'
import { Route as DashboardJobsCapacityTaggingJobsJobIdOverviewRouteImport } from './routes/dashboard/jobs/capacity-tagging/jobs/$jobId/overview/route'
import { Route as DashboardJobsCameraCalibrationScheduleScheduledJobIdScheduleRouteImport } from './routes/dashboard/jobs/camera-calibration/schedule/$scheduledJobId/schedule/route'
import { Route as DashboardJobsCameraCalibrationScheduleScheduledJobIdOverviewRouteImport } from './routes/dashboard/jobs/camera-calibration/schedule/$scheduledJobId/overview/route'
import { Route as DashboardJobsCameraCalibrationScheduleScheduledJobIdInputsRouteImport } from './routes/dashboard/jobs/camera-calibration/schedule/$scheduledJobId/inputs/route'
import { Route as DashboardJobsCameraCalibrationJobsJobIdOverviewRouteImport } from './routes/dashboard/jobs/camera-calibration/jobs/$jobId/overview/route'
import { Route as DashboardJobsCameraCalibrationJobsJobIdDevicesRouteImport } from './routes/dashboard/jobs/camera-calibration/jobs/$jobId/devices/route'
import { Route as AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdScheduleRouteImport } from './routes/admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId/schedule/route'
import { Route as AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdOverviewRouteImport } from './routes/admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId/overview/route'
import { Route as AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdInputsRouteImport } from './routes/admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId/inputs/route'
import { Route as AdminDashboardJobsServiceHealthChecksJobsJobIdOverviewRouteImport } from './routes/admin-dashboard/jobs/service-health-checks/jobs/$jobId/overview/route'
import { Route as DashboardResourcesDevicesDeviceIdDataSessionsSessionIdRouteImport } from './routes/dashboard/resources/devices/$deviceId/data/sessions/$sessionId/route'
import { Route as DashboardResourcesDevicesDeviceIdDataSamplesSampleIdRouteImport } from './routes/dashboard/resources/devices/$deviceId/data/samples/$sampleId/route'
import { Route as DashboardResourcesDevicesDeviceIdDataSessionsSessionIdIndexImport } from './routes/dashboard/resources/devices/$deviceId/data/sessions/$sessionId/index'
import { Route as DashboardResourcesDevicesDeviceIdDataSamplesSampleIdIndexImport } from './routes/dashboard/resources/devices/$deviceId/data/samples/$sampleId/index'

// Create Virtual Routes

const LoginRouteLazyImport = createFileRoute('/login')()

// Create/Update Routes

const LoginRouteLazyRoute = LoginRouteLazyImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/login/route.lazy').then((d) => d.Route))

const UnresponsiveRouteRoute = UnresponsiveRouteImport.update({
  id: '/unresponsive',
  path: '/unresponsive',
  getParentRoute: () => rootRoute,
} as any)

const DashboardRouteRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRoute,
} as any)

const AdminDashboardRouteRoute = AdminDashboardRouteImport.update({
  id: '/admin-dashboard',
  path: '/admin-dashboard',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const DashboardIndexRoute = DashboardIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardRouteRoute,
} as any)

const AdminDashboardIndexRoute = AdminDashboardIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminDashboardRouteRoute,
} as any)

const NextSplatRoute = NextSplatImport.update({
  id: '/next/$',
  path: '/next/$',
  getParentRoute: () => rootRoute,
} as any)

const DashboardSupportRoute = DashboardSupportImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => DashboardRouteRoute,
} as any)

const DashboardHomeRoute = DashboardHomeImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => DashboardRouteRoute,
} as any)

const DashboardUnauthorizedRouteRoute = DashboardUnauthorizedRouteImport.update(
  {
    id: '/unauthorized',
    path: '/unauthorized',
    getParentRoute: () => DashboardRouteRoute,
  } as any,
)

const DashboardSettingsRouteRoute = DashboardSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => DashboardRouteRoute,
} as any)

const DashboardResourcesRouteRoute = DashboardResourcesRouteImport.update({
  id: '/resources',
  path: '/resources',
  getParentRoute: () => DashboardRouteRoute,
} as any)

const DashboardReportsRouteRoute = DashboardReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => DashboardRouteRoute,
} as any)

const DashboardModelsRouteRoute = DashboardModelsRouteImport.update({
  id: '/models',
  path: '/models',
  getParentRoute: () => DashboardRouteRoute,
} as any)

const DashboardJobsRouteRoute = DashboardJobsRouteImport.update({
  id: '/jobs',
  path: '/jobs',
  getParentRoute: () => DashboardRouteRoute,
} as any)

const DashboardDataRouteRoute = DashboardDataRouteImport.update({
  id: '/data',
  path: '/data',
  getParentRoute: () => DashboardRouteRoute,
} as any)

const DashboardAlertsRouteRoute = DashboardAlertsRouteImport.update({
  id: '/alerts',
  path: '/alerts',
  getParentRoute: () => DashboardRouteRoute,
} as any)

const AdminDashboardNotificationsRouteRoute =
  AdminDashboardNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AdminDashboardRouteRoute,
  } as any)

const AdminDashboardJobsRouteRoute = AdminDashboardJobsRouteImport.update({
  id: '/jobs',
  path: '/jobs',
  getParentRoute: () => AdminDashboardRouteRoute,
} as any)

const AdminDashboardDomainAuthSettingsRouteRoute =
  AdminDashboardDomainAuthSettingsRouteImport.update({
    id: '/domain-auth-settings',
    path: '/domain-auth-settings',
    getParentRoute: () => AdminDashboardRouteRoute,
  } as any)

const AdminDashboardAccountsManagementRouteRoute =
  AdminDashboardAccountsManagementRouteImport.update({
    id: '/accounts-management',
    path: '/accounts-management',
    getParentRoute: () => AdminDashboardRouteRoute,
  } as any)

const DashboardSettingsIndexRoute = DashboardSettingsIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardSettingsRouteRoute,
} as any)

const DashboardResourcesIndexRoute = DashboardResourcesIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardResourcesRouteRoute,
} as any)

const DashboardReportsIndexRoute = DashboardReportsIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardReportsRouteRoute,
} as any)

const DashboardJobsIndexRoute = DashboardJobsIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardJobsRouteRoute,
} as any)

const DashboardHomeIndexRoute = DashboardHomeIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardHomeRoute,
} as any)

const DashboardDataIndexRoute = DashboardDataIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardDataRouteRoute,
} as any)

const DashboardRestRoute = DashboardRestImport.update({
  id: '/[/rest]',
  path: '/[/rest]',
  getParentRoute: () => DashboardRouteRoute,
} as any)

const DashboardSettingsUserManagementRouteRoute =
  DashboardSettingsUserManagementRouteImport.update({
    id: '/user-management',
    path: '/user-management',
    getParentRoute: () => DashboardSettingsRouteRoute,
  } as any)

const DashboardSettingsTagsManagementRouteRoute =
  DashboardSettingsTagsManagementRouteImport.update({
    id: '/tags-management',
    path: '/tags-management',
    getParentRoute: () => DashboardSettingsRouteRoute,
  } as any)

const DashboardSettingsReportSettingsRouteRoute =
  DashboardSettingsReportSettingsRouteImport.update({
    id: '/report-settings',
    path: '/report-settings',
    getParentRoute: () => DashboardSettingsRouteRoute,
  } as any)

const DashboardSettingsRegionsRouteRoute =
  DashboardSettingsRegionsRouteImport.update({
    id: '/regions',
    path: '/regions',
    getParentRoute: () => DashboardSettingsRouteRoute,
  } as any)

const DashboardSettingsQueuesRouteRoute =
  DashboardSettingsQueuesRouteImport.update({
    id: '/queues',
    path: '/queues',
    getParentRoute: () => DashboardSettingsRouteRoute,
  } as any)

const DashboardSettingsPermissionsSettingsDevRouteRoute =
  DashboardSettingsPermissionsSettingsDevRouteImport.update({
    id: '/permissions-settings-dev',
    path: '/permissions-settings-dev',
    getParentRoute: () => DashboardSettingsRouteRoute,
  } as any)

const DashboardSettingsPermissionsSettingsRouteRoute =
  DashboardSettingsPermissionsSettingsRouteImport.update({
    id: '/permissions-settings',
    path: '/permissions-settings',
    getParentRoute: () => DashboardSettingsRouteRoute,
  } as any)

const DashboardSettingsOverviewRouteRoute =
  DashboardSettingsOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => DashboardSettingsRouteRoute,
  } as any)

const DashboardSettingsJobDefaultsRouteRoute =
  DashboardSettingsJobDefaultsRouteImport.update({
    id: '/job-defaults',
    path: '/job-defaults',
    getParentRoute: () => DashboardSettingsRouteRoute,
  } as any)

const DashboardSettingsAlertManagementRouteRoute =
  DashboardSettingsAlertManagementRouteImport.update({
    id: '/alert-management',
    path: '/alert-management',
    getParentRoute: () => DashboardSettingsRouteRoute,
  } as any)

const DashboardResourcesSitesRouteRoute =
  DashboardResourcesSitesRouteImport.update({
    id: '/sites',
    path: '/sites',
    getParentRoute: () => DashboardResourcesRouteRoute,
  } as any)

const DashboardResourcesSiteGroupsRouteRoute =
  DashboardResourcesSiteGroupsRouteImport.update({
    id: '/site-groups',
    path: '/site-groups',
    getParentRoute: () => DashboardResourcesRouteRoute,
  } as any)

const DashboardResourcesDevicesRouteRoute =
  DashboardResourcesDevicesRouteImport.update({
    id: '/devices',
    path: '/devices',
    getParentRoute: () => DashboardResourcesRouteRoute,
  } as any)

const DashboardResourcesClustersRouteRoute =
  DashboardResourcesClustersRouteImport.update({
    id: '/clusters',
    path: '/clusters',
    getParentRoute: () => DashboardResourcesRouteRoute,
  } as any)

const DashboardReportsCompanionRouteRoute =
  DashboardReportsCompanionRouteImport.update({
    id: '/companion',
    path: '/companion',
    getParentRoute: () => DashboardReportsRouteRoute,
  } as any)

const DashboardReportsAnalyticsHubRouteRoute =
  DashboardReportsAnalyticsHubRouteImport.update({
    id: '/analytics-hub',
    path: '/analytics-hub',
    getParentRoute: () => DashboardReportsRouteRoute,
  } as any)

const DashboardReportsReportIdRouteRoute =
  DashboardReportsReportIdRouteImport.update({
    id: '/$reportId',
    path: '/$reportId',
    getParentRoute: () => DashboardReportsRouteRoute,
  } as any)

const DashboardModelsModelIdRouteRoute =
  DashboardModelsModelIdRouteImport.update({
    id: '/$modelId',
    path: '/$modelId',
    getParentRoute: () => DashboardModelsRouteRoute,
  } as any)

const DashboardJobsWorkerJobsRouteRoute =
  DashboardJobsWorkerJobsRouteImport.update({
    id: '/worker-jobs',
    path: '/worker-jobs',
    getParentRoute: () => DashboardJobsRouteRoute,
  } as any)

const DashboardJobsVideoUploadRouteRoute =
  DashboardJobsVideoUploadRouteImport.update({
    id: '/video-upload',
    path: '/video-upload',
    getParentRoute: () => DashboardJobsRouteRoute,
  } as any)

const DashboardJobsTrainingRouteRoute = DashboardJobsTrainingRouteImport.update(
  {
    id: '/training',
    path: '/training',
    getParentRoute: () => DashboardJobsRouteRoute,
  } as any,
)

const DashboardJobsSyncSamplesRouteRoute =
  DashboardJobsSyncSamplesRouteImport.update({
    id: '/sync-samples',
    path: '/sync-samples',
    getParentRoute: () => DashboardJobsRouteRoute,
  } as any)

const DashboardJobsSampleUploadRouteRoute =
  DashboardJobsSampleUploadRouteImport.update({
    id: '/sample-upload',
    path: '/sample-upload',
    getParentRoute: () => DashboardJobsRouteRoute,
  } as any)

const DashboardJobsRestartsRouteRoute = DashboardJobsRestartsRouteImport.update(
  {
    id: '/restarts',
    path: '/restarts',
    getParentRoute: () => DashboardJobsRouteRoute,
  } as any,
)

const DashboardJobsRecoveryEstimatesRouteRoute =
  DashboardJobsRecoveryEstimatesRouteImport.update({
    id: '/recovery-estimates',
    path: '/recovery-estimates',
    getParentRoute: () => DashboardJobsRouteRoute,
  } as any)

const DashboardJobsModelsRouteRoute = DashboardJobsModelsRouteImport.update({
  id: '/models',
  path: '/models',
  getParentRoute: () => DashboardJobsRouteRoute,
} as any)

const DashboardJobsHeadBlurVideosRouteRoute =
  DashboardJobsHeadBlurVideosRouteImport.update({
    id: '/head-blur-videos',
    path: '/head-blur-videos',
    getParentRoute: () => DashboardJobsRouteRoute,
  } as any)

const DashboardJobsHeadBlurImagesRouteRoute =
  DashboardJobsHeadBlurImagesRouteImport.update({
    id: '/head-blur-images',
    path: '/head-blur-images',
    getParentRoute: () => DashboardJobsRouteRoute,
  } as any)

const DashboardJobsDeploymentsRouteRoute =
  DashboardJobsDeploymentsRouteImport.update({
    id: '/deployments',
    path: '/deployments',
    getParentRoute: () => DashboardJobsRouteRoute,
  } as any)

const DashboardJobsDeleteVideosRouteRoute =
  DashboardJobsDeleteVideosRouteImport.update({
    id: '/delete-videos',
    path: '/delete-videos',
    getParentRoute: () => DashboardJobsRouteRoute,
  } as any)

const DashboardJobsDeleteSamplesRouteRoute =
  DashboardJobsDeleteSamplesRouteImport.update({
    id: '/delete-samples',
    path: '/delete-samples',
    getParentRoute: () => DashboardJobsRouteRoute,
  } as any)

const DashboardJobsConfigRouteRoute = DashboardJobsConfigRouteImport.update({
  id: '/config',
  path: '/config',
  getParentRoute: () => DashboardJobsRouteRoute,
} as any)

const DashboardJobsCatalogUploadRouteRoute =
  DashboardJobsCatalogUploadRouteImport.update({
    id: '/catalog-upload',
    path: '/catalog-upload',
    getParentRoute: () => DashboardJobsRouteRoute,
  } as any)

const DashboardJobsCapacityTaggingRouteRoute =
  DashboardJobsCapacityTaggingRouteImport.update({
    id: '/capacity-tagging',
    path: '/capacity-tagging',
    getParentRoute: () => DashboardJobsRouteRoute,
  } as any)

const DashboardJobsCameraCalibrationRouteRoute =
  DashboardJobsCameraCalibrationRouteImport.update({
    id: '/camera-calibration',
    path: '/camera-calibration',
    getParentRoute: () => DashboardJobsRouteRoute,
  } as any)

const DashboardHomeManagerReportRouteRoute =
  DashboardHomeManagerReportRouteImport.update({
    id: '/manager-report',
    path: '/manager-report',
    getParentRoute: () => DashboardHomeRoute,
  } as any)

const DashboardDataSessionsRouteRoute = DashboardDataSessionsRouteImport.update(
  {
    id: '/sessions',
    path: '/sessions',
    getParentRoute: () => DashboardDataRouteRoute,
  } as any,
)

const DashboardDataPendingRouteRoute = DashboardDataPendingRouteImport.update({
  id: '/pending',
  path: '/pending',
  getParentRoute: () => DashboardDataRouteRoute,
} as any)

const DashboardDataLabelDistributionRouteRoute =
  DashboardDataLabelDistributionRouteImport.update({
    id: '/label-distribution',
    path: '/label-distribution',
    getParentRoute: () => DashboardDataRouteRoute,
  } as any)

const DashboardDataJsonDataRouteRoute = DashboardDataJsonDataRouteImport.update(
  {
    id: '/json-data',
    path: '/json-data',
    getParentRoute: () => DashboardDataRouteRoute,
  } as any,
)

const DashboardDataImagesRouteRoute = DashboardDataImagesRouteImport.update({
  id: '/images',
  path: '/images',
  getParentRoute: () => DashboardDataRouteRoute,
} as any)

const DashboardDataDatasetsRouteRoute = DashboardDataDatasetsRouteImport.update(
  {
    id: '/datasets',
    path: '/datasets',
    getParentRoute: () => DashboardDataRouteRoute,
  } as any,
)

const DashboardDataCatalogRouteRoute = DashboardDataCatalogRouteImport.update({
  id: '/catalog',
  path: '/catalog',
  getParentRoute: () => DashboardDataRouteRoute,
} as any)

const DashboardDataAnnotationsRouteRoute =
  DashboardDataAnnotationsRouteImport.update({
    id: '/annotations',
    path: '/annotations',
    getParentRoute: () => DashboardDataRouteRoute,
  } as any)

const AdminDashboardNotificationsNotificationIdRouteRoute =
  AdminDashboardNotificationsNotificationIdRouteImport.update({
    id: '/$notificationId',
    path: '/$notificationId',
    getParentRoute: () => AdminDashboardNotificationsRouteRoute,
  } as any)

const AdminDashboardJobsServiceHealthChecksRouteRoute =
  AdminDashboardJobsServiceHealthChecksRouteImport.update({
    id: '/service-health-checks',
    path: '/service-health-checks',
    getParentRoute: () => AdminDashboardJobsRouteRoute,
  } as any)

const AdminDashboardAccountsManagementAccountIdRouteRoute =
  AdminDashboardAccountsManagementAccountIdRouteImport.update({
    id: '/$accountId',
    path: '/$accountId',
    getParentRoute: () => AdminDashboardAccountsManagementRouteRoute,
  } as any)

const DashboardSettingsTagsManagementIndexRoute =
  DashboardSettingsTagsManagementIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardSettingsTagsManagementRouteRoute,
  } as any)

const DashboardSettingsQueuesIndexRoute =
  DashboardSettingsQueuesIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardSettingsQueuesRouteRoute,
  } as any)

const DashboardSettingsAlertManagementIndexRoute =
  DashboardSettingsAlertManagementIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardSettingsAlertManagementRouteRoute,
  } as any)

const DashboardModelsModelIdIndexRoute =
  DashboardModelsModelIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardModelsModelIdRouteRoute,
  } as any)

const DashboardJobsWorkerJobsIndexRoute =
  DashboardJobsWorkerJobsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardJobsWorkerJobsRouteRoute,
  } as any)

const DashboardJobsVideoUploadIndexRoute =
  DashboardJobsVideoUploadIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardJobsVideoUploadRouteRoute,
  } as any)

const DashboardJobsTrainingIndexRoute = DashboardJobsTrainingIndexImport.update(
  {
    id: '/',
    path: '/',
    getParentRoute: () => DashboardJobsTrainingRouteRoute,
  } as any,
)

const DashboardJobsSyncSamplesIndexRoute =
  DashboardJobsSyncSamplesIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardJobsSyncSamplesRouteRoute,
  } as any)

const DashboardJobsSampleUploadIndexRoute =
  DashboardJobsSampleUploadIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardJobsSampleUploadRouteRoute,
  } as any)

const DashboardJobsRestartsIndexRoute = DashboardJobsRestartsIndexImport.update(
  {
    id: '/',
    path: '/',
    getParentRoute: () => DashboardJobsRestartsRouteRoute,
  } as any,
)

const DashboardJobsRecoveryEstimatesIndexRoute =
  DashboardJobsRecoveryEstimatesIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardJobsRecoveryEstimatesRouteRoute,
  } as any)

const DashboardJobsModelsIndexRoute = DashboardJobsModelsIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardJobsModelsRouteRoute,
} as any)

const DashboardJobsHeadBlurVideosIndexRoute =
  DashboardJobsHeadBlurVideosIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardJobsHeadBlurVideosRouteRoute,
  } as any)

const DashboardJobsHeadBlurImagesIndexRoute =
  DashboardJobsHeadBlurImagesIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardJobsHeadBlurImagesRouteRoute,
  } as any)

const DashboardJobsDeploymentsIndexRoute =
  DashboardJobsDeploymentsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardJobsDeploymentsRouteRoute,
  } as any)

const DashboardJobsDeleteVideosIndexRoute =
  DashboardJobsDeleteVideosIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardJobsDeleteVideosRouteRoute,
  } as any)

const DashboardJobsDeleteSamplesIndexRoute =
  DashboardJobsDeleteSamplesIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardJobsDeleteSamplesRouteRoute,
  } as any)

const DashboardJobsConfigIndexRoute = DashboardJobsConfigIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardJobsConfigRouteRoute,
} as any)

const DashboardJobsCatalogUploadIndexRoute =
  DashboardJobsCatalogUploadIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardJobsCatalogUploadRouteRoute,
  } as any)

const DashboardJobsCapacityTaggingIndexRoute =
  DashboardJobsCapacityTaggingIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardJobsCapacityTaggingRouteRoute,
  } as any)

const DashboardJobsCameraCalibrationIndexRoute =
  DashboardJobsCameraCalibrationIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardJobsCameraCalibrationRouteRoute,
  } as any)

const DashboardHomeManagerReportIndexRoute =
  DashboardHomeManagerReportIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardHomeManagerReportRouteRoute,
  } as any)

const AdminDashboardJobsServiceHealthChecksIndexRoute =
  AdminDashboardJobsServiceHealthChecksIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminDashboardJobsServiceHealthChecksRouteRoute,
  } as any)

const AdminDashboardAccountsManagementAccountIdIndexRoute =
  AdminDashboardAccountsManagementAccountIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminDashboardAccountsManagementAccountIdRouteRoute,
  } as any)

const DashboardSettingsUserManagementThumbnailRoute =
  DashboardSettingsUserManagementThumbnailImport.update({
    id: '/thumbnail',
    path: '/thumbnail',
    getParentRoute: () => DashboardSettingsUserManagementRouteRoute,
  } as any)

const DashboardResourcesRestRoute = DashboardResourcesRestImport.update({
  id: '/[/rest]',
  path: '/[/rest]',
  getParentRoute: () => DashboardResourcesRouteRoute,
} as any)

const DashboardDataRestRoute = DashboardDataRestImport.update({
  id: '/[/rest]',
  path: '/[/rest]',
  getParentRoute: () => DashboardDataRouteRoute,
} as any)

const DashboardSettingsUserManagementUserIdRouteRoute =
  DashboardSettingsUserManagementUserIdRouteImport.update({
    id: '/$userId',
    path: '/$userId',
    getParentRoute: () => DashboardSettingsUserManagementRouteRoute,
  } as any)

const DashboardSettingsTagsManagementSitesRouteRoute =
  DashboardSettingsTagsManagementSitesRouteImport.update({
    id: '/sites',
    path: '/sites',
    getParentRoute: () => DashboardSettingsTagsManagementRouteRoute,
  } as any)

const DashboardSettingsTagsManagementSessionsRouteRoute =
  DashboardSettingsTagsManagementSessionsRouteImport.update({
    id: '/sessions',
    path: '/sessions',
    getParentRoute: () => DashboardSettingsTagsManagementRouteRoute,
  } as any)

const DashboardSettingsTagsManagementSamplesRouteRoute =
  DashboardSettingsTagsManagementSamplesRouteImport.update({
    id: '/samples',
    path: '/samples',
    getParentRoute: () => DashboardSettingsTagsManagementRouteRoute,
  } as any)

const DashboardSettingsTagsManagementDevicesRouteRoute =
  DashboardSettingsTagsManagementDevicesRouteImport.update({
    id: '/devices',
    path: '/devices',
    getParentRoute: () => DashboardSettingsTagsManagementRouteRoute,
  } as any)

const DashboardSettingsTagsManagementClustersRouteRoute =
  DashboardSettingsTagsManagementClustersRouteImport.update({
    id: '/clusters',
    path: '/clusters',
    getParentRoute: () => DashboardSettingsTagsManagementRouteRoute,
  } as any)

const DashboardSettingsTagsManagementCatalogRouteRoute =
  DashboardSettingsTagsManagementCatalogRouteImport.update({
    id: '/catalog',
    path: '/catalog',
    getParentRoute: () => DashboardSettingsTagsManagementRouteRoute,
  } as any)

const DashboardSettingsReportSettingsReportIdRouteRoute =
  DashboardSettingsReportSettingsReportIdRouteImport.update({
    id: '/$reportId',
    path: '/$reportId',
    getParentRoute: () => DashboardSettingsReportSettingsRouteRoute,
  } as any)

const DashboardSettingsQueuesQueueNameRouteRoute =
  DashboardSettingsQueuesQueueNameRouteImport.update({
    id: '/$queueName',
    path: '/$queueName',
    getParentRoute: () => DashboardSettingsQueuesRouteRoute,
  } as any)

const DashboardSettingsAlertManagementMetricAlertsRouteRoute =
  DashboardSettingsAlertManagementMetricAlertsRouteImport.update({
    id: '/metric-alerts',
    path: '/metric-alerts',
    getParentRoute: () => DashboardSettingsAlertManagementRouteRoute,
  } as any)

const DashboardSettingsAlertManagementAlertsRouteRoute =
  DashboardSettingsAlertManagementAlertsRouteImport.update({
    id: '/alerts',
    path: '/alerts',
    getParentRoute: () => DashboardSettingsAlertManagementRouteRoute,
  } as any)

const DashboardSettingsAlertManagementAlertChannelsRouteRoute =
  DashboardSettingsAlertManagementAlertChannelsRouteImport.update({
    id: '/alert-channels',
    path: '/alert-channels',
    getParentRoute: () => DashboardSettingsAlertManagementRouteRoute,
  } as any)

const DashboardResourcesSitesSiteIdRouteRoute =
  DashboardResourcesSitesSiteIdRouteImport.update({
    id: '/$siteId',
    path: '/$siteId',
    getParentRoute: () => DashboardResourcesSitesRouteRoute,
  } as any)

const DashboardResourcesSiteGroupsSiteGroupIdRouteRoute =
  DashboardResourcesSiteGroupsSiteGroupIdRouteImport.update({
    id: '/$siteGroupId',
    path: '/$siteGroupId',
    getParentRoute: () => DashboardResourcesSiteGroupsRouteRoute,
  } as any)

const DashboardResourcesDevicesDeviceIdRouteRoute =
  DashboardResourcesDevicesDeviceIdRouteImport.update({
    id: '/$deviceId',
    path: '/$deviceId',
    getParentRoute: () => DashboardResourcesDevicesRouteRoute,
  } as any)

const DashboardResourcesClustersClusterIdRouteRoute =
  DashboardResourcesClustersClusterIdRouteImport.update({
    id: '/$clusterId',
    path: '/$clusterId',
    getParentRoute: () => DashboardResourcesClustersRouteRoute,
  } as any)

const DashboardModelsModelIdOverviewRouteRoute =
  DashboardModelsModelIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => DashboardModelsModelIdRouteRoute,
  } as any)

const DashboardModelsModelIdMatrixRouteRoute =
  DashboardModelsModelIdMatrixRouteImport.update({
    id: '/matrix',
    path: '/matrix',
    getParentRoute: () => DashboardModelsModelIdRouteRoute,
  } as any)

const DashboardModelsModelIdLabelsRouteRoute =
  DashboardModelsModelIdLabelsRouteImport.update({
    id: '/labels',
    path: '/labels',
    getParentRoute: () => DashboardModelsModelIdRouteRoute,
  } as any)

const DashboardModelsModelIdDeploymentRouteRoute =
  DashboardModelsModelIdDeploymentRouteImport.update({
    id: '/deployment',
    path: '/deployment',
    getParentRoute: () => DashboardModelsModelIdRouteRoute,
  } as any)

const DashboardJobsWorkerJobsScheduleRouteRoute =
  DashboardJobsWorkerJobsScheduleRouteImport.update({
    id: '/schedule',
    path: '/schedule',
    getParentRoute: () => DashboardJobsWorkerJobsRouteRoute,
  } as any)

const DashboardJobsWorkerJobsJobsRouteRoute =
  DashboardJobsWorkerJobsJobsRouteImport.update({
    id: '/jobs',
    path: '/jobs',
    getParentRoute: () => DashboardJobsWorkerJobsRouteRoute,
  } as any)

const DashboardJobsVideoUploadScheduleRouteRoute =
  DashboardJobsVideoUploadScheduleRouteImport.update({
    id: '/schedule',
    path: '/schedule',
    getParentRoute: () => DashboardJobsVideoUploadRouteRoute,
  } as any)

const DashboardJobsVideoUploadJobsRouteRoute =
  DashboardJobsVideoUploadJobsRouteImport.update({
    id: '/jobs',
    path: '/jobs',
    getParentRoute: () => DashboardJobsVideoUploadRouteRoute,
  } as any)

const DashboardJobsVideoUploadAlertsRouteRoute =
  DashboardJobsVideoUploadAlertsRouteImport.update({
    id: '/alerts',
    path: '/alerts',
    getParentRoute: () => DashboardJobsVideoUploadRouteRoute,
  } as any)

const DashboardJobsTrainingScheduleRouteRoute =
  DashboardJobsTrainingScheduleRouteImport.update({
    id: '/schedule',
    path: '/schedule',
    getParentRoute: () => DashboardJobsTrainingRouteRoute,
  } as any)

const DashboardJobsTrainingJobsRouteRoute =
  DashboardJobsTrainingJobsRouteImport.update({
    id: '/jobs',
    path: '/jobs',
    getParentRoute: () => DashboardJobsTrainingRouteRoute,
  } as any)

const DashboardJobsSyncSamplesScheduleRouteRoute =
  DashboardJobsSyncSamplesScheduleRouteImport.update({
    id: '/schedule',
    path: '/schedule',
    getParentRoute: () => DashboardJobsSyncSamplesRouteRoute,
  } as any)

const DashboardJobsSyncSamplesJobsRouteRoute =
  DashboardJobsSyncSamplesJobsRouteImport.update({
    id: '/jobs',
    path: '/jobs',
    getParentRoute: () => DashboardJobsSyncSamplesRouteRoute,
  } as any)

const DashboardJobsSyncSamplesAlertsRouteRoute =
  DashboardJobsSyncSamplesAlertsRouteImport.update({
    id: '/alerts',
    path: '/alerts',
    getParentRoute: () => DashboardJobsSyncSamplesRouteRoute,
  } as any)

const DashboardJobsSampleUploadScheduleRouteRoute =
  DashboardJobsSampleUploadScheduleRouteImport.update({
    id: '/schedule',
    path: '/schedule',
    getParentRoute: () => DashboardJobsSampleUploadRouteRoute,
  } as any)

const DashboardJobsSampleUploadJobsRouteRoute =
  DashboardJobsSampleUploadJobsRouteImport.update({
    id: '/jobs',
    path: '/jobs',
    getParentRoute: () => DashboardJobsSampleUploadRouteRoute,
  } as any)

const DashboardJobsSampleUploadAlertsRouteRoute =
  DashboardJobsSampleUploadAlertsRouteImport.update({
    id: '/alerts',
    path: '/alerts',
    getParentRoute: () => DashboardJobsSampleUploadRouteRoute,
  } as any)

const DashboardJobsRestartsScheduleRouteRoute =
  DashboardJobsRestartsScheduleRouteImport.update({
    id: '/schedule',
    path: '/schedule',
    getParentRoute: () => DashboardJobsRestartsRouteRoute,
  } as any)

const DashboardJobsRestartsJobsRouteRoute =
  DashboardJobsRestartsJobsRouteImport.update({
    id: '/jobs',
    path: '/jobs',
    getParentRoute: () => DashboardJobsRestartsRouteRoute,
  } as any)

const DashboardJobsRecoveryEstimatesScheduleRouteRoute =
  DashboardJobsRecoveryEstimatesScheduleRouteImport.update({
    id: '/schedule',
    path: '/schedule',
    getParentRoute: () => DashboardJobsRecoveryEstimatesRouteRoute,
  } as any)

const DashboardJobsRecoveryEstimatesJobsRouteRoute =
  DashboardJobsRecoveryEstimatesJobsRouteImport.update({
    id: '/jobs',
    path: '/jobs',
    getParentRoute: () => DashboardJobsRecoveryEstimatesRouteRoute,
  } as any)

const DashboardJobsModelsScheduleRouteRoute =
  DashboardJobsModelsScheduleRouteImport.update({
    id: '/schedule',
    path: '/schedule',
    getParentRoute: () => DashboardJobsModelsRouteRoute,
  } as any)

const DashboardJobsModelsJobsRouteRoute =
  DashboardJobsModelsJobsRouteImport.update({
    id: '/jobs',
    path: '/jobs',
    getParentRoute: () => DashboardJobsModelsRouteRoute,
  } as any)

const DashboardJobsHeadBlurVideosScheduleRouteRoute =
  DashboardJobsHeadBlurVideosScheduleRouteImport.update({
    id: '/schedule',
    path: '/schedule',
    getParentRoute: () => DashboardJobsHeadBlurVideosRouteRoute,
  } as any)

const DashboardJobsHeadBlurVideosJobsRouteRoute =
  DashboardJobsHeadBlurVideosJobsRouteImport.update({
    id: '/jobs',
    path: '/jobs',
    getParentRoute: () => DashboardJobsHeadBlurVideosRouteRoute,
  } as any)

const DashboardJobsHeadBlurImagesScheduleRouteRoute =
  DashboardJobsHeadBlurImagesScheduleRouteImport.update({
    id: '/schedule',
    path: '/schedule',
    getParentRoute: () => DashboardJobsHeadBlurImagesRouteRoute,
  } as any)

const DashboardJobsHeadBlurImagesJobsRouteRoute =
  DashboardJobsHeadBlurImagesJobsRouteImport.update({
    id: '/jobs',
    path: '/jobs',
    getParentRoute: () => DashboardJobsHeadBlurImagesRouteRoute,
  } as any)

const DashboardJobsDeploymentsScheduleRouteRoute =
  DashboardJobsDeploymentsScheduleRouteImport.update({
    id: '/schedule',
    path: '/schedule',
    getParentRoute: () => DashboardJobsDeploymentsRouteRoute,
  } as any)

const DashboardJobsDeploymentsJobsRouteRoute =
  DashboardJobsDeploymentsJobsRouteImport.update({
    id: '/jobs',
    path: '/jobs',
    getParentRoute: () => DashboardJobsDeploymentsRouteRoute,
  } as any)

const DashboardJobsDeleteVideosScheduleRouteRoute =
  DashboardJobsDeleteVideosScheduleRouteImport.update({
    id: '/schedule',
    path: '/schedule',
    getParentRoute: () => DashboardJobsDeleteVideosRouteRoute,
  } as any)

const DashboardJobsDeleteVideosJobsRouteRoute =
  DashboardJobsDeleteVideosJobsRouteImport.update({
    id: '/jobs',
    path: '/jobs',
    getParentRoute: () => DashboardJobsDeleteVideosRouteRoute,
  } as any)

const DashboardJobsDeleteVideosAlertsRouteRoute =
  DashboardJobsDeleteVideosAlertsRouteImport.update({
    id: '/alerts',
    path: '/alerts',
    getParentRoute: () => DashboardJobsDeleteVideosRouteRoute,
  } as any)

const DashboardJobsDeleteSamplesScheduleRouteRoute =
  DashboardJobsDeleteSamplesScheduleRouteImport.update({
    id: '/schedule',
    path: '/schedule',
    getParentRoute: () => DashboardJobsDeleteSamplesRouteRoute,
  } as any)

const DashboardJobsDeleteSamplesJobsRouteRoute =
  DashboardJobsDeleteSamplesJobsRouteImport.update({
    id: '/jobs',
    path: '/jobs',
    getParentRoute: () => DashboardJobsDeleteSamplesRouteRoute,
  } as any)

const DashboardJobsDeleteSamplesAlertsRouteRoute =
  DashboardJobsDeleteSamplesAlertsRouteImport.update({
    id: '/alerts',
    path: '/alerts',
    getParentRoute: () => DashboardJobsDeleteSamplesRouteRoute,
  } as any)

const DashboardJobsConfigScheduleRouteRoute =
  DashboardJobsConfigScheduleRouteImport.update({
    id: '/schedule',
    path: '/schedule',
    getParentRoute: () => DashboardJobsConfigRouteRoute,
  } as any)

const DashboardJobsConfigJobsRouteRoute =
  DashboardJobsConfigJobsRouteImport.update({
    id: '/jobs',
    path: '/jobs',
    getParentRoute: () => DashboardJobsConfigRouteRoute,
  } as any)

const DashboardJobsCatalogUploadScheduleRouteRoute =
  DashboardJobsCatalogUploadScheduleRouteImport.update({
    id: '/schedule',
    path: '/schedule',
    getParentRoute: () => DashboardJobsCatalogUploadRouteRoute,
  } as any)

const DashboardJobsCatalogUploadJobsRouteRoute =
  DashboardJobsCatalogUploadJobsRouteImport.update({
    id: '/jobs',
    path: '/jobs',
    getParentRoute: () => DashboardJobsCatalogUploadRouteRoute,
  } as any)

const DashboardJobsCapacityTaggingScheduleRouteRoute =
  DashboardJobsCapacityTaggingScheduleRouteImport.update({
    id: '/schedule',
    path: '/schedule',
    getParentRoute: () => DashboardJobsCapacityTaggingRouteRoute,
  } as any)

const DashboardJobsCapacityTaggingJobsRouteRoute =
  DashboardJobsCapacityTaggingJobsRouteImport.update({
    id: '/jobs',
    path: '/jobs',
    getParentRoute: () => DashboardJobsCapacityTaggingRouteRoute,
  } as any)

const DashboardJobsCameraCalibrationScheduleRouteRoute =
  DashboardJobsCameraCalibrationScheduleRouteImport.update({
    id: '/schedule',
    path: '/schedule',
    getParentRoute: () => DashboardJobsCameraCalibrationRouteRoute,
  } as any)

const DashboardJobsCameraCalibrationJobsRouteRoute =
  DashboardJobsCameraCalibrationJobsRouteImport.update({
    id: '/jobs',
    path: '/jobs',
    getParentRoute: () => DashboardJobsCameraCalibrationRouteRoute,
  } as any)

const DashboardJobsCameraCalibrationAlertsRouteRoute =
  DashboardJobsCameraCalibrationAlertsRouteImport.update({
    id: '/alerts',
    path: '/alerts',
    getParentRoute: () => DashboardJobsCameraCalibrationRouteRoute,
  } as any)

const DashboardHomeManagerReportSessionIdRouteRoute =
  DashboardHomeManagerReportSessionIdRouteImport.update({
    id: '/$sessionId',
    path: '/$sessionId',
    getParentRoute: () => DashboardHomeManagerReportRouteRoute,
  } as any)

const DashboardDataSessionsSessionIdRouteRoute =
  DashboardDataSessionsSessionIdRouteImport.update({
    id: '/$sessionId',
    path: '/$sessionId',
    getParentRoute: () => DashboardDataSessionsRouteRoute,
  } as any)

const DashboardDataLabelDistributionLabelRouteRoute =
  DashboardDataLabelDistributionLabelRouteImport.update({
    id: '/$label',
    path: '/$label',
    getParentRoute: () => DashboardDataLabelDistributionRouteRoute,
  } as any)

const DashboardDataJsonDataJsonDataUUIDRouteRoute =
  DashboardDataJsonDataJsonDataUUIDRouteImport.update({
    id: '/$jsonDataUUID',
    path: '/$jsonDataUUID',
    getParentRoute: () => DashboardDataJsonDataRouteRoute,
  } as any)

const DashboardDataImagesImageUUIDRouteRoute =
  DashboardDataImagesImageUUIDRouteImport.update({
    id: '/$imageUUID',
    path: '/$imageUUID',
    getParentRoute: () => DashboardDataImagesRouteRoute,
  } as any)

const DashboardDataDatasetsDatasetIdRouteRoute =
  DashboardDataDatasetsDatasetIdRouteImport.update({
    id: '/$datasetId',
    path: '/$datasetId',
    getParentRoute: () => DashboardDataDatasetsRouteRoute,
  } as any)

const DashboardDataCatalogItemRouteRoute =
  DashboardDataCatalogItemRouteImport.update({
    id: '/$item',
    path: '/$item',
    getParentRoute: () => DashboardDataCatalogRouteRoute,
  } as any)

const AdminDashboardNotificationsNotificationIdOverviewRouteRoute =
  AdminDashboardNotificationsNotificationIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => AdminDashboardNotificationsNotificationIdRouteRoute,
  } as any)

const AdminDashboardJobsServiceHealthChecksScheduleRouteRoute =
  AdminDashboardJobsServiceHealthChecksScheduleRouteImport.update({
    id: '/schedule',
    path: '/schedule',
    getParentRoute: () => AdminDashboardJobsServiceHealthChecksRouteRoute,
  } as any)

const AdminDashboardJobsServiceHealthChecksJobsRouteRoute =
  AdminDashboardJobsServiceHealthChecksJobsRouteImport.update({
    id: '/jobs',
    path: '/jobs',
    getParentRoute: () => AdminDashboardJobsServiceHealthChecksRouteRoute,
  } as any)

const AdminDashboardAccountsManagementAccountIdRegionsRouteRoute =
  AdminDashboardAccountsManagementAccountIdRegionsRouteImport.update({
    id: '/regions',
    path: '/regions',
    getParentRoute: () => AdminDashboardAccountsManagementAccountIdRouteRoute,
  } as any)

const AdminDashboardAccountsManagementAccountIdOverviewRouteRoute =
  AdminDashboardAccountsManagementAccountIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => AdminDashboardAccountsManagementAccountIdRouteRoute,
  } as any)

const AdminDashboardAccountsManagementAccountIdOperationalHoursRouteRoute =
  AdminDashboardAccountsManagementAccountIdOperationalHoursRouteImport.update({
    id: '/operational-hours',
    path: '/operational-hours',
    getParentRoute: () => AdminDashboardAccountsManagementAccountIdRouteRoute,
  } as any)

const DashboardSettingsUserManagementUserIdIndexRoute =
  DashboardSettingsUserManagementUserIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardSettingsUserManagementUserIdRouteRoute,
  } as any)

const DashboardSettingsReportSettingsReportIdIndexRoute =
  DashboardSettingsReportSettingsReportIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardSettingsReportSettingsReportIdRouteRoute,
  } as any)

const DashboardSettingsQueuesQueueNameIndexRoute =
  DashboardSettingsQueuesQueueNameIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardSettingsQueuesQueueNameRouteRoute,
  } as any)

const DashboardResourcesSitesSiteIdIndexRoute =
  DashboardResourcesSitesSiteIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardResourcesSitesSiteIdRouteRoute,
  } as any)

const DashboardResourcesSiteGroupsSiteGroupIdIndexRoute =
  DashboardResourcesSiteGroupsSiteGroupIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardResourcesSiteGroupsSiteGroupIdRouteRoute,
  } as any)

const DashboardResourcesDevicesDeviceIdIndexRoute =
  DashboardResourcesDevicesDeviceIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardResourcesDevicesDeviceIdRouteRoute,
  } as any)

const DashboardResourcesClustersClusterIdIndexRoute =
  DashboardResourcesClustersClusterIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardResourcesClustersClusterIdRouteRoute,
  } as any)

const DashboardModelsModelIdDeploymentIndexRoute =
  DashboardModelsModelIdDeploymentIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardModelsModelIdDeploymentRouteRoute,
  } as any)

const DashboardHomeManagerReportSessionIdIndexRoute =
  DashboardHomeManagerReportSessionIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardHomeManagerReportSessionIdRouteRoute,
  } as any)

const DashboardDataSessionsSessionIdIndexRoute =
  DashboardDataSessionsSessionIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardDataSessionsSessionIdRouteRoute,
  } as any)

const DashboardDataLabelDistributionLabelIndexRoute =
  DashboardDataLabelDistributionLabelIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardDataLabelDistributionLabelRouteRoute,
  } as any)

const DashboardDataJsonDataJsonDataUUIDIndexRoute =
  DashboardDataJsonDataJsonDataUUIDIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardDataJsonDataJsonDataUUIDRouteRoute,
  } as any)

const DashboardDataImagesImageUUIDIndexRoute =
  DashboardDataImagesImageUUIDIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardDataImagesImageUUIDRouteRoute,
  } as any)

const DashboardDataCatalogItemIndexRoute =
  DashboardDataCatalogItemIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardDataCatalogItemRouteRoute,
  } as any)

const DashboardDataJsonDataJsonDataUUIDOverviewRoute =
  DashboardDataJsonDataJsonDataUUIDOverviewImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => DashboardDataJsonDataJsonDataUUIDRouteRoute,
  } as any)

const DashboardSettingsUserManagementUserIdOverviewRouteRoute =
  DashboardSettingsUserManagementUserIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => DashboardSettingsUserManagementUserIdRouteRoute,
  } as any)

const DashboardSettingsTagsManagementSitesTagIdRouteRoute =
  DashboardSettingsTagsManagementSitesTagIdRouteImport.update({
    id: '/$tagId',
    path: '/$tagId',
    getParentRoute: () => DashboardSettingsTagsManagementSitesRouteRoute,
  } as any)

const DashboardSettingsTagsManagementSessionsTagIdRouteRoute =
  DashboardSettingsTagsManagementSessionsTagIdRouteImport.update({
    id: '/$tagId',
    path: '/$tagId',
    getParentRoute: () => DashboardSettingsTagsManagementSessionsRouteRoute,
  } as any)

const DashboardSettingsTagsManagementSamplesTagIdRouteRoute =
  DashboardSettingsTagsManagementSamplesTagIdRouteImport.update({
    id: '/$tagId',
    path: '/$tagId',
    getParentRoute: () => DashboardSettingsTagsManagementSamplesRouteRoute,
  } as any)

const DashboardSettingsTagsManagementDevicesTagIdRouteRoute =
  DashboardSettingsTagsManagementDevicesTagIdRouteImport.update({
    id: '/$tagId',
    path: '/$tagId',
    getParentRoute: () => DashboardSettingsTagsManagementDevicesRouteRoute,
  } as any)

const DashboardSettingsTagsManagementClustersTagIdRouteRoute =
  DashboardSettingsTagsManagementClustersTagIdRouteImport.update({
    id: '/$tagId',
    path: '/$tagId',
    getParentRoute: () => DashboardSettingsTagsManagementClustersRouteRoute,
  } as any)

const DashboardSettingsTagsManagementCatalogTagIdRouteRoute =
  DashboardSettingsTagsManagementCatalogTagIdRouteImport.update({
    id: '/$tagId',
    path: '/$tagId',
    getParentRoute: () => DashboardSettingsTagsManagementCatalogRouteRoute,
  } as any)

const DashboardSettingsReportSubscriptionReportIdSubscriptionIdRouteRoute =
  DashboardSettingsReportSubscriptionReportIdSubscriptionIdRouteImport.update({
    id: '/report-subscription/$reportId/$subscriptionId',
    path: '/report-subscription/$reportId/$subscriptionId',
    getParentRoute: () => DashboardSettingsRouteRoute,
  } as any)

const DashboardSettingsReportSettingsReportIdSubscriptions2RouteRoute =
  DashboardSettingsReportSettingsReportIdSubscriptions2RouteImport.update({
    id: '/subscriptions2',
    path: '/subscriptions2',
    getParentRoute: () => DashboardSettingsReportSettingsReportIdRouteRoute,
  } as any)

const DashboardSettingsReportSettingsReportIdSendLogRouteRoute =
  DashboardSettingsReportSettingsReportIdSendLogRouteImport.update({
    id: '/send-log',
    path: '/send-log',
    getParentRoute: () => DashboardSettingsReportSettingsReportIdRouteRoute,
  } as any)

const DashboardSettingsReportSettingsReportIdParametersRouteRoute =
  DashboardSettingsReportSettingsReportIdParametersRouteImport.update({
    id: '/parameters',
    path: '/parameters',
    getParentRoute: () => DashboardSettingsReportSettingsReportIdRouteRoute,
  } as any)

const DashboardSettingsReportSettingsReportIdOverviewRouteRoute =
  DashboardSettingsReportSettingsReportIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => DashboardSettingsReportSettingsReportIdRouteRoute,
  } as any)

const DashboardSettingsQueuesQueueNamePendingRouteRoute =
  DashboardSettingsQueuesQueueNamePendingRouteImport.update({
    id: '/pending',
    path: '/pending',
    getParentRoute: () => DashboardSettingsQueuesQueueNameRouteRoute,
  } as any)

const DashboardSettingsQueuesQueueNameFailuresRouteRoute =
  DashboardSettingsQueuesQueueNameFailuresRouteImport.update({
    id: '/failures',
    path: '/failures',
    getParentRoute: () => DashboardSettingsQueuesQueueNameRouteRoute,
  } as any)

const DashboardSettingsAlertManagementAlertsAlertIdRouteRoute =
  DashboardSettingsAlertManagementAlertsAlertIdRouteImport.update({
    id: '/$alertId',
    path: '/$alertId',
    getParentRoute: () => DashboardSettingsAlertManagementAlertsRouteRoute,
  } as any)

const DashboardResourcesSitesSiteIdVersionHistoryRouteRoute =
  DashboardResourcesSitesSiteIdVersionHistoryRouteImport.update({
    id: '/version-history',
    path: '/version-history',
    getParentRoute: () => DashboardResourcesSitesSiteIdRouteRoute,
  } as any)

const DashboardResourcesSitesSiteIdOverviewRouteRoute =
  DashboardResourcesSitesSiteIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => DashboardResourcesSitesSiteIdRouteRoute,
  } as any)

const DashboardResourcesSitesSiteIdDevicesRouteRoute =
  DashboardResourcesSitesSiteIdDevicesRouteImport.update({
    id: '/devices',
    path: '/devices',
    getParentRoute: () => DashboardResourcesSitesSiteIdRouteRoute,
  } as any)

const DashboardResourcesSiteGroupsSiteGroupIdSitesRouteRoute =
  DashboardResourcesSiteGroupsSiteGroupIdSitesRouteImport.update({
    id: '/sites',
    path: '/sites',
    getParentRoute: () => DashboardResourcesSiteGroupsSiteGroupIdRouteRoute,
  } as any)

const DashboardResourcesSiteGroupsSiteGroupIdOverviewRouteRoute =
  DashboardResourcesSiteGroupsSiteGroupIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => DashboardResourcesSiteGroupsSiteGroupIdRouteRoute,
  } as any)

const DashboardResourcesSiteGroupsSiteGroupIdLabelsRouteRoute =
  DashboardResourcesSiteGroupsSiteGroupIdLabelsRouteImport.update({
    id: '/labels',
    path: '/labels',
    getParentRoute: () => DashboardResourcesSiteGroupsSiteGroupIdRouteRoute,
  } as any)

const DashboardResourcesDevicesDeviceIdVersionHistoryRouteRoute =
  DashboardResourcesDevicesDeviceIdVersionHistoryRouteImport.update({
    id: '/version-history',
    path: '/version-history',
    getParentRoute: () => DashboardResourcesDevicesDeviceIdRouteRoute,
  } as any)

const DashboardResourcesDevicesDeviceIdSettingsRouteRoute =
  DashboardResourcesDevicesDeviceIdSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => DashboardResourcesDevicesDeviceIdRouteRoute,
  } as any)

const DashboardResourcesDevicesDeviceIdOverviewRouteRoute =
  DashboardResourcesDevicesDeviceIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => DashboardResourcesDevicesDeviceIdRouteRoute,
  } as any)

const DashboardResourcesDevicesDeviceIdLogsRouteRoute =
  DashboardResourcesDevicesDeviceIdLogsRouteImport.update({
    id: '/logs',
    path: '/logs',
    getParentRoute: () => DashboardResourcesDevicesDeviceIdRouteRoute,
  } as any)

const DashboardResourcesDevicesDeviceIdDiagnosticsRouteRoute =
  DashboardResourcesDevicesDeviceIdDiagnosticsRouteImport.update({
    id: '/diagnostics',
    path: '/diagnostics',
    getParentRoute: () => DashboardResourcesDevicesDeviceIdRouteRoute,
  } as any)

const DashboardResourcesDevicesDeviceIdDataRouteRoute =
  DashboardResourcesDevicesDeviceIdDataRouteImport.update({
    id: '/data',
    path: '/data',
    getParentRoute: () => DashboardResourcesDevicesDeviceIdRouteRoute,
  } as any)

const DashboardResourcesDevicesDeviceIdCameraRouteRoute =
  DashboardResourcesDevicesDeviceIdCameraRouteImport.update({
    id: '/camera',
    path: '/camera',
    getParentRoute: () => DashboardResourcesDevicesDeviceIdRouteRoute,
  } as any)

const DashboardResourcesClustersClusterIdOverviewRouteRoute =
  DashboardResourcesClustersClusterIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => DashboardResourcesClustersClusterIdRouteRoute,
  } as any)

const DashboardResourcesClustersClusterIdDevicesRouteRoute =
  DashboardResourcesClustersClusterIdDevicesRouteImport.update({
    id: '/devices',
    path: '/devices',
    getParentRoute: () => DashboardResourcesClustersClusterIdRouteRoute,
  } as any)

const DashboardModelsModelIdDeploymentDevicesRouteRoute =
  DashboardModelsModelIdDeploymentDevicesRouteImport.update({
    id: '/devices',
    path: '/devices',
    getParentRoute: () => DashboardModelsModelIdDeploymentRouteRoute,
  } as any)

const DashboardModelsModelIdDeploymentClustersRouteRoute =
  DashboardModelsModelIdDeploymentClustersRouteImport.update({
    id: '/clusters',
    path: '/clusters',
    getParentRoute: () => DashboardModelsModelIdDeploymentRouteRoute,
  } as any)

const DashboardJobsWorkerJobsScheduleScheduledJobIdRouteRoute =
  DashboardJobsWorkerJobsScheduleScheduledJobIdRouteImport.update({
    id: '/$scheduledJobId',
    path: '/$scheduledJobId',
    getParentRoute: () => DashboardJobsWorkerJobsScheduleRouteRoute,
  } as any)

const DashboardJobsWorkerJobsJobsJobIdRouteRoute =
  DashboardJobsWorkerJobsJobsJobIdRouteImport.update({
    id: '/$jobId',
    path: '/$jobId',
    getParentRoute: () => DashboardJobsWorkerJobsJobsRouteRoute,
  } as any)

const DashboardJobsVideoUploadScheduleScheduledJobIdRouteRoute =
  DashboardJobsVideoUploadScheduleScheduledJobIdRouteImport.update({
    id: '/$scheduledJobId',
    path: '/$scheduledJobId',
    getParentRoute: () => DashboardJobsVideoUploadScheduleRouteRoute,
  } as any)

const DashboardJobsVideoUploadJobsJobIdRouteRoute =
  DashboardJobsVideoUploadJobsJobIdRouteImport.update({
    id: '/$jobId',
    path: '/$jobId',
    getParentRoute: () => DashboardJobsVideoUploadJobsRouteRoute,
  } as any)

const DashboardJobsTrainingScheduleScheduledJobIdRouteRoute =
  DashboardJobsTrainingScheduleScheduledJobIdRouteImport.update({
    id: '/$scheduledJobId',
    path: '/$scheduledJobId',
    getParentRoute: () => DashboardJobsTrainingScheduleRouteRoute,
  } as any)

const DashboardJobsTrainingJobsJobIdRouteRoute =
  DashboardJobsTrainingJobsJobIdRouteImport.update({
    id: '/$jobId',
    path: '/$jobId',
    getParentRoute: () => DashboardJobsTrainingJobsRouteRoute,
  } as any)

const DashboardJobsSyncSamplesScheduleScheduledJobIdRouteRoute =
  DashboardJobsSyncSamplesScheduleScheduledJobIdRouteImport.update({
    id: '/$scheduledJobId',
    path: '/$scheduledJobId',
    getParentRoute: () => DashboardJobsSyncSamplesScheduleRouteRoute,
  } as any)

const DashboardJobsSyncSamplesJobsJobIdRouteRoute =
  DashboardJobsSyncSamplesJobsJobIdRouteImport.update({
    id: '/$jobId',
    path: '/$jobId',
    getParentRoute: () => DashboardJobsSyncSamplesJobsRouteRoute,
  } as any)

const DashboardJobsSampleUploadScheduleScheduledJobIdRouteRoute =
  DashboardJobsSampleUploadScheduleScheduledJobIdRouteImport.update({
    id: '/$scheduledJobId',
    path: '/$scheduledJobId',
    getParentRoute: () => DashboardJobsSampleUploadScheduleRouteRoute,
  } as any)

const DashboardJobsSampleUploadJobsJobIdRouteRoute =
  DashboardJobsSampleUploadJobsJobIdRouteImport.update({
    id: '/$jobId',
    path: '/$jobId',
    getParentRoute: () => DashboardJobsSampleUploadJobsRouteRoute,
  } as any)

const DashboardJobsRestartsScheduleScheduledJobIdRouteRoute =
  DashboardJobsRestartsScheduleScheduledJobIdRouteImport.update({
    id: '/$scheduledJobId',
    path: '/$scheduledJobId',
    getParentRoute: () => DashboardJobsRestartsScheduleRouteRoute,
  } as any)

const DashboardJobsRestartsJobsJobIdRouteRoute =
  DashboardJobsRestartsJobsJobIdRouteImport.update({
    id: '/$jobId',
    path: '/$jobId',
    getParentRoute: () => DashboardJobsRestartsJobsRouteRoute,
  } as any)

const DashboardJobsRecoveryEstimatesScheduleScheduledJobIdRouteRoute =
  DashboardJobsRecoveryEstimatesScheduleScheduledJobIdRouteImport.update({
    id: '/$scheduledJobId',
    path: '/$scheduledJobId',
    getParentRoute: () => DashboardJobsRecoveryEstimatesScheduleRouteRoute,
  } as any)

const DashboardJobsRecoveryEstimatesJobsJobIdRouteRoute =
  DashboardJobsRecoveryEstimatesJobsJobIdRouteImport.update({
    id: '/$jobId',
    path: '/$jobId',
    getParentRoute: () => DashboardJobsRecoveryEstimatesJobsRouteRoute,
  } as any)

const DashboardJobsModelsScheduleScheduledJobIdRouteRoute =
  DashboardJobsModelsScheduleScheduledJobIdRouteImport.update({
    id: '/$scheduledJobId',
    path: '/$scheduledJobId',
    getParentRoute: () => DashboardJobsModelsScheduleRouteRoute,
  } as any)

const DashboardJobsModelsJobsJobIdRouteRoute =
  DashboardJobsModelsJobsJobIdRouteImport.update({
    id: '/$jobId',
    path: '/$jobId',
    getParentRoute: () => DashboardJobsModelsJobsRouteRoute,
  } as any)

const DashboardJobsHeadBlurVideosScheduleScheduledJobIdRouteRoute =
  DashboardJobsHeadBlurVideosScheduleScheduledJobIdRouteImport.update({
    id: '/$scheduledJobId',
    path: '/$scheduledJobId',
    getParentRoute: () => DashboardJobsHeadBlurVideosScheduleRouteRoute,
  } as any)

const DashboardJobsHeadBlurVideosJobsJobIdRouteRoute =
  DashboardJobsHeadBlurVideosJobsJobIdRouteImport.update({
    id: '/$jobId',
    path: '/$jobId',
    getParentRoute: () => DashboardJobsHeadBlurVideosJobsRouteRoute,
  } as any)

const DashboardJobsHeadBlurImagesScheduleScheduledJobIdRouteRoute =
  DashboardJobsHeadBlurImagesScheduleScheduledJobIdRouteImport.update({
    id: '/$scheduledJobId',
    path: '/$scheduledJobId',
    getParentRoute: () => DashboardJobsHeadBlurImagesScheduleRouteRoute,
  } as any)

const DashboardJobsHeadBlurImagesJobsJobIdRouteRoute =
  DashboardJobsHeadBlurImagesJobsJobIdRouteImport.update({
    id: '/$jobId',
    path: '/$jobId',
    getParentRoute: () => DashboardJobsHeadBlurImagesJobsRouteRoute,
  } as any)

const DashboardJobsDeploymentsScheduleScheduledJobIdRouteRoute =
  DashboardJobsDeploymentsScheduleScheduledJobIdRouteImport.update({
    id: '/$scheduledJobId',
    path: '/$scheduledJobId',
    getParentRoute: () => DashboardJobsDeploymentsScheduleRouteRoute,
  } as any)

const DashboardJobsDeploymentsJobsJobIdRouteRoute =
  DashboardJobsDeploymentsJobsJobIdRouteImport.update({
    id: '/$jobId',
    path: '/$jobId',
    getParentRoute: () => DashboardJobsDeploymentsJobsRouteRoute,
  } as any)

const DashboardJobsDeleteVideosScheduleScheduledJobIdRouteRoute =
  DashboardJobsDeleteVideosScheduleScheduledJobIdRouteImport.update({
    id: '/$scheduledJobId',
    path: '/$scheduledJobId',
    getParentRoute: () => DashboardJobsDeleteVideosScheduleRouteRoute,
  } as any)

const DashboardJobsDeleteVideosJobsJobIdRouteRoute =
  DashboardJobsDeleteVideosJobsJobIdRouteImport.update({
    id: '/$jobId',
    path: '/$jobId',
    getParentRoute: () => DashboardJobsDeleteVideosJobsRouteRoute,
  } as any)

const DashboardJobsDeleteSamplesScheduleScheduledJobIdRouteRoute =
  DashboardJobsDeleteSamplesScheduleScheduledJobIdRouteImport.update({
    id: '/$scheduledJobId',
    path: '/$scheduledJobId',
    getParentRoute: () => DashboardJobsDeleteSamplesScheduleRouteRoute,
  } as any)

const DashboardJobsDeleteSamplesJobsJobIdRouteRoute =
  DashboardJobsDeleteSamplesJobsJobIdRouteImport.update({
    id: '/$jobId',
    path: '/$jobId',
    getParentRoute: () => DashboardJobsDeleteSamplesJobsRouteRoute,
  } as any)

const DashboardJobsConfigScheduleScheduledJobIdRouteRoute =
  DashboardJobsConfigScheduleScheduledJobIdRouteImport.update({
    id: '/$scheduledJobId',
    path: '/$scheduledJobId',
    getParentRoute: () => DashboardJobsConfigScheduleRouteRoute,
  } as any)

const DashboardJobsConfigJobsJobIdRouteRoute =
  DashboardJobsConfigJobsJobIdRouteImport.update({
    id: '/$jobId',
    path: '/$jobId',
    getParentRoute: () => DashboardJobsConfigJobsRouteRoute,
  } as any)

const DashboardJobsCatalogUploadScheduleScheduledJobIdRouteRoute =
  DashboardJobsCatalogUploadScheduleScheduledJobIdRouteImport.update({
    id: '/$scheduledJobId',
    path: '/$scheduledJobId',
    getParentRoute: () => DashboardJobsCatalogUploadScheduleRouteRoute,
  } as any)

const DashboardJobsCatalogUploadJobsJobIdRouteRoute =
  DashboardJobsCatalogUploadJobsJobIdRouteImport.update({
    id: '/$jobId',
    path: '/$jobId',
    getParentRoute: () => DashboardJobsCatalogUploadJobsRouteRoute,
  } as any)

const DashboardJobsCapacityTaggingScheduleScheduledJobIdRouteRoute =
  DashboardJobsCapacityTaggingScheduleScheduledJobIdRouteImport.update({
    id: '/$scheduledJobId',
    path: '/$scheduledJobId',
    getParentRoute: () => DashboardJobsCapacityTaggingScheduleRouteRoute,
  } as any)

const DashboardJobsCapacityTaggingJobsJobIdRouteRoute =
  DashboardJobsCapacityTaggingJobsJobIdRouteImport.update({
    id: '/$jobId',
    path: '/$jobId',
    getParentRoute: () => DashboardJobsCapacityTaggingJobsRouteRoute,
  } as any)

const DashboardJobsCameraCalibrationScheduleScheduledJobIdRouteRoute =
  DashboardJobsCameraCalibrationScheduleScheduledJobIdRouteImport.update({
    id: '/$scheduledJobId',
    path: '/$scheduledJobId',
    getParentRoute: () => DashboardJobsCameraCalibrationScheduleRouteRoute,
  } as any)

const DashboardJobsCameraCalibrationJobsJobIdRouteRoute =
  DashboardJobsCameraCalibrationJobsJobIdRouteImport.update({
    id: '/$jobId',
    path: '/$jobId',
    getParentRoute: () => DashboardJobsCameraCalibrationJobsRouteRoute,
  } as any)

const DashboardHomeManagerReportSessionIdOverviewRouteRoute =
  DashboardHomeManagerReportSessionIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => DashboardHomeManagerReportSessionIdRouteRoute,
  } as any)

const DashboardDataSessionsSessionIdOverviewRouteRoute =
  DashboardDataSessionsSessionIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => DashboardDataSessionsSessionIdRouteRoute,
  } as any)

const DashboardDataImagesImageUUIDTransactionDetailsRouteRoute =
  DashboardDataImagesImageUUIDTransactionDetailsRouteImport.update({
    id: '/transaction-details',
    path: '/transaction-details',
    getParentRoute: () => DashboardDataImagesImageUUIDRouteRoute,
  } as any)

const DashboardDataImagesImageUUIDOverviewRouteRoute =
  DashboardDataImagesImageUUIDOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => DashboardDataImagesImageUUIDRouteRoute,
  } as any)

const DashboardDataImagesImageUUIDAdditionalRouteRoute =
  DashboardDataImagesImageUUIDAdditionalRouteImport.update({
    id: '/additional',
    path: '/additional',
    getParentRoute: () => DashboardDataImagesImageUUIDRouteRoute,
  } as any)

const DashboardDataDatasetsDatasetIdSessionsRouteRoute =
  DashboardDataDatasetsDatasetIdSessionsRouteImport.update({
    id: '/sessions',
    path: '/sessions',
    getParentRoute: () => DashboardDataDatasetsDatasetIdRouteRoute,
  } as any)

const DashboardDataDatasetsDatasetIdOverviewRouteRoute =
  DashboardDataDatasetsDatasetIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => DashboardDataDatasetsDatasetIdRouteRoute,
  } as any)

const DashboardDataDatasetsDatasetIdImagesRouteRoute =
  DashboardDataDatasetsDatasetIdImagesRouteImport.update({
    id: '/images',
    path: '/images',
    getParentRoute: () => DashboardDataDatasetsDatasetIdRouteRoute,
  } as any)

const DashboardDataCatalogItemPricesRouteRoute =
  DashboardDataCatalogItemPricesRouteImport.update({
    id: '/prices',
    path: '/prices',
    getParentRoute: () => DashboardDataCatalogItemRouteRoute,
  } as any)

const DashboardDataCatalogItemLabelsRouteRoute =
  DashboardDataCatalogItemLabelsRouteImport.update({
    id: '/labels',
    path: '/labels',
    getParentRoute: () => DashboardDataCatalogItemRouteRoute,
  } as any)

const DashboardDataCatalogItemDetailsRouteRoute =
  DashboardDataCatalogItemDetailsRouteImport.update({
    id: '/details',
    path: '/details',
    getParentRoute: () => DashboardDataCatalogItemRouteRoute,
  } as any)

const AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdRouteRoute =
  AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdRouteImport.update(
    {
      id: '/$scheduledJobId',
      path: '/$scheduledJobId',
      getParentRoute: () =>
        AdminDashboardJobsServiceHealthChecksScheduleRouteRoute,
    } as any,
  )

const AdminDashboardJobsServiceHealthChecksJobsJobIdRouteRoute =
  AdminDashboardJobsServiceHealthChecksJobsJobIdRouteImport.update({
    id: '/$jobId',
    path: '/$jobId',
    getParentRoute: () => AdminDashboardJobsServiceHealthChecksJobsRouteRoute,
  } as any)

const DashboardSettingsQueuesQueueNamePendingIndexRouteRoute =
  DashboardSettingsQueuesQueueNamePendingIndexRouteImport.update({
    id: '/$index',
    path: '/$index',
    getParentRoute: () => DashboardSettingsQueuesQueueNamePendingRouteRoute,
  } as any)

const DashboardSettingsQueuesQueueNameFailuresIndexRouteRoute =
  DashboardSettingsQueuesQueueNameFailuresIndexRouteImport.update({
    id: '/$index',
    path: '/$index',
    getParentRoute: () => DashboardSettingsQueuesQueueNameFailuresRouteRoute,
  } as any)

const DashboardSettingsTagsManagementSitesTagIdIndexRoute =
  DashboardSettingsTagsManagementSitesTagIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardSettingsTagsManagementSitesTagIdRouteRoute,
  } as any)

const DashboardSettingsTagsManagementSessionsTagIdIndexRoute =
  DashboardSettingsTagsManagementSessionsTagIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      DashboardSettingsTagsManagementSessionsTagIdRouteRoute,
  } as any)

const DashboardSettingsTagsManagementSamplesTagIdIndexRoute =
  DashboardSettingsTagsManagementSamplesTagIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardSettingsTagsManagementSamplesTagIdRouteRoute,
  } as any)

const DashboardSettingsTagsManagementDevicesTagIdIndexRoute =
  DashboardSettingsTagsManagementDevicesTagIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardSettingsTagsManagementDevicesTagIdRouteRoute,
  } as any)

const DashboardSettingsTagsManagementClustersTagIdIndexRoute =
  DashboardSettingsTagsManagementClustersTagIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      DashboardSettingsTagsManagementClustersTagIdRouteRoute,
  } as any)

const DashboardSettingsTagsManagementCatalogTagIdIndexRoute =
  DashboardSettingsTagsManagementCatalogTagIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardSettingsTagsManagementCatalogTagIdRouteRoute,
  } as any)

const DashboardSettingsReportSubscriptionReportIdSubscriptionIdIndexRoute =
  DashboardSettingsReportSubscriptionReportIdSubscriptionIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      DashboardSettingsReportSubscriptionReportIdSubscriptionIdRouteRoute,
  } as any)

const DashboardSettingsAlertManagementMetricAlertsMetricAlertIdIndexRoute =
  DashboardSettingsAlertManagementMetricAlertsMetricAlertIdIndexImport.update({
    id: '/$metricAlertId/',
    path: '/$metricAlertId/',
    getParentRoute: () =>
      DashboardSettingsAlertManagementMetricAlertsRouteRoute,
  } as any)

const DashboardSettingsAlertManagementAlertsAlertIdIndexRoute =
  DashboardSettingsAlertManagementAlertsAlertIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      DashboardSettingsAlertManagementAlertsAlertIdRouteRoute,
  } as any)

const DashboardResourcesSitesSiteIdVersionHistoryIndexRoute =
  DashboardResourcesSitesSiteIdVersionHistoryIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardResourcesSitesSiteIdVersionHistoryRouteRoute,
  } as any)

const DashboardResourcesDevicesDeviceIdVersionHistoryIndexRoute =
  DashboardResourcesDevicesDeviceIdVersionHistoryIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      DashboardResourcesDevicesDeviceIdVersionHistoryRouteRoute,
  } as any)

const DashboardResourcesDevicesDeviceIdDataIndexRoute =
  DashboardResourcesDevicesDeviceIdDataIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardResourcesDevicesDeviceIdDataRouteRoute,
  } as any)

const DashboardJobsWorkerJobsScheduleScheduledJobIdIndexRoute =
  DashboardJobsWorkerJobsScheduleScheduledJobIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      DashboardJobsWorkerJobsScheduleScheduledJobIdRouteRoute,
  } as any)

const DashboardJobsWorkerJobsJobsJobIdIndexRoute =
  DashboardJobsWorkerJobsJobsJobIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardJobsWorkerJobsJobsJobIdRouteRoute,
  } as any)

const DashboardJobsVideoUploadScheduleScheduledJobIdIndexRoute =
  DashboardJobsVideoUploadScheduleScheduledJobIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      DashboardJobsVideoUploadScheduleScheduledJobIdRouteRoute,
  } as any)

const DashboardJobsVideoUploadJobsJobIdIndexRoute =
  DashboardJobsVideoUploadJobsJobIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardJobsVideoUploadJobsJobIdRouteRoute,
  } as any)

const DashboardJobsTrainingScheduleScheduledJobIdIndexRoute =
  DashboardJobsTrainingScheduleScheduledJobIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardJobsTrainingScheduleScheduledJobIdRouteRoute,
  } as any)

const DashboardJobsTrainingJobsJobIdIndexRoute =
  DashboardJobsTrainingJobsJobIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardJobsTrainingJobsJobIdRouteRoute,
  } as any)

const DashboardJobsSyncSamplesScheduleScheduledJobIdIndexRoute =
  DashboardJobsSyncSamplesScheduleScheduledJobIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      DashboardJobsSyncSamplesScheduleScheduledJobIdRouteRoute,
  } as any)

const DashboardJobsSyncSamplesJobsJobIdIndexRoute =
  DashboardJobsSyncSamplesJobsJobIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardJobsSyncSamplesJobsJobIdRouteRoute,
  } as any)

const DashboardJobsSampleUploadScheduleScheduledJobIdIndexRoute =
  DashboardJobsSampleUploadScheduleScheduledJobIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      DashboardJobsSampleUploadScheduleScheduledJobIdRouteRoute,
  } as any)

const DashboardJobsSampleUploadJobsJobIdIndexRoute =
  DashboardJobsSampleUploadJobsJobIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardJobsSampleUploadJobsJobIdRouteRoute,
  } as any)

const DashboardJobsRestartsScheduleScheduledJobIdIndexRoute =
  DashboardJobsRestartsScheduleScheduledJobIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardJobsRestartsScheduleScheduledJobIdRouteRoute,
  } as any)

const DashboardJobsRestartsJobsJobIdIndexRoute =
  DashboardJobsRestartsJobsJobIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardJobsRestartsJobsJobIdRouteRoute,
  } as any)

const DashboardJobsRecoveryEstimatesScheduleScheduledJobIdIndexRoute =
  DashboardJobsRecoveryEstimatesScheduleScheduledJobIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      DashboardJobsRecoveryEstimatesScheduleScheduledJobIdRouteRoute,
  } as any)

const DashboardJobsRecoveryEstimatesJobsJobIdIndexRoute =
  DashboardJobsRecoveryEstimatesJobsJobIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardJobsRecoveryEstimatesJobsJobIdRouteRoute,
  } as any)

const DashboardJobsModelsScheduleScheduledJobIdIndexRoute =
  DashboardJobsModelsScheduleScheduledJobIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardJobsModelsScheduleScheduledJobIdRouteRoute,
  } as any)

const DashboardJobsModelsJobsJobIdIndexRoute =
  DashboardJobsModelsJobsJobIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardJobsModelsJobsJobIdRouteRoute,
  } as any)

const DashboardJobsHeadBlurVideosScheduleScheduledJobIdIndexRoute =
  DashboardJobsHeadBlurVideosScheduleScheduledJobIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      DashboardJobsHeadBlurVideosScheduleScheduledJobIdRouteRoute,
  } as any)

const DashboardJobsHeadBlurVideosJobsJobIdIndexRoute =
  DashboardJobsHeadBlurVideosJobsJobIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardJobsHeadBlurVideosJobsJobIdRouteRoute,
  } as any)

const DashboardJobsHeadBlurImagesScheduleScheduledJobIdIndexRoute =
  DashboardJobsHeadBlurImagesScheduleScheduledJobIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      DashboardJobsHeadBlurImagesScheduleScheduledJobIdRouteRoute,
  } as any)

const DashboardJobsHeadBlurImagesJobsJobIdIndexRoute =
  DashboardJobsHeadBlurImagesJobsJobIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardJobsHeadBlurImagesJobsJobIdRouteRoute,
  } as any)

const DashboardJobsDeploymentsScheduleScheduledJobIdIndexRoute =
  DashboardJobsDeploymentsScheduleScheduledJobIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      DashboardJobsDeploymentsScheduleScheduledJobIdRouteRoute,
  } as any)

const DashboardJobsDeploymentsJobsJobIdIndexRoute =
  DashboardJobsDeploymentsJobsJobIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardJobsDeploymentsJobsJobIdRouteRoute,
  } as any)

const DashboardJobsDeleteVideosScheduleScheduledJobIdIndexRoute =
  DashboardJobsDeleteVideosScheduleScheduledJobIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      DashboardJobsDeleteVideosScheduleScheduledJobIdRouteRoute,
  } as any)

const DashboardJobsDeleteVideosJobsJobIdIndexRoute =
  DashboardJobsDeleteVideosJobsJobIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardJobsDeleteVideosJobsJobIdRouteRoute,
  } as any)

const DashboardJobsDeleteSamplesScheduleScheduledJobIdIndexRoute =
  DashboardJobsDeleteSamplesScheduleScheduledJobIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      DashboardJobsDeleteSamplesScheduleScheduledJobIdRouteRoute,
  } as any)

const DashboardJobsDeleteSamplesJobsJobIdIndexRoute =
  DashboardJobsDeleteSamplesJobsJobIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardJobsDeleteSamplesJobsJobIdRouteRoute,
  } as any)

const DashboardJobsConfigScheduleScheduledJobIdIndexRoute =
  DashboardJobsConfigScheduleScheduledJobIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardJobsConfigScheduleScheduledJobIdRouteRoute,
  } as any)

const DashboardJobsConfigJobsJobIdIndexRoute =
  DashboardJobsConfigJobsJobIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardJobsConfigJobsJobIdRouteRoute,
  } as any)

const DashboardJobsCatalogUploadScheduleScheduledJobIdIndexRoute =
  DashboardJobsCatalogUploadScheduleScheduledJobIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      DashboardJobsCatalogUploadScheduleScheduledJobIdRouteRoute,
  } as any)

const DashboardJobsCatalogUploadJobsJobIdIndexRoute =
  DashboardJobsCatalogUploadJobsJobIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardJobsCatalogUploadJobsJobIdRouteRoute,
  } as any)

const DashboardJobsCapacityTaggingScheduleScheduledJobIdIndexRoute =
  DashboardJobsCapacityTaggingScheduleScheduledJobIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      DashboardJobsCapacityTaggingScheduleScheduledJobIdRouteRoute,
  } as any)

const DashboardJobsCapacityTaggingJobsJobIdIndexRoute =
  DashboardJobsCapacityTaggingJobsJobIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardJobsCapacityTaggingJobsJobIdRouteRoute,
  } as any)

const DashboardJobsCameraCalibrationScheduleScheduledJobIdIndexRoute =
  DashboardJobsCameraCalibrationScheduleScheduledJobIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      DashboardJobsCameraCalibrationScheduleScheduledJobIdRouteRoute,
  } as any)

const DashboardJobsCameraCalibrationJobsJobIdIndexRoute =
  DashboardJobsCameraCalibrationJobsJobIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardJobsCameraCalibrationJobsJobIdRouteRoute,
  } as any)

const AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdIndexRoute =
  AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdRouteRoute,
    } as any,
  )

const AdminDashboardJobsServiceHealthChecksJobsJobIdIndexRoute =
  AdminDashboardJobsServiceHealthChecksJobsJobIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AdminDashboardJobsServiceHealthChecksJobsJobIdRouteRoute,
  } as any)

const DashboardSettingsTagsManagementSitesTagIdDetailsRouteRoute =
  DashboardSettingsTagsManagementSitesTagIdDetailsRouteImport.update({
    id: '/details',
    path: '/details',
    getParentRoute: () => DashboardSettingsTagsManagementSitesTagIdRouteRoute,
  } as any)

const DashboardSettingsTagsManagementSessionsTagIdDetailsRouteRoute =
  DashboardSettingsTagsManagementSessionsTagIdDetailsRouteImport.update({
    id: '/details',
    path: '/details',
    getParentRoute: () =>
      DashboardSettingsTagsManagementSessionsTagIdRouteRoute,
  } as any)

const DashboardSettingsTagsManagementSamplesTagIdDetailsRouteRoute =
  DashboardSettingsTagsManagementSamplesTagIdDetailsRouteImport.update({
    id: '/details',
    path: '/details',
    getParentRoute: () => DashboardSettingsTagsManagementSamplesTagIdRouteRoute,
  } as any)

const DashboardSettingsTagsManagementDevicesTagIdDetailsRouteRoute =
  DashboardSettingsTagsManagementDevicesTagIdDetailsRouteImport.update({
    id: '/details',
    path: '/details',
    getParentRoute: () => DashboardSettingsTagsManagementDevicesTagIdRouteRoute,
  } as any)

const DashboardSettingsTagsManagementClustersTagIdDetailsRouteRoute =
  DashboardSettingsTagsManagementClustersTagIdDetailsRouteImport.update({
    id: '/details',
    path: '/details',
    getParentRoute: () =>
      DashboardSettingsTagsManagementClustersTagIdRouteRoute,
  } as any)

const DashboardSettingsTagsManagementCatalogTagIdDetailsRouteRoute =
  DashboardSettingsTagsManagementCatalogTagIdDetailsRouteImport.update({
    id: '/details',
    path: '/details',
    getParentRoute: () => DashboardSettingsTagsManagementCatalogTagIdRouteRoute,
  } as any)

const DashboardSettingsReportSubscriptionReportIdSubscriptionIdSendHistoryRouteRoute =
  DashboardSettingsReportSubscriptionReportIdSubscriptionIdSendHistoryRouteImport.update(
    {
      id: '/send-history',
      path: '/send-history',
      getParentRoute: () =>
        DashboardSettingsReportSubscriptionReportIdSubscriptionIdRouteRoute,
    } as any,
  )

const DashboardSettingsReportSubscriptionReportIdSubscriptionIdReviewAndApproveRouteRoute =
  DashboardSettingsReportSubscriptionReportIdSubscriptionIdReviewAndApproveRouteImport.update(
    {
      id: '/review-and-approve',
      path: '/review-and-approve',
      getParentRoute: () =>
        DashboardSettingsReportSubscriptionReportIdSubscriptionIdRouteRoute,
    } as any,
  )

const DashboardSettingsReportSubscriptionReportIdSubscriptionIdOverviewRouteRoute =
  DashboardSettingsReportSubscriptionReportIdSubscriptionIdOverviewRouteImport.update(
    {
      id: '/overview',
      path: '/overview',
      getParentRoute: () =>
        DashboardSettingsReportSubscriptionReportIdSubscriptionIdRouteRoute,
    } as any,
  )

const DashboardSettingsReportSubscriptionReportIdSubscriptionIdEditRouteRoute =
  DashboardSettingsReportSubscriptionReportIdSubscriptionIdEditRouteImport.update(
    {
      id: '/edit',
      path: '/edit',
      getParentRoute: () =>
        DashboardSettingsReportSubscriptionReportIdSubscriptionIdRouteRoute,
    } as any,
  )

const DashboardSettingsAlertManagementAlertsAlertIdOverviewRouteRoute =
  DashboardSettingsAlertManagementAlertsAlertIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () =>
      DashboardSettingsAlertManagementAlertsAlertIdRouteRoute,
  } as any)

const DashboardResourcesSitesSiteIdVersionHistoryZebraAdapterRouteRoute =
  DashboardResourcesSitesSiteIdVersionHistoryZebraAdapterRouteImport.update({
    id: '/zebra-adapter',
    path: '/zebra-adapter',
    getParentRoute: () => DashboardResourcesSitesSiteIdVersionHistoryRouteRoute,
  } as any)

const DashboardResourcesSitesSiteIdVersionHistoryTrainerRouteRoute =
  DashboardResourcesSitesSiteIdVersionHistoryTrainerRouteImport.update({
    id: '/trainer',
    path: '/trainer',
    getParentRoute: () => DashboardResourcesSitesSiteIdVersionHistoryRouteRoute,
  } as any)

const DashboardResourcesSitesSiteIdVersionHistoryOnScreenAppRouteRoute =
  DashboardResourcesSitesSiteIdVersionHistoryOnScreenAppRouteImport.update({
    id: '/on-screen-app',
    path: '/on-screen-app',
    getParentRoute: () => DashboardResourcesSitesSiteIdVersionHistoryRouteRoute,
  } as any)

const DashboardResourcesSitesSiteIdVersionHistoryDetectorRouteRoute =
  DashboardResourcesSitesSiteIdVersionHistoryDetectorRouteImport.update({
    id: '/detector',
    path: '/detector',
    getParentRoute: () => DashboardResourcesSitesSiteIdVersionHistoryRouteRoute,
  } as any)

const DashboardResourcesSitesSiteIdVersionHistoryAgentRouteRoute =
  DashboardResourcesSitesSiteIdVersionHistoryAgentRouteImport.update({
    id: '/agent',
    path: '/agent',
    getParentRoute: () => DashboardResourcesSitesSiteIdVersionHistoryRouteRoute,
  } as any)

const DashboardResourcesDevicesDeviceIdVersionHistoryZebraAdapterRouteRoute =
  DashboardResourcesDevicesDeviceIdVersionHistoryZebraAdapterRouteImport.update(
    {
      id: '/zebra-adapter',
      path: '/zebra-adapter',
      getParentRoute: () =>
        DashboardResourcesDevicesDeviceIdVersionHistoryRouteRoute,
    } as any,
  )

const DashboardResourcesDevicesDeviceIdVersionHistoryTrainerRouteRoute =
  DashboardResourcesDevicesDeviceIdVersionHistoryTrainerRouteImport.update({
    id: '/trainer',
    path: '/trainer',
    getParentRoute: () =>
      DashboardResourcesDevicesDeviceIdVersionHistoryRouteRoute,
  } as any)

const DashboardResourcesDevicesDeviceIdVersionHistoryOnScreenAppRouteRoute =
  DashboardResourcesDevicesDeviceIdVersionHistoryOnScreenAppRouteImport.update({
    id: '/on-screen-app',
    path: '/on-screen-app',
    getParentRoute: () =>
      DashboardResourcesDevicesDeviceIdVersionHistoryRouteRoute,
  } as any)

const DashboardResourcesDevicesDeviceIdVersionHistoryModelsRouteRoute =
  DashboardResourcesDevicesDeviceIdVersionHistoryModelsRouteImport.update({
    id: '/models',
    path: '/models',
    getParentRoute: () =>
      DashboardResourcesDevicesDeviceIdVersionHistoryRouteRoute,
  } as any)

const DashboardResourcesDevicesDeviceIdVersionHistoryDetectorRouteRoute =
  DashboardResourcesDevicesDeviceIdVersionHistoryDetectorRouteImport.update({
    id: '/detector',
    path: '/detector',
    getParentRoute: () =>
      DashboardResourcesDevicesDeviceIdVersionHistoryRouteRoute,
  } as any)

const DashboardResourcesDevicesDeviceIdVersionHistoryAgentRouteRoute =
  DashboardResourcesDevicesDeviceIdVersionHistoryAgentRouteImport.update({
    id: '/agent',
    path: '/agent',
    getParentRoute: () =>
      DashboardResourcesDevicesDeviceIdVersionHistoryRouteRoute,
  } as any)

const DashboardResourcesDevicesDeviceIdDiagnosticsObjectDetectionRouteRoute =
  DashboardResourcesDevicesDeviceIdDiagnosticsObjectDetectionRouteImport.update(
    {
      id: '/object-detection',
      path: '/object-detection',
      getParentRoute: () =>
        DashboardResourcesDevicesDeviceIdDiagnosticsRouteRoute,
    } as any,
  )

const DashboardResourcesDevicesDeviceIdDiagnosticsCustomRouteRoute =
  DashboardResourcesDevicesDeviceIdDiagnosticsCustomRouteImport.update({
    id: '/custom',
    path: '/custom',
    getParentRoute: () =>
      DashboardResourcesDevicesDeviceIdDiagnosticsRouteRoute,
  } as any)

const DashboardResourcesDevicesDeviceIdDiagnosticsClassifierRouteRoute =
  DashboardResourcesDevicesDeviceIdDiagnosticsClassifierRouteImport.update({
    id: '/classifier',
    path: '/classifier',
    getParentRoute: () =>
      DashboardResourcesDevicesDeviceIdDiagnosticsRouteRoute,
  } as any)

const DashboardResourcesDevicesDeviceIdDataTextJsonRouteRoute =
  DashboardResourcesDevicesDeviceIdDataTextJsonRouteImport.update({
    id: '/text-json',
    path: '/text-json',
    getParentRoute: () => DashboardResourcesDevicesDeviceIdDataRouteRoute,
  } as any)

const DashboardResourcesDevicesDeviceIdDataSessionsRouteRoute =
  DashboardResourcesDevicesDeviceIdDataSessionsRouteImport.update({
    id: '/sessions',
    path: '/sessions',
    getParentRoute: () => DashboardResourcesDevicesDeviceIdDataRouteRoute,
  } as any)

const DashboardResourcesDevicesDeviceIdDataSamplesRouteRoute =
  DashboardResourcesDevicesDeviceIdDataSamplesRouteImport.update({
    id: '/samples',
    path: '/samples',
    getParentRoute: () => DashboardResourcesDevicesDeviceIdDataRouteRoute,
  } as any)

const DashboardJobsWorkerJobsScheduleScheduledJobIdScheduleRouteRoute =
  DashboardJobsWorkerJobsScheduleScheduledJobIdScheduleRouteImport.update({
    id: '/schedule',
    path: '/schedule',
    getParentRoute: () =>
      DashboardJobsWorkerJobsScheduleScheduledJobIdRouteRoute,
  } as any)

const DashboardJobsWorkerJobsScheduleScheduledJobIdOverviewRouteRoute =
  DashboardJobsWorkerJobsScheduleScheduledJobIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () =>
      DashboardJobsWorkerJobsScheduleScheduledJobIdRouteRoute,
  } as any)

const DashboardJobsWorkerJobsScheduleScheduledJobIdInputsRouteRoute =
  DashboardJobsWorkerJobsScheduleScheduledJobIdInputsRouteImport.update({
    id: '/inputs',
    path: '/inputs',
    getParentRoute: () =>
      DashboardJobsWorkerJobsScheduleScheduledJobIdRouteRoute,
  } as any)

const DashboardJobsWorkerJobsJobsJobIdOverviewRouteRoute =
  DashboardJobsWorkerJobsJobsJobIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => DashboardJobsWorkerJobsJobsJobIdRouteRoute,
  } as any)

const DashboardJobsWorkerJobsJobsJobIdDevicesRouteRoute =
  DashboardJobsWorkerJobsJobsJobIdDevicesRouteImport.update({
    id: '/devices',
    path: '/devices',
    getParentRoute: () => DashboardJobsWorkerJobsJobsJobIdRouteRoute,
  } as any)

const DashboardJobsVideoUploadScheduleScheduledJobIdScheduleRouteRoute =
  DashboardJobsVideoUploadScheduleScheduledJobIdScheduleRouteImport.update({
    id: '/schedule',
    path: '/schedule',
    getParentRoute: () =>
      DashboardJobsVideoUploadScheduleScheduledJobIdRouteRoute,
  } as any)

const DashboardJobsVideoUploadScheduleScheduledJobIdOverviewRouteRoute =
  DashboardJobsVideoUploadScheduleScheduledJobIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () =>
      DashboardJobsVideoUploadScheduleScheduledJobIdRouteRoute,
  } as any)

const DashboardJobsVideoUploadScheduleScheduledJobIdInputsRouteRoute =
  DashboardJobsVideoUploadScheduleScheduledJobIdInputsRouteImport.update({
    id: '/inputs',
    path: '/inputs',
    getParentRoute: () =>
      DashboardJobsVideoUploadScheduleScheduledJobIdRouteRoute,
  } as any)

const DashboardJobsVideoUploadJobsJobIdOverviewRouteRoute =
  DashboardJobsVideoUploadJobsJobIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => DashboardJobsVideoUploadJobsJobIdRouteRoute,
  } as any)

const DashboardJobsVideoUploadJobsJobIdDevicesRouteRoute =
  DashboardJobsVideoUploadJobsJobIdDevicesRouteImport.update({
    id: '/devices',
    path: '/devices',
    getParentRoute: () => DashboardJobsVideoUploadJobsJobIdRouteRoute,
  } as any)

const DashboardJobsTrainingScheduleScheduledJobIdScheduleRouteRoute =
  DashboardJobsTrainingScheduleScheduledJobIdScheduleRouteImport.update({
    id: '/schedule',
    path: '/schedule',
    getParentRoute: () => DashboardJobsTrainingScheduleScheduledJobIdRouteRoute,
  } as any)

const DashboardJobsTrainingScheduleScheduledJobIdOverviewRouteRoute =
  DashboardJobsTrainingScheduleScheduledJobIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => DashboardJobsTrainingScheduleScheduledJobIdRouteRoute,
  } as any)

const DashboardJobsTrainingScheduleScheduledJobIdInputsRouteRoute =
  DashboardJobsTrainingScheduleScheduledJobIdInputsRouteImport.update({
    id: '/inputs',
    path: '/inputs',
    getParentRoute: () => DashboardJobsTrainingScheduleScheduledJobIdRouteRoute,
  } as any)

const DashboardJobsTrainingJobsJobIdOverviewRouteRoute =
  DashboardJobsTrainingJobsJobIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => DashboardJobsTrainingJobsJobIdRouteRoute,
  } as any)

const DashboardJobsTrainingJobsJobIdMetricsRouteRoute =
  DashboardJobsTrainingJobsJobIdMetricsRouteImport.update({
    id: '/metrics',
    path: '/metrics',
    getParentRoute: () => DashboardJobsTrainingJobsJobIdRouteRoute,
  } as any)

const DashboardJobsTrainingJobsJobIdLabelsRouteRoute =
  DashboardJobsTrainingJobsJobIdLabelsRouteImport.update({
    id: '/labels',
    path: '/labels',
    getParentRoute: () => DashboardJobsTrainingJobsJobIdRouteRoute,
  } as any)

const DashboardJobsTrainingJobsJobIdDevicesRouteRoute =
  DashboardJobsTrainingJobsJobIdDevicesRouteImport.update({
    id: '/devices',
    path: '/devices',
    getParentRoute: () => DashboardJobsTrainingJobsJobIdRouteRoute,
  } as any)

const DashboardJobsSyncSamplesScheduleScheduledJobIdScheduleRouteRoute =
  DashboardJobsSyncSamplesScheduleScheduledJobIdScheduleRouteImport.update({
    id: '/schedule',
    path: '/schedule',
    getParentRoute: () =>
      DashboardJobsSyncSamplesScheduleScheduledJobIdRouteRoute,
  } as any)

const DashboardJobsSyncSamplesScheduleScheduledJobIdOverviewRouteRoute =
  DashboardJobsSyncSamplesScheduleScheduledJobIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () =>
      DashboardJobsSyncSamplesScheduleScheduledJobIdRouteRoute,
  } as any)

const DashboardJobsSyncSamplesScheduleScheduledJobIdInputsRouteRoute =
  DashboardJobsSyncSamplesScheduleScheduledJobIdInputsRouteImport.update({
    id: '/inputs',
    path: '/inputs',
    getParentRoute: () =>
      DashboardJobsSyncSamplesScheduleScheduledJobIdRouteRoute,
  } as any)

const DashboardJobsSyncSamplesJobsJobIdOverviewRouteRoute =
  DashboardJobsSyncSamplesJobsJobIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => DashboardJobsSyncSamplesJobsJobIdRouteRoute,
  } as any)

const DashboardJobsSyncSamplesJobsJobIdDevicesRouteRoute =
  DashboardJobsSyncSamplesJobsJobIdDevicesRouteImport.update({
    id: '/devices',
    path: '/devices',
    getParentRoute: () => DashboardJobsSyncSamplesJobsJobIdRouteRoute,
  } as any)

const DashboardJobsSampleUploadScheduleScheduledJobIdScheduleRouteRoute =
  DashboardJobsSampleUploadScheduleScheduledJobIdScheduleRouteImport.update({
    id: '/schedule',
    path: '/schedule',
    getParentRoute: () =>
      DashboardJobsSampleUploadScheduleScheduledJobIdRouteRoute,
  } as any)

const DashboardJobsSampleUploadScheduleScheduledJobIdOverviewRouteRoute =
  DashboardJobsSampleUploadScheduleScheduledJobIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () =>
      DashboardJobsSampleUploadScheduleScheduledJobIdRouteRoute,
  } as any)

const DashboardJobsSampleUploadScheduleScheduledJobIdInputsRouteRoute =
  DashboardJobsSampleUploadScheduleScheduledJobIdInputsRouteImport.update({
    id: '/inputs',
    path: '/inputs',
    getParentRoute: () =>
      DashboardJobsSampleUploadScheduleScheduledJobIdRouteRoute,
  } as any)

const DashboardJobsSampleUploadJobsJobIdOverviewRouteRoute =
  DashboardJobsSampleUploadJobsJobIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => DashboardJobsSampleUploadJobsJobIdRouteRoute,
  } as any)

const DashboardJobsSampleUploadJobsJobIdDevicesRouteRoute =
  DashboardJobsSampleUploadJobsJobIdDevicesRouteImport.update({
    id: '/devices',
    path: '/devices',
    getParentRoute: () => DashboardJobsSampleUploadJobsJobIdRouteRoute,
  } as any)

const DashboardJobsRestartsScheduleScheduledJobIdScheduleRouteRoute =
  DashboardJobsRestartsScheduleScheduledJobIdScheduleRouteImport.update({
    id: '/schedule',
    path: '/schedule',
    getParentRoute: () => DashboardJobsRestartsScheduleScheduledJobIdRouteRoute,
  } as any)

const DashboardJobsRestartsScheduleScheduledJobIdOverviewRouteRoute =
  DashboardJobsRestartsScheduleScheduledJobIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => DashboardJobsRestartsScheduleScheduledJobIdRouteRoute,
  } as any)

const DashboardJobsRestartsJobsJobIdOverviewRouteRoute =
  DashboardJobsRestartsJobsJobIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => DashboardJobsRestartsJobsJobIdRouteRoute,
  } as any)

const DashboardJobsRestartsJobsJobIdDevicesRouteRoute =
  DashboardJobsRestartsJobsJobIdDevicesRouteImport.update({
    id: '/devices',
    path: '/devices',
    getParentRoute: () => DashboardJobsRestartsJobsJobIdRouteRoute,
  } as any)

const DashboardJobsRecoveryEstimatesScheduleScheduledJobIdScheduleRouteRoute =
  DashboardJobsRecoveryEstimatesScheduleScheduledJobIdScheduleRouteImport.update(
    {
      id: '/schedule',
      path: '/schedule',
      getParentRoute: () =>
        DashboardJobsRecoveryEstimatesScheduleScheduledJobIdRouteRoute,
    } as any,
  )

const DashboardJobsRecoveryEstimatesScheduleScheduledJobIdOverviewRouteRoute =
  DashboardJobsRecoveryEstimatesScheduleScheduledJobIdOverviewRouteImport.update(
    {
      id: '/overview',
      path: '/overview',
      getParentRoute: () =>
        DashboardJobsRecoveryEstimatesScheduleScheduledJobIdRouteRoute,
    } as any,
  )

const DashboardJobsRecoveryEstimatesScheduleScheduledJobIdInputsRouteRoute =
  DashboardJobsRecoveryEstimatesScheduleScheduledJobIdInputsRouteImport.update({
    id: '/inputs',
    path: '/inputs',
    getParentRoute: () =>
      DashboardJobsRecoveryEstimatesScheduleScheduledJobIdRouteRoute,
  } as any)

const DashboardJobsRecoveryEstimatesJobsJobIdOverviewRouteRoute =
  DashboardJobsRecoveryEstimatesJobsJobIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => DashboardJobsRecoveryEstimatesJobsJobIdRouteRoute,
  } as any)

const DashboardJobsModelsScheduleScheduledJobIdScheduleRouteRoute =
  DashboardJobsModelsScheduleScheduledJobIdScheduleRouteImport.update({
    id: '/schedule',
    path: '/schedule',
    getParentRoute: () => DashboardJobsModelsScheduleScheduledJobIdRouteRoute,
  } as any)

const DashboardJobsModelsScheduleScheduledJobIdOverviewRouteRoute =
  DashboardJobsModelsScheduleScheduledJobIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => DashboardJobsModelsScheduleScheduledJobIdRouteRoute,
  } as any)

const DashboardJobsModelsJobsJobIdOverviewRouteRoute =
  DashboardJobsModelsJobsJobIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => DashboardJobsModelsJobsJobIdRouteRoute,
  } as any)

const DashboardJobsModelsJobsJobIdDevicesRouteRoute =
  DashboardJobsModelsJobsJobIdDevicesRouteImport.update({
    id: '/devices',
    path: '/devices',
    getParentRoute: () => DashboardJobsModelsJobsJobIdRouteRoute,
  } as any)

const DashboardJobsHeadBlurVideosScheduleScheduledJobIdScheduleRouteRoute =
  DashboardJobsHeadBlurVideosScheduleScheduledJobIdScheduleRouteImport.update({
    id: '/schedule',
    path: '/schedule',
    getParentRoute: () =>
      DashboardJobsHeadBlurVideosScheduleScheduledJobIdRouteRoute,
  } as any)

const DashboardJobsHeadBlurVideosScheduleScheduledJobIdOverviewRouteRoute =
  DashboardJobsHeadBlurVideosScheduleScheduledJobIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () =>
      DashboardJobsHeadBlurVideosScheduleScheduledJobIdRouteRoute,
  } as any)

const DashboardJobsHeadBlurVideosScheduleScheduledJobIdInputsRouteRoute =
  DashboardJobsHeadBlurVideosScheduleScheduledJobIdInputsRouteImport.update({
    id: '/inputs',
    path: '/inputs',
    getParentRoute: () =>
      DashboardJobsHeadBlurVideosScheduleScheduledJobIdRouteRoute,
  } as any)

const DashboardJobsHeadBlurVideosJobsJobIdOverviewRouteRoute =
  DashboardJobsHeadBlurVideosJobsJobIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => DashboardJobsHeadBlurVideosJobsJobIdRouteRoute,
  } as any)

const DashboardJobsHeadBlurVideosJobsJobIdDevicesRouteRoute =
  DashboardJobsHeadBlurVideosJobsJobIdDevicesRouteImport.update({
    id: '/devices',
    path: '/devices',
    getParentRoute: () => DashboardJobsHeadBlurVideosJobsJobIdRouteRoute,
  } as any)

const DashboardJobsHeadBlurImagesScheduleScheduledJobIdScheduleRouteRoute =
  DashboardJobsHeadBlurImagesScheduleScheduledJobIdScheduleRouteImport.update({
    id: '/schedule',
    path: '/schedule',
    getParentRoute: () =>
      DashboardJobsHeadBlurImagesScheduleScheduledJobIdRouteRoute,
  } as any)

const DashboardJobsHeadBlurImagesScheduleScheduledJobIdOverviewRouteRoute =
  DashboardJobsHeadBlurImagesScheduleScheduledJobIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () =>
      DashboardJobsHeadBlurImagesScheduleScheduledJobIdRouteRoute,
  } as any)

const DashboardJobsHeadBlurImagesScheduleScheduledJobIdInputsRouteRoute =
  DashboardJobsHeadBlurImagesScheduleScheduledJobIdInputsRouteImport.update({
    id: '/inputs',
    path: '/inputs',
    getParentRoute: () =>
      DashboardJobsHeadBlurImagesScheduleScheduledJobIdRouteRoute,
  } as any)

const DashboardJobsHeadBlurImagesJobsJobIdOverviewRouteRoute =
  DashboardJobsHeadBlurImagesJobsJobIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => DashboardJobsHeadBlurImagesJobsJobIdRouteRoute,
  } as any)

const DashboardJobsHeadBlurImagesJobsJobIdDevicesRouteRoute =
  DashboardJobsHeadBlurImagesJobsJobIdDevicesRouteImport.update({
    id: '/devices',
    path: '/devices',
    getParentRoute: () => DashboardJobsHeadBlurImagesJobsJobIdRouteRoute,
  } as any)

const DashboardJobsDeploymentsScheduleScheduledJobIdScheduleRouteRoute =
  DashboardJobsDeploymentsScheduleScheduledJobIdScheduleRouteImport.update({
    id: '/schedule',
    path: '/schedule',
    getParentRoute: () =>
      DashboardJobsDeploymentsScheduleScheduledJobIdRouteRoute,
  } as any)

const DashboardJobsDeploymentsScheduleScheduledJobIdOverviewRouteRoute =
  DashboardJobsDeploymentsScheduleScheduledJobIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () =>
      DashboardJobsDeploymentsScheduleScheduledJobIdRouteRoute,
  } as any)

const DashboardJobsDeploymentsJobsJobIdOverviewRouteRoute =
  DashboardJobsDeploymentsJobsJobIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => DashboardJobsDeploymentsJobsJobIdRouteRoute,
  } as any)

const DashboardJobsDeploymentsJobsJobIdDevicesRouteRoute =
  DashboardJobsDeploymentsJobsJobIdDevicesRouteImport.update({
    id: '/devices',
    path: '/devices',
    getParentRoute: () => DashboardJobsDeploymentsJobsJobIdRouteRoute,
  } as any)

const DashboardJobsDeleteVideosScheduleScheduledJobIdScheduleRouteRoute =
  DashboardJobsDeleteVideosScheduleScheduledJobIdScheduleRouteImport.update({
    id: '/schedule',
    path: '/schedule',
    getParentRoute: () =>
      DashboardJobsDeleteVideosScheduleScheduledJobIdRouteRoute,
  } as any)

const DashboardJobsDeleteVideosScheduleScheduledJobIdOverviewRouteRoute =
  DashboardJobsDeleteVideosScheduleScheduledJobIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () =>
      DashboardJobsDeleteVideosScheduleScheduledJobIdRouteRoute,
  } as any)

const DashboardJobsDeleteVideosScheduleScheduledJobIdInputsRouteRoute =
  DashboardJobsDeleteVideosScheduleScheduledJobIdInputsRouteImport.update({
    id: '/inputs',
    path: '/inputs',
    getParentRoute: () =>
      DashboardJobsDeleteVideosScheduleScheduledJobIdRouteRoute,
  } as any)

const DashboardJobsDeleteVideosJobsJobIdOverviewRouteRoute =
  DashboardJobsDeleteVideosJobsJobIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => DashboardJobsDeleteVideosJobsJobIdRouteRoute,
  } as any)

const DashboardJobsDeleteVideosJobsJobIdDevicesRouteRoute =
  DashboardJobsDeleteVideosJobsJobIdDevicesRouteImport.update({
    id: '/devices',
    path: '/devices',
    getParentRoute: () => DashboardJobsDeleteVideosJobsJobIdRouteRoute,
  } as any)

const DashboardJobsDeleteSamplesScheduleScheduledJobIdScheduleRouteRoute =
  DashboardJobsDeleteSamplesScheduleScheduledJobIdScheduleRouteImport.update({
    id: '/schedule',
    path: '/schedule',
    getParentRoute: () =>
      DashboardJobsDeleteSamplesScheduleScheduledJobIdRouteRoute,
  } as any)

const DashboardJobsDeleteSamplesScheduleScheduledJobIdOverviewRouteRoute =
  DashboardJobsDeleteSamplesScheduleScheduledJobIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () =>
      DashboardJobsDeleteSamplesScheduleScheduledJobIdRouteRoute,
  } as any)

const DashboardJobsDeleteSamplesScheduleScheduledJobIdInputsRouteRoute =
  DashboardJobsDeleteSamplesScheduleScheduledJobIdInputsRouteImport.update({
    id: '/inputs',
    path: '/inputs',
    getParentRoute: () =>
      DashboardJobsDeleteSamplesScheduleScheduledJobIdRouteRoute,
  } as any)

const DashboardJobsDeleteSamplesJobsJobIdOverviewRouteRoute =
  DashboardJobsDeleteSamplesJobsJobIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => DashboardJobsDeleteSamplesJobsJobIdRouteRoute,
  } as any)

const DashboardJobsDeleteSamplesJobsJobIdDevicesRouteRoute =
  DashboardJobsDeleteSamplesJobsJobIdDevicesRouteImport.update({
    id: '/devices',
    path: '/devices',
    getParentRoute: () => DashboardJobsDeleteSamplesJobsJobIdRouteRoute,
  } as any)

const DashboardJobsConfigScheduleScheduledJobIdScheduleRouteRoute =
  DashboardJobsConfigScheduleScheduledJobIdScheduleRouteImport.update({
    id: '/schedule',
    path: '/schedule',
    getParentRoute: () => DashboardJobsConfigScheduleScheduledJobIdRouteRoute,
  } as any)

const DashboardJobsConfigScheduleScheduledJobIdOverviewRouteRoute =
  DashboardJobsConfigScheduleScheduledJobIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => DashboardJobsConfigScheduleScheduledJobIdRouteRoute,
  } as any)

const DashboardJobsConfigJobsJobIdOverviewRouteRoute =
  DashboardJobsConfigJobsJobIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => DashboardJobsConfigJobsJobIdRouteRoute,
  } as any)

const DashboardJobsConfigJobsJobIdDevicesRouteRoute =
  DashboardJobsConfigJobsJobIdDevicesRouteImport.update({
    id: '/devices',
    path: '/devices',
    getParentRoute: () => DashboardJobsConfigJobsJobIdRouteRoute,
  } as any)

const DashboardJobsCatalogUploadScheduleScheduledJobIdScheduleRouteRoute =
  DashboardJobsCatalogUploadScheduleScheduledJobIdScheduleRouteImport.update({
    id: '/schedule',
    path: '/schedule',
    getParentRoute: () =>
      DashboardJobsCatalogUploadScheduleScheduledJobIdRouteRoute,
  } as any)

const DashboardJobsCatalogUploadScheduleScheduledJobIdOverviewRouteRoute =
  DashboardJobsCatalogUploadScheduleScheduledJobIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () =>
      DashboardJobsCatalogUploadScheduleScheduledJobIdRouteRoute,
  } as any)

const DashboardJobsCatalogUploadScheduleScheduledJobIdLabelsRouteRoute =
  DashboardJobsCatalogUploadScheduleScheduledJobIdLabelsRouteImport.update({
    id: '/labels',
    path: '/labels',
    getParentRoute: () =>
      DashboardJobsCatalogUploadScheduleScheduledJobIdRouteRoute,
  } as any)

const DashboardJobsCatalogUploadJobsJobIdOverviewRouteRoute =
  DashboardJobsCatalogUploadJobsJobIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => DashboardJobsCatalogUploadJobsJobIdRouteRoute,
  } as any)

const DashboardJobsCatalogUploadJobsJobIdLabelsRouteRoute =
  DashboardJobsCatalogUploadJobsJobIdLabelsRouteImport.update({
    id: '/labels',
    path: '/labels',
    getParentRoute: () => DashboardJobsCatalogUploadJobsJobIdRouteRoute,
  } as any)

const DashboardJobsCatalogUploadJobsJobIdDevicesRouteRoute =
  DashboardJobsCatalogUploadJobsJobIdDevicesRouteImport.update({
    id: '/devices',
    path: '/devices',
    getParentRoute: () => DashboardJobsCatalogUploadJobsJobIdRouteRoute,
  } as any)

const DashboardJobsCapacityTaggingScheduleScheduledJobIdScheduleRouteRoute =
  DashboardJobsCapacityTaggingScheduleScheduledJobIdScheduleRouteImport.update({
    id: '/schedule',
    path: '/schedule',
    getParentRoute: () =>
      DashboardJobsCapacityTaggingScheduleScheduledJobIdRouteRoute,
  } as any)

const DashboardJobsCapacityTaggingScheduleScheduledJobIdOverviewRouteRoute =
  DashboardJobsCapacityTaggingScheduleScheduledJobIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () =>
      DashboardJobsCapacityTaggingScheduleScheduledJobIdRouteRoute,
  } as any)

const DashboardJobsCapacityTaggingScheduleScheduledJobIdInputsRouteRoute =
  DashboardJobsCapacityTaggingScheduleScheduledJobIdInputsRouteImport.update({
    id: '/inputs',
    path: '/inputs',
    getParentRoute: () =>
      DashboardJobsCapacityTaggingScheduleScheduledJobIdRouteRoute,
  } as any)

const DashboardJobsCapacityTaggingJobsJobIdOverviewRouteRoute =
  DashboardJobsCapacityTaggingJobsJobIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => DashboardJobsCapacityTaggingJobsJobIdRouteRoute,
  } as any)

const DashboardJobsCameraCalibrationScheduleScheduledJobIdScheduleRouteRoute =
  DashboardJobsCameraCalibrationScheduleScheduledJobIdScheduleRouteImport.update(
    {
      id: '/schedule',
      path: '/schedule',
      getParentRoute: () =>
        DashboardJobsCameraCalibrationScheduleScheduledJobIdRouteRoute,
    } as any,
  )

const DashboardJobsCameraCalibrationScheduleScheduledJobIdOverviewRouteRoute =
  DashboardJobsCameraCalibrationScheduleScheduledJobIdOverviewRouteImport.update(
    {
      id: '/overview',
      path: '/overview',
      getParentRoute: () =>
        DashboardJobsCameraCalibrationScheduleScheduledJobIdRouteRoute,
    } as any,
  )

const DashboardJobsCameraCalibrationScheduleScheduledJobIdInputsRouteRoute =
  DashboardJobsCameraCalibrationScheduleScheduledJobIdInputsRouteImport.update({
    id: '/inputs',
    path: '/inputs',
    getParentRoute: () =>
      DashboardJobsCameraCalibrationScheduleScheduledJobIdRouteRoute,
  } as any)

const DashboardJobsCameraCalibrationJobsJobIdOverviewRouteRoute =
  DashboardJobsCameraCalibrationJobsJobIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => DashboardJobsCameraCalibrationJobsJobIdRouteRoute,
  } as any)

const DashboardJobsCameraCalibrationJobsJobIdDevicesRouteRoute =
  DashboardJobsCameraCalibrationJobsJobIdDevicesRouteImport.update({
    id: '/devices',
    path: '/devices',
    getParentRoute: () => DashboardJobsCameraCalibrationJobsJobIdRouteRoute,
  } as any)

const AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdScheduleRouteRoute =
  AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdScheduleRouteImport.update(
    {
      id: '/schedule',
      path: '/schedule',
      getParentRoute: () =>
        AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdRouteRoute,
    } as any,
  )

const AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdOverviewRouteRoute =
  AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdOverviewRouteImport.update(
    {
      id: '/overview',
      path: '/overview',
      getParentRoute: () =>
        AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdRouteRoute,
    } as any,
  )

const AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdInputsRouteRoute =
  AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdInputsRouteImport.update(
    {
      id: '/inputs',
      path: '/inputs',
      getParentRoute: () =>
        AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdRouteRoute,
    } as any,
  )

const AdminDashboardJobsServiceHealthChecksJobsJobIdOverviewRouteRoute =
  AdminDashboardJobsServiceHealthChecksJobsJobIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () =>
      AdminDashboardJobsServiceHealthChecksJobsJobIdRouteRoute,
  } as any)

const DashboardResourcesDevicesDeviceIdDataSessionsSessionIdRouteRoute =
  DashboardResourcesDevicesDeviceIdDataSessionsSessionIdRouteImport.update({
    id: '/$sessionId',
    path: '/$sessionId',
    getParentRoute: () =>
      DashboardResourcesDevicesDeviceIdDataSessionsRouteRoute,
  } as any)

const DashboardResourcesDevicesDeviceIdDataSamplesSampleIdRouteRoute =
  DashboardResourcesDevicesDeviceIdDataSamplesSampleIdRouteImport.update({
    id: '/$sampleId',
    path: '/$sampleId',
    getParentRoute: () =>
      DashboardResourcesDevicesDeviceIdDataSamplesRouteRoute,
  } as any)

const DashboardResourcesDevicesDeviceIdDataSessionsSessionIdIndexRoute =
  DashboardResourcesDevicesDeviceIdDataSessionsSessionIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      DashboardResourcesDevicesDeviceIdDataSessionsSessionIdRouteRoute,
  } as any)

const DashboardResourcesDevicesDeviceIdDataSamplesSampleIdIndexRoute =
  DashboardResourcesDevicesDeviceIdDataSamplesSampleIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      DashboardResourcesDevicesDeviceIdDataSamplesSampleIdRouteRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/admin-dashboard': {
      id: '/admin-dashboard'
      path: '/admin-dashboard'
      fullPath: '/admin-dashboard'
      preLoaderRoute: typeof AdminDashboardRouteImport
      parentRoute: typeof rootRoute
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRoute
    }
    '/unresponsive': {
      id: '/unresponsive'
      path: '/unresponsive'
      fullPath: '/unresponsive'
      preLoaderRoute: typeof UnresponsiveRouteImport
      parentRoute: typeof rootRoute
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteLazyImport
      parentRoute: typeof rootRoute
    }
    '/admin-dashboard/accounts-management': {
      id: '/admin-dashboard/accounts-management'
      path: '/accounts-management'
      fullPath: '/admin-dashboard/accounts-management'
      preLoaderRoute: typeof AdminDashboardAccountsManagementRouteImport
      parentRoute: typeof AdminDashboardRouteImport
    }
    '/admin-dashboard/domain-auth-settings': {
      id: '/admin-dashboard/domain-auth-settings'
      path: '/domain-auth-settings'
      fullPath: '/admin-dashboard/domain-auth-settings'
      preLoaderRoute: typeof AdminDashboardDomainAuthSettingsRouteImport
      parentRoute: typeof AdminDashboardRouteImport
    }
    '/admin-dashboard/jobs': {
      id: '/admin-dashboard/jobs'
      path: '/jobs'
      fullPath: '/admin-dashboard/jobs'
      preLoaderRoute: typeof AdminDashboardJobsRouteImport
      parentRoute: typeof AdminDashboardRouteImport
    }
    '/admin-dashboard/notifications': {
      id: '/admin-dashboard/notifications'
      path: '/notifications'
      fullPath: '/admin-dashboard/notifications'
      preLoaderRoute: typeof AdminDashboardNotificationsRouteImport
      parentRoute: typeof AdminDashboardRouteImport
    }
    '/dashboard/alerts': {
      id: '/dashboard/alerts'
      path: '/alerts'
      fullPath: '/dashboard/alerts'
      preLoaderRoute: typeof DashboardAlertsRouteImport
      parentRoute: typeof DashboardRouteImport
    }
    '/dashboard/data': {
      id: '/dashboard/data'
      path: '/data'
      fullPath: '/dashboard/data'
      preLoaderRoute: typeof DashboardDataRouteImport
      parentRoute: typeof DashboardRouteImport
    }
    '/dashboard/jobs': {
      id: '/dashboard/jobs'
      path: '/jobs'
      fullPath: '/dashboard/jobs'
      preLoaderRoute: typeof DashboardJobsRouteImport
      parentRoute: typeof DashboardRouteImport
    }
    '/dashboard/models': {
      id: '/dashboard/models'
      path: '/models'
      fullPath: '/dashboard/models'
      preLoaderRoute: typeof DashboardModelsRouteImport
      parentRoute: typeof DashboardRouteImport
    }
    '/dashboard/reports': {
      id: '/dashboard/reports'
      path: '/reports'
      fullPath: '/dashboard/reports'
      preLoaderRoute: typeof DashboardReportsRouteImport
      parentRoute: typeof DashboardRouteImport
    }
    '/dashboard/resources': {
      id: '/dashboard/resources'
      path: '/resources'
      fullPath: '/dashboard/resources'
      preLoaderRoute: typeof DashboardResourcesRouteImport
      parentRoute: typeof DashboardRouteImport
    }
    '/dashboard/settings': {
      id: '/dashboard/settings'
      path: '/settings'
      fullPath: '/dashboard/settings'
      preLoaderRoute: typeof DashboardSettingsRouteImport
      parentRoute: typeof DashboardRouteImport
    }
    '/dashboard/unauthorized': {
      id: '/dashboard/unauthorized'
      path: '/unauthorized'
      fullPath: '/dashboard/unauthorized'
      preLoaderRoute: typeof DashboardUnauthorizedRouteImport
      parentRoute: typeof DashboardRouteImport
    }
    '/dashboard/home': {
      id: '/dashboard/home'
      path: '/home'
      fullPath: '/dashboard/home'
      preLoaderRoute: typeof DashboardHomeImport
      parentRoute: typeof DashboardRouteImport
    }
    '/dashboard/support': {
      id: '/dashboard/support'
      path: '/support'
      fullPath: '/dashboard/support'
      preLoaderRoute: typeof DashboardSupportImport
      parentRoute: typeof DashboardRouteImport
    }
    '/next/$': {
      id: '/next/$'
      path: '/next/$'
      fullPath: '/next/$'
      preLoaderRoute: typeof NextSplatImport
      parentRoute: typeof rootRoute
    }
    '/admin-dashboard/': {
      id: '/admin-dashboard/'
      path: '/'
      fullPath: '/admin-dashboard/'
      preLoaderRoute: typeof AdminDashboardIndexImport
      parentRoute: typeof AdminDashboardRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexImport
      parentRoute: typeof DashboardRouteImport
    }
    '/admin-dashboard/accounts-management/$accountId': {
      id: '/admin-dashboard/accounts-management/$accountId'
      path: '/$accountId'
      fullPath: '/admin-dashboard/accounts-management/$accountId'
      preLoaderRoute: typeof AdminDashboardAccountsManagementAccountIdRouteImport
      parentRoute: typeof AdminDashboardAccountsManagementRouteImport
    }
    '/admin-dashboard/jobs/service-health-checks': {
      id: '/admin-dashboard/jobs/service-health-checks'
      path: '/service-health-checks'
      fullPath: '/admin-dashboard/jobs/service-health-checks'
      preLoaderRoute: typeof AdminDashboardJobsServiceHealthChecksRouteImport
      parentRoute: typeof AdminDashboardJobsRouteImport
    }
    '/admin-dashboard/notifications/$notificationId': {
      id: '/admin-dashboard/notifications/$notificationId'
      path: '/$notificationId'
      fullPath: '/admin-dashboard/notifications/$notificationId'
      preLoaderRoute: typeof AdminDashboardNotificationsNotificationIdRouteImport
      parentRoute: typeof AdminDashboardNotificationsRouteImport
    }
    '/dashboard/data/annotations': {
      id: '/dashboard/data/annotations'
      path: '/annotations'
      fullPath: '/dashboard/data/annotations'
      preLoaderRoute: typeof DashboardDataAnnotationsRouteImport
      parentRoute: typeof DashboardDataRouteImport
    }
    '/dashboard/data/catalog': {
      id: '/dashboard/data/catalog'
      path: '/catalog'
      fullPath: '/dashboard/data/catalog'
      preLoaderRoute: typeof DashboardDataCatalogRouteImport
      parentRoute: typeof DashboardDataRouteImport
    }
    '/dashboard/data/datasets': {
      id: '/dashboard/data/datasets'
      path: '/datasets'
      fullPath: '/dashboard/data/datasets'
      preLoaderRoute: typeof DashboardDataDatasetsRouteImport
      parentRoute: typeof DashboardDataRouteImport
    }
    '/dashboard/data/images': {
      id: '/dashboard/data/images'
      path: '/images'
      fullPath: '/dashboard/data/images'
      preLoaderRoute: typeof DashboardDataImagesRouteImport
      parentRoute: typeof DashboardDataRouteImport
    }
    '/dashboard/data/json-data': {
      id: '/dashboard/data/json-data'
      path: '/json-data'
      fullPath: '/dashboard/data/json-data'
      preLoaderRoute: typeof DashboardDataJsonDataRouteImport
      parentRoute: typeof DashboardDataRouteImport
    }
    '/dashboard/data/label-distribution': {
      id: '/dashboard/data/label-distribution'
      path: '/label-distribution'
      fullPath: '/dashboard/data/label-distribution'
      preLoaderRoute: typeof DashboardDataLabelDistributionRouteImport
      parentRoute: typeof DashboardDataRouteImport
    }
    '/dashboard/data/pending': {
      id: '/dashboard/data/pending'
      path: '/pending'
      fullPath: '/dashboard/data/pending'
      preLoaderRoute: typeof DashboardDataPendingRouteImport
      parentRoute: typeof DashboardDataRouteImport
    }
    '/dashboard/data/sessions': {
      id: '/dashboard/data/sessions'
      path: '/sessions'
      fullPath: '/dashboard/data/sessions'
      preLoaderRoute: typeof DashboardDataSessionsRouteImport
      parentRoute: typeof DashboardDataRouteImport
    }
    '/dashboard/home/manager-report': {
      id: '/dashboard/home/manager-report'
      path: '/manager-report'
      fullPath: '/dashboard/home/manager-report'
      preLoaderRoute: typeof DashboardHomeManagerReportRouteImport
      parentRoute: typeof DashboardHomeImport
    }
    '/dashboard/jobs/camera-calibration': {
      id: '/dashboard/jobs/camera-calibration'
      path: '/camera-calibration'
      fullPath: '/dashboard/jobs/camera-calibration'
      preLoaderRoute: typeof DashboardJobsCameraCalibrationRouteImport
      parentRoute: typeof DashboardJobsRouteImport
    }
    '/dashboard/jobs/capacity-tagging': {
      id: '/dashboard/jobs/capacity-tagging'
      path: '/capacity-tagging'
      fullPath: '/dashboard/jobs/capacity-tagging'
      preLoaderRoute: typeof DashboardJobsCapacityTaggingRouteImport
      parentRoute: typeof DashboardJobsRouteImport
    }
    '/dashboard/jobs/catalog-upload': {
      id: '/dashboard/jobs/catalog-upload'
      path: '/catalog-upload'
      fullPath: '/dashboard/jobs/catalog-upload'
      preLoaderRoute: typeof DashboardJobsCatalogUploadRouteImport
      parentRoute: typeof DashboardJobsRouteImport
    }
    '/dashboard/jobs/config': {
      id: '/dashboard/jobs/config'
      path: '/config'
      fullPath: '/dashboard/jobs/config'
      preLoaderRoute: typeof DashboardJobsConfigRouteImport
      parentRoute: typeof DashboardJobsRouteImport
    }
    '/dashboard/jobs/delete-samples': {
      id: '/dashboard/jobs/delete-samples'
      path: '/delete-samples'
      fullPath: '/dashboard/jobs/delete-samples'
      preLoaderRoute: typeof DashboardJobsDeleteSamplesRouteImport
      parentRoute: typeof DashboardJobsRouteImport
    }
    '/dashboard/jobs/delete-videos': {
      id: '/dashboard/jobs/delete-videos'
      path: '/delete-videos'
      fullPath: '/dashboard/jobs/delete-videos'
      preLoaderRoute: typeof DashboardJobsDeleteVideosRouteImport
      parentRoute: typeof DashboardJobsRouteImport
    }
    '/dashboard/jobs/deployments': {
      id: '/dashboard/jobs/deployments'
      path: '/deployments'
      fullPath: '/dashboard/jobs/deployments'
      preLoaderRoute: typeof DashboardJobsDeploymentsRouteImport
      parentRoute: typeof DashboardJobsRouteImport
    }
    '/dashboard/jobs/head-blur-images': {
      id: '/dashboard/jobs/head-blur-images'
      path: '/head-blur-images'
      fullPath: '/dashboard/jobs/head-blur-images'
      preLoaderRoute: typeof DashboardJobsHeadBlurImagesRouteImport
      parentRoute: typeof DashboardJobsRouteImport
    }
    '/dashboard/jobs/head-blur-videos': {
      id: '/dashboard/jobs/head-blur-videos'
      path: '/head-blur-videos'
      fullPath: '/dashboard/jobs/head-blur-videos'
      preLoaderRoute: typeof DashboardJobsHeadBlurVideosRouteImport
      parentRoute: typeof DashboardJobsRouteImport
    }
    '/dashboard/jobs/models': {
      id: '/dashboard/jobs/models'
      path: '/models'
      fullPath: '/dashboard/jobs/models'
      preLoaderRoute: typeof DashboardJobsModelsRouteImport
      parentRoute: typeof DashboardJobsRouteImport
    }
    '/dashboard/jobs/recovery-estimates': {
      id: '/dashboard/jobs/recovery-estimates'
      path: '/recovery-estimates'
      fullPath: '/dashboard/jobs/recovery-estimates'
      preLoaderRoute: typeof DashboardJobsRecoveryEstimatesRouteImport
      parentRoute: typeof DashboardJobsRouteImport
    }
    '/dashboard/jobs/restarts': {
      id: '/dashboard/jobs/restarts'
      path: '/restarts'
      fullPath: '/dashboard/jobs/restarts'
      preLoaderRoute: typeof DashboardJobsRestartsRouteImport
      parentRoute: typeof DashboardJobsRouteImport
    }
    '/dashboard/jobs/sample-upload': {
      id: '/dashboard/jobs/sample-upload'
      path: '/sample-upload'
      fullPath: '/dashboard/jobs/sample-upload'
      preLoaderRoute: typeof DashboardJobsSampleUploadRouteImport
      parentRoute: typeof DashboardJobsRouteImport
    }
    '/dashboard/jobs/sync-samples': {
      id: '/dashboard/jobs/sync-samples'
      path: '/sync-samples'
      fullPath: '/dashboard/jobs/sync-samples'
      preLoaderRoute: typeof DashboardJobsSyncSamplesRouteImport
      parentRoute: typeof DashboardJobsRouteImport
    }
    '/dashboard/jobs/training': {
      id: '/dashboard/jobs/training'
      path: '/training'
      fullPath: '/dashboard/jobs/training'
      preLoaderRoute: typeof DashboardJobsTrainingRouteImport
      parentRoute: typeof DashboardJobsRouteImport
    }
    '/dashboard/jobs/video-upload': {
      id: '/dashboard/jobs/video-upload'
      path: '/video-upload'
      fullPath: '/dashboard/jobs/video-upload'
      preLoaderRoute: typeof DashboardJobsVideoUploadRouteImport
      parentRoute: typeof DashboardJobsRouteImport
    }
    '/dashboard/jobs/worker-jobs': {
      id: '/dashboard/jobs/worker-jobs'
      path: '/worker-jobs'
      fullPath: '/dashboard/jobs/worker-jobs'
      preLoaderRoute: typeof DashboardJobsWorkerJobsRouteImport
      parentRoute: typeof DashboardJobsRouteImport
    }
    '/dashboard/models/$modelId': {
      id: '/dashboard/models/$modelId'
      path: '/$modelId'
      fullPath: '/dashboard/models/$modelId'
      preLoaderRoute: typeof DashboardModelsModelIdRouteImport
      parentRoute: typeof DashboardModelsRouteImport
    }
    '/dashboard/reports/$reportId': {
      id: '/dashboard/reports/$reportId'
      path: '/$reportId'
      fullPath: '/dashboard/reports/$reportId'
      preLoaderRoute: typeof DashboardReportsReportIdRouteImport
      parentRoute: typeof DashboardReportsRouteImport
    }
    '/dashboard/reports/analytics-hub': {
      id: '/dashboard/reports/analytics-hub'
      path: '/analytics-hub'
      fullPath: '/dashboard/reports/analytics-hub'
      preLoaderRoute: typeof DashboardReportsAnalyticsHubRouteImport
      parentRoute: typeof DashboardReportsRouteImport
    }
    '/dashboard/reports/companion': {
      id: '/dashboard/reports/companion'
      path: '/companion'
      fullPath: '/dashboard/reports/companion'
      preLoaderRoute: typeof DashboardReportsCompanionRouteImport
      parentRoute: typeof DashboardReportsRouteImport
    }
    '/dashboard/resources/clusters': {
      id: '/dashboard/resources/clusters'
      path: '/clusters'
      fullPath: '/dashboard/resources/clusters'
      preLoaderRoute: typeof DashboardResourcesClustersRouteImport
      parentRoute: typeof DashboardResourcesRouteImport
    }
    '/dashboard/resources/devices': {
      id: '/dashboard/resources/devices'
      path: '/devices'
      fullPath: '/dashboard/resources/devices'
      preLoaderRoute: typeof DashboardResourcesDevicesRouteImport
      parentRoute: typeof DashboardResourcesRouteImport
    }
    '/dashboard/resources/site-groups': {
      id: '/dashboard/resources/site-groups'
      path: '/site-groups'
      fullPath: '/dashboard/resources/site-groups'
      preLoaderRoute: typeof DashboardResourcesSiteGroupsRouteImport
      parentRoute: typeof DashboardResourcesRouteImport
    }
    '/dashboard/resources/sites': {
      id: '/dashboard/resources/sites'
      path: '/sites'
      fullPath: '/dashboard/resources/sites'
      preLoaderRoute: typeof DashboardResourcesSitesRouteImport
      parentRoute: typeof DashboardResourcesRouteImport
    }
    '/dashboard/settings/alert-management': {
      id: '/dashboard/settings/alert-management'
      path: '/alert-management'
      fullPath: '/dashboard/settings/alert-management'
      preLoaderRoute: typeof DashboardSettingsAlertManagementRouteImport
      parentRoute: typeof DashboardSettingsRouteImport
    }
    '/dashboard/settings/job-defaults': {
      id: '/dashboard/settings/job-defaults'
      path: '/job-defaults'
      fullPath: '/dashboard/settings/job-defaults'
      preLoaderRoute: typeof DashboardSettingsJobDefaultsRouteImport
      parentRoute: typeof DashboardSettingsRouteImport
    }
    '/dashboard/settings/overview': {
      id: '/dashboard/settings/overview'
      path: '/overview'
      fullPath: '/dashboard/settings/overview'
      preLoaderRoute: typeof DashboardSettingsOverviewRouteImport
      parentRoute: typeof DashboardSettingsRouteImport
    }
    '/dashboard/settings/permissions-settings': {
      id: '/dashboard/settings/permissions-settings'
      path: '/permissions-settings'
      fullPath: '/dashboard/settings/permissions-settings'
      preLoaderRoute: typeof DashboardSettingsPermissionsSettingsRouteImport
      parentRoute: typeof DashboardSettingsRouteImport
    }
    '/dashboard/settings/permissions-settings-dev': {
      id: '/dashboard/settings/permissions-settings-dev'
      path: '/permissions-settings-dev'
      fullPath: '/dashboard/settings/permissions-settings-dev'
      preLoaderRoute: typeof DashboardSettingsPermissionsSettingsDevRouteImport
      parentRoute: typeof DashboardSettingsRouteImport
    }
    '/dashboard/settings/queues': {
      id: '/dashboard/settings/queues'
      path: '/queues'
      fullPath: '/dashboard/settings/queues'
      preLoaderRoute: typeof DashboardSettingsQueuesRouteImport
      parentRoute: typeof DashboardSettingsRouteImport
    }
    '/dashboard/settings/regions': {
      id: '/dashboard/settings/regions'
      path: '/regions'
      fullPath: '/dashboard/settings/regions'
      preLoaderRoute: typeof DashboardSettingsRegionsRouteImport
      parentRoute: typeof DashboardSettingsRouteImport
    }
    '/dashboard/settings/report-settings': {
      id: '/dashboard/settings/report-settings'
      path: '/report-settings'
      fullPath: '/dashboard/settings/report-settings'
      preLoaderRoute: typeof DashboardSettingsReportSettingsRouteImport
      parentRoute: typeof DashboardSettingsRouteImport
    }
    '/dashboard/settings/tags-management': {
      id: '/dashboard/settings/tags-management'
      path: '/tags-management'
      fullPath: '/dashboard/settings/tags-management'
      preLoaderRoute: typeof DashboardSettingsTagsManagementRouteImport
      parentRoute: typeof DashboardSettingsRouteImport
    }
    '/dashboard/settings/user-management': {
      id: '/dashboard/settings/user-management'
      path: '/user-management'
      fullPath: '/dashboard/settings/user-management'
      preLoaderRoute: typeof DashboardSettingsUserManagementRouteImport
      parentRoute: typeof DashboardSettingsRouteImport
    }
    '/dashboard/[/rest]': {
      id: '/dashboard/[/rest]'
      path: '/[/rest]'
      fullPath: '/dashboard/[/rest]'
      preLoaderRoute: typeof DashboardRestImport
      parentRoute: typeof DashboardRouteImport
    }
    '/dashboard/data/': {
      id: '/dashboard/data/'
      path: '/'
      fullPath: '/dashboard/data/'
      preLoaderRoute: typeof DashboardDataIndexImport
      parentRoute: typeof DashboardDataRouteImport
    }
    '/dashboard/home/': {
      id: '/dashboard/home/'
      path: '/'
      fullPath: '/dashboard/home/'
      preLoaderRoute: typeof DashboardHomeIndexImport
      parentRoute: typeof DashboardHomeImport
    }
    '/dashboard/jobs/': {
      id: '/dashboard/jobs/'
      path: '/'
      fullPath: '/dashboard/jobs/'
      preLoaderRoute: typeof DashboardJobsIndexImport
      parentRoute: typeof DashboardJobsRouteImport
    }
    '/dashboard/reports/': {
      id: '/dashboard/reports/'
      path: '/'
      fullPath: '/dashboard/reports/'
      preLoaderRoute: typeof DashboardReportsIndexImport
      parentRoute: typeof DashboardReportsRouteImport
    }
    '/dashboard/resources/': {
      id: '/dashboard/resources/'
      path: '/'
      fullPath: '/dashboard/resources/'
      preLoaderRoute: typeof DashboardResourcesIndexImport
      parentRoute: typeof DashboardResourcesRouteImport
    }
    '/dashboard/settings/': {
      id: '/dashboard/settings/'
      path: '/'
      fullPath: '/dashboard/settings/'
      preLoaderRoute: typeof DashboardSettingsIndexImport
      parentRoute: typeof DashboardSettingsRouteImport
    }
    '/admin-dashboard/accounts-management/$accountId/operational-hours': {
      id: '/admin-dashboard/accounts-management/$accountId/operational-hours'
      path: '/operational-hours'
      fullPath: '/admin-dashboard/accounts-management/$accountId/operational-hours'
      preLoaderRoute: typeof AdminDashboardAccountsManagementAccountIdOperationalHoursRouteImport
      parentRoute: typeof AdminDashboardAccountsManagementAccountIdRouteImport
    }
    '/admin-dashboard/accounts-management/$accountId/overview': {
      id: '/admin-dashboard/accounts-management/$accountId/overview'
      path: '/overview'
      fullPath: '/admin-dashboard/accounts-management/$accountId/overview'
      preLoaderRoute: typeof AdminDashboardAccountsManagementAccountIdOverviewRouteImport
      parentRoute: typeof AdminDashboardAccountsManagementAccountIdRouteImport
    }
    '/admin-dashboard/accounts-management/$accountId/regions': {
      id: '/admin-dashboard/accounts-management/$accountId/regions'
      path: '/regions'
      fullPath: '/admin-dashboard/accounts-management/$accountId/regions'
      preLoaderRoute: typeof AdminDashboardAccountsManagementAccountIdRegionsRouteImport
      parentRoute: typeof AdminDashboardAccountsManagementAccountIdRouteImport
    }
    '/admin-dashboard/jobs/service-health-checks/jobs': {
      id: '/admin-dashboard/jobs/service-health-checks/jobs'
      path: '/jobs'
      fullPath: '/admin-dashboard/jobs/service-health-checks/jobs'
      preLoaderRoute: typeof AdminDashboardJobsServiceHealthChecksJobsRouteImport
      parentRoute: typeof AdminDashboardJobsServiceHealthChecksRouteImport
    }
    '/admin-dashboard/jobs/service-health-checks/schedule': {
      id: '/admin-dashboard/jobs/service-health-checks/schedule'
      path: '/schedule'
      fullPath: '/admin-dashboard/jobs/service-health-checks/schedule'
      preLoaderRoute: typeof AdminDashboardJobsServiceHealthChecksScheduleRouteImport
      parentRoute: typeof AdminDashboardJobsServiceHealthChecksRouteImport
    }
    '/admin-dashboard/notifications/$notificationId/overview': {
      id: '/admin-dashboard/notifications/$notificationId/overview'
      path: '/overview'
      fullPath: '/admin-dashboard/notifications/$notificationId/overview'
      preLoaderRoute: typeof AdminDashboardNotificationsNotificationIdOverviewRouteImport
      parentRoute: typeof AdminDashboardNotificationsNotificationIdRouteImport
    }
    '/dashboard/data/catalog/$item': {
      id: '/dashboard/data/catalog/$item'
      path: '/$item'
      fullPath: '/dashboard/data/catalog/$item'
      preLoaderRoute: typeof DashboardDataCatalogItemRouteImport
      parentRoute: typeof DashboardDataCatalogRouteImport
    }
    '/dashboard/data/datasets/$datasetId': {
      id: '/dashboard/data/datasets/$datasetId'
      path: '/$datasetId'
      fullPath: '/dashboard/data/datasets/$datasetId'
      preLoaderRoute: typeof DashboardDataDatasetsDatasetIdRouteImport
      parentRoute: typeof DashboardDataDatasetsRouteImport
    }
    '/dashboard/data/images/$imageUUID': {
      id: '/dashboard/data/images/$imageUUID'
      path: '/$imageUUID'
      fullPath: '/dashboard/data/images/$imageUUID'
      preLoaderRoute: typeof DashboardDataImagesImageUUIDRouteImport
      parentRoute: typeof DashboardDataImagesRouteImport
    }
    '/dashboard/data/json-data/$jsonDataUUID': {
      id: '/dashboard/data/json-data/$jsonDataUUID'
      path: '/$jsonDataUUID'
      fullPath: '/dashboard/data/json-data/$jsonDataUUID'
      preLoaderRoute: typeof DashboardDataJsonDataJsonDataUUIDRouteImport
      parentRoute: typeof DashboardDataJsonDataRouteImport
    }
    '/dashboard/data/label-distribution/$label': {
      id: '/dashboard/data/label-distribution/$label'
      path: '/$label'
      fullPath: '/dashboard/data/label-distribution/$label'
      preLoaderRoute: typeof DashboardDataLabelDistributionLabelRouteImport
      parentRoute: typeof DashboardDataLabelDistributionRouteImport
    }
    '/dashboard/data/sessions/$sessionId': {
      id: '/dashboard/data/sessions/$sessionId'
      path: '/$sessionId'
      fullPath: '/dashboard/data/sessions/$sessionId'
      preLoaderRoute: typeof DashboardDataSessionsSessionIdRouteImport
      parentRoute: typeof DashboardDataSessionsRouteImport
    }
    '/dashboard/home/manager-report/$sessionId': {
      id: '/dashboard/home/manager-report/$sessionId'
      path: '/$sessionId'
      fullPath: '/dashboard/home/manager-report/$sessionId'
      preLoaderRoute: typeof DashboardHomeManagerReportSessionIdRouteImport
      parentRoute: typeof DashboardHomeManagerReportRouteImport
    }
    '/dashboard/jobs/camera-calibration/alerts': {
      id: '/dashboard/jobs/camera-calibration/alerts'
      path: '/alerts'
      fullPath: '/dashboard/jobs/camera-calibration/alerts'
      preLoaderRoute: typeof DashboardJobsCameraCalibrationAlertsRouteImport
      parentRoute: typeof DashboardJobsCameraCalibrationRouteImport
    }
    '/dashboard/jobs/camera-calibration/jobs': {
      id: '/dashboard/jobs/camera-calibration/jobs'
      path: '/jobs'
      fullPath: '/dashboard/jobs/camera-calibration/jobs'
      preLoaderRoute: typeof DashboardJobsCameraCalibrationJobsRouteImport
      parentRoute: typeof DashboardJobsCameraCalibrationRouteImport
    }
    '/dashboard/jobs/camera-calibration/schedule': {
      id: '/dashboard/jobs/camera-calibration/schedule'
      path: '/schedule'
      fullPath: '/dashboard/jobs/camera-calibration/schedule'
      preLoaderRoute: typeof DashboardJobsCameraCalibrationScheduleRouteImport
      parentRoute: typeof DashboardJobsCameraCalibrationRouteImport
    }
    '/dashboard/jobs/capacity-tagging/jobs': {
      id: '/dashboard/jobs/capacity-tagging/jobs'
      path: '/jobs'
      fullPath: '/dashboard/jobs/capacity-tagging/jobs'
      preLoaderRoute: typeof DashboardJobsCapacityTaggingJobsRouteImport
      parentRoute: typeof DashboardJobsCapacityTaggingRouteImport
    }
    '/dashboard/jobs/capacity-tagging/schedule': {
      id: '/dashboard/jobs/capacity-tagging/schedule'
      path: '/schedule'
      fullPath: '/dashboard/jobs/capacity-tagging/schedule'
      preLoaderRoute: typeof DashboardJobsCapacityTaggingScheduleRouteImport
      parentRoute: typeof DashboardJobsCapacityTaggingRouteImport
    }
    '/dashboard/jobs/catalog-upload/jobs': {
      id: '/dashboard/jobs/catalog-upload/jobs'
      path: '/jobs'
      fullPath: '/dashboard/jobs/catalog-upload/jobs'
      preLoaderRoute: typeof DashboardJobsCatalogUploadJobsRouteImport
      parentRoute: typeof DashboardJobsCatalogUploadRouteImport
    }
    '/dashboard/jobs/catalog-upload/schedule': {
      id: '/dashboard/jobs/catalog-upload/schedule'
      path: '/schedule'
      fullPath: '/dashboard/jobs/catalog-upload/schedule'
      preLoaderRoute: typeof DashboardJobsCatalogUploadScheduleRouteImport
      parentRoute: typeof DashboardJobsCatalogUploadRouteImport
    }
    '/dashboard/jobs/config/jobs': {
      id: '/dashboard/jobs/config/jobs'
      path: '/jobs'
      fullPath: '/dashboard/jobs/config/jobs'
      preLoaderRoute: typeof DashboardJobsConfigJobsRouteImport
      parentRoute: typeof DashboardJobsConfigRouteImport
    }
    '/dashboard/jobs/config/schedule': {
      id: '/dashboard/jobs/config/schedule'
      path: '/schedule'
      fullPath: '/dashboard/jobs/config/schedule'
      preLoaderRoute: typeof DashboardJobsConfigScheduleRouteImport
      parentRoute: typeof DashboardJobsConfigRouteImport
    }
    '/dashboard/jobs/delete-samples/alerts': {
      id: '/dashboard/jobs/delete-samples/alerts'
      path: '/alerts'
      fullPath: '/dashboard/jobs/delete-samples/alerts'
      preLoaderRoute: typeof DashboardJobsDeleteSamplesAlertsRouteImport
      parentRoute: typeof DashboardJobsDeleteSamplesRouteImport
    }
    '/dashboard/jobs/delete-samples/jobs': {
      id: '/dashboard/jobs/delete-samples/jobs'
      path: '/jobs'
      fullPath: '/dashboard/jobs/delete-samples/jobs'
      preLoaderRoute: typeof DashboardJobsDeleteSamplesJobsRouteImport
      parentRoute: typeof DashboardJobsDeleteSamplesRouteImport
    }
    '/dashboard/jobs/delete-samples/schedule': {
      id: '/dashboard/jobs/delete-samples/schedule'
      path: '/schedule'
      fullPath: '/dashboard/jobs/delete-samples/schedule'
      preLoaderRoute: typeof DashboardJobsDeleteSamplesScheduleRouteImport
      parentRoute: typeof DashboardJobsDeleteSamplesRouteImport
    }
    '/dashboard/jobs/delete-videos/alerts': {
      id: '/dashboard/jobs/delete-videos/alerts'
      path: '/alerts'
      fullPath: '/dashboard/jobs/delete-videos/alerts'
      preLoaderRoute: typeof DashboardJobsDeleteVideosAlertsRouteImport
      parentRoute: typeof DashboardJobsDeleteVideosRouteImport
    }
    '/dashboard/jobs/delete-videos/jobs': {
      id: '/dashboard/jobs/delete-videos/jobs'
      path: '/jobs'
      fullPath: '/dashboard/jobs/delete-videos/jobs'
      preLoaderRoute: typeof DashboardJobsDeleteVideosJobsRouteImport
      parentRoute: typeof DashboardJobsDeleteVideosRouteImport
    }
    '/dashboard/jobs/delete-videos/schedule': {
      id: '/dashboard/jobs/delete-videos/schedule'
      path: '/schedule'
      fullPath: '/dashboard/jobs/delete-videos/schedule'
      preLoaderRoute: typeof DashboardJobsDeleteVideosScheduleRouteImport
      parentRoute: typeof DashboardJobsDeleteVideosRouteImport
    }
    '/dashboard/jobs/deployments/jobs': {
      id: '/dashboard/jobs/deployments/jobs'
      path: '/jobs'
      fullPath: '/dashboard/jobs/deployments/jobs'
      preLoaderRoute: typeof DashboardJobsDeploymentsJobsRouteImport
      parentRoute: typeof DashboardJobsDeploymentsRouteImport
    }
    '/dashboard/jobs/deployments/schedule': {
      id: '/dashboard/jobs/deployments/schedule'
      path: '/schedule'
      fullPath: '/dashboard/jobs/deployments/schedule'
      preLoaderRoute: typeof DashboardJobsDeploymentsScheduleRouteImport
      parentRoute: typeof DashboardJobsDeploymentsRouteImport
    }
    '/dashboard/jobs/head-blur-images/jobs': {
      id: '/dashboard/jobs/head-blur-images/jobs'
      path: '/jobs'
      fullPath: '/dashboard/jobs/head-blur-images/jobs'
      preLoaderRoute: typeof DashboardJobsHeadBlurImagesJobsRouteImport
      parentRoute: typeof DashboardJobsHeadBlurImagesRouteImport
    }
    '/dashboard/jobs/head-blur-images/schedule': {
      id: '/dashboard/jobs/head-blur-images/schedule'
      path: '/schedule'
      fullPath: '/dashboard/jobs/head-blur-images/schedule'
      preLoaderRoute: typeof DashboardJobsHeadBlurImagesScheduleRouteImport
      parentRoute: typeof DashboardJobsHeadBlurImagesRouteImport
    }
    '/dashboard/jobs/head-blur-videos/jobs': {
      id: '/dashboard/jobs/head-blur-videos/jobs'
      path: '/jobs'
      fullPath: '/dashboard/jobs/head-blur-videos/jobs'
      preLoaderRoute: typeof DashboardJobsHeadBlurVideosJobsRouteImport
      parentRoute: typeof DashboardJobsHeadBlurVideosRouteImport
    }
    '/dashboard/jobs/head-blur-videos/schedule': {
      id: '/dashboard/jobs/head-blur-videos/schedule'
      path: '/schedule'
      fullPath: '/dashboard/jobs/head-blur-videos/schedule'
      preLoaderRoute: typeof DashboardJobsHeadBlurVideosScheduleRouteImport
      parentRoute: typeof DashboardJobsHeadBlurVideosRouteImport
    }
    '/dashboard/jobs/models/jobs': {
      id: '/dashboard/jobs/models/jobs'
      path: '/jobs'
      fullPath: '/dashboard/jobs/models/jobs'
      preLoaderRoute: typeof DashboardJobsModelsJobsRouteImport
      parentRoute: typeof DashboardJobsModelsRouteImport
    }
    '/dashboard/jobs/models/schedule': {
      id: '/dashboard/jobs/models/schedule'
      path: '/schedule'
      fullPath: '/dashboard/jobs/models/schedule'
      preLoaderRoute: typeof DashboardJobsModelsScheduleRouteImport
      parentRoute: typeof DashboardJobsModelsRouteImport
    }
    '/dashboard/jobs/recovery-estimates/jobs': {
      id: '/dashboard/jobs/recovery-estimates/jobs'
      path: '/jobs'
      fullPath: '/dashboard/jobs/recovery-estimates/jobs'
      preLoaderRoute: typeof DashboardJobsRecoveryEstimatesJobsRouteImport
      parentRoute: typeof DashboardJobsRecoveryEstimatesRouteImport
    }
    '/dashboard/jobs/recovery-estimates/schedule': {
      id: '/dashboard/jobs/recovery-estimates/schedule'
      path: '/schedule'
      fullPath: '/dashboard/jobs/recovery-estimates/schedule'
      preLoaderRoute: typeof DashboardJobsRecoveryEstimatesScheduleRouteImport
      parentRoute: typeof DashboardJobsRecoveryEstimatesRouteImport
    }
    '/dashboard/jobs/restarts/jobs': {
      id: '/dashboard/jobs/restarts/jobs'
      path: '/jobs'
      fullPath: '/dashboard/jobs/restarts/jobs'
      preLoaderRoute: typeof DashboardJobsRestartsJobsRouteImport
      parentRoute: typeof DashboardJobsRestartsRouteImport
    }
    '/dashboard/jobs/restarts/schedule': {
      id: '/dashboard/jobs/restarts/schedule'
      path: '/schedule'
      fullPath: '/dashboard/jobs/restarts/schedule'
      preLoaderRoute: typeof DashboardJobsRestartsScheduleRouteImport
      parentRoute: typeof DashboardJobsRestartsRouteImport
    }
    '/dashboard/jobs/sample-upload/alerts': {
      id: '/dashboard/jobs/sample-upload/alerts'
      path: '/alerts'
      fullPath: '/dashboard/jobs/sample-upload/alerts'
      preLoaderRoute: typeof DashboardJobsSampleUploadAlertsRouteImport
      parentRoute: typeof DashboardJobsSampleUploadRouteImport
    }
    '/dashboard/jobs/sample-upload/jobs': {
      id: '/dashboard/jobs/sample-upload/jobs'
      path: '/jobs'
      fullPath: '/dashboard/jobs/sample-upload/jobs'
      preLoaderRoute: typeof DashboardJobsSampleUploadJobsRouteImport
      parentRoute: typeof DashboardJobsSampleUploadRouteImport
    }
    '/dashboard/jobs/sample-upload/schedule': {
      id: '/dashboard/jobs/sample-upload/schedule'
      path: '/schedule'
      fullPath: '/dashboard/jobs/sample-upload/schedule'
      preLoaderRoute: typeof DashboardJobsSampleUploadScheduleRouteImport
      parentRoute: typeof DashboardJobsSampleUploadRouteImport
    }
    '/dashboard/jobs/sync-samples/alerts': {
      id: '/dashboard/jobs/sync-samples/alerts'
      path: '/alerts'
      fullPath: '/dashboard/jobs/sync-samples/alerts'
      preLoaderRoute: typeof DashboardJobsSyncSamplesAlertsRouteImport
      parentRoute: typeof DashboardJobsSyncSamplesRouteImport
    }
    '/dashboard/jobs/sync-samples/jobs': {
      id: '/dashboard/jobs/sync-samples/jobs'
      path: '/jobs'
      fullPath: '/dashboard/jobs/sync-samples/jobs'
      preLoaderRoute: typeof DashboardJobsSyncSamplesJobsRouteImport
      parentRoute: typeof DashboardJobsSyncSamplesRouteImport
    }
    '/dashboard/jobs/sync-samples/schedule': {
      id: '/dashboard/jobs/sync-samples/schedule'
      path: '/schedule'
      fullPath: '/dashboard/jobs/sync-samples/schedule'
      preLoaderRoute: typeof DashboardJobsSyncSamplesScheduleRouteImport
      parentRoute: typeof DashboardJobsSyncSamplesRouteImport
    }
    '/dashboard/jobs/training/jobs': {
      id: '/dashboard/jobs/training/jobs'
      path: '/jobs'
      fullPath: '/dashboard/jobs/training/jobs'
      preLoaderRoute: typeof DashboardJobsTrainingJobsRouteImport
      parentRoute: typeof DashboardJobsTrainingRouteImport
    }
    '/dashboard/jobs/training/schedule': {
      id: '/dashboard/jobs/training/schedule'
      path: '/schedule'
      fullPath: '/dashboard/jobs/training/schedule'
      preLoaderRoute: typeof DashboardJobsTrainingScheduleRouteImport
      parentRoute: typeof DashboardJobsTrainingRouteImport
    }
    '/dashboard/jobs/video-upload/alerts': {
      id: '/dashboard/jobs/video-upload/alerts'
      path: '/alerts'
      fullPath: '/dashboard/jobs/video-upload/alerts'
      preLoaderRoute: typeof DashboardJobsVideoUploadAlertsRouteImport
      parentRoute: typeof DashboardJobsVideoUploadRouteImport
    }
    '/dashboard/jobs/video-upload/jobs': {
      id: '/dashboard/jobs/video-upload/jobs'
      path: '/jobs'
      fullPath: '/dashboard/jobs/video-upload/jobs'
      preLoaderRoute: typeof DashboardJobsVideoUploadJobsRouteImport
      parentRoute: typeof DashboardJobsVideoUploadRouteImport
    }
    '/dashboard/jobs/video-upload/schedule': {
      id: '/dashboard/jobs/video-upload/schedule'
      path: '/schedule'
      fullPath: '/dashboard/jobs/video-upload/schedule'
      preLoaderRoute: typeof DashboardJobsVideoUploadScheduleRouteImport
      parentRoute: typeof DashboardJobsVideoUploadRouteImport
    }
    '/dashboard/jobs/worker-jobs/jobs': {
      id: '/dashboard/jobs/worker-jobs/jobs'
      path: '/jobs'
      fullPath: '/dashboard/jobs/worker-jobs/jobs'
      preLoaderRoute: typeof DashboardJobsWorkerJobsJobsRouteImport
      parentRoute: typeof DashboardJobsWorkerJobsRouteImport
    }
    '/dashboard/jobs/worker-jobs/schedule': {
      id: '/dashboard/jobs/worker-jobs/schedule'
      path: '/schedule'
      fullPath: '/dashboard/jobs/worker-jobs/schedule'
      preLoaderRoute: typeof DashboardJobsWorkerJobsScheduleRouteImport
      parentRoute: typeof DashboardJobsWorkerJobsRouteImport
    }
    '/dashboard/models/$modelId/deployment': {
      id: '/dashboard/models/$modelId/deployment'
      path: '/deployment'
      fullPath: '/dashboard/models/$modelId/deployment'
      preLoaderRoute: typeof DashboardModelsModelIdDeploymentRouteImport
      parentRoute: typeof DashboardModelsModelIdRouteImport
    }
    '/dashboard/models/$modelId/labels': {
      id: '/dashboard/models/$modelId/labels'
      path: '/labels'
      fullPath: '/dashboard/models/$modelId/labels'
      preLoaderRoute: typeof DashboardModelsModelIdLabelsRouteImport
      parentRoute: typeof DashboardModelsModelIdRouteImport
    }
    '/dashboard/models/$modelId/matrix': {
      id: '/dashboard/models/$modelId/matrix'
      path: '/matrix'
      fullPath: '/dashboard/models/$modelId/matrix'
      preLoaderRoute: typeof DashboardModelsModelIdMatrixRouteImport
      parentRoute: typeof DashboardModelsModelIdRouteImport
    }
    '/dashboard/models/$modelId/overview': {
      id: '/dashboard/models/$modelId/overview'
      path: '/overview'
      fullPath: '/dashboard/models/$modelId/overview'
      preLoaderRoute: typeof DashboardModelsModelIdOverviewRouteImport
      parentRoute: typeof DashboardModelsModelIdRouteImport
    }
    '/dashboard/resources/clusters/$clusterId': {
      id: '/dashboard/resources/clusters/$clusterId'
      path: '/$clusterId'
      fullPath: '/dashboard/resources/clusters/$clusterId'
      preLoaderRoute: typeof DashboardResourcesClustersClusterIdRouteImport
      parentRoute: typeof DashboardResourcesClustersRouteImport
    }
    '/dashboard/resources/devices/$deviceId': {
      id: '/dashboard/resources/devices/$deviceId'
      path: '/$deviceId'
      fullPath: '/dashboard/resources/devices/$deviceId'
      preLoaderRoute: typeof DashboardResourcesDevicesDeviceIdRouteImport
      parentRoute: typeof DashboardResourcesDevicesRouteImport
    }
    '/dashboard/resources/site-groups/$siteGroupId': {
      id: '/dashboard/resources/site-groups/$siteGroupId'
      path: '/$siteGroupId'
      fullPath: '/dashboard/resources/site-groups/$siteGroupId'
      preLoaderRoute: typeof DashboardResourcesSiteGroupsSiteGroupIdRouteImport
      parentRoute: typeof DashboardResourcesSiteGroupsRouteImport
    }
    '/dashboard/resources/sites/$siteId': {
      id: '/dashboard/resources/sites/$siteId'
      path: '/$siteId'
      fullPath: '/dashboard/resources/sites/$siteId'
      preLoaderRoute: typeof DashboardResourcesSitesSiteIdRouteImport
      parentRoute: typeof DashboardResourcesSitesRouteImport
    }
    '/dashboard/settings/alert-management/alert-channels': {
      id: '/dashboard/settings/alert-management/alert-channels'
      path: '/alert-channels'
      fullPath: '/dashboard/settings/alert-management/alert-channels'
      preLoaderRoute: typeof DashboardSettingsAlertManagementAlertChannelsRouteImport
      parentRoute: typeof DashboardSettingsAlertManagementRouteImport
    }
    '/dashboard/settings/alert-management/alerts': {
      id: '/dashboard/settings/alert-management/alerts'
      path: '/alerts'
      fullPath: '/dashboard/settings/alert-management/alerts'
      preLoaderRoute: typeof DashboardSettingsAlertManagementAlertsRouteImport
      parentRoute: typeof DashboardSettingsAlertManagementRouteImport
    }
    '/dashboard/settings/alert-management/metric-alerts': {
      id: '/dashboard/settings/alert-management/metric-alerts'
      path: '/metric-alerts'
      fullPath: '/dashboard/settings/alert-management/metric-alerts'
      preLoaderRoute: typeof DashboardSettingsAlertManagementMetricAlertsRouteImport
      parentRoute: typeof DashboardSettingsAlertManagementRouteImport
    }
    '/dashboard/settings/queues/$queueName': {
      id: '/dashboard/settings/queues/$queueName'
      path: '/$queueName'
      fullPath: '/dashboard/settings/queues/$queueName'
      preLoaderRoute: typeof DashboardSettingsQueuesQueueNameRouteImport
      parentRoute: typeof DashboardSettingsQueuesRouteImport
    }
    '/dashboard/settings/report-settings/$reportId': {
      id: '/dashboard/settings/report-settings/$reportId'
      path: '/$reportId'
      fullPath: '/dashboard/settings/report-settings/$reportId'
      preLoaderRoute: typeof DashboardSettingsReportSettingsReportIdRouteImport
      parentRoute: typeof DashboardSettingsReportSettingsRouteImport
    }
    '/dashboard/settings/tags-management/catalog': {
      id: '/dashboard/settings/tags-management/catalog'
      path: '/catalog'
      fullPath: '/dashboard/settings/tags-management/catalog'
      preLoaderRoute: typeof DashboardSettingsTagsManagementCatalogRouteImport
      parentRoute: typeof DashboardSettingsTagsManagementRouteImport
    }
    '/dashboard/settings/tags-management/clusters': {
      id: '/dashboard/settings/tags-management/clusters'
      path: '/clusters'
      fullPath: '/dashboard/settings/tags-management/clusters'
      preLoaderRoute: typeof DashboardSettingsTagsManagementClustersRouteImport
      parentRoute: typeof DashboardSettingsTagsManagementRouteImport
    }
    '/dashboard/settings/tags-management/devices': {
      id: '/dashboard/settings/tags-management/devices'
      path: '/devices'
      fullPath: '/dashboard/settings/tags-management/devices'
      preLoaderRoute: typeof DashboardSettingsTagsManagementDevicesRouteImport
      parentRoute: typeof DashboardSettingsTagsManagementRouteImport
    }
    '/dashboard/settings/tags-management/samples': {
      id: '/dashboard/settings/tags-management/samples'
      path: '/samples'
      fullPath: '/dashboard/settings/tags-management/samples'
      preLoaderRoute: typeof DashboardSettingsTagsManagementSamplesRouteImport
      parentRoute: typeof DashboardSettingsTagsManagementRouteImport
    }
    '/dashboard/settings/tags-management/sessions': {
      id: '/dashboard/settings/tags-management/sessions'
      path: '/sessions'
      fullPath: '/dashboard/settings/tags-management/sessions'
      preLoaderRoute: typeof DashboardSettingsTagsManagementSessionsRouteImport
      parentRoute: typeof DashboardSettingsTagsManagementRouteImport
    }
    '/dashboard/settings/tags-management/sites': {
      id: '/dashboard/settings/tags-management/sites'
      path: '/sites'
      fullPath: '/dashboard/settings/tags-management/sites'
      preLoaderRoute: typeof DashboardSettingsTagsManagementSitesRouteImport
      parentRoute: typeof DashboardSettingsTagsManagementRouteImport
    }
    '/dashboard/settings/user-management/$userId': {
      id: '/dashboard/settings/user-management/$userId'
      path: '/$userId'
      fullPath: '/dashboard/settings/user-management/$userId'
      preLoaderRoute: typeof DashboardSettingsUserManagementUserIdRouteImport
      parentRoute: typeof DashboardSettingsUserManagementRouteImport
    }
    '/dashboard/data/[/rest]': {
      id: '/dashboard/data/[/rest]'
      path: '/[/rest]'
      fullPath: '/dashboard/data/[/rest]'
      preLoaderRoute: typeof DashboardDataRestImport
      parentRoute: typeof DashboardDataRouteImport
    }
    '/dashboard/resources/[/rest]': {
      id: '/dashboard/resources/[/rest]'
      path: '/[/rest]'
      fullPath: '/dashboard/resources/[/rest]'
      preLoaderRoute: typeof DashboardResourcesRestImport
      parentRoute: typeof DashboardResourcesRouteImport
    }
    '/dashboard/settings/user-management/thumbnail': {
      id: '/dashboard/settings/user-management/thumbnail'
      path: '/thumbnail'
      fullPath: '/dashboard/settings/user-management/thumbnail'
      preLoaderRoute: typeof DashboardSettingsUserManagementThumbnailImport
      parentRoute: typeof DashboardSettingsUserManagementRouteImport
    }
    '/admin-dashboard/accounts-management/$accountId/': {
      id: '/admin-dashboard/accounts-management/$accountId/'
      path: '/'
      fullPath: '/admin-dashboard/accounts-management/$accountId/'
      preLoaderRoute: typeof AdminDashboardAccountsManagementAccountIdIndexImport
      parentRoute: typeof AdminDashboardAccountsManagementAccountIdRouteImport
    }
    '/admin-dashboard/jobs/service-health-checks/': {
      id: '/admin-dashboard/jobs/service-health-checks/'
      path: '/'
      fullPath: '/admin-dashboard/jobs/service-health-checks/'
      preLoaderRoute: typeof AdminDashboardJobsServiceHealthChecksIndexImport
      parentRoute: typeof AdminDashboardJobsServiceHealthChecksRouteImport
    }
    '/dashboard/home/manager-report/': {
      id: '/dashboard/home/manager-report/'
      path: '/'
      fullPath: '/dashboard/home/manager-report/'
      preLoaderRoute: typeof DashboardHomeManagerReportIndexImport
      parentRoute: typeof DashboardHomeManagerReportRouteImport
    }
    '/dashboard/jobs/camera-calibration/': {
      id: '/dashboard/jobs/camera-calibration/'
      path: '/'
      fullPath: '/dashboard/jobs/camera-calibration/'
      preLoaderRoute: typeof DashboardJobsCameraCalibrationIndexImport
      parentRoute: typeof DashboardJobsCameraCalibrationRouteImport
    }
    '/dashboard/jobs/capacity-tagging/': {
      id: '/dashboard/jobs/capacity-tagging/'
      path: '/'
      fullPath: '/dashboard/jobs/capacity-tagging/'
      preLoaderRoute: typeof DashboardJobsCapacityTaggingIndexImport
      parentRoute: typeof DashboardJobsCapacityTaggingRouteImport
    }
    '/dashboard/jobs/catalog-upload/': {
      id: '/dashboard/jobs/catalog-upload/'
      path: '/'
      fullPath: '/dashboard/jobs/catalog-upload/'
      preLoaderRoute: typeof DashboardJobsCatalogUploadIndexImport
      parentRoute: typeof DashboardJobsCatalogUploadRouteImport
    }
    '/dashboard/jobs/config/': {
      id: '/dashboard/jobs/config/'
      path: '/'
      fullPath: '/dashboard/jobs/config/'
      preLoaderRoute: typeof DashboardJobsConfigIndexImport
      parentRoute: typeof DashboardJobsConfigRouteImport
    }
    '/dashboard/jobs/delete-samples/': {
      id: '/dashboard/jobs/delete-samples/'
      path: '/'
      fullPath: '/dashboard/jobs/delete-samples/'
      preLoaderRoute: typeof DashboardJobsDeleteSamplesIndexImport
      parentRoute: typeof DashboardJobsDeleteSamplesRouteImport
    }
    '/dashboard/jobs/delete-videos/': {
      id: '/dashboard/jobs/delete-videos/'
      path: '/'
      fullPath: '/dashboard/jobs/delete-videos/'
      preLoaderRoute: typeof DashboardJobsDeleteVideosIndexImport
      parentRoute: typeof DashboardJobsDeleteVideosRouteImport
    }
    '/dashboard/jobs/deployments/': {
      id: '/dashboard/jobs/deployments/'
      path: '/'
      fullPath: '/dashboard/jobs/deployments/'
      preLoaderRoute: typeof DashboardJobsDeploymentsIndexImport
      parentRoute: typeof DashboardJobsDeploymentsRouteImport
    }
    '/dashboard/jobs/head-blur-images/': {
      id: '/dashboard/jobs/head-blur-images/'
      path: '/'
      fullPath: '/dashboard/jobs/head-blur-images/'
      preLoaderRoute: typeof DashboardJobsHeadBlurImagesIndexImport
      parentRoute: typeof DashboardJobsHeadBlurImagesRouteImport
    }
    '/dashboard/jobs/head-blur-videos/': {
      id: '/dashboard/jobs/head-blur-videos/'
      path: '/'
      fullPath: '/dashboard/jobs/head-blur-videos/'
      preLoaderRoute: typeof DashboardJobsHeadBlurVideosIndexImport
      parentRoute: typeof DashboardJobsHeadBlurVideosRouteImport
    }
    '/dashboard/jobs/models/': {
      id: '/dashboard/jobs/models/'
      path: '/'
      fullPath: '/dashboard/jobs/models/'
      preLoaderRoute: typeof DashboardJobsModelsIndexImport
      parentRoute: typeof DashboardJobsModelsRouteImport
    }
    '/dashboard/jobs/recovery-estimates/': {
      id: '/dashboard/jobs/recovery-estimates/'
      path: '/'
      fullPath: '/dashboard/jobs/recovery-estimates/'
      preLoaderRoute: typeof DashboardJobsRecoveryEstimatesIndexImport
      parentRoute: typeof DashboardJobsRecoveryEstimatesRouteImport
    }
    '/dashboard/jobs/restarts/': {
      id: '/dashboard/jobs/restarts/'
      path: '/'
      fullPath: '/dashboard/jobs/restarts/'
      preLoaderRoute: typeof DashboardJobsRestartsIndexImport
      parentRoute: typeof DashboardJobsRestartsRouteImport
    }
    '/dashboard/jobs/sample-upload/': {
      id: '/dashboard/jobs/sample-upload/'
      path: '/'
      fullPath: '/dashboard/jobs/sample-upload/'
      preLoaderRoute: typeof DashboardJobsSampleUploadIndexImport
      parentRoute: typeof DashboardJobsSampleUploadRouteImport
    }
    '/dashboard/jobs/sync-samples/': {
      id: '/dashboard/jobs/sync-samples/'
      path: '/'
      fullPath: '/dashboard/jobs/sync-samples/'
      preLoaderRoute: typeof DashboardJobsSyncSamplesIndexImport
      parentRoute: typeof DashboardJobsSyncSamplesRouteImport
    }
    '/dashboard/jobs/training/': {
      id: '/dashboard/jobs/training/'
      path: '/'
      fullPath: '/dashboard/jobs/training/'
      preLoaderRoute: typeof DashboardJobsTrainingIndexImport
      parentRoute: typeof DashboardJobsTrainingRouteImport
    }
    '/dashboard/jobs/video-upload/': {
      id: '/dashboard/jobs/video-upload/'
      path: '/'
      fullPath: '/dashboard/jobs/video-upload/'
      preLoaderRoute: typeof DashboardJobsVideoUploadIndexImport
      parentRoute: typeof DashboardJobsVideoUploadRouteImport
    }
    '/dashboard/jobs/worker-jobs/': {
      id: '/dashboard/jobs/worker-jobs/'
      path: '/'
      fullPath: '/dashboard/jobs/worker-jobs/'
      preLoaderRoute: typeof DashboardJobsWorkerJobsIndexImport
      parentRoute: typeof DashboardJobsWorkerJobsRouteImport
    }
    '/dashboard/models/$modelId/': {
      id: '/dashboard/models/$modelId/'
      path: '/'
      fullPath: '/dashboard/models/$modelId/'
      preLoaderRoute: typeof DashboardModelsModelIdIndexImport
      parentRoute: typeof DashboardModelsModelIdRouteImport
    }
    '/dashboard/settings/alert-management/': {
      id: '/dashboard/settings/alert-management/'
      path: '/'
      fullPath: '/dashboard/settings/alert-management/'
      preLoaderRoute: typeof DashboardSettingsAlertManagementIndexImport
      parentRoute: typeof DashboardSettingsAlertManagementRouteImport
    }
    '/dashboard/settings/queues/': {
      id: '/dashboard/settings/queues/'
      path: '/'
      fullPath: '/dashboard/settings/queues/'
      preLoaderRoute: typeof DashboardSettingsQueuesIndexImport
      parentRoute: typeof DashboardSettingsQueuesRouteImport
    }
    '/dashboard/settings/tags-management/': {
      id: '/dashboard/settings/tags-management/'
      path: '/'
      fullPath: '/dashboard/settings/tags-management/'
      preLoaderRoute: typeof DashboardSettingsTagsManagementIndexImport
      parentRoute: typeof DashboardSettingsTagsManagementRouteImport
    }
    '/admin-dashboard/jobs/service-health-checks/jobs/$jobId': {
      id: '/admin-dashboard/jobs/service-health-checks/jobs/$jobId'
      path: '/$jobId'
      fullPath: '/admin-dashboard/jobs/service-health-checks/jobs/$jobId'
      preLoaderRoute: typeof AdminDashboardJobsServiceHealthChecksJobsJobIdRouteImport
      parentRoute: typeof AdminDashboardJobsServiceHealthChecksJobsRouteImport
    }
    '/admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId': {
      id: '/admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId'
      path: '/$scheduledJobId'
      fullPath: '/admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId'
      preLoaderRoute: typeof AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdRouteImport
      parentRoute: typeof AdminDashboardJobsServiceHealthChecksScheduleRouteImport
    }
    '/dashboard/data/catalog/$item/details': {
      id: '/dashboard/data/catalog/$item/details'
      path: '/details'
      fullPath: '/dashboard/data/catalog/$item/details'
      preLoaderRoute: typeof DashboardDataCatalogItemDetailsRouteImport
      parentRoute: typeof DashboardDataCatalogItemRouteImport
    }
    '/dashboard/data/catalog/$item/labels': {
      id: '/dashboard/data/catalog/$item/labels'
      path: '/labels'
      fullPath: '/dashboard/data/catalog/$item/labels'
      preLoaderRoute: typeof DashboardDataCatalogItemLabelsRouteImport
      parentRoute: typeof DashboardDataCatalogItemRouteImport
    }
    '/dashboard/data/catalog/$item/prices': {
      id: '/dashboard/data/catalog/$item/prices'
      path: '/prices'
      fullPath: '/dashboard/data/catalog/$item/prices'
      preLoaderRoute: typeof DashboardDataCatalogItemPricesRouteImport
      parentRoute: typeof DashboardDataCatalogItemRouteImport
    }
    '/dashboard/data/datasets/$datasetId/images': {
      id: '/dashboard/data/datasets/$datasetId/images'
      path: '/images'
      fullPath: '/dashboard/data/datasets/$datasetId/images'
      preLoaderRoute: typeof DashboardDataDatasetsDatasetIdImagesRouteImport
      parentRoute: typeof DashboardDataDatasetsDatasetIdRouteImport
    }
    '/dashboard/data/datasets/$datasetId/overview': {
      id: '/dashboard/data/datasets/$datasetId/overview'
      path: '/overview'
      fullPath: '/dashboard/data/datasets/$datasetId/overview'
      preLoaderRoute: typeof DashboardDataDatasetsDatasetIdOverviewRouteImport
      parentRoute: typeof DashboardDataDatasetsDatasetIdRouteImport
    }
    '/dashboard/data/datasets/$datasetId/sessions': {
      id: '/dashboard/data/datasets/$datasetId/sessions'
      path: '/sessions'
      fullPath: '/dashboard/data/datasets/$datasetId/sessions'
      preLoaderRoute: typeof DashboardDataDatasetsDatasetIdSessionsRouteImport
      parentRoute: typeof DashboardDataDatasetsDatasetIdRouteImport
    }
    '/dashboard/data/images/$imageUUID/additional': {
      id: '/dashboard/data/images/$imageUUID/additional'
      path: '/additional'
      fullPath: '/dashboard/data/images/$imageUUID/additional'
      preLoaderRoute: typeof DashboardDataImagesImageUUIDAdditionalRouteImport
      parentRoute: typeof DashboardDataImagesImageUUIDRouteImport
    }
    '/dashboard/data/images/$imageUUID/overview': {
      id: '/dashboard/data/images/$imageUUID/overview'
      path: '/overview'
      fullPath: '/dashboard/data/images/$imageUUID/overview'
      preLoaderRoute: typeof DashboardDataImagesImageUUIDOverviewRouteImport
      parentRoute: typeof DashboardDataImagesImageUUIDRouteImport
    }
    '/dashboard/data/images/$imageUUID/transaction-details': {
      id: '/dashboard/data/images/$imageUUID/transaction-details'
      path: '/transaction-details'
      fullPath: '/dashboard/data/images/$imageUUID/transaction-details'
      preLoaderRoute: typeof DashboardDataImagesImageUUIDTransactionDetailsRouteImport
      parentRoute: typeof DashboardDataImagesImageUUIDRouteImport
    }
    '/dashboard/data/sessions/$sessionId/overview': {
      id: '/dashboard/data/sessions/$sessionId/overview'
      path: '/overview'
      fullPath: '/dashboard/data/sessions/$sessionId/overview'
      preLoaderRoute: typeof DashboardDataSessionsSessionIdOverviewRouteImport
      parentRoute: typeof DashboardDataSessionsSessionIdRouteImport
    }
    '/dashboard/home/manager-report/$sessionId/overview': {
      id: '/dashboard/home/manager-report/$sessionId/overview'
      path: '/overview'
      fullPath: '/dashboard/home/manager-report/$sessionId/overview'
      preLoaderRoute: typeof DashboardHomeManagerReportSessionIdOverviewRouteImport
      parentRoute: typeof DashboardHomeManagerReportSessionIdRouteImport
    }
    '/dashboard/jobs/camera-calibration/jobs/$jobId': {
      id: '/dashboard/jobs/camera-calibration/jobs/$jobId'
      path: '/$jobId'
      fullPath: '/dashboard/jobs/camera-calibration/jobs/$jobId'
      preLoaderRoute: typeof DashboardJobsCameraCalibrationJobsJobIdRouteImport
      parentRoute: typeof DashboardJobsCameraCalibrationJobsRouteImport
    }
    '/dashboard/jobs/camera-calibration/schedule/$scheduledJobId': {
      id: '/dashboard/jobs/camera-calibration/schedule/$scheduledJobId'
      path: '/$scheduledJobId'
      fullPath: '/dashboard/jobs/camera-calibration/schedule/$scheduledJobId'
      preLoaderRoute: typeof DashboardJobsCameraCalibrationScheduleScheduledJobIdRouteImport
      parentRoute: typeof DashboardJobsCameraCalibrationScheduleRouteImport
    }
    '/dashboard/jobs/capacity-tagging/jobs/$jobId': {
      id: '/dashboard/jobs/capacity-tagging/jobs/$jobId'
      path: '/$jobId'
      fullPath: '/dashboard/jobs/capacity-tagging/jobs/$jobId'
      preLoaderRoute: typeof DashboardJobsCapacityTaggingJobsJobIdRouteImport
      parentRoute: typeof DashboardJobsCapacityTaggingJobsRouteImport
    }
    '/dashboard/jobs/capacity-tagging/schedule/$scheduledJobId': {
      id: '/dashboard/jobs/capacity-tagging/schedule/$scheduledJobId'
      path: '/$scheduledJobId'
      fullPath: '/dashboard/jobs/capacity-tagging/schedule/$scheduledJobId'
      preLoaderRoute: typeof DashboardJobsCapacityTaggingScheduleScheduledJobIdRouteImport
      parentRoute: typeof DashboardJobsCapacityTaggingScheduleRouteImport
    }
    '/dashboard/jobs/catalog-upload/jobs/$jobId': {
      id: '/dashboard/jobs/catalog-upload/jobs/$jobId'
      path: '/$jobId'
      fullPath: '/dashboard/jobs/catalog-upload/jobs/$jobId'
      preLoaderRoute: typeof DashboardJobsCatalogUploadJobsJobIdRouteImport
      parentRoute: typeof DashboardJobsCatalogUploadJobsRouteImport
    }
    '/dashboard/jobs/catalog-upload/schedule/$scheduledJobId': {
      id: '/dashboard/jobs/catalog-upload/schedule/$scheduledJobId'
      path: '/$scheduledJobId'
      fullPath: '/dashboard/jobs/catalog-upload/schedule/$scheduledJobId'
      preLoaderRoute: typeof DashboardJobsCatalogUploadScheduleScheduledJobIdRouteImport
      parentRoute: typeof DashboardJobsCatalogUploadScheduleRouteImport
    }
    '/dashboard/jobs/config/jobs/$jobId': {
      id: '/dashboard/jobs/config/jobs/$jobId'
      path: '/$jobId'
      fullPath: '/dashboard/jobs/config/jobs/$jobId'
      preLoaderRoute: typeof DashboardJobsConfigJobsJobIdRouteImport
      parentRoute: typeof DashboardJobsConfigJobsRouteImport
    }
    '/dashboard/jobs/config/schedule/$scheduledJobId': {
      id: '/dashboard/jobs/config/schedule/$scheduledJobId'
      path: '/$scheduledJobId'
      fullPath: '/dashboard/jobs/config/schedule/$scheduledJobId'
      preLoaderRoute: typeof DashboardJobsConfigScheduleScheduledJobIdRouteImport
      parentRoute: typeof DashboardJobsConfigScheduleRouteImport
    }
    '/dashboard/jobs/delete-samples/jobs/$jobId': {
      id: '/dashboard/jobs/delete-samples/jobs/$jobId'
      path: '/$jobId'
      fullPath: '/dashboard/jobs/delete-samples/jobs/$jobId'
      preLoaderRoute: typeof DashboardJobsDeleteSamplesJobsJobIdRouteImport
      parentRoute: typeof DashboardJobsDeleteSamplesJobsRouteImport
    }
    '/dashboard/jobs/delete-samples/schedule/$scheduledJobId': {
      id: '/dashboard/jobs/delete-samples/schedule/$scheduledJobId'
      path: '/$scheduledJobId'
      fullPath: '/dashboard/jobs/delete-samples/schedule/$scheduledJobId'
      preLoaderRoute: typeof DashboardJobsDeleteSamplesScheduleScheduledJobIdRouteImport
      parentRoute: typeof DashboardJobsDeleteSamplesScheduleRouteImport
    }
    '/dashboard/jobs/delete-videos/jobs/$jobId': {
      id: '/dashboard/jobs/delete-videos/jobs/$jobId'
      path: '/$jobId'
      fullPath: '/dashboard/jobs/delete-videos/jobs/$jobId'
      preLoaderRoute: typeof DashboardJobsDeleteVideosJobsJobIdRouteImport
      parentRoute: typeof DashboardJobsDeleteVideosJobsRouteImport
    }
    '/dashboard/jobs/delete-videos/schedule/$scheduledJobId': {
      id: '/dashboard/jobs/delete-videos/schedule/$scheduledJobId'
      path: '/$scheduledJobId'
      fullPath: '/dashboard/jobs/delete-videos/schedule/$scheduledJobId'
      preLoaderRoute: typeof DashboardJobsDeleteVideosScheduleScheduledJobIdRouteImport
      parentRoute: typeof DashboardJobsDeleteVideosScheduleRouteImport
    }
    '/dashboard/jobs/deployments/jobs/$jobId': {
      id: '/dashboard/jobs/deployments/jobs/$jobId'
      path: '/$jobId'
      fullPath: '/dashboard/jobs/deployments/jobs/$jobId'
      preLoaderRoute: typeof DashboardJobsDeploymentsJobsJobIdRouteImport
      parentRoute: typeof DashboardJobsDeploymentsJobsRouteImport
    }
    '/dashboard/jobs/deployments/schedule/$scheduledJobId': {
      id: '/dashboard/jobs/deployments/schedule/$scheduledJobId'
      path: '/$scheduledJobId'
      fullPath: '/dashboard/jobs/deployments/schedule/$scheduledJobId'
      preLoaderRoute: typeof DashboardJobsDeploymentsScheduleScheduledJobIdRouteImport
      parentRoute: typeof DashboardJobsDeploymentsScheduleRouteImport
    }
    '/dashboard/jobs/head-blur-images/jobs/$jobId': {
      id: '/dashboard/jobs/head-blur-images/jobs/$jobId'
      path: '/$jobId'
      fullPath: '/dashboard/jobs/head-blur-images/jobs/$jobId'
      preLoaderRoute: typeof DashboardJobsHeadBlurImagesJobsJobIdRouteImport
      parentRoute: typeof DashboardJobsHeadBlurImagesJobsRouteImport
    }
    '/dashboard/jobs/head-blur-images/schedule/$scheduledJobId': {
      id: '/dashboard/jobs/head-blur-images/schedule/$scheduledJobId'
      path: '/$scheduledJobId'
      fullPath: '/dashboard/jobs/head-blur-images/schedule/$scheduledJobId'
      preLoaderRoute: typeof DashboardJobsHeadBlurImagesScheduleScheduledJobIdRouteImport
      parentRoute: typeof DashboardJobsHeadBlurImagesScheduleRouteImport
    }
    '/dashboard/jobs/head-blur-videos/jobs/$jobId': {
      id: '/dashboard/jobs/head-blur-videos/jobs/$jobId'
      path: '/$jobId'
      fullPath: '/dashboard/jobs/head-blur-videos/jobs/$jobId'
      preLoaderRoute: typeof DashboardJobsHeadBlurVideosJobsJobIdRouteImport
      parentRoute: typeof DashboardJobsHeadBlurVideosJobsRouteImport
    }
    '/dashboard/jobs/head-blur-videos/schedule/$scheduledJobId': {
      id: '/dashboard/jobs/head-blur-videos/schedule/$scheduledJobId'
      path: '/$scheduledJobId'
      fullPath: '/dashboard/jobs/head-blur-videos/schedule/$scheduledJobId'
      preLoaderRoute: typeof DashboardJobsHeadBlurVideosScheduleScheduledJobIdRouteImport
      parentRoute: typeof DashboardJobsHeadBlurVideosScheduleRouteImport
    }
    '/dashboard/jobs/models/jobs/$jobId': {
      id: '/dashboard/jobs/models/jobs/$jobId'
      path: '/$jobId'
      fullPath: '/dashboard/jobs/models/jobs/$jobId'
      preLoaderRoute: typeof DashboardJobsModelsJobsJobIdRouteImport
      parentRoute: typeof DashboardJobsModelsJobsRouteImport
    }
    '/dashboard/jobs/models/schedule/$scheduledJobId': {
      id: '/dashboard/jobs/models/schedule/$scheduledJobId'
      path: '/$scheduledJobId'
      fullPath: '/dashboard/jobs/models/schedule/$scheduledJobId'
      preLoaderRoute: typeof DashboardJobsModelsScheduleScheduledJobIdRouteImport
      parentRoute: typeof DashboardJobsModelsScheduleRouteImport
    }
    '/dashboard/jobs/recovery-estimates/jobs/$jobId': {
      id: '/dashboard/jobs/recovery-estimates/jobs/$jobId'
      path: '/$jobId'
      fullPath: '/dashboard/jobs/recovery-estimates/jobs/$jobId'
      preLoaderRoute: typeof DashboardJobsRecoveryEstimatesJobsJobIdRouteImport
      parentRoute: typeof DashboardJobsRecoveryEstimatesJobsRouteImport
    }
    '/dashboard/jobs/recovery-estimates/schedule/$scheduledJobId': {
      id: '/dashboard/jobs/recovery-estimates/schedule/$scheduledJobId'
      path: '/$scheduledJobId'
      fullPath: '/dashboard/jobs/recovery-estimates/schedule/$scheduledJobId'
      preLoaderRoute: typeof DashboardJobsRecoveryEstimatesScheduleScheduledJobIdRouteImport
      parentRoute: typeof DashboardJobsRecoveryEstimatesScheduleRouteImport
    }
    '/dashboard/jobs/restarts/jobs/$jobId': {
      id: '/dashboard/jobs/restarts/jobs/$jobId'
      path: '/$jobId'
      fullPath: '/dashboard/jobs/restarts/jobs/$jobId'
      preLoaderRoute: typeof DashboardJobsRestartsJobsJobIdRouteImport
      parentRoute: typeof DashboardJobsRestartsJobsRouteImport
    }
    '/dashboard/jobs/restarts/schedule/$scheduledJobId': {
      id: '/dashboard/jobs/restarts/schedule/$scheduledJobId'
      path: '/$scheduledJobId'
      fullPath: '/dashboard/jobs/restarts/schedule/$scheduledJobId'
      preLoaderRoute: typeof DashboardJobsRestartsScheduleScheduledJobIdRouteImport
      parentRoute: typeof DashboardJobsRestartsScheduleRouteImport
    }
    '/dashboard/jobs/sample-upload/jobs/$jobId': {
      id: '/dashboard/jobs/sample-upload/jobs/$jobId'
      path: '/$jobId'
      fullPath: '/dashboard/jobs/sample-upload/jobs/$jobId'
      preLoaderRoute: typeof DashboardJobsSampleUploadJobsJobIdRouteImport
      parentRoute: typeof DashboardJobsSampleUploadJobsRouteImport
    }
    '/dashboard/jobs/sample-upload/schedule/$scheduledJobId': {
      id: '/dashboard/jobs/sample-upload/schedule/$scheduledJobId'
      path: '/$scheduledJobId'
      fullPath: '/dashboard/jobs/sample-upload/schedule/$scheduledJobId'
      preLoaderRoute: typeof DashboardJobsSampleUploadScheduleScheduledJobIdRouteImport
      parentRoute: typeof DashboardJobsSampleUploadScheduleRouteImport
    }
    '/dashboard/jobs/sync-samples/jobs/$jobId': {
      id: '/dashboard/jobs/sync-samples/jobs/$jobId'
      path: '/$jobId'
      fullPath: '/dashboard/jobs/sync-samples/jobs/$jobId'
      preLoaderRoute: typeof DashboardJobsSyncSamplesJobsJobIdRouteImport
      parentRoute: typeof DashboardJobsSyncSamplesJobsRouteImport
    }
    '/dashboard/jobs/sync-samples/schedule/$scheduledJobId': {
      id: '/dashboard/jobs/sync-samples/schedule/$scheduledJobId'
      path: '/$scheduledJobId'
      fullPath: '/dashboard/jobs/sync-samples/schedule/$scheduledJobId'
      preLoaderRoute: typeof DashboardJobsSyncSamplesScheduleScheduledJobIdRouteImport
      parentRoute: typeof DashboardJobsSyncSamplesScheduleRouteImport
    }
    '/dashboard/jobs/training/jobs/$jobId': {
      id: '/dashboard/jobs/training/jobs/$jobId'
      path: '/$jobId'
      fullPath: '/dashboard/jobs/training/jobs/$jobId'
      preLoaderRoute: typeof DashboardJobsTrainingJobsJobIdRouteImport
      parentRoute: typeof DashboardJobsTrainingJobsRouteImport
    }
    '/dashboard/jobs/training/schedule/$scheduledJobId': {
      id: '/dashboard/jobs/training/schedule/$scheduledJobId'
      path: '/$scheduledJobId'
      fullPath: '/dashboard/jobs/training/schedule/$scheduledJobId'
      preLoaderRoute: typeof DashboardJobsTrainingScheduleScheduledJobIdRouteImport
      parentRoute: typeof DashboardJobsTrainingScheduleRouteImport
    }
    '/dashboard/jobs/video-upload/jobs/$jobId': {
      id: '/dashboard/jobs/video-upload/jobs/$jobId'
      path: '/$jobId'
      fullPath: '/dashboard/jobs/video-upload/jobs/$jobId'
      preLoaderRoute: typeof DashboardJobsVideoUploadJobsJobIdRouteImport
      parentRoute: typeof DashboardJobsVideoUploadJobsRouteImport
    }
    '/dashboard/jobs/video-upload/schedule/$scheduledJobId': {
      id: '/dashboard/jobs/video-upload/schedule/$scheduledJobId'
      path: '/$scheduledJobId'
      fullPath: '/dashboard/jobs/video-upload/schedule/$scheduledJobId'
      preLoaderRoute: typeof DashboardJobsVideoUploadScheduleScheduledJobIdRouteImport
      parentRoute: typeof DashboardJobsVideoUploadScheduleRouteImport
    }
    '/dashboard/jobs/worker-jobs/jobs/$jobId': {
      id: '/dashboard/jobs/worker-jobs/jobs/$jobId'
      path: '/$jobId'
      fullPath: '/dashboard/jobs/worker-jobs/jobs/$jobId'
      preLoaderRoute: typeof DashboardJobsWorkerJobsJobsJobIdRouteImport
      parentRoute: typeof DashboardJobsWorkerJobsJobsRouteImport
    }
    '/dashboard/jobs/worker-jobs/schedule/$scheduledJobId': {
      id: '/dashboard/jobs/worker-jobs/schedule/$scheduledJobId'
      path: '/$scheduledJobId'
      fullPath: '/dashboard/jobs/worker-jobs/schedule/$scheduledJobId'
      preLoaderRoute: typeof DashboardJobsWorkerJobsScheduleScheduledJobIdRouteImport
      parentRoute: typeof DashboardJobsWorkerJobsScheduleRouteImport
    }
    '/dashboard/models/$modelId/deployment/clusters': {
      id: '/dashboard/models/$modelId/deployment/clusters'
      path: '/clusters'
      fullPath: '/dashboard/models/$modelId/deployment/clusters'
      preLoaderRoute: typeof DashboardModelsModelIdDeploymentClustersRouteImport
      parentRoute: typeof DashboardModelsModelIdDeploymentRouteImport
    }
    '/dashboard/models/$modelId/deployment/devices': {
      id: '/dashboard/models/$modelId/deployment/devices'
      path: '/devices'
      fullPath: '/dashboard/models/$modelId/deployment/devices'
      preLoaderRoute: typeof DashboardModelsModelIdDeploymentDevicesRouteImport
      parentRoute: typeof DashboardModelsModelIdDeploymentRouteImport
    }
    '/dashboard/resources/clusters/$clusterId/devices': {
      id: '/dashboard/resources/clusters/$clusterId/devices'
      path: '/devices'
      fullPath: '/dashboard/resources/clusters/$clusterId/devices'
      preLoaderRoute: typeof DashboardResourcesClustersClusterIdDevicesRouteImport
      parentRoute: typeof DashboardResourcesClustersClusterIdRouteImport
    }
    '/dashboard/resources/clusters/$clusterId/overview': {
      id: '/dashboard/resources/clusters/$clusterId/overview'
      path: '/overview'
      fullPath: '/dashboard/resources/clusters/$clusterId/overview'
      preLoaderRoute: typeof DashboardResourcesClustersClusterIdOverviewRouteImport
      parentRoute: typeof DashboardResourcesClustersClusterIdRouteImport
    }
    '/dashboard/resources/devices/$deviceId/camera': {
      id: '/dashboard/resources/devices/$deviceId/camera'
      path: '/camera'
      fullPath: '/dashboard/resources/devices/$deviceId/camera'
      preLoaderRoute: typeof DashboardResourcesDevicesDeviceIdCameraRouteImport
      parentRoute: typeof DashboardResourcesDevicesDeviceIdRouteImport
    }
    '/dashboard/resources/devices/$deviceId/data': {
      id: '/dashboard/resources/devices/$deviceId/data'
      path: '/data'
      fullPath: '/dashboard/resources/devices/$deviceId/data'
      preLoaderRoute: typeof DashboardResourcesDevicesDeviceIdDataRouteImport
      parentRoute: typeof DashboardResourcesDevicesDeviceIdRouteImport
    }
    '/dashboard/resources/devices/$deviceId/diagnostics': {
      id: '/dashboard/resources/devices/$deviceId/diagnostics'
      path: '/diagnostics'
      fullPath: '/dashboard/resources/devices/$deviceId/diagnostics'
      preLoaderRoute: typeof DashboardResourcesDevicesDeviceIdDiagnosticsRouteImport
      parentRoute: typeof DashboardResourcesDevicesDeviceIdRouteImport
    }
    '/dashboard/resources/devices/$deviceId/logs': {
      id: '/dashboard/resources/devices/$deviceId/logs'
      path: '/logs'
      fullPath: '/dashboard/resources/devices/$deviceId/logs'
      preLoaderRoute: typeof DashboardResourcesDevicesDeviceIdLogsRouteImport
      parentRoute: typeof DashboardResourcesDevicesDeviceIdRouteImport
    }
    '/dashboard/resources/devices/$deviceId/overview': {
      id: '/dashboard/resources/devices/$deviceId/overview'
      path: '/overview'
      fullPath: '/dashboard/resources/devices/$deviceId/overview'
      preLoaderRoute: typeof DashboardResourcesDevicesDeviceIdOverviewRouteImport
      parentRoute: typeof DashboardResourcesDevicesDeviceIdRouteImport
    }
    '/dashboard/resources/devices/$deviceId/settings': {
      id: '/dashboard/resources/devices/$deviceId/settings'
      path: '/settings'
      fullPath: '/dashboard/resources/devices/$deviceId/settings'
      preLoaderRoute: typeof DashboardResourcesDevicesDeviceIdSettingsRouteImport
      parentRoute: typeof DashboardResourcesDevicesDeviceIdRouteImport
    }
    '/dashboard/resources/devices/$deviceId/version-history': {
      id: '/dashboard/resources/devices/$deviceId/version-history'
      path: '/version-history'
      fullPath: '/dashboard/resources/devices/$deviceId/version-history'
      preLoaderRoute: typeof DashboardResourcesDevicesDeviceIdVersionHistoryRouteImport
      parentRoute: typeof DashboardResourcesDevicesDeviceIdRouteImport
    }
    '/dashboard/resources/site-groups/$siteGroupId/labels': {
      id: '/dashboard/resources/site-groups/$siteGroupId/labels'
      path: '/labels'
      fullPath: '/dashboard/resources/site-groups/$siteGroupId/labels'
      preLoaderRoute: typeof DashboardResourcesSiteGroupsSiteGroupIdLabelsRouteImport
      parentRoute: typeof DashboardResourcesSiteGroupsSiteGroupIdRouteImport
    }
    '/dashboard/resources/site-groups/$siteGroupId/overview': {
      id: '/dashboard/resources/site-groups/$siteGroupId/overview'
      path: '/overview'
      fullPath: '/dashboard/resources/site-groups/$siteGroupId/overview'
      preLoaderRoute: typeof DashboardResourcesSiteGroupsSiteGroupIdOverviewRouteImport
      parentRoute: typeof DashboardResourcesSiteGroupsSiteGroupIdRouteImport
    }
    '/dashboard/resources/site-groups/$siteGroupId/sites': {
      id: '/dashboard/resources/site-groups/$siteGroupId/sites'
      path: '/sites'
      fullPath: '/dashboard/resources/site-groups/$siteGroupId/sites'
      preLoaderRoute: typeof DashboardResourcesSiteGroupsSiteGroupIdSitesRouteImport
      parentRoute: typeof DashboardResourcesSiteGroupsSiteGroupIdRouteImport
    }
    '/dashboard/resources/sites/$siteId/devices': {
      id: '/dashboard/resources/sites/$siteId/devices'
      path: '/devices'
      fullPath: '/dashboard/resources/sites/$siteId/devices'
      preLoaderRoute: typeof DashboardResourcesSitesSiteIdDevicesRouteImport
      parentRoute: typeof DashboardResourcesSitesSiteIdRouteImport
    }
    '/dashboard/resources/sites/$siteId/overview': {
      id: '/dashboard/resources/sites/$siteId/overview'
      path: '/overview'
      fullPath: '/dashboard/resources/sites/$siteId/overview'
      preLoaderRoute: typeof DashboardResourcesSitesSiteIdOverviewRouteImport
      parentRoute: typeof DashboardResourcesSitesSiteIdRouteImport
    }
    '/dashboard/resources/sites/$siteId/version-history': {
      id: '/dashboard/resources/sites/$siteId/version-history'
      path: '/version-history'
      fullPath: '/dashboard/resources/sites/$siteId/version-history'
      preLoaderRoute: typeof DashboardResourcesSitesSiteIdVersionHistoryRouteImport
      parentRoute: typeof DashboardResourcesSitesSiteIdRouteImport
    }
    '/dashboard/settings/alert-management/alerts/$alertId': {
      id: '/dashboard/settings/alert-management/alerts/$alertId'
      path: '/$alertId'
      fullPath: '/dashboard/settings/alert-management/alerts/$alertId'
      preLoaderRoute: typeof DashboardSettingsAlertManagementAlertsAlertIdRouteImport
      parentRoute: typeof DashboardSettingsAlertManagementAlertsRouteImport
    }
    '/dashboard/settings/queues/$queueName/failures': {
      id: '/dashboard/settings/queues/$queueName/failures'
      path: '/failures'
      fullPath: '/dashboard/settings/queues/$queueName/failures'
      preLoaderRoute: typeof DashboardSettingsQueuesQueueNameFailuresRouteImport
      parentRoute: typeof DashboardSettingsQueuesQueueNameRouteImport
    }
    '/dashboard/settings/queues/$queueName/pending': {
      id: '/dashboard/settings/queues/$queueName/pending'
      path: '/pending'
      fullPath: '/dashboard/settings/queues/$queueName/pending'
      preLoaderRoute: typeof DashboardSettingsQueuesQueueNamePendingRouteImport
      parentRoute: typeof DashboardSettingsQueuesQueueNameRouteImport
    }
    '/dashboard/settings/report-settings/$reportId/overview': {
      id: '/dashboard/settings/report-settings/$reportId/overview'
      path: '/overview'
      fullPath: '/dashboard/settings/report-settings/$reportId/overview'
      preLoaderRoute: typeof DashboardSettingsReportSettingsReportIdOverviewRouteImport
      parentRoute: typeof DashboardSettingsReportSettingsReportIdRouteImport
    }
    '/dashboard/settings/report-settings/$reportId/parameters': {
      id: '/dashboard/settings/report-settings/$reportId/parameters'
      path: '/parameters'
      fullPath: '/dashboard/settings/report-settings/$reportId/parameters'
      preLoaderRoute: typeof DashboardSettingsReportSettingsReportIdParametersRouteImport
      parentRoute: typeof DashboardSettingsReportSettingsReportIdRouteImport
    }
    '/dashboard/settings/report-settings/$reportId/send-log': {
      id: '/dashboard/settings/report-settings/$reportId/send-log'
      path: '/send-log'
      fullPath: '/dashboard/settings/report-settings/$reportId/send-log'
      preLoaderRoute: typeof DashboardSettingsReportSettingsReportIdSendLogRouteImport
      parentRoute: typeof DashboardSettingsReportSettingsReportIdRouteImport
    }
    '/dashboard/settings/report-settings/$reportId/subscriptions2': {
      id: '/dashboard/settings/report-settings/$reportId/subscriptions2'
      path: '/subscriptions2'
      fullPath: '/dashboard/settings/report-settings/$reportId/subscriptions2'
      preLoaderRoute: typeof DashboardSettingsReportSettingsReportIdSubscriptions2RouteImport
      parentRoute: typeof DashboardSettingsReportSettingsReportIdRouteImport
    }
    '/dashboard/settings/report-subscription/$reportId/$subscriptionId': {
      id: '/dashboard/settings/report-subscription/$reportId/$subscriptionId'
      path: '/report-subscription/$reportId/$subscriptionId'
      fullPath: '/dashboard/settings/report-subscription/$reportId/$subscriptionId'
      preLoaderRoute: typeof DashboardSettingsReportSubscriptionReportIdSubscriptionIdRouteImport
      parentRoute: typeof DashboardSettingsRouteImport
    }
    '/dashboard/settings/tags-management/catalog/$tagId': {
      id: '/dashboard/settings/tags-management/catalog/$tagId'
      path: '/$tagId'
      fullPath: '/dashboard/settings/tags-management/catalog/$tagId'
      preLoaderRoute: typeof DashboardSettingsTagsManagementCatalogTagIdRouteImport
      parentRoute: typeof DashboardSettingsTagsManagementCatalogRouteImport
    }
    '/dashboard/settings/tags-management/clusters/$tagId': {
      id: '/dashboard/settings/tags-management/clusters/$tagId'
      path: '/$tagId'
      fullPath: '/dashboard/settings/tags-management/clusters/$tagId'
      preLoaderRoute: typeof DashboardSettingsTagsManagementClustersTagIdRouteImport
      parentRoute: typeof DashboardSettingsTagsManagementClustersRouteImport
    }
    '/dashboard/settings/tags-management/devices/$tagId': {
      id: '/dashboard/settings/tags-management/devices/$tagId'
      path: '/$tagId'
      fullPath: '/dashboard/settings/tags-management/devices/$tagId'
      preLoaderRoute: typeof DashboardSettingsTagsManagementDevicesTagIdRouteImport
      parentRoute: typeof DashboardSettingsTagsManagementDevicesRouteImport
    }
    '/dashboard/settings/tags-management/samples/$tagId': {
      id: '/dashboard/settings/tags-management/samples/$tagId'
      path: '/$tagId'
      fullPath: '/dashboard/settings/tags-management/samples/$tagId'
      preLoaderRoute: typeof DashboardSettingsTagsManagementSamplesTagIdRouteImport
      parentRoute: typeof DashboardSettingsTagsManagementSamplesRouteImport
    }
    '/dashboard/settings/tags-management/sessions/$tagId': {
      id: '/dashboard/settings/tags-management/sessions/$tagId'
      path: '/$tagId'
      fullPath: '/dashboard/settings/tags-management/sessions/$tagId'
      preLoaderRoute: typeof DashboardSettingsTagsManagementSessionsTagIdRouteImport
      parentRoute: typeof DashboardSettingsTagsManagementSessionsRouteImport
    }
    '/dashboard/settings/tags-management/sites/$tagId': {
      id: '/dashboard/settings/tags-management/sites/$tagId'
      path: '/$tagId'
      fullPath: '/dashboard/settings/tags-management/sites/$tagId'
      preLoaderRoute: typeof DashboardSettingsTagsManagementSitesTagIdRouteImport
      parentRoute: typeof DashboardSettingsTagsManagementSitesRouteImport
    }
    '/dashboard/settings/user-management/$userId/overview': {
      id: '/dashboard/settings/user-management/$userId/overview'
      path: '/overview'
      fullPath: '/dashboard/settings/user-management/$userId/overview'
      preLoaderRoute: typeof DashboardSettingsUserManagementUserIdOverviewRouteImport
      parentRoute: typeof DashboardSettingsUserManagementUserIdRouteImport
    }
    '/dashboard/data/json-data/$jsonDataUUID/overview': {
      id: '/dashboard/data/json-data/$jsonDataUUID/overview'
      path: '/overview'
      fullPath: '/dashboard/data/json-data/$jsonDataUUID/overview'
      preLoaderRoute: typeof DashboardDataJsonDataJsonDataUUIDOverviewImport
      parentRoute: typeof DashboardDataJsonDataJsonDataUUIDRouteImport
    }
    '/dashboard/data/catalog/$item/': {
      id: '/dashboard/data/catalog/$item/'
      path: '/'
      fullPath: '/dashboard/data/catalog/$item/'
      preLoaderRoute: typeof DashboardDataCatalogItemIndexImport
      parentRoute: typeof DashboardDataCatalogItemRouteImport
    }
    '/dashboard/data/images/$imageUUID/': {
      id: '/dashboard/data/images/$imageUUID/'
      path: '/'
      fullPath: '/dashboard/data/images/$imageUUID/'
      preLoaderRoute: typeof DashboardDataImagesImageUUIDIndexImport
      parentRoute: typeof DashboardDataImagesImageUUIDRouteImport
    }
    '/dashboard/data/json-data/$jsonDataUUID/': {
      id: '/dashboard/data/json-data/$jsonDataUUID/'
      path: '/'
      fullPath: '/dashboard/data/json-data/$jsonDataUUID/'
      preLoaderRoute: typeof DashboardDataJsonDataJsonDataUUIDIndexImport
      parentRoute: typeof DashboardDataJsonDataJsonDataUUIDRouteImport
    }
    '/dashboard/data/label-distribution/$label/': {
      id: '/dashboard/data/label-distribution/$label/'
      path: '/'
      fullPath: '/dashboard/data/label-distribution/$label/'
      preLoaderRoute: typeof DashboardDataLabelDistributionLabelIndexImport
      parentRoute: typeof DashboardDataLabelDistributionLabelRouteImport
    }
    '/dashboard/data/sessions/$sessionId/': {
      id: '/dashboard/data/sessions/$sessionId/'
      path: '/'
      fullPath: '/dashboard/data/sessions/$sessionId/'
      preLoaderRoute: typeof DashboardDataSessionsSessionIdIndexImport
      parentRoute: typeof DashboardDataSessionsSessionIdRouteImport
    }
    '/dashboard/home/manager-report/$sessionId/': {
      id: '/dashboard/home/manager-report/$sessionId/'
      path: '/'
      fullPath: '/dashboard/home/manager-report/$sessionId/'
      preLoaderRoute: typeof DashboardHomeManagerReportSessionIdIndexImport
      parentRoute: typeof DashboardHomeManagerReportSessionIdRouteImport
    }
    '/dashboard/models/$modelId/deployment/': {
      id: '/dashboard/models/$modelId/deployment/'
      path: '/'
      fullPath: '/dashboard/models/$modelId/deployment/'
      preLoaderRoute: typeof DashboardModelsModelIdDeploymentIndexImport
      parentRoute: typeof DashboardModelsModelIdDeploymentRouteImport
    }
    '/dashboard/resources/clusters/$clusterId/': {
      id: '/dashboard/resources/clusters/$clusterId/'
      path: '/'
      fullPath: '/dashboard/resources/clusters/$clusterId/'
      preLoaderRoute: typeof DashboardResourcesClustersClusterIdIndexImport
      parentRoute: typeof DashboardResourcesClustersClusterIdRouteImport
    }
    '/dashboard/resources/devices/$deviceId/': {
      id: '/dashboard/resources/devices/$deviceId/'
      path: '/'
      fullPath: '/dashboard/resources/devices/$deviceId/'
      preLoaderRoute: typeof DashboardResourcesDevicesDeviceIdIndexImport
      parentRoute: typeof DashboardResourcesDevicesDeviceIdRouteImport
    }
    '/dashboard/resources/site-groups/$siteGroupId/': {
      id: '/dashboard/resources/site-groups/$siteGroupId/'
      path: '/'
      fullPath: '/dashboard/resources/site-groups/$siteGroupId/'
      preLoaderRoute: typeof DashboardResourcesSiteGroupsSiteGroupIdIndexImport
      parentRoute: typeof DashboardResourcesSiteGroupsSiteGroupIdRouteImport
    }
    '/dashboard/resources/sites/$siteId/': {
      id: '/dashboard/resources/sites/$siteId/'
      path: '/'
      fullPath: '/dashboard/resources/sites/$siteId/'
      preLoaderRoute: typeof DashboardResourcesSitesSiteIdIndexImport
      parentRoute: typeof DashboardResourcesSitesSiteIdRouteImport
    }
    '/dashboard/settings/queues/$queueName/': {
      id: '/dashboard/settings/queues/$queueName/'
      path: '/'
      fullPath: '/dashboard/settings/queues/$queueName/'
      preLoaderRoute: typeof DashboardSettingsQueuesQueueNameIndexImport
      parentRoute: typeof DashboardSettingsQueuesQueueNameRouteImport
    }
    '/dashboard/settings/report-settings/$reportId/': {
      id: '/dashboard/settings/report-settings/$reportId/'
      path: '/'
      fullPath: '/dashboard/settings/report-settings/$reportId/'
      preLoaderRoute: typeof DashboardSettingsReportSettingsReportIdIndexImport
      parentRoute: typeof DashboardSettingsReportSettingsReportIdRouteImport
    }
    '/dashboard/settings/user-management/$userId/': {
      id: '/dashboard/settings/user-management/$userId/'
      path: '/'
      fullPath: '/dashboard/settings/user-management/$userId/'
      preLoaderRoute: typeof DashboardSettingsUserManagementUserIdIndexImport
      parentRoute: typeof DashboardSettingsUserManagementUserIdRouteImport
    }
    '/admin-dashboard/jobs/service-health-checks/jobs/$jobId/overview': {
      id: '/admin-dashboard/jobs/service-health-checks/jobs/$jobId/overview'
      path: '/overview'
      fullPath: '/admin-dashboard/jobs/service-health-checks/jobs/$jobId/overview'
      preLoaderRoute: typeof AdminDashboardJobsServiceHealthChecksJobsJobIdOverviewRouteImport
      parentRoute: typeof AdminDashboardJobsServiceHealthChecksJobsJobIdRouteImport
    }
    '/admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId/inputs': {
      id: '/admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId/inputs'
      path: '/inputs'
      fullPath: '/admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId/inputs'
      preLoaderRoute: typeof AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdInputsRouteImport
      parentRoute: typeof AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdRouteImport
    }
    '/admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId/overview': {
      id: '/admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId/overview'
      path: '/overview'
      fullPath: '/admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId/overview'
      preLoaderRoute: typeof AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdOverviewRouteImport
      parentRoute: typeof AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdRouteImport
    }
    '/admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId/schedule': {
      id: '/admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId/schedule'
      path: '/schedule'
      fullPath: '/admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId/schedule'
      preLoaderRoute: typeof AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdScheduleRouteImport
      parentRoute: typeof AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdRouteImport
    }
    '/dashboard/jobs/camera-calibration/jobs/$jobId/devices': {
      id: '/dashboard/jobs/camera-calibration/jobs/$jobId/devices'
      path: '/devices'
      fullPath: '/dashboard/jobs/camera-calibration/jobs/$jobId/devices'
      preLoaderRoute: typeof DashboardJobsCameraCalibrationJobsJobIdDevicesRouteImport
      parentRoute: typeof DashboardJobsCameraCalibrationJobsJobIdRouteImport
    }
    '/dashboard/jobs/camera-calibration/jobs/$jobId/overview': {
      id: '/dashboard/jobs/camera-calibration/jobs/$jobId/overview'
      path: '/overview'
      fullPath: '/dashboard/jobs/camera-calibration/jobs/$jobId/overview'
      preLoaderRoute: typeof DashboardJobsCameraCalibrationJobsJobIdOverviewRouteImport
      parentRoute: typeof DashboardJobsCameraCalibrationJobsJobIdRouteImport
    }
    '/dashboard/jobs/camera-calibration/schedule/$scheduledJobId/inputs': {
      id: '/dashboard/jobs/camera-calibration/schedule/$scheduledJobId/inputs'
      path: '/inputs'
      fullPath: '/dashboard/jobs/camera-calibration/schedule/$scheduledJobId/inputs'
      preLoaderRoute: typeof DashboardJobsCameraCalibrationScheduleScheduledJobIdInputsRouteImport
      parentRoute: typeof DashboardJobsCameraCalibrationScheduleScheduledJobIdRouteImport
    }
    '/dashboard/jobs/camera-calibration/schedule/$scheduledJobId/overview': {
      id: '/dashboard/jobs/camera-calibration/schedule/$scheduledJobId/overview'
      path: '/overview'
      fullPath: '/dashboard/jobs/camera-calibration/schedule/$scheduledJobId/overview'
      preLoaderRoute: typeof DashboardJobsCameraCalibrationScheduleScheduledJobIdOverviewRouteImport
      parentRoute: typeof DashboardJobsCameraCalibrationScheduleScheduledJobIdRouteImport
    }
    '/dashboard/jobs/camera-calibration/schedule/$scheduledJobId/schedule': {
      id: '/dashboard/jobs/camera-calibration/schedule/$scheduledJobId/schedule'
      path: '/schedule'
      fullPath: '/dashboard/jobs/camera-calibration/schedule/$scheduledJobId/schedule'
      preLoaderRoute: typeof DashboardJobsCameraCalibrationScheduleScheduledJobIdScheduleRouteImport
      parentRoute: typeof DashboardJobsCameraCalibrationScheduleScheduledJobIdRouteImport
    }
    '/dashboard/jobs/capacity-tagging/jobs/$jobId/overview': {
      id: '/dashboard/jobs/capacity-tagging/jobs/$jobId/overview'
      path: '/overview'
      fullPath: '/dashboard/jobs/capacity-tagging/jobs/$jobId/overview'
      preLoaderRoute: typeof DashboardJobsCapacityTaggingJobsJobIdOverviewRouteImport
      parentRoute: typeof DashboardJobsCapacityTaggingJobsJobIdRouteImport
    }
    '/dashboard/jobs/capacity-tagging/schedule/$scheduledJobId/inputs': {
      id: '/dashboard/jobs/capacity-tagging/schedule/$scheduledJobId/inputs'
      path: '/inputs'
      fullPath: '/dashboard/jobs/capacity-tagging/schedule/$scheduledJobId/inputs'
      preLoaderRoute: typeof DashboardJobsCapacityTaggingScheduleScheduledJobIdInputsRouteImport
      parentRoute: typeof DashboardJobsCapacityTaggingScheduleScheduledJobIdRouteImport
    }
    '/dashboard/jobs/capacity-tagging/schedule/$scheduledJobId/overview': {
      id: '/dashboard/jobs/capacity-tagging/schedule/$scheduledJobId/overview'
      path: '/overview'
      fullPath: '/dashboard/jobs/capacity-tagging/schedule/$scheduledJobId/overview'
      preLoaderRoute: typeof DashboardJobsCapacityTaggingScheduleScheduledJobIdOverviewRouteImport
      parentRoute: typeof DashboardJobsCapacityTaggingScheduleScheduledJobIdRouteImport
    }
    '/dashboard/jobs/capacity-tagging/schedule/$scheduledJobId/schedule': {
      id: '/dashboard/jobs/capacity-tagging/schedule/$scheduledJobId/schedule'
      path: '/schedule'
      fullPath: '/dashboard/jobs/capacity-tagging/schedule/$scheduledJobId/schedule'
      preLoaderRoute: typeof DashboardJobsCapacityTaggingScheduleScheduledJobIdScheduleRouteImport
      parentRoute: typeof DashboardJobsCapacityTaggingScheduleScheduledJobIdRouteImport
    }
    '/dashboard/jobs/catalog-upload/jobs/$jobId/devices': {
      id: '/dashboard/jobs/catalog-upload/jobs/$jobId/devices'
      path: '/devices'
      fullPath: '/dashboard/jobs/catalog-upload/jobs/$jobId/devices'
      preLoaderRoute: typeof DashboardJobsCatalogUploadJobsJobIdDevicesRouteImport
      parentRoute: typeof DashboardJobsCatalogUploadJobsJobIdRouteImport
    }
    '/dashboard/jobs/catalog-upload/jobs/$jobId/labels': {
      id: '/dashboard/jobs/catalog-upload/jobs/$jobId/labels'
      path: '/labels'
      fullPath: '/dashboard/jobs/catalog-upload/jobs/$jobId/labels'
      preLoaderRoute: typeof DashboardJobsCatalogUploadJobsJobIdLabelsRouteImport
      parentRoute: typeof DashboardJobsCatalogUploadJobsJobIdRouteImport
    }
    '/dashboard/jobs/catalog-upload/jobs/$jobId/overview': {
      id: '/dashboard/jobs/catalog-upload/jobs/$jobId/overview'
      path: '/overview'
      fullPath: '/dashboard/jobs/catalog-upload/jobs/$jobId/overview'
      preLoaderRoute: typeof DashboardJobsCatalogUploadJobsJobIdOverviewRouteImport
      parentRoute: typeof DashboardJobsCatalogUploadJobsJobIdRouteImport
    }
    '/dashboard/jobs/catalog-upload/schedule/$scheduledJobId/labels': {
      id: '/dashboard/jobs/catalog-upload/schedule/$scheduledJobId/labels'
      path: '/labels'
      fullPath: '/dashboard/jobs/catalog-upload/schedule/$scheduledJobId/labels'
      preLoaderRoute: typeof DashboardJobsCatalogUploadScheduleScheduledJobIdLabelsRouteImport
      parentRoute: typeof DashboardJobsCatalogUploadScheduleScheduledJobIdRouteImport
    }
    '/dashboard/jobs/catalog-upload/schedule/$scheduledJobId/overview': {
      id: '/dashboard/jobs/catalog-upload/schedule/$scheduledJobId/overview'
      path: '/overview'
      fullPath: '/dashboard/jobs/catalog-upload/schedule/$scheduledJobId/overview'
      preLoaderRoute: typeof DashboardJobsCatalogUploadScheduleScheduledJobIdOverviewRouteImport
      parentRoute: typeof DashboardJobsCatalogUploadScheduleScheduledJobIdRouteImport
    }
    '/dashboard/jobs/catalog-upload/schedule/$scheduledJobId/schedule': {
      id: '/dashboard/jobs/catalog-upload/schedule/$scheduledJobId/schedule'
      path: '/schedule'
      fullPath: '/dashboard/jobs/catalog-upload/schedule/$scheduledJobId/schedule'
      preLoaderRoute: typeof DashboardJobsCatalogUploadScheduleScheduledJobIdScheduleRouteImport
      parentRoute: typeof DashboardJobsCatalogUploadScheduleScheduledJobIdRouteImport
    }
    '/dashboard/jobs/config/jobs/$jobId/devices': {
      id: '/dashboard/jobs/config/jobs/$jobId/devices'
      path: '/devices'
      fullPath: '/dashboard/jobs/config/jobs/$jobId/devices'
      preLoaderRoute: typeof DashboardJobsConfigJobsJobIdDevicesRouteImport
      parentRoute: typeof DashboardJobsConfigJobsJobIdRouteImport
    }
    '/dashboard/jobs/config/jobs/$jobId/overview': {
      id: '/dashboard/jobs/config/jobs/$jobId/overview'
      path: '/overview'
      fullPath: '/dashboard/jobs/config/jobs/$jobId/overview'
      preLoaderRoute: typeof DashboardJobsConfigJobsJobIdOverviewRouteImport
      parentRoute: typeof DashboardJobsConfigJobsJobIdRouteImport
    }
    '/dashboard/jobs/config/schedule/$scheduledJobId/overview': {
      id: '/dashboard/jobs/config/schedule/$scheduledJobId/overview'
      path: '/overview'
      fullPath: '/dashboard/jobs/config/schedule/$scheduledJobId/overview'
      preLoaderRoute: typeof DashboardJobsConfigScheduleScheduledJobIdOverviewRouteImport
      parentRoute: typeof DashboardJobsConfigScheduleScheduledJobIdRouteImport
    }
    '/dashboard/jobs/config/schedule/$scheduledJobId/schedule': {
      id: '/dashboard/jobs/config/schedule/$scheduledJobId/schedule'
      path: '/schedule'
      fullPath: '/dashboard/jobs/config/schedule/$scheduledJobId/schedule'
      preLoaderRoute: typeof DashboardJobsConfigScheduleScheduledJobIdScheduleRouteImport
      parentRoute: typeof DashboardJobsConfigScheduleScheduledJobIdRouteImport
    }
    '/dashboard/jobs/delete-samples/jobs/$jobId/devices': {
      id: '/dashboard/jobs/delete-samples/jobs/$jobId/devices'
      path: '/devices'
      fullPath: '/dashboard/jobs/delete-samples/jobs/$jobId/devices'
      preLoaderRoute: typeof DashboardJobsDeleteSamplesJobsJobIdDevicesRouteImport
      parentRoute: typeof DashboardJobsDeleteSamplesJobsJobIdRouteImport
    }
    '/dashboard/jobs/delete-samples/jobs/$jobId/overview': {
      id: '/dashboard/jobs/delete-samples/jobs/$jobId/overview'
      path: '/overview'
      fullPath: '/dashboard/jobs/delete-samples/jobs/$jobId/overview'
      preLoaderRoute: typeof DashboardJobsDeleteSamplesJobsJobIdOverviewRouteImport
      parentRoute: typeof DashboardJobsDeleteSamplesJobsJobIdRouteImport
    }
    '/dashboard/jobs/delete-samples/schedule/$scheduledJobId/inputs': {
      id: '/dashboard/jobs/delete-samples/schedule/$scheduledJobId/inputs'
      path: '/inputs'
      fullPath: '/dashboard/jobs/delete-samples/schedule/$scheduledJobId/inputs'
      preLoaderRoute: typeof DashboardJobsDeleteSamplesScheduleScheduledJobIdInputsRouteImport
      parentRoute: typeof DashboardJobsDeleteSamplesScheduleScheduledJobIdRouteImport
    }
    '/dashboard/jobs/delete-samples/schedule/$scheduledJobId/overview': {
      id: '/dashboard/jobs/delete-samples/schedule/$scheduledJobId/overview'
      path: '/overview'
      fullPath: '/dashboard/jobs/delete-samples/schedule/$scheduledJobId/overview'
      preLoaderRoute: typeof DashboardJobsDeleteSamplesScheduleScheduledJobIdOverviewRouteImport
      parentRoute: typeof DashboardJobsDeleteSamplesScheduleScheduledJobIdRouteImport
    }
    '/dashboard/jobs/delete-samples/schedule/$scheduledJobId/schedule': {
      id: '/dashboard/jobs/delete-samples/schedule/$scheduledJobId/schedule'
      path: '/schedule'
      fullPath: '/dashboard/jobs/delete-samples/schedule/$scheduledJobId/schedule'
      preLoaderRoute: typeof DashboardJobsDeleteSamplesScheduleScheduledJobIdScheduleRouteImport
      parentRoute: typeof DashboardJobsDeleteSamplesScheduleScheduledJobIdRouteImport
    }
    '/dashboard/jobs/delete-videos/jobs/$jobId/devices': {
      id: '/dashboard/jobs/delete-videos/jobs/$jobId/devices'
      path: '/devices'
      fullPath: '/dashboard/jobs/delete-videos/jobs/$jobId/devices'
      preLoaderRoute: typeof DashboardJobsDeleteVideosJobsJobIdDevicesRouteImport
      parentRoute: typeof DashboardJobsDeleteVideosJobsJobIdRouteImport
    }
    '/dashboard/jobs/delete-videos/jobs/$jobId/overview': {
      id: '/dashboard/jobs/delete-videos/jobs/$jobId/overview'
      path: '/overview'
      fullPath: '/dashboard/jobs/delete-videos/jobs/$jobId/overview'
      preLoaderRoute: typeof DashboardJobsDeleteVideosJobsJobIdOverviewRouteImport
      parentRoute: typeof DashboardJobsDeleteVideosJobsJobIdRouteImport
    }
    '/dashboard/jobs/delete-videos/schedule/$scheduledJobId/inputs': {
      id: '/dashboard/jobs/delete-videos/schedule/$scheduledJobId/inputs'
      path: '/inputs'
      fullPath: '/dashboard/jobs/delete-videos/schedule/$scheduledJobId/inputs'
      preLoaderRoute: typeof DashboardJobsDeleteVideosScheduleScheduledJobIdInputsRouteImport
      parentRoute: typeof DashboardJobsDeleteVideosScheduleScheduledJobIdRouteImport
    }
    '/dashboard/jobs/delete-videos/schedule/$scheduledJobId/overview': {
      id: '/dashboard/jobs/delete-videos/schedule/$scheduledJobId/overview'
      path: '/overview'
      fullPath: '/dashboard/jobs/delete-videos/schedule/$scheduledJobId/overview'
      preLoaderRoute: typeof DashboardJobsDeleteVideosScheduleScheduledJobIdOverviewRouteImport
      parentRoute: typeof DashboardJobsDeleteVideosScheduleScheduledJobIdRouteImport
    }
    '/dashboard/jobs/delete-videos/schedule/$scheduledJobId/schedule': {
      id: '/dashboard/jobs/delete-videos/schedule/$scheduledJobId/schedule'
      path: '/schedule'
      fullPath: '/dashboard/jobs/delete-videos/schedule/$scheduledJobId/schedule'
      preLoaderRoute: typeof DashboardJobsDeleteVideosScheduleScheduledJobIdScheduleRouteImport
      parentRoute: typeof DashboardJobsDeleteVideosScheduleScheduledJobIdRouteImport
    }
    '/dashboard/jobs/deployments/jobs/$jobId/devices': {
      id: '/dashboard/jobs/deployments/jobs/$jobId/devices'
      path: '/devices'
      fullPath: '/dashboard/jobs/deployments/jobs/$jobId/devices'
      preLoaderRoute: typeof DashboardJobsDeploymentsJobsJobIdDevicesRouteImport
      parentRoute: typeof DashboardJobsDeploymentsJobsJobIdRouteImport
    }
    '/dashboard/jobs/deployments/jobs/$jobId/overview': {
      id: '/dashboard/jobs/deployments/jobs/$jobId/overview'
      path: '/overview'
      fullPath: '/dashboard/jobs/deployments/jobs/$jobId/overview'
      preLoaderRoute: typeof DashboardJobsDeploymentsJobsJobIdOverviewRouteImport
      parentRoute: typeof DashboardJobsDeploymentsJobsJobIdRouteImport
    }
    '/dashboard/jobs/deployments/schedule/$scheduledJobId/overview': {
      id: '/dashboard/jobs/deployments/schedule/$scheduledJobId/overview'
      path: '/overview'
      fullPath: '/dashboard/jobs/deployments/schedule/$scheduledJobId/overview'
      preLoaderRoute: typeof DashboardJobsDeploymentsScheduleScheduledJobIdOverviewRouteImport
      parentRoute: typeof DashboardJobsDeploymentsScheduleScheduledJobIdRouteImport
    }
    '/dashboard/jobs/deployments/schedule/$scheduledJobId/schedule': {
      id: '/dashboard/jobs/deployments/schedule/$scheduledJobId/schedule'
      path: '/schedule'
      fullPath: '/dashboard/jobs/deployments/schedule/$scheduledJobId/schedule'
      preLoaderRoute: typeof DashboardJobsDeploymentsScheduleScheduledJobIdScheduleRouteImport
      parentRoute: typeof DashboardJobsDeploymentsScheduleScheduledJobIdRouteImport
    }
    '/dashboard/jobs/head-blur-images/jobs/$jobId/devices': {
      id: '/dashboard/jobs/head-blur-images/jobs/$jobId/devices'
      path: '/devices'
      fullPath: '/dashboard/jobs/head-blur-images/jobs/$jobId/devices'
      preLoaderRoute: typeof DashboardJobsHeadBlurImagesJobsJobIdDevicesRouteImport
      parentRoute: typeof DashboardJobsHeadBlurImagesJobsJobIdRouteImport
    }
    '/dashboard/jobs/head-blur-images/jobs/$jobId/overview': {
      id: '/dashboard/jobs/head-blur-images/jobs/$jobId/overview'
      path: '/overview'
      fullPath: '/dashboard/jobs/head-blur-images/jobs/$jobId/overview'
      preLoaderRoute: typeof DashboardJobsHeadBlurImagesJobsJobIdOverviewRouteImport
      parentRoute: typeof DashboardJobsHeadBlurImagesJobsJobIdRouteImport
    }
    '/dashboard/jobs/head-blur-images/schedule/$scheduledJobId/inputs': {
      id: '/dashboard/jobs/head-blur-images/schedule/$scheduledJobId/inputs'
      path: '/inputs'
      fullPath: '/dashboard/jobs/head-blur-images/schedule/$scheduledJobId/inputs'
      preLoaderRoute: typeof DashboardJobsHeadBlurImagesScheduleScheduledJobIdInputsRouteImport
      parentRoute: typeof DashboardJobsHeadBlurImagesScheduleScheduledJobIdRouteImport
    }
    '/dashboard/jobs/head-blur-images/schedule/$scheduledJobId/overview': {
      id: '/dashboard/jobs/head-blur-images/schedule/$scheduledJobId/overview'
      path: '/overview'
      fullPath: '/dashboard/jobs/head-blur-images/schedule/$scheduledJobId/overview'
      preLoaderRoute: typeof DashboardJobsHeadBlurImagesScheduleScheduledJobIdOverviewRouteImport
      parentRoute: typeof DashboardJobsHeadBlurImagesScheduleScheduledJobIdRouteImport
    }
    '/dashboard/jobs/head-blur-images/schedule/$scheduledJobId/schedule': {
      id: '/dashboard/jobs/head-blur-images/schedule/$scheduledJobId/schedule'
      path: '/schedule'
      fullPath: '/dashboard/jobs/head-blur-images/schedule/$scheduledJobId/schedule'
      preLoaderRoute: typeof DashboardJobsHeadBlurImagesScheduleScheduledJobIdScheduleRouteImport
      parentRoute: typeof DashboardJobsHeadBlurImagesScheduleScheduledJobIdRouteImport
    }
    '/dashboard/jobs/head-blur-videos/jobs/$jobId/devices': {
      id: '/dashboard/jobs/head-blur-videos/jobs/$jobId/devices'
      path: '/devices'
      fullPath: '/dashboard/jobs/head-blur-videos/jobs/$jobId/devices'
      preLoaderRoute: typeof DashboardJobsHeadBlurVideosJobsJobIdDevicesRouteImport
      parentRoute: typeof DashboardJobsHeadBlurVideosJobsJobIdRouteImport
    }
    '/dashboard/jobs/head-blur-videos/jobs/$jobId/overview': {
      id: '/dashboard/jobs/head-blur-videos/jobs/$jobId/overview'
      path: '/overview'
      fullPath: '/dashboard/jobs/head-blur-videos/jobs/$jobId/overview'
      preLoaderRoute: typeof DashboardJobsHeadBlurVideosJobsJobIdOverviewRouteImport
      parentRoute: typeof DashboardJobsHeadBlurVideosJobsJobIdRouteImport
    }
    '/dashboard/jobs/head-blur-videos/schedule/$scheduledJobId/inputs': {
      id: '/dashboard/jobs/head-blur-videos/schedule/$scheduledJobId/inputs'
      path: '/inputs'
      fullPath: '/dashboard/jobs/head-blur-videos/schedule/$scheduledJobId/inputs'
      preLoaderRoute: typeof DashboardJobsHeadBlurVideosScheduleScheduledJobIdInputsRouteImport
      parentRoute: typeof DashboardJobsHeadBlurVideosScheduleScheduledJobIdRouteImport
    }
    '/dashboard/jobs/head-blur-videos/schedule/$scheduledJobId/overview': {
      id: '/dashboard/jobs/head-blur-videos/schedule/$scheduledJobId/overview'
      path: '/overview'
      fullPath: '/dashboard/jobs/head-blur-videos/schedule/$scheduledJobId/overview'
      preLoaderRoute: typeof DashboardJobsHeadBlurVideosScheduleScheduledJobIdOverviewRouteImport
      parentRoute: typeof DashboardJobsHeadBlurVideosScheduleScheduledJobIdRouteImport
    }
    '/dashboard/jobs/head-blur-videos/schedule/$scheduledJobId/schedule': {
      id: '/dashboard/jobs/head-blur-videos/schedule/$scheduledJobId/schedule'
      path: '/schedule'
      fullPath: '/dashboard/jobs/head-blur-videos/schedule/$scheduledJobId/schedule'
      preLoaderRoute: typeof DashboardJobsHeadBlurVideosScheduleScheduledJobIdScheduleRouteImport
      parentRoute: typeof DashboardJobsHeadBlurVideosScheduleScheduledJobIdRouteImport
    }
    '/dashboard/jobs/models/jobs/$jobId/devices': {
      id: '/dashboard/jobs/models/jobs/$jobId/devices'
      path: '/devices'
      fullPath: '/dashboard/jobs/models/jobs/$jobId/devices'
      preLoaderRoute: typeof DashboardJobsModelsJobsJobIdDevicesRouteImport
      parentRoute: typeof DashboardJobsModelsJobsJobIdRouteImport
    }
    '/dashboard/jobs/models/jobs/$jobId/overview': {
      id: '/dashboard/jobs/models/jobs/$jobId/overview'
      path: '/overview'
      fullPath: '/dashboard/jobs/models/jobs/$jobId/overview'
      preLoaderRoute: typeof DashboardJobsModelsJobsJobIdOverviewRouteImport
      parentRoute: typeof DashboardJobsModelsJobsJobIdRouteImport
    }
    '/dashboard/jobs/models/schedule/$scheduledJobId/overview': {
      id: '/dashboard/jobs/models/schedule/$scheduledJobId/overview'
      path: '/overview'
      fullPath: '/dashboard/jobs/models/schedule/$scheduledJobId/overview'
      preLoaderRoute: typeof DashboardJobsModelsScheduleScheduledJobIdOverviewRouteImport
      parentRoute: typeof DashboardJobsModelsScheduleScheduledJobIdRouteImport
    }
    '/dashboard/jobs/models/schedule/$scheduledJobId/schedule': {
      id: '/dashboard/jobs/models/schedule/$scheduledJobId/schedule'
      path: '/schedule'
      fullPath: '/dashboard/jobs/models/schedule/$scheduledJobId/schedule'
      preLoaderRoute: typeof DashboardJobsModelsScheduleScheduledJobIdScheduleRouteImport
      parentRoute: typeof DashboardJobsModelsScheduleScheduledJobIdRouteImport
    }
    '/dashboard/jobs/recovery-estimates/jobs/$jobId/overview': {
      id: '/dashboard/jobs/recovery-estimates/jobs/$jobId/overview'
      path: '/overview'
      fullPath: '/dashboard/jobs/recovery-estimates/jobs/$jobId/overview'
      preLoaderRoute: typeof DashboardJobsRecoveryEstimatesJobsJobIdOverviewRouteImport
      parentRoute: typeof DashboardJobsRecoveryEstimatesJobsJobIdRouteImport
    }
    '/dashboard/jobs/recovery-estimates/schedule/$scheduledJobId/inputs': {
      id: '/dashboard/jobs/recovery-estimates/schedule/$scheduledJobId/inputs'
      path: '/inputs'
      fullPath: '/dashboard/jobs/recovery-estimates/schedule/$scheduledJobId/inputs'
      preLoaderRoute: typeof DashboardJobsRecoveryEstimatesScheduleScheduledJobIdInputsRouteImport
      parentRoute: typeof DashboardJobsRecoveryEstimatesScheduleScheduledJobIdRouteImport
    }
    '/dashboard/jobs/recovery-estimates/schedule/$scheduledJobId/overview': {
      id: '/dashboard/jobs/recovery-estimates/schedule/$scheduledJobId/overview'
      path: '/overview'
      fullPath: '/dashboard/jobs/recovery-estimates/schedule/$scheduledJobId/overview'
      preLoaderRoute: typeof DashboardJobsRecoveryEstimatesScheduleScheduledJobIdOverviewRouteImport
      parentRoute: typeof DashboardJobsRecoveryEstimatesScheduleScheduledJobIdRouteImport
    }
    '/dashboard/jobs/recovery-estimates/schedule/$scheduledJobId/schedule': {
      id: '/dashboard/jobs/recovery-estimates/schedule/$scheduledJobId/schedule'
      path: '/schedule'
      fullPath: '/dashboard/jobs/recovery-estimates/schedule/$scheduledJobId/schedule'
      preLoaderRoute: typeof DashboardJobsRecoveryEstimatesScheduleScheduledJobIdScheduleRouteImport
      parentRoute: typeof DashboardJobsRecoveryEstimatesScheduleScheduledJobIdRouteImport
    }
    '/dashboard/jobs/restarts/jobs/$jobId/devices': {
      id: '/dashboard/jobs/restarts/jobs/$jobId/devices'
      path: '/devices'
      fullPath: '/dashboard/jobs/restarts/jobs/$jobId/devices'
      preLoaderRoute: typeof DashboardJobsRestartsJobsJobIdDevicesRouteImport
      parentRoute: typeof DashboardJobsRestartsJobsJobIdRouteImport
    }
    '/dashboard/jobs/restarts/jobs/$jobId/overview': {
      id: '/dashboard/jobs/restarts/jobs/$jobId/overview'
      path: '/overview'
      fullPath: '/dashboard/jobs/restarts/jobs/$jobId/overview'
      preLoaderRoute: typeof DashboardJobsRestartsJobsJobIdOverviewRouteImport
      parentRoute: typeof DashboardJobsRestartsJobsJobIdRouteImport
    }
    '/dashboard/jobs/restarts/schedule/$scheduledJobId/overview': {
      id: '/dashboard/jobs/restarts/schedule/$scheduledJobId/overview'
      path: '/overview'
      fullPath: '/dashboard/jobs/restarts/schedule/$scheduledJobId/overview'
      preLoaderRoute: typeof DashboardJobsRestartsScheduleScheduledJobIdOverviewRouteImport
      parentRoute: typeof DashboardJobsRestartsScheduleScheduledJobIdRouteImport
    }
    '/dashboard/jobs/restarts/schedule/$scheduledJobId/schedule': {
      id: '/dashboard/jobs/restarts/schedule/$scheduledJobId/schedule'
      path: '/schedule'
      fullPath: '/dashboard/jobs/restarts/schedule/$scheduledJobId/schedule'
      preLoaderRoute: typeof DashboardJobsRestartsScheduleScheduledJobIdScheduleRouteImport
      parentRoute: typeof DashboardJobsRestartsScheduleScheduledJobIdRouteImport
    }
    '/dashboard/jobs/sample-upload/jobs/$jobId/devices': {
      id: '/dashboard/jobs/sample-upload/jobs/$jobId/devices'
      path: '/devices'
      fullPath: '/dashboard/jobs/sample-upload/jobs/$jobId/devices'
      preLoaderRoute: typeof DashboardJobsSampleUploadJobsJobIdDevicesRouteImport
      parentRoute: typeof DashboardJobsSampleUploadJobsJobIdRouteImport
    }
    '/dashboard/jobs/sample-upload/jobs/$jobId/overview': {
      id: '/dashboard/jobs/sample-upload/jobs/$jobId/overview'
      path: '/overview'
      fullPath: '/dashboard/jobs/sample-upload/jobs/$jobId/overview'
      preLoaderRoute: typeof DashboardJobsSampleUploadJobsJobIdOverviewRouteImport
      parentRoute: typeof DashboardJobsSampleUploadJobsJobIdRouteImport
    }
    '/dashboard/jobs/sample-upload/schedule/$scheduledJobId/inputs': {
      id: '/dashboard/jobs/sample-upload/schedule/$scheduledJobId/inputs'
      path: '/inputs'
      fullPath: '/dashboard/jobs/sample-upload/schedule/$scheduledJobId/inputs'
      preLoaderRoute: typeof DashboardJobsSampleUploadScheduleScheduledJobIdInputsRouteImport
      parentRoute: typeof DashboardJobsSampleUploadScheduleScheduledJobIdRouteImport
    }
    '/dashboard/jobs/sample-upload/schedule/$scheduledJobId/overview': {
      id: '/dashboard/jobs/sample-upload/schedule/$scheduledJobId/overview'
      path: '/overview'
      fullPath: '/dashboard/jobs/sample-upload/schedule/$scheduledJobId/overview'
      preLoaderRoute: typeof DashboardJobsSampleUploadScheduleScheduledJobIdOverviewRouteImport
      parentRoute: typeof DashboardJobsSampleUploadScheduleScheduledJobIdRouteImport
    }
    '/dashboard/jobs/sample-upload/schedule/$scheduledJobId/schedule': {
      id: '/dashboard/jobs/sample-upload/schedule/$scheduledJobId/schedule'
      path: '/schedule'
      fullPath: '/dashboard/jobs/sample-upload/schedule/$scheduledJobId/schedule'
      preLoaderRoute: typeof DashboardJobsSampleUploadScheduleScheduledJobIdScheduleRouteImport
      parentRoute: typeof DashboardJobsSampleUploadScheduleScheduledJobIdRouteImport
    }
    '/dashboard/jobs/sync-samples/jobs/$jobId/devices': {
      id: '/dashboard/jobs/sync-samples/jobs/$jobId/devices'
      path: '/devices'
      fullPath: '/dashboard/jobs/sync-samples/jobs/$jobId/devices'
      preLoaderRoute: typeof DashboardJobsSyncSamplesJobsJobIdDevicesRouteImport
      parentRoute: typeof DashboardJobsSyncSamplesJobsJobIdRouteImport
    }
    '/dashboard/jobs/sync-samples/jobs/$jobId/overview': {
      id: '/dashboard/jobs/sync-samples/jobs/$jobId/overview'
      path: '/overview'
      fullPath: '/dashboard/jobs/sync-samples/jobs/$jobId/overview'
      preLoaderRoute: typeof DashboardJobsSyncSamplesJobsJobIdOverviewRouteImport
      parentRoute: typeof DashboardJobsSyncSamplesJobsJobIdRouteImport
    }
    '/dashboard/jobs/sync-samples/schedule/$scheduledJobId/inputs': {
      id: '/dashboard/jobs/sync-samples/schedule/$scheduledJobId/inputs'
      path: '/inputs'
      fullPath: '/dashboard/jobs/sync-samples/schedule/$scheduledJobId/inputs'
      preLoaderRoute: typeof DashboardJobsSyncSamplesScheduleScheduledJobIdInputsRouteImport
      parentRoute: typeof DashboardJobsSyncSamplesScheduleScheduledJobIdRouteImport
    }
    '/dashboard/jobs/sync-samples/schedule/$scheduledJobId/overview': {
      id: '/dashboard/jobs/sync-samples/schedule/$scheduledJobId/overview'
      path: '/overview'
      fullPath: '/dashboard/jobs/sync-samples/schedule/$scheduledJobId/overview'
      preLoaderRoute: typeof DashboardJobsSyncSamplesScheduleScheduledJobIdOverviewRouteImport
      parentRoute: typeof DashboardJobsSyncSamplesScheduleScheduledJobIdRouteImport
    }
    '/dashboard/jobs/sync-samples/schedule/$scheduledJobId/schedule': {
      id: '/dashboard/jobs/sync-samples/schedule/$scheduledJobId/schedule'
      path: '/schedule'
      fullPath: '/dashboard/jobs/sync-samples/schedule/$scheduledJobId/schedule'
      preLoaderRoute: typeof DashboardJobsSyncSamplesScheduleScheduledJobIdScheduleRouteImport
      parentRoute: typeof DashboardJobsSyncSamplesScheduleScheduledJobIdRouteImport
    }
    '/dashboard/jobs/training/jobs/$jobId/devices': {
      id: '/dashboard/jobs/training/jobs/$jobId/devices'
      path: '/devices'
      fullPath: '/dashboard/jobs/training/jobs/$jobId/devices'
      preLoaderRoute: typeof DashboardJobsTrainingJobsJobIdDevicesRouteImport
      parentRoute: typeof DashboardJobsTrainingJobsJobIdRouteImport
    }
    '/dashboard/jobs/training/jobs/$jobId/labels': {
      id: '/dashboard/jobs/training/jobs/$jobId/labels'
      path: '/labels'
      fullPath: '/dashboard/jobs/training/jobs/$jobId/labels'
      preLoaderRoute: typeof DashboardJobsTrainingJobsJobIdLabelsRouteImport
      parentRoute: typeof DashboardJobsTrainingJobsJobIdRouteImport
    }
    '/dashboard/jobs/training/jobs/$jobId/metrics': {
      id: '/dashboard/jobs/training/jobs/$jobId/metrics'
      path: '/metrics'
      fullPath: '/dashboard/jobs/training/jobs/$jobId/metrics'
      preLoaderRoute: typeof DashboardJobsTrainingJobsJobIdMetricsRouteImport
      parentRoute: typeof DashboardJobsTrainingJobsJobIdRouteImport
    }
    '/dashboard/jobs/training/jobs/$jobId/overview': {
      id: '/dashboard/jobs/training/jobs/$jobId/overview'
      path: '/overview'
      fullPath: '/dashboard/jobs/training/jobs/$jobId/overview'
      preLoaderRoute: typeof DashboardJobsTrainingJobsJobIdOverviewRouteImport
      parentRoute: typeof DashboardJobsTrainingJobsJobIdRouteImport
    }
    '/dashboard/jobs/training/schedule/$scheduledJobId/inputs': {
      id: '/dashboard/jobs/training/schedule/$scheduledJobId/inputs'
      path: '/inputs'
      fullPath: '/dashboard/jobs/training/schedule/$scheduledJobId/inputs'
      preLoaderRoute: typeof DashboardJobsTrainingScheduleScheduledJobIdInputsRouteImport
      parentRoute: typeof DashboardJobsTrainingScheduleScheduledJobIdRouteImport
    }
    '/dashboard/jobs/training/schedule/$scheduledJobId/overview': {
      id: '/dashboard/jobs/training/schedule/$scheduledJobId/overview'
      path: '/overview'
      fullPath: '/dashboard/jobs/training/schedule/$scheduledJobId/overview'
      preLoaderRoute: typeof DashboardJobsTrainingScheduleScheduledJobIdOverviewRouteImport
      parentRoute: typeof DashboardJobsTrainingScheduleScheduledJobIdRouteImport
    }
    '/dashboard/jobs/training/schedule/$scheduledJobId/schedule': {
      id: '/dashboard/jobs/training/schedule/$scheduledJobId/schedule'
      path: '/schedule'
      fullPath: '/dashboard/jobs/training/schedule/$scheduledJobId/schedule'
      preLoaderRoute: typeof DashboardJobsTrainingScheduleScheduledJobIdScheduleRouteImport
      parentRoute: typeof DashboardJobsTrainingScheduleScheduledJobIdRouteImport
    }
    '/dashboard/jobs/video-upload/jobs/$jobId/devices': {
      id: '/dashboard/jobs/video-upload/jobs/$jobId/devices'
      path: '/devices'
      fullPath: '/dashboard/jobs/video-upload/jobs/$jobId/devices'
      preLoaderRoute: typeof DashboardJobsVideoUploadJobsJobIdDevicesRouteImport
      parentRoute: typeof DashboardJobsVideoUploadJobsJobIdRouteImport
    }
    '/dashboard/jobs/video-upload/jobs/$jobId/overview': {
      id: '/dashboard/jobs/video-upload/jobs/$jobId/overview'
      path: '/overview'
      fullPath: '/dashboard/jobs/video-upload/jobs/$jobId/overview'
      preLoaderRoute: typeof DashboardJobsVideoUploadJobsJobIdOverviewRouteImport
      parentRoute: typeof DashboardJobsVideoUploadJobsJobIdRouteImport
    }
    '/dashboard/jobs/video-upload/schedule/$scheduledJobId/inputs': {
      id: '/dashboard/jobs/video-upload/schedule/$scheduledJobId/inputs'
      path: '/inputs'
      fullPath: '/dashboard/jobs/video-upload/schedule/$scheduledJobId/inputs'
      preLoaderRoute: typeof DashboardJobsVideoUploadScheduleScheduledJobIdInputsRouteImport
      parentRoute: typeof DashboardJobsVideoUploadScheduleScheduledJobIdRouteImport
    }
    '/dashboard/jobs/video-upload/schedule/$scheduledJobId/overview': {
      id: '/dashboard/jobs/video-upload/schedule/$scheduledJobId/overview'
      path: '/overview'
      fullPath: '/dashboard/jobs/video-upload/schedule/$scheduledJobId/overview'
      preLoaderRoute: typeof DashboardJobsVideoUploadScheduleScheduledJobIdOverviewRouteImport
      parentRoute: typeof DashboardJobsVideoUploadScheduleScheduledJobIdRouteImport
    }
    '/dashboard/jobs/video-upload/schedule/$scheduledJobId/schedule': {
      id: '/dashboard/jobs/video-upload/schedule/$scheduledJobId/schedule'
      path: '/schedule'
      fullPath: '/dashboard/jobs/video-upload/schedule/$scheduledJobId/schedule'
      preLoaderRoute: typeof DashboardJobsVideoUploadScheduleScheduledJobIdScheduleRouteImport
      parentRoute: typeof DashboardJobsVideoUploadScheduleScheduledJobIdRouteImport
    }
    '/dashboard/jobs/worker-jobs/jobs/$jobId/devices': {
      id: '/dashboard/jobs/worker-jobs/jobs/$jobId/devices'
      path: '/devices'
      fullPath: '/dashboard/jobs/worker-jobs/jobs/$jobId/devices'
      preLoaderRoute: typeof DashboardJobsWorkerJobsJobsJobIdDevicesRouteImport
      parentRoute: typeof DashboardJobsWorkerJobsJobsJobIdRouteImport
    }
    '/dashboard/jobs/worker-jobs/jobs/$jobId/overview': {
      id: '/dashboard/jobs/worker-jobs/jobs/$jobId/overview'
      path: '/overview'
      fullPath: '/dashboard/jobs/worker-jobs/jobs/$jobId/overview'
      preLoaderRoute: typeof DashboardJobsWorkerJobsJobsJobIdOverviewRouteImport
      parentRoute: typeof DashboardJobsWorkerJobsJobsJobIdRouteImport
    }
    '/dashboard/jobs/worker-jobs/schedule/$scheduledJobId/inputs': {
      id: '/dashboard/jobs/worker-jobs/schedule/$scheduledJobId/inputs'
      path: '/inputs'
      fullPath: '/dashboard/jobs/worker-jobs/schedule/$scheduledJobId/inputs'
      preLoaderRoute: typeof DashboardJobsWorkerJobsScheduleScheduledJobIdInputsRouteImport
      parentRoute: typeof DashboardJobsWorkerJobsScheduleScheduledJobIdRouteImport
    }
    '/dashboard/jobs/worker-jobs/schedule/$scheduledJobId/overview': {
      id: '/dashboard/jobs/worker-jobs/schedule/$scheduledJobId/overview'
      path: '/overview'
      fullPath: '/dashboard/jobs/worker-jobs/schedule/$scheduledJobId/overview'
      preLoaderRoute: typeof DashboardJobsWorkerJobsScheduleScheduledJobIdOverviewRouteImport
      parentRoute: typeof DashboardJobsWorkerJobsScheduleScheduledJobIdRouteImport
    }
    '/dashboard/jobs/worker-jobs/schedule/$scheduledJobId/schedule': {
      id: '/dashboard/jobs/worker-jobs/schedule/$scheduledJobId/schedule'
      path: '/schedule'
      fullPath: '/dashboard/jobs/worker-jobs/schedule/$scheduledJobId/schedule'
      preLoaderRoute: typeof DashboardJobsWorkerJobsScheduleScheduledJobIdScheduleRouteImport
      parentRoute: typeof DashboardJobsWorkerJobsScheduleScheduledJobIdRouteImport
    }
    '/dashboard/resources/devices/$deviceId/data/samples': {
      id: '/dashboard/resources/devices/$deviceId/data/samples'
      path: '/samples'
      fullPath: '/dashboard/resources/devices/$deviceId/data/samples'
      preLoaderRoute: typeof DashboardResourcesDevicesDeviceIdDataSamplesRouteImport
      parentRoute: typeof DashboardResourcesDevicesDeviceIdDataRouteImport
    }
    '/dashboard/resources/devices/$deviceId/data/sessions': {
      id: '/dashboard/resources/devices/$deviceId/data/sessions'
      path: '/sessions'
      fullPath: '/dashboard/resources/devices/$deviceId/data/sessions'
      preLoaderRoute: typeof DashboardResourcesDevicesDeviceIdDataSessionsRouteImport
      parentRoute: typeof DashboardResourcesDevicesDeviceIdDataRouteImport
    }
    '/dashboard/resources/devices/$deviceId/data/text-json': {
      id: '/dashboard/resources/devices/$deviceId/data/text-json'
      path: '/text-json'
      fullPath: '/dashboard/resources/devices/$deviceId/data/text-json'
      preLoaderRoute: typeof DashboardResourcesDevicesDeviceIdDataTextJsonRouteImport
      parentRoute: typeof DashboardResourcesDevicesDeviceIdDataRouteImport
    }
    '/dashboard/resources/devices/$deviceId/diagnostics/classifier': {
      id: '/dashboard/resources/devices/$deviceId/diagnostics/classifier'
      path: '/classifier'
      fullPath: '/dashboard/resources/devices/$deviceId/diagnostics/classifier'
      preLoaderRoute: typeof DashboardResourcesDevicesDeviceIdDiagnosticsClassifierRouteImport
      parentRoute: typeof DashboardResourcesDevicesDeviceIdDiagnosticsRouteImport
    }
    '/dashboard/resources/devices/$deviceId/diagnostics/custom': {
      id: '/dashboard/resources/devices/$deviceId/diagnostics/custom'
      path: '/custom'
      fullPath: '/dashboard/resources/devices/$deviceId/diagnostics/custom'
      preLoaderRoute: typeof DashboardResourcesDevicesDeviceIdDiagnosticsCustomRouteImport
      parentRoute: typeof DashboardResourcesDevicesDeviceIdDiagnosticsRouteImport
    }
    '/dashboard/resources/devices/$deviceId/diagnostics/object-detection': {
      id: '/dashboard/resources/devices/$deviceId/diagnostics/object-detection'
      path: '/object-detection'
      fullPath: '/dashboard/resources/devices/$deviceId/diagnostics/object-detection'
      preLoaderRoute: typeof DashboardResourcesDevicesDeviceIdDiagnosticsObjectDetectionRouteImport
      parentRoute: typeof DashboardResourcesDevicesDeviceIdDiagnosticsRouteImport
    }
    '/dashboard/resources/devices/$deviceId/version-history/agent': {
      id: '/dashboard/resources/devices/$deviceId/version-history/agent'
      path: '/agent'
      fullPath: '/dashboard/resources/devices/$deviceId/version-history/agent'
      preLoaderRoute: typeof DashboardResourcesDevicesDeviceIdVersionHistoryAgentRouteImport
      parentRoute: typeof DashboardResourcesDevicesDeviceIdVersionHistoryRouteImport
    }
    '/dashboard/resources/devices/$deviceId/version-history/detector': {
      id: '/dashboard/resources/devices/$deviceId/version-history/detector'
      path: '/detector'
      fullPath: '/dashboard/resources/devices/$deviceId/version-history/detector'
      preLoaderRoute: typeof DashboardResourcesDevicesDeviceIdVersionHistoryDetectorRouteImport
      parentRoute: typeof DashboardResourcesDevicesDeviceIdVersionHistoryRouteImport
    }
    '/dashboard/resources/devices/$deviceId/version-history/models': {
      id: '/dashboard/resources/devices/$deviceId/version-history/models'
      path: '/models'
      fullPath: '/dashboard/resources/devices/$deviceId/version-history/models'
      preLoaderRoute: typeof DashboardResourcesDevicesDeviceIdVersionHistoryModelsRouteImport
      parentRoute: typeof DashboardResourcesDevicesDeviceIdVersionHistoryRouteImport
    }
    '/dashboard/resources/devices/$deviceId/version-history/on-screen-app': {
      id: '/dashboard/resources/devices/$deviceId/version-history/on-screen-app'
      path: '/on-screen-app'
      fullPath: '/dashboard/resources/devices/$deviceId/version-history/on-screen-app'
      preLoaderRoute: typeof DashboardResourcesDevicesDeviceIdVersionHistoryOnScreenAppRouteImport
      parentRoute: typeof DashboardResourcesDevicesDeviceIdVersionHistoryRouteImport
    }
    '/dashboard/resources/devices/$deviceId/version-history/trainer': {
      id: '/dashboard/resources/devices/$deviceId/version-history/trainer'
      path: '/trainer'
      fullPath: '/dashboard/resources/devices/$deviceId/version-history/trainer'
      preLoaderRoute: typeof DashboardResourcesDevicesDeviceIdVersionHistoryTrainerRouteImport
      parentRoute: typeof DashboardResourcesDevicesDeviceIdVersionHistoryRouteImport
    }
    '/dashboard/resources/devices/$deviceId/version-history/zebra-adapter': {
      id: '/dashboard/resources/devices/$deviceId/version-history/zebra-adapter'
      path: '/zebra-adapter'
      fullPath: '/dashboard/resources/devices/$deviceId/version-history/zebra-adapter'
      preLoaderRoute: typeof DashboardResourcesDevicesDeviceIdVersionHistoryZebraAdapterRouteImport
      parentRoute: typeof DashboardResourcesDevicesDeviceIdVersionHistoryRouteImport
    }
    '/dashboard/resources/sites/$siteId/version-history/agent': {
      id: '/dashboard/resources/sites/$siteId/version-history/agent'
      path: '/agent'
      fullPath: '/dashboard/resources/sites/$siteId/version-history/agent'
      preLoaderRoute: typeof DashboardResourcesSitesSiteIdVersionHistoryAgentRouteImport
      parentRoute: typeof DashboardResourcesSitesSiteIdVersionHistoryRouteImport
    }
    '/dashboard/resources/sites/$siteId/version-history/detector': {
      id: '/dashboard/resources/sites/$siteId/version-history/detector'
      path: '/detector'
      fullPath: '/dashboard/resources/sites/$siteId/version-history/detector'
      preLoaderRoute: typeof DashboardResourcesSitesSiteIdVersionHistoryDetectorRouteImport
      parentRoute: typeof DashboardResourcesSitesSiteIdVersionHistoryRouteImport
    }
    '/dashboard/resources/sites/$siteId/version-history/on-screen-app': {
      id: '/dashboard/resources/sites/$siteId/version-history/on-screen-app'
      path: '/on-screen-app'
      fullPath: '/dashboard/resources/sites/$siteId/version-history/on-screen-app'
      preLoaderRoute: typeof DashboardResourcesSitesSiteIdVersionHistoryOnScreenAppRouteImport
      parentRoute: typeof DashboardResourcesSitesSiteIdVersionHistoryRouteImport
    }
    '/dashboard/resources/sites/$siteId/version-history/trainer': {
      id: '/dashboard/resources/sites/$siteId/version-history/trainer'
      path: '/trainer'
      fullPath: '/dashboard/resources/sites/$siteId/version-history/trainer'
      preLoaderRoute: typeof DashboardResourcesSitesSiteIdVersionHistoryTrainerRouteImport
      parentRoute: typeof DashboardResourcesSitesSiteIdVersionHistoryRouteImport
    }
    '/dashboard/resources/sites/$siteId/version-history/zebra-adapter': {
      id: '/dashboard/resources/sites/$siteId/version-history/zebra-adapter'
      path: '/zebra-adapter'
      fullPath: '/dashboard/resources/sites/$siteId/version-history/zebra-adapter'
      preLoaderRoute: typeof DashboardResourcesSitesSiteIdVersionHistoryZebraAdapterRouteImport
      parentRoute: typeof DashboardResourcesSitesSiteIdVersionHistoryRouteImport
    }
    '/dashboard/settings/alert-management/alerts/$alertId/overview': {
      id: '/dashboard/settings/alert-management/alerts/$alertId/overview'
      path: '/overview'
      fullPath: '/dashboard/settings/alert-management/alerts/$alertId/overview'
      preLoaderRoute: typeof DashboardSettingsAlertManagementAlertsAlertIdOverviewRouteImport
      parentRoute: typeof DashboardSettingsAlertManagementAlertsAlertIdRouteImport
    }
    '/dashboard/settings/queues/$queueName/failures/$index': {
      id: '/dashboard/settings/queues/$queueName/failures/$index'
      path: '/$index'
      fullPath: '/dashboard/settings/queues/$queueName/failures/$index'
      preLoaderRoute: typeof DashboardSettingsQueuesQueueNameFailuresIndexRouteImport
      parentRoute: typeof DashboardSettingsQueuesQueueNameFailuresRouteImport
    }
    '/dashboard/settings/queues/$queueName/pending/$index': {
      id: '/dashboard/settings/queues/$queueName/pending/$index'
      path: '/$index'
      fullPath: '/dashboard/settings/queues/$queueName/pending/$index'
      preLoaderRoute: typeof DashboardSettingsQueuesQueueNamePendingIndexRouteImport
      parentRoute: typeof DashboardSettingsQueuesQueueNamePendingRouteImport
    }
    '/dashboard/settings/report-subscription/$reportId/$subscriptionId/edit': {
      id: '/dashboard/settings/report-subscription/$reportId/$subscriptionId/edit'
      path: '/edit'
      fullPath: '/dashboard/settings/report-subscription/$reportId/$subscriptionId/edit'
      preLoaderRoute: typeof DashboardSettingsReportSubscriptionReportIdSubscriptionIdEditRouteImport
      parentRoute: typeof DashboardSettingsReportSubscriptionReportIdSubscriptionIdRouteImport
    }
    '/dashboard/settings/report-subscription/$reportId/$subscriptionId/overview': {
      id: '/dashboard/settings/report-subscription/$reportId/$subscriptionId/overview'
      path: '/overview'
      fullPath: '/dashboard/settings/report-subscription/$reportId/$subscriptionId/overview'
      preLoaderRoute: typeof DashboardSettingsReportSubscriptionReportIdSubscriptionIdOverviewRouteImport
      parentRoute: typeof DashboardSettingsReportSubscriptionReportIdSubscriptionIdRouteImport
    }
    '/dashboard/settings/report-subscription/$reportId/$subscriptionId/review-and-approve': {
      id: '/dashboard/settings/report-subscription/$reportId/$subscriptionId/review-and-approve'
      path: '/review-and-approve'
      fullPath: '/dashboard/settings/report-subscription/$reportId/$subscriptionId/review-and-approve'
      preLoaderRoute: typeof DashboardSettingsReportSubscriptionReportIdSubscriptionIdReviewAndApproveRouteImport
      parentRoute: typeof DashboardSettingsReportSubscriptionReportIdSubscriptionIdRouteImport
    }
    '/dashboard/settings/report-subscription/$reportId/$subscriptionId/send-history': {
      id: '/dashboard/settings/report-subscription/$reportId/$subscriptionId/send-history'
      path: '/send-history'
      fullPath: '/dashboard/settings/report-subscription/$reportId/$subscriptionId/send-history'
      preLoaderRoute: typeof DashboardSettingsReportSubscriptionReportIdSubscriptionIdSendHistoryRouteImport
      parentRoute: typeof DashboardSettingsReportSubscriptionReportIdSubscriptionIdRouteImport
    }
    '/dashboard/settings/tags-management/catalog/$tagId/details': {
      id: '/dashboard/settings/tags-management/catalog/$tagId/details'
      path: '/details'
      fullPath: '/dashboard/settings/tags-management/catalog/$tagId/details'
      preLoaderRoute: typeof DashboardSettingsTagsManagementCatalogTagIdDetailsRouteImport
      parentRoute: typeof DashboardSettingsTagsManagementCatalogTagIdRouteImport
    }
    '/dashboard/settings/tags-management/clusters/$tagId/details': {
      id: '/dashboard/settings/tags-management/clusters/$tagId/details'
      path: '/details'
      fullPath: '/dashboard/settings/tags-management/clusters/$tagId/details'
      preLoaderRoute: typeof DashboardSettingsTagsManagementClustersTagIdDetailsRouteImport
      parentRoute: typeof DashboardSettingsTagsManagementClustersTagIdRouteImport
    }
    '/dashboard/settings/tags-management/devices/$tagId/details': {
      id: '/dashboard/settings/tags-management/devices/$tagId/details'
      path: '/details'
      fullPath: '/dashboard/settings/tags-management/devices/$tagId/details'
      preLoaderRoute: typeof DashboardSettingsTagsManagementDevicesTagIdDetailsRouteImport
      parentRoute: typeof DashboardSettingsTagsManagementDevicesTagIdRouteImport
    }
    '/dashboard/settings/tags-management/samples/$tagId/details': {
      id: '/dashboard/settings/tags-management/samples/$tagId/details'
      path: '/details'
      fullPath: '/dashboard/settings/tags-management/samples/$tagId/details'
      preLoaderRoute: typeof DashboardSettingsTagsManagementSamplesTagIdDetailsRouteImport
      parentRoute: typeof DashboardSettingsTagsManagementSamplesTagIdRouteImport
    }
    '/dashboard/settings/tags-management/sessions/$tagId/details': {
      id: '/dashboard/settings/tags-management/sessions/$tagId/details'
      path: '/details'
      fullPath: '/dashboard/settings/tags-management/sessions/$tagId/details'
      preLoaderRoute: typeof DashboardSettingsTagsManagementSessionsTagIdDetailsRouteImport
      parentRoute: typeof DashboardSettingsTagsManagementSessionsTagIdRouteImport
    }
    '/dashboard/settings/tags-management/sites/$tagId/details': {
      id: '/dashboard/settings/tags-management/sites/$tagId/details'
      path: '/details'
      fullPath: '/dashboard/settings/tags-management/sites/$tagId/details'
      preLoaderRoute: typeof DashboardSettingsTagsManagementSitesTagIdDetailsRouteImport
      parentRoute: typeof DashboardSettingsTagsManagementSitesTagIdRouteImport
    }
    '/admin-dashboard/jobs/service-health-checks/jobs/$jobId/': {
      id: '/admin-dashboard/jobs/service-health-checks/jobs/$jobId/'
      path: '/'
      fullPath: '/admin-dashboard/jobs/service-health-checks/jobs/$jobId/'
      preLoaderRoute: typeof AdminDashboardJobsServiceHealthChecksJobsJobIdIndexImport
      parentRoute: typeof AdminDashboardJobsServiceHealthChecksJobsJobIdRouteImport
    }
    '/admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId/': {
      id: '/admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId/'
      path: '/'
      fullPath: '/admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId/'
      preLoaderRoute: typeof AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdIndexImport
      parentRoute: typeof AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdRouteImport
    }
    '/dashboard/jobs/camera-calibration/jobs/$jobId/': {
      id: '/dashboard/jobs/camera-calibration/jobs/$jobId/'
      path: '/'
      fullPath: '/dashboard/jobs/camera-calibration/jobs/$jobId/'
      preLoaderRoute: typeof DashboardJobsCameraCalibrationJobsJobIdIndexImport
      parentRoute: typeof DashboardJobsCameraCalibrationJobsJobIdRouteImport
    }
    '/dashboard/jobs/camera-calibration/schedule/$scheduledJobId/': {
      id: '/dashboard/jobs/camera-calibration/schedule/$scheduledJobId/'
      path: '/'
      fullPath: '/dashboard/jobs/camera-calibration/schedule/$scheduledJobId/'
      preLoaderRoute: typeof DashboardJobsCameraCalibrationScheduleScheduledJobIdIndexImport
      parentRoute: typeof DashboardJobsCameraCalibrationScheduleScheduledJobIdRouteImport
    }
    '/dashboard/jobs/capacity-tagging/jobs/$jobId/': {
      id: '/dashboard/jobs/capacity-tagging/jobs/$jobId/'
      path: '/'
      fullPath: '/dashboard/jobs/capacity-tagging/jobs/$jobId/'
      preLoaderRoute: typeof DashboardJobsCapacityTaggingJobsJobIdIndexImport
      parentRoute: typeof DashboardJobsCapacityTaggingJobsJobIdRouteImport
    }
    '/dashboard/jobs/capacity-tagging/schedule/$scheduledJobId/': {
      id: '/dashboard/jobs/capacity-tagging/schedule/$scheduledJobId/'
      path: '/'
      fullPath: '/dashboard/jobs/capacity-tagging/schedule/$scheduledJobId/'
      preLoaderRoute: typeof DashboardJobsCapacityTaggingScheduleScheduledJobIdIndexImport
      parentRoute: typeof DashboardJobsCapacityTaggingScheduleScheduledJobIdRouteImport
    }
    '/dashboard/jobs/catalog-upload/jobs/$jobId/': {
      id: '/dashboard/jobs/catalog-upload/jobs/$jobId/'
      path: '/'
      fullPath: '/dashboard/jobs/catalog-upload/jobs/$jobId/'
      preLoaderRoute: typeof DashboardJobsCatalogUploadJobsJobIdIndexImport
      parentRoute: typeof DashboardJobsCatalogUploadJobsJobIdRouteImport
    }
    '/dashboard/jobs/catalog-upload/schedule/$scheduledJobId/': {
      id: '/dashboard/jobs/catalog-upload/schedule/$scheduledJobId/'
      path: '/'
      fullPath: '/dashboard/jobs/catalog-upload/schedule/$scheduledJobId/'
      preLoaderRoute: typeof DashboardJobsCatalogUploadScheduleScheduledJobIdIndexImport
      parentRoute: typeof DashboardJobsCatalogUploadScheduleScheduledJobIdRouteImport
    }
    '/dashboard/jobs/config/jobs/$jobId/': {
      id: '/dashboard/jobs/config/jobs/$jobId/'
      path: '/'
      fullPath: '/dashboard/jobs/config/jobs/$jobId/'
      preLoaderRoute: typeof DashboardJobsConfigJobsJobIdIndexImport
      parentRoute: typeof DashboardJobsConfigJobsJobIdRouteImport
    }
    '/dashboard/jobs/config/schedule/$scheduledJobId/': {
      id: '/dashboard/jobs/config/schedule/$scheduledJobId/'
      path: '/'
      fullPath: '/dashboard/jobs/config/schedule/$scheduledJobId/'
      preLoaderRoute: typeof DashboardJobsConfigScheduleScheduledJobIdIndexImport
      parentRoute: typeof DashboardJobsConfigScheduleScheduledJobIdRouteImport
    }
    '/dashboard/jobs/delete-samples/jobs/$jobId/': {
      id: '/dashboard/jobs/delete-samples/jobs/$jobId/'
      path: '/'
      fullPath: '/dashboard/jobs/delete-samples/jobs/$jobId/'
      preLoaderRoute: typeof DashboardJobsDeleteSamplesJobsJobIdIndexImport
      parentRoute: typeof DashboardJobsDeleteSamplesJobsJobIdRouteImport
    }
    '/dashboard/jobs/delete-samples/schedule/$scheduledJobId/': {
      id: '/dashboard/jobs/delete-samples/schedule/$scheduledJobId/'
      path: '/'
      fullPath: '/dashboard/jobs/delete-samples/schedule/$scheduledJobId/'
      preLoaderRoute: typeof DashboardJobsDeleteSamplesScheduleScheduledJobIdIndexImport
      parentRoute: typeof DashboardJobsDeleteSamplesScheduleScheduledJobIdRouteImport
    }
    '/dashboard/jobs/delete-videos/jobs/$jobId/': {
      id: '/dashboard/jobs/delete-videos/jobs/$jobId/'
      path: '/'
      fullPath: '/dashboard/jobs/delete-videos/jobs/$jobId/'
      preLoaderRoute: typeof DashboardJobsDeleteVideosJobsJobIdIndexImport
      parentRoute: typeof DashboardJobsDeleteVideosJobsJobIdRouteImport
    }
    '/dashboard/jobs/delete-videos/schedule/$scheduledJobId/': {
      id: '/dashboard/jobs/delete-videos/schedule/$scheduledJobId/'
      path: '/'
      fullPath: '/dashboard/jobs/delete-videos/schedule/$scheduledJobId/'
      preLoaderRoute: typeof DashboardJobsDeleteVideosScheduleScheduledJobIdIndexImport
      parentRoute: typeof DashboardJobsDeleteVideosScheduleScheduledJobIdRouteImport
    }
    '/dashboard/jobs/deployments/jobs/$jobId/': {
      id: '/dashboard/jobs/deployments/jobs/$jobId/'
      path: '/'
      fullPath: '/dashboard/jobs/deployments/jobs/$jobId/'
      preLoaderRoute: typeof DashboardJobsDeploymentsJobsJobIdIndexImport
      parentRoute: typeof DashboardJobsDeploymentsJobsJobIdRouteImport
    }
    '/dashboard/jobs/deployments/schedule/$scheduledJobId/': {
      id: '/dashboard/jobs/deployments/schedule/$scheduledJobId/'
      path: '/'
      fullPath: '/dashboard/jobs/deployments/schedule/$scheduledJobId/'
      preLoaderRoute: typeof DashboardJobsDeploymentsScheduleScheduledJobIdIndexImport
      parentRoute: typeof DashboardJobsDeploymentsScheduleScheduledJobIdRouteImport
    }
    '/dashboard/jobs/head-blur-images/jobs/$jobId/': {
      id: '/dashboard/jobs/head-blur-images/jobs/$jobId/'
      path: '/'
      fullPath: '/dashboard/jobs/head-blur-images/jobs/$jobId/'
      preLoaderRoute: typeof DashboardJobsHeadBlurImagesJobsJobIdIndexImport
      parentRoute: typeof DashboardJobsHeadBlurImagesJobsJobIdRouteImport
    }
    '/dashboard/jobs/head-blur-images/schedule/$scheduledJobId/': {
      id: '/dashboard/jobs/head-blur-images/schedule/$scheduledJobId/'
      path: '/'
      fullPath: '/dashboard/jobs/head-blur-images/schedule/$scheduledJobId/'
      preLoaderRoute: typeof DashboardJobsHeadBlurImagesScheduleScheduledJobIdIndexImport
      parentRoute: typeof DashboardJobsHeadBlurImagesScheduleScheduledJobIdRouteImport
    }
    '/dashboard/jobs/head-blur-videos/jobs/$jobId/': {
      id: '/dashboard/jobs/head-blur-videos/jobs/$jobId/'
      path: '/'
      fullPath: '/dashboard/jobs/head-blur-videos/jobs/$jobId/'
      preLoaderRoute: typeof DashboardJobsHeadBlurVideosJobsJobIdIndexImport
      parentRoute: typeof DashboardJobsHeadBlurVideosJobsJobIdRouteImport
    }
    '/dashboard/jobs/head-blur-videos/schedule/$scheduledJobId/': {
      id: '/dashboard/jobs/head-blur-videos/schedule/$scheduledJobId/'
      path: '/'
      fullPath: '/dashboard/jobs/head-blur-videos/schedule/$scheduledJobId/'
      preLoaderRoute: typeof DashboardJobsHeadBlurVideosScheduleScheduledJobIdIndexImport
      parentRoute: typeof DashboardJobsHeadBlurVideosScheduleScheduledJobIdRouteImport
    }
    '/dashboard/jobs/models/jobs/$jobId/': {
      id: '/dashboard/jobs/models/jobs/$jobId/'
      path: '/'
      fullPath: '/dashboard/jobs/models/jobs/$jobId/'
      preLoaderRoute: typeof DashboardJobsModelsJobsJobIdIndexImport
      parentRoute: typeof DashboardJobsModelsJobsJobIdRouteImport
    }
    '/dashboard/jobs/models/schedule/$scheduledJobId/': {
      id: '/dashboard/jobs/models/schedule/$scheduledJobId/'
      path: '/'
      fullPath: '/dashboard/jobs/models/schedule/$scheduledJobId/'
      preLoaderRoute: typeof DashboardJobsModelsScheduleScheduledJobIdIndexImport
      parentRoute: typeof DashboardJobsModelsScheduleScheduledJobIdRouteImport
    }
    '/dashboard/jobs/recovery-estimates/jobs/$jobId/': {
      id: '/dashboard/jobs/recovery-estimates/jobs/$jobId/'
      path: '/'
      fullPath: '/dashboard/jobs/recovery-estimates/jobs/$jobId/'
      preLoaderRoute: typeof DashboardJobsRecoveryEstimatesJobsJobIdIndexImport
      parentRoute: typeof DashboardJobsRecoveryEstimatesJobsJobIdRouteImport
    }
    '/dashboard/jobs/recovery-estimates/schedule/$scheduledJobId/': {
      id: '/dashboard/jobs/recovery-estimates/schedule/$scheduledJobId/'
      path: '/'
      fullPath: '/dashboard/jobs/recovery-estimates/schedule/$scheduledJobId/'
      preLoaderRoute: typeof DashboardJobsRecoveryEstimatesScheduleScheduledJobIdIndexImport
      parentRoute: typeof DashboardJobsRecoveryEstimatesScheduleScheduledJobIdRouteImport
    }
    '/dashboard/jobs/restarts/jobs/$jobId/': {
      id: '/dashboard/jobs/restarts/jobs/$jobId/'
      path: '/'
      fullPath: '/dashboard/jobs/restarts/jobs/$jobId/'
      preLoaderRoute: typeof DashboardJobsRestartsJobsJobIdIndexImport
      parentRoute: typeof DashboardJobsRestartsJobsJobIdRouteImport
    }
    '/dashboard/jobs/restarts/schedule/$scheduledJobId/': {
      id: '/dashboard/jobs/restarts/schedule/$scheduledJobId/'
      path: '/'
      fullPath: '/dashboard/jobs/restarts/schedule/$scheduledJobId/'
      preLoaderRoute: typeof DashboardJobsRestartsScheduleScheduledJobIdIndexImport
      parentRoute: typeof DashboardJobsRestartsScheduleScheduledJobIdRouteImport
    }
    '/dashboard/jobs/sample-upload/jobs/$jobId/': {
      id: '/dashboard/jobs/sample-upload/jobs/$jobId/'
      path: '/'
      fullPath: '/dashboard/jobs/sample-upload/jobs/$jobId/'
      preLoaderRoute: typeof DashboardJobsSampleUploadJobsJobIdIndexImport
      parentRoute: typeof DashboardJobsSampleUploadJobsJobIdRouteImport
    }
    '/dashboard/jobs/sample-upload/schedule/$scheduledJobId/': {
      id: '/dashboard/jobs/sample-upload/schedule/$scheduledJobId/'
      path: '/'
      fullPath: '/dashboard/jobs/sample-upload/schedule/$scheduledJobId/'
      preLoaderRoute: typeof DashboardJobsSampleUploadScheduleScheduledJobIdIndexImport
      parentRoute: typeof DashboardJobsSampleUploadScheduleScheduledJobIdRouteImport
    }
    '/dashboard/jobs/sync-samples/jobs/$jobId/': {
      id: '/dashboard/jobs/sync-samples/jobs/$jobId/'
      path: '/'
      fullPath: '/dashboard/jobs/sync-samples/jobs/$jobId/'
      preLoaderRoute: typeof DashboardJobsSyncSamplesJobsJobIdIndexImport
      parentRoute: typeof DashboardJobsSyncSamplesJobsJobIdRouteImport
    }
    '/dashboard/jobs/sync-samples/schedule/$scheduledJobId/': {
      id: '/dashboard/jobs/sync-samples/schedule/$scheduledJobId/'
      path: '/'
      fullPath: '/dashboard/jobs/sync-samples/schedule/$scheduledJobId/'
      preLoaderRoute: typeof DashboardJobsSyncSamplesScheduleScheduledJobIdIndexImport
      parentRoute: typeof DashboardJobsSyncSamplesScheduleScheduledJobIdRouteImport
    }
    '/dashboard/jobs/training/jobs/$jobId/': {
      id: '/dashboard/jobs/training/jobs/$jobId/'
      path: '/'
      fullPath: '/dashboard/jobs/training/jobs/$jobId/'
      preLoaderRoute: typeof DashboardJobsTrainingJobsJobIdIndexImport
      parentRoute: typeof DashboardJobsTrainingJobsJobIdRouteImport
    }
    '/dashboard/jobs/training/schedule/$scheduledJobId/': {
      id: '/dashboard/jobs/training/schedule/$scheduledJobId/'
      path: '/'
      fullPath: '/dashboard/jobs/training/schedule/$scheduledJobId/'
      preLoaderRoute: typeof DashboardJobsTrainingScheduleScheduledJobIdIndexImport
      parentRoute: typeof DashboardJobsTrainingScheduleScheduledJobIdRouteImport
    }
    '/dashboard/jobs/video-upload/jobs/$jobId/': {
      id: '/dashboard/jobs/video-upload/jobs/$jobId/'
      path: '/'
      fullPath: '/dashboard/jobs/video-upload/jobs/$jobId/'
      preLoaderRoute: typeof DashboardJobsVideoUploadJobsJobIdIndexImport
      parentRoute: typeof DashboardJobsVideoUploadJobsJobIdRouteImport
    }
    '/dashboard/jobs/video-upload/schedule/$scheduledJobId/': {
      id: '/dashboard/jobs/video-upload/schedule/$scheduledJobId/'
      path: '/'
      fullPath: '/dashboard/jobs/video-upload/schedule/$scheduledJobId/'
      preLoaderRoute: typeof DashboardJobsVideoUploadScheduleScheduledJobIdIndexImport
      parentRoute: typeof DashboardJobsVideoUploadScheduleScheduledJobIdRouteImport
    }
    '/dashboard/jobs/worker-jobs/jobs/$jobId/': {
      id: '/dashboard/jobs/worker-jobs/jobs/$jobId/'
      path: '/'
      fullPath: '/dashboard/jobs/worker-jobs/jobs/$jobId/'
      preLoaderRoute: typeof DashboardJobsWorkerJobsJobsJobIdIndexImport
      parentRoute: typeof DashboardJobsWorkerJobsJobsJobIdRouteImport
    }
    '/dashboard/jobs/worker-jobs/schedule/$scheduledJobId/': {
      id: '/dashboard/jobs/worker-jobs/schedule/$scheduledJobId/'
      path: '/'
      fullPath: '/dashboard/jobs/worker-jobs/schedule/$scheduledJobId/'
      preLoaderRoute: typeof DashboardJobsWorkerJobsScheduleScheduledJobIdIndexImport
      parentRoute: typeof DashboardJobsWorkerJobsScheduleScheduledJobIdRouteImport
    }
    '/dashboard/resources/devices/$deviceId/data/': {
      id: '/dashboard/resources/devices/$deviceId/data/'
      path: '/'
      fullPath: '/dashboard/resources/devices/$deviceId/data/'
      preLoaderRoute: typeof DashboardResourcesDevicesDeviceIdDataIndexImport
      parentRoute: typeof DashboardResourcesDevicesDeviceIdDataRouteImport
    }
    '/dashboard/resources/devices/$deviceId/version-history/': {
      id: '/dashboard/resources/devices/$deviceId/version-history/'
      path: '/'
      fullPath: '/dashboard/resources/devices/$deviceId/version-history/'
      preLoaderRoute: typeof DashboardResourcesDevicesDeviceIdVersionHistoryIndexImport
      parentRoute: typeof DashboardResourcesDevicesDeviceIdVersionHistoryRouteImport
    }
    '/dashboard/resources/sites/$siteId/version-history/': {
      id: '/dashboard/resources/sites/$siteId/version-history/'
      path: '/'
      fullPath: '/dashboard/resources/sites/$siteId/version-history/'
      preLoaderRoute: typeof DashboardResourcesSitesSiteIdVersionHistoryIndexImport
      parentRoute: typeof DashboardResourcesSitesSiteIdVersionHistoryRouteImport
    }
    '/dashboard/settings/alert-management/alerts/$alertId/': {
      id: '/dashboard/settings/alert-management/alerts/$alertId/'
      path: '/'
      fullPath: '/dashboard/settings/alert-management/alerts/$alertId/'
      preLoaderRoute: typeof DashboardSettingsAlertManagementAlertsAlertIdIndexImport
      parentRoute: typeof DashboardSettingsAlertManagementAlertsAlertIdRouteImport
    }
    '/dashboard/settings/alert-management/metric-alerts/$metricAlertId/': {
      id: '/dashboard/settings/alert-management/metric-alerts/$metricAlertId/'
      path: '/$metricAlertId'
      fullPath: '/dashboard/settings/alert-management/metric-alerts/$metricAlertId'
      preLoaderRoute: typeof DashboardSettingsAlertManagementMetricAlertsMetricAlertIdIndexImport
      parentRoute: typeof DashboardSettingsAlertManagementMetricAlertsRouteImport
    }
    '/dashboard/settings/report-subscription/$reportId/$subscriptionId/': {
      id: '/dashboard/settings/report-subscription/$reportId/$subscriptionId/'
      path: '/'
      fullPath: '/dashboard/settings/report-subscription/$reportId/$subscriptionId/'
      preLoaderRoute: typeof DashboardSettingsReportSubscriptionReportIdSubscriptionIdIndexImport
      parentRoute: typeof DashboardSettingsReportSubscriptionReportIdSubscriptionIdRouteImport
    }
    '/dashboard/settings/tags-management/catalog/$tagId/': {
      id: '/dashboard/settings/tags-management/catalog/$tagId/'
      path: '/'
      fullPath: '/dashboard/settings/tags-management/catalog/$tagId/'
      preLoaderRoute: typeof DashboardSettingsTagsManagementCatalogTagIdIndexImport
      parentRoute: typeof DashboardSettingsTagsManagementCatalogTagIdRouteImport
    }
    '/dashboard/settings/tags-management/clusters/$tagId/': {
      id: '/dashboard/settings/tags-management/clusters/$tagId/'
      path: '/'
      fullPath: '/dashboard/settings/tags-management/clusters/$tagId/'
      preLoaderRoute: typeof DashboardSettingsTagsManagementClustersTagIdIndexImport
      parentRoute: typeof DashboardSettingsTagsManagementClustersTagIdRouteImport
    }
    '/dashboard/settings/tags-management/devices/$tagId/': {
      id: '/dashboard/settings/tags-management/devices/$tagId/'
      path: '/'
      fullPath: '/dashboard/settings/tags-management/devices/$tagId/'
      preLoaderRoute: typeof DashboardSettingsTagsManagementDevicesTagIdIndexImport
      parentRoute: typeof DashboardSettingsTagsManagementDevicesTagIdRouteImport
    }
    '/dashboard/settings/tags-management/samples/$tagId/': {
      id: '/dashboard/settings/tags-management/samples/$tagId/'
      path: '/'
      fullPath: '/dashboard/settings/tags-management/samples/$tagId/'
      preLoaderRoute: typeof DashboardSettingsTagsManagementSamplesTagIdIndexImport
      parentRoute: typeof DashboardSettingsTagsManagementSamplesTagIdRouteImport
    }
    '/dashboard/settings/tags-management/sessions/$tagId/': {
      id: '/dashboard/settings/tags-management/sessions/$tagId/'
      path: '/'
      fullPath: '/dashboard/settings/tags-management/sessions/$tagId/'
      preLoaderRoute: typeof DashboardSettingsTagsManagementSessionsTagIdIndexImport
      parentRoute: typeof DashboardSettingsTagsManagementSessionsTagIdRouteImport
    }
    '/dashboard/settings/tags-management/sites/$tagId/': {
      id: '/dashboard/settings/tags-management/sites/$tagId/'
      path: '/'
      fullPath: '/dashboard/settings/tags-management/sites/$tagId/'
      preLoaderRoute: typeof DashboardSettingsTagsManagementSitesTagIdIndexImport
      parentRoute: typeof DashboardSettingsTagsManagementSitesTagIdRouteImport
    }
    '/dashboard/resources/devices/$deviceId/data/samples/$sampleId': {
      id: '/dashboard/resources/devices/$deviceId/data/samples/$sampleId'
      path: '/$sampleId'
      fullPath: '/dashboard/resources/devices/$deviceId/data/samples/$sampleId'
      preLoaderRoute: typeof DashboardResourcesDevicesDeviceIdDataSamplesSampleIdRouteImport
      parentRoute: typeof DashboardResourcesDevicesDeviceIdDataSamplesRouteImport
    }
    '/dashboard/resources/devices/$deviceId/data/sessions/$sessionId': {
      id: '/dashboard/resources/devices/$deviceId/data/sessions/$sessionId'
      path: '/$sessionId'
      fullPath: '/dashboard/resources/devices/$deviceId/data/sessions/$sessionId'
      preLoaderRoute: typeof DashboardResourcesDevicesDeviceIdDataSessionsSessionIdRouteImport
      parentRoute: typeof DashboardResourcesDevicesDeviceIdDataSessionsRouteImport
    }
    '/dashboard/resources/devices/$deviceId/data/samples/$sampleId/': {
      id: '/dashboard/resources/devices/$deviceId/data/samples/$sampleId/'
      path: '/'
      fullPath: '/dashboard/resources/devices/$deviceId/data/samples/$sampleId/'
      preLoaderRoute: typeof DashboardResourcesDevicesDeviceIdDataSamplesSampleIdIndexImport
      parentRoute: typeof DashboardResourcesDevicesDeviceIdDataSamplesSampleIdRouteImport
    }
    '/dashboard/resources/devices/$deviceId/data/sessions/$sessionId/': {
      id: '/dashboard/resources/devices/$deviceId/data/sessions/$sessionId/'
      path: '/'
      fullPath: '/dashboard/resources/devices/$deviceId/data/sessions/$sessionId/'
      preLoaderRoute: typeof DashboardResourcesDevicesDeviceIdDataSessionsSessionIdIndexImport
      parentRoute: typeof DashboardResourcesDevicesDeviceIdDataSessionsSessionIdRouteImport
    }
  }
}

// Create and export the route tree

interface AdminDashboardAccountsManagementAccountIdRouteRouteChildren {
  AdminDashboardAccountsManagementAccountIdOperationalHoursRouteRoute: typeof AdminDashboardAccountsManagementAccountIdOperationalHoursRouteRoute
  AdminDashboardAccountsManagementAccountIdOverviewRouteRoute: typeof AdminDashboardAccountsManagementAccountIdOverviewRouteRoute
  AdminDashboardAccountsManagementAccountIdRegionsRouteRoute: typeof AdminDashboardAccountsManagementAccountIdRegionsRouteRoute
  AdminDashboardAccountsManagementAccountIdIndexRoute: typeof AdminDashboardAccountsManagementAccountIdIndexRoute
}

const AdminDashboardAccountsManagementAccountIdRouteRouteChildren: AdminDashboardAccountsManagementAccountIdRouteRouteChildren =
  {
    AdminDashboardAccountsManagementAccountIdOperationalHoursRouteRoute:
      AdminDashboardAccountsManagementAccountIdOperationalHoursRouteRoute,
    AdminDashboardAccountsManagementAccountIdOverviewRouteRoute:
      AdminDashboardAccountsManagementAccountIdOverviewRouteRoute,
    AdminDashboardAccountsManagementAccountIdRegionsRouteRoute:
      AdminDashboardAccountsManagementAccountIdRegionsRouteRoute,
    AdminDashboardAccountsManagementAccountIdIndexRoute:
      AdminDashboardAccountsManagementAccountIdIndexRoute,
  }

const AdminDashboardAccountsManagementAccountIdRouteRouteWithChildren =
  AdminDashboardAccountsManagementAccountIdRouteRoute._addFileChildren(
    AdminDashboardAccountsManagementAccountIdRouteRouteChildren,
  )

interface AdminDashboardAccountsManagementRouteRouteChildren {
  AdminDashboardAccountsManagementAccountIdRouteRoute: typeof AdminDashboardAccountsManagementAccountIdRouteRouteWithChildren
}

const AdminDashboardAccountsManagementRouteRouteChildren: AdminDashboardAccountsManagementRouteRouteChildren =
  {
    AdminDashboardAccountsManagementAccountIdRouteRoute:
      AdminDashboardAccountsManagementAccountIdRouteRouteWithChildren,
  }

const AdminDashboardAccountsManagementRouteRouteWithChildren =
  AdminDashboardAccountsManagementRouteRoute._addFileChildren(
    AdminDashboardAccountsManagementRouteRouteChildren,
  )

interface AdminDashboardJobsServiceHealthChecksJobsJobIdRouteRouteChildren {
  AdminDashboardJobsServiceHealthChecksJobsJobIdOverviewRouteRoute: typeof AdminDashboardJobsServiceHealthChecksJobsJobIdOverviewRouteRoute
  AdminDashboardJobsServiceHealthChecksJobsJobIdIndexRoute: typeof AdminDashboardJobsServiceHealthChecksJobsJobIdIndexRoute
}

const AdminDashboardJobsServiceHealthChecksJobsJobIdRouteRouteChildren: AdminDashboardJobsServiceHealthChecksJobsJobIdRouteRouteChildren =
  {
    AdminDashboardJobsServiceHealthChecksJobsJobIdOverviewRouteRoute:
      AdminDashboardJobsServiceHealthChecksJobsJobIdOverviewRouteRoute,
    AdminDashboardJobsServiceHealthChecksJobsJobIdIndexRoute:
      AdminDashboardJobsServiceHealthChecksJobsJobIdIndexRoute,
  }

const AdminDashboardJobsServiceHealthChecksJobsJobIdRouteRouteWithChildren =
  AdminDashboardJobsServiceHealthChecksJobsJobIdRouteRoute._addFileChildren(
    AdminDashboardJobsServiceHealthChecksJobsJobIdRouteRouteChildren,
  )

interface AdminDashboardJobsServiceHealthChecksJobsRouteRouteChildren {
  AdminDashboardJobsServiceHealthChecksJobsJobIdRouteRoute: typeof AdminDashboardJobsServiceHealthChecksJobsJobIdRouteRouteWithChildren
}

const AdminDashboardJobsServiceHealthChecksJobsRouteRouteChildren: AdminDashboardJobsServiceHealthChecksJobsRouteRouteChildren =
  {
    AdminDashboardJobsServiceHealthChecksJobsJobIdRouteRoute:
      AdminDashboardJobsServiceHealthChecksJobsJobIdRouteRouteWithChildren,
  }

const AdminDashboardJobsServiceHealthChecksJobsRouteRouteWithChildren =
  AdminDashboardJobsServiceHealthChecksJobsRouteRoute._addFileChildren(
    AdminDashboardJobsServiceHealthChecksJobsRouteRouteChildren,
  )

interface AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdRouteRouteChildren {
  AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdInputsRouteRoute: typeof AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdInputsRouteRoute
  AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdOverviewRouteRoute: typeof AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdOverviewRouteRoute
  AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdScheduleRouteRoute: typeof AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdScheduleRouteRoute
  AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdIndexRoute: typeof AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdIndexRoute
}

const AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdRouteRouteChildren: AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdRouteRouteChildren =
  {
    AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdInputsRouteRoute:
      AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdInputsRouteRoute,
    AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdOverviewRouteRoute:
      AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdOverviewRouteRoute,
    AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdScheduleRouteRoute:
      AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdScheduleRouteRoute,
    AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdIndexRoute:
      AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdIndexRoute,
  }

const AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdRouteRouteWithChildren =
  AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdRouteRoute._addFileChildren(
    AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdRouteRouteChildren,
  )

interface AdminDashboardJobsServiceHealthChecksScheduleRouteRouteChildren {
  AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdRouteRoute: typeof AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdRouteRouteWithChildren
}

const AdminDashboardJobsServiceHealthChecksScheduleRouteRouteChildren: AdminDashboardJobsServiceHealthChecksScheduleRouteRouteChildren =
  {
    AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdRouteRoute:
      AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdRouteRouteWithChildren,
  }

const AdminDashboardJobsServiceHealthChecksScheduleRouteRouteWithChildren =
  AdminDashboardJobsServiceHealthChecksScheduleRouteRoute._addFileChildren(
    AdminDashboardJobsServiceHealthChecksScheduleRouteRouteChildren,
  )

interface AdminDashboardJobsServiceHealthChecksRouteRouteChildren {
  AdminDashboardJobsServiceHealthChecksJobsRouteRoute: typeof AdminDashboardJobsServiceHealthChecksJobsRouteRouteWithChildren
  AdminDashboardJobsServiceHealthChecksScheduleRouteRoute: typeof AdminDashboardJobsServiceHealthChecksScheduleRouteRouteWithChildren
  AdminDashboardJobsServiceHealthChecksIndexRoute: typeof AdminDashboardJobsServiceHealthChecksIndexRoute
}

const AdminDashboardJobsServiceHealthChecksRouteRouteChildren: AdminDashboardJobsServiceHealthChecksRouteRouteChildren =
  {
    AdminDashboardJobsServiceHealthChecksJobsRouteRoute:
      AdminDashboardJobsServiceHealthChecksJobsRouteRouteWithChildren,
    AdminDashboardJobsServiceHealthChecksScheduleRouteRoute:
      AdminDashboardJobsServiceHealthChecksScheduleRouteRouteWithChildren,
    AdminDashboardJobsServiceHealthChecksIndexRoute:
      AdminDashboardJobsServiceHealthChecksIndexRoute,
  }

const AdminDashboardJobsServiceHealthChecksRouteRouteWithChildren =
  AdminDashboardJobsServiceHealthChecksRouteRoute._addFileChildren(
    AdminDashboardJobsServiceHealthChecksRouteRouteChildren,
  )

interface AdminDashboardJobsRouteRouteChildren {
  AdminDashboardJobsServiceHealthChecksRouteRoute: typeof AdminDashboardJobsServiceHealthChecksRouteRouteWithChildren
}

const AdminDashboardJobsRouteRouteChildren: AdminDashboardJobsRouteRouteChildren =
  {
    AdminDashboardJobsServiceHealthChecksRouteRoute:
      AdminDashboardJobsServiceHealthChecksRouteRouteWithChildren,
  }

const AdminDashboardJobsRouteRouteWithChildren =
  AdminDashboardJobsRouteRoute._addFileChildren(
    AdminDashboardJobsRouteRouteChildren,
  )

interface AdminDashboardNotificationsNotificationIdRouteRouteChildren {
  AdminDashboardNotificationsNotificationIdOverviewRouteRoute: typeof AdminDashboardNotificationsNotificationIdOverviewRouteRoute
}

const AdminDashboardNotificationsNotificationIdRouteRouteChildren: AdminDashboardNotificationsNotificationIdRouteRouteChildren =
  {
    AdminDashboardNotificationsNotificationIdOverviewRouteRoute:
      AdminDashboardNotificationsNotificationIdOverviewRouteRoute,
  }

const AdminDashboardNotificationsNotificationIdRouteRouteWithChildren =
  AdminDashboardNotificationsNotificationIdRouteRoute._addFileChildren(
    AdminDashboardNotificationsNotificationIdRouteRouteChildren,
  )

interface AdminDashboardNotificationsRouteRouteChildren {
  AdminDashboardNotificationsNotificationIdRouteRoute: typeof AdminDashboardNotificationsNotificationIdRouteRouteWithChildren
}

const AdminDashboardNotificationsRouteRouteChildren: AdminDashboardNotificationsRouteRouteChildren =
  {
    AdminDashboardNotificationsNotificationIdRouteRoute:
      AdminDashboardNotificationsNotificationIdRouteRouteWithChildren,
  }

const AdminDashboardNotificationsRouteRouteWithChildren =
  AdminDashboardNotificationsRouteRoute._addFileChildren(
    AdminDashboardNotificationsRouteRouteChildren,
  )

interface AdminDashboardRouteRouteChildren {
  AdminDashboardAccountsManagementRouteRoute: typeof AdminDashboardAccountsManagementRouteRouteWithChildren
  AdminDashboardDomainAuthSettingsRouteRoute: typeof AdminDashboardDomainAuthSettingsRouteRoute
  AdminDashboardJobsRouteRoute: typeof AdminDashboardJobsRouteRouteWithChildren
  AdminDashboardNotificationsRouteRoute: typeof AdminDashboardNotificationsRouteRouteWithChildren
  AdminDashboardIndexRoute: typeof AdminDashboardIndexRoute
}

const AdminDashboardRouteRouteChildren: AdminDashboardRouteRouteChildren = {
  AdminDashboardAccountsManagementRouteRoute:
    AdminDashboardAccountsManagementRouteRouteWithChildren,
  AdminDashboardDomainAuthSettingsRouteRoute:
    AdminDashboardDomainAuthSettingsRouteRoute,
  AdminDashboardJobsRouteRoute: AdminDashboardJobsRouteRouteWithChildren,
  AdminDashboardNotificationsRouteRoute:
    AdminDashboardNotificationsRouteRouteWithChildren,
  AdminDashboardIndexRoute: AdminDashboardIndexRoute,
}

const AdminDashboardRouteRouteWithChildren =
  AdminDashboardRouteRoute._addFileChildren(AdminDashboardRouteRouteChildren)

interface DashboardDataCatalogItemRouteRouteChildren {
  DashboardDataCatalogItemDetailsRouteRoute: typeof DashboardDataCatalogItemDetailsRouteRoute
  DashboardDataCatalogItemLabelsRouteRoute: typeof DashboardDataCatalogItemLabelsRouteRoute
  DashboardDataCatalogItemPricesRouteRoute: typeof DashboardDataCatalogItemPricesRouteRoute
  DashboardDataCatalogItemIndexRoute: typeof DashboardDataCatalogItemIndexRoute
}

const DashboardDataCatalogItemRouteRouteChildren: DashboardDataCatalogItemRouteRouteChildren =
  {
    DashboardDataCatalogItemDetailsRouteRoute:
      DashboardDataCatalogItemDetailsRouteRoute,
    DashboardDataCatalogItemLabelsRouteRoute:
      DashboardDataCatalogItemLabelsRouteRoute,
    DashboardDataCatalogItemPricesRouteRoute:
      DashboardDataCatalogItemPricesRouteRoute,
    DashboardDataCatalogItemIndexRoute: DashboardDataCatalogItemIndexRoute,
  }

const DashboardDataCatalogItemRouteRouteWithChildren =
  DashboardDataCatalogItemRouteRoute._addFileChildren(
    DashboardDataCatalogItemRouteRouteChildren,
  )

interface DashboardDataCatalogRouteRouteChildren {
  DashboardDataCatalogItemRouteRoute: typeof DashboardDataCatalogItemRouteRouteWithChildren
}

const DashboardDataCatalogRouteRouteChildren: DashboardDataCatalogRouteRouteChildren =
  {
    DashboardDataCatalogItemRouteRoute:
      DashboardDataCatalogItemRouteRouteWithChildren,
  }

const DashboardDataCatalogRouteRouteWithChildren =
  DashboardDataCatalogRouteRoute._addFileChildren(
    DashboardDataCatalogRouteRouteChildren,
  )

interface DashboardDataDatasetsDatasetIdRouteRouteChildren {
  DashboardDataDatasetsDatasetIdImagesRouteRoute: typeof DashboardDataDatasetsDatasetIdImagesRouteRoute
  DashboardDataDatasetsDatasetIdOverviewRouteRoute: typeof DashboardDataDatasetsDatasetIdOverviewRouteRoute
  DashboardDataDatasetsDatasetIdSessionsRouteRoute: typeof DashboardDataDatasetsDatasetIdSessionsRouteRoute
}

const DashboardDataDatasetsDatasetIdRouteRouteChildren: DashboardDataDatasetsDatasetIdRouteRouteChildren =
  {
    DashboardDataDatasetsDatasetIdImagesRouteRoute:
      DashboardDataDatasetsDatasetIdImagesRouteRoute,
    DashboardDataDatasetsDatasetIdOverviewRouteRoute:
      DashboardDataDatasetsDatasetIdOverviewRouteRoute,
    DashboardDataDatasetsDatasetIdSessionsRouteRoute:
      DashboardDataDatasetsDatasetIdSessionsRouteRoute,
  }

const DashboardDataDatasetsDatasetIdRouteRouteWithChildren =
  DashboardDataDatasetsDatasetIdRouteRoute._addFileChildren(
    DashboardDataDatasetsDatasetIdRouteRouteChildren,
  )

interface DashboardDataDatasetsRouteRouteChildren {
  DashboardDataDatasetsDatasetIdRouteRoute: typeof DashboardDataDatasetsDatasetIdRouteRouteWithChildren
}

const DashboardDataDatasetsRouteRouteChildren: DashboardDataDatasetsRouteRouteChildren =
  {
    DashboardDataDatasetsDatasetIdRouteRoute:
      DashboardDataDatasetsDatasetIdRouteRouteWithChildren,
  }

const DashboardDataDatasetsRouteRouteWithChildren =
  DashboardDataDatasetsRouteRoute._addFileChildren(
    DashboardDataDatasetsRouteRouteChildren,
  )

interface DashboardDataImagesImageUUIDRouteRouteChildren {
  DashboardDataImagesImageUUIDAdditionalRouteRoute: typeof DashboardDataImagesImageUUIDAdditionalRouteRoute
  DashboardDataImagesImageUUIDOverviewRouteRoute: typeof DashboardDataImagesImageUUIDOverviewRouteRoute
  DashboardDataImagesImageUUIDTransactionDetailsRouteRoute: typeof DashboardDataImagesImageUUIDTransactionDetailsRouteRoute
  DashboardDataImagesImageUUIDIndexRoute: typeof DashboardDataImagesImageUUIDIndexRoute
}

const DashboardDataImagesImageUUIDRouteRouteChildren: DashboardDataImagesImageUUIDRouteRouteChildren =
  {
    DashboardDataImagesImageUUIDAdditionalRouteRoute:
      DashboardDataImagesImageUUIDAdditionalRouteRoute,
    DashboardDataImagesImageUUIDOverviewRouteRoute:
      DashboardDataImagesImageUUIDOverviewRouteRoute,
    DashboardDataImagesImageUUIDTransactionDetailsRouteRoute:
      DashboardDataImagesImageUUIDTransactionDetailsRouteRoute,
    DashboardDataImagesImageUUIDIndexRoute:
      DashboardDataImagesImageUUIDIndexRoute,
  }

const DashboardDataImagesImageUUIDRouteRouteWithChildren =
  DashboardDataImagesImageUUIDRouteRoute._addFileChildren(
    DashboardDataImagesImageUUIDRouteRouteChildren,
  )

interface DashboardDataImagesRouteRouteChildren {
  DashboardDataImagesImageUUIDRouteRoute: typeof DashboardDataImagesImageUUIDRouteRouteWithChildren
}

const DashboardDataImagesRouteRouteChildren: DashboardDataImagesRouteRouteChildren =
  {
    DashboardDataImagesImageUUIDRouteRoute:
      DashboardDataImagesImageUUIDRouteRouteWithChildren,
  }

const DashboardDataImagesRouteRouteWithChildren =
  DashboardDataImagesRouteRoute._addFileChildren(
    DashboardDataImagesRouteRouteChildren,
  )

interface DashboardDataJsonDataJsonDataUUIDRouteRouteChildren {
  DashboardDataJsonDataJsonDataUUIDOverviewRoute: typeof DashboardDataJsonDataJsonDataUUIDOverviewRoute
  DashboardDataJsonDataJsonDataUUIDIndexRoute: typeof DashboardDataJsonDataJsonDataUUIDIndexRoute
}

const DashboardDataJsonDataJsonDataUUIDRouteRouteChildren: DashboardDataJsonDataJsonDataUUIDRouteRouteChildren =
  {
    DashboardDataJsonDataJsonDataUUIDOverviewRoute:
      DashboardDataJsonDataJsonDataUUIDOverviewRoute,
    DashboardDataJsonDataJsonDataUUIDIndexRoute:
      DashboardDataJsonDataJsonDataUUIDIndexRoute,
  }

const DashboardDataJsonDataJsonDataUUIDRouteRouteWithChildren =
  DashboardDataJsonDataJsonDataUUIDRouteRoute._addFileChildren(
    DashboardDataJsonDataJsonDataUUIDRouteRouteChildren,
  )

interface DashboardDataJsonDataRouteRouteChildren {
  DashboardDataJsonDataJsonDataUUIDRouteRoute: typeof DashboardDataJsonDataJsonDataUUIDRouteRouteWithChildren
}

const DashboardDataJsonDataRouteRouteChildren: DashboardDataJsonDataRouteRouteChildren =
  {
    DashboardDataJsonDataJsonDataUUIDRouteRoute:
      DashboardDataJsonDataJsonDataUUIDRouteRouteWithChildren,
  }

const DashboardDataJsonDataRouteRouteWithChildren =
  DashboardDataJsonDataRouteRoute._addFileChildren(
    DashboardDataJsonDataRouteRouteChildren,
  )

interface DashboardDataLabelDistributionLabelRouteRouteChildren {
  DashboardDataLabelDistributionLabelIndexRoute: typeof DashboardDataLabelDistributionLabelIndexRoute
}

const DashboardDataLabelDistributionLabelRouteRouteChildren: DashboardDataLabelDistributionLabelRouteRouteChildren =
  {
    DashboardDataLabelDistributionLabelIndexRoute:
      DashboardDataLabelDistributionLabelIndexRoute,
  }

const DashboardDataLabelDistributionLabelRouteRouteWithChildren =
  DashboardDataLabelDistributionLabelRouteRoute._addFileChildren(
    DashboardDataLabelDistributionLabelRouteRouteChildren,
  )

interface DashboardDataLabelDistributionRouteRouteChildren {
  DashboardDataLabelDistributionLabelRouteRoute: typeof DashboardDataLabelDistributionLabelRouteRouteWithChildren
}

const DashboardDataLabelDistributionRouteRouteChildren: DashboardDataLabelDistributionRouteRouteChildren =
  {
    DashboardDataLabelDistributionLabelRouteRoute:
      DashboardDataLabelDistributionLabelRouteRouteWithChildren,
  }

const DashboardDataLabelDistributionRouteRouteWithChildren =
  DashboardDataLabelDistributionRouteRoute._addFileChildren(
    DashboardDataLabelDistributionRouteRouteChildren,
  )

interface DashboardDataSessionsSessionIdRouteRouteChildren {
  DashboardDataSessionsSessionIdOverviewRouteRoute: typeof DashboardDataSessionsSessionIdOverviewRouteRoute
  DashboardDataSessionsSessionIdIndexRoute: typeof DashboardDataSessionsSessionIdIndexRoute
}

const DashboardDataSessionsSessionIdRouteRouteChildren: DashboardDataSessionsSessionIdRouteRouteChildren =
  {
    DashboardDataSessionsSessionIdOverviewRouteRoute:
      DashboardDataSessionsSessionIdOverviewRouteRoute,
    DashboardDataSessionsSessionIdIndexRoute:
      DashboardDataSessionsSessionIdIndexRoute,
  }

const DashboardDataSessionsSessionIdRouteRouteWithChildren =
  DashboardDataSessionsSessionIdRouteRoute._addFileChildren(
    DashboardDataSessionsSessionIdRouteRouteChildren,
  )

interface DashboardDataSessionsRouteRouteChildren {
  DashboardDataSessionsSessionIdRouteRoute: typeof DashboardDataSessionsSessionIdRouteRouteWithChildren
}

const DashboardDataSessionsRouteRouteChildren: DashboardDataSessionsRouteRouteChildren =
  {
    DashboardDataSessionsSessionIdRouteRoute:
      DashboardDataSessionsSessionIdRouteRouteWithChildren,
  }

const DashboardDataSessionsRouteRouteWithChildren =
  DashboardDataSessionsRouteRoute._addFileChildren(
    DashboardDataSessionsRouteRouteChildren,
  )

interface DashboardDataRouteRouteChildren {
  DashboardDataAnnotationsRouteRoute: typeof DashboardDataAnnotationsRouteRoute
  DashboardDataCatalogRouteRoute: typeof DashboardDataCatalogRouteRouteWithChildren
  DashboardDataDatasetsRouteRoute: typeof DashboardDataDatasetsRouteRouteWithChildren
  DashboardDataImagesRouteRoute: typeof DashboardDataImagesRouteRouteWithChildren
  DashboardDataJsonDataRouteRoute: typeof DashboardDataJsonDataRouteRouteWithChildren
  DashboardDataLabelDistributionRouteRoute: typeof DashboardDataLabelDistributionRouteRouteWithChildren
  DashboardDataPendingRouteRoute: typeof DashboardDataPendingRouteRoute
  DashboardDataSessionsRouteRoute: typeof DashboardDataSessionsRouteRouteWithChildren
  DashboardDataIndexRoute: typeof DashboardDataIndexRoute
  DashboardDataRestRoute: typeof DashboardDataRestRoute
}

const DashboardDataRouteRouteChildren: DashboardDataRouteRouteChildren = {
  DashboardDataAnnotationsRouteRoute: DashboardDataAnnotationsRouteRoute,
  DashboardDataCatalogRouteRoute: DashboardDataCatalogRouteRouteWithChildren,
  DashboardDataDatasetsRouteRoute: DashboardDataDatasetsRouteRouteWithChildren,
  DashboardDataImagesRouteRoute: DashboardDataImagesRouteRouteWithChildren,
  DashboardDataJsonDataRouteRoute: DashboardDataJsonDataRouteRouteWithChildren,
  DashboardDataLabelDistributionRouteRoute:
    DashboardDataLabelDistributionRouteRouteWithChildren,
  DashboardDataPendingRouteRoute: DashboardDataPendingRouteRoute,
  DashboardDataSessionsRouteRoute: DashboardDataSessionsRouteRouteWithChildren,
  DashboardDataIndexRoute: DashboardDataIndexRoute,
  DashboardDataRestRoute: DashboardDataRestRoute,
}

const DashboardDataRouteRouteWithChildren =
  DashboardDataRouteRoute._addFileChildren(DashboardDataRouteRouteChildren)

interface DashboardJobsCameraCalibrationJobsJobIdRouteRouteChildren {
  DashboardJobsCameraCalibrationJobsJobIdDevicesRouteRoute: typeof DashboardJobsCameraCalibrationJobsJobIdDevicesRouteRoute
  DashboardJobsCameraCalibrationJobsJobIdOverviewRouteRoute: typeof DashboardJobsCameraCalibrationJobsJobIdOverviewRouteRoute
  DashboardJobsCameraCalibrationJobsJobIdIndexRoute: typeof DashboardJobsCameraCalibrationJobsJobIdIndexRoute
}

const DashboardJobsCameraCalibrationJobsJobIdRouteRouteChildren: DashboardJobsCameraCalibrationJobsJobIdRouteRouteChildren =
  {
    DashboardJobsCameraCalibrationJobsJobIdDevicesRouteRoute:
      DashboardJobsCameraCalibrationJobsJobIdDevicesRouteRoute,
    DashboardJobsCameraCalibrationJobsJobIdOverviewRouteRoute:
      DashboardJobsCameraCalibrationJobsJobIdOverviewRouteRoute,
    DashboardJobsCameraCalibrationJobsJobIdIndexRoute:
      DashboardJobsCameraCalibrationJobsJobIdIndexRoute,
  }

const DashboardJobsCameraCalibrationJobsJobIdRouteRouteWithChildren =
  DashboardJobsCameraCalibrationJobsJobIdRouteRoute._addFileChildren(
    DashboardJobsCameraCalibrationJobsJobIdRouteRouteChildren,
  )

interface DashboardJobsCameraCalibrationJobsRouteRouteChildren {
  DashboardJobsCameraCalibrationJobsJobIdRouteRoute: typeof DashboardJobsCameraCalibrationJobsJobIdRouteRouteWithChildren
}

const DashboardJobsCameraCalibrationJobsRouteRouteChildren: DashboardJobsCameraCalibrationJobsRouteRouteChildren =
  {
    DashboardJobsCameraCalibrationJobsJobIdRouteRoute:
      DashboardJobsCameraCalibrationJobsJobIdRouteRouteWithChildren,
  }

const DashboardJobsCameraCalibrationJobsRouteRouteWithChildren =
  DashboardJobsCameraCalibrationJobsRouteRoute._addFileChildren(
    DashboardJobsCameraCalibrationJobsRouteRouteChildren,
  )

interface DashboardJobsCameraCalibrationScheduleScheduledJobIdRouteRouteChildren {
  DashboardJobsCameraCalibrationScheduleScheduledJobIdInputsRouteRoute: typeof DashboardJobsCameraCalibrationScheduleScheduledJobIdInputsRouteRoute
  DashboardJobsCameraCalibrationScheduleScheduledJobIdOverviewRouteRoute: typeof DashboardJobsCameraCalibrationScheduleScheduledJobIdOverviewRouteRoute
  DashboardJobsCameraCalibrationScheduleScheduledJobIdScheduleRouteRoute: typeof DashboardJobsCameraCalibrationScheduleScheduledJobIdScheduleRouteRoute
  DashboardJobsCameraCalibrationScheduleScheduledJobIdIndexRoute: typeof DashboardJobsCameraCalibrationScheduleScheduledJobIdIndexRoute
}

const DashboardJobsCameraCalibrationScheduleScheduledJobIdRouteRouteChildren: DashboardJobsCameraCalibrationScheduleScheduledJobIdRouteRouteChildren =
  {
    DashboardJobsCameraCalibrationScheduleScheduledJobIdInputsRouteRoute:
      DashboardJobsCameraCalibrationScheduleScheduledJobIdInputsRouteRoute,
    DashboardJobsCameraCalibrationScheduleScheduledJobIdOverviewRouteRoute:
      DashboardJobsCameraCalibrationScheduleScheduledJobIdOverviewRouteRoute,
    DashboardJobsCameraCalibrationScheduleScheduledJobIdScheduleRouteRoute:
      DashboardJobsCameraCalibrationScheduleScheduledJobIdScheduleRouteRoute,
    DashboardJobsCameraCalibrationScheduleScheduledJobIdIndexRoute:
      DashboardJobsCameraCalibrationScheduleScheduledJobIdIndexRoute,
  }

const DashboardJobsCameraCalibrationScheduleScheduledJobIdRouteRouteWithChildren =
  DashboardJobsCameraCalibrationScheduleScheduledJobIdRouteRoute._addFileChildren(
    DashboardJobsCameraCalibrationScheduleScheduledJobIdRouteRouteChildren,
  )

interface DashboardJobsCameraCalibrationScheduleRouteRouteChildren {
  DashboardJobsCameraCalibrationScheduleScheduledJobIdRouteRoute: typeof DashboardJobsCameraCalibrationScheduleScheduledJobIdRouteRouteWithChildren
}

const DashboardJobsCameraCalibrationScheduleRouteRouteChildren: DashboardJobsCameraCalibrationScheduleRouteRouteChildren =
  {
    DashboardJobsCameraCalibrationScheduleScheduledJobIdRouteRoute:
      DashboardJobsCameraCalibrationScheduleScheduledJobIdRouteRouteWithChildren,
  }

const DashboardJobsCameraCalibrationScheduleRouteRouteWithChildren =
  DashboardJobsCameraCalibrationScheduleRouteRoute._addFileChildren(
    DashboardJobsCameraCalibrationScheduleRouteRouteChildren,
  )

interface DashboardJobsCameraCalibrationRouteRouteChildren {
  DashboardJobsCameraCalibrationAlertsRouteRoute: typeof DashboardJobsCameraCalibrationAlertsRouteRoute
  DashboardJobsCameraCalibrationJobsRouteRoute: typeof DashboardJobsCameraCalibrationJobsRouteRouteWithChildren
  DashboardJobsCameraCalibrationScheduleRouteRoute: typeof DashboardJobsCameraCalibrationScheduleRouteRouteWithChildren
  DashboardJobsCameraCalibrationIndexRoute: typeof DashboardJobsCameraCalibrationIndexRoute
}

const DashboardJobsCameraCalibrationRouteRouteChildren: DashboardJobsCameraCalibrationRouteRouteChildren =
  {
    DashboardJobsCameraCalibrationAlertsRouteRoute:
      DashboardJobsCameraCalibrationAlertsRouteRoute,
    DashboardJobsCameraCalibrationJobsRouteRoute:
      DashboardJobsCameraCalibrationJobsRouteRouteWithChildren,
    DashboardJobsCameraCalibrationScheduleRouteRoute:
      DashboardJobsCameraCalibrationScheduleRouteRouteWithChildren,
    DashboardJobsCameraCalibrationIndexRoute:
      DashboardJobsCameraCalibrationIndexRoute,
  }

const DashboardJobsCameraCalibrationRouteRouteWithChildren =
  DashboardJobsCameraCalibrationRouteRoute._addFileChildren(
    DashboardJobsCameraCalibrationRouteRouteChildren,
  )

interface DashboardJobsCapacityTaggingJobsJobIdRouteRouteChildren {
  DashboardJobsCapacityTaggingJobsJobIdOverviewRouteRoute: typeof DashboardJobsCapacityTaggingJobsJobIdOverviewRouteRoute
  DashboardJobsCapacityTaggingJobsJobIdIndexRoute: typeof DashboardJobsCapacityTaggingJobsJobIdIndexRoute
}

const DashboardJobsCapacityTaggingJobsJobIdRouteRouteChildren: DashboardJobsCapacityTaggingJobsJobIdRouteRouteChildren =
  {
    DashboardJobsCapacityTaggingJobsJobIdOverviewRouteRoute:
      DashboardJobsCapacityTaggingJobsJobIdOverviewRouteRoute,
    DashboardJobsCapacityTaggingJobsJobIdIndexRoute:
      DashboardJobsCapacityTaggingJobsJobIdIndexRoute,
  }

const DashboardJobsCapacityTaggingJobsJobIdRouteRouteWithChildren =
  DashboardJobsCapacityTaggingJobsJobIdRouteRoute._addFileChildren(
    DashboardJobsCapacityTaggingJobsJobIdRouteRouteChildren,
  )

interface DashboardJobsCapacityTaggingJobsRouteRouteChildren {
  DashboardJobsCapacityTaggingJobsJobIdRouteRoute: typeof DashboardJobsCapacityTaggingJobsJobIdRouteRouteWithChildren
}

const DashboardJobsCapacityTaggingJobsRouteRouteChildren: DashboardJobsCapacityTaggingJobsRouteRouteChildren =
  {
    DashboardJobsCapacityTaggingJobsJobIdRouteRoute:
      DashboardJobsCapacityTaggingJobsJobIdRouteRouteWithChildren,
  }

const DashboardJobsCapacityTaggingJobsRouteRouteWithChildren =
  DashboardJobsCapacityTaggingJobsRouteRoute._addFileChildren(
    DashboardJobsCapacityTaggingJobsRouteRouteChildren,
  )

interface DashboardJobsCapacityTaggingScheduleScheduledJobIdRouteRouteChildren {
  DashboardJobsCapacityTaggingScheduleScheduledJobIdInputsRouteRoute: typeof DashboardJobsCapacityTaggingScheduleScheduledJobIdInputsRouteRoute
  DashboardJobsCapacityTaggingScheduleScheduledJobIdOverviewRouteRoute: typeof DashboardJobsCapacityTaggingScheduleScheduledJobIdOverviewRouteRoute
  DashboardJobsCapacityTaggingScheduleScheduledJobIdScheduleRouteRoute: typeof DashboardJobsCapacityTaggingScheduleScheduledJobIdScheduleRouteRoute
  DashboardJobsCapacityTaggingScheduleScheduledJobIdIndexRoute: typeof DashboardJobsCapacityTaggingScheduleScheduledJobIdIndexRoute
}

const DashboardJobsCapacityTaggingScheduleScheduledJobIdRouteRouteChildren: DashboardJobsCapacityTaggingScheduleScheduledJobIdRouteRouteChildren =
  {
    DashboardJobsCapacityTaggingScheduleScheduledJobIdInputsRouteRoute:
      DashboardJobsCapacityTaggingScheduleScheduledJobIdInputsRouteRoute,
    DashboardJobsCapacityTaggingScheduleScheduledJobIdOverviewRouteRoute:
      DashboardJobsCapacityTaggingScheduleScheduledJobIdOverviewRouteRoute,
    DashboardJobsCapacityTaggingScheduleScheduledJobIdScheduleRouteRoute:
      DashboardJobsCapacityTaggingScheduleScheduledJobIdScheduleRouteRoute,
    DashboardJobsCapacityTaggingScheduleScheduledJobIdIndexRoute:
      DashboardJobsCapacityTaggingScheduleScheduledJobIdIndexRoute,
  }

const DashboardJobsCapacityTaggingScheduleScheduledJobIdRouteRouteWithChildren =
  DashboardJobsCapacityTaggingScheduleScheduledJobIdRouteRoute._addFileChildren(
    DashboardJobsCapacityTaggingScheduleScheduledJobIdRouteRouteChildren,
  )

interface DashboardJobsCapacityTaggingScheduleRouteRouteChildren {
  DashboardJobsCapacityTaggingScheduleScheduledJobIdRouteRoute: typeof DashboardJobsCapacityTaggingScheduleScheduledJobIdRouteRouteWithChildren
}

const DashboardJobsCapacityTaggingScheduleRouteRouteChildren: DashboardJobsCapacityTaggingScheduleRouteRouteChildren =
  {
    DashboardJobsCapacityTaggingScheduleScheduledJobIdRouteRoute:
      DashboardJobsCapacityTaggingScheduleScheduledJobIdRouteRouteWithChildren,
  }

const DashboardJobsCapacityTaggingScheduleRouteRouteWithChildren =
  DashboardJobsCapacityTaggingScheduleRouteRoute._addFileChildren(
    DashboardJobsCapacityTaggingScheduleRouteRouteChildren,
  )

interface DashboardJobsCapacityTaggingRouteRouteChildren {
  DashboardJobsCapacityTaggingJobsRouteRoute: typeof DashboardJobsCapacityTaggingJobsRouteRouteWithChildren
  DashboardJobsCapacityTaggingScheduleRouteRoute: typeof DashboardJobsCapacityTaggingScheduleRouteRouteWithChildren
  DashboardJobsCapacityTaggingIndexRoute: typeof DashboardJobsCapacityTaggingIndexRoute
}

const DashboardJobsCapacityTaggingRouteRouteChildren: DashboardJobsCapacityTaggingRouteRouteChildren =
  {
    DashboardJobsCapacityTaggingJobsRouteRoute:
      DashboardJobsCapacityTaggingJobsRouteRouteWithChildren,
    DashboardJobsCapacityTaggingScheduleRouteRoute:
      DashboardJobsCapacityTaggingScheduleRouteRouteWithChildren,
    DashboardJobsCapacityTaggingIndexRoute:
      DashboardJobsCapacityTaggingIndexRoute,
  }

const DashboardJobsCapacityTaggingRouteRouteWithChildren =
  DashboardJobsCapacityTaggingRouteRoute._addFileChildren(
    DashboardJobsCapacityTaggingRouteRouteChildren,
  )

interface DashboardJobsCatalogUploadJobsJobIdRouteRouteChildren {
  DashboardJobsCatalogUploadJobsJobIdDevicesRouteRoute: typeof DashboardJobsCatalogUploadJobsJobIdDevicesRouteRoute
  DashboardJobsCatalogUploadJobsJobIdLabelsRouteRoute: typeof DashboardJobsCatalogUploadJobsJobIdLabelsRouteRoute
  DashboardJobsCatalogUploadJobsJobIdOverviewRouteRoute: typeof DashboardJobsCatalogUploadJobsJobIdOverviewRouteRoute
  DashboardJobsCatalogUploadJobsJobIdIndexRoute: typeof DashboardJobsCatalogUploadJobsJobIdIndexRoute
}

const DashboardJobsCatalogUploadJobsJobIdRouteRouteChildren: DashboardJobsCatalogUploadJobsJobIdRouteRouteChildren =
  {
    DashboardJobsCatalogUploadJobsJobIdDevicesRouteRoute:
      DashboardJobsCatalogUploadJobsJobIdDevicesRouteRoute,
    DashboardJobsCatalogUploadJobsJobIdLabelsRouteRoute:
      DashboardJobsCatalogUploadJobsJobIdLabelsRouteRoute,
    DashboardJobsCatalogUploadJobsJobIdOverviewRouteRoute:
      DashboardJobsCatalogUploadJobsJobIdOverviewRouteRoute,
    DashboardJobsCatalogUploadJobsJobIdIndexRoute:
      DashboardJobsCatalogUploadJobsJobIdIndexRoute,
  }

const DashboardJobsCatalogUploadJobsJobIdRouteRouteWithChildren =
  DashboardJobsCatalogUploadJobsJobIdRouteRoute._addFileChildren(
    DashboardJobsCatalogUploadJobsJobIdRouteRouteChildren,
  )

interface DashboardJobsCatalogUploadJobsRouteRouteChildren {
  DashboardJobsCatalogUploadJobsJobIdRouteRoute: typeof DashboardJobsCatalogUploadJobsJobIdRouteRouteWithChildren
}

const DashboardJobsCatalogUploadJobsRouteRouteChildren: DashboardJobsCatalogUploadJobsRouteRouteChildren =
  {
    DashboardJobsCatalogUploadJobsJobIdRouteRoute:
      DashboardJobsCatalogUploadJobsJobIdRouteRouteWithChildren,
  }

const DashboardJobsCatalogUploadJobsRouteRouteWithChildren =
  DashboardJobsCatalogUploadJobsRouteRoute._addFileChildren(
    DashboardJobsCatalogUploadJobsRouteRouteChildren,
  )

interface DashboardJobsCatalogUploadScheduleScheduledJobIdRouteRouteChildren {
  DashboardJobsCatalogUploadScheduleScheduledJobIdLabelsRouteRoute: typeof DashboardJobsCatalogUploadScheduleScheduledJobIdLabelsRouteRoute
  DashboardJobsCatalogUploadScheduleScheduledJobIdOverviewRouteRoute: typeof DashboardJobsCatalogUploadScheduleScheduledJobIdOverviewRouteRoute
  DashboardJobsCatalogUploadScheduleScheduledJobIdScheduleRouteRoute: typeof DashboardJobsCatalogUploadScheduleScheduledJobIdScheduleRouteRoute
  DashboardJobsCatalogUploadScheduleScheduledJobIdIndexRoute: typeof DashboardJobsCatalogUploadScheduleScheduledJobIdIndexRoute
}

const DashboardJobsCatalogUploadScheduleScheduledJobIdRouteRouteChildren: DashboardJobsCatalogUploadScheduleScheduledJobIdRouteRouteChildren =
  {
    DashboardJobsCatalogUploadScheduleScheduledJobIdLabelsRouteRoute:
      DashboardJobsCatalogUploadScheduleScheduledJobIdLabelsRouteRoute,
    DashboardJobsCatalogUploadScheduleScheduledJobIdOverviewRouteRoute:
      DashboardJobsCatalogUploadScheduleScheduledJobIdOverviewRouteRoute,
    DashboardJobsCatalogUploadScheduleScheduledJobIdScheduleRouteRoute:
      DashboardJobsCatalogUploadScheduleScheduledJobIdScheduleRouteRoute,
    DashboardJobsCatalogUploadScheduleScheduledJobIdIndexRoute:
      DashboardJobsCatalogUploadScheduleScheduledJobIdIndexRoute,
  }

const DashboardJobsCatalogUploadScheduleScheduledJobIdRouteRouteWithChildren =
  DashboardJobsCatalogUploadScheduleScheduledJobIdRouteRoute._addFileChildren(
    DashboardJobsCatalogUploadScheduleScheduledJobIdRouteRouteChildren,
  )

interface DashboardJobsCatalogUploadScheduleRouteRouteChildren {
  DashboardJobsCatalogUploadScheduleScheduledJobIdRouteRoute: typeof DashboardJobsCatalogUploadScheduleScheduledJobIdRouteRouteWithChildren
}

const DashboardJobsCatalogUploadScheduleRouteRouteChildren: DashboardJobsCatalogUploadScheduleRouteRouteChildren =
  {
    DashboardJobsCatalogUploadScheduleScheduledJobIdRouteRoute:
      DashboardJobsCatalogUploadScheduleScheduledJobIdRouteRouteWithChildren,
  }

const DashboardJobsCatalogUploadScheduleRouteRouteWithChildren =
  DashboardJobsCatalogUploadScheduleRouteRoute._addFileChildren(
    DashboardJobsCatalogUploadScheduleRouteRouteChildren,
  )

interface DashboardJobsCatalogUploadRouteRouteChildren {
  DashboardJobsCatalogUploadJobsRouteRoute: typeof DashboardJobsCatalogUploadJobsRouteRouteWithChildren
  DashboardJobsCatalogUploadScheduleRouteRoute: typeof DashboardJobsCatalogUploadScheduleRouteRouteWithChildren
  DashboardJobsCatalogUploadIndexRoute: typeof DashboardJobsCatalogUploadIndexRoute
}

const DashboardJobsCatalogUploadRouteRouteChildren: DashboardJobsCatalogUploadRouteRouteChildren =
  {
    DashboardJobsCatalogUploadJobsRouteRoute:
      DashboardJobsCatalogUploadJobsRouteRouteWithChildren,
    DashboardJobsCatalogUploadScheduleRouteRoute:
      DashboardJobsCatalogUploadScheduleRouteRouteWithChildren,
    DashboardJobsCatalogUploadIndexRoute: DashboardJobsCatalogUploadIndexRoute,
  }

const DashboardJobsCatalogUploadRouteRouteWithChildren =
  DashboardJobsCatalogUploadRouteRoute._addFileChildren(
    DashboardJobsCatalogUploadRouteRouteChildren,
  )

interface DashboardJobsConfigJobsJobIdRouteRouteChildren {
  DashboardJobsConfigJobsJobIdDevicesRouteRoute: typeof DashboardJobsConfigJobsJobIdDevicesRouteRoute
  DashboardJobsConfigJobsJobIdOverviewRouteRoute: typeof DashboardJobsConfigJobsJobIdOverviewRouteRoute
  DashboardJobsConfigJobsJobIdIndexRoute: typeof DashboardJobsConfigJobsJobIdIndexRoute
}

const DashboardJobsConfigJobsJobIdRouteRouteChildren: DashboardJobsConfigJobsJobIdRouteRouteChildren =
  {
    DashboardJobsConfigJobsJobIdDevicesRouteRoute:
      DashboardJobsConfigJobsJobIdDevicesRouteRoute,
    DashboardJobsConfigJobsJobIdOverviewRouteRoute:
      DashboardJobsConfigJobsJobIdOverviewRouteRoute,
    DashboardJobsConfigJobsJobIdIndexRoute:
      DashboardJobsConfigJobsJobIdIndexRoute,
  }

const DashboardJobsConfigJobsJobIdRouteRouteWithChildren =
  DashboardJobsConfigJobsJobIdRouteRoute._addFileChildren(
    DashboardJobsConfigJobsJobIdRouteRouteChildren,
  )

interface DashboardJobsConfigJobsRouteRouteChildren {
  DashboardJobsConfigJobsJobIdRouteRoute: typeof DashboardJobsConfigJobsJobIdRouteRouteWithChildren
}

const DashboardJobsConfigJobsRouteRouteChildren: DashboardJobsConfigJobsRouteRouteChildren =
  {
    DashboardJobsConfigJobsJobIdRouteRoute:
      DashboardJobsConfigJobsJobIdRouteRouteWithChildren,
  }

const DashboardJobsConfigJobsRouteRouteWithChildren =
  DashboardJobsConfigJobsRouteRoute._addFileChildren(
    DashboardJobsConfigJobsRouteRouteChildren,
  )

interface DashboardJobsConfigScheduleScheduledJobIdRouteRouteChildren {
  DashboardJobsConfigScheduleScheduledJobIdOverviewRouteRoute: typeof DashboardJobsConfigScheduleScheduledJobIdOverviewRouteRoute
  DashboardJobsConfigScheduleScheduledJobIdScheduleRouteRoute: typeof DashboardJobsConfigScheduleScheduledJobIdScheduleRouteRoute
  DashboardJobsConfigScheduleScheduledJobIdIndexRoute: typeof DashboardJobsConfigScheduleScheduledJobIdIndexRoute
}

const DashboardJobsConfigScheduleScheduledJobIdRouteRouteChildren: DashboardJobsConfigScheduleScheduledJobIdRouteRouteChildren =
  {
    DashboardJobsConfigScheduleScheduledJobIdOverviewRouteRoute:
      DashboardJobsConfigScheduleScheduledJobIdOverviewRouteRoute,
    DashboardJobsConfigScheduleScheduledJobIdScheduleRouteRoute:
      DashboardJobsConfigScheduleScheduledJobIdScheduleRouteRoute,
    DashboardJobsConfigScheduleScheduledJobIdIndexRoute:
      DashboardJobsConfigScheduleScheduledJobIdIndexRoute,
  }

const DashboardJobsConfigScheduleScheduledJobIdRouteRouteWithChildren =
  DashboardJobsConfigScheduleScheduledJobIdRouteRoute._addFileChildren(
    DashboardJobsConfigScheduleScheduledJobIdRouteRouteChildren,
  )

interface DashboardJobsConfigScheduleRouteRouteChildren {
  DashboardJobsConfigScheduleScheduledJobIdRouteRoute: typeof DashboardJobsConfigScheduleScheduledJobIdRouteRouteWithChildren
}

const DashboardJobsConfigScheduleRouteRouteChildren: DashboardJobsConfigScheduleRouteRouteChildren =
  {
    DashboardJobsConfigScheduleScheduledJobIdRouteRoute:
      DashboardJobsConfigScheduleScheduledJobIdRouteRouteWithChildren,
  }

const DashboardJobsConfigScheduleRouteRouteWithChildren =
  DashboardJobsConfigScheduleRouteRoute._addFileChildren(
    DashboardJobsConfigScheduleRouteRouteChildren,
  )

interface DashboardJobsConfigRouteRouteChildren {
  DashboardJobsConfigJobsRouteRoute: typeof DashboardJobsConfigJobsRouteRouteWithChildren
  DashboardJobsConfigScheduleRouteRoute: typeof DashboardJobsConfigScheduleRouteRouteWithChildren
  DashboardJobsConfigIndexRoute: typeof DashboardJobsConfigIndexRoute
}

const DashboardJobsConfigRouteRouteChildren: DashboardJobsConfigRouteRouteChildren =
  {
    DashboardJobsConfigJobsRouteRoute:
      DashboardJobsConfigJobsRouteRouteWithChildren,
    DashboardJobsConfigScheduleRouteRoute:
      DashboardJobsConfigScheduleRouteRouteWithChildren,
    DashboardJobsConfigIndexRoute: DashboardJobsConfigIndexRoute,
  }

const DashboardJobsConfigRouteRouteWithChildren =
  DashboardJobsConfigRouteRoute._addFileChildren(
    DashboardJobsConfigRouteRouteChildren,
  )

interface DashboardJobsDeleteSamplesJobsJobIdRouteRouteChildren {
  DashboardJobsDeleteSamplesJobsJobIdDevicesRouteRoute: typeof DashboardJobsDeleteSamplesJobsJobIdDevicesRouteRoute
  DashboardJobsDeleteSamplesJobsJobIdOverviewRouteRoute: typeof DashboardJobsDeleteSamplesJobsJobIdOverviewRouteRoute
  DashboardJobsDeleteSamplesJobsJobIdIndexRoute: typeof DashboardJobsDeleteSamplesJobsJobIdIndexRoute
}

const DashboardJobsDeleteSamplesJobsJobIdRouteRouteChildren: DashboardJobsDeleteSamplesJobsJobIdRouteRouteChildren =
  {
    DashboardJobsDeleteSamplesJobsJobIdDevicesRouteRoute:
      DashboardJobsDeleteSamplesJobsJobIdDevicesRouteRoute,
    DashboardJobsDeleteSamplesJobsJobIdOverviewRouteRoute:
      DashboardJobsDeleteSamplesJobsJobIdOverviewRouteRoute,
    DashboardJobsDeleteSamplesJobsJobIdIndexRoute:
      DashboardJobsDeleteSamplesJobsJobIdIndexRoute,
  }

const DashboardJobsDeleteSamplesJobsJobIdRouteRouteWithChildren =
  DashboardJobsDeleteSamplesJobsJobIdRouteRoute._addFileChildren(
    DashboardJobsDeleteSamplesJobsJobIdRouteRouteChildren,
  )

interface DashboardJobsDeleteSamplesJobsRouteRouteChildren {
  DashboardJobsDeleteSamplesJobsJobIdRouteRoute: typeof DashboardJobsDeleteSamplesJobsJobIdRouteRouteWithChildren
}

const DashboardJobsDeleteSamplesJobsRouteRouteChildren: DashboardJobsDeleteSamplesJobsRouteRouteChildren =
  {
    DashboardJobsDeleteSamplesJobsJobIdRouteRoute:
      DashboardJobsDeleteSamplesJobsJobIdRouteRouteWithChildren,
  }

const DashboardJobsDeleteSamplesJobsRouteRouteWithChildren =
  DashboardJobsDeleteSamplesJobsRouteRoute._addFileChildren(
    DashboardJobsDeleteSamplesJobsRouteRouteChildren,
  )

interface DashboardJobsDeleteSamplesScheduleScheduledJobIdRouteRouteChildren {
  DashboardJobsDeleteSamplesScheduleScheduledJobIdInputsRouteRoute: typeof DashboardJobsDeleteSamplesScheduleScheduledJobIdInputsRouteRoute
  DashboardJobsDeleteSamplesScheduleScheduledJobIdOverviewRouteRoute: typeof DashboardJobsDeleteSamplesScheduleScheduledJobIdOverviewRouteRoute
  DashboardJobsDeleteSamplesScheduleScheduledJobIdScheduleRouteRoute: typeof DashboardJobsDeleteSamplesScheduleScheduledJobIdScheduleRouteRoute
  DashboardJobsDeleteSamplesScheduleScheduledJobIdIndexRoute: typeof DashboardJobsDeleteSamplesScheduleScheduledJobIdIndexRoute
}

const DashboardJobsDeleteSamplesScheduleScheduledJobIdRouteRouteChildren: DashboardJobsDeleteSamplesScheduleScheduledJobIdRouteRouteChildren =
  {
    DashboardJobsDeleteSamplesScheduleScheduledJobIdInputsRouteRoute:
      DashboardJobsDeleteSamplesScheduleScheduledJobIdInputsRouteRoute,
    DashboardJobsDeleteSamplesScheduleScheduledJobIdOverviewRouteRoute:
      DashboardJobsDeleteSamplesScheduleScheduledJobIdOverviewRouteRoute,
    DashboardJobsDeleteSamplesScheduleScheduledJobIdScheduleRouteRoute:
      DashboardJobsDeleteSamplesScheduleScheduledJobIdScheduleRouteRoute,
    DashboardJobsDeleteSamplesScheduleScheduledJobIdIndexRoute:
      DashboardJobsDeleteSamplesScheduleScheduledJobIdIndexRoute,
  }

const DashboardJobsDeleteSamplesScheduleScheduledJobIdRouteRouteWithChildren =
  DashboardJobsDeleteSamplesScheduleScheduledJobIdRouteRoute._addFileChildren(
    DashboardJobsDeleteSamplesScheduleScheduledJobIdRouteRouteChildren,
  )

interface DashboardJobsDeleteSamplesScheduleRouteRouteChildren {
  DashboardJobsDeleteSamplesScheduleScheduledJobIdRouteRoute: typeof DashboardJobsDeleteSamplesScheduleScheduledJobIdRouteRouteWithChildren
}

const DashboardJobsDeleteSamplesScheduleRouteRouteChildren: DashboardJobsDeleteSamplesScheduleRouteRouteChildren =
  {
    DashboardJobsDeleteSamplesScheduleScheduledJobIdRouteRoute:
      DashboardJobsDeleteSamplesScheduleScheduledJobIdRouteRouteWithChildren,
  }

const DashboardJobsDeleteSamplesScheduleRouteRouteWithChildren =
  DashboardJobsDeleteSamplesScheduleRouteRoute._addFileChildren(
    DashboardJobsDeleteSamplesScheduleRouteRouteChildren,
  )

interface DashboardJobsDeleteSamplesRouteRouteChildren {
  DashboardJobsDeleteSamplesAlertsRouteRoute: typeof DashboardJobsDeleteSamplesAlertsRouteRoute
  DashboardJobsDeleteSamplesJobsRouteRoute: typeof DashboardJobsDeleteSamplesJobsRouteRouteWithChildren
  DashboardJobsDeleteSamplesScheduleRouteRoute: typeof DashboardJobsDeleteSamplesScheduleRouteRouteWithChildren
  DashboardJobsDeleteSamplesIndexRoute: typeof DashboardJobsDeleteSamplesIndexRoute
}

const DashboardJobsDeleteSamplesRouteRouteChildren: DashboardJobsDeleteSamplesRouteRouteChildren =
  {
    DashboardJobsDeleteSamplesAlertsRouteRoute:
      DashboardJobsDeleteSamplesAlertsRouteRoute,
    DashboardJobsDeleteSamplesJobsRouteRoute:
      DashboardJobsDeleteSamplesJobsRouteRouteWithChildren,
    DashboardJobsDeleteSamplesScheduleRouteRoute:
      DashboardJobsDeleteSamplesScheduleRouteRouteWithChildren,
    DashboardJobsDeleteSamplesIndexRoute: DashboardJobsDeleteSamplesIndexRoute,
  }

const DashboardJobsDeleteSamplesRouteRouteWithChildren =
  DashboardJobsDeleteSamplesRouteRoute._addFileChildren(
    DashboardJobsDeleteSamplesRouteRouteChildren,
  )

interface DashboardJobsDeleteVideosJobsJobIdRouteRouteChildren {
  DashboardJobsDeleteVideosJobsJobIdDevicesRouteRoute: typeof DashboardJobsDeleteVideosJobsJobIdDevicesRouteRoute
  DashboardJobsDeleteVideosJobsJobIdOverviewRouteRoute: typeof DashboardJobsDeleteVideosJobsJobIdOverviewRouteRoute
  DashboardJobsDeleteVideosJobsJobIdIndexRoute: typeof DashboardJobsDeleteVideosJobsJobIdIndexRoute
}

const DashboardJobsDeleteVideosJobsJobIdRouteRouteChildren: DashboardJobsDeleteVideosJobsJobIdRouteRouteChildren =
  {
    DashboardJobsDeleteVideosJobsJobIdDevicesRouteRoute:
      DashboardJobsDeleteVideosJobsJobIdDevicesRouteRoute,
    DashboardJobsDeleteVideosJobsJobIdOverviewRouteRoute:
      DashboardJobsDeleteVideosJobsJobIdOverviewRouteRoute,
    DashboardJobsDeleteVideosJobsJobIdIndexRoute:
      DashboardJobsDeleteVideosJobsJobIdIndexRoute,
  }

const DashboardJobsDeleteVideosJobsJobIdRouteRouteWithChildren =
  DashboardJobsDeleteVideosJobsJobIdRouteRoute._addFileChildren(
    DashboardJobsDeleteVideosJobsJobIdRouteRouteChildren,
  )

interface DashboardJobsDeleteVideosJobsRouteRouteChildren {
  DashboardJobsDeleteVideosJobsJobIdRouteRoute: typeof DashboardJobsDeleteVideosJobsJobIdRouteRouteWithChildren
}

const DashboardJobsDeleteVideosJobsRouteRouteChildren: DashboardJobsDeleteVideosJobsRouteRouteChildren =
  {
    DashboardJobsDeleteVideosJobsJobIdRouteRoute:
      DashboardJobsDeleteVideosJobsJobIdRouteRouteWithChildren,
  }

const DashboardJobsDeleteVideosJobsRouteRouteWithChildren =
  DashboardJobsDeleteVideosJobsRouteRoute._addFileChildren(
    DashboardJobsDeleteVideosJobsRouteRouteChildren,
  )

interface DashboardJobsDeleteVideosScheduleScheduledJobIdRouteRouteChildren {
  DashboardJobsDeleteVideosScheduleScheduledJobIdInputsRouteRoute: typeof DashboardJobsDeleteVideosScheduleScheduledJobIdInputsRouteRoute
  DashboardJobsDeleteVideosScheduleScheduledJobIdOverviewRouteRoute: typeof DashboardJobsDeleteVideosScheduleScheduledJobIdOverviewRouteRoute
  DashboardJobsDeleteVideosScheduleScheduledJobIdScheduleRouteRoute: typeof DashboardJobsDeleteVideosScheduleScheduledJobIdScheduleRouteRoute
  DashboardJobsDeleteVideosScheduleScheduledJobIdIndexRoute: typeof DashboardJobsDeleteVideosScheduleScheduledJobIdIndexRoute
}

const DashboardJobsDeleteVideosScheduleScheduledJobIdRouteRouteChildren: DashboardJobsDeleteVideosScheduleScheduledJobIdRouteRouteChildren =
  {
    DashboardJobsDeleteVideosScheduleScheduledJobIdInputsRouteRoute:
      DashboardJobsDeleteVideosScheduleScheduledJobIdInputsRouteRoute,
    DashboardJobsDeleteVideosScheduleScheduledJobIdOverviewRouteRoute:
      DashboardJobsDeleteVideosScheduleScheduledJobIdOverviewRouteRoute,
    DashboardJobsDeleteVideosScheduleScheduledJobIdScheduleRouteRoute:
      DashboardJobsDeleteVideosScheduleScheduledJobIdScheduleRouteRoute,
    DashboardJobsDeleteVideosScheduleScheduledJobIdIndexRoute:
      DashboardJobsDeleteVideosScheduleScheduledJobIdIndexRoute,
  }

const DashboardJobsDeleteVideosScheduleScheduledJobIdRouteRouteWithChildren =
  DashboardJobsDeleteVideosScheduleScheduledJobIdRouteRoute._addFileChildren(
    DashboardJobsDeleteVideosScheduleScheduledJobIdRouteRouteChildren,
  )

interface DashboardJobsDeleteVideosScheduleRouteRouteChildren {
  DashboardJobsDeleteVideosScheduleScheduledJobIdRouteRoute: typeof DashboardJobsDeleteVideosScheduleScheduledJobIdRouteRouteWithChildren
}

const DashboardJobsDeleteVideosScheduleRouteRouteChildren: DashboardJobsDeleteVideosScheduleRouteRouteChildren =
  {
    DashboardJobsDeleteVideosScheduleScheduledJobIdRouteRoute:
      DashboardJobsDeleteVideosScheduleScheduledJobIdRouteRouteWithChildren,
  }

const DashboardJobsDeleteVideosScheduleRouteRouteWithChildren =
  DashboardJobsDeleteVideosScheduleRouteRoute._addFileChildren(
    DashboardJobsDeleteVideosScheduleRouteRouteChildren,
  )

interface DashboardJobsDeleteVideosRouteRouteChildren {
  DashboardJobsDeleteVideosAlertsRouteRoute: typeof DashboardJobsDeleteVideosAlertsRouteRoute
  DashboardJobsDeleteVideosJobsRouteRoute: typeof DashboardJobsDeleteVideosJobsRouteRouteWithChildren
  DashboardJobsDeleteVideosScheduleRouteRoute: typeof DashboardJobsDeleteVideosScheduleRouteRouteWithChildren
  DashboardJobsDeleteVideosIndexRoute: typeof DashboardJobsDeleteVideosIndexRoute
}

const DashboardJobsDeleteVideosRouteRouteChildren: DashboardJobsDeleteVideosRouteRouteChildren =
  {
    DashboardJobsDeleteVideosAlertsRouteRoute:
      DashboardJobsDeleteVideosAlertsRouteRoute,
    DashboardJobsDeleteVideosJobsRouteRoute:
      DashboardJobsDeleteVideosJobsRouteRouteWithChildren,
    DashboardJobsDeleteVideosScheduleRouteRoute:
      DashboardJobsDeleteVideosScheduleRouteRouteWithChildren,
    DashboardJobsDeleteVideosIndexRoute: DashboardJobsDeleteVideosIndexRoute,
  }

const DashboardJobsDeleteVideosRouteRouteWithChildren =
  DashboardJobsDeleteVideosRouteRoute._addFileChildren(
    DashboardJobsDeleteVideosRouteRouteChildren,
  )

interface DashboardJobsDeploymentsJobsJobIdRouteRouteChildren {
  DashboardJobsDeploymentsJobsJobIdDevicesRouteRoute: typeof DashboardJobsDeploymentsJobsJobIdDevicesRouteRoute
  DashboardJobsDeploymentsJobsJobIdOverviewRouteRoute: typeof DashboardJobsDeploymentsJobsJobIdOverviewRouteRoute
  DashboardJobsDeploymentsJobsJobIdIndexRoute: typeof DashboardJobsDeploymentsJobsJobIdIndexRoute
}

const DashboardJobsDeploymentsJobsJobIdRouteRouteChildren: DashboardJobsDeploymentsJobsJobIdRouteRouteChildren =
  {
    DashboardJobsDeploymentsJobsJobIdDevicesRouteRoute:
      DashboardJobsDeploymentsJobsJobIdDevicesRouteRoute,
    DashboardJobsDeploymentsJobsJobIdOverviewRouteRoute:
      DashboardJobsDeploymentsJobsJobIdOverviewRouteRoute,
    DashboardJobsDeploymentsJobsJobIdIndexRoute:
      DashboardJobsDeploymentsJobsJobIdIndexRoute,
  }

const DashboardJobsDeploymentsJobsJobIdRouteRouteWithChildren =
  DashboardJobsDeploymentsJobsJobIdRouteRoute._addFileChildren(
    DashboardJobsDeploymentsJobsJobIdRouteRouteChildren,
  )

interface DashboardJobsDeploymentsJobsRouteRouteChildren {
  DashboardJobsDeploymentsJobsJobIdRouteRoute: typeof DashboardJobsDeploymentsJobsJobIdRouteRouteWithChildren
}

const DashboardJobsDeploymentsJobsRouteRouteChildren: DashboardJobsDeploymentsJobsRouteRouteChildren =
  {
    DashboardJobsDeploymentsJobsJobIdRouteRoute:
      DashboardJobsDeploymentsJobsJobIdRouteRouteWithChildren,
  }

const DashboardJobsDeploymentsJobsRouteRouteWithChildren =
  DashboardJobsDeploymentsJobsRouteRoute._addFileChildren(
    DashboardJobsDeploymentsJobsRouteRouteChildren,
  )

interface DashboardJobsDeploymentsScheduleScheduledJobIdRouteRouteChildren {
  DashboardJobsDeploymentsScheduleScheduledJobIdOverviewRouteRoute: typeof DashboardJobsDeploymentsScheduleScheduledJobIdOverviewRouteRoute
  DashboardJobsDeploymentsScheduleScheduledJobIdScheduleRouteRoute: typeof DashboardJobsDeploymentsScheduleScheduledJobIdScheduleRouteRoute
  DashboardJobsDeploymentsScheduleScheduledJobIdIndexRoute: typeof DashboardJobsDeploymentsScheduleScheduledJobIdIndexRoute
}

const DashboardJobsDeploymentsScheduleScheduledJobIdRouteRouteChildren: DashboardJobsDeploymentsScheduleScheduledJobIdRouteRouteChildren =
  {
    DashboardJobsDeploymentsScheduleScheduledJobIdOverviewRouteRoute:
      DashboardJobsDeploymentsScheduleScheduledJobIdOverviewRouteRoute,
    DashboardJobsDeploymentsScheduleScheduledJobIdScheduleRouteRoute:
      DashboardJobsDeploymentsScheduleScheduledJobIdScheduleRouteRoute,
    DashboardJobsDeploymentsScheduleScheduledJobIdIndexRoute:
      DashboardJobsDeploymentsScheduleScheduledJobIdIndexRoute,
  }

const DashboardJobsDeploymentsScheduleScheduledJobIdRouteRouteWithChildren =
  DashboardJobsDeploymentsScheduleScheduledJobIdRouteRoute._addFileChildren(
    DashboardJobsDeploymentsScheduleScheduledJobIdRouteRouteChildren,
  )

interface DashboardJobsDeploymentsScheduleRouteRouteChildren {
  DashboardJobsDeploymentsScheduleScheduledJobIdRouteRoute: typeof DashboardJobsDeploymentsScheduleScheduledJobIdRouteRouteWithChildren
}

const DashboardJobsDeploymentsScheduleRouteRouteChildren: DashboardJobsDeploymentsScheduleRouteRouteChildren =
  {
    DashboardJobsDeploymentsScheduleScheduledJobIdRouteRoute:
      DashboardJobsDeploymentsScheduleScheduledJobIdRouteRouteWithChildren,
  }

const DashboardJobsDeploymentsScheduleRouteRouteWithChildren =
  DashboardJobsDeploymentsScheduleRouteRoute._addFileChildren(
    DashboardJobsDeploymentsScheduleRouteRouteChildren,
  )

interface DashboardJobsDeploymentsRouteRouteChildren {
  DashboardJobsDeploymentsJobsRouteRoute: typeof DashboardJobsDeploymentsJobsRouteRouteWithChildren
  DashboardJobsDeploymentsScheduleRouteRoute: typeof DashboardJobsDeploymentsScheduleRouteRouteWithChildren
  DashboardJobsDeploymentsIndexRoute: typeof DashboardJobsDeploymentsIndexRoute
}

const DashboardJobsDeploymentsRouteRouteChildren: DashboardJobsDeploymentsRouteRouteChildren =
  {
    DashboardJobsDeploymentsJobsRouteRoute:
      DashboardJobsDeploymentsJobsRouteRouteWithChildren,
    DashboardJobsDeploymentsScheduleRouteRoute:
      DashboardJobsDeploymentsScheduleRouteRouteWithChildren,
    DashboardJobsDeploymentsIndexRoute: DashboardJobsDeploymentsIndexRoute,
  }

const DashboardJobsDeploymentsRouteRouteWithChildren =
  DashboardJobsDeploymentsRouteRoute._addFileChildren(
    DashboardJobsDeploymentsRouteRouteChildren,
  )

interface DashboardJobsHeadBlurImagesJobsJobIdRouteRouteChildren {
  DashboardJobsHeadBlurImagesJobsJobIdDevicesRouteRoute: typeof DashboardJobsHeadBlurImagesJobsJobIdDevicesRouteRoute
  DashboardJobsHeadBlurImagesJobsJobIdOverviewRouteRoute: typeof DashboardJobsHeadBlurImagesJobsJobIdOverviewRouteRoute
  DashboardJobsHeadBlurImagesJobsJobIdIndexRoute: typeof DashboardJobsHeadBlurImagesJobsJobIdIndexRoute
}

const DashboardJobsHeadBlurImagesJobsJobIdRouteRouteChildren: DashboardJobsHeadBlurImagesJobsJobIdRouteRouteChildren =
  {
    DashboardJobsHeadBlurImagesJobsJobIdDevicesRouteRoute:
      DashboardJobsHeadBlurImagesJobsJobIdDevicesRouteRoute,
    DashboardJobsHeadBlurImagesJobsJobIdOverviewRouteRoute:
      DashboardJobsHeadBlurImagesJobsJobIdOverviewRouteRoute,
    DashboardJobsHeadBlurImagesJobsJobIdIndexRoute:
      DashboardJobsHeadBlurImagesJobsJobIdIndexRoute,
  }

const DashboardJobsHeadBlurImagesJobsJobIdRouteRouteWithChildren =
  DashboardJobsHeadBlurImagesJobsJobIdRouteRoute._addFileChildren(
    DashboardJobsHeadBlurImagesJobsJobIdRouteRouteChildren,
  )

interface DashboardJobsHeadBlurImagesJobsRouteRouteChildren {
  DashboardJobsHeadBlurImagesJobsJobIdRouteRoute: typeof DashboardJobsHeadBlurImagesJobsJobIdRouteRouteWithChildren
}

const DashboardJobsHeadBlurImagesJobsRouteRouteChildren: DashboardJobsHeadBlurImagesJobsRouteRouteChildren =
  {
    DashboardJobsHeadBlurImagesJobsJobIdRouteRoute:
      DashboardJobsHeadBlurImagesJobsJobIdRouteRouteWithChildren,
  }

const DashboardJobsHeadBlurImagesJobsRouteRouteWithChildren =
  DashboardJobsHeadBlurImagesJobsRouteRoute._addFileChildren(
    DashboardJobsHeadBlurImagesJobsRouteRouteChildren,
  )

interface DashboardJobsHeadBlurImagesScheduleScheduledJobIdRouteRouteChildren {
  DashboardJobsHeadBlurImagesScheduleScheduledJobIdInputsRouteRoute: typeof DashboardJobsHeadBlurImagesScheduleScheduledJobIdInputsRouteRoute
  DashboardJobsHeadBlurImagesScheduleScheduledJobIdOverviewRouteRoute: typeof DashboardJobsHeadBlurImagesScheduleScheduledJobIdOverviewRouteRoute
  DashboardJobsHeadBlurImagesScheduleScheduledJobIdScheduleRouteRoute: typeof DashboardJobsHeadBlurImagesScheduleScheduledJobIdScheduleRouteRoute
  DashboardJobsHeadBlurImagesScheduleScheduledJobIdIndexRoute: typeof DashboardJobsHeadBlurImagesScheduleScheduledJobIdIndexRoute
}

const DashboardJobsHeadBlurImagesScheduleScheduledJobIdRouteRouteChildren: DashboardJobsHeadBlurImagesScheduleScheduledJobIdRouteRouteChildren =
  {
    DashboardJobsHeadBlurImagesScheduleScheduledJobIdInputsRouteRoute:
      DashboardJobsHeadBlurImagesScheduleScheduledJobIdInputsRouteRoute,
    DashboardJobsHeadBlurImagesScheduleScheduledJobIdOverviewRouteRoute:
      DashboardJobsHeadBlurImagesScheduleScheduledJobIdOverviewRouteRoute,
    DashboardJobsHeadBlurImagesScheduleScheduledJobIdScheduleRouteRoute:
      DashboardJobsHeadBlurImagesScheduleScheduledJobIdScheduleRouteRoute,
    DashboardJobsHeadBlurImagesScheduleScheduledJobIdIndexRoute:
      DashboardJobsHeadBlurImagesScheduleScheduledJobIdIndexRoute,
  }

const DashboardJobsHeadBlurImagesScheduleScheduledJobIdRouteRouteWithChildren =
  DashboardJobsHeadBlurImagesScheduleScheduledJobIdRouteRoute._addFileChildren(
    DashboardJobsHeadBlurImagesScheduleScheduledJobIdRouteRouteChildren,
  )

interface DashboardJobsHeadBlurImagesScheduleRouteRouteChildren {
  DashboardJobsHeadBlurImagesScheduleScheduledJobIdRouteRoute: typeof DashboardJobsHeadBlurImagesScheduleScheduledJobIdRouteRouteWithChildren
}

const DashboardJobsHeadBlurImagesScheduleRouteRouteChildren: DashboardJobsHeadBlurImagesScheduleRouteRouteChildren =
  {
    DashboardJobsHeadBlurImagesScheduleScheduledJobIdRouteRoute:
      DashboardJobsHeadBlurImagesScheduleScheduledJobIdRouteRouteWithChildren,
  }

const DashboardJobsHeadBlurImagesScheduleRouteRouteWithChildren =
  DashboardJobsHeadBlurImagesScheduleRouteRoute._addFileChildren(
    DashboardJobsHeadBlurImagesScheduleRouteRouteChildren,
  )

interface DashboardJobsHeadBlurImagesRouteRouteChildren {
  DashboardJobsHeadBlurImagesJobsRouteRoute: typeof DashboardJobsHeadBlurImagesJobsRouteRouteWithChildren
  DashboardJobsHeadBlurImagesScheduleRouteRoute: typeof DashboardJobsHeadBlurImagesScheduleRouteRouteWithChildren
  DashboardJobsHeadBlurImagesIndexRoute: typeof DashboardJobsHeadBlurImagesIndexRoute
}

const DashboardJobsHeadBlurImagesRouteRouteChildren: DashboardJobsHeadBlurImagesRouteRouteChildren =
  {
    DashboardJobsHeadBlurImagesJobsRouteRoute:
      DashboardJobsHeadBlurImagesJobsRouteRouteWithChildren,
    DashboardJobsHeadBlurImagesScheduleRouteRoute:
      DashboardJobsHeadBlurImagesScheduleRouteRouteWithChildren,
    DashboardJobsHeadBlurImagesIndexRoute:
      DashboardJobsHeadBlurImagesIndexRoute,
  }

const DashboardJobsHeadBlurImagesRouteRouteWithChildren =
  DashboardJobsHeadBlurImagesRouteRoute._addFileChildren(
    DashboardJobsHeadBlurImagesRouteRouteChildren,
  )

interface DashboardJobsHeadBlurVideosJobsJobIdRouteRouteChildren {
  DashboardJobsHeadBlurVideosJobsJobIdDevicesRouteRoute: typeof DashboardJobsHeadBlurVideosJobsJobIdDevicesRouteRoute
  DashboardJobsHeadBlurVideosJobsJobIdOverviewRouteRoute: typeof DashboardJobsHeadBlurVideosJobsJobIdOverviewRouteRoute
  DashboardJobsHeadBlurVideosJobsJobIdIndexRoute: typeof DashboardJobsHeadBlurVideosJobsJobIdIndexRoute
}

const DashboardJobsHeadBlurVideosJobsJobIdRouteRouteChildren: DashboardJobsHeadBlurVideosJobsJobIdRouteRouteChildren =
  {
    DashboardJobsHeadBlurVideosJobsJobIdDevicesRouteRoute:
      DashboardJobsHeadBlurVideosJobsJobIdDevicesRouteRoute,
    DashboardJobsHeadBlurVideosJobsJobIdOverviewRouteRoute:
      DashboardJobsHeadBlurVideosJobsJobIdOverviewRouteRoute,
    DashboardJobsHeadBlurVideosJobsJobIdIndexRoute:
      DashboardJobsHeadBlurVideosJobsJobIdIndexRoute,
  }

const DashboardJobsHeadBlurVideosJobsJobIdRouteRouteWithChildren =
  DashboardJobsHeadBlurVideosJobsJobIdRouteRoute._addFileChildren(
    DashboardJobsHeadBlurVideosJobsJobIdRouteRouteChildren,
  )

interface DashboardJobsHeadBlurVideosJobsRouteRouteChildren {
  DashboardJobsHeadBlurVideosJobsJobIdRouteRoute: typeof DashboardJobsHeadBlurVideosJobsJobIdRouteRouteWithChildren
}

const DashboardJobsHeadBlurVideosJobsRouteRouteChildren: DashboardJobsHeadBlurVideosJobsRouteRouteChildren =
  {
    DashboardJobsHeadBlurVideosJobsJobIdRouteRoute:
      DashboardJobsHeadBlurVideosJobsJobIdRouteRouteWithChildren,
  }

const DashboardJobsHeadBlurVideosJobsRouteRouteWithChildren =
  DashboardJobsHeadBlurVideosJobsRouteRoute._addFileChildren(
    DashboardJobsHeadBlurVideosJobsRouteRouteChildren,
  )

interface DashboardJobsHeadBlurVideosScheduleScheduledJobIdRouteRouteChildren {
  DashboardJobsHeadBlurVideosScheduleScheduledJobIdInputsRouteRoute: typeof DashboardJobsHeadBlurVideosScheduleScheduledJobIdInputsRouteRoute
  DashboardJobsHeadBlurVideosScheduleScheduledJobIdOverviewRouteRoute: typeof DashboardJobsHeadBlurVideosScheduleScheduledJobIdOverviewRouteRoute
  DashboardJobsHeadBlurVideosScheduleScheduledJobIdScheduleRouteRoute: typeof DashboardJobsHeadBlurVideosScheduleScheduledJobIdScheduleRouteRoute
  DashboardJobsHeadBlurVideosScheduleScheduledJobIdIndexRoute: typeof DashboardJobsHeadBlurVideosScheduleScheduledJobIdIndexRoute
}

const DashboardJobsHeadBlurVideosScheduleScheduledJobIdRouteRouteChildren: DashboardJobsHeadBlurVideosScheduleScheduledJobIdRouteRouteChildren =
  {
    DashboardJobsHeadBlurVideosScheduleScheduledJobIdInputsRouteRoute:
      DashboardJobsHeadBlurVideosScheduleScheduledJobIdInputsRouteRoute,
    DashboardJobsHeadBlurVideosScheduleScheduledJobIdOverviewRouteRoute:
      DashboardJobsHeadBlurVideosScheduleScheduledJobIdOverviewRouteRoute,
    DashboardJobsHeadBlurVideosScheduleScheduledJobIdScheduleRouteRoute:
      DashboardJobsHeadBlurVideosScheduleScheduledJobIdScheduleRouteRoute,
    DashboardJobsHeadBlurVideosScheduleScheduledJobIdIndexRoute:
      DashboardJobsHeadBlurVideosScheduleScheduledJobIdIndexRoute,
  }

const DashboardJobsHeadBlurVideosScheduleScheduledJobIdRouteRouteWithChildren =
  DashboardJobsHeadBlurVideosScheduleScheduledJobIdRouteRoute._addFileChildren(
    DashboardJobsHeadBlurVideosScheduleScheduledJobIdRouteRouteChildren,
  )

interface DashboardJobsHeadBlurVideosScheduleRouteRouteChildren {
  DashboardJobsHeadBlurVideosScheduleScheduledJobIdRouteRoute: typeof DashboardJobsHeadBlurVideosScheduleScheduledJobIdRouteRouteWithChildren
}

const DashboardJobsHeadBlurVideosScheduleRouteRouteChildren: DashboardJobsHeadBlurVideosScheduleRouteRouteChildren =
  {
    DashboardJobsHeadBlurVideosScheduleScheduledJobIdRouteRoute:
      DashboardJobsHeadBlurVideosScheduleScheduledJobIdRouteRouteWithChildren,
  }

const DashboardJobsHeadBlurVideosScheduleRouteRouteWithChildren =
  DashboardJobsHeadBlurVideosScheduleRouteRoute._addFileChildren(
    DashboardJobsHeadBlurVideosScheduleRouteRouteChildren,
  )

interface DashboardJobsHeadBlurVideosRouteRouteChildren {
  DashboardJobsHeadBlurVideosJobsRouteRoute: typeof DashboardJobsHeadBlurVideosJobsRouteRouteWithChildren
  DashboardJobsHeadBlurVideosScheduleRouteRoute: typeof DashboardJobsHeadBlurVideosScheduleRouteRouteWithChildren
  DashboardJobsHeadBlurVideosIndexRoute: typeof DashboardJobsHeadBlurVideosIndexRoute
}

const DashboardJobsHeadBlurVideosRouteRouteChildren: DashboardJobsHeadBlurVideosRouteRouteChildren =
  {
    DashboardJobsHeadBlurVideosJobsRouteRoute:
      DashboardJobsHeadBlurVideosJobsRouteRouteWithChildren,
    DashboardJobsHeadBlurVideosScheduleRouteRoute:
      DashboardJobsHeadBlurVideosScheduleRouteRouteWithChildren,
    DashboardJobsHeadBlurVideosIndexRoute:
      DashboardJobsHeadBlurVideosIndexRoute,
  }

const DashboardJobsHeadBlurVideosRouteRouteWithChildren =
  DashboardJobsHeadBlurVideosRouteRoute._addFileChildren(
    DashboardJobsHeadBlurVideosRouteRouteChildren,
  )

interface DashboardJobsModelsJobsJobIdRouteRouteChildren {
  DashboardJobsModelsJobsJobIdDevicesRouteRoute: typeof DashboardJobsModelsJobsJobIdDevicesRouteRoute
  DashboardJobsModelsJobsJobIdOverviewRouteRoute: typeof DashboardJobsModelsJobsJobIdOverviewRouteRoute
  DashboardJobsModelsJobsJobIdIndexRoute: typeof DashboardJobsModelsJobsJobIdIndexRoute
}

const DashboardJobsModelsJobsJobIdRouteRouteChildren: DashboardJobsModelsJobsJobIdRouteRouteChildren =
  {
    DashboardJobsModelsJobsJobIdDevicesRouteRoute:
      DashboardJobsModelsJobsJobIdDevicesRouteRoute,
    DashboardJobsModelsJobsJobIdOverviewRouteRoute:
      DashboardJobsModelsJobsJobIdOverviewRouteRoute,
    DashboardJobsModelsJobsJobIdIndexRoute:
      DashboardJobsModelsJobsJobIdIndexRoute,
  }

const DashboardJobsModelsJobsJobIdRouteRouteWithChildren =
  DashboardJobsModelsJobsJobIdRouteRoute._addFileChildren(
    DashboardJobsModelsJobsJobIdRouteRouteChildren,
  )

interface DashboardJobsModelsJobsRouteRouteChildren {
  DashboardJobsModelsJobsJobIdRouteRoute: typeof DashboardJobsModelsJobsJobIdRouteRouteWithChildren
}

const DashboardJobsModelsJobsRouteRouteChildren: DashboardJobsModelsJobsRouteRouteChildren =
  {
    DashboardJobsModelsJobsJobIdRouteRoute:
      DashboardJobsModelsJobsJobIdRouteRouteWithChildren,
  }

const DashboardJobsModelsJobsRouteRouteWithChildren =
  DashboardJobsModelsJobsRouteRoute._addFileChildren(
    DashboardJobsModelsJobsRouteRouteChildren,
  )

interface DashboardJobsModelsScheduleScheduledJobIdRouteRouteChildren {
  DashboardJobsModelsScheduleScheduledJobIdOverviewRouteRoute: typeof DashboardJobsModelsScheduleScheduledJobIdOverviewRouteRoute
  DashboardJobsModelsScheduleScheduledJobIdScheduleRouteRoute: typeof DashboardJobsModelsScheduleScheduledJobIdScheduleRouteRoute
  DashboardJobsModelsScheduleScheduledJobIdIndexRoute: typeof DashboardJobsModelsScheduleScheduledJobIdIndexRoute
}

const DashboardJobsModelsScheduleScheduledJobIdRouteRouteChildren: DashboardJobsModelsScheduleScheduledJobIdRouteRouteChildren =
  {
    DashboardJobsModelsScheduleScheduledJobIdOverviewRouteRoute:
      DashboardJobsModelsScheduleScheduledJobIdOverviewRouteRoute,
    DashboardJobsModelsScheduleScheduledJobIdScheduleRouteRoute:
      DashboardJobsModelsScheduleScheduledJobIdScheduleRouteRoute,
    DashboardJobsModelsScheduleScheduledJobIdIndexRoute:
      DashboardJobsModelsScheduleScheduledJobIdIndexRoute,
  }

const DashboardJobsModelsScheduleScheduledJobIdRouteRouteWithChildren =
  DashboardJobsModelsScheduleScheduledJobIdRouteRoute._addFileChildren(
    DashboardJobsModelsScheduleScheduledJobIdRouteRouteChildren,
  )

interface DashboardJobsModelsScheduleRouteRouteChildren {
  DashboardJobsModelsScheduleScheduledJobIdRouteRoute: typeof DashboardJobsModelsScheduleScheduledJobIdRouteRouteWithChildren
}

const DashboardJobsModelsScheduleRouteRouteChildren: DashboardJobsModelsScheduleRouteRouteChildren =
  {
    DashboardJobsModelsScheduleScheduledJobIdRouteRoute:
      DashboardJobsModelsScheduleScheduledJobIdRouteRouteWithChildren,
  }

const DashboardJobsModelsScheduleRouteRouteWithChildren =
  DashboardJobsModelsScheduleRouteRoute._addFileChildren(
    DashboardJobsModelsScheduleRouteRouteChildren,
  )

interface DashboardJobsModelsRouteRouteChildren {
  DashboardJobsModelsJobsRouteRoute: typeof DashboardJobsModelsJobsRouteRouteWithChildren
  DashboardJobsModelsScheduleRouteRoute: typeof DashboardJobsModelsScheduleRouteRouteWithChildren
  DashboardJobsModelsIndexRoute: typeof DashboardJobsModelsIndexRoute
}

const DashboardJobsModelsRouteRouteChildren: DashboardJobsModelsRouteRouteChildren =
  {
    DashboardJobsModelsJobsRouteRoute:
      DashboardJobsModelsJobsRouteRouteWithChildren,
    DashboardJobsModelsScheduleRouteRoute:
      DashboardJobsModelsScheduleRouteRouteWithChildren,
    DashboardJobsModelsIndexRoute: DashboardJobsModelsIndexRoute,
  }

const DashboardJobsModelsRouteRouteWithChildren =
  DashboardJobsModelsRouteRoute._addFileChildren(
    DashboardJobsModelsRouteRouteChildren,
  )

interface DashboardJobsRecoveryEstimatesJobsJobIdRouteRouteChildren {
  DashboardJobsRecoveryEstimatesJobsJobIdOverviewRouteRoute: typeof DashboardJobsRecoveryEstimatesJobsJobIdOverviewRouteRoute
  DashboardJobsRecoveryEstimatesJobsJobIdIndexRoute: typeof DashboardJobsRecoveryEstimatesJobsJobIdIndexRoute
}

const DashboardJobsRecoveryEstimatesJobsJobIdRouteRouteChildren: DashboardJobsRecoveryEstimatesJobsJobIdRouteRouteChildren =
  {
    DashboardJobsRecoveryEstimatesJobsJobIdOverviewRouteRoute:
      DashboardJobsRecoveryEstimatesJobsJobIdOverviewRouteRoute,
    DashboardJobsRecoveryEstimatesJobsJobIdIndexRoute:
      DashboardJobsRecoveryEstimatesJobsJobIdIndexRoute,
  }

const DashboardJobsRecoveryEstimatesJobsJobIdRouteRouteWithChildren =
  DashboardJobsRecoveryEstimatesJobsJobIdRouteRoute._addFileChildren(
    DashboardJobsRecoveryEstimatesJobsJobIdRouteRouteChildren,
  )

interface DashboardJobsRecoveryEstimatesJobsRouteRouteChildren {
  DashboardJobsRecoveryEstimatesJobsJobIdRouteRoute: typeof DashboardJobsRecoveryEstimatesJobsJobIdRouteRouteWithChildren
}

const DashboardJobsRecoveryEstimatesJobsRouteRouteChildren: DashboardJobsRecoveryEstimatesJobsRouteRouteChildren =
  {
    DashboardJobsRecoveryEstimatesJobsJobIdRouteRoute:
      DashboardJobsRecoveryEstimatesJobsJobIdRouteRouteWithChildren,
  }

const DashboardJobsRecoveryEstimatesJobsRouteRouteWithChildren =
  DashboardJobsRecoveryEstimatesJobsRouteRoute._addFileChildren(
    DashboardJobsRecoveryEstimatesJobsRouteRouteChildren,
  )

interface DashboardJobsRecoveryEstimatesScheduleScheduledJobIdRouteRouteChildren {
  DashboardJobsRecoveryEstimatesScheduleScheduledJobIdInputsRouteRoute: typeof DashboardJobsRecoveryEstimatesScheduleScheduledJobIdInputsRouteRoute
  DashboardJobsRecoveryEstimatesScheduleScheduledJobIdOverviewRouteRoute: typeof DashboardJobsRecoveryEstimatesScheduleScheduledJobIdOverviewRouteRoute
  DashboardJobsRecoveryEstimatesScheduleScheduledJobIdScheduleRouteRoute: typeof DashboardJobsRecoveryEstimatesScheduleScheduledJobIdScheduleRouteRoute
  DashboardJobsRecoveryEstimatesScheduleScheduledJobIdIndexRoute: typeof DashboardJobsRecoveryEstimatesScheduleScheduledJobIdIndexRoute
}

const DashboardJobsRecoveryEstimatesScheduleScheduledJobIdRouteRouteChildren: DashboardJobsRecoveryEstimatesScheduleScheduledJobIdRouteRouteChildren =
  {
    DashboardJobsRecoveryEstimatesScheduleScheduledJobIdInputsRouteRoute:
      DashboardJobsRecoveryEstimatesScheduleScheduledJobIdInputsRouteRoute,
    DashboardJobsRecoveryEstimatesScheduleScheduledJobIdOverviewRouteRoute:
      DashboardJobsRecoveryEstimatesScheduleScheduledJobIdOverviewRouteRoute,
    DashboardJobsRecoveryEstimatesScheduleScheduledJobIdScheduleRouteRoute:
      DashboardJobsRecoveryEstimatesScheduleScheduledJobIdScheduleRouteRoute,
    DashboardJobsRecoveryEstimatesScheduleScheduledJobIdIndexRoute:
      DashboardJobsRecoveryEstimatesScheduleScheduledJobIdIndexRoute,
  }

const DashboardJobsRecoveryEstimatesScheduleScheduledJobIdRouteRouteWithChildren =
  DashboardJobsRecoveryEstimatesScheduleScheduledJobIdRouteRoute._addFileChildren(
    DashboardJobsRecoveryEstimatesScheduleScheduledJobIdRouteRouteChildren,
  )

interface DashboardJobsRecoveryEstimatesScheduleRouteRouteChildren {
  DashboardJobsRecoveryEstimatesScheduleScheduledJobIdRouteRoute: typeof DashboardJobsRecoveryEstimatesScheduleScheduledJobIdRouteRouteWithChildren
}

const DashboardJobsRecoveryEstimatesScheduleRouteRouteChildren: DashboardJobsRecoveryEstimatesScheduleRouteRouteChildren =
  {
    DashboardJobsRecoveryEstimatesScheduleScheduledJobIdRouteRoute:
      DashboardJobsRecoveryEstimatesScheduleScheduledJobIdRouteRouteWithChildren,
  }

const DashboardJobsRecoveryEstimatesScheduleRouteRouteWithChildren =
  DashboardJobsRecoveryEstimatesScheduleRouteRoute._addFileChildren(
    DashboardJobsRecoveryEstimatesScheduleRouteRouteChildren,
  )

interface DashboardJobsRecoveryEstimatesRouteRouteChildren {
  DashboardJobsRecoveryEstimatesJobsRouteRoute: typeof DashboardJobsRecoveryEstimatesJobsRouteRouteWithChildren
  DashboardJobsRecoveryEstimatesScheduleRouteRoute: typeof DashboardJobsRecoveryEstimatesScheduleRouteRouteWithChildren
  DashboardJobsRecoveryEstimatesIndexRoute: typeof DashboardJobsRecoveryEstimatesIndexRoute
}

const DashboardJobsRecoveryEstimatesRouteRouteChildren: DashboardJobsRecoveryEstimatesRouteRouteChildren =
  {
    DashboardJobsRecoveryEstimatesJobsRouteRoute:
      DashboardJobsRecoveryEstimatesJobsRouteRouteWithChildren,
    DashboardJobsRecoveryEstimatesScheduleRouteRoute:
      DashboardJobsRecoveryEstimatesScheduleRouteRouteWithChildren,
    DashboardJobsRecoveryEstimatesIndexRoute:
      DashboardJobsRecoveryEstimatesIndexRoute,
  }

const DashboardJobsRecoveryEstimatesRouteRouteWithChildren =
  DashboardJobsRecoveryEstimatesRouteRoute._addFileChildren(
    DashboardJobsRecoveryEstimatesRouteRouteChildren,
  )

interface DashboardJobsRestartsJobsJobIdRouteRouteChildren {
  DashboardJobsRestartsJobsJobIdDevicesRouteRoute: typeof DashboardJobsRestartsJobsJobIdDevicesRouteRoute
  DashboardJobsRestartsJobsJobIdOverviewRouteRoute: typeof DashboardJobsRestartsJobsJobIdOverviewRouteRoute
  DashboardJobsRestartsJobsJobIdIndexRoute: typeof DashboardJobsRestartsJobsJobIdIndexRoute
}

const DashboardJobsRestartsJobsJobIdRouteRouteChildren: DashboardJobsRestartsJobsJobIdRouteRouteChildren =
  {
    DashboardJobsRestartsJobsJobIdDevicesRouteRoute:
      DashboardJobsRestartsJobsJobIdDevicesRouteRoute,
    DashboardJobsRestartsJobsJobIdOverviewRouteRoute:
      DashboardJobsRestartsJobsJobIdOverviewRouteRoute,
    DashboardJobsRestartsJobsJobIdIndexRoute:
      DashboardJobsRestartsJobsJobIdIndexRoute,
  }

const DashboardJobsRestartsJobsJobIdRouteRouteWithChildren =
  DashboardJobsRestartsJobsJobIdRouteRoute._addFileChildren(
    DashboardJobsRestartsJobsJobIdRouteRouteChildren,
  )

interface DashboardJobsRestartsJobsRouteRouteChildren {
  DashboardJobsRestartsJobsJobIdRouteRoute: typeof DashboardJobsRestartsJobsJobIdRouteRouteWithChildren
}

const DashboardJobsRestartsJobsRouteRouteChildren: DashboardJobsRestartsJobsRouteRouteChildren =
  {
    DashboardJobsRestartsJobsJobIdRouteRoute:
      DashboardJobsRestartsJobsJobIdRouteRouteWithChildren,
  }

const DashboardJobsRestartsJobsRouteRouteWithChildren =
  DashboardJobsRestartsJobsRouteRoute._addFileChildren(
    DashboardJobsRestartsJobsRouteRouteChildren,
  )

interface DashboardJobsRestartsScheduleScheduledJobIdRouteRouteChildren {
  DashboardJobsRestartsScheduleScheduledJobIdOverviewRouteRoute: typeof DashboardJobsRestartsScheduleScheduledJobIdOverviewRouteRoute
  DashboardJobsRestartsScheduleScheduledJobIdScheduleRouteRoute: typeof DashboardJobsRestartsScheduleScheduledJobIdScheduleRouteRoute
  DashboardJobsRestartsScheduleScheduledJobIdIndexRoute: typeof DashboardJobsRestartsScheduleScheduledJobIdIndexRoute
}

const DashboardJobsRestartsScheduleScheduledJobIdRouteRouteChildren: DashboardJobsRestartsScheduleScheduledJobIdRouteRouteChildren =
  {
    DashboardJobsRestartsScheduleScheduledJobIdOverviewRouteRoute:
      DashboardJobsRestartsScheduleScheduledJobIdOverviewRouteRoute,
    DashboardJobsRestartsScheduleScheduledJobIdScheduleRouteRoute:
      DashboardJobsRestartsScheduleScheduledJobIdScheduleRouteRoute,
    DashboardJobsRestartsScheduleScheduledJobIdIndexRoute:
      DashboardJobsRestartsScheduleScheduledJobIdIndexRoute,
  }

const DashboardJobsRestartsScheduleScheduledJobIdRouteRouteWithChildren =
  DashboardJobsRestartsScheduleScheduledJobIdRouteRoute._addFileChildren(
    DashboardJobsRestartsScheduleScheduledJobIdRouteRouteChildren,
  )

interface DashboardJobsRestartsScheduleRouteRouteChildren {
  DashboardJobsRestartsScheduleScheduledJobIdRouteRoute: typeof DashboardJobsRestartsScheduleScheduledJobIdRouteRouteWithChildren
}

const DashboardJobsRestartsScheduleRouteRouteChildren: DashboardJobsRestartsScheduleRouteRouteChildren =
  {
    DashboardJobsRestartsScheduleScheduledJobIdRouteRoute:
      DashboardJobsRestartsScheduleScheduledJobIdRouteRouteWithChildren,
  }

const DashboardJobsRestartsScheduleRouteRouteWithChildren =
  DashboardJobsRestartsScheduleRouteRoute._addFileChildren(
    DashboardJobsRestartsScheduleRouteRouteChildren,
  )

interface DashboardJobsRestartsRouteRouteChildren {
  DashboardJobsRestartsJobsRouteRoute: typeof DashboardJobsRestartsJobsRouteRouteWithChildren
  DashboardJobsRestartsScheduleRouteRoute: typeof DashboardJobsRestartsScheduleRouteRouteWithChildren
  DashboardJobsRestartsIndexRoute: typeof DashboardJobsRestartsIndexRoute
}

const DashboardJobsRestartsRouteRouteChildren: DashboardJobsRestartsRouteRouteChildren =
  {
    DashboardJobsRestartsJobsRouteRoute:
      DashboardJobsRestartsJobsRouteRouteWithChildren,
    DashboardJobsRestartsScheduleRouteRoute:
      DashboardJobsRestartsScheduleRouteRouteWithChildren,
    DashboardJobsRestartsIndexRoute: DashboardJobsRestartsIndexRoute,
  }

const DashboardJobsRestartsRouteRouteWithChildren =
  DashboardJobsRestartsRouteRoute._addFileChildren(
    DashboardJobsRestartsRouteRouteChildren,
  )

interface DashboardJobsSampleUploadJobsJobIdRouteRouteChildren {
  DashboardJobsSampleUploadJobsJobIdDevicesRouteRoute: typeof DashboardJobsSampleUploadJobsJobIdDevicesRouteRoute
  DashboardJobsSampleUploadJobsJobIdOverviewRouteRoute: typeof DashboardJobsSampleUploadJobsJobIdOverviewRouteRoute
  DashboardJobsSampleUploadJobsJobIdIndexRoute: typeof DashboardJobsSampleUploadJobsJobIdIndexRoute
}

const DashboardJobsSampleUploadJobsJobIdRouteRouteChildren: DashboardJobsSampleUploadJobsJobIdRouteRouteChildren =
  {
    DashboardJobsSampleUploadJobsJobIdDevicesRouteRoute:
      DashboardJobsSampleUploadJobsJobIdDevicesRouteRoute,
    DashboardJobsSampleUploadJobsJobIdOverviewRouteRoute:
      DashboardJobsSampleUploadJobsJobIdOverviewRouteRoute,
    DashboardJobsSampleUploadJobsJobIdIndexRoute:
      DashboardJobsSampleUploadJobsJobIdIndexRoute,
  }

const DashboardJobsSampleUploadJobsJobIdRouteRouteWithChildren =
  DashboardJobsSampleUploadJobsJobIdRouteRoute._addFileChildren(
    DashboardJobsSampleUploadJobsJobIdRouteRouteChildren,
  )

interface DashboardJobsSampleUploadJobsRouteRouteChildren {
  DashboardJobsSampleUploadJobsJobIdRouteRoute: typeof DashboardJobsSampleUploadJobsJobIdRouteRouteWithChildren
}

const DashboardJobsSampleUploadJobsRouteRouteChildren: DashboardJobsSampleUploadJobsRouteRouteChildren =
  {
    DashboardJobsSampleUploadJobsJobIdRouteRoute:
      DashboardJobsSampleUploadJobsJobIdRouteRouteWithChildren,
  }

const DashboardJobsSampleUploadJobsRouteRouteWithChildren =
  DashboardJobsSampleUploadJobsRouteRoute._addFileChildren(
    DashboardJobsSampleUploadJobsRouteRouteChildren,
  )

interface DashboardJobsSampleUploadScheduleScheduledJobIdRouteRouteChildren {
  DashboardJobsSampleUploadScheduleScheduledJobIdInputsRouteRoute: typeof DashboardJobsSampleUploadScheduleScheduledJobIdInputsRouteRoute
  DashboardJobsSampleUploadScheduleScheduledJobIdOverviewRouteRoute: typeof DashboardJobsSampleUploadScheduleScheduledJobIdOverviewRouteRoute
  DashboardJobsSampleUploadScheduleScheduledJobIdScheduleRouteRoute: typeof DashboardJobsSampleUploadScheduleScheduledJobIdScheduleRouteRoute
  DashboardJobsSampleUploadScheduleScheduledJobIdIndexRoute: typeof DashboardJobsSampleUploadScheduleScheduledJobIdIndexRoute
}

const DashboardJobsSampleUploadScheduleScheduledJobIdRouteRouteChildren: DashboardJobsSampleUploadScheduleScheduledJobIdRouteRouteChildren =
  {
    DashboardJobsSampleUploadScheduleScheduledJobIdInputsRouteRoute:
      DashboardJobsSampleUploadScheduleScheduledJobIdInputsRouteRoute,
    DashboardJobsSampleUploadScheduleScheduledJobIdOverviewRouteRoute:
      DashboardJobsSampleUploadScheduleScheduledJobIdOverviewRouteRoute,
    DashboardJobsSampleUploadScheduleScheduledJobIdScheduleRouteRoute:
      DashboardJobsSampleUploadScheduleScheduledJobIdScheduleRouteRoute,
    DashboardJobsSampleUploadScheduleScheduledJobIdIndexRoute:
      DashboardJobsSampleUploadScheduleScheduledJobIdIndexRoute,
  }

const DashboardJobsSampleUploadScheduleScheduledJobIdRouteRouteWithChildren =
  DashboardJobsSampleUploadScheduleScheduledJobIdRouteRoute._addFileChildren(
    DashboardJobsSampleUploadScheduleScheduledJobIdRouteRouteChildren,
  )

interface DashboardJobsSampleUploadScheduleRouteRouteChildren {
  DashboardJobsSampleUploadScheduleScheduledJobIdRouteRoute: typeof DashboardJobsSampleUploadScheduleScheduledJobIdRouteRouteWithChildren
}

const DashboardJobsSampleUploadScheduleRouteRouteChildren: DashboardJobsSampleUploadScheduleRouteRouteChildren =
  {
    DashboardJobsSampleUploadScheduleScheduledJobIdRouteRoute:
      DashboardJobsSampleUploadScheduleScheduledJobIdRouteRouteWithChildren,
  }

const DashboardJobsSampleUploadScheduleRouteRouteWithChildren =
  DashboardJobsSampleUploadScheduleRouteRoute._addFileChildren(
    DashboardJobsSampleUploadScheduleRouteRouteChildren,
  )

interface DashboardJobsSampleUploadRouteRouteChildren {
  DashboardJobsSampleUploadAlertsRouteRoute: typeof DashboardJobsSampleUploadAlertsRouteRoute
  DashboardJobsSampleUploadJobsRouteRoute: typeof DashboardJobsSampleUploadJobsRouteRouteWithChildren
  DashboardJobsSampleUploadScheduleRouteRoute: typeof DashboardJobsSampleUploadScheduleRouteRouteWithChildren
  DashboardJobsSampleUploadIndexRoute: typeof DashboardJobsSampleUploadIndexRoute
}

const DashboardJobsSampleUploadRouteRouteChildren: DashboardJobsSampleUploadRouteRouteChildren =
  {
    DashboardJobsSampleUploadAlertsRouteRoute:
      DashboardJobsSampleUploadAlertsRouteRoute,
    DashboardJobsSampleUploadJobsRouteRoute:
      DashboardJobsSampleUploadJobsRouteRouteWithChildren,
    DashboardJobsSampleUploadScheduleRouteRoute:
      DashboardJobsSampleUploadScheduleRouteRouteWithChildren,
    DashboardJobsSampleUploadIndexRoute: DashboardJobsSampleUploadIndexRoute,
  }

const DashboardJobsSampleUploadRouteRouteWithChildren =
  DashboardJobsSampleUploadRouteRoute._addFileChildren(
    DashboardJobsSampleUploadRouteRouteChildren,
  )

interface DashboardJobsSyncSamplesJobsJobIdRouteRouteChildren {
  DashboardJobsSyncSamplesJobsJobIdDevicesRouteRoute: typeof DashboardJobsSyncSamplesJobsJobIdDevicesRouteRoute
  DashboardJobsSyncSamplesJobsJobIdOverviewRouteRoute: typeof DashboardJobsSyncSamplesJobsJobIdOverviewRouteRoute
  DashboardJobsSyncSamplesJobsJobIdIndexRoute: typeof DashboardJobsSyncSamplesJobsJobIdIndexRoute
}

const DashboardJobsSyncSamplesJobsJobIdRouteRouteChildren: DashboardJobsSyncSamplesJobsJobIdRouteRouteChildren =
  {
    DashboardJobsSyncSamplesJobsJobIdDevicesRouteRoute:
      DashboardJobsSyncSamplesJobsJobIdDevicesRouteRoute,
    DashboardJobsSyncSamplesJobsJobIdOverviewRouteRoute:
      DashboardJobsSyncSamplesJobsJobIdOverviewRouteRoute,
    DashboardJobsSyncSamplesJobsJobIdIndexRoute:
      DashboardJobsSyncSamplesJobsJobIdIndexRoute,
  }

const DashboardJobsSyncSamplesJobsJobIdRouteRouteWithChildren =
  DashboardJobsSyncSamplesJobsJobIdRouteRoute._addFileChildren(
    DashboardJobsSyncSamplesJobsJobIdRouteRouteChildren,
  )

interface DashboardJobsSyncSamplesJobsRouteRouteChildren {
  DashboardJobsSyncSamplesJobsJobIdRouteRoute: typeof DashboardJobsSyncSamplesJobsJobIdRouteRouteWithChildren
}

const DashboardJobsSyncSamplesJobsRouteRouteChildren: DashboardJobsSyncSamplesJobsRouteRouteChildren =
  {
    DashboardJobsSyncSamplesJobsJobIdRouteRoute:
      DashboardJobsSyncSamplesJobsJobIdRouteRouteWithChildren,
  }

const DashboardJobsSyncSamplesJobsRouteRouteWithChildren =
  DashboardJobsSyncSamplesJobsRouteRoute._addFileChildren(
    DashboardJobsSyncSamplesJobsRouteRouteChildren,
  )

interface DashboardJobsSyncSamplesScheduleScheduledJobIdRouteRouteChildren {
  DashboardJobsSyncSamplesScheduleScheduledJobIdInputsRouteRoute: typeof DashboardJobsSyncSamplesScheduleScheduledJobIdInputsRouteRoute
  DashboardJobsSyncSamplesScheduleScheduledJobIdOverviewRouteRoute: typeof DashboardJobsSyncSamplesScheduleScheduledJobIdOverviewRouteRoute
  DashboardJobsSyncSamplesScheduleScheduledJobIdScheduleRouteRoute: typeof DashboardJobsSyncSamplesScheduleScheduledJobIdScheduleRouteRoute
  DashboardJobsSyncSamplesScheduleScheduledJobIdIndexRoute: typeof DashboardJobsSyncSamplesScheduleScheduledJobIdIndexRoute
}

const DashboardJobsSyncSamplesScheduleScheduledJobIdRouteRouteChildren: DashboardJobsSyncSamplesScheduleScheduledJobIdRouteRouteChildren =
  {
    DashboardJobsSyncSamplesScheduleScheduledJobIdInputsRouteRoute:
      DashboardJobsSyncSamplesScheduleScheduledJobIdInputsRouteRoute,
    DashboardJobsSyncSamplesScheduleScheduledJobIdOverviewRouteRoute:
      DashboardJobsSyncSamplesScheduleScheduledJobIdOverviewRouteRoute,
    DashboardJobsSyncSamplesScheduleScheduledJobIdScheduleRouteRoute:
      DashboardJobsSyncSamplesScheduleScheduledJobIdScheduleRouteRoute,
    DashboardJobsSyncSamplesScheduleScheduledJobIdIndexRoute:
      DashboardJobsSyncSamplesScheduleScheduledJobIdIndexRoute,
  }

const DashboardJobsSyncSamplesScheduleScheduledJobIdRouteRouteWithChildren =
  DashboardJobsSyncSamplesScheduleScheduledJobIdRouteRoute._addFileChildren(
    DashboardJobsSyncSamplesScheduleScheduledJobIdRouteRouteChildren,
  )

interface DashboardJobsSyncSamplesScheduleRouteRouteChildren {
  DashboardJobsSyncSamplesScheduleScheduledJobIdRouteRoute: typeof DashboardJobsSyncSamplesScheduleScheduledJobIdRouteRouteWithChildren
}

const DashboardJobsSyncSamplesScheduleRouteRouteChildren: DashboardJobsSyncSamplesScheduleRouteRouteChildren =
  {
    DashboardJobsSyncSamplesScheduleScheduledJobIdRouteRoute:
      DashboardJobsSyncSamplesScheduleScheduledJobIdRouteRouteWithChildren,
  }

const DashboardJobsSyncSamplesScheduleRouteRouteWithChildren =
  DashboardJobsSyncSamplesScheduleRouteRoute._addFileChildren(
    DashboardJobsSyncSamplesScheduleRouteRouteChildren,
  )

interface DashboardJobsSyncSamplesRouteRouteChildren {
  DashboardJobsSyncSamplesAlertsRouteRoute: typeof DashboardJobsSyncSamplesAlertsRouteRoute
  DashboardJobsSyncSamplesJobsRouteRoute: typeof DashboardJobsSyncSamplesJobsRouteRouteWithChildren
  DashboardJobsSyncSamplesScheduleRouteRoute: typeof DashboardJobsSyncSamplesScheduleRouteRouteWithChildren
  DashboardJobsSyncSamplesIndexRoute: typeof DashboardJobsSyncSamplesIndexRoute
}

const DashboardJobsSyncSamplesRouteRouteChildren: DashboardJobsSyncSamplesRouteRouteChildren =
  {
    DashboardJobsSyncSamplesAlertsRouteRoute:
      DashboardJobsSyncSamplesAlertsRouteRoute,
    DashboardJobsSyncSamplesJobsRouteRoute:
      DashboardJobsSyncSamplesJobsRouteRouteWithChildren,
    DashboardJobsSyncSamplesScheduleRouteRoute:
      DashboardJobsSyncSamplesScheduleRouteRouteWithChildren,
    DashboardJobsSyncSamplesIndexRoute: DashboardJobsSyncSamplesIndexRoute,
  }

const DashboardJobsSyncSamplesRouteRouteWithChildren =
  DashboardJobsSyncSamplesRouteRoute._addFileChildren(
    DashboardJobsSyncSamplesRouteRouteChildren,
  )

interface DashboardJobsTrainingJobsJobIdRouteRouteChildren {
  DashboardJobsTrainingJobsJobIdDevicesRouteRoute: typeof DashboardJobsTrainingJobsJobIdDevicesRouteRoute
  DashboardJobsTrainingJobsJobIdLabelsRouteRoute: typeof DashboardJobsTrainingJobsJobIdLabelsRouteRoute
  DashboardJobsTrainingJobsJobIdMetricsRouteRoute: typeof DashboardJobsTrainingJobsJobIdMetricsRouteRoute
  DashboardJobsTrainingJobsJobIdOverviewRouteRoute: typeof DashboardJobsTrainingJobsJobIdOverviewRouteRoute
  DashboardJobsTrainingJobsJobIdIndexRoute: typeof DashboardJobsTrainingJobsJobIdIndexRoute
}

const DashboardJobsTrainingJobsJobIdRouteRouteChildren: DashboardJobsTrainingJobsJobIdRouteRouteChildren =
  {
    DashboardJobsTrainingJobsJobIdDevicesRouteRoute:
      DashboardJobsTrainingJobsJobIdDevicesRouteRoute,
    DashboardJobsTrainingJobsJobIdLabelsRouteRoute:
      DashboardJobsTrainingJobsJobIdLabelsRouteRoute,
    DashboardJobsTrainingJobsJobIdMetricsRouteRoute:
      DashboardJobsTrainingJobsJobIdMetricsRouteRoute,
    DashboardJobsTrainingJobsJobIdOverviewRouteRoute:
      DashboardJobsTrainingJobsJobIdOverviewRouteRoute,
    DashboardJobsTrainingJobsJobIdIndexRoute:
      DashboardJobsTrainingJobsJobIdIndexRoute,
  }

const DashboardJobsTrainingJobsJobIdRouteRouteWithChildren =
  DashboardJobsTrainingJobsJobIdRouteRoute._addFileChildren(
    DashboardJobsTrainingJobsJobIdRouteRouteChildren,
  )

interface DashboardJobsTrainingJobsRouteRouteChildren {
  DashboardJobsTrainingJobsJobIdRouteRoute: typeof DashboardJobsTrainingJobsJobIdRouteRouteWithChildren
}

const DashboardJobsTrainingJobsRouteRouteChildren: DashboardJobsTrainingJobsRouteRouteChildren =
  {
    DashboardJobsTrainingJobsJobIdRouteRoute:
      DashboardJobsTrainingJobsJobIdRouteRouteWithChildren,
  }

const DashboardJobsTrainingJobsRouteRouteWithChildren =
  DashboardJobsTrainingJobsRouteRoute._addFileChildren(
    DashboardJobsTrainingJobsRouteRouteChildren,
  )

interface DashboardJobsTrainingScheduleScheduledJobIdRouteRouteChildren {
  DashboardJobsTrainingScheduleScheduledJobIdInputsRouteRoute: typeof DashboardJobsTrainingScheduleScheduledJobIdInputsRouteRoute
  DashboardJobsTrainingScheduleScheduledJobIdOverviewRouteRoute: typeof DashboardJobsTrainingScheduleScheduledJobIdOverviewRouteRoute
  DashboardJobsTrainingScheduleScheduledJobIdScheduleRouteRoute: typeof DashboardJobsTrainingScheduleScheduledJobIdScheduleRouteRoute
  DashboardJobsTrainingScheduleScheduledJobIdIndexRoute: typeof DashboardJobsTrainingScheduleScheduledJobIdIndexRoute
}

const DashboardJobsTrainingScheduleScheduledJobIdRouteRouteChildren: DashboardJobsTrainingScheduleScheduledJobIdRouteRouteChildren =
  {
    DashboardJobsTrainingScheduleScheduledJobIdInputsRouteRoute:
      DashboardJobsTrainingScheduleScheduledJobIdInputsRouteRoute,
    DashboardJobsTrainingScheduleScheduledJobIdOverviewRouteRoute:
      DashboardJobsTrainingScheduleScheduledJobIdOverviewRouteRoute,
    DashboardJobsTrainingScheduleScheduledJobIdScheduleRouteRoute:
      DashboardJobsTrainingScheduleScheduledJobIdScheduleRouteRoute,
    DashboardJobsTrainingScheduleScheduledJobIdIndexRoute:
      DashboardJobsTrainingScheduleScheduledJobIdIndexRoute,
  }

const DashboardJobsTrainingScheduleScheduledJobIdRouteRouteWithChildren =
  DashboardJobsTrainingScheduleScheduledJobIdRouteRoute._addFileChildren(
    DashboardJobsTrainingScheduleScheduledJobIdRouteRouteChildren,
  )

interface DashboardJobsTrainingScheduleRouteRouteChildren {
  DashboardJobsTrainingScheduleScheduledJobIdRouteRoute: typeof DashboardJobsTrainingScheduleScheduledJobIdRouteRouteWithChildren
}

const DashboardJobsTrainingScheduleRouteRouteChildren: DashboardJobsTrainingScheduleRouteRouteChildren =
  {
    DashboardJobsTrainingScheduleScheduledJobIdRouteRoute:
      DashboardJobsTrainingScheduleScheduledJobIdRouteRouteWithChildren,
  }

const DashboardJobsTrainingScheduleRouteRouteWithChildren =
  DashboardJobsTrainingScheduleRouteRoute._addFileChildren(
    DashboardJobsTrainingScheduleRouteRouteChildren,
  )

interface DashboardJobsTrainingRouteRouteChildren {
  DashboardJobsTrainingJobsRouteRoute: typeof DashboardJobsTrainingJobsRouteRouteWithChildren
  DashboardJobsTrainingScheduleRouteRoute: typeof DashboardJobsTrainingScheduleRouteRouteWithChildren
  DashboardJobsTrainingIndexRoute: typeof DashboardJobsTrainingIndexRoute
}

const DashboardJobsTrainingRouteRouteChildren: DashboardJobsTrainingRouteRouteChildren =
  {
    DashboardJobsTrainingJobsRouteRoute:
      DashboardJobsTrainingJobsRouteRouteWithChildren,
    DashboardJobsTrainingScheduleRouteRoute:
      DashboardJobsTrainingScheduleRouteRouteWithChildren,
    DashboardJobsTrainingIndexRoute: DashboardJobsTrainingIndexRoute,
  }

const DashboardJobsTrainingRouteRouteWithChildren =
  DashboardJobsTrainingRouteRoute._addFileChildren(
    DashboardJobsTrainingRouteRouteChildren,
  )

interface DashboardJobsVideoUploadJobsJobIdRouteRouteChildren {
  DashboardJobsVideoUploadJobsJobIdDevicesRouteRoute: typeof DashboardJobsVideoUploadJobsJobIdDevicesRouteRoute
  DashboardJobsVideoUploadJobsJobIdOverviewRouteRoute: typeof DashboardJobsVideoUploadJobsJobIdOverviewRouteRoute
  DashboardJobsVideoUploadJobsJobIdIndexRoute: typeof DashboardJobsVideoUploadJobsJobIdIndexRoute
}

const DashboardJobsVideoUploadJobsJobIdRouteRouteChildren: DashboardJobsVideoUploadJobsJobIdRouteRouteChildren =
  {
    DashboardJobsVideoUploadJobsJobIdDevicesRouteRoute:
      DashboardJobsVideoUploadJobsJobIdDevicesRouteRoute,
    DashboardJobsVideoUploadJobsJobIdOverviewRouteRoute:
      DashboardJobsVideoUploadJobsJobIdOverviewRouteRoute,
    DashboardJobsVideoUploadJobsJobIdIndexRoute:
      DashboardJobsVideoUploadJobsJobIdIndexRoute,
  }

const DashboardJobsVideoUploadJobsJobIdRouteRouteWithChildren =
  DashboardJobsVideoUploadJobsJobIdRouteRoute._addFileChildren(
    DashboardJobsVideoUploadJobsJobIdRouteRouteChildren,
  )

interface DashboardJobsVideoUploadJobsRouteRouteChildren {
  DashboardJobsVideoUploadJobsJobIdRouteRoute: typeof DashboardJobsVideoUploadJobsJobIdRouteRouteWithChildren
}

const DashboardJobsVideoUploadJobsRouteRouteChildren: DashboardJobsVideoUploadJobsRouteRouteChildren =
  {
    DashboardJobsVideoUploadJobsJobIdRouteRoute:
      DashboardJobsVideoUploadJobsJobIdRouteRouteWithChildren,
  }

const DashboardJobsVideoUploadJobsRouteRouteWithChildren =
  DashboardJobsVideoUploadJobsRouteRoute._addFileChildren(
    DashboardJobsVideoUploadJobsRouteRouteChildren,
  )

interface DashboardJobsVideoUploadScheduleScheduledJobIdRouteRouteChildren {
  DashboardJobsVideoUploadScheduleScheduledJobIdInputsRouteRoute: typeof DashboardJobsVideoUploadScheduleScheduledJobIdInputsRouteRoute
  DashboardJobsVideoUploadScheduleScheduledJobIdOverviewRouteRoute: typeof DashboardJobsVideoUploadScheduleScheduledJobIdOverviewRouteRoute
  DashboardJobsVideoUploadScheduleScheduledJobIdScheduleRouteRoute: typeof DashboardJobsVideoUploadScheduleScheduledJobIdScheduleRouteRoute
  DashboardJobsVideoUploadScheduleScheduledJobIdIndexRoute: typeof DashboardJobsVideoUploadScheduleScheduledJobIdIndexRoute
}

const DashboardJobsVideoUploadScheduleScheduledJobIdRouteRouteChildren: DashboardJobsVideoUploadScheduleScheduledJobIdRouteRouteChildren =
  {
    DashboardJobsVideoUploadScheduleScheduledJobIdInputsRouteRoute:
      DashboardJobsVideoUploadScheduleScheduledJobIdInputsRouteRoute,
    DashboardJobsVideoUploadScheduleScheduledJobIdOverviewRouteRoute:
      DashboardJobsVideoUploadScheduleScheduledJobIdOverviewRouteRoute,
    DashboardJobsVideoUploadScheduleScheduledJobIdScheduleRouteRoute:
      DashboardJobsVideoUploadScheduleScheduledJobIdScheduleRouteRoute,
    DashboardJobsVideoUploadScheduleScheduledJobIdIndexRoute:
      DashboardJobsVideoUploadScheduleScheduledJobIdIndexRoute,
  }

const DashboardJobsVideoUploadScheduleScheduledJobIdRouteRouteWithChildren =
  DashboardJobsVideoUploadScheduleScheduledJobIdRouteRoute._addFileChildren(
    DashboardJobsVideoUploadScheduleScheduledJobIdRouteRouteChildren,
  )

interface DashboardJobsVideoUploadScheduleRouteRouteChildren {
  DashboardJobsVideoUploadScheduleScheduledJobIdRouteRoute: typeof DashboardJobsVideoUploadScheduleScheduledJobIdRouteRouteWithChildren
}

const DashboardJobsVideoUploadScheduleRouteRouteChildren: DashboardJobsVideoUploadScheduleRouteRouteChildren =
  {
    DashboardJobsVideoUploadScheduleScheduledJobIdRouteRoute:
      DashboardJobsVideoUploadScheduleScheduledJobIdRouteRouteWithChildren,
  }

const DashboardJobsVideoUploadScheduleRouteRouteWithChildren =
  DashboardJobsVideoUploadScheduleRouteRoute._addFileChildren(
    DashboardJobsVideoUploadScheduleRouteRouteChildren,
  )

interface DashboardJobsVideoUploadRouteRouteChildren {
  DashboardJobsVideoUploadAlertsRouteRoute: typeof DashboardJobsVideoUploadAlertsRouteRoute
  DashboardJobsVideoUploadJobsRouteRoute: typeof DashboardJobsVideoUploadJobsRouteRouteWithChildren
  DashboardJobsVideoUploadScheduleRouteRoute: typeof DashboardJobsVideoUploadScheduleRouteRouteWithChildren
  DashboardJobsVideoUploadIndexRoute: typeof DashboardJobsVideoUploadIndexRoute
}

const DashboardJobsVideoUploadRouteRouteChildren: DashboardJobsVideoUploadRouteRouteChildren =
  {
    DashboardJobsVideoUploadAlertsRouteRoute:
      DashboardJobsVideoUploadAlertsRouteRoute,
    DashboardJobsVideoUploadJobsRouteRoute:
      DashboardJobsVideoUploadJobsRouteRouteWithChildren,
    DashboardJobsVideoUploadScheduleRouteRoute:
      DashboardJobsVideoUploadScheduleRouteRouteWithChildren,
    DashboardJobsVideoUploadIndexRoute: DashboardJobsVideoUploadIndexRoute,
  }

const DashboardJobsVideoUploadRouteRouteWithChildren =
  DashboardJobsVideoUploadRouteRoute._addFileChildren(
    DashboardJobsVideoUploadRouteRouteChildren,
  )

interface DashboardJobsWorkerJobsJobsJobIdRouteRouteChildren {
  DashboardJobsWorkerJobsJobsJobIdDevicesRouteRoute: typeof DashboardJobsWorkerJobsJobsJobIdDevicesRouteRoute
  DashboardJobsWorkerJobsJobsJobIdOverviewRouteRoute: typeof DashboardJobsWorkerJobsJobsJobIdOverviewRouteRoute
  DashboardJobsWorkerJobsJobsJobIdIndexRoute: typeof DashboardJobsWorkerJobsJobsJobIdIndexRoute
}

const DashboardJobsWorkerJobsJobsJobIdRouteRouteChildren: DashboardJobsWorkerJobsJobsJobIdRouteRouteChildren =
  {
    DashboardJobsWorkerJobsJobsJobIdDevicesRouteRoute:
      DashboardJobsWorkerJobsJobsJobIdDevicesRouteRoute,
    DashboardJobsWorkerJobsJobsJobIdOverviewRouteRoute:
      DashboardJobsWorkerJobsJobsJobIdOverviewRouteRoute,
    DashboardJobsWorkerJobsJobsJobIdIndexRoute:
      DashboardJobsWorkerJobsJobsJobIdIndexRoute,
  }

const DashboardJobsWorkerJobsJobsJobIdRouteRouteWithChildren =
  DashboardJobsWorkerJobsJobsJobIdRouteRoute._addFileChildren(
    DashboardJobsWorkerJobsJobsJobIdRouteRouteChildren,
  )

interface DashboardJobsWorkerJobsJobsRouteRouteChildren {
  DashboardJobsWorkerJobsJobsJobIdRouteRoute: typeof DashboardJobsWorkerJobsJobsJobIdRouteRouteWithChildren
}

const DashboardJobsWorkerJobsJobsRouteRouteChildren: DashboardJobsWorkerJobsJobsRouteRouteChildren =
  {
    DashboardJobsWorkerJobsJobsJobIdRouteRoute:
      DashboardJobsWorkerJobsJobsJobIdRouteRouteWithChildren,
  }

const DashboardJobsWorkerJobsJobsRouteRouteWithChildren =
  DashboardJobsWorkerJobsJobsRouteRoute._addFileChildren(
    DashboardJobsWorkerJobsJobsRouteRouteChildren,
  )

interface DashboardJobsWorkerJobsScheduleScheduledJobIdRouteRouteChildren {
  DashboardJobsWorkerJobsScheduleScheduledJobIdInputsRouteRoute: typeof DashboardJobsWorkerJobsScheduleScheduledJobIdInputsRouteRoute
  DashboardJobsWorkerJobsScheduleScheduledJobIdOverviewRouteRoute: typeof DashboardJobsWorkerJobsScheduleScheduledJobIdOverviewRouteRoute
  DashboardJobsWorkerJobsScheduleScheduledJobIdScheduleRouteRoute: typeof DashboardJobsWorkerJobsScheduleScheduledJobIdScheduleRouteRoute
  DashboardJobsWorkerJobsScheduleScheduledJobIdIndexRoute: typeof DashboardJobsWorkerJobsScheduleScheduledJobIdIndexRoute
}

const DashboardJobsWorkerJobsScheduleScheduledJobIdRouteRouteChildren: DashboardJobsWorkerJobsScheduleScheduledJobIdRouteRouteChildren =
  {
    DashboardJobsWorkerJobsScheduleScheduledJobIdInputsRouteRoute:
      DashboardJobsWorkerJobsScheduleScheduledJobIdInputsRouteRoute,
    DashboardJobsWorkerJobsScheduleScheduledJobIdOverviewRouteRoute:
      DashboardJobsWorkerJobsScheduleScheduledJobIdOverviewRouteRoute,
    DashboardJobsWorkerJobsScheduleScheduledJobIdScheduleRouteRoute:
      DashboardJobsWorkerJobsScheduleScheduledJobIdScheduleRouteRoute,
    DashboardJobsWorkerJobsScheduleScheduledJobIdIndexRoute:
      DashboardJobsWorkerJobsScheduleScheduledJobIdIndexRoute,
  }

const DashboardJobsWorkerJobsScheduleScheduledJobIdRouteRouteWithChildren =
  DashboardJobsWorkerJobsScheduleScheduledJobIdRouteRoute._addFileChildren(
    DashboardJobsWorkerJobsScheduleScheduledJobIdRouteRouteChildren,
  )

interface DashboardJobsWorkerJobsScheduleRouteRouteChildren {
  DashboardJobsWorkerJobsScheduleScheduledJobIdRouteRoute: typeof DashboardJobsWorkerJobsScheduleScheduledJobIdRouteRouteWithChildren
}

const DashboardJobsWorkerJobsScheduleRouteRouteChildren: DashboardJobsWorkerJobsScheduleRouteRouteChildren =
  {
    DashboardJobsWorkerJobsScheduleScheduledJobIdRouteRoute:
      DashboardJobsWorkerJobsScheduleScheduledJobIdRouteRouteWithChildren,
  }

const DashboardJobsWorkerJobsScheduleRouteRouteWithChildren =
  DashboardJobsWorkerJobsScheduleRouteRoute._addFileChildren(
    DashboardJobsWorkerJobsScheduleRouteRouteChildren,
  )

interface DashboardJobsWorkerJobsRouteRouteChildren {
  DashboardJobsWorkerJobsJobsRouteRoute: typeof DashboardJobsWorkerJobsJobsRouteRouteWithChildren
  DashboardJobsWorkerJobsScheduleRouteRoute: typeof DashboardJobsWorkerJobsScheduleRouteRouteWithChildren
  DashboardJobsWorkerJobsIndexRoute: typeof DashboardJobsWorkerJobsIndexRoute
}

const DashboardJobsWorkerJobsRouteRouteChildren: DashboardJobsWorkerJobsRouteRouteChildren =
  {
    DashboardJobsWorkerJobsJobsRouteRoute:
      DashboardJobsWorkerJobsJobsRouteRouteWithChildren,
    DashboardJobsWorkerJobsScheduleRouteRoute:
      DashboardJobsWorkerJobsScheduleRouteRouteWithChildren,
    DashboardJobsWorkerJobsIndexRoute: DashboardJobsWorkerJobsIndexRoute,
  }

const DashboardJobsWorkerJobsRouteRouteWithChildren =
  DashboardJobsWorkerJobsRouteRoute._addFileChildren(
    DashboardJobsWorkerJobsRouteRouteChildren,
  )

interface DashboardJobsRouteRouteChildren {
  DashboardJobsCameraCalibrationRouteRoute: typeof DashboardJobsCameraCalibrationRouteRouteWithChildren
  DashboardJobsCapacityTaggingRouteRoute: typeof DashboardJobsCapacityTaggingRouteRouteWithChildren
  DashboardJobsCatalogUploadRouteRoute: typeof DashboardJobsCatalogUploadRouteRouteWithChildren
  DashboardJobsConfigRouteRoute: typeof DashboardJobsConfigRouteRouteWithChildren
  DashboardJobsDeleteSamplesRouteRoute: typeof DashboardJobsDeleteSamplesRouteRouteWithChildren
  DashboardJobsDeleteVideosRouteRoute: typeof DashboardJobsDeleteVideosRouteRouteWithChildren
  DashboardJobsDeploymentsRouteRoute: typeof DashboardJobsDeploymentsRouteRouteWithChildren
  DashboardJobsHeadBlurImagesRouteRoute: typeof DashboardJobsHeadBlurImagesRouteRouteWithChildren
  DashboardJobsHeadBlurVideosRouteRoute: typeof DashboardJobsHeadBlurVideosRouteRouteWithChildren
  DashboardJobsModelsRouteRoute: typeof DashboardJobsModelsRouteRouteWithChildren
  DashboardJobsRecoveryEstimatesRouteRoute: typeof DashboardJobsRecoveryEstimatesRouteRouteWithChildren
  DashboardJobsRestartsRouteRoute: typeof DashboardJobsRestartsRouteRouteWithChildren
  DashboardJobsSampleUploadRouteRoute: typeof DashboardJobsSampleUploadRouteRouteWithChildren
  DashboardJobsSyncSamplesRouteRoute: typeof DashboardJobsSyncSamplesRouteRouteWithChildren
  DashboardJobsTrainingRouteRoute: typeof DashboardJobsTrainingRouteRouteWithChildren
  DashboardJobsVideoUploadRouteRoute: typeof DashboardJobsVideoUploadRouteRouteWithChildren
  DashboardJobsWorkerJobsRouteRoute: typeof DashboardJobsWorkerJobsRouteRouteWithChildren
  DashboardJobsIndexRoute: typeof DashboardJobsIndexRoute
}

const DashboardJobsRouteRouteChildren: DashboardJobsRouteRouteChildren = {
  DashboardJobsCameraCalibrationRouteRoute:
    DashboardJobsCameraCalibrationRouteRouteWithChildren,
  DashboardJobsCapacityTaggingRouteRoute:
    DashboardJobsCapacityTaggingRouteRouteWithChildren,
  DashboardJobsCatalogUploadRouteRoute:
    DashboardJobsCatalogUploadRouteRouteWithChildren,
  DashboardJobsConfigRouteRoute: DashboardJobsConfigRouteRouteWithChildren,
  DashboardJobsDeleteSamplesRouteRoute:
    DashboardJobsDeleteSamplesRouteRouteWithChildren,
  DashboardJobsDeleteVideosRouteRoute:
    DashboardJobsDeleteVideosRouteRouteWithChildren,
  DashboardJobsDeploymentsRouteRoute:
    DashboardJobsDeploymentsRouteRouteWithChildren,
  DashboardJobsHeadBlurImagesRouteRoute:
    DashboardJobsHeadBlurImagesRouteRouteWithChildren,
  DashboardJobsHeadBlurVideosRouteRoute:
    DashboardJobsHeadBlurVideosRouteRouteWithChildren,
  DashboardJobsModelsRouteRoute: DashboardJobsModelsRouteRouteWithChildren,
  DashboardJobsRecoveryEstimatesRouteRoute:
    DashboardJobsRecoveryEstimatesRouteRouteWithChildren,
  DashboardJobsRestartsRouteRoute: DashboardJobsRestartsRouteRouteWithChildren,
  DashboardJobsSampleUploadRouteRoute:
    DashboardJobsSampleUploadRouteRouteWithChildren,
  DashboardJobsSyncSamplesRouteRoute:
    DashboardJobsSyncSamplesRouteRouteWithChildren,
  DashboardJobsTrainingRouteRoute: DashboardJobsTrainingRouteRouteWithChildren,
  DashboardJobsVideoUploadRouteRoute:
    DashboardJobsVideoUploadRouteRouteWithChildren,
  DashboardJobsWorkerJobsRouteRoute:
    DashboardJobsWorkerJobsRouteRouteWithChildren,
  DashboardJobsIndexRoute: DashboardJobsIndexRoute,
}

const DashboardJobsRouteRouteWithChildren =
  DashboardJobsRouteRoute._addFileChildren(DashboardJobsRouteRouteChildren)

interface DashboardModelsModelIdDeploymentRouteRouteChildren {
  DashboardModelsModelIdDeploymentClustersRouteRoute: typeof DashboardModelsModelIdDeploymentClustersRouteRoute
  DashboardModelsModelIdDeploymentDevicesRouteRoute: typeof DashboardModelsModelIdDeploymentDevicesRouteRoute
  DashboardModelsModelIdDeploymentIndexRoute: typeof DashboardModelsModelIdDeploymentIndexRoute
}

const DashboardModelsModelIdDeploymentRouteRouteChildren: DashboardModelsModelIdDeploymentRouteRouteChildren =
  {
    DashboardModelsModelIdDeploymentClustersRouteRoute:
      DashboardModelsModelIdDeploymentClustersRouteRoute,
    DashboardModelsModelIdDeploymentDevicesRouteRoute:
      DashboardModelsModelIdDeploymentDevicesRouteRoute,
    DashboardModelsModelIdDeploymentIndexRoute:
      DashboardModelsModelIdDeploymentIndexRoute,
  }

const DashboardModelsModelIdDeploymentRouteRouteWithChildren =
  DashboardModelsModelIdDeploymentRouteRoute._addFileChildren(
    DashboardModelsModelIdDeploymentRouteRouteChildren,
  )

interface DashboardModelsModelIdRouteRouteChildren {
  DashboardModelsModelIdDeploymentRouteRoute: typeof DashboardModelsModelIdDeploymentRouteRouteWithChildren
  DashboardModelsModelIdLabelsRouteRoute: typeof DashboardModelsModelIdLabelsRouteRoute
  DashboardModelsModelIdMatrixRouteRoute: typeof DashboardModelsModelIdMatrixRouteRoute
  DashboardModelsModelIdOverviewRouteRoute: typeof DashboardModelsModelIdOverviewRouteRoute
  DashboardModelsModelIdIndexRoute: typeof DashboardModelsModelIdIndexRoute
}

const DashboardModelsModelIdRouteRouteChildren: DashboardModelsModelIdRouteRouteChildren =
  {
    DashboardModelsModelIdDeploymentRouteRoute:
      DashboardModelsModelIdDeploymentRouteRouteWithChildren,
    DashboardModelsModelIdLabelsRouteRoute:
      DashboardModelsModelIdLabelsRouteRoute,
    DashboardModelsModelIdMatrixRouteRoute:
      DashboardModelsModelIdMatrixRouteRoute,
    DashboardModelsModelIdOverviewRouteRoute:
      DashboardModelsModelIdOverviewRouteRoute,
    DashboardModelsModelIdIndexRoute: DashboardModelsModelIdIndexRoute,
  }

const DashboardModelsModelIdRouteRouteWithChildren =
  DashboardModelsModelIdRouteRoute._addFileChildren(
    DashboardModelsModelIdRouteRouteChildren,
  )

interface DashboardModelsRouteRouteChildren {
  DashboardModelsModelIdRouteRoute: typeof DashboardModelsModelIdRouteRouteWithChildren
}

const DashboardModelsRouteRouteChildren: DashboardModelsRouteRouteChildren = {
  DashboardModelsModelIdRouteRoute:
    DashboardModelsModelIdRouteRouteWithChildren,
}

const DashboardModelsRouteRouteWithChildren =
  DashboardModelsRouteRoute._addFileChildren(DashboardModelsRouteRouteChildren)

interface DashboardReportsRouteRouteChildren {
  DashboardReportsReportIdRouteRoute: typeof DashboardReportsReportIdRouteRoute
  DashboardReportsAnalyticsHubRouteRoute: typeof DashboardReportsAnalyticsHubRouteRoute
  DashboardReportsCompanionRouteRoute: typeof DashboardReportsCompanionRouteRoute
  DashboardReportsIndexRoute: typeof DashboardReportsIndexRoute
}

const DashboardReportsRouteRouteChildren: DashboardReportsRouteRouteChildren = {
  DashboardReportsReportIdRouteRoute: DashboardReportsReportIdRouteRoute,
  DashboardReportsAnalyticsHubRouteRoute:
    DashboardReportsAnalyticsHubRouteRoute,
  DashboardReportsCompanionRouteRoute: DashboardReportsCompanionRouteRoute,
  DashboardReportsIndexRoute: DashboardReportsIndexRoute,
}

const DashboardReportsRouteRouteWithChildren =
  DashboardReportsRouteRoute._addFileChildren(
    DashboardReportsRouteRouteChildren,
  )

interface DashboardResourcesClustersClusterIdRouteRouteChildren {
  DashboardResourcesClustersClusterIdDevicesRouteRoute: typeof DashboardResourcesClustersClusterIdDevicesRouteRoute
  DashboardResourcesClustersClusterIdOverviewRouteRoute: typeof DashboardResourcesClustersClusterIdOverviewRouteRoute
  DashboardResourcesClustersClusterIdIndexRoute: typeof DashboardResourcesClustersClusterIdIndexRoute
}

const DashboardResourcesClustersClusterIdRouteRouteChildren: DashboardResourcesClustersClusterIdRouteRouteChildren =
  {
    DashboardResourcesClustersClusterIdDevicesRouteRoute:
      DashboardResourcesClustersClusterIdDevicesRouteRoute,
    DashboardResourcesClustersClusterIdOverviewRouteRoute:
      DashboardResourcesClustersClusterIdOverviewRouteRoute,
    DashboardResourcesClustersClusterIdIndexRoute:
      DashboardResourcesClustersClusterIdIndexRoute,
  }

const DashboardResourcesClustersClusterIdRouteRouteWithChildren =
  DashboardResourcesClustersClusterIdRouteRoute._addFileChildren(
    DashboardResourcesClustersClusterIdRouteRouteChildren,
  )

interface DashboardResourcesClustersRouteRouteChildren {
  DashboardResourcesClustersClusterIdRouteRoute: typeof DashboardResourcesClustersClusterIdRouteRouteWithChildren
}

const DashboardResourcesClustersRouteRouteChildren: DashboardResourcesClustersRouteRouteChildren =
  {
    DashboardResourcesClustersClusterIdRouteRoute:
      DashboardResourcesClustersClusterIdRouteRouteWithChildren,
  }

const DashboardResourcesClustersRouteRouteWithChildren =
  DashboardResourcesClustersRouteRoute._addFileChildren(
    DashboardResourcesClustersRouteRouteChildren,
  )

interface DashboardResourcesDevicesDeviceIdDataSamplesSampleIdRouteRouteChildren {
  DashboardResourcesDevicesDeviceIdDataSamplesSampleIdIndexRoute: typeof DashboardResourcesDevicesDeviceIdDataSamplesSampleIdIndexRoute
}

const DashboardResourcesDevicesDeviceIdDataSamplesSampleIdRouteRouteChildren: DashboardResourcesDevicesDeviceIdDataSamplesSampleIdRouteRouteChildren =
  {
    DashboardResourcesDevicesDeviceIdDataSamplesSampleIdIndexRoute:
      DashboardResourcesDevicesDeviceIdDataSamplesSampleIdIndexRoute,
  }

const DashboardResourcesDevicesDeviceIdDataSamplesSampleIdRouteRouteWithChildren =
  DashboardResourcesDevicesDeviceIdDataSamplesSampleIdRouteRoute._addFileChildren(
    DashboardResourcesDevicesDeviceIdDataSamplesSampleIdRouteRouteChildren,
  )

interface DashboardResourcesDevicesDeviceIdDataSamplesRouteRouteChildren {
  DashboardResourcesDevicesDeviceIdDataSamplesSampleIdRouteRoute: typeof DashboardResourcesDevicesDeviceIdDataSamplesSampleIdRouteRouteWithChildren
}

const DashboardResourcesDevicesDeviceIdDataSamplesRouteRouteChildren: DashboardResourcesDevicesDeviceIdDataSamplesRouteRouteChildren =
  {
    DashboardResourcesDevicesDeviceIdDataSamplesSampleIdRouteRoute:
      DashboardResourcesDevicesDeviceIdDataSamplesSampleIdRouteRouteWithChildren,
  }

const DashboardResourcesDevicesDeviceIdDataSamplesRouteRouteWithChildren =
  DashboardResourcesDevicesDeviceIdDataSamplesRouteRoute._addFileChildren(
    DashboardResourcesDevicesDeviceIdDataSamplesRouteRouteChildren,
  )

interface DashboardResourcesDevicesDeviceIdDataSessionsSessionIdRouteRouteChildren {
  DashboardResourcesDevicesDeviceIdDataSessionsSessionIdIndexRoute: typeof DashboardResourcesDevicesDeviceIdDataSessionsSessionIdIndexRoute
}

const DashboardResourcesDevicesDeviceIdDataSessionsSessionIdRouteRouteChildren: DashboardResourcesDevicesDeviceIdDataSessionsSessionIdRouteRouteChildren =
  {
    DashboardResourcesDevicesDeviceIdDataSessionsSessionIdIndexRoute:
      DashboardResourcesDevicesDeviceIdDataSessionsSessionIdIndexRoute,
  }

const DashboardResourcesDevicesDeviceIdDataSessionsSessionIdRouteRouteWithChildren =
  DashboardResourcesDevicesDeviceIdDataSessionsSessionIdRouteRoute._addFileChildren(
    DashboardResourcesDevicesDeviceIdDataSessionsSessionIdRouteRouteChildren,
  )

interface DashboardResourcesDevicesDeviceIdDataSessionsRouteRouteChildren {
  DashboardResourcesDevicesDeviceIdDataSessionsSessionIdRouteRoute: typeof DashboardResourcesDevicesDeviceIdDataSessionsSessionIdRouteRouteWithChildren
}

const DashboardResourcesDevicesDeviceIdDataSessionsRouteRouteChildren: DashboardResourcesDevicesDeviceIdDataSessionsRouteRouteChildren =
  {
    DashboardResourcesDevicesDeviceIdDataSessionsSessionIdRouteRoute:
      DashboardResourcesDevicesDeviceIdDataSessionsSessionIdRouteRouteWithChildren,
  }

const DashboardResourcesDevicesDeviceIdDataSessionsRouteRouteWithChildren =
  DashboardResourcesDevicesDeviceIdDataSessionsRouteRoute._addFileChildren(
    DashboardResourcesDevicesDeviceIdDataSessionsRouteRouteChildren,
  )

interface DashboardResourcesDevicesDeviceIdDataRouteRouteChildren {
  DashboardResourcesDevicesDeviceIdDataSamplesRouteRoute: typeof DashboardResourcesDevicesDeviceIdDataSamplesRouteRouteWithChildren
  DashboardResourcesDevicesDeviceIdDataSessionsRouteRoute: typeof DashboardResourcesDevicesDeviceIdDataSessionsRouteRouteWithChildren
  DashboardResourcesDevicesDeviceIdDataTextJsonRouteRoute: typeof DashboardResourcesDevicesDeviceIdDataTextJsonRouteRoute
  DashboardResourcesDevicesDeviceIdDataIndexRoute: typeof DashboardResourcesDevicesDeviceIdDataIndexRoute
}

const DashboardResourcesDevicesDeviceIdDataRouteRouteChildren: DashboardResourcesDevicesDeviceIdDataRouteRouteChildren =
  {
    DashboardResourcesDevicesDeviceIdDataSamplesRouteRoute:
      DashboardResourcesDevicesDeviceIdDataSamplesRouteRouteWithChildren,
    DashboardResourcesDevicesDeviceIdDataSessionsRouteRoute:
      DashboardResourcesDevicesDeviceIdDataSessionsRouteRouteWithChildren,
    DashboardResourcesDevicesDeviceIdDataTextJsonRouteRoute:
      DashboardResourcesDevicesDeviceIdDataTextJsonRouteRoute,
    DashboardResourcesDevicesDeviceIdDataIndexRoute:
      DashboardResourcesDevicesDeviceIdDataIndexRoute,
  }

const DashboardResourcesDevicesDeviceIdDataRouteRouteWithChildren =
  DashboardResourcesDevicesDeviceIdDataRouteRoute._addFileChildren(
    DashboardResourcesDevicesDeviceIdDataRouteRouteChildren,
  )

interface DashboardResourcesDevicesDeviceIdDiagnosticsRouteRouteChildren {
  DashboardResourcesDevicesDeviceIdDiagnosticsClassifierRouteRoute: typeof DashboardResourcesDevicesDeviceIdDiagnosticsClassifierRouteRoute
  DashboardResourcesDevicesDeviceIdDiagnosticsCustomRouteRoute: typeof DashboardResourcesDevicesDeviceIdDiagnosticsCustomRouteRoute
  DashboardResourcesDevicesDeviceIdDiagnosticsObjectDetectionRouteRoute: typeof DashboardResourcesDevicesDeviceIdDiagnosticsObjectDetectionRouteRoute
}

const DashboardResourcesDevicesDeviceIdDiagnosticsRouteRouteChildren: DashboardResourcesDevicesDeviceIdDiagnosticsRouteRouteChildren =
  {
    DashboardResourcesDevicesDeviceIdDiagnosticsClassifierRouteRoute:
      DashboardResourcesDevicesDeviceIdDiagnosticsClassifierRouteRoute,
    DashboardResourcesDevicesDeviceIdDiagnosticsCustomRouteRoute:
      DashboardResourcesDevicesDeviceIdDiagnosticsCustomRouteRoute,
    DashboardResourcesDevicesDeviceIdDiagnosticsObjectDetectionRouteRoute:
      DashboardResourcesDevicesDeviceIdDiagnosticsObjectDetectionRouteRoute,
  }

const DashboardResourcesDevicesDeviceIdDiagnosticsRouteRouteWithChildren =
  DashboardResourcesDevicesDeviceIdDiagnosticsRouteRoute._addFileChildren(
    DashboardResourcesDevicesDeviceIdDiagnosticsRouteRouteChildren,
  )

interface DashboardResourcesDevicesDeviceIdVersionHistoryRouteRouteChildren {
  DashboardResourcesDevicesDeviceIdVersionHistoryAgentRouteRoute: typeof DashboardResourcesDevicesDeviceIdVersionHistoryAgentRouteRoute
  DashboardResourcesDevicesDeviceIdVersionHistoryDetectorRouteRoute: typeof DashboardResourcesDevicesDeviceIdVersionHistoryDetectorRouteRoute
  DashboardResourcesDevicesDeviceIdVersionHistoryModelsRouteRoute: typeof DashboardResourcesDevicesDeviceIdVersionHistoryModelsRouteRoute
  DashboardResourcesDevicesDeviceIdVersionHistoryOnScreenAppRouteRoute: typeof DashboardResourcesDevicesDeviceIdVersionHistoryOnScreenAppRouteRoute
  DashboardResourcesDevicesDeviceIdVersionHistoryTrainerRouteRoute: typeof DashboardResourcesDevicesDeviceIdVersionHistoryTrainerRouteRoute
  DashboardResourcesDevicesDeviceIdVersionHistoryZebraAdapterRouteRoute: typeof DashboardResourcesDevicesDeviceIdVersionHistoryZebraAdapterRouteRoute
  DashboardResourcesDevicesDeviceIdVersionHistoryIndexRoute: typeof DashboardResourcesDevicesDeviceIdVersionHistoryIndexRoute
}

const DashboardResourcesDevicesDeviceIdVersionHistoryRouteRouteChildren: DashboardResourcesDevicesDeviceIdVersionHistoryRouteRouteChildren =
  {
    DashboardResourcesDevicesDeviceIdVersionHistoryAgentRouteRoute:
      DashboardResourcesDevicesDeviceIdVersionHistoryAgentRouteRoute,
    DashboardResourcesDevicesDeviceIdVersionHistoryDetectorRouteRoute:
      DashboardResourcesDevicesDeviceIdVersionHistoryDetectorRouteRoute,
    DashboardResourcesDevicesDeviceIdVersionHistoryModelsRouteRoute:
      DashboardResourcesDevicesDeviceIdVersionHistoryModelsRouteRoute,
    DashboardResourcesDevicesDeviceIdVersionHistoryOnScreenAppRouteRoute:
      DashboardResourcesDevicesDeviceIdVersionHistoryOnScreenAppRouteRoute,
    DashboardResourcesDevicesDeviceIdVersionHistoryTrainerRouteRoute:
      DashboardResourcesDevicesDeviceIdVersionHistoryTrainerRouteRoute,
    DashboardResourcesDevicesDeviceIdVersionHistoryZebraAdapterRouteRoute:
      DashboardResourcesDevicesDeviceIdVersionHistoryZebraAdapterRouteRoute,
    DashboardResourcesDevicesDeviceIdVersionHistoryIndexRoute:
      DashboardResourcesDevicesDeviceIdVersionHistoryIndexRoute,
  }

const DashboardResourcesDevicesDeviceIdVersionHistoryRouteRouteWithChildren =
  DashboardResourcesDevicesDeviceIdVersionHistoryRouteRoute._addFileChildren(
    DashboardResourcesDevicesDeviceIdVersionHistoryRouteRouteChildren,
  )

interface DashboardResourcesDevicesDeviceIdRouteRouteChildren {
  DashboardResourcesDevicesDeviceIdCameraRouteRoute: typeof DashboardResourcesDevicesDeviceIdCameraRouteRoute
  DashboardResourcesDevicesDeviceIdDataRouteRoute: typeof DashboardResourcesDevicesDeviceIdDataRouteRouteWithChildren
  DashboardResourcesDevicesDeviceIdDiagnosticsRouteRoute: typeof DashboardResourcesDevicesDeviceIdDiagnosticsRouteRouteWithChildren
  DashboardResourcesDevicesDeviceIdLogsRouteRoute: typeof DashboardResourcesDevicesDeviceIdLogsRouteRoute
  DashboardResourcesDevicesDeviceIdOverviewRouteRoute: typeof DashboardResourcesDevicesDeviceIdOverviewRouteRoute
  DashboardResourcesDevicesDeviceIdSettingsRouteRoute: typeof DashboardResourcesDevicesDeviceIdSettingsRouteRoute
  DashboardResourcesDevicesDeviceIdVersionHistoryRouteRoute: typeof DashboardResourcesDevicesDeviceIdVersionHistoryRouteRouteWithChildren
  DashboardResourcesDevicesDeviceIdIndexRoute: typeof DashboardResourcesDevicesDeviceIdIndexRoute
}

const DashboardResourcesDevicesDeviceIdRouteRouteChildren: DashboardResourcesDevicesDeviceIdRouteRouteChildren =
  {
    DashboardResourcesDevicesDeviceIdCameraRouteRoute:
      DashboardResourcesDevicesDeviceIdCameraRouteRoute,
    DashboardResourcesDevicesDeviceIdDataRouteRoute:
      DashboardResourcesDevicesDeviceIdDataRouteRouteWithChildren,
    DashboardResourcesDevicesDeviceIdDiagnosticsRouteRoute:
      DashboardResourcesDevicesDeviceIdDiagnosticsRouteRouteWithChildren,
    DashboardResourcesDevicesDeviceIdLogsRouteRoute:
      DashboardResourcesDevicesDeviceIdLogsRouteRoute,
    DashboardResourcesDevicesDeviceIdOverviewRouteRoute:
      DashboardResourcesDevicesDeviceIdOverviewRouteRoute,
    DashboardResourcesDevicesDeviceIdSettingsRouteRoute:
      DashboardResourcesDevicesDeviceIdSettingsRouteRoute,
    DashboardResourcesDevicesDeviceIdVersionHistoryRouteRoute:
      DashboardResourcesDevicesDeviceIdVersionHistoryRouteRouteWithChildren,
    DashboardResourcesDevicesDeviceIdIndexRoute:
      DashboardResourcesDevicesDeviceIdIndexRoute,
  }

const DashboardResourcesDevicesDeviceIdRouteRouteWithChildren =
  DashboardResourcesDevicesDeviceIdRouteRoute._addFileChildren(
    DashboardResourcesDevicesDeviceIdRouteRouteChildren,
  )

interface DashboardResourcesDevicesRouteRouteChildren {
  DashboardResourcesDevicesDeviceIdRouteRoute: typeof DashboardResourcesDevicesDeviceIdRouteRouteWithChildren
}

const DashboardResourcesDevicesRouteRouteChildren: DashboardResourcesDevicesRouteRouteChildren =
  {
    DashboardResourcesDevicesDeviceIdRouteRoute:
      DashboardResourcesDevicesDeviceIdRouteRouteWithChildren,
  }

const DashboardResourcesDevicesRouteRouteWithChildren =
  DashboardResourcesDevicesRouteRoute._addFileChildren(
    DashboardResourcesDevicesRouteRouteChildren,
  )

interface DashboardResourcesSiteGroupsSiteGroupIdRouteRouteChildren {
  DashboardResourcesSiteGroupsSiteGroupIdLabelsRouteRoute: typeof DashboardResourcesSiteGroupsSiteGroupIdLabelsRouteRoute
  DashboardResourcesSiteGroupsSiteGroupIdOverviewRouteRoute: typeof DashboardResourcesSiteGroupsSiteGroupIdOverviewRouteRoute
  DashboardResourcesSiteGroupsSiteGroupIdSitesRouteRoute: typeof DashboardResourcesSiteGroupsSiteGroupIdSitesRouteRoute
  DashboardResourcesSiteGroupsSiteGroupIdIndexRoute: typeof DashboardResourcesSiteGroupsSiteGroupIdIndexRoute
}

const DashboardResourcesSiteGroupsSiteGroupIdRouteRouteChildren: DashboardResourcesSiteGroupsSiteGroupIdRouteRouteChildren =
  {
    DashboardResourcesSiteGroupsSiteGroupIdLabelsRouteRoute:
      DashboardResourcesSiteGroupsSiteGroupIdLabelsRouteRoute,
    DashboardResourcesSiteGroupsSiteGroupIdOverviewRouteRoute:
      DashboardResourcesSiteGroupsSiteGroupIdOverviewRouteRoute,
    DashboardResourcesSiteGroupsSiteGroupIdSitesRouteRoute:
      DashboardResourcesSiteGroupsSiteGroupIdSitesRouteRoute,
    DashboardResourcesSiteGroupsSiteGroupIdIndexRoute:
      DashboardResourcesSiteGroupsSiteGroupIdIndexRoute,
  }

const DashboardResourcesSiteGroupsSiteGroupIdRouteRouteWithChildren =
  DashboardResourcesSiteGroupsSiteGroupIdRouteRoute._addFileChildren(
    DashboardResourcesSiteGroupsSiteGroupIdRouteRouteChildren,
  )

interface DashboardResourcesSiteGroupsRouteRouteChildren {
  DashboardResourcesSiteGroupsSiteGroupIdRouteRoute: typeof DashboardResourcesSiteGroupsSiteGroupIdRouteRouteWithChildren
}

const DashboardResourcesSiteGroupsRouteRouteChildren: DashboardResourcesSiteGroupsRouteRouteChildren =
  {
    DashboardResourcesSiteGroupsSiteGroupIdRouteRoute:
      DashboardResourcesSiteGroupsSiteGroupIdRouteRouteWithChildren,
  }

const DashboardResourcesSiteGroupsRouteRouteWithChildren =
  DashboardResourcesSiteGroupsRouteRoute._addFileChildren(
    DashboardResourcesSiteGroupsRouteRouteChildren,
  )

interface DashboardResourcesSitesSiteIdVersionHistoryRouteRouteChildren {
  DashboardResourcesSitesSiteIdVersionHistoryAgentRouteRoute: typeof DashboardResourcesSitesSiteIdVersionHistoryAgentRouteRoute
  DashboardResourcesSitesSiteIdVersionHistoryDetectorRouteRoute: typeof DashboardResourcesSitesSiteIdVersionHistoryDetectorRouteRoute
  DashboardResourcesSitesSiteIdVersionHistoryOnScreenAppRouteRoute: typeof DashboardResourcesSitesSiteIdVersionHistoryOnScreenAppRouteRoute
  DashboardResourcesSitesSiteIdVersionHistoryTrainerRouteRoute: typeof DashboardResourcesSitesSiteIdVersionHistoryTrainerRouteRoute
  DashboardResourcesSitesSiteIdVersionHistoryZebraAdapterRouteRoute: typeof DashboardResourcesSitesSiteIdVersionHistoryZebraAdapterRouteRoute
  DashboardResourcesSitesSiteIdVersionHistoryIndexRoute: typeof DashboardResourcesSitesSiteIdVersionHistoryIndexRoute
}

const DashboardResourcesSitesSiteIdVersionHistoryRouteRouteChildren: DashboardResourcesSitesSiteIdVersionHistoryRouteRouteChildren =
  {
    DashboardResourcesSitesSiteIdVersionHistoryAgentRouteRoute:
      DashboardResourcesSitesSiteIdVersionHistoryAgentRouteRoute,
    DashboardResourcesSitesSiteIdVersionHistoryDetectorRouteRoute:
      DashboardResourcesSitesSiteIdVersionHistoryDetectorRouteRoute,
    DashboardResourcesSitesSiteIdVersionHistoryOnScreenAppRouteRoute:
      DashboardResourcesSitesSiteIdVersionHistoryOnScreenAppRouteRoute,
    DashboardResourcesSitesSiteIdVersionHistoryTrainerRouteRoute:
      DashboardResourcesSitesSiteIdVersionHistoryTrainerRouteRoute,
    DashboardResourcesSitesSiteIdVersionHistoryZebraAdapterRouteRoute:
      DashboardResourcesSitesSiteIdVersionHistoryZebraAdapterRouteRoute,
    DashboardResourcesSitesSiteIdVersionHistoryIndexRoute:
      DashboardResourcesSitesSiteIdVersionHistoryIndexRoute,
  }

const DashboardResourcesSitesSiteIdVersionHistoryRouteRouteWithChildren =
  DashboardResourcesSitesSiteIdVersionHistoryRouteRoute._addFileChildren(
    DashboardResourcesSitesSiteIdVersionHistoryRouteRouteChildren,
  )

interface DashboardResourcesSitesSiteIdRouteRouteChildren {
  DashboardResourcesSitesSiteIdDevicesRouteRoute: typeof DashboardResourcesSitesSiteIdDevicesRouteRoute
  DashboardResourcesSitesSiteIdOverviewRouteRoute: typeof DashboardResourcesSitesSiteIdOverviewRouteRoute
  DashboardResourcesSitesSiteIdVersionHistoryRouteRoute: typeof DashboardResourcesSitesSiteIdVersionHistoryRouteRouteWithChildren
  DashboardResourcesSitesSiteIdIndexRoute: typeof DashboardResourcesSitesSiteIdIndexRoute
}

const DashboardResourcesSitesSiteIdRouteRouteChildren: DashboardResourcesSitesSiteIdRouteRouteChildren =
  {
    DashboardResourcesSitesSiteIdDevicesRouteRoute:
      DashboardResourcesSitesSiteIdDevicesRouteRoute,
    DashboardResourcesSitesSiteIdOverviewRouteRoute:
      DashboardResourcesSitesSiteIdOverviewRouteRoute,
    DashboardResourcesSitesSiteIdVersionHistoryRouteRoute:
      DashboardResourcesSitesSiteIdVersionHistoryRouteRouteWithChildren,
    DashboardResourcesSitesSiteIdIndexRoute:
      DashboardResourcesSitesSiteIdIndexRoute,
  }

const DashboardResourcesSitesSiteIdRouteRouteWithChildren =
  DashboardResourcesSitesSiteIdRouteRoute._addFileChildren(
    DashboardResourcesSitesSiteIdRouteRouteChildren,
  )

interface DashboardResourcesSitesRouteRouteChildren {
  DashboardResourcesSitesSiteIdRouteRoute: typeof DashboardResourcesSitesSiteIdRouteRouteWithChildren
}

const DashboardResourcesSitesRouteRouteChildren: DashboardResourcesSitesRouteRouteChildren =
  {
    DashboardResourcesSitesSiteIdRouteRoute:
      DashboardResourcesSitesSiteIdRouteRouteWithChildren,
  }

const DashboardResourcesSitesRouteRouteWithChildren =
  DashboardResourcesSitesRouteRoute._addFileChildren(
    DashboardResourcesSitesRouteRouteChildren,
  )

interface DashboardResourcesRouteRouteChildren {
  DashboardResourcesClustersRouteRoute: typeof DashboardResourcesClustersRouteRouteWithChildren
  DashboardResourcesDevicesRouteRoute: typeof DashboardResourcesDevicesRouteRouteWithChildren
  DashboardResourcesSiteGroupsRouteRoute: typeof DashboardResourcesSiteGroupsRouteRouteWithChildren
  DashboardResourcesSitesRouteRoute: typeof DashboardResourcesSitesRouteRouteWithChildren
  DashboardResourcesIndexRoute: typeof DashboardResourcesIndexRoute
  DashboardResourcesRestRoute: typeof DashboardResourcesRestRoute
}

const DashboardResourcesRouteRouteChildren: DashboardResourcesRouteRouteChildren =
  {
    DashboardResourcesClustersRouteRoute:
      DashboardResourcesClustersRouteRouteWithChildren,
    DashboardResourcesDevicesRouteRoute:
      DashboardResourcesDevicesRouteRouteWithChildren,
    DashboardResourcesSiteGroupsRouteRoute:
      DashboardResourcesSiteGroupsRouteRouteWithChildren,
    DashboardResourcesSitesRouteRoute:
      DashboardResourcesSitesRouteRouteWithChildren,
    DashboardResourcesIndexRoute: DashboardResourcesIndexRoute,
    DashboardResourcesRestRoute: DashboardResourcesRestRoute,
  }

const DashboardResourcesRouteRouteWithChildren =
  DashboardResourcesRouteRoute._addFileChildren(
    DashboardResourcesRouteRouteChildren,
  )

interface DashboardSettingsAlertManagementAlertsAlertIdRouteRouteChildren {
  DashboardSettingsAlertManagementAlertsAlertIdOverviewRouteRoute: typeof DashboardSettingsAlertManagementAlertsAlertIdOverviewRouteRoute
  DashboardSettingsAlertManagementAlertsAlertIdIndexRoute: typeof DashboardSettingsAlertManagementAlertsAlertIdIndexRoute
}

const DashboardSettingsAlertManagementAlertsAlertIdRouteRouteChildren: DashboardSettingsAlertManagementAlertsAlertIdRouteRouteChildren =
  {
    DashboardSettingsAlertManagementAlertsAlertIdOverviewRouteRoute:
      DashboardSettingsAlertManagementAlertsAlertIdOverviewRouteRoute,
    DashboardSettingsAlertManagementAlertsAlertIdIndexRoute:
      DashboardSettingsAlertManagementAlertsAlertIdIndexRoute,
  }

const DashboardSettingsAlertManagementAlertsAlertIdRouteRouteWithChildren =
  DashboardSettingsAlertManagementAlertsAlertIdRouteRoute._addFileChildren(
    DashboardSettingsAlertManagementAlertsAlertIdRouteRouteChildren,
  )

interface DashboardSettingsAlertManagementAlertsRouteRouteChildren {
  DashboardSettingsAlertManagementAlertsAlertIdRouteRoute: typeof DashboardSettingsAlertManagementAlertsAlertIdRouteRouteWithChildren
}

const DashboardSettingsAlertManagementAlertsRouteRouteChildren: DashboardSettingsAlertManagementAlertsRouteRouteChildren =
  {
    DashboardSettingsAlertManagementAlertsAlertIdRouteRoute:
      DashboardSettingsAlertManagementAlertsAlertIdRouteRouteWithChildren,
  }

const DashboardSettingsAlertManagementAlertsRouteRouteWithChildren =
  DashboardSettingsAlertManagementAlertsRouteRoute._addFileChildren(
    DashboardSettingsAlertManagementAlertsRouteRouteChildren,
  )

interface DashboardSettingsAlertManagementMetricAlertsRouteRouteChildren {
  DashboardSettingsAlertManagementMetricAlertsMetricAlertIdIndexRoute: typeof DashboardSettingsAlertManagementMetricAlertsMetricAlertIdIndexRoute
}

const DashboardSettingsAlertManagementMetricAlertsRouteRouteChildren: DashboardSettingsAlertManagementMetricAlertsRouteRouteChildren =
  {
    DashboardSettingsAlertManagementMetricAlertsMetricAlertIdIndexRoute:
      DashboardSettingsAlertManagementMetricAlertsMetricAlertIdIndexRoute,
  }

const DashboardSettingsAlertManagementMetricAlertsRouteRouteWithChildren =
  DashboardSettingsAlertManagementMetricAlertsRouteRoute._addFileChildren(
    DashboardSettingsAlertManagementMetricAlertsRouteRouteChildren,
  )

interface DashboardSettingsAlertManagementRouteRouteChildren {
  DashboardSettingsAlertManagementAlertChannelsRouteRoute: typeof DashboardSettingsAlertManagementAlertChannelsRouteRoute
  DashboardSettingsAlertManagementAlertsRouteRoute: typeof DashboardSettingsAlertManagementAlertsRouteRouteWithChildren
  DashboardSettingsAlertManagementMetricAlertsRouteRoute: typeof DashboardSettingsAlertManagementMetricAlertsRouteRouteWithChildren
  DashboardSettingsAlertManagementIndexRoute: typeof DashboardSettingsAlertManagementIndexRoute
}

const DashboardSettingsAlertManagementRouteRouteChildren: DashboardSettingsAlertManagementRouteRouteChildren =
  {
    DashboardSettingsAlertManagementAlertChannelsRouteRoute:
      DashboardSettingsAlertManagementAlertChannelsRouteRoute,
    DashboardSettingsAlertManagementAlertsRouteRoute:
      DashboardSettingsAlertManagementAlertsRouteRouteWithChildren,
    DashboardSettingsAlertManagementMetricAlertsRouteRoute:
      DashboardSettingsAlertManagementMetricAlertsRouteRouteWithChildren,
    DashboardSettingsAlertManagementIndexRoute:
      DashboardSettingsAlertManagementIndexRoute,
  }

const DashboardSettingsAlertManagementRouteRouteWithChildren =
  DashboardSettingsAlertManagementRouteRoute._addFileChildren(
    DashboardSettingsAlertManagementRouteRouteChildren,
  )

interface DashboardSettingsQueuesQueueNameFailuresRouteRouteChildren {
  DashboardSettingsQueuesQueueNameFailuresIndexRouteRoute: typeof DashboardSettingsQueuesQueueNameFailuresIndexRouteRoute
}

const DashboardSettingsQueuesQueueNameFailuresRouteRouteChildren: DashboardSettingsQueuesQueueNameFailuresRouteRouteChildren =
  {
    DashboardSettingsQueuesQueueNameFailuresIndexRouteRoute:
      DashboardSettingsQueuesQueueNameFailuresIndexRouteRoute,
  }

const DashboardSettingsQueuesQueueNameFailuresRouteRouteWithChildren =
  DashboardSettingsQueuesQueueNameFailuresRouteRoute._addFileChildren(
    DashboardSettingsQueuesQueueNameFailuresRouteRouteChildren,
  )

interface DashboardSettingsQueuesQueueNamePendingRouteRouteChildren {
  DashboardSettingsQueuesQueueNamePendingIndexRouteRoute: typeof DashboardSettingsQueuesQueueNamePendingIndexRouteRoute
}

const DashboardSettingsQueuesQueueNamePendingRouteRouteChildren: DashboardSettingsQueuesQueueNamePendingRouteRouteChildren =
  {
    DashboardSettingsQueuesQueueNamePendingIndexRouteRoute:
      DashboardSettingsQueuesQueueNamePendingIndexRouteRoute,
  }

const DashboardSettingsQueuesQueueNamePendingRouteRouteWithChildren =
  DashboardSettingsQueuesQueueNamePendingRouteRoute._addFileChildren(
    DashboardSettingsQueuesQueueNamePendingRouteRouteChildren,
  )

interface DashboardSettingsQueuesQueueNameRouteRouteChildren {
  DashboardSettingsQueuesQueueNameFailuresRouteRoute: typeof DashboardSettingsQueuesQueueNameFailuresRouteRouteWithChildren
  DashboardSettingsQueuesQueueNamePendingRouteRoute: typeof DashboardSettingsQueuesQueueNamePendingRouteRouteWithChildren
  DashboardSettingsQueuesQueueNameIndexRoute: typeof DashboardSettingsQueuesQueueNameIndexRoute
}

const DashboardSettingsQueuesQueueNameRouteRouteChildren: DashboardSettingsQueuesQueueNameRouteRouteChildren =
  {
    DashboardSettingsQueuesQueueNameFailuresRouteRoute:
      DashboardSettingsQueuesQueueNameFailuresRouteRouteWithChildren,
    DashboardSettingsQueuesQueueNamePendingRouteRoute:
      DashboardSettingsQueuesQueueNamePendingRouteRouteWithChildren,
    DashboardSettingsQueuesQueueNameIndexRoute:
      DashboardSettingsQueuesQueueNameIndexRoute,
  }

const DashboardSettingsQueuesQueueNameRouteRouteWithChildren =
  DashboardSettingsQueuesQueueNameRouteRoute._addFileChildren(
    DashboardSettingsQueuesQueueNameRouteRouteChildren,
  )

interface DashboardSettingsQueuesRouteRouteChildren {
  DashboardSettingsQueuesQueueNameRouteRoute: typeof DashboardSettingsQueuesQueueNameRouteRouteWithChildren
  DashboardSettingsQueuesIndexRoute: typeof DashboardSettingsQueuesIndexRoute
}

const DashboardSettingsQueuesRouteRouteChildren: DashboardSettingsQueuesRouteRouteChildren =
  {
    DashboardSettingsQueuesQueueNameRouteRoute:
      DashboardSettingsQueuesQueueNameRouteRouteWithChildren,
    DashboardSettingsQueuesIndexRoute: DashboardSettingsQueuesIndexRoute,
  }

const DashboardSettingsQueuesRouteRouteWithChildren =
  DashboardSettingsQueuesRouteRoute._addFileChildren(
    DashboardSettingsQueuesRouteRouteChildren,
  )

interface DashboardSettingsReportSettingsReportIdRouteRouteChildren {
  DashboardSettingsReportSettingsReportIdOverviewRouteRoute: typeof DashboardSettingsReportSettingsReportIdOverviewRouteRoute
  DashboardSettingsReportSettingsReportIdParametersRouteRoute: typeof DashboardSettingsReportSettingsReportIdParametersRouteRoute
  DashboardSettingsReportSettingsReportIdSendLogRouteRoute: typeof DashboardSettingsReportSettingsReportIdSendLogRouteRoute
  DashboardSettingsReportSettingsReportIdSubscriptions2RouteRoute: typeof DashboardSettingsReportSettingsReportIdSubscriptions2RouteRoute
  DashboardSettingsReportSettingsReportIdIndexRoute: typeof DashboardSettingsReportSettingsReportIdIndexRoute
}

const DashboardSettingsReportSettingsReportIdRouteRouteChildren: DashboardSettingsReportSettingsReportIdRouteRouteChildren =
  {
    DashboardSettingsReportSettingsReportIdOverviewRouteRoute:
      DashboardSettingsReportSettingsReportIdOverviewRouteRoute,
    DashboardSettingsReportSettingsReportIdParametersRouteRoute:
      DashboardSettingsReportSettingsReportIdParametersRouteRoute,
    DashboardSettingsReportSettingsReportIdSendLogRouteRoute:
      DashboardSettingsReportSettingsReportIdSendLogRouteRoute,
    DashboardSettingsReportSettingsReportIdSubscriptions2RouteRoute:
      DashboardSettingsReportSettingsReportIdSubscriptions2RouteRoute,
    DashboardSettingsReportSettingsReportIdIndexRoute:
      DashboardSettingsReportSettingsReportIdIndexRoute,
  }

const DashboardSettingsReportSettingsReportIdRouteRouteWithChildren =
  DashboardSettingsReportSettingsReportIdRouteRoute._addFileChildren(
    DashboardSettingsReportSettingsReportIdRouteRouteChildren,
  )

interface DashboardSettingsReportSettingsRouteRouteChildren {
  DashboardSettingsReportSettingsReportIdRouteRoute: typeof DashboardSettingsReportSettingsReportIdRouteRouteWithChildren
}

const DashboardSettingsReportSettingsRouteRouteChildren: DashboardSettingsReportSettingsRouteRouteChildren =
  {
    DashboardSettingsReportSettingsReportIdRouteRoute:
      DashboardSettingsReportSettingsReportIdRouteRouteWithChildren,
  }

const DashboardSettingsReportSettingsRouteRouteWithChildren =
  DashboardSettingsReportSettingsRouteRoute._addFileChildren(
    DashboardSettingsReportSettingsRouteRouteChildren,
  )

interface DashboardSettingsTagsManagementCatalogTagIdRouteRouteChildren {
  DashboardSettingsTagsManagementCatalogTagIdDetailsRouteRoute: typeof DashboardSettingsTagsManagementCatalogTagIdDetailsRouteRoute
  DashboardSettingsTagsManagementCatalogTagIdIndexRoute: typeof DashboardSettingsTagsManagementCatalogTagIdIndexRoute
}

const DashboardSettingsTagsManagementCatalogTagIdRouteRouteChildren: DashboardSettingsTagsManagementCatalogTagIdRouteRouteChildren =
  {
    DashboardSettingsTagsManagementCatalogTagIdDetailsRouteRoute:
      DashboardSettingsTagsManagementCatalogTagIdDetailsRouteRoute,
    DashboardSettingsTagsManagementCatalogTagIdIndexRoute:
      DashboardSettingsTagsManagementCatalogTagIdIndexRoute,
  }

const DashboardSettingsTagsManagementCatalogTagIdRouteRouteWithChildren =
  DashboardSettingsTagsManagementCatalogTagIdRouteRoute._addFileChildren(
    DashboardSettingsTagsManagementCatalogTagIdRouteRouteChildren,
  )

interface DashboardSettingsTagsManagementCatalogRouteRouteChildren {
  DashboardSettingsTagsManagementCatalogTagIdRouteRoute: typeof DashboardSettingsTagsManagementCatalogTagIdRouteRouteWithChildren
}

const DashboardSettingsTagsManagementCatalogRouteRouteChildren: DashboardSettingsTagsManagementCatalogRouteRouteChildren =
  {
    DashboardSettingsTagsManagementCatalogTagIdRouteRoute:
      DashboardSettingsTagsManagementCatalogTagIdRouteRouteWithChildren,
  }

const DashboardSettingsTagsManagementCatalogRouteRouteWithChildren =
  DashboardSettingsTagsManagementCatalogRouteRoute._addFileChildren(
    DashboardSettingsTagsManagementCatalogRouteRouteChildren,
  )

interface DashboardSettingsTagsManagementClustersTagIdRouteRouteChildren {
  DashboardSettingsTagsManagementClustersTagIdDetailsRouteRoute: typeof DashboardSettingsTagsManagementClustersTagIdDetailsRouteRoute
  DashboardSettingsTagsManagementClustersTagIdIndexRoute: typeof DashboardSettingsTagsManagementClustersTagIdIndexRoute
}

const DashboardSettingsTagsManagementClustersTagIdRouteRouteChildren: DashboardSettingsTagsManagementClustersTagIdRouteRouteChildren =
  {
    DashboardSettingsTagsManagementClustersTagIdDetailsRouteRoute:
      DashboardSettingsTagsManagementClustersTagIdDetailsRouteRoute,
    DashboardSettingsTagsManagementClustersTagIdIndexRoute:
      DashboardSettingsTagsManagementClustersTagIdIndexRoute,
  }

const DashboardSettingsTagsManagementClustersTagIdRouteRouteWithChildren =
  DashboardSettingsTagsManagementClustersTagIdRouteRoute._addFileChildren(
    DashboardSettingsTagsManagementClustersTagIdRouteRouteChildren,
  )

interface DashboardSettingsTagsManagementClustersRouteRouteChildren {
  DashboardSettingsTagsManagementClustersTagIdRouteRoute: typeof DashboardSettingsTagsManagementClustersTagIdRouteRouteWithChildren
}

const DashboardSettingsTagsManagementClustersRouteRouteChildren: DashboardSettingsTagsManagementClustersRouteRouteChildren =
  {
    DashboardSettingsTagsManagementClustersTagIdRouteRoute:
      DashboardSettingsTagsManagementClustersTagIdRouteRouteWithChildren,
  }

const DashboardSettingsTagsManagementClustersRouteRouteWithChildren =
  DashboardSettingsTagsManagementClustersRouteRoute._addFileChildren(
    DashboardSettingsTagsManagementClustersRouteRouteChildren,
  )

interface DashboardSettingsTagsManagementDevicesTagIdRouteRouteChildren {
  DashboardSettingsTagsManagementDevicesTagIdDetailsRouteRoute: typeof DashboardSettingsTagsManagementDevicesTagIdDetailsRouteRoute
  DashboardSettingsTagsManagementDevicesTagIdIndexRoute: typeof DashboardSettingsTagsManagementDevicesTagIdIndexRoute
}

const DashboardSettingsTagsManagementDevicesTagIdRouteRouteChildren: DashboardSettingsTagsManagementDevicesTagIdRouteRouteChildren =
  {
    DashboardSettingsTagsManagementDevicesTagIdDetailsRouteRoute:
      DashboardSettingsTagsManagementDevicesTagIdDetailsRouteRoute,
    DashboardSettingsTagsManagementDevicesTagIdIndexRoute:
      DashboardSettingsTagsManagementDevicesTagIdIndexRoute,
  }

const DashboardSettingsTagsManagementDevicesTagIdRouteRouteWithChildren =
  DashboardSettingsTagsManagementDevicesTagIdRouteRoute._addFileChildren(
    DashboardSettingsTagsManagementDevicesTagIdRouteRouteChildren,
  )

interface DashboardSettingsTagsManagementDevicesRouteRouteChildren {
  DashboardSettingsTagsManagementDevicesTagIdRouteRoute: typeof DashboardSettingsTagsManagementDevicesTagIdRouteRouteWithChildren
}

const DashboardSettingsTagsManagementDevicesRouteRouteChildren: DashboardSettingsTagsManagementDevicesRouteRouteChildren =
  {
    DashboardSettingsTagsManagementDevicesTagIdRouteRoute:
      DashboardSettingsTagsManagementDevicesTagIdRouteRouteWithChildren,
  }

const DashboardSettingsTagsManagementDevicesRouteRouteWithChildren =
  DashboardSettingsTagsManagementDevicesRouteRoute._addFileChildren(
    DashboardSettingsTagsManagementDevicesRouteRouteChildren,
  )

interface DashboardSettingsTagsManagementSamplesTagIdRouteRouteChildren {
  DashboardSettingsTagsManagementSamplesTagIdDetailsRouteRoute: typeof DashboardSettingsTagsManagementSamplesTagIdDetailsRouteRoute
  DashboardSettingsTagsManagementSamplesTagIdIndexRoute: typeof DashboardSettingsTagsManagementSamplesTagIdIndexRoute
}

const DashboardSettingsTagsManagementSamplesTagIdRouteRouteChildren: DashboardSettingsTagsManagementSamplesTagIdRouteRouteChildren =
  {
    DashboardSettingsTagsManagementSamplesTagIdDetailsRouteRoute:
      DashboardSettingsTagsManagementSamplesTagIdDetailsRouteRoute,
    DashboardSettingsTagsManagementSamplesTagIdIndexRoute:
      DashboardSettingsTagsManagementSamplesTagIdIndexRoute,
  }

const DashboardSettingsTagsManagementSamplesTagIdRouteRouteWithChildren =
  DashboardSettingsTagsManagementSamplesTagIdRouteRoute._addFileChildren(
    DashboardSettingsTagsManagementSamplesTagIdRouteRouteChildren,
  )

interface DashboardSettingsTagsManagementSamplesRouteRouteChildren {
  DashboardSettingsTagsManagementSamplesTagIdRouteRoute: typeof DashboardSettingsTagsManagementSamplesTagIdRouteRouteWithChildren
}

const DashboardSettingsTagsManagementSamplesRouteRouteChildren: DashboardSettingsTagsManagementSamplesRouteRouteChildren =
  {
    DashboardSettingsTagsManagementSamplesTagIdRouteRoute:
      DashboardSettingsTagsManagementSamplesTagIdRouteRouteWithChildren,
  }

const DashboardSettingsTagsManagementSamplesRouteRouteWithChildren =
  DashboardSettingsTagsManagementSamplesRouteRoute._addFileChildren(
    DashboardSettingsTagsManagementSamplesRouteRouteChildren,
  )

interface DashboardSettingsTagsManagementSessionsTagIdRouteRouteChildren {
  DashboardSettingsTagsManagementSessionsTagIdDetailsRouteRoute: typeof DashboardSettingsTagsManagementSessionsTagIdDetailsRouteRoute
  DashboardSettingsTagsManagementSessionsTagIdIndexRoute: typeof DashboardSettingsTagsManagementSessionsTagIdIndexRoute
}

const DashboardSettingsTagsManagementSessionsTagIdRouteRouteChildren: DashboardSettingsTagsManagementSessionsTagIdRouteRouteChildren =
  {
    DashboardSettingsTagsManagementSessionsTagIdDetailsRouteRoute:
      DashboardSettingsTagsManagementSessionsTagIdDetailsRouteRoute,
    DashboardSettingsTagsManagementSessionsTagIdIndexRoute:
      DashboardSettingsTagsManagementSessionsTagIdIndexRoute,
  }

const DashboardSettingsTagsManagementSessionsTagIdRouteRouteWithChildren =
  DashboardSettingsTagsManagementSessionsTagIdRouteRoute._addFileChildren(
    DashboardSettingsTagsManagementSessionsTagIdRouteRouteChildren,
  )

interface DashboardSettingsTagsManagementSessionsRouteRouteChildren {
  DashboardSettingsTagsManagementSessionsTagIdRouteRoute: typeof DashboardSettingsTagsManagementSessionsTagIdRouteRouteWithChildren
}

const DashboardSettingsTagsManagementSessionsRouteRouteChildren: DashboardSettingsTagsManagementSessionsRouteRouteChildren =
  {
    DashboardSettingsTagsManagementSessionsTagIdRouteRoute:
      DashboardSettingsTagsManagementSessionsTagIdRouteRouteWithChildren,
  }

const DashboardSettingsTagsManagementSessionsRouteRouteWithChildren =
  DashboardSettingsTagsManagementSessionsRouteRoute._addFileChildren(
    DashboardSettingsTagsManagementSessionsRouteRouteChildren,
  )

interface DashboardSettingsTagsManagementSitesTagIdRouteRouteChildren {
  DashboardSettingsTagsManagementSitesTagIdDetailsRouteRoute: typeof DashboardSettingsTagsManagementSitesTagIdDetailsRouteRoute
  DashboardSettingsTagsManagementSitesTagIdIndexRoute: typeof DashboardSettingsTagsManagementSitesTagIdIndexRoute
}

const DashboardSettingsTagsManagementSitesTagIdRouteRouteChildren: DashboardSettingsTagsManagementSitesTagIdRouteRouteChildren =
  {
    DashboardSettingsTagsManagementSitesTagIdDetailsRouteRoute:
      DashboardSettingsTagsManagementSitesTagIdDetailsRouteRoute,
    DashboardSettingsTagsManagementSitesTagIdIndexRoute:
      DashboardSettingsTagsManagementSitesTagIdIndexRoute,
  }

const DashboardSettingsTagsManagementSitesTagIdRouteRouteWithChildren =
  DashboardSettingsTagsManagementSitesTagIdRouteRoute._addFileChildren(
    DashboardSettingsTagsManagementSitesTagIdRouteRouteChildren,
  )

interface DashboardSettingsTagsManagementSitesRouteRouteChildren {
  DashboardSettingsTagsManagementSitesTagIdRouteRoute: typeof DashboardSettingsTagsManagementSitesTagIdRouteRouteWithChildren
}

const DashboardSettingsTagsManagementSitesRouteRouteChildren: DashboardSettingsTagsManagementSitesRouteRouteChildren =
  {
    DashboardSettingsTagsManagementSitesTagIdRouteRoute:
      DashboardSettingsTagsManagementSitesTagIdRouteRouteWithChildren,
  }

const DashboardSettingsTagsManagementSitesRouteRouteWithChildren =
  DashboardSettingsTagsManagementSitesRouteRoute._addFileChildren(
    DashboardSettingsTagsManagementSitesRouteRouteChildren,
  )

interface DashboardSettingsTagsManagementRouteRouteChildren {
  DashboardSettingsTagsManagementCatalogRouteRoute: typeof DashboardSettingsTagsManagementCatalogRouteRouteWithChildren
  DashboardSettingsTagsManagementClustersRouteRoute: typeof DashboardSettingsTagsManagementClustersRouteRouteWithChildren
  DashboardSettingsTagsManagementDevicesRouteRoute: typeof DashboardSettingsTagsManagementDevicesRouteRouteWithChildren
  DashboardSettingsTagsManagementSamplesRouteRoute: typeof DashboardSettingsTagsManagementSamplesRouteRouteWithChildren
  DashboardSettingsTagsManagementSessionsRouteRoute: typeof DashboardSettingsTagsManagementSessionsRouteRouteWithChildren
  DashboardSettingsTagsManagementSitesRouteRoute: typeof DashboardSettingsTagsManagementSitesRouteRouteWithChildren
  DashboardSettingsTagsManagementIndexRoute: typeof DashboardSettingsTagsManagementIndexRoute
}

const DashboardSettingsTagsManagementRouteRouteChildren: DashboardSettingsTagsManagementRouteRouteChildren =
  {
    DashboardSettingsTagsManagementCatalogRouteRoute:
      DashboardSettingsTagsManagementCatalogRouteRouteWithChildren,
    DashboardSettingsTagsManagementClustersRouteRoute:
      DashboardSettingsTagsManagementClustersRouteRouteWithChildren,
    DashboardSettingsTagsManagementDevicesRouteRoute:
      DashboardSettingsTagsManagementDevicesRouteRouteWithChildren,
    DashboardSettingsTagsManagementSamplesRouteRoute:
      DashboardSettingsTagsManagementSamplesRouteRouteWithChildren,
    DashboardSettingsTagsManagementSessionsRouteRoute:
      DashboardSettingsTagsManagementSessionsRouteRouteWithChildren,
    DashboardSettingsTagsManagementSitesRouteRoute:
      DashboardSettingsTagsManagementSitesRouteRouteWithChildren,
    DashboardSettingsTagsManagementIndexRoute:
      DashboardSettingsTagsManagementIndexRoute,
  }

const DashboardSettingsTagsManagementRouteRouteWithChildren =
  DashboardSettingsTagsManagementRouteRoute._addFileChildren(
    DashboardSettingsTagsManagementRouteRouteChildren,
  )

interface DashboardSettingsUserManagementUserIdRouteRouteChildren {
  DashboardSettingsUserManagementUserIdOverviewRouteRoute: typeof DashboardSettingsUserManagementUserIdOverviewRouteRoute
  DashboardSettingsUserManagementUserIdIndexRoute: typeof DashboardSettingsUserManagementUserIdIndexRoute
}

const DashboardSettingsUserManagementUserIdRouteRouteChildren: DashboardSettingsUserManagementUserIdRouteRouteChildren =
  {
    DashboardSettingsUserManagementUserIdOverviewRouteRoute:
      DashboardSettingsUserManagementUserIdOverviewRouteRoute,
    DashboardSettingsUserManagementUserIdIndexRoute:
      DashboardSettingsUserManagementUserIdIndexRoute,
  }

const DashboardSettingsUserManagementUserIdRouteRouteWithChildren =
  DashboardSettingsUserManagementUserIdRouteRoute._addFileChildren(
    DashboardSettingsUserManagementUserIdRouteRouteChildren,
  )

interface DashboardSettingsUserManagementRouteRouteChildren {
  DashboardSettingsUserManagementUserIdRouteRoute: typeof DashboardSettingsUserManagementUserIdRouteRouteWithChildren
  DashboardSettingsUserManagementThumbnailRoute: typeof DashboardSettingsUserManagementThumbnailRoute
}

const DashboardSettingsUserManagementRouteRouteChildren: DashboardSettingsUserManagementRouteRouteChildren =
  {
    DashboardSettingsUserManagementUserIdRouteRoute:
      DashboardSettingsUserManagementUserIdRouteRouteWithChildren,
    DashboardSettingsUserManagementThumbnailRoute:
      DashboardSettingsUserManagementThumbnailRoute,
  }

const DashboardSettingsUserManagementRouteRouteWithChildren =
  DashboardSettingsUserManagementRouteRoute._addFileChildren(
    DashboardSettingsUserManagementRouteRouteChildren,
  )

interface DashboardSettingsReportSubscriptionReportIdSubscriptionIdRouteRouteChildren {
  DashboardSettingsReportSubscriptionReportIdSubscriptionIdEditRouteRoute: typeof DashboardSettingsReportSubscriptionReportIdSubscriptionIdEditRouteRoute
  DashboardSettingsReportSubscriptionReportIdSubscriptionIdOverviewRouteRoute: typeof DashboardSettingsReportSubscriptionReportIdSubscriptionIdOverviewRouteRoute
  DashboardSettingsReportSubscriptionReportIdSubscriptionIdReviewAndApproveRouteRoute: typeof DashboardSettingsReportSubscriptionReportIdSubscriptionIdReviewAndApproveRouteRoute
  DashboardSettingsReportSubscriptionReportIdSubscriptionIdSendHistoryRouteRoute: typeof DashboardSettingsReportSubscriptionReportIdSubscriptionIdSendHistoryRouteRoute
  DashboardSettingsReportSubscriptionReportIdSubscriptionIdIndexRoute: typeof DashboardSettingsReportSubscriptionReportIdSubscriptionIdIndexRoute
}

const DashboardSettingsReportSubscriptionReportIdSubscriptionIdRouteRouteChildren: DashboardSettingsReportSubscriptionReportIdSubscriptionIdRouteRouteChildren =
  {
    DashboardSettingsReportSubscriptionReportIdSubscriptionIdEditRouteRoute:
      DashboardSettingsReportSubscriptionReportIdSubscriptionIdEditRouteRoute,
    DashboardSettingsReportSubscriptionReportIdSubscriptionIdOverviewRouteRoute:
      DashboardSettingsReportSubscriptionReportIdSubscriptionIdOverviewRouteRoute,
    DashboardSettingsReportSubscriptionReportIdSubscriptionIdReviewAndApproveRouteRoute:
      DashboardSettingsReportSubscriptionReportIdSubscriptionIdReviewAndApproveRouteRoute,
    DashboardSettingsReportSubscriptionReportIdSubscriptionIdSendHistoryRouteRoute:
      DashboardSettingsReportSubscriptionReportIdSubscriptionIdSendHistoryRouteRoute,
    DashboardSettingsReportSubscriptionReportIdSubscriptionIdIndexRoute:
      DashboardSettingsReportSubscriptionReportIdSubscriptionIdIndexRoute,
  }

const DashboardSettingsReportSubscriptionReportIdSubscriptionIdRouteRouteWithChildren =
  DashboardSettingsReportSubscriptionReportIdSubscriptionIdRouteRoute._addFileChildren(
    DashboardSettingsReportSubscriptionReportIdSubscriptionIdRouteRouteChildren,
  )

interface DashboardSettingsRouteRouteChildren {
  DashboardSettingsAlertManagementRouteRoute: typeof DashboardSettingsAlertManagementRouteRouteWithChildren
  DashboardSettingsJobDefaultsRouteRoute: typeof DashboardSettingsJobDefaultsRouteRoute
  DashboardSettingsOverviewRouteRoute: typeof DashboardSettingsOverviewRouteRoute
  DashboardSettingsPermissionsSettingsRouteRoute: typeof DashboardSettingsPermissionsSettingsRouteRoute
  DashboardSettingsPermissionsSettingsDevRouteRoute: typeof DashboardSettingsPermissionsSettingsDevRouteRoute
  DashboardSettingsQueuesRouteRoute: typeof DashboardSettingsQueuesRouteRouteWithChildren
  DashboardSettingsRegionsRouteRoute: typeof DashboardSettingsRegionsRouteRoute
  DashboardSettingsReportSettingsRouteRoute: typeof DashboardSettingsReportSettingsRouteRouteWithChildren
  DashboardSettingsTagsManagementRouteRoute: typeof DashboardSettingsTagsManagementRouteRouteWithChildren
  DashboardSettingsUserManagementRouteRoute: typeof DashboardSettingsUserManagementRouteRouteWithChildren
  DashboardSettingsIndexRoute: typeof DashboardSettingsIndexRoute
  DashboardSettingsReportSubscriptionReportIdSubscriptionIdRouteRoute: typeof DashboardSettingsReportSubscriptionReportIdSubscriptionIdRouteRouteWithChildren
}

const DashboardSettingsRouteRouteChildren: DashboardSettingsRouteRouteChildren =
  {
    DashboardSettingsAlertManagementRouteRoute:
      DashboardSettingsAlertManagementRouteRouteWithChildren,
    DashboardSettingsJobDefaultsRouteRoute:
      DashboardSettingsJobDefaultsRouteRoute,
    DashboardSettingsOverviewRouteRoute: DashboardSettingsOverviewRouteRoute,
    DashboardSettingsPermissionsSettingsRouteRoute:
      DashboardSettingsPermissionsSettingsRouteRoute,
    DashboardSettingsPermissionsSettingsDevRouteRoute:
      DashboardSettingsPermissionsSettingsDevRouteRoute,
    DashboardSettingsQueuesRouteRoute:
      DashboardSettingsQueuesRouteRouteWithChildren,
    DashboardSettingsRegionsRouteRoute: DashboardSettingsRegionsRouteRoute,
    DashboardSettingsReportSettingsRouteRoute:
      DashboardSettingsReportSettingsRouteRouteWithChildren,
    DashboardSettingsTagsManagementRouteRoute:
      DashboardSettingsTagsManagementRouteRouteWithChildren,
    DashboardSettingsUserManagementRouteRoute:
      DashboardSettingsUserManagementRouteRouteWithChildren,
    DashboardSettingsIndexRoute: DashboardSettingsIndexRoute,
    DashboardSettingsReportSubscriptionReportIdSubscriptionIdRouteRoute:
      DashboardSettingsReportSubscriptionReportIdSubscriptionIdRouteRouteWithChildren,
  }

const DashboardSettingsRouteRouteWithChildren =
  DashboardSettingsRouteRoute._addFileChildren(
    DashboardSettingsRouteRouteChildren,
  )

interface DashboardHomeManagerReportSessionIdRouteRouteChildren {
  DashboardHomeManagerReportSessionIdOverviewRouteRoute: typeof DashboardHomeManagerReportSessionIdOverviewRouteRoute
  DashboardHomeManagerReportSessionIdIndexRoute: typeof DashboardHomeManagerReportSessionIdIndexRoute
}

const DashboardHomeManagerReportSessionIdRouteRouteChildren: DashboardHomeManagerReportSessionIdRouteRouteChildren =
  {
    DashboardHomeManagerReportSessionIdOverviewRouteRoute:
      DashboardHomeManagerReportSessionIdOverviewRouteRoute,
    DashboardHomeManagerReportSessionIdIndexRoute:
      DashboardHomeManagerReportSessionIdIndexRoute,
  }

const DashboardHomeManagerReportSessionIdRouteRouteWithChildren =
  DashboardHomeManagerReportSessionIdRouteRoute._addFileChildren(
    DashboardHomeManagerReportSessionIdRouteRouteChildren,
  )

interface DashboardHomeManagerReportRouteRouteChildren {
  DashboardHomeManagerReportSessionIdRouteRoute: typeof DashboardHomeManagerReportSessionIdRouteRouteWithChildren
  DashboardHomeManagerReportIndexRoute: typeof DashboardHomeManagerReportIndexRoute
}

const DashboardHomeManagerReportRouteRouteChildren: DashboardHomeManagerReportRouteRouteChildren =
  {
    DashboardHomeManagerReportSessionIdRouteRoute:
      DashboardHomeManagerReportSessionIdRouteRouteWithChildren,
    DashboardHomeManagerReportIndexRoute: DashboardHomeManagerReportIndexRoute,
  }

const DashboardHomeManagerReportRouteRouteWithChildren =
  DashboardHomeManagerReportRouteRoute._addFileChildren(
    DashboardHomeManagerReportRouteRouteChildren,
  )

interface DashboardHomeRouteChildren {
  DashboardHomeManagerReportRouteRoute: typeof DashboardHomeManagerReportRouteRouteWithChildren
  DashboardHomeIndexRoute: typeof DashboardHomeIndexRoute
}

const DashboardHomeRouteChildren: DashboardHomeRouteChildren = {
  DashboardHomeManagerReportRouteRoute:
    DashboardHomeManagerReportRouteRouteWithChildren,
  DashboardHomeIndexRoute: DashboardHomeIndexRoute,
}

const DashboardHomeRouteWithChildren = DashboardHomeRoute._addFileChildren(
  DashboardHomeRouteChildren,
)

interface DashboardRouteRouteChildren {
  DashboardAlertsRouteRoute: typeof DashboardAlertsRouteRoute
  DashboardDataRouteRoute: typeof DashboardDataRouteRouteWithChildren
  DashboardJobsRouteRoute: typeof DashboardJobsRouteRouteWithChildren
  DashboardModelsRouteRoute: typeof DashboardModelsRouteRouteWithChildren
  DashboardReportsRouteRoute: typeof DashboardReportsRouteRouteWithChildren
  DashboardResourcesRouteRoute: typeof DashboardResourcesRouteRouteWithChildren
  DashboardSettingsRouteRoute: typeof DashboardSettingsRouteRouteWithChildren
  DashboardUnauthorizedRouteRoute: typeof DashboardUnauthorizedRouteRoute
  DashboardHomeRoute: typeof DashboardHomeRouteWithChildren
  DashboardSupportRoute: typeof DashboardSupportRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
  DashboardRestRoute: typeof DashboardRestRoute
}

const DashboardRouteRouteChildren: DashboardRouteRouteChildren = {
  DashboardAlertsRouteRoute: DashboardAlertsRouteRoute,
  DashboardDataRouteRoute: DashboardDataRouteRouteWithChildren,
  DashboardJobsRouteRoute: DashboardJobsRouteRouteWithChildren,
  DashboardModelsRouteRoute: DashboardModelsRouteRouteWithChildren,
  DashboardReportsRouteRoute: DashboardReportsRouteRouteWithChildren,
  DashboardResourcesRouteRoute: DashboardResourcesRouteRouteWithChildren,
  DashboardSettingsRouteRoute: DashboardSettingsRouteRouteWithChildren,
  DashboardUnauthorizedRouteRoute: DashboardUnauthorizedRouteRoute,
  DashboardHomeRoute: DashboardHomeRouteWithChildren,
  DashboardSupportRoute: DashboardSupportRoute,
  DashboardIndexRoute: DashboardIndexRoute,
  DashboardRestRoute: DashboardRestRoute,
}

const DashboardRouteRouteWithChildren = DashboardRouteRoute._addFileChildren(
  DashboardRouteRouteChildren,
)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin-dashboard': typeof AdminDashboardRouteRouteWithChildren
  '/dashboard': typeof DashboardRouteRouteWithChildren
  '/unresponsive': typeof UnresponsiveRouteRoute
  '/login': typeof LoginRouteLazyRoute
  '/admin-dashboard/accounts-management': typeof AdminDashboardAccountsManagementRouteRouteWithChildren
  '/admin-dashboard/domain-auth-settings': typeof AdminDashboardDomainAuthSettingsRouteRoute
  '/admin-dashboard/jobs': typeof AdminDashboardJobsRouteRouteWithChildren
  '/admin-dashboard/notifications': typeof AdminDashboardNotificationsRouteRouteWithChildren
  '/dashboard/alerts': typeof DashboardAlertsRouteRoute
  '/dashboard/data': typeof DashboardDataRouteRouteWithChildren
  '/dashboard/jobs': typeof DashboardJobsRouteRouteWithChildren
  '/dashboard/models': typeof DashboardModelsRouteRouteWithChildren
  '/dashboard/reports': typeof DashboardReportsRouteRouteWithChildren
  '/dashboard/resources': typeof DashboardResourcesRouteRouteWithChildren
  '/dashboard/settings': typeof DashboardSettingsRouteRouteWithChildren
  '/dashboard/unauthorized': typeof DashboardUnauthorizedRouteRoute
  '/dashboard/home': typeof DashboardHomeRouteWithChildren
  '/dashboard/support': typeof DashboardSupportRoute
  '/next/$': typeof NextSplatRoute
  '/admin-dashboard/': typeof AdminDashboardIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/admin-dashboard/accounts-management/$accountId': typeof AdminDashboardAccountsManagementAccountIdRouteRouteWithChildren
  '/admin-dashboard/jobs/service-health-checks': typeof AdminDashboardJobsServiceHealthChecksRouteRouteWithChildren
  '/admin-dashboard/notifications/$notificationId': typeof AdminDashboardNotificationsNotificationIdRouteRouteWithChildren
  '/dashboard/data/annotations': typeof DashboardDataAnnotationsRouteRoute
  '/dashboard/data/catalog': typeof DashboardDataCatalogRouteRouteWithChildren
  '/dashboard/data/datasets': typeof DashboardDataDatasetsRouteRouteWithChildren
  '/dashboard/data/images': typeof DashboardDataImagesRouteRouteWithChildren
  '/dashboard/data/json-data': typeof DashboardDataJsonDataRouteRouteWithChildren
  '/dashboard/data/label-distribution': typeof DashboardDataLabelDistributionRouteRouteWithChildren
  '/dashboard/data/pending': typeof DashboardDataPendingRouteRoute
  '/dashboard/data/sessions': typeof DashboardDataSessionsRouteRouteWithChildren
  '/dashboard/home/manager-report': typeof DashboardHomeManagerReportRouteRouteWithChildren
  '/dashboard/jobs/camera-calibration': typeof DashboardJobsCameraCalibrationRouteRouteWithChildren
  '/dashboard/jobs/capacity-tagging': typeof DashboardJobsCapacityTaggingRouteRouteWithChildren
  '/dashboard/jobs/catalog-upload': typeof DashboardJobsCatalogUploadRouteRouteWithChildren
  '/dashboard/jobs/config': typeof DashboardJobsConfigRouteRouteWithChildren
  '/dashboard/jobs/delete-samples': typeof DashboardJobsDeleteSamplesRouteRouteWithChildren
  '/dashboard/jobs/delete-videos': typeof DashboardJobsDeleteVideosRouteRouteWithChildren
  '/dashboard/jobs/deployments': typeof DashboardJobsDeploymentsRouteRouteWithChildren
  '/dashboard/jobs/head-blur-images': typeof DashboardJobsHeadBlurImagesRouteRouteWithChildren
  '/dashboard/jobs/head-blur-videos': typeof DashboardJobsHeadBlurVideosRouteRouteWithChildren
  '/dashboard/jobs/models': typeof DashboardJobsModelsRouteRouteWithChildren
  '/dashboard/jobs/recovery-estimates': typeof DashboardJobsRecoveryEstimatesRouteRouteWithChildren
  '/dashboard/jobs/restarts': typeof DashboardJobsRestartsRouteRouteWithChildren
  '/dashboard/jobs/sample-upload': typeof DashboardJobsSampleUploadRouteRouteWithChildren
  '/dashboard/jobs/sync-samples': typeof DashboardJobsSyncSamplesRouteRouteWithChildren
  '/dashboard/jobs/training': typeof DashboardJobsTrainingRouteRouteWithChildren
  '/dashboard/jobs/video-upload': typeof DashboardJobsVideoUploadRouteRouteWithChildren
  '/dashboard/jobs/worker-jobs': typeof DashboardJobsWorkerJobsRouteRouteWithChildren
  '/dashboard/models/$modelId': typeof DashboardModelsModelIdRouteRouteWithChildren
  '/dashboard/reports/$reportId': typeof DashboardReportsReportIdRouteRoute
  '/dashboard/reports/analytics-hub': typeof DashboardReportsAnalyticsHubRouteRoute
  '/dashboard/reports/companion': typeof DashboardReportsCompanionRouteRoute
  '/dashboard/resources/clusters': typeof DashboardResourcesClustersRouteRouteWithChildren
  '/dashboard/resources/devices': typeof DashboardResourcesDevicesRouteRouteWithChildren
  '/dashboard/resources/site-groups': typeof DashboardResourcesSiteGroupsRouteRouteWithChildren
  '/dashboard/resources/sites': typeof DashboardResourcesSitesRouteRouteWithChildren
  '/dashboard/settings/alert-management': typeof DashboardSettingsAlertManagementRouteRouteWithChildren
  '/dashboard/settings/job-defaults': typeof DashboardSettingsJobDefaultsRouteRoute
  '/dashboard/settings/overview': typeof DashboardSettingsOverviewRouteRoute
  '/dashboard/settings/permissions-settings': typeof DashboardSettingsPermissionsSettingsRouteRoute
  '/dashboard/settings/permissions-settings-dev': typeof DashboardSettingsPermissionsSettingsDevRouteRoute
  '/dashboard/settings/queues': typeof DashboardSettingsQueuesRouteRouteWithChildren
  '/dashboard/settings/regions': typeof DashboardSettingsRegionsRouteRoute
  '/dashboard/settings/report-settings': typeof DashboardSettingsReportSettingsRouteRouteWithChildren
  '/dashboard/settings/tags-management': typeof DashboardSettingsTagsManagementRouteRouteWithChildren
  '/dashboard/settings/user-management': typeof DashboardSettingsUserManagementRouteRouteWithChildren
  '/dashboard/[/rest]': typeof DashboardRestRoute
  '/dashboard/data/': typeof DashboardDataIndexRoute
  '/dashboard/home/': typeof DashboardHomeIndexRoute
  '/dashboard/jobs/': typeof DashboardJobsIndexRoute
  '/dashboard/reports/': typeof DashboardReportsIndexRoute
  '/dashboard/resources/': typeof DashboardResourcesIndexRoute
  '/dashboard/settings/': typeof DashboardSettingsIndexRoute
  '/admin-dashboard/accounts-management/$accountId/operational-hours': typeof AdminDashboardAccountsManagementAccountIdOperationalHoursRouteRoute
  '/admin-dashboard/accounts-management/$accountId/overview': typeof AdminDashboardAccountsManagementAccountIdOverviewRouteRoute
  '/admin-dashboard/accounts-management/$accountId/regions': typeof AdminDashboardAccountsManagementAccountIdRegionsRouteRoute
  '/admin-dashboard/jobs/service-health-checks/jobs': typeof AdminDashboardJobsServiceHealthChecksJobsRouteRouteWithChildren
  '/admin-dashboard/jobs/service-health-checks/schedule': typeof AdminDashboardJobsServiceHealthChecksScheduleRouteRouteWithChildren
  '/admin-dashboard/notifications/$notificationId/overview': typeof AdminDashboardNotificationsNotificationIdOverviewRouteRoute
  '/dashboard/data/catalog/$item': typeof DashboardDataCatalogItemRouteRouteWithChildren
  '/dashboard/data/datasets/$datasetId': typeof DashboardDataDatasetsDatasetIdRouteRouteWithChildren
  '/dashboard/data/images/$imageUUID': typeof DashboardDataImagesImageUUIDRouteRouteWithChildren
  '/dashboard/data/json-data/$jsonDataUUID': typeof DashboardDataJsonDataJsonDataUUIDRouteRouteWithChildren
  '/dashboard/data/label-distribution/$label': typeof DashboardDataLabelDistributionLabelRouteRouteWithChildren
  '/dashboard/data/sessions/$sessionId': typeof DashboardDataSessionsSessionIdRouteRouteWithChildren
  '/dashboard/home/manager-report/$sessionId': typeof DashboardHomeManagerReportSessionIdRouteRouteWithChildren
  '/dashboard/jobs/camera-calibration/alerts': typeof DashboardJobsCameraCalibrationAlertsRouteRoute
  '/dashboard/jobs/camera-calibration/jobs': typeof DashboardJobsCameraCalibrationJobsRouteRouteWithChildren
  '/dashboard/jobs/camera-calibration/schedule': typeof DashboardJobsCameraCalibrationScheduleRouteRouteWithChildren
  '/dashboard/jobs/capacity-tagging/jobs': typeof DashboardJobsCapacityTaggingJobsRouteRouteWithChildren
  '/dashboard/jobs/capacity-tagging/schedule': typeof DashboardJobsCapacityTaggingScheduleRouteRouteWithChildren
  '/dashboard/jobs/catalog-upload/jobs': typeof DashboardJobsCatalogUploadJobsRouteRouteWithChildren
  '/dashboard/jobs/catalog-upload/schedule': typeof DashboardJobsCatalogUploadScheduleRouteRouteWithChildren
  '/dashboard/jobs/config/jobs': typeof DashboardJobsConfigJobsRouteRouteWithChildren
  '/dashboard/jobs/config/schedule': typeof DashboardJobsConfigScheduleRouteRouteWithChildren
  '/dashboard/jobs/delete-samples/alerts': typeof DashboardJobsDeleteSamplesAlertsRouteRoute
  '/dashboard/jobs/delete-samples/jobs': typeof DashboardJobsDeleteSamplesJobsRouteRouteWithChildren
  '/dashboard/jobs/delete-samples/schedule': typeof DashboardJobsDeleteSamplesScheduleRouteRouteWithChildren
  '/dashboard/jobs/delete-videos/alerts': typeof DashboardJobsDeleteVideosAlertsRouteRoute
  '/dashboard/jobs/delete-videos/jobs': typeof DashboardJobsDeleteVideosJobsRouteRouteWithChildren
  '/dashboard/jobs/delete-videos/schedule': typeof DashboardJobsDeleteVideosScheduleRouteRouteWithChildren
  '/dashboard/jobs/deployments/jobs': typeof DashboardJobsDeploymentsJobsRouteRouteWithChildren
  '/dashboard/jobs/deployments/schedule': typeof DashboardJobsDeploymentsScheduleRouteRouteWithChildren
  '/dashboard/jobs/head-blur-images/jobs': typeof DashboardJobsHeadBlurImagesJobsRouteRouteWithChildren
  '/dashboard/jobs/head-blur-images/schedule': typeof DashboardJobsHeadBlurImagesScheduleRouteRouteWithChildren
  '/dashboard/jobs/head-blur-videos/jobs': typeof DashboardJobsHeadBlurVideosJobsRouteRouteWithChildren
  '/dashboard/jobs/head-blur-videos/schedule': typeof DashboardJobsHeadBlurVideosScheduleRouteRouteWithChildren
  '/dashboard/jobs/models/jobs': typeof DashboardJobsModelsJobsRouteRouteWithChildren
  '/dashboard/jobs/models/schedule': typeof DashboardJobsModelsScheduleRouteRouteWithChildren
  '/dashboard/jobs/recovery-estimates/jobs': typeof DashboardJobsRecoveryEstimatesJobsRouteRouteWithChildren
  '/dashboard/jobs/recovery-estimates/schedule': typeof DashboardJobsRecoveryEstimatesScheduleRouteRouteWithChildren
  '/dashboard/jobs/restarts/jobs': typeof DashboardJobsRestartsJobsRouteRouteWithChildren
  '/dashboard/jobs/restarts/schedule': typeof DashboardJobsRestartsScheduleRouteRouteWithChildren
  '/dashboard/jobs/sample-upload/alerts': typeof DashboardJobsSampleUploadAlertsRouteRoute
  '/dashboard/jobs/sample-upload/jobs': typeof DashboardJobsSampleUploadJobsRouteRouteWithChildren
  '/dashboard/jobs/sample-upload/schedule': typeof DashboardJobsSampleUploadScheduleRouteRouteWithChildren
  '/dashboard/jobs/sync-samples/alerts': typeof DashboardJobsSyncSamplesAlertsRouteRoute
  '/dashboard/jobs/sync-samples/jobs': typeof DashboardJobsSyncSamplesJobsRouteRouteWithChildren
  '/dashboard/jobs/sync-samples/schedule': typeof DashboardJobsSyncSamplesScheduleRouteRouteWithChildren
  '/dashboard/jobs/training/jobs': typeof DashboardJobsTrainingJobsRouteRouteWithChildren
  '/dashboard/jobs/training/schedule': typeof DashboardJobsTrainingScheduleRouteRouteWithChildren
  '/dashboard/jobs/video-upload/alerts': typeof DashboardJobsVideoUploadAlertsRouteRoute
  '/dashboard/jobs/video-upload/jobs': typeof DashboardJobsVideoUploadJobsRouteRouteWithChildren
  '/dashboard/jobs/video-upload/schedule': typeof DashboardJobsVideoUploadScheduleRouteRouteWithChildren
  '/dashboard/jobs/worker-jobs/jobs': typeof DashboardJobsWorkerJobsJobsRouteRouteWithChildren
  '/dashboard/jobs/worker-jobs/schedule': typeof DashboardJobsWorkerJobsScheduleRouteRouteWithChildren
  '/dashboard/models/$modelId/deployment': typeof DashboardModelsModelIdDeploymentRouteRouteWithChildren
  '/dashboard/models/$modelId/labels': typeof DashboardModelsModelIdLabelsRouteRoute
  '/dashboard/models/$modelId/matrix': typeof DashboardModelsModelIdMatrixRouteRoute
  '/dashboard/models/$modelId/overview': typeof DashboardModelsModelIdOverviewRouteRoute
  '/dashboard/resources/clusters/$clusterId': typeof DashboardResourcesClustersClusterIdRouteRouteWithChildren
  '/dashboard/resources/devices/$deviceId': typeof DashboardResourcesDevicesDeviceIdRouteRouteWithChildren
  '/dashboard/resources/site-groups/$siteGroupId': typeof DashboardResourcesSiteGroupsSiteGroupIdRouteRouteWithChildren
  '/dashboard/resources/sites/$siteId': typeof DashboardResourcesSitesSiteIdRouteRouteWithChildren
  '/dashboard/settings/alert-management/alert-channels': typeof DashboardSettingsAlertManagementAlertChannelsRouteRoute
  '/dashboard/settings/alert-management/alerts': typeof DashboardSettingsAlertManagementAlertsRouteRouteWithChildren
  '/dashboard/settings/alert-management/metric-alerts': typeof DashboardSettingsAlertManagementMetricAlertsRouteRouteWithChildren
  '/dashboard/settings/queues/$queueName': typeof DashboardSettingsQueuesQueueNameRouteRouteWithChildren
  '/dashboard/settings/report-settings/$reportId': typeof DashboardSettingsReportSettingsReportIdRouteRouteWithChildren
  '/dashboard/settings/tags-management/catalog': typeof DashboardSettingsTagsManagementCatalogRouteRouteWithChildren
  '/dashboard/settings/tags-management/clusters': typeof DashboardSettingsTagsManagementClustersRouteRouteWithChildren
  '/dashboard/settings/tags-management/devices': typeof DashboardSettingsTagsManagementDevicesRouteRouteWithChildren
  '/dashboard/settings/tags-management/samples': typeof DashboardSettingsTagsManagementSamplesRouteRouteWithChildren
  '/dashboard/settings/tags-management/sessions': typeof DashboardSettingsTagsManagementSessionsRouteRouteWithChildren
  '/dashboard/settings/tags-management/sites': typeof DashboardSettingsTagsManagementSitesRouteRouteWithChildren
  '/dashboard/settings/user-management/$userId': typeof DashboardSettingsUserManagementUserIdRouteRouteWithChildren
  '/dashboard/data/[/rest]': typeof DashboardDataRestRoute
  '/dashboard/resources/[/rest]': typeof DashboardResourcesRestRoute
  '/dashboard/settings/user-management/thumbnail': typeof DashboardSettingsUserManagementThumbnailRoute
  '/admin-dashboard/accounts-management/$accountId/': typeof AdminDashboardAccountsManagementAccountIdIndexRoute
  '/admin-dashboard/jobs/service-health-checks/': typeof AdminDashboardJobsServiceHealthChecksIndexRoute
  '/dashboard/home/manager-report/': typeof DashboardHomeManagerReportIndexRoute
  '/dashboard/jobs/camera-calibration/': typeof DashboardJobsCameraCalibrationIndexRoute
  '/dashboard/jobs/capacity-tagging/': typeof DashboardJobsCapacityTaggingIndexRoute
  '/dashboard/jobs/catalog-upload/': typeof DashboardJobsCatalogUploadIndexRoute
  '/dashboard/jobs/config/': typeof DashboardJobsConfigIndexRoute
  '/dashboard/jobs/delete-samples/': typeof DashboardJobsDeleteSamplesIndexRoute
  '/dashboard/jobs/delete-videos/': typeof DashboardJobsDeleteVideosIndexRoute
  '/dashboard/jobs/deployments/': typeof DashboardJobsDeploymentsIndexRoute
  '/dashboard/jobs/head-blur-images/': typeof DashboardJobsHeadBlurImagesIndexRoute
  '/dashboard/jobs/head-blur-videos/': typeof DashboardJobsHeadBlurVideosIndexRoute
  '/dashboard/jobs/models/': typeof DashboardJobsModelsIndexRoute
  '/dashboard/jobs/recovery-estimates/': typeof DashboardJobsRecoveryEstimatesIndexRoute
  '/dashboard/jobs/restarts/': typeof DashboardJobsRestartsIndexRoute
  '/dashboard/jobs/sample-upload/': typeof DashboardJobsSampleUploadIndexRoute
  '/dashboard/jobs/sync-samples/': typeof DashboardJobsSyncSamplesIndexRoute
  '/dashboard/jobs/training/': typeof DashboardJobsTrainingIndexRoute
  '/dashboard/jobs/video-upload/': typeof DashboardJobsVideoUploadIndexRoute
  '/dashboard/jobs/worker-jobs/': typeof DashboardJobsWorkerJobsIndexRoute
  '/dashboard/models/$modelId/': typeof DashboardModelsModelIdIndexRoute
  '/dashboard/settings/alert-management/': typeof DashboardSettingsAlertManagementIndexRoute
  '/dashboard/settings/queues/': typeof DashboardSettingsQueuesIndexRoute
  '/dashboard/settings/tags-management/': typeof DashboardSettingsTagsManagementIndexRoute
  '/admin-dashboard/jobs/service-health-checks/jobs/$jobId': typeof AdminDashboardJobsServiceHealthChecksJobsJobIdRouteRouteWithChildren
  '/admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId': typeof AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdRouteRouteWithChildren
  '/dashboard/data/catalog/$item/details': typeof DashboardDataCatalogItemDetailsRouteRoute
  '/dashboard/data/catalog/$item/labels': typeof DashboardDataCatalogItemLabelsRouteRoute
  '/dashboard/data/catalog/$item/prices': typeof DashboardDataCatalogItemPricesRouteRoute
  '/dashboard/data/datasets/$datasetId/images': typeof DashboardDataDatasetsDatasetIdImagesRouteRoute
  '/dashboard/data/datasets/$datasetId/overview': typeof DashboardDataDatasetsDatasetIdOverviewRouteRoute
  '/dashboard/data/datasets/$datasetId/sessions': typeof DashboardDataDatasetsDatasetIdSessionsRouteRoute
  '/dashboard/data/images/$imageUUID/additional': typeof DashboardDataImagesImageUUIDAdditionalRouteRoute
  '/dashboard/data/images/$imageUUID/overview': typeof DashboardDataImagesImageUUIDOverviewRouteRoute
  '/dashboard/data/images/$imageUUID/transaction-details': typeof DashboardDataImagesImageUUIDTransactionDetailsRouteRoute
  '/dashboard/data/sessions/$sessionId/overview': typeof DashboardDataSessionsSessionIdOverviewRouteRoute
  '/dashboard/home/manager-report/$sessionId/overview': typeof DashboardHomeManagerReportSessionIdOverviewRouteRoute
  '/dashboard/jobs/camera-calibration/jobs/$jobId': typeof DashboardJobsCameraCalibrationJobsJobIdRouteRouteWithChildren
  '/dashboard/jobs/camera-calibration/schedule/$scheduledJobId': typeof DashboardJobsCameraCalibrationScheduleScheduledJobIdRouteRouteWithChildren
  '/dashboard/jobs/capacity-tagging/jobs/$jobId': typeof DashboardJobsCapacityTaggingJobsJobIdRouteRouteWithChildren
  '/dashboard/jobs/capacity-tagging/schedule/$scheduledJobId': typeof DashboardJobsCapacityTaggingScheduleScheduledJobIdRouteRouteWithChildren
  '/dashboard/jobs/catalog-upload/jobs/$jobId': typeof DashboardJobsCatalogUploadJobsJobIdRouteRouteWithChildren
  '/dashboard/jobs/catalog-upload/schedule/$scheduledJobId': typeof DashboardJobsCatalogUploadScheduleScheduledJobIdRouteRouteWithChildren
  '/dashboard/jobs/config/jobs/$jobId': typeof DashboardJobsConfigJobsJobIdRouteRouteWithChildren
  '/dashboard/jobs/config/schedule/$scheduledJobId': typeof DashboardJobsConfigScheduleScheduledJobIdRouteRouteWithChildren
  '/dashboard/jobs/delete-samples/jobs/$jobId': typeof DashboardJobsDeleteSamplesJobsJobIdRouteRouteWithChildren
  '/dashboard/jobs/delete-samples/schedule/$scheduledJobId': typeof DashboardJobsDeleteSamplesScheduleScheduledJobIdRouteRouteWithChildren
  '/dashboard/jobs/delete-videos/jobs/$jobId': typeof DashboardJobsDeleteVideosJobsJobIdRouteRouteWithChildren
  '/dashboard/jobs/delete-videos/schedule/$scheduledJobId': typeof DashboardJobsDeleteVideosScheduleScheduledJobIdRouteRouteWithChildren
  '/dashboard/jobs/deployments/jobs/$jobId': typeof DashboardJobsDeploymentsJobsJobIdRouteRouteWithChildren
  '/dashboard/jobs/deployments/schedule/$scheduledJobId': typeof DashboardJobsDeploymentsScheduleScheduledJobIdRouteRouteWithChildren
  '/dashboard/jobs/head-blur-images/jobs/$jobId': typeof DashboardJobsHeadBlurImagesJobsJobIdRouteRouteWithChildren
  '/dashboard/jobs/head-blur-images/schedule/$scheduledJobId': typeof DashboardJobsHeadBlurImagesScheduleScheduledJobIdRouteRouteWithChildren
  '/dashboard/jobs/head-blur-videos/jobs/$jobId': typeof DashboardJobsHeadBlurVideosJobsJobIdRouteRouteWithChildren
  '/dashboard/jobs/head-blur-videos/schedule/$scheduledJobId': typeof DashboardJobsHeadBlurVideosScheduleScheduledJobIdRouteRouteWithChildren
  '/dashboard/jobs/models/jobs/$jobId': typeof DashboardJobsModelsJobsJobIdRouteRouteWithChildren
  '/dashboard/jobs/models/schedule/$scheduledJobId': typeof DashboardJobsModelsScheduleScheduledJobIdRouteRouteWithChildren
  '/dashboard/jobs/recovery-estimates/jobs/$jobId': typeof DashboardJobsRecoveryEstimatesJobsJobIdRouteRouteWithChildren
  '/dashboard/jobs/recovery-estimates/schedule/$scheduledJobId': typeof DashboardJobsRecoveryEstimatesScheduleScheduledJobIdRouteRouteWithChildren
  '/dashboard/jobs/restarts/jobs/$jobId': typeof DashboardJobsRestartsJobsJobIdRouteRouteWithChildren
  '/dashboard/jobs/restarts/schedule/$scheduledJobId': typeof DashboardJobsRestartsScheduleScheduledJobIdRouteRouteWithChildren
  '/dashboard/jobs/sample-upload/jobs/$jobId': typeof DashboardJobsSampleUploadJobsJobIdRouteRouteWithChildren
  '/dashboard/jobs/sample-upload/schedule/$scheduledJobId': typeof DashboardJobsSampleUploadScheduleScheduledJobIdRouteRouteWithChildren
  '/dashboard/jobs/sync-samples/jobs/$jobId': typeof DashboardJobsSyncSamplesJobsJobIdRouteRouteWithChildren
  '/dashboard/jobs/sync-samples/schedule/$scheduledJobId': typeof DashboardJobsSyncSamplesScheduleScheduledJobIdRouteRouteWithChildren
  '/dashboard/jobs/training/jobs/$jobId': typeof DashboardJobsTrainingJobsJobIdRouteRouteWithChildren
  '/dashboard/jobs/training/schedule/$scheduledJobId': typeof DashboardJobsTrainingScheduleScheduledJobIdRouteRouteWithChildren
  '/dashboard/jobs/video-upload/jobs/$jobId': typeof DashboardJobsVideoUploadJobsJobIdRouteRouteWithChildren
  '/dashboard/jobs/video-upload/schedule/$scheduledJobId': typeof DashboardJobsVideoUploadScheduleScheduledJobIdRouteRouteWithChildren
  '/dashboard/jobs/worker-jobs/jobs/$jobId': typeof DashboardJobsWorkerJobsJobsJobIdRouteRouteWithChildren
  '/dashboard/jobs/worker-jobs/schedule/$scheduledJobId': typeof DashboardJobsWorkerJobsScheduleScheduledJobIdRouteRouteWithChildren
  '/dashboard/models/$modelId/deployment/clusters': typeof DashboardModelsModelIdDeploymentClustersRouteRoute
  '/dashboard/models/$modelId/deployment/devices': typeof DashboardModelsModelIdDeploymentDevicesRouteRoute
  '/dashboard/resources/clusters/$clusterId/devices': typeof DashboardResourcesClustersClusterIdDevicesRouteRoute
  '/dashboard/resources/clusters/$clusterId/overview': typeof DashboardResourcesClustersClusterIdOverviewRouteRoute
  '/dashboard/resources/devices/$deviceId/camera': typeof DashboardResourcesDevicesDeviceIdCameraRouteRoute
  '/dashboard/resources/devices/$deviceId/data': typeof DashboardResourcesDevicesDeviceIdDataRouteRouteWithChildren
  '/dashboard/resources/devices/$deviceId/diagnostics': typeof DashboardResourcesDevicesDeviceIdDiagnosticsRouteRouteWithChildren
  '/dashboard/resources/devices/$deviceId/logs': typeof DashboardResourcesDevicesDeviceIdLogsRouteRoute
  '/dashboard/resources/devices/$deviceId/overview': typeof DashboardResourcesDevicesDeviceIdOverviewRouteRoute
  '/dashboard/resources/devices/$deviceId/settings': typeof DashboardResourcesDevicesDeviceIdSettingsRouteRoute
  '/dashboard/resources/devices/$deviceId/version-history': typeof DashboardResourcesDevicesDeviceIdVersionHistoryRouteRouteWithChildren
  '/dashboard/resources/site-groups/$siteGroupId/labels': typeof DashboardResourcesSiteGroupsSiteGroupIdLabelsRouteRoute
  '/dashboard/resources/site-groups/$siteGroupId/overview': typeof DashboardResourcesSiteGroupsSiteGroupIdOverviewRouteRoute
  '/dashboard/resources/site-groups/$siteGroupId/sites': typeof DashboardResourcesSiteGroupsSiteGroupIdSitesRouteRoute
  '/dashboard/resources/sites/$siteId/devices': typeof DashboardResourcesSitesSiteIdDevicesRouteRoute
  '/dashboard/resources/sites/$siteId/overview': typeof DashboardResourcesSitesSiteIdOverviewRouteRoute
  '/dashboard/resources/sites/$siteId/version-history': typeof DashboardResourcesSitesSiteIdVersionHistoryRouteRouteWithChildren
  '/dashboard/settings/alert-management/alerts/$alertId': typeof DashboardSettingsAlertManagementAlertsAlertIdRouteRouteWithChildren
  '/dashboard/settings/queues/$queueName/failures': typeof DashboardSettingsQueuesQueueNameFailuresRouteRouteWithChildren
  '/dashboard/settings/queues/$queueName/pending': typeof DashboardSettingsQueuesQueueNamePendingRouteRouteWithChildren
  '/dashboard/settings/report-settings/$reportId/overview': typeof DashboardSettingsReportSettingsReportIdOverviewRouteRoute
  '/dashboard/settings/report-settings/$reportId/parameters': typeof DashboardSettingsReportSettingsReportIdParametersRouteRoute
  '/dashboard/settings/report-settings/$reportId/send-log': typeof DashboardSettingsReportSettingsReportIdSendLogRouteRoute
  '/dashboard/settings/report-settings/$reportId/subscriptions2': typeof DashboardSettingsReportSettingsReportIdSubscriptions2RouteRoute
  '/dashboard/settings/report-subscription/$reportId/$subscriptionId': typeof DashboardSettingsReportSubscriptionReportIdSubscriptionIdRouteRouteWithChildren
  '/dashboard/settings/tags-management/catalog/$tagId': typeof DashboardSettingsTagsManagementCatalogTagIdRouteRouteWithChildren
  '/dashboard/settings/tags-management/clusters/$tagId': typeof DashboardSettingsTagsManagementClustersTagIdRouteRouteWithChildren
  '/dashboard/settings/tags-management/devices/$tagId': typeof DashboardSettingsTagsManagementDevicesTagIdRouteRouteWithChildren
  '/dashboard/settings/tags-management/samples/$tagId': typeof DashboardSettingsTagsManagementSamplesTagIdRouteRouteWithChildren
  '/dashboard/settings/tags-management/sessions/$tagId': typeof DashboardSettingsTagsManagementSessionsTagIdRouteRouteWithChildren
  '/dashboard/settings/tags-management/sites/$tagId': typeof DashboardSettingsTagsManagementSitesTagIdRouteRouteWithChildren
  '/dashboard/settings/user-management/$userId/overview': typeof DashboardSettingsUserManagementUserIdOverviewRouteRoute
  '/dashboard/data/json-data/$jsonDataUUID/overview': typeof DashboardDataJsonDataJsonDataUUIDOverviewRoute
  '/dashboard/data/catalog/$item/': typeof DashboardDataCatalogItemIndexRoute
  '/dashboard/data/images/$imageUUID/': typeof DashboardDataImagesImageUUIDIndexRoute
  '/dashboard/data/json-data/$jsonDataUUID/': typeof DashboardDataJsonDataJsonDataUUIDIndexRoute
  '/dashboard/data/label-distribution/$label/': typeof DashboardDataLabelDistributionLabelIndexRoute
  '/dashboard/data/sessions/$sessionId/': typeof DashboardDataSessionsSessionIdIndexRoute
  '/dashboard/home/manager-report/$sessionId/': typeof DashboardHomeManagerReportSessionIdIndexRoute
  '/dashboard/models/$modelId/deployment/': typeof DashboardModelsModelIdDeploymentIndexRoute
  '/dashboard/resources/clusters/$clusterId/': typeof DashboardResourcesClustersClusterIdIndexRoute
  '/dashboard/resources/devices/$deviceId/': typeof DashboardResourcesDevicesDeviceIdIndexRoute
  '/dashboard/resources/site-groups/$siteGroupId/': typeof DashboardResourcesSiteGroupsSiteGroupIdIndexRoute
  '/dashboard/resources/sites/$siteId/': typeof DashboardResourcesSitesSiteIdIndexRoute
  '/dashboard/settings/queues/$queueName/': typeof DashboardSettingsQueuesQueueNameIndexRoute
  '/dashboard/settings/report-settings/$reportId/': typeof DashboardSettingsReportSettingsReportIdIndexRoute
  '/dashboard/settings/user-management/$userId/': typeof DashboardSettingsUserManagementUserIdIndexRoute
  '/admin-dashboard/jobs/service-health-checks/jobs/$jobId/overview': typeof AdminDashboardJobsServiceHealthChecksJobsJobIdOverviewRouteRoute
  '/admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId/inputs': typeof AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdInputsRouteRoute
  '/admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId/overview': typeof AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdOverviewRouteRoute
  '/admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId/schedule': typeof AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdScheduleRouteRoute
  '/dashboard/jobs/camera-calibration/jobs/$jobId/devices': typeof DashboardJobsCameraCalibrationJobsJobIdDevicesRouteRoute
  '/dashboard/jobs/camera-calibration/jobs/$jobId/overview': typeof DashboardJobsCameraCalibrationJobsJobIdOverviewRouteRoute
  '/dashboard/jobs/camera-calibration/schedule/$scheduledJobId/inputs': typeof DashboardJobsCameraCalibrationScheduleScheduledJobIdInputsRouteRoute
  '/dashboard/jobs/camera-calibration/schedule/$scheduledJobId/overview': typeof DashboardJobsCameraCalibrationScheduleScheduledJobIdOverviewRouteRoute
  '/dashboard/jobs/camera-calibration/schedule/$scheduledJobId/schedule': typeof DashboardJobsCameraCalibrationScheduleScheduledJobIdScheduleRouteRoute
  '/dashboard/jobs/capacity-tagging/jobs/$jobId/overview': typeof DashboardJobsCapacityTaggingJobsJobIdOverviewRouteRoute
  '/dashboard/jobs/capacity-tagging/schedule/$scheduledJobId/inputs': typeof DashboardJobsCapacityTaggingScheduleScheduledJobIdInputsRouteRoute
  '/dashboard/jobs/capacity-tagging/schedule/$scheduledJobId/overview': typeof DashboardJobsCapacityTaggingScheduleScheduledJobIdOverviewRouteRoute
  '/dashboard/jobs/capacity-tagging/schedule/$scheduledJobId/schedule': typeof DashboardJobsCapacityTaggingScheduleScheduledJobIdScheduleRouteRoute
  '/dashboard/jobs/catalog-upload/jobs/$jobId/devices': typeof DashboardJobsCatalogUploadJobsJobIdDevicesRouteRoute
  '/dashboard/jobs/catalog-upload/jobs/$jobId/labels': typeof DashboardJobsCatalogUploadJobsJobIdLabelsRouteRoute
  '/dashboard/jobs/catalog-upload/jobs/$jobId/overview': typeof DashboardJobsCatalogUploadJobsJobIdOverviewRouteRoute
  '/dashboard/jobs/catalog-upload/schedule/$scheduledJobId/labels': typeof DashboardJobsCatalogUploadScheduleScheduledJobIdLabelsRouteRoute
  '/dashboard/jobs/catalog-upload/schedule/$scheduledJobId/overview': typeof DashboardJobsCatalogUploadScheduleScheduledJobIdOverviewRouteRoute
  '/dashboard/jobs/catalog-upload/schedule/$scheduledJobId/schedule': typeof DashboardJobsCatalogUploadScheduleScheduledJobIdScheduleRouteRoute
  '/dashboard/jobs/config/jobs/$jobId/devices': typeof DashboardJobsConfigJobsJobIdDevicesRouteRoute
  '/dashboard/jobs/config/jobs/$jobId/overview': typeof DashboardJobsConfigJobsJobIdOverviewRouteRoute
  '/dashboard/jobs/config/schedule/$scheduledJobId/overview': typeof DashboardJobsConfigScheduleScheduledJobIdOverviewRouteRoute
  '/dashboard/jobs/config/schedule/$scheduledJobId/schedule': typeof DashboardJobsConfigScheduleScheduledJobIdScheduleRouteRoute
  '/dashboard/jobs/delete-samples/jobs/$jobId/devices': typeof DashboardJobsDeleteSamplesJobsJobIdDevicesRouteRoute
  '/dashboard/jobs/delete-samples/jobs/$jobId/overview': typeof DashboardJobsDeleteSamplesJobsJobIdOverviewRouteRoute
  '/dashboard/jobs/delete-samples/schedule/$scheduledJobId/inputs': typeof DashboardJobsDeleteSamplesScheduleScheduledJobIdInputsRouteRoute
  '/dashboard/jobs/delete-samples/schedule/$scheduledJobId/overview': typeof DashboardJobsDeleteSamplesScheduleScheduledJobIdOverviewRouteRoute
  '/dashboard/jobs/delete-samples/schedule/$scheduledJobId/schedule': typeof DashboardJobsDeleteSamplesScheduleScheduledJobIdScheduleRouteRoute
  '/dashboard/jobs/delete-videos/jobs/$jobId/devices': typeof DashboardJobsDeleteVideosJobsJobIdDevicesRouteRoute
  '/dashboard/jobs/delete-videos/jobs/$jobId/overview': typeof DashboardJobsDeleteVideosJobsJobIdOverviewRouteRoute
  '/dashboard/jobs/delete-videos/schedule/$scheduledJobId/inputs': typeof DashboardJobsDeleteVideosScheduleScheduledJobIdInputsRouteRoute
  '/dashboard/jobs/delete-videos/schedule/$scheduledJobId/overview': typeof DashboardJobsDeleteVideosScheduleScheduledJobIdOverviewRouteRoute
  '/dashboard/jobs/delete-videos/schedule/$scheduledJobId/schedule': typeof DashboardJobsDeleteVideosScheduleScheduledJobIdScheduleRouteRoute
  '/dashboard/jobs/deployments/jobs/$jobId/devices': typeof DashboardJobsDeploymentsJobsJobIdDevicesRouteRoute
  '/dashboard/jobs/deployments/jobs/$jobId/overview': typeof DashboardJobsDeploymentsJobsJobIdOverviewRouteRoute
  '/dashboard/jobs/deployments/schedule/$scheduledJobId/overview': typeof DashboardJobsDeploymentsScheduleScheduledJobIdOverviewRouteRoute
  '/dashboard/jobs/deployments/schedule/$scheduledJobId/schedule': typeof DashboardJobsDeploymentsScheduleScheduledJobIdScheduleRouteRoute
  '/dashboard/jobs/head-blur-images/jobs/$jobId/devices': typeof DashboardJobsHeadBlurImagesJobsJobIdDevicesRouteRoute
  '/dashboard/jobs/head-blur-images/jobs/$jobId/overview': typeof DashboardJobsHeadBlurImagesJobsJobIdOverviewRouteRoute
  '/dashboard/jobs/head-blur-images/schedule/$scheduledJobId/inputs': typeof DashboardJobsHeadBlurImagesScheduleScheduledJobIdInputsRouteRoute
  '/dashboard/jobs/head-blur-images/schedule/$scheduledJobId/overview': typeof DashboardJobsHeadBlurImagesScheduleScheduledJobIdOverviewRouteRoute
  '/dashboard/jobs/head-blur-images/schedule/$scheduledJobId/schedule': typeof DashboardJobsHeadBlurImagesScheduleScheduledJobIdScheduleRouteRoute
  '/dashboard/jobs/head-blur-videos/jobs/$jobId/devices': typeof DashboardJobsHeadBlurVideosJobsJobIdDevicesRouteRoute
  '/dashboard/jobs/head-blur-videos/jobs/$jobId/overview': typeof DashboardJobsHeadBlurVideosJobsJobIdOverviewRouteRoute
  '/dashboard/jobs/head-blur-videos/schedule/$scheduledJobId/inputs': typeof DashboardJobsHeadBlurVideosScheduleScheduledJobIdInputsRouteRoute
  '/dashboard/jobs/head-blur-videos/schedule/$scheduledJobId/overview': typeof DashboardJobsHeadBlurVideosScheduleScheduledJobIdOverviewRouteRoute
  '/dashboard/jobs/head-blur-videos/schedule/$scheduledJobId/schedule': typeof DashboardJobsHeadBlurVideosScheduleScheduledJobIdScheduleRouteRoute
  '/dashboard/jobs/models/jobs/$jobId/devices': typeof DashboardJobsModelsJobsJobIdDevicesRouteRoute
  '/dashboard/jobs/models/jobs/$jobId/overview': typeof DashboardJobsModelsJobsJobIdOverviewRouteRoute
  '/dashboard/jobs/models/schedule/$scheduledJobId/overview': typeof DashboardJobsModelsScheduleScheduledJobIdOverviewRouteRoute
  '/dashboard/jobs/models/schedule/$scheduledJobId/schedule': typeof DashboardJobsModelsScheduleScheduledJobIdScheduleRouteRoute
  '/dashboard/jobs/recovery-estimates/jobs/$jobId/overview': typeof DashboardJobsRecoveryEstimatesJobsJobIdOverviewRouteRoute
  '/dashboard/jobs/recovery-estimates/schedule/$scheduledJobId/inputs': typeof DashboardJobsRecoveryEstimatesScheduleScheduledJobIdInputsRouteRoute
  '/dashboard/jobs/recovery-estimates/schedule/$scheduledJobId/overview': typeof DashboardJobsRecoveryEstimatesScheduleScheduledJobIdOverviewRouteRoute
  '/dashboard/jobs/recovery-estimates/schedule/$scheduledJobId/schedule': typeof DashboardJobsRecoveryEstimatesScheduleScheduledJobIdScheduleRouteRoute
  '/dashboard/jobs/restarts/jobs/$jobId/devices': typeof DashboardJobsRestartsJobsJobIdDevicesRouteRoute
  '/dashboard/jobs/restarts/jobs/$jobId/overview': typeof DashboardJobsRestartsJobsJobIdOverviewRouteRoute
  '/dashboard/jobs/restarts/schedule/$scheduledJobId/overview': typeof DashboardJobsRestartsScheduleScheduledJobIdOverviewRouteRoute
  '/dashboard/jobs/restarts/schedule/$scheduledJobId/schedule': typeof DashboardJobsRestartsScheduleScheduledJobIdScheduleRouteRoute
  '/dashboard/jobs/sample-upload/jobs/$jobId/devices': typeof DashboardJobsSampleUploadJobsJobIdDevicesRouteRoute
  '/dashboard/jobs/sample-upload/jobs/$jobId/overview': typeof DashboardJobsSampleUploadJobsJobIdOverviewRouteRoute
  '/dashboard/jobs/sample-upload/schedule/$scheduledJobId/inputs': typeof DashboardJobsSampleUploadScheduleScheduledJobIdInputsRouteRoute
  '/dashboard/jobs/sample-upload/schedule/$scheduledJobId/overview': typeof DashboardJobsSampleUploadScheduleScheduledJobIdOverviewRouteRoute
  '/dashboard/jobs/sample-upload/schedule/$scheduledJobId/schedule': typeof DashboardJobsSampleUploadScheduleScheduledJobIdScheduleRouteRoute
  '/dashboard/jobs/sync-samples/jobs/$jobId/devices': typeof DashboardJobsSyncSamplesJobsJobIdDevicesRouteRoute
  '/dashboard/jobs/sync-samples/jobs/$jobId/overview': typeof DashboardJobsSyncSamplesJobsJobIdOverviewRouteRoute
  '/dashboard/jobs/sync-samples/schedule/$scheduledJobId/inputs': typeof DashboardJobsSyncSamplesScheduleScheduledJobIdInputsRouteRoute
  '/dashboard/jobs/sync-samples/schedule/$scheduledJobId/overview': typeof DashboardJobsSyncSamplesScheduleScheduledJobIdOverviewRouteRoute
  '/dashboard/jobs/sync-samples/schedule/$scheduledJobId/schedule': typeof DashboardJobsSyncSamplesScheduleScheduledJobIdScheduleRouteRoute
  '/dashboard/jobs/training/jobs/$jobId/devices': typeof DashboardJobsTrainingJobsJobIdDevicesRouteRoute
  '/dashboard/jobs/training/jobs/$jobId/labels': typeof DashboardJobsTrainingJobsJobIdLabelsRouteRoute
  '/dashboard/jobs/training/jobs/$jobId/metrics': typeof DashboardJobsTrainingJobsJobIdMetricsRouteRoute
  '/dashboard/jobs/training/jobs/$jobId/overview': typeof DashboardJobsTrainingJobsJobIdOverviewRouteRoute
  '/dashboard/jobs/training/schedule/$scheduledJobId/inputs': typeof DashboardJobsTrainingScheduleScheduledJobIdInputsRouteRoute
  '/dashboard/jobs/training/schedule/$scheduledJobId/overview': typeof DashboardJobsTrainingScheduleScheduledJobIdOverviewRouteRoute
  '/dashboard/jobs/training/schedule/$scheduledJobId/schedule': typeof DashboardJobsTrainingScheduleScheduledJobIdScheduleRouteRoute
  '/dashboard/jobs/video-upload/jobs/$jobId/devices': typeof DashboardJobsVideoUploadJobsJobIdDevicesRouteRoute
  '/dashboard/jobs/video-upload/jobs/$jobId/overview': typeof DashboardJobsVideoUploadJobsJobIdOverviewRouteRoute
  '/dashboard/jobs/video-upload/schedule/$scheduledJobId/inputs': typeof DashboardJobsVideoUploadScheduleScheduledJobIdInputsRouteRoute
  '/dashboard/jobs/video-upload/schedule/$scheduledJobId/overview': typeof DashboardJobsVideoUploadScheduleScheduledJobIdOverviewRouteRoute
  '/dashboard/jobs/video-upload/schedule/$scheduledJobId/schedule': typeof DashboardJobsVideoUploadScheduleScheduledJobIdScheduleRouteRoute
  '/dashboard/jobs/worker-jobs/jobs/$jobId/devices': typeof DashboardJobsWorkerJobsJobsJobIdDevicesRouteRoute
  '/dashboard/jobs/worker-jobs/jobs/$jobId/overview': typeof DashboardJobsWorkerJobsJobsJobIdOverviewRouteRoute
  '/dashboard/jobs/worker-jobs/schedule/$scheduledJobId/inputs': typeof DashboardJobsWorkerJobsScheduleScheduledJobIdInputsRouteRoute
  '/dashboard/jobs/worker-jobs/schedule/$scheduledJobId/overview': typeof DashboardJobsWorkerJobsScheduleScheduledJobIdOverviewRouteRoute
  '/dashboard/jobs/worker-jobs/schedule/$scheduledJobId/schedule': typeof DashboardJobsWorkerJobsScheduleScheduledJobIdScheduleRouteRoute
  '/dashboard/resources/devices/$deviceId/data/samples': typeof DashboardResourcesDevicesDeviceIdDataSamplesRouteRouteWithChildren
  '/dashboard/resources/devices/$deviceId/data/sessions': typeof DashboardResourcesDevicesDeviceIdDataSessionsRouteRouteWithChildren
  '/dashboard/resources/devices/$deviceId/data/text-json': typeof DashboardResourcesDevicesDeviceIdDataTextJsonRouteRoute
  '/dashboard/resources/devices/$deviceId/diagnostics/classifier': typeof DashboardResourcesDevicesDeviceIdDiagnosticsClassifierRouteRoute
  '/dashboard/resources/devices/$deviceId/diagnostics/custom': typeof DashboardResourcesDevicesDeviceIdDiagnosticsCustomRouteRoute
  '/dashboard/resources/devices/$deviceId/diagnostics/object-detection': typeof DashboardResourcesDevicesDeviceIdDiagnosticsObjectDetectionRouteRoute
  '/dashboard/resources/devices/$deviceId/version-history/agent': typeof DashboardResourcesDevicesDeviceIdVersionHistoryAgentRouteRoute
  '/dashboard/resources/devices/$deviceId/version-history/detector': typeof DashboardResourcesDevicesDeviceIdVersionHistoryDetectorRouteRoute
  '/dashboard/resources/devices/$deviceId/version-history/models': typeof DashboardResourcesDevicesDeviceIdVersionHistoryModelsRouteRoute
  '/dashboard/resources/devices/$deviceId/version-history/on-screen-app': typeof DashboardResourcesDevicesDeviceIdVersionHistoryOnScreenAppRouteRoute
  '/dashboard/resources/devices/$deviceId/version-history/trainer': typeof DashboardResourcesDevicesDeviceIdVersionHistoryTrainerRouteRoute
  '/dashboard/resources/devices/$deviceId/version-history/zebra-adapter': typeof DashboardResourcesDevicesDeviceIdVersionHistoryZebraAdapterRouteRoute
  '/dashboard/resources/sites/$siteId/version-history/agent': typeof DashboardResourcesSitesSiteIdVersionHistoryAgentRouteRoute
  '/dashboard/resources/sites/$siteId/version-history/detector': typeof DashboardResourcesSitesSiteIdVersionHistoryDetectorRouteRoute
  '/dashboard/resources/sites/$siteId/version-history/on-screen-app': typeof DashboardResourcesSitesSiteIdVersionHistoryOnScreenAppRouteRoute
  '/dashboard/resources/sites/$siteId/version-history/trainer': typeof DashboardResourcesSitesSiteIdVersionHistoryTrainerRouteRoute
  '/dashboard/resources/sites/$siteId/version-history/zebra-adapter': typeof DashboardResourcesSitesSiteIdVersionHistoryZebraAdapterRouteRoute
  '/dashboard/settings/alert-management/alerts/$alertId/overview': typeof DashboardSettingsAlertManagementAlertsAlertIdOverviewRouteRoute
  '/dashboard/settings/queues/$queueName/failures/$index': typeof DashboardSettingsQueuesQueueNameFailuresIndexRouteRoute
  '/dashboard/settings/queues/$queueName/pending/$index': typeof DashboardSettingsQueuesQueueNamePendingIndexRouteRoute
  '/dashboard/settings/report-subscription/$reportId/$subscriptionId/edit': typeof DashboardSettingsReportSubscriptionReportIdSubscriptionIdEditRouteRoute
  '/dashboard/settings/report-subscription/$reportId/$subscriptionId/overview': typeof DashboardSettingsReportSubscriptionReportIdSubscriptionIdOverviewRouteRoute
  '/dashboard/settings/report-subscription/$reportId/$subscriptionId/review-and-approve': typeof DashboardSettingsReportSubscriptionReportIdSubscriptionIdReviewAndApproveRouteRoute
  '/dashboard/settings/report-subscription/$reportId/$subscriptionId/send-history': typeof DashboardSettingsReportSubscriptionReportIdSubscriptionIdSendHistoryRouteRoute
  '/dashboard/settings/tags-management/catalog/$tagId/details': typeof DashboardSettingsTagsManagementCatalogTagIdDetailsRouteRoute
  '/dashboard/settings/tags-management/clusters/$tagId/details': typeof DashboardSettingsTagsManagementClustersTagIdDetailsRouteRoute
  '/dashboard/settings/tags-management/devices/$tagId/details': typeof DashboardSettingsTagsManagementDevicesTagIdDetailsRouteRoute
  '/dashboard/settings/tags-management/samples/$tagId/details': typeof DashboardSettingsTagsManagementSamplesTagIdDetailsRouteRoute
  '/dashboard/settings/tags-management/sessions/$tagId/details': typeof DashboardSettingsTagsManagementSessionsTagIdDetailsRouteRoute
  '/dashboard/settings/tags-management/sites/$tagId/details': typeof DashboardSettingsTagsManagementSitesTagIdDetailsRouteRoute
  '/admin-dashboard/jobs/service-health-checks/jobs/$jobId/': typeof AdminDashboardJobsServiceHealthChecksJobsJobIdIndexRoute
  '/admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId/': typeof AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdIndexRoute
  '/dashboard/jobs/camera-calibration/jobs/$jobId/': typeof DashboardJobsCameraCalibrationJobsJobIdIndexRoute
  '/dashboard/jobs/camera-calibration/schedule/$scheduledJobId/': typeof DashboardJobsCameraCalibrationScheduleScheduledJobIdIndexRoute
  '/dashboard/jobs/capacity-tagging/jobs/$jobId/': typeof DashboardJobsCapacityTaggingJobsJobIdIndexRoute
  '/dashboard/jobs/capacity-tagging/schedule/$scheduledJobId/': typeof DashboardJobsCapacityTaggingScheduleScheduledJobIdIndexRoute
  '/dashboard/jobs/catalog-upload/jobs/$jobId/': typeof DashboardJobsCatalogUploadJobsJobIdIndexRoute
  '/dashboard/jobs/catalog-upload/schedule/$scheduledJobId/': typeof DashboardJobsCatalogUploadScheduleScheduledJobIdIndexRoute
  '/dashboard/jobs/config/jobs/$jobId/': typeof DashboardJobsConfigJobsJobIdIndexRoute
  '/dashboard/jobs/config/schedule/$scheduledJobId/': typeof DashboardJobsConfigScheduleScheduledJobIdIndexRoute
  '/dashboard/jobs/delete-samples/jobs/$jobId/': typeof DashboardJobsDeleteSamplesJobsJobIdIndexRoute
  '/dashboard/jobs/delete-samples/schedule/$scheduledJobId/': typeof DashboardJobsDeleteSamplesScheduleScheduledJobIdIndexRoute
  '/dashboard/jobs/delete-videos/jobs/$jobId/': typeof DashboardJobsDeleteVideosJobsJobIdIndexRoute
  '/dashboard/jobs/delete-videos/schedule/$scheduledJobId/': typeof DashboardJobsDeleteVideosScheduleScheduledJobIdIndexRoute
  '/dashboard/jobs/deployments/jobs/$jobId/': typeof DashboardJobsDeploymentsJobsJobIdIndexRoute
  '/dashboard/jobs/deployments/schedule/$scheduledJobId/': typeof DashboardJobsDeploymentsScheduleScheduledJobIdIndexRoute
  '/dashboard/jobs/head-blur-images/jobs/$jobId/': typeof DashboardJobsHeadBlurImagesJobsJobIdIndexRoute
  '/dashboard/jobs/head-blur-images/schedule/$scheduledJobId/': typeof DashboardJobsHeadBlurImagesScheduleScheduledJobIdIndexRoute
  '/dashboard/jobs/head-blur-videos/jobs/$jobId/': typeof DashboardJobsHeadBlurVideosJobsJobIdIndexRoute
  '/dashboard/jobs/head-blur-videos/schedule/$scheduledJobId/': typeof DashboardJobsHeadBlurVideosScheduleScheduledJobIdIndexRoute
  '/dashboard/jobs/models/jobs/$jobId/': typeof DashboardJobsModelsJobsJobIdIndexRoute
  '/dashboard/jobs/models/schedule/$scheduledJobId/': typeof DashboardJobsModelsScheduleScheduledJobIdIndexRoute
  '/dashboard/jobs/recovery-estimates/jobs/$jobId/': typeof DashboardJobsRecoveryEstimatesJobsJobIdIndexRoute
  '/dashboard/jobs/recovery-estimates/schedule/$scheduledJobId/': typeof DashboardJobsRecoveryEstimatesScheduleScheduledJobIdIndexRoute
  '/dashboard/jobs/restarts/jobs/$jobId/': typeof DashboardJobsRestartsJobsJobIdIndexRoute
  '/dashboard/jobs/restarts/schedule/$scheduledJobId/': typeof DashboardJobsRestartsScheduleScheduledJobIdIndexRoute
  '/dashboard/jobs/sample-upload/jobs/$jobId/': typeof DashboardJobsSampleUploadJobsJobIdIndexRoute
  '/dashboard/jobs/sample-upload/schedule/$scheduledJobId/': typeof DashboardJobsSampleUploadScheduleScheduledJobIdIndexRoute
  '/dashboard/jobs/sync-samples/jobs/$jobId/': typeof DashboardJobsSyncSamplesJobsJobIdIndexRoute
  '/dashboard/jobs/sync-samples/schedule/$scheduledJobId/': typeof DashboardJobsSyncSamplesScheduleScheduledJobIdIndexRoute
  '/dashboard/jobs/training/jobs/$jobId/': typeof DashboardJobsTrainingJobsJobIdIndexRoute
  '/dashboard/jobs/training/schedule/$scheduledJobId/': typeof DashboardJobsTrainingScheduleScheduledJobIdIndexRoute
  '/dashboard/jobs/video-upload/jobs/$jobId/': typeof DashboardJobsVideoUploadJobsJobIdIndexRoute
  '/dashboard/jobs/video-upload/schedule/$scheduledJobId/': typeof DashboardJobsVideoUploadScheduleScheduledJobIdIndexRoute
  '/dashboard/jobs/worker-jobs/jobs/$jobId/': typeof DashboardJobsWorkerJobsJobsJobIdIndexRoute
  '/dashboard/jobs/worker-jobs/schedule/$scheduledJobId/': typeof DashboardJobsWorkerJobsScheduleScheduledJobIdIndexRoute
  '/dashboard/resources/devices/$deviceId/data/': typeof DashboardResourcesDevicesDeviceIdDataIndexRoute
  '/dashboard/resources/devices/$deviceId/version-history/': typeof DashboardResourcesDevicesDeviceIdVersionHistoryIndexRoute
  '/dashboard/resources/sites/$siteId/version-history/': typeof DashboardResourcesSitesSiteIdVersionHistoryIndexRoute
  '/dashboard/settings/alert-management/alerts/$alertId/': typeof DashboardSettingsAlertManagementAlertsAlertIdIndexRoute
  '/dashboard/settings/alert-management/metric-alerts/$metricAlertId': typeof DashboardSettingsAlertManagementMetricAlertsMetricAlertIdIndexRoute
  '/dashboard/settings/report-subscription/$reportId/$subscriptionId/': typeof DashboardSettingsReportSubscriptionReportIdSubscriptionIdIndexRoute
  '/dashboard/settings/tags-management/catalog/$tagId/': typeof DashboardSettingsTagsManagementCatalogTagIdIndexRoute
  '/dashboard/settings/tags-management/clusters/$tagId/': typeof DashboardSettingsTagsManagementClustersTagIdIndexRoute
  '/dashboard/settings/tags-management/devices/$tagId/': typeof DashboardSettingsTagsManagementDevicesTagIdIndexRoute
  '/dashboard/settings/tags-management/samples/$tagId/': typeof DashboardSettingsTagsManagementSamplesTagIdIndexRoute
  '/dashboard/settings/tags-management/sessions/$tagId/': typeof DashboardSettingsTagsManagementSessionsTagIdIndexRoute
  '/dashboard/settings/tags-management/sites/$tagId/': typeof DashboardSettingsTagsManagementSitesTagIdIndexRoute
  '/dashboard/resources/devices/$deviceId/data/samples/$sampleId': typeof DashboardResourcesDevicesDeviceIdDataSamplesSampleIdRouteRouteWithChildren
  '/dashboard/resources/devices/$deviceId/data/sessions/$sessionId': typeof DashboardResourcesDevicesDeviceIdDataSessionsSessionIdRouteRouteWithChildren
  '/dashboard/resources/devices/$deviceId/data/samples/$sampleId/': typeof DashboardResourcesDevicesDeviceIdDataSamplesSampleIdIndexRoute
  '/dashboard/resources/devices/$deviceId/data/sessions/$sessionId/': typeof DashboardResourcesDevicesDeviceIdDataSessionsSessionIdIndexRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/unresponsive': typeof UnresponsiveRouteRoute
  '/login': typeof LoginRouteLazyRoute
  '/admin-dashboard/accounts-management': typeof AdminDashboardAccountsManagementRouteRouteWithChildren
  '/admin-dashboard/domain-auth-settings': typeof AdminDashboardDomainAuthSettingsRouteRoute
  '/admin-dashboard/jobs': typeof AdminDashboardJobsRouteRouteWithChildren
  '/admin-dashboard/notifications': typeof AdminDashboardNotificationsRouteRouteWithChildren
  '/dashboard/alerts': typeof DashboardAlertsRouteRoute
  '/dashboard/models': typeof DashboardModelsRouteRouteWithChildren
  '/dashboard/unauthorized': typeof DashboardUnauthorizedRouteRoute
  '/dashboard/support': typeof DashboardSupportRoute
  '/next/$': typeof NextSplatRoute
  '/admin-dashboard': typeof AdminDashboardIndexRoute
  '/dashboard': typeof DashboardIndexRoute
  '/admin-dashboard/notifications/$notificationId': typeof AdminDashboardNotificationsNotificationIdRouteRouteWithChildren
  '/dashboard/data/annotations': typeof DashboardDataAnnotationsRouteRoute
  '/dashboard/data/catalog': typeof DashboardDataCatalogRouteRouteWithChildren
  '/dashboard/data/datasets': typeof DashboardDataDatasetsRouteRouteWithChildren
  '/dashboard/data/images': typeof DashboardDataImagesRouteRouteWithChildren
  '/dashboard/data/json-data': typeof DashboardDataJsonDataRouteRouteWithChildren
  '/dashboard/data/label-distribution': typeof DashboardDataLabelDistributionRouteRouteWithChildren
  '/dashboard/data/pending': typeof DashboardDataPendingRouteRoute
  '/dashboard/data/sessions': typeof DashboardDataSessionsRouteRouteWithChildren
  '/dashboard/reports/$reportId': typeof DashboardReportsReportIdRouteRoute
  '/dashboard/reports/analytics-hub': typeof DashboardReportsAnalyticsHubRouteRoute
  '/dashboard/reports/companion': typeof DashboardReportsCompanionRouteRoute
  '/dashboard/resources/clusters': typeof DashboardResourcesClustersRouteRouteWithChildren
  '/dashboard/resources/devices': typeof DashboardResourcesDevicesRouteRouteWithChildren
  '/dashboard/resources/site-groups': typeof DashboardResourcesSiteGroupsRouteRouteWithChildren
  '/dashboard/resources/sites': typeof DashboardResourcesSitesRouteRouteWithChildren
  '/dashboard/settings/job-defaults': typeof DashboardSettingsJobDefaultsRouteRoute
  '/dashboard/settings/overview': typeof DashboardSettingsOverviewRouteRoute
  '/dashboard/settings/permissions-settings': typeof DashboardSettingsPermissionsSettingsRouteRoute
  '/dashboard/settings/permissions-settings-dev': typeof DashboardSettingsPermissionsSettingsDevRouteRoute
  '/dashboard/settings/regions': typeof DashboardSettingsRegionsRouteRoute
  '/dashboard/settings/report-settings': typeof DashboardSettingsReportSettingsRouteRouteWithChildren
  '/dashboard/settings/user-management': typeof DashboardSettingsUserManagementRouteRouteWithChildren
  '/dashboard/[/rest]': typeof DashboardRestRoute
  '/dashboard/data': typeof DashboardDataIndexRoute
  '/dashboard/home': typeof DashboardHomeIndexRoute
  '/dashboard/jobs': typeof DashboardJobsIndexRoute
  '/dashboard/reports': typeof DashboardReportsIndexRoute
  '/dashboard/resources': typeof DashboardResourcesIndexRoute
  '/dashboard/settings': typeof DashboardSettingsIndexRoute
  '/admin-dashboard/accounts-management/$accountId/operational-hours': typeof AdminDashboardAccountsManagementAccountIdOperationalHoursRouteRoute
  '/admin-dashboard/accounts-management/$accountId/overview': typeof AdminDashboardAccountsManagementAccountIdOverviewRouteRoute
  '/admin-dashboard/accounts-management/$accountId/regions': typeof AdminDashboardAccountsManagementAccountIdRegionsRouteRoute
  '/admin-dashboard/jobs/service-health-checks/jobs': typeof AdminDashboardJobsServiceHealthChecksJobsRouteRouteWithChildren
  '/admin-dashboard/jobs/service-health-checks/schedule': typeof AdminDashboardJobsServiceHealthChecksScheduleRouteRouteWithChildren
  '/admin-dashboard/notifications/$notificationId/overview': typeof AdminDashboardNotificationsNotificationIdOverviewRouteRoute
  '/dashboard/data/datasets/$datasetId': typeof DashboardDataDatasetsDatasetIdRouteRouteWithChildren
  '/dashboard/jobs/camera-calibration/alerts': typeof DashboardJobsCameraCalibrationAlertsRouteRoute
  '/dashboard/jobs/camera-calibration/jobs': typeof DashboardJobsCameraCalibrationJobsRouteRouteWithChildren
  '/dashboard/jobs/camera-calibration/schedule': typeof DashboardJobsCameraCalibrationScheduleRouteRouteWithChildren
  '/dashboard/jobs/capacity-tagging/jobs': typeof DashboardJobsCapacityTaggingJobsRouteRouteWithChildren
  '/dashboard/jobs/capacity-tagging/schedule': typeof DashboardJobsCapacityTaggingScheduleRouteRouteWithChildren
  '/dashboard/jobs/catalog-upload/jobs': typeof DashboardJobsCatalogUploadJobsRouteRouteWithChildren
  '/dashboard/jobs/catalog-upload/schedule': typeof DashboardJobsCatalogUploadScheduleRouteRouteWithChildren
  '/dashboard/jobs/config/jobs': typeof DashboardJobsConfigJobsRouteRouteWithChildren
  '/dashboard/jobs/config/schedule': typeof DashboardJobsConfigScheduleRouteRouteWithChildren
  '/dashboard/jobs/delete-samples/alerts': typeof DashboardJobsDeleteSamplesAlertsRouteRoute
  '/dashboard/jobs/delete-samples/jobs': typeof DashboardJobsDeleteSamplesJobsRouteRouteWithChildren
  '/dashboard/jobs/delete-samples/schedule': typeof DashboardJobsDeleteSamplesScheduleRouteRouteWithChildren
  '/dashboard/jobs/delete-videos/alerts': typeof DashboardJobsDeleteVideosAlertsRouteRoute
  '/dashboard/jobs/delete-videos/jobs': typeof DashboardJobsDeleteVideosJobsRouteRouteWithChildren
  '/dashboard/jobs/delete-videos/schedule': typeof DashboardJobsDeleteVideosScheduleRouteRouteWithChildren
  '/dashboard/jobs/deployments/jobs': typeof DashboardJobsDeploymentsJobsRouteRouteWithChildren
  '/dashboard/jobs/deployments/schedule': typeof DashboardJobsDeploymentsScheduleRouteRouteWithChildren
  '/dashboard/jobs/head-blur-images/jobs': typeof DashboardJobsHeadBlurImagesJobsRouteRouteWithChildren
  '/dashboard/jobs/head-blur-images/schedule': typeof DashboardJobsHeadBlurImagesScheduleRouteRouteWithChildren
  '/dashboard/jobs/head-blur-videos/jobs': typeof DashboardJobsHeadBlurVideosJobsRouteRouteWithChildren
  '/dashboard/jobs/head-blur-videos/schedule': typeof DashboardJobsHeadBlurVideosScheduleRouteRouteWithChildren
  '/dashboard/jobs/models/jobs': typeof DashboardJobsModelsJobsRouteRouteWithChildren
  '/dashboard/jobs/models/schedule': typeof DashboardJobsModelsScheduleRouteRouteWithChildren
  '/dashboard/jobs/recovery-estimates/jobs': typeof DashboardJobsRecoveryEstimatesJobsRouteRouteWithChildren
  '/dashboard/jobs/recovery-estimates/schedule': typeof DashboardJobsRecoveryEstimatesScheduleRouteRouteWithChildren
  '/dashboard/jobs/restarts/jobs': typeof DashboardJobsRestartsJobsRouteRouteWithChildren
  '/dashboard/jobs/restarts/schedule': typeof DashboardJobsRestartsScheduleRouteRouteWithChildren
  '/dashboard/jobs/sample-upload/alerts': typeof DashboardJobsSampleUploadAlertsRouteRoute
  '/dashboard/jobs/sample-upload/jobs': typeof DashboardJobsSampleUploadJobsRouteRouteWithChildren
  '/dashboard/jobs/sample-upload/schedule': typeof DashboardJobsSampleUploadScheduleRouteRouteWithChildren
  '/dashboard/jobs/sync-samples/alerts': typeof DashboardJobsSyncSamplesAlertsRouteRoute
  '/dashboard/jobs/sync-samples/jobs': typeof DashboardJobsSyncSamplesJobsRouteRouteWithChildren
  '/dashboard/jobs/sync-samples/schedule': typeof DashboardJobsSyncSamplesScheduleRouteRouteWithChildren
  '/dashboard/jobs/training/jobs': typeof DashboardJobsTrainingJobsRouteRouteWithChildren
  '/dashboard/jobs/training/schedule': typeof DashboardJobsTrainingScheduleRouteRouteWithChildren
  '/dashboard/jobs/video-upload/alerts': typeof DashboardJobsVideoUploadAlertsRouteRoute
  '/dashboard/jobs/video-upload/jobs': typeof DashboardJobsVideoUploadJobsRouteRouteWithChildren
  '/dashboard/jobs/video-upload/schedule': typeof DashboardJobsVideoUploadScheduleRouteRouteWithChildren
  '/dashboard/jobs/worker-jobs/jobs': typeof DashboardJobsWorkerJobsJobsRouteRouteWithChildren
  '/dashboard/jobs/worker-jobs/schedule': typeof DashboardJobsWorkerJobsScheduleRouteRouteWithChildren
  '/dashboard/models/$modelId/labels': typeof DashboardModelsModelIdLabelsRouteRoute
  '/dashboard/models/$modelId/matrix': typeof DashboardModelsModelIdMatrixRouteRoute
  '/dashboard/models/$modelId/overview': typeof DashboardModelsModelIdOverviewRouteRoute
  '/dashboard/settings/alert-management/alert-channels': typeof DashboardSettingsAlertManagementAlertChannelsRouteRoute
  '/dashboard/settings/alert-management/alerts': typeof DashboardSettingsAlertManagementAlertsRouteRouteWithChildren
  '/dashboard/settings/alert-management/metric-alerts': typeof DashboardSettingsAlertManagementMetricAlertsRouteRouteWithChildren
  '/dashboard/settings/tags-management/catalog': typeof DashboardSettingsTagsManagementCatalogRouteRouteWithChildren
  '/dashboard/settings/tags-management/clusters': typeof DashboardSettingsTagsManagementClustersRouteRouteWithChildren
  '/dashboard/settings/tags-management/devices': typeof DashboardSettingsTagsManagementDevicesRouteRouteWithChildren
  '/dashboard/settings/tags-management/samples': typeof DashboardSettingsTagsManagementSamplesRouteRouteWithChildren
  '/dashboard/settings/tags-management/sessions': typeof DashboardSettingsTagsManagementSessionsRouteRouteWithChildren
  '/dashboard/settings/tags-management/sites': typeof DashboardSettingsTagsManagementSitesRouteRouteWithChildren
  '/dashboard/data/[/rest]': typeof DashboardDataRestRoute
  '/dashboard/resources/[/rest]': typeof DashboardResourcesRestRoute
  '/dashboard/settings/user-management/thumbnail': typeof DashboardSettingsUserManagementThumbnailRoute
  '/admin-dashboard/accounts-management/$accountId': typeof AdminDashboardAccountsManagementAccountIdIndexRoute
  '/admin-dashboard/jobs/service-health-checks': typeof AdminDashboardJobsServiceHealthChecksIndexRoute
  '/dashboard/home/manager-report': typeof DashboardHomeManagerReportIndexRoute
  '/dashboard/jobs/camera-calibration': typeof DashboardJobsCameraCalibrationIndexRoute
  '/dashboard/jobs/capacity-tagging': typeof DashboardJobsCapacityTaggingIndexRoute
  '/dashboard/jobs/catalog-upload': typeof DashboardJobsCatalogUploadIndexRoute
  '/dashboard/jobs/config': typeof DashboardJobsConfigIndexRoute
  '/dashboard/jobs/delete-samples': typeof DashboardJobsDeleteSamplesIndexRoute
  '/dashboard/jobs/delete-videos': typeof DashboardJobsDeleteVideosIndexRoute
  '/dashboard/jobs/deployments': typeof DashboardJobsDeploymentsIndexRoute
  '/dashboard/jobs/head-blur-images': typeof DashboardJobsHeadBlurImagesIndexRoute
  '/dashboard/jobs/head-blur-videos': typeof DashboardJobsHeadBlurVideosIndexRoute
  '/dashboard/jobs/models': typeof DashboardJobsModelsIndexRoute
  '/dashboard/jobs/recovery-estimates': typeof DashboardJobsRecoveryEstimatesIndexRoute
  '/dashboard/jobs/restarts': typeof DashboardJobsRestartsIndexRoute
  '/dashboard/jobs/sample-upload': typeof DashboardJobsSampleUploadIndexRoute
  '/dashboard/jobs/sync-samples': typeof DashboardJobsSyncSamplesIndexRoute
  '/dashboard/jobs/training': typeof DashboardJobsTrainingIndexRoute
  '/dashboard/jobs/video-upload': typeof DashboardJobsVideoUploadIndexRoute
  '/dashboard/jobs/worker-jobs': typeof DashboardJobsWorkerJobsIndexRoute
  '/dashboard/models/$modelId': typeof DashboardModelsModelIdIndexRoute
  '/dashboard/settings/alert-management': typeof DashboardSettingsAlertManagementIndexRoute
  '/dashboard/settings/queues': typeof DashboardSettingsQueuesIndexRoute
  '/dashboard/settings/tags-management': typeof DashboardSettingsTagsManagementIndexRoute
  '/dashboard/data/catalog/$item/details': typeof DashboardDataCatalogItemDetailsRouteRoute
  '/dashboard/data/catalog/$item/labels': typeof DashboardDataCatalogItemLabelsRouteRoute
  '/dashboard/data/catalog/$item/prices': typeof DashboardDataCatalogItemPricesRouteRoute
  '/dashboard/data/datasets/$datasetId/images': typeof DashboardDataDatasetsDatasetIdImagesRouteRoute
  '/dashboard/data/datasets/$datasetId/overview': typeof DashboardDataDatasetsDatasetIdOverviewRouteRoute
  '/dashboard/data/datasets/$datasetId/sessions': typeof DashboardDataDatasetsDatasetIdSessionsRouteRoute
  '/dashboard/data/images/$imageUUID/additional': typeof DashboardDataImagesImageUUIDAdditionalRouteRoute
  '/dashboard/data/images/$imageUUID/overview': typeof DashboardDataImagesImageUUIDOverviewRouteRoute
  '/dashboard/data/images/$imageUUID/transaction-details': typeof DashboardDataImagesImageUUIDTransactionDetailsRouteRoute
  '/dashboard/data/sessions/$sessionId/overview': typeof DashboardDataSessionsSessionIdOverviewRouteRoute
  '/dashboard/home/manager-report/$sessionId/overview': typeof DashboardHomeManagerReportSessionIdOverviewRouteRoute
  '/dashboard/models/$modelId/deployment/clusters': typeof DashboardModelsModelIdDeploymentClustersRouteRoute
  '/dashboard/models/$modelId/deployment/devices': typeof DashboardModelsModelIdDeploymentDevicesRouteRoute
  '/dashboard/resources/clusters/$clusterId/devices': typeof DashboardResourcesClustersClusterIdDevicesRouteRoute
  '/dashboard/resources/clusters/$clusterId/overview': typeof DashboardResourcesClustersClusterIdOverviewRouteRoute
  '/dashboard/resources/devices/$deviceId/camera': typeof DashboardResourcesDevicesDeviceIdCameraRouteRoute
  '/dashboard/resources/devices/$deviceId/diagnostics': typeof DashboardResourcesDevicesDeviceIdDiagnosticsRouteRouteWithChildren
  '/dashboard/resources/devices/$deviceId/logs': typeof DashboardResourcesDevicesDeviceIdLogsRouteRoute
  '/dashboard/resources/devices/$deviceId/overview': typeof DashboardResourcesDevicesDeviceIdOverviewRouteRoute
  '/dashboard/resources/devices/$deviceId/settings': typeof DashboardResourcesDevicesDeviceIdSettingsRouteRoute
  '/dashboard/resources/site-groups/$siteGroupId/labels': typeof DashboardResourcesSiteGroupsSiteGroupIdLabelsRouteRoute
  '/dashboard/resources/site-groups/$siteGroupId/overview': typeof DashboardResourcesSiteGroupsSiteGroupIdOverviewRouteRoute
  '/dashboard/resources/site-groups/$siteGroupId/sites': typeof DashboardResourcesSiteGroupsSiteGroupIdSitesRouteRoute
  '/dashboard/resources/sites/$siteId/devices': typeof DashboardResourcesSitesSiteIdDevicesRouteRoute
  '/dashboard/resources/sites/$siteId/overview': typeof DashboardResourcesSitesSiteIdOverviewRouteRoute
  '/dashboard/settings/queues/$queueName/failures': typeof DashboardSettingsQueuesQueueNameFailuresRouteRouteWithChildren
  '/dashboard/settings/queues/$queueName/pending': typeof DashboardSettingsQueuesQueueNamePendingRouteRouteWithChildren
  '/dashboard/settings/report-settings/$reportId/overview': typeof DashboardSettingsReportSettingsReportIdOverviewRouteRoute
  '/dashboard/settings/report-settings/$reportId/parameters': typeof DashboardSettingsReportSettingsReportIdParametersRouteRoute
  '/dashboard/settings/report-settings/$reportId/send-log': typeof DashboardSettingsReportSettingsReportIdSendLogRouteRoute
  '/dashboard/settings/report-settings/$reportId/subscriptions2': typeof DashboardSettingsReportSettingsReportIdSubscriptions2RouteRoute
  '/dashboard/settings/user-management/$userId/overview': typeof DashboardSettingsUserManagementUserIdOverviewRouteRoute
  '/dashboard/data/json-data/$jsonDataUUID/overview': typeof DashboardDataJsonDataJsonDataUUIDOverviewRoute
  '/dashboard/data/catalog/$item': typeof DashboardDataCatalogItemIndexRoute
  '/dashboard/data/images/$imageUUID': typeof DashboardDataImagesImageUUIDIndexRoute
  '/dashboard/data/json-data/$jsonDataUUID': typeof DashboardDataJsonDataJsonDataUUIDIndexRoute
  '/dashboard/data/label-distribution/$label': typeof DashboardDataLabelDistributionLabelIndexRoute
  '/dashboard/data/sessions/$sessionId': typeof DashboardDataSessionsSessionIdIndexRoute
  '/dashboard/home/manager-report/$sessionId': typeof DashboardHomeManagerReportSessionIdIndexRoute
  '/dashboard/models/$modelId/deployment': typeof DashboardModelsModelIdDeploymentIndexRoute
  '/dashboard/resources/clusters/$clusterId': typeof DashboardResourcesClustersClusterIdIndexRoute
  '/dashboard/resources/devices/$deviceId': typeof DashboardResourcesDevicesDeviceIdIndexRoute
  '/dashboard/resources/site-groups/$siteGroupId': typeof DashboardResourcesSiteGroupsSiteGroupIdIndexRoute
  '/dashboard/resources/sites/$siteId': typeof DashboardResourcesSitesSiteIdIndexRoute
  '/dashboard/settings/queues/$queueName': typeof DashboardSettingsQueuesQueueNameIndexRoute
  '/dashboard/settings/report-settings/$reportId': typeof DashboardSettingsReportSettingsReportIdIndexRoute
  '/dashboard/settings/user-management/$userId': typeof DashboardSettingsUserManagementUserIdIndexRoute
  '/admin-dashboard/jobs/service-health-checks/jobs/$jobId/overview': typeof AdminDashboardJobsServiceHealthChecksJobsJobIdOverviewRouteRoute
  '/admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId/inputs': typeof AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdInputsRouteRoute
  '/admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId/overview': typeof AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdOverviewRouteRoute
  '/admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId/schedule': typeof AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdScheduleRouteRoute
  '/dashboard/jobs/camera-calibration/jobs/$jobId/devices': typeof DashboardJobsCameraCalibrationJobsJobIdDevicesRouteRoute
  '/dashboard/jobs/camera-calibration/jobs/$jobId/overview': typeof DashboardJobsCameraCalibrationJobsJobIdOverviewRouteRoute
  '/dashboard/jobs/camera-calibration/schedule/$scheduledJobId/inputs': typeof DashboardJobsCameraCalibrationScheduleScheduledJobIdInputsRouteRoute
  '/dashboard/jobs/camera-calibration/schedule/$scheduledJobId/overview': typeof DashboardJobsCameraCalibrationScheduleScheduledJobIdOverviewRouteRoute
  '/dashboard/jobs/camera-calibration/schedule/$scheduledJobId/schedule': typeof DashboardJobsCameraCalibrationScheduleScheduledJobIdScheduleRouteRoute
  '/dashboard/jobs/capacity-tagging/jobs/$jobId/overview': typeof DashboardJobsCapacityTaggingJobsJobIdOverviewRouteRoute
  '/dashboard/jobs/capacity-tagging/schedule/$scheduledJobId/inputs': typeof DashboardJobsCapacityTaggingScheduleScheduledJobIdInputsRouteRoute
  '/dashboard/jobs/capacity-tagging/schedule/$scheduledJobId/overview': typeof DashboardJobsCapacityTaggingScheduleScheduledJobIdOverviewRouteRoute
  '/dashboard/jobs/capacity-tagging/schedule/$scheduledJobId/schedule': typeof DashboardJobsCapacityTaggingScheduleScheduledJobIdScheduleRouteRoute
  '/dashboard/jobs/catalog-upload/jobs/$jobId/devices': typeof DashboardJobsCatalogUploadJobsJobIdDevicesRouteRoute
  '/dashboard/jobs/catalog-upload/jobs/$jobId/labels': typeof DashboardJobsCatalogUploadJobsJobIdLabelsRouteRoute
  '/dashboard/jobs/catalog-upload/jobs/$jobId/overview': typeof DashboardJobsCatalogUploadJobsJobIdOverviewRouteRoute
  '/dashboard/jobs/catalog-upload/schedule/$scheduledJobId/labels': typeof DashboardJobsCatalogUploadScheduleScheduledJobIdLabelsRouteRoute
  '/dashboard/jobs/catalog-upload/schedule/$scheduledJobId/overview': typeof DashboardJobsCatalogUploadScheduleScheduledJobIdOverviewRouteRoute
  '/dashboard/jobs/catalog-upload/schedule/$scheduledJobId/schedule': typeof DashboardJobsCatalogUploadScheduleScheduledJobIdScheduleRouteRoute
  '/dashboard/jobs/config/jobs/$jobId/devices': typeof DashboardJobsConfigJobsJobIdDevicesRouteRoute
  '/dashboard/jobs/config/jobs/$jobId/overview': typeof DashboardJobsConfigJobsJobIdOverviewRouteRoute
  '/dashboard/jobs/config/schedule/$scheduledJobId/overview': typeof DashboardJobsConfigScheduleScheduledJobIdOverviewRouteRoute
  '/dashboard/jobs/config/schedule/$scheduledJobId/schedule': typeof DashboardJobsConfigScheduleScheduledJobIdScheduleRouteRoute
  '/dashboard/jobs/delete-samples/jobs/$jobId/devices': typeof DashboardJobsDeleteSamplesJobsJobIdDevicesRouteRoute
  '/dashboard/jobs/delete-samples/jobs/$jobId/overview': typeof DashboardJobsDeleteSamplesJobsJobIdOverviewRouteRoute
  '/dashboard/jobs/delete-samples/schedule/$scheduledJobId/inputs': typeof DashboardJobsDeleteSamplesScheduleScheduledJobIdInputsRouteRoute
  '/dashboard/jobs/delete-samples/schedule/$scheduledJobId/overview': typeof DashboardJobsDeleteSamplesScheduleScheduledJobIdOverviewRouteRoute
  '/dashboard/jobs/delete-samples/schedule/$scheduledJobId/schedule': typeof DashboardJobsDeleteSamplesScheduleScheduledJobIdScheduleRouteRoute
  '/dashboard/jobs/delete-videos/jobs/$jobId/devices': typeof DashboardJobsDeleteVideosJobsJobIdDevicesRouteRoute
  '/dashboard/jobs/delete-videos/jobs/$jobId/overview': typeof DashboardJobsDeleteVideosJobsJobIdOverviewRouteRoute
  '/dashboard/jobs/delete-videos/schedule/$scheduledJobId/inputs': typeof DashboardJobsDeleteVideosScheduleScheduledJobIdInputsRouteRoute
  '/dashboard/jobs/delete-videos/schedule/$scheduledJobId/overview': typeof DashboardJobsDeleteVideosScheduleScheduledJobIdOverviewRouteRoute
  '/dashboard/jobs/delete-videos/schedule/$scheduledJobId/schedule': typeof DashboardJobsDeleteVideosScheduleScheduledJobIdScheduleRouteRoute
  '/dashboard/jobs/deployments/jobs/$jobId/devices': typeof DashboardJobsDeploymentsJobsJobIdDevicesRouteRoute
  '/dashboard/jobs/deployments/jobs/$jobId/overview': typeof DashboardJobsDeploymentsJobsJobIdOverviewRouteRoute
  '/dashboard/jobs/deployments/schedule/$scheduledJobId/overview': typeof DashboardJobsDeploymentsScheduleScheduledJobIdOverviewRouteRoute
  '/dashboard/jobs/deployments/schedule/$scheduledJobId/schedule': typeof DashboardJobsDeploymentsScheduleScheduledJobIdScheduleRouteRoute
  '/dashboard/jobs/head-blur-images/jobs/$jobId/devices': typeof DashboardJobsHeadBlurImagesJobsJobIdDevicesRouteRoute
  '/dashboard/jobs/head-blur-images/jobs/$jobId/overview': typeof DashboardJobsHeadBlurImagesJobsJobIdOverviewRouteRoute
  '/dashboard/jobs/head-blur-images/schedule/$scheduledJobId/inputs': typeof DashboardJobsHeadBlurImagesScheduleScheduledJobIdInputsRouteRoute
  '/dashboard/jobs/head-blur-images/schedule/$scheduledJobId/overview': typeof DashboardJobsHeadBlurImagesScheduleScheduledJobIdOverviewRouteRoute
  '/dashboard/jobs/head-blur-images/schedule/$scheduledJobId/schedule': typeof DashboardJobsHeadBlurImagesScheduleScheduledJobIdScheduleRouteRoute
  '/dashboard/jobs/head-blur-videos/jobs/$jobId/devices': typeof DashboardJobsHeadBlurVideosJobsJobIdDevicesRouteRoute
  '/dashboard/jobs/head-blur-videos/jobs/$jobId/overview': typeof DashboardJobsHeadBlurVideosJobsJobIdOverviewRouteRoute
  '/dashboard/jobs/head-blur-videos/schedule/$scheduledJobId/inputs': typeof DashboardJobsHeadBlurVideosScheduleScheduledJobIdInputsRouteRoute
  '/dashboard/jobs/head-blur-videos/schedule/$scheduledJobId/overview': typeof DashboardJobsHeadBlurVideosScheduleScheduledJobIdOverviewRouteRoute
  '/dashboard/jobs/head-blur-videos/schedule/$scheduledJobId/schedule': typeof DashboardJobsHeadBlurVideosScheduleScheduledJobIdScheduleRouteRoute
  '/dashboard/jobs/models/jobs/$jobId/devices': typeof DashboardJobsModelsJobsJobIdDevicesRouteRoute
  '/dashboard/jobs/models/jobs/$jobId/overview': typeof DashboardJobsModelsJobsJobIdOverviewRouteRoute
  '/dashboard/jobs/models/schedule/$scheduledJobId/overview': typeof DashboardJobsModelsScheduleScheduledJobIdOverviewRouteRoute
  '/dashboard/jobs/models/schedule/$scheduledJobId/schedule': typeof DashboardJobsModelsScheduleScheduledJobIdScheduleRouteRoute
  '/dashboard/jobs/recovery-estimates/jobs/$jobId/overview': typeof DashboardJobsRecoveryEstimatesJobsJobIdOverviewRouteRoute
  '/dashboard/jobs/recovery-estimates/schedule/$scheduledJobId/inputs': typeof DashboardJobsRecoveryEstimatesScheduleScheduledJobIdInputsRouteRoute
  '/dashboard/jobs/recovery-estimates/schedule/$scheduledJobId/overview': typeof DashboardJobsRecoveryEstimatesScheduleScheduledJobIdOverviewRouteRoute
  '/dashboard/jobs/recovery-estimates/schedule/$scheduledJobId/schedule': typeof DashboardJobsRecoveryEstimatesScheduleScheduledJobIdScheduleRouteRoute
  '/dashboard/jobs/restarts/jobs/$jobId/devices': typeof DashboardJobsRestartsJobsJobIdDevicesRouteRoute
  '/dashboard/jobs/restarts/jobs/$jobId/overview': typeof DashboardJobsRestartsJobsJobIdOverviewRouteRoute
  '/dashboard/jobs/restarts/schedule/$scheduledJobId/overview': typeof DashboardJobsRestartsScheduleScheduledJobIdOverviewRouteRoute
  '/dashboard/jobs/restarts/schedule/$scheduledJobId/schedule': typeof DashboardJobsRestartsScheduleScheduledJobIdScheduleRouteRoute
  '/dashboard/jobs/sample-upload/jobs/$jobId/devices': typeof DashboardJobsSampleUploadJobsJobIdDevicesRouteRoute
  '/dashboard/jobs/sample-upload/jobs/$jobId/overview': typeof DashboardJobsSampleUploadJobsJobIdOverviewRouteRoute
  '/dashboard/jobs/sample-upload/schedule/$scheduledJobId/inputs': typeof DashboardJobsSampleUploadScheduleScheduledJobIdInputsRouteRoute
  '/dashboard/jobs/sample-upload/schedule/$scheduledJobId/overview': typeof DashboardJobsSampleUploadScheduleScheduledJobIdOverviewRouteRoute
  '/dashboard/jobs/sample-upload/schedule/$scheduledJobId/schedule': typeof DashboardJobsSampleUploadScheduleScheduledJobIdScheduleRouteRoute
  '/dashboard/jobs/sync-samples/jobs/$jobId/devices': typeof DashboardJobsSyncSamplesJobsJobIdDevicesRouteRoute
  '/dashboard/jobs/sync-samples/jobs/$jobId/overview': typeof DashboardJobsSyncSamplesJobsJobIdOverviewRouteRoute
  '/dashboard/jobs/sync-samples/schedule/$scheduledJobId/inputs': typeof DashboardJobsSyncSamplesScheduleScheduledJobIdInputsRouteRoute
  '/dashboard/jobs/sync-samples/schedule/$scheduledJobId/overview': typeof DashboardJobsSyncSamplesScheduleScheduledJobIdOverviewRouteRoute
  '/dashboard/jobs/sync-samples/schedule/$scheduledJobId/schedule': typeof DashboardJobsSyncSamplesScheduleScheduledJobIdScheduleRouteRoute
  '/dashboard/jobs/training/jobs/$jobId/devices': typeof DashboardJobsTrainingJobsJobIdDevicesRouteRoute
  '/dashboard/jobs/training/jobs/$jobId/labels': typeof DashboardJobsTrainingJobsJobIdLabelsRouteRoute
  '/dashboard/jobs/training/jobs/$jobId/metrics': typeof DashboardJobsTrainingJobsJobIdMetricsRouteRoute
  '/dashboard/jobs/training/jobs/$jobId/overview': typeof DashboardJobsTrainingJobsJobIdOverviewRouteRoute
  '/dashboard/jobs/training/schedule/$scheduledJobId/inputs': typeof DashboardJobsTrainingScheduleScheduledJobIdInputsRouteRoute
  '/dashboard/jobs/training/schedule/$scheduledJobId/overview': typeof DashboardJobsTrainingScheduleScheduledJobIdOverviewRouteRoute
  '/dashboard/jobs/training/schedule/$scheduledJobId/schedule': typeof DashboardJobsTrainingScheduleScheduledJobIdScheduleRouteRoute
  '/dashboard/jobs/video-upload/jobs/$jobId/devices': typeof DashboardJobsVideoUploadJobsJobIdDevicesRouteRoute
  '/dashboard/jobs/video-upload/jobs/$jobId/overview': typeof DashboardJobsVideoUploadJobsJobIdOverviewRouteRoute
  '/dashboard/jobs/video-upload/schedule/$scheduledJobId/inputs': typeof DashboardJobsVideoUploadScheduleScheduledJobIdInputsRouteRoute
  '/dashboard/jobs/video-upload/schedule/$scheduledJobId/overview': typeof DashboardJobsVideoUploadScheduleScheduledJobIdOverviewRouteRoute
  '/dashboard/jobs/video-upload/schedule/$scheduledJobId/schedule': typeof DashboardJobsVideoUploadScheduleScheduledJobIdScheduleRouteRoute
  '/dashboard/jobs/worker-jobs/jobs/$jobId/devices': typeof DashboardJobsWorkerJobsJobsJobIdDevicesRouteRoute
  '/dashboard/jobs/worker-jobs/jobs/$jobId/overview': typeof DashboardJobsWorkerJobsJobsJobIdOverviewRouteRoute
  '/dashboard/jobs/worker-jobs/schedule/$scheduledJobId/inputs': typeof DashboardJobsWorkerJobsScheduleScheduledJobIdInputsRouteRoute
  '/dashboard/jobs/worker-jobs/schedule/$scheduledJobId/overview': typeof DashboardJobsWorkerJobsScheduleScheduledJobIdOverviewRouteRoute
  '/dashboard/jobs/worker-jobs/schedule/$scheduledJobId/schedule': typeof DashboardJobsWorkerJobsScheduleScheduledJobIdScheduleRouteRoute
  '/dashboard/resources/devices/$deviceId/data/samples': typeof DashboardResourcesDevicesDeviceIdDataSamplesRouteRouteWithChildren
  '/dashboard/resources/devices/$deviceId/data/sessions': typeof DashboardResourcesDevicesDeviceIdDataSessionsRouteRouteWithChildren
  '/dashboard/resources/devices/$deviceId/data/text-json': typeof DashboardResourcesDevicesDeviceIdDataTextJsonRouteRoute
  '/dashboard/resources/devices/$deviceId/diagnostics/classifier': typeof DashboardResourcesDevicesDeviceIdDiagnosticsClassifierRouteRoute
  '/dashboard/resources/devices/$deviceId/diagnostics/custom': typeof DashboardResourcesDevicesDeviceIdDiagnosticsCustomRouteRoute
  '/dashboard/resources/devices/$deviceId/diagnostics/object-detection': typeof DashboardResourcesDevicesDeviceIdDiagnosticsObjectDetectionRouteRoute
  '/dashboard/resources/devices/$deviceId/version-history/agent': typeof DashboardResourcesDevicesDeviceIdVersionHistoryAgentRouteRoute
  '/dashboard/resources/devices/$deviceId/version-history/detector': typeof DashboardResourcesDevicesDeviceIdVersionHistoryDetectorRouteRoute
  '/dashboard/resources/devices/$deviceId/version-history/models': typeof DashboardResourcesDevicesDeviceIdVersionHistoryModelsRouteRoute
  '/dashboard/resources/devices/$deviceId/version-history/on-screen-app': typeof DashboardResourcesDevicesDeviceIdVersionHistoryOnScreenAppRouteRoute
  '/dashboard/resources/devices/$deviceId/version-history/trainer': typeof DashboardResourcesDevicesDeviceIdVersionHistoryTrainerRouteRoute
  '/dashboard/resources/devices/$deviceId/version-history/zebra-adapter': typeof DashboardResourcesDevicesDeviceIdVersionHistoryZebraAdapterRouteRoute
  '/dashboard/resources/sites/$siteId/version-history/agent': typeof DashboardResourcesSitesSiteIdVersionHistoryAgentRouteRoute
  '/dashboard/resources/sites/$siteId/version-history/detector': typeof DashboardResourcesSitesSiteIdVersionHistoryDetectorRouteRoute
  '/dashboard/resources/sites/$siteId/version-history/on-screen-app': typeof DashboardResourcesSitesSiteIdVersionHistoryOnScreenAppRouteRoute
  '/dashboard/resources/sites/$siteId/version-history/trainer': typeof DashboardResourcesSitesSiteIdVersionHistoryTrainerRouteRoute
  '/dashboard/resources/sites/$siteId/version-history/zebra-adapter': typeof DashboardResourcesSitesSiteIdVersionHistoryZebraAdapterRouteRoute
  '/dashboard/settings/alert-management/alerts/$alertId/overview': typeof DashboardSettingsAlertManagementAlertsAlertIdOverviewRouteRoute
  '/dashboard/settings/queues/$queueName/failures/$index': typeof DashboardSettingsQueuesQueueNameFailuresIndexRouteRoute
  '/dashboard/settings/queues/$queueName/pending/$index': typeof DashboardSettingsQueuesQueueNamePendingIndexRouteRoute
  '/dashboard/settings/report-subscription/$reportId/$subscriptionId/edit': typeof DashboardSettingsReportSubscriptionReportIdSubscriptionIdEditRouteRoute
  '/dashboard/settings/report-subscription/$reportId/$subscriptionId/overview': typeof DashboardSettingsReportSubscriptionReportIdSubscriptionIdOverviewRouteRoute
  '/dashboard/settings/report-subscription/$reportId/$subscriptionId/review-and-approve': typeof DashboardSettingsReportSubscriptionReportIdSubscriptionIdReviewAndApproveRouteRoute
  '/dashboard/settings/report-subscription/$reportId/$subscriptionId/send-history': typeof DashboardSettingsReportSubscriptionReportIdSubscriptionIdSendHistoryRouteRoute
  '/dashboard/settings/tags-management/catalog/$tagId/details': typeof DashboardSettingsTagsManagementCatalogTagIdDetailsRouteRoute
  '/dashboard/settings/tags-management/clusters/$tagId/details': typeof DashboardSettingsTagsManagementClustersTagIdDetailsRouteRoute
  '/dashboard/settings/tags-management/devices/$tagId/details': typeof DashboardSettingsTagsManagementDevicesTagIdDetailsRouteRoute
  '/dashboard/settings/tags-management/samples/$tagId/details': typeof DashboardSettingsTagsManagementSamplesTagIdDetailsRouteRoute
  '/dashboard/settings/tags-management/sessions/$tagId/details': typeof DashboardSettingsTagsManagementSessionsTagIdDetailsRouteRoute
  '/dashboard/settings/tags-management/sites/$tagId/details': typeof DashboardSettingsTagsManagementSitesTagIdDetailsRouteRoute
  '/admin-dashboard/jobs/service-health-checks/jobs/$jobId': typeof AdminDashboardJobsServiceHealthChecksJobsJobIdIndexRoute
  '/admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId': typeof AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdIndexRoute
  '/dashboard/jobs/camera-calibration/jobs/$jobId': typeof DashboardJobsCameraCalibrationJobsJobIdIndexRoute
  '/dashboard/jobs/camera-calibration/schedule/$scheduledJobId': typeof DashboardJobsCameraCalibrationScheduleScheduledJobIdIndexRoute
  '/dashboard/jobs/capacity-tagging/jobs/$jobId': typeof DashboardJobsCapacityTaggingJobsJobIdIndexRoute
  '/dashboard/jobs/capacity-tagging/schedule/$scheduledJobId': typeof DashboardJobsCapacityTaggingScheduleScheduledJobIdIndexRoute
  '/dashboard/jobs/catalog-upload/jobs/$jobId': typeof DashboardJobsCatalogUploadJobsJobIdIndexRoute
  '/dashboard/jobs/catalog-upload/schedule/$scheduledJobId': typeof DashboardJobsCatalogUploadScheduleScheduledJobIdIndexRoute
  '/dashboard/jobs/config/jobs/$jobId': typeof DashboardJobsConfigJobsJobIdIndexRoute
  '/dashboard/jobs/config/schedule/$scheduledJobId': typeof DashboardJobsConfigScheduleScheduledJobIdIndexRoute
  '/dashboard/jobs/delete-samples/jobs/$jobId': typeof DashboardJobsDeleteSamplesJobsJobIdIndexRoute
  '/dashboard/jobs/delete-samples/schedule/$scheduledJobId': typeof DashboardJobsDeleteSamplesScheduleScheduledJobIdIndexRoute
  '/dashboard/jobs/delete-videos/jobs/$jobId': typeof DashboardJobsDeleteVideosJobsJobIdIndexRoute
  '/dashboard/jobs/delete-videos/schedule/$scheduledJobId': typeof DashboardJobsDeleteVideosScheduleScheduledJobIdIndexRoute
  '/dashboard/jobs/deployments/jobs/$jobId': typeof DashboardJobsDeploymentsJobsJobIdIndexRoute
  '/dashboard/jobs/deployments/schedule/$scheduledJobId': typeof DashboardJobsDeploymentsScheduleScheduledJobIdIndexRoute
  '/dashboard/jobs/head-blur-images/jobs/$jobId': typeof DashboardJobsHeadBlurImagesJobsJobIdIndexRoute
  '/dashboard/jobs/head-blur-images/schedule/$scheduledJobId': typeof DashboardJobsHeadBlurImagesScheduleScheduledJobIdIndexRoute
  '/dashboard/jobs/head-blur-videos/jobs/$jobId': typeof DashboardJobsHeadBlurVideosJobsJobIdIndexRoute
  '/dashboard/jobs/head-blur-videos/schedule/$scheduledJobId': typeof DashboardJobsHeadBlurVideosScheduleScheduledJobIdIndexRoute
  '/dashboard/jobs/models/jobs/$jobId': typeof DashboardJobsModelsJobsJobIdIndexRoute
  '/dashboard/jobs/models/schedule/$scheduledJobId': typeof DashboardJobsModelsScheduleScheduledJobIdIndexRoute
  '/dashboard/jobs/recovery-estimates/jobs/$jobId': typeof DashboardJobsRecoveryEstimatesJobsJobIdIndexRoute
  '/dashboard/jobs/recovery-estimates/schedule/$scheduledJobId': typeof DashboardJobsRecoveryEstimatesScheduleScheduledJobIdIndexRoute
  '/dashboard/jobs/restarts/jobs/$jobId': typeof DashboardJobsRestartsJobsJobIdIndexRoute
  '/dashboard/jobs/restarts/schedule/$scheduledJobId': typeof DashboardJobsRestartsScheduleScheduledJobIdIndexRoute
  '/dashboard/jobs/sample-upload/jobs/$jobId': typeof DashboardJobsSampleUploadJobsJobIdIndexRoute
  '/dashboard/jobs/sample-upload/schedule/$scheduledJobId': typeof DashboardJobsSampleUploadScheduleScheduledJobIdIndexRoute
  '/dashboard/jobs/sync-samples/jobs/$jobId': typeof DashboardJobsSyncSamplesJobsJobIdIndexRoute
  '/dashboard/jobs/sync-samples/schedule/$scheduledJobId': typeof DashboardJobsSyncSamplesScheduleScheduledJobIdIndexRoute
  '/dashboard/jobs/training/jobs/$jobId': typeof DashboardJobsTrainingJobsJobIdIndexRoute
  '/dashboard/jobs/training/schedule/$scheduledJobId': typeof DashboardJobsTrainingScheduleScheduledJobIdIndexRoute
  '/dashboard/jobs/video-upload/jobs/$jobId': typeof DashboardJobsVideoUploadJobsJobIdIndexRoute
  '/dashboard/jobs/video-upload/schedule/$scheduledJobId': typeof DashboardJobsVideoUploadScheduleScheduledJobIdIndexRoute
  '/dashboard/jobs/worker-jobs/jobs/$jobId': typeof DashboardJobsWorkerJobsJobsJobIdIndexRoute
  '/dashboard/jobs/worker-jobs/schedule/$scheduledJobId': typeof DashboardJobsWorkerJobsScheduleScheduledJobIdIndexRoute
  '/dashboard/resources/devices/$deviceId/data': typeof DashboardResourcesDevicesDeviceIdDataIndexRoute
  '/dashboard/resources/devices/$deviceId/version-history': typeof DashboardResourcesDevicesDeviceIdVersionHistoryIndexRoute
  '/dashboard/resources/sites/$siteId/version-history': typeof DashboardResourcesSitesSiteIdVersionHistoryIndexRoute
  '/dashboard/settings/alert-management/alerts/$alertId': typeof DashboardSettingsAlertManagementAlertsAlertIdIndexRoute
  '/dashboard/settings/alert-management/metric-alerts/$metricAlertId': typeof DashboardSettingsAlertManagementMetricAlertsMetricAlertIdIndexRoute
  '/dashboard/settings/report-subscription/$reportId/$subscriptionId': typeof DashboardSettingsReportSubscriptionReportIdSubscriptionIdIndexRoute
  '/dashboard/settings/tags-management/catalog/$tagId': typeof DashboardSettingsTagsManagementCatalogTagIdIndexRoute
  '/dashboard/settings/tags-management/clusters/$tagId': typeof DashboardSettingsTagsManagementClustersTagIdIndexRoute
  '/dashboard/settings/tags-management/devices/$tagId': typeof DashboardSettingsTagsManagementDevicesTagIdIndexRoute
  '/dashboard/settings/tags-management/samples/$tagId': typeof DashboardSettingsTagsManagementSamplesTagIdIndexRoute
  '/dashboard/settings/tags-management/sessions/$tagId': typeof DashboardSettingsTagsManagementSessionsTagIdIndexRoute
  '/dashboard/settings/tags-management/sites/$tagId': typeof DashboardSettingsTagsManagementSitesTagIdIndexRoute
  '/dashboard/resources/devices/$deviceId/data/samples/$sampleId': typeof DashboardResourcesDevicesDeviceIdDataSamplesSampleIdIndexRoute
  '/dashboard/resources/devices/$deviceId/data/sessions/$sessionId': typeof DashboardResourcesDevicesDeviceIdDataSessionsSessionIdIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/admin-dashboard': typeof AdminDashboardRouteRouteWithChildren
  '/dashboard': typeof DashboardRouteRouteWithChildren
  '/unresponsive': typeof UnresponsiveRouteRoute
  '/login': typeof LoginRouteLazyRoute
  '/admin-dashboard/accounts-management': typeof AdminDashboardAccountsManagementRouteRouteWithChildren
  '/admin-dashboard/domain-auth-settings': typeof AdminDashboardDomainAuthSettingsRouteRoute
  '/admin-dashboard/jobs': typeof AdminDashboardJobsRouteRouteWithChildren
  '/admin-dashboard/notifications': typeof AdminDashboardNotificationsRouteRouteWithChildren
  '/dashboard/alerts': typeof DashboardAlertsRouteRoute
  '/dashboard/data': typeof DashboardDataRouteRouteWithChildren
  '/dashboard/jobs': typeof DashboardJobsRouteRouteWithChildren
  '/dashboard/models': typeof DashboardModelsRouteRouteWithChildren
  '/dashboard/reports': typeof DashboardReportsRouteRouteWithChildren
  '/dashboard/resources': typeof DashboardResourcesRouteRouteWithChildren
  '/dashboard/settings': typeof DashboardSettingsRouteRouteWithChildren
  '/dashboard/unauthorized': typeof DashboardUnauthorizedRouteRoute
  '/dashboard/home': typeof DashboardHomeRouteWithChildren
  '/dashboard/support': typeof DashboardSupportRoute
  '/next/$': typeof NextSplatRoute
  '/admin-dashboard/': typeof AdminDashboardIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/admin-dashboard/accounts-management/$accountId': typeof AdminDashboardAccountsManagementAccountIdRouteRouteWithChildren
  '/admin-dashboard/jobs/service-health-checks': typeof AdminDashboardJobsServiceHealthChecksRouteRouteWithChildren
  '/admin-dashboard/notifications/$notificationId': typeof AdminDashboardNotificationsNotificationIdRouteRouteWithChildren
  '/dashboard/data/annotations': typeof DashboardDataAnnotationsRouteRoute
  '/dashboard/data/catalog': typeof DashboardDataCatalogRouteRouteWithChildren
  '/dashboard/data/datasets': typeof DashboardDataDatasetsRouteRouteWithChildren
  '/dashboard/data/images': typeof DashboardDataImagesRouteRouteWithChildren
  '/dashboard/data/json-data': typeof DashboardDataJsonDataRouteRouteWithChildren
  '/dashboard/data/label-distribution': typeof DashboardDataLabelDistributionRouteRouteWithChildren
  '/dashboard/data/pending': typeof DashboardDataPendingRouteRoute
  '/dashboard/data/sessions': typeof DashboardDataSessionsRouteRouteWithChildren
  '/dashboard/home/manager-report': typeof DashboardHomeManagerReportRouteRouteWithChildren
  '/dashboard/jobs/camera-calibration': typeof DashboardJobsCameraCalibrationRouteRouteWithChildren
  '/dashboard/jobs/capacity-tagging': typeof DashboardJobsCapacityTaggingRouteRouteWithChildren
  '/dashboard/jobs/catalog-upload': typeof DashboardJobsCatalogUploadRouteRouteWithChildren
  '/dashboard/jobs/config': typeof DashboardJobsConfigRouteRouteWithChildren
  '/dashboard/jobs/delete-samples': typeof DashboardJobsDeleteSamplesRouteRouteWithChildren
  '/dashboard/jobs/delete-videos': typeof DashboardJobsDeleteVideosRouteRouteWithChildren
  '/dashboard/jobs/deployments': typeof DashboardJobsDeploymentsRouteRouteWithChildren
  '/dashboard/jobs/head-blur-images': typeof DashboardJobsHeadBlurImagesRouteRouteWithChildren
  '/dashboard/jobs/head-blur-videos': typeof DashboardJobsHeadBlurVideosRouteRouteWithChildren
  '/dashboard/jobs/models': typeof DashboardJobsModelsRouteRouteWithChildren
  '/dashboard/jobs/recovery-estimates': typeof DashboardJobsRecoveryEstimatesRouteRouteWithChildren
  '/dashboard/jobs/restarts': typeof DashboardJobsRestartsRouteRouteWithChildren
  '/dashboard/jobs/sample-upload': typeof DashboardJobsSampleUploadRouteRouteWithChildren
  '/dashboard/jobs/sync-samples': typeof DashboardJobsSyncSamplesRouteRouteWithChildren
  '/dashboard/jobs/training': typeof DashboardJobsTrainingRouteRouteWithChildren
  '/dashboard/jobs/video-upload': typeof DashboardJobsVideoUploadRouteRouteWithChildren
  '/dashboard/jobs/worker-jobs': typeof DashboardJobsWorkerJobsRouteRouteWithChildren
  '/dashboard/models/$modelId': typeof DashboardModelsModelIdRouteRouteWithChildren
  '/dashboard/reports/$reportId': typeof DashboardReportsReportIdRouteRoute
  '/dashboard/reports/analytics-hub': typeof DashboardReportsAnalyticsHubRouteRoute
  '/dashboard/reports/companion': typeof DashboardReportsCompanionRouteRoute
  '/dashboard/resources/clusters': typeof DashboardResourcesClustersRouteRouteWithChildren
  '/dashboard/resources/devices': typeof DashboardResourcesDevicesRouteRouteWithChildren
  '/dashboard/resources/site-groups': typeof DashboardResourcesSiteGroupsRouteRouteWithChildren
  '/dashboard/resources/sites': typeof DashboardResourcesSitesRouteRouteWithChildren
  '/dashboard/settings/alert-management': typeof DashboardSettingsAlertManagementRouteRouteWithChildren
  '/dashboard/settings/job-defaults': typeof DashboardSettingsJobDefaultsRouteRoute
  '/dashboard/settings/overview': typeof DashboardSettingsOverviewRouteRoute
  '/dashboard/settings/permissions-settings': typeof DashboardSettingsPermissionsSettingsRouteRoute
  '/dashboard/settings/permissions-settings-dev': typeof DashboardSettingsPermissionsSettingsDevRouteRoute
  '/dashboard/settings/queues': typeof DashboardSettingsQueuesRouteRouteWithChildren
  '/dashboard/settings/regions': typeof DashboardSettingsRegionsRouteRoute
  '/dashboard/settings/report-settings': typeof DashboardSettingsReportSettingsRouteRouteWithChildren
  '/dashboard/settings/tags-management': typeof DashboardSettingsTagsManagementRouteRouteWithChildren
  '/dashboard/settings/user-management': typeof DashboardSettingsUserManagementRouteRouteWithChildren
  '/dashboard/[/rest]': typeof DashboardRestRoute
  '/dashboard/data/': typeof DashboardDataIndexRoute
  '/dashboard/home/': typeof DashboardHomeIndexRoute
  '/dashboard/jobs/': typeof DashboardJobsIndexRoute
  '/dashboard/reports/': typeof DashboardReportsIndexRoute
  '/dashboard/resources/': typeof DashboardResourcesIndexRoute
  '/dashboard/settings/': typeof DashboardSettingsIndexRoute
  '/admin-dashboard/accounts-management/$accountId/operational-hours': typeof AdminDashboardAccountsManagementAccountIdOperationalHoursRouteRoute
  '/admin-dashboard/accounts-management/$accountId/overview': typeof AdminDashboardAccountsManagementAccountIdOverviewRouteRoute
  '/admin-dashboard/accounts-management/$accountId/regions': typeof AdminDashboardAccountsManagementAccountIdRegionsRouteRoute
  '/admin-dashboard/jobs/service-health-checks/jobs': typeof AdminDashboardJobsServiceHealthChecksJobsRouteRouteWithChildren
  '/admin-dashboard/jobs/service-health-checks/schedule': typeof AdminDashboardJobsServiceHealthChecksScheduleRouteRouteWithChildren
  '/admin-dashboard/notifications/$notificationId/overview': typeof AdminDashboardNotificationsNotificationIdOverviewRouteRoute
  '/dashboard/data/catalog/$item': typeof DashboardDataCatalogItemRouteRouteWithChildren
  '/dashboard/data/datasets/$datasetId': typeof DashboardDataDatasetsDatasetIdRouteRouteWithChildren
  '/dashboard/data/images/$imageUUID': typeof DashboardDataImagesImageUUIDRouteRouteWithChildren
  '/dashboard/data/json-data/$jsonDataUUID': typeof DashboardDataJsonDataJsonDataUUIDRouteRouteWithChildren
  '/dashboard/data/label-distribution/$label': typeof DashboardDataLabelDistributionLabelRouteRouteWithChildren
  '/dashboard/data/sessions/$sessionId': typeof DashboardDataSessionsSessionIdRouteRouteWithChildren
  '/dashboard/home/manager-report/$sessionId': typeof DashboardHomeManagerReportSessionIdRouteRouteWithChildren
  '/dashboard/jobs/camera-calibration/alerts': typeof DashboardJobsCameraCalibrationAlertsRouteRoute
  '/dashboard/jobs/camera-calibration/jobs': typeof DashboardJobsCameraCalibrationJobsRouteRouteWithChildren
  '/dashboard/jobs/camera-calibration/schedule': typeof DashboardJobsCameraCalibrationScheduleRouteRouteWithChildren
  '/dashboard/jobs/capacity-tagging/jobs': typeof DashboardJobsCapacityTaggingJobsRouteRouteWithChildren
  '/dashboard/jobs/capacity-tagging/schedule': typeof DashboardJobsCapacityTaggingScheduleRouteRouteWithChildren
  '/dashboard/jobs/catalog-upload/jobs': typeof DashboardJobsCatalogUploadJobsRouteRouteWithChildren
  '/dashboard/jobs/catalog-upload/schedule': typeof DashboardJobsCatalogUploadScheduleRouteRouteWithChildren
  '/dashboard/jobs/config/jobs': typeof DashboardJobsConfigJobsRouteRouteWithChildren
  '/dashboard/jobs/config/schedule': typeof DashboardJobsConfigScheduleRouteRouteWithChildren
  '/dashboard/jobs/delete-samples/alerts': typeof DashboardJobsDeleteSamplesAlertsRouteRoute
  '/dashboard/jobs/delete-samples/jobs': typeof DashboardJobsDeleteSamplesJobsRouteRouteWithChildren
  '/dashboard/jobs/delete-samples/schedule': typeof DashboardJobsDeleteSamplesScheduleRouteRouteWithChildren
  '/dashboard/jobs/delete-videos/alerts': typeof DashboardJobsDeleteVideosAlertsRouteRoute
  '/dashboard/jobs/delete-videos/jobs': typeof DashboardJobsDeleteVideosJobsRouteRouteWithChildren
  '/dashboard/jobs/delete-videos/schedule': typeof DashboardJobsDeleteVideosScheduleRouteRouteWithChildren
  '/dashboard/jobs/deployments/jobs': typeof DashboardJobsDeploymentsJobsRouteRouteWithChildren
  '/dashboard/jobs/deployments/schedule': typeof DashboardJobsDeploymentsScheduleRouteRouteWithChildren
  '/dashboard/jobs/head-blur-images/jobs': typeof DashboardJobsHeadBlurImagesJobsRouteRouteWithChildren
  '/dashboard/jobs/head-blur-images/schedule': typeof DashboardJobsHeadBlurImagesScheduleRouteRouteWithChildren
  '/dashboard/jobs/head-blur-videos/jobs': typeof DashboardJobsHeadBlurVideosJobsRouteRouteWithChildren
  '/dashboard/jobs/head-blur-videos/schedule': typeof DashboardJobsHeadBlurVideosScheduleRouteRouteWithChildren
  '/dashboard/jobs/models/jobs': typeof DashboardJobsModelsJobsRouteRouteWithChildren
  '/dashboard/jobs/models/schedule': typeof DashboardJobsModelsScheduleRouteRouteWithChildren
  '/dashboard/jobs/recovery-estimates/jobs': typeof DashboardJobsRecoveryEstimatesJobsRouteRouteWithChildren
  '/dashboard/jobs/recovery-estimates/schedule': typeof DashboardJobsRecoveryEstimatesScheduleRouteRouteWithChildren
  '/dashboard/jobs/restarts/jobs': typeof DashboardJobsRestartsJobsRouteRouteWithChildren
  '/dashboard/jobs/restarts/schedule': typeof DashboardJobsRestartsScheduleRouteRouteWithChildren
  '/dashboard/jobs/sample-upload/alerts': typeof DashboardJobsSampleUploadAlertsRouteRoute
  '/dashboard/jobs/sample-upload/jobs': typeof DashboardJobsSampleUploadJobsRouteRouteWithChildren
  '/dashboard/jobs/sample-upload/schedule': typeof DashboardJobsSampleUploadScheduleRouteRouteWithChildren
  '/dashboard/jobs/sync-samples/alerts': typeof DashboardJobsSyncSamplesAlertsRouteRoute
  '/dashboard/jobs/sync-samples/jobs': typeof DashboardJobsSyncSamplesJobsRouteRouteWithChildren
  '/dashboard/jobs/sync-samples/schedule': typeof DashboardJobsSyncSamplesScheduleRouteRouteWithChildren
  '/dashboard/jobs/training/jobs': typeof DashboardJobsTrainingJobsRouteRouteWithChildren
  '/dashboard/jobs/training/schedule': typeof DashboardJobsTrainingScheduleRouteRouteWithChildren
  '/dashboard/jobs/video-upload/alerts': typeof DashboardJobsVideoUploadAlertsRouteRoute
  '/dashboard/jobs/video-upload/jobs': typeof DashboardJobsVideoUploadJobsRouteRouteWithChildren
  '/dashboard/jobs/video-upload/schedule': typeof DashboardJobsVideoUploadScheduleRouteRouteWithChildren
  '/dashboard/jobs/worker-jobs/jobs': typeof DashboardJobsWorkerJobsJobsRouteRouteWithChildren
  '/dashboard/jobs/worker-jobs/schedule': typeof DashboardJobsWorkerJobsScheduleRouteRouteWithChildren
  '/dashboard/models/$modelId/deployment': typeof DashboardModelsModelIdDeploymentRouteRouteWithChildren
  '/dashboard/models/$modelId/labels': typeof DashboardModelsModelIdLabelsRouteRoute
  '/dashboard/models/$modelId/matrix': typeof DashboardModelsModelIdMatrixRouteRoute
  '/dashboard/models/$modelId/overview': typeof DashboardModelsModelIdOverviewRouteRoute
  '/dashboard/resources/clusters/$clusterId': typeof DashboardResourcesClustersClusterIdRouteRouteWithChildren
  '/dashboard/resources/devices/$deviceId': typeof DashboardResourcesDevicesDeviceIdRouteRouteWithChildren
  '/dashboard/resources/site-groups/$siteGroupId': typeof DashboardResourcesSiteGroupsSiteGroupIdRouteRouteWithChildren
  '/dashboard/resources/sites/$siteId': typeof DashboardResourcesSitesSiteIdRouteRouteWithChildren
  '/dashboard/settings/alert-management/alert-channels': typeof DashboardSettingsAlertManagementAlertChannelsRouteRoute
  '/dashboard/settings/alert-management/alerts': typeof DashboardSettingsAlertManagementAlertsRouteRouteWithChildren
  '/dashboard/settings/alert-management/metric-alerts': typeof DashboardSettingsAlertManagementMetricAlertsRouteRouteWithChildren
  '/dashboard/settings/queues/$queueName': typeof DashboardSettingsQueuesQueueNameRouteRouteWithChildren
  '/dashboard/settings/report-settings/$reportId': typeof DashboardSettingsReportSettingsReportIdRouteRouteWithChildren
  '/dashboard/settings/tags-management/catalog': typeof DashboardSettingsTagsManagementCatalogRouteRouteWithChildren
  '/dashboard/settings/tags-management/clusters': typeof DashboardSettingsTagsManagementClustersRouteRouteWithChildren
  '/dashboard/settings/tags-management/devices': typeof DashboardSettingsTagsManagementDevicesRouteRouteWithChildren
  '/dashboard/settings/tags-management/samples': typeof DashboardSettingsTagsManagementSamplesRouteRouteWithChildren
  '/dashboard/settings/tags-management/sessions': typeof DashboardSettingsTagsManagementSessionsRouteRouteWithChildren
  '/dashboard/settings/tags-management/sites': typeof DashboardSettingsTagsManagementSitesRouteRouteWithChildren
  '/dashboard/settings/user-management/$userId': typeof DashboardSettingsUserManagementUserIdRouteRouteWithChildren
  '/dashboard/data/[/rest]': typeof DashboardDataRestRoute
  '/dashboard/resources/[/rest]': typeof DashboardResourcesRestRoute
  '/dashboard/settings/user-management/thumbnail': typeof DashboardSettingsUserManagementThumbnailRoute
  '/admin-dashboard/accounts-management/$accountId/': typeof AdminDashboardAccountsManagementAccountIdIndexRoute
  '/admin-dashboard/jobs/service-health-checks/': typeof AdminDashboardJobsServiceHealthChecksIndexRoute
  '/dashboard/home/manager-report/': typeof DashboardHomeManagerReportIndexRoute
  '/dashboard/jobs/camera-calibration/': typeof DashboardJobsCameraCalibrationIndexRoute
  '/dashboard/jobs/capacity-tagging/': typeof DashboardJobsCapacityTaggingIndexRoute
  '/dashboard/jobs/catalog-upload/': typeof DashboardJobsCatalogUploadIndexRoute
  '/dashboard/jobs/config/': typeof DashboardJobsConfigIndexRoute
  '/dashboard/jobs/delete-samples/': typeof DashboardJobsDeleteSamplesIndexRoute
  '/dashboard/jobs/delete-videos/': typeof DashboardJobsDeleteVideosIndexRoute
  '/dashboard/jobs/deployments/': typeof DashboardJobsDeploymentsIndexRoute
  '/dashboard/jobs/head-blur-images/': typeof DashboardJobsHeadBlurImagesIndexRoute
  '/dashboard/jobs/head-blur-videos/': typeof DashboardJobsHeadBlurVideosIndexRoute
  '/dashboard/jobs/models/': typeof DashboardJobsModelsIndexRoute
  '/dashboard/jobs/recovery-estimates/': typeof DashboardJobsRecoveryEstimatesIndexRoute
  '/dashboard/jobs/restarts/': typeof DashboardJobsRestartsIndexRoute
  '/dashboard/jobs/sample-upload/': typeof DashboardJobsSampleUploadIndexRoute
  '/dashboard/jobs/sync-samples/': typeof DashboardJobsSyncSamplesIndexRoute
  '/dashboard/jobs/training/': typeof DashboardJobsTrainingIndexRoute
  '/dashboard/jobs/video-upload/': typeof DashboardJobsVideoUploadIndexRoute
  '/dashboard/jobs/worker-jobs/': typeof DashboardJobsWorkerJobsIndexRoute
  '/dashboard/models/$modelId/': typeof DashboardModelsModelIdIndexRoute
  '/dashboard/settings/alert-management/': typeof DashboardSettingsAlertManagementIndexRoute
  '/dashboard/settings/queues/': typeof DashboardSettingsQueuesIndexRoute
  '/dashboard/settings/tags-management/': typeof DashboardSettingsTagsManagementIndexRoute
  '/admin-dashboard/jobs/service-health-checks/jobs/$jobId': typeof AdminDashboardJobsServiceHealthChecksJobsJobIdRouteRouteWithChildren
  '/admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId': typeof AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdRouteRouteWithChildren
  '/dashboard/data/catalog/$item/details': typeof DashboardDataCatalogItemDetailsRouteRoute
  '/dashboard/data/catalog/$item/labels': typeof DashboardDataCatalogItemLabelsRouteRoute
  '/dashboard/data/catalog/$item/prices': typeof DashboardDataCatalogItemPricesRouteRoute
  '/dashboard/data/datasets/$datasetId/images': typeof DashboardDataDatasetsDatasetIdImagesRouteRoute
  '/dashboard/data/datasets/$datasetId/overview': typeof DashboardDataDatasetsDatasetIdOverviewRouteRoute
  '/dashboard/data/datasets/$datasetId/sessions': typeof DashboardDataDatasetsDatasetIdSessionsRouteRoute
  '/dashboard/data/images/$imageUUID/additional': typeof DashboardDataImagesImageUUIDAdditionalRouteRoute
  '/dashboard/data/images/$imageUUID/overview': typeof DashboardDataImagesImageUUIDOverviewRouteRoute
  '/dashboard/data/images/$imageUUID/transaction-details': typeof DashboardDataImagesImageUUIDTransactionDetailsRouteRoute
  '/dashboard/data/sessions/$sessionId/overview': typeof DashboardDataSessionsSessionIdOverviewRouteRoute
  '/dashboard/home/manager-report/$sessionId/overview': typeof DashboardHomeManagerReportSessionIdOverviewRouteRoute
  '/dashboard/jobs/camera-calibration/jobs/$jobId': typeof DashboardJobsCameraCalibrationJobsJobIdRouteRouteWithChildren
  '/dashboard/jobs/camera-calibration/schedule/$scheduledJobId': typeof DashboardJobsCameraCalibrationScheduleScheduledJobIdRouteRouteWithChildren
  '/dashboard/jobs/capacity-tagging/jobs/$jobId': typeof DashboardJobsCapacityTaggingJobsJobIdRouteRouteWithChildren
  '/dashboard/jobs/capacity-tagging/schedule/$scheduledJobId': typeof DashboardJobsCapacityTaggingScheduleScheduledJobIdRouteRouteWithChildren
  '/dashboard/jobs/catalog-upload/jobs/$jobId': typeof DashboardJobsCatalogUploadJobsJobIdRouteRouteWithChildren
  '/dashboard/jobs/catalog-upload/schedule/$scheduledJobId': typeof DashboardJobsCatalogUploadScheduleScheduledJobIdRouteRouteWithChildren
  '/dashboard/jobs/config/jobs/$jobId': typeof DashboardJobsConfigJobsJobIdRouteRouteWithChildren
  '/dashboard/jobs/config/schedule/$scheduledJobId': typeof DashboardJobsConfigScheduleScheduledJobIdRouteRouteWithChildren
  '/dashboard/jobs/delete-samples/jobs/$jobId': typeof DashboardJobsDeleteSamplesJobsJobIdRouteRouteWithChildren
  '/dashboard/jobs/delete-samples/schedule/$scheduledJobId': typeof DashboardJobsDeleteSamplesScheduleScheduledJobIdRouteRouteWithChildren
  '/dashboard/jobs/delete-videos/jobs/$jobId': typeof DashboardJobsDeleteVideosJobsJobIdRouteRouteWithChildren
  '/dashboard/jobs/delete-videos/schedule/$scheduledJobId': typeof DashboardJobsDeleteVideosScheduleScheduledJobIdRouteRouteWithChildren
  '/dashboard/jobs/deployments/jobs/$jobId': typeof DashboardJobsDeploymentsJobsJobIdRouteRouteWithChildren
  '/dashboard/jobs/deployments/schedule/$scheduledJobId': typeof DashboardJobsDeploymentsScheduleScheduledJobIdRouteRouteWithChildren
  '/dashboard/jobs/head-blur-images/jobs/$jobId': typeof DashboardJobsHeadBlurImagesJobsJobIdRouteRouteWithChildren
  '/dashboard/jobs/head-blur-images/schedule/$scheduledJobId': typeof DashboardJobsHeadBlurImagesScheduleScheduledJobIdRouteRouteWithChildren
  '/dashboard/jobs/head-blur-videos/jobs/$jobId': typeof DashboardJobsHeadBlurVideosJobsJobIdRouteRouteWithChildren
  '/dashboard/jobs/head-blur-videos/schedule/$scheduledJobId': typeof DashboardJobsHeadBlurVideosScheduleScheduledJobIdRouteRouteWithChildren
  '/dashboard/jobs/models/jobs/$jobId': typeof DashboardJobsModelsJobsJobIdRouteRouteWithChildren
  '/dashboard/jobs/models/schedule/$scheduledJobId': typeof DashboardJobsModelsScheduleScheduledJobIdRouteRouteWithChildren
  '/dashboard/jobs/recovery-estimates/jobs/$jobId': typeof DashboardJobsRecoveryEstimatesJobsJobIdRouteRouteWithChildren
  '/dashboard/jobs/recovery-estimates/schedule/$scheduledJobId': typeof DashboardJobsRecoveryEstimatesScheduleScheduledJobIdRouteRouteWithChildren
  '/dashboard/jobs/restarts/jobs/$jobId': typeof DashboardJobsRestartsJobsJobIdRouteRouteWithChildren
  '/dashboard/jobs/restarts/schedule/$scheduledJobId': typeof DashboardJobsRestartsScheduleScheduledJobIdRouteRouteWithChildren
  '/dashboard/jobs/sample-upload/jobs/$jobId': typeof DashboardJobsSampleUploadJobsJobIdRouteRouteWithChildren
  '/dashboard/jobs/sample-upload/schedule/$scheduledJobId': typeof DashboardJobsSampleUploadScheduleScheduledJobIdRouteRouteWithChildren
  '/dashboard/jobs/sync-samples/jobs/$jobId': typeof DashboardJobsSyncSamplesJobsJobIdRouteRouteWithChildren
  '/dashboard/jobs/sync-samples/schedule/$scheduledJobId': typeof DashboardJobsSyncSamplesScheduleScheduledJobIdRouteRouteWithChildren
  '/dashboard/jobs/training/jobs/$jobId': typeof DashboardJobsTrainingJobsJobIdRouteRouteWithChildren
  '/dashboard/jobs/training/schedule/$scheduledJobId': typeof DashboardJobsTrainingScheduleScheduledJobIdRouteRouteWithChildren
  '/dashboard/jobs/video-upload/jobs/$jobId': typeof DashboardJobsVideoUploadJobsJobIdRouteRouteWithChildren
  '/dashboard/jobs/video-upload/schedule/$scheduledJobId': typeof DashboardJobsVideoUploadScheduleScheduledJobIdRouteRouteWithChildren
  '/dashboard/jobs/worker-jobs/jobs/$jobId': typeof DashboardJobsWorkerJobsJobsJobIdRouteRouteWithChildren
  '/dashboard/jobs/worker-jobs/schedule/$scheduledJobId': typeof DashboardJobsWorkerJobsScheduleScheduledJobIdRouteRouteWithChildren
  '/dashboard/models/$modelId/deployment/clusters': typeof DashboardModelsModelIdDeploymentClustersRouteRoute
  '/dashboard/models/$modelId/deployment/devices': typeof DashboardModelsModelIdDeploymentDevicesRouteRoute
  '/dashboard/resources/clusters/$clusterId/devices': typeof DashboardResourcesClustersClusterIdDevicesRouteRoute
  '/dashboard/resources/clusters/$clusterId/overview': typeof DashboardResourcesClustersClusterIdOverviewRouteRoute
  '/dashboard/resources/devices/$deviceId/camera': typeof DashboardResourcesDevicesDeviceIdCameraRouteRoute
  '/dashboard/resources/devices/$deviceId/data': typeof DashboardResourcesDevicesDeviceIdDataRouteRouteWithChildren
  '/dashboard/resources/devices/$deviceId/diagnostics': typeof DashboardResourcesDevicesDeviceIdDiagnosticsRouteRouteWithChildren
  '/dashboard/resources/devices/$deviceId/logs': typeof DashboardResourcesDevicesDeviceIdLogsRouteRoute
  '/dashboard/resources/devices/$deviceId/overview': typeof DashboardResourcesDevicesDeviceIdOverviewRouteRoute
  '/dashboard/resources/devices/$deviceId/settings': typeof DashboardResourcesDevicesDeviceIdSettingsRouteRoute
  '/dashboard/resources/devices/$deviceId/version-history': typeof DashboardResourcesDevicesDeviceIdVersionHistoryRouteRouteWithChildren
  '/dashboard/resources/site-groups/$siteGroupId/labels': typeof DashboardResourcesSiteGroupsSiteGroupIdLabelsRouteRoute
  '/dashboard/resources/site-groups/$siteGroupId/overview': typeof DashboardResourcesSiteGroupsSiteGroupIdOverviewRouteRoute
  '/dashboard/resources/site-groups/$siteGroupId/sites': typeof DashboardResourcesSiteGroupsSiteGroupIdSitesRouteRoute
  '/dashboard/resources/sites/$siteId/devices': typeof DashboardResourcesSitesSiteIdDevicesRouteRoute
  '/dashboard/resources/sites/$siteId/overview': typeof DashboardResourcesSitesSiteIdOverviewRouteRoute
  '/dashboard/resources/sites/$siteId/version-history': typeof DashboardResourcesSitesSiteIdVersionHistoryRouteRouteWithChildren
  '/dashboard/settings/alert-management/alerts/$alertId': typeof DashboardSettingsAlertManagementAlertsAlertIdRouteRouteWithChildren
  '/dashboard/settings/queues/$queueName/failures': typeof DashboardSettingsQueuesQueueNameFailuresRouteRouteWithChildren
  '/dashboard/settings/queues/$queueName/pending': typeof DashboardSettingsQueuesQueueNamePendingRouteRouteWithChildren
  '/dashboard/settings/report-settings/$reportId/overview': typeof DashboardSettingsReportSettingsReportIdOverviewRouteRoute
  '/dashboard/settings/report-settings/$reportId/parameters': typeof DashboardSettingsReportSettingsReportIdParametersRouteRoute
  '/dashboard/settings/report-settings/$reportId/send-log': typeof DashboardSettingsReportSettingsReportIdSendLogRouteRoute
  '/dashboard/settings/report-settings/$reportId/subscriptions2': typeof DashboardSettingsReportSettingsReportIdSubscriptions2RouteRoute
  '/dashboard/settings/report-subscription/$reportId/$subscriptionId': typeof DashboardSettingsReportSubscriptionReportIdSubscriptionIdRouteRouteWithChildren
  '/dashboard/settings/tags-management/catalog/$tagId': typeof DashboardSettingsTagsManagementCatalogTagIdRouteRouteWithChildren
  '/dashboard/settings/tags-management/clusters/$tagId': typeof DashboardSettingsTagsManagementClustersTagIdRouteRouteWithChildren
  '/dashboard/settings/tags-management/devices/$tagId': typeof DashboardSettingsTagsManagementDevicesTagIdRouteRouteWithChildren
  '/dashboard/settings/tags-management/samples/$tagId': typeof DashboardSettingsTagsManagementSamplesTagIdRouteRouteWithChildren
  '/dashboard/settings/tags-management/sessions/$tagId': typeof DashboardSettingsTagsManagementSessionsTagIdRouteRouteWithChildren
  '/dashboard/settings/tags-management/sites/$tagId': typeof DashboardSettingsTagsManagementSitesTagIdRouteRouteWithChildren
  '/dashboard/settings/user-management/$userId/overview': typeof DashboardSettingsUserManagementUserIdOverviewRouteRoute
  '/dashboard/data/json-data/$jsonDataUUID/overview': typeof DashboardDataJsonDataJsonDataUUIDOverviewRoute
  '/dashboard/data/catalog/$item/': typeof DashboardDataCatalogItemIndexRoute
  '/dashboard/data/images/$imageUUID/': typeof DashboardDataImagesImageUUIDIndexRoute
  '/dashboard/data/json-data/$jsonDataUUID/': typeof DashboardDataJsonDataJsonDataUUIDIndexRoute
  '/dashboard/data/label-distribution/$label/': typeof DashboardDataLabelDistributionLabelIndexRoute
  '/dashboard/data/sessions/$sessionId/': typeof DashboardDataSessionsSessionIdIndexRoute
  '/dashboard/home/manager-report/$sessionId/': typeof DashboardHomeManagerReportSessionIdIndexRoute
  '/dashboard/models/$modelId/deployment/': typeof DashboardModelsModelIdDeploymentIndexRoute
  '/dashboard/resources/clusters/$clusterId/': typeof DashboardResourcesClustersClusterIdIndexRoute
  '/dashboard/resources/devices/$deviceId/': typeof DashboardResourcesDevicesDeviceIdIndexRoute
  '/dashboard/resources/site-groups/$siteGroupId/': typeof DashboardResourcesSiteGroupsSiteGroupIdIndexRoute
  '/dashboard/resources/sites/$siteId/': typeof DashboardResourcesSitesSiteIdIndexRoute
  '/dashboard/settings/queues/$queueName/': typeof DashboardSettingsQueuesQueueNameIndexRoute
  '/dashboard/settings/report-settings/$reportId/': typeof DashboardSettingsReportSettingsReportIdIndexRoute
  '/dashboard/settings/user-management/$userId/': typeof DashboardSettingsUserManagementUserIdIndexRoute
  '/admin-dashboard/jobs/service-health-checks/jobs/$jobId/overview': typeof AdminDashboardJobsServiceHealthChecksJobsJobIdOverviewRouteRoute
  '/admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId/inputs': typeof AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdInputsRouteRoute
  '/admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId/overview': typeof AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdOverviewRouteRoute
  '/admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId/schedule': typeof AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdScheduleRouteRoute
  '/dashboard/jobs/camera-calibration/jobs/$jobId/devices': typeof DashboardJobsCameraCalibrationJobsJobIdDevicesRouteRoute
  '/dashboard/jobs/camera-calibration/jobs/$jobId/overview': typeof DashboardJobsCameraCalibrationJobsJobIdOverviewRouteRoute
  '/dashboard/jobs/camera-calibration/schedule/$scheduledJobId/inputs': typeof DashboardJobsCameraCalibrationScheduleScheduledJobIdInputsRouteRoute
  '/dashboard/jobs/camera-calibration/schedule/$scheduledJobId/overview': typeof DashboardJobsCameraCalibrationScheduleScheduledJobIdOverviewRouteRoute
  '/dashboard/jobs/camera-calibration/schedule/$scheduledJobId/schedule': typeof DashboardJobsCameraCalibrationScheduleScheduledJobIdScheduleRouteRoute
  '/dashboard/jobs/capacity-tagging/jobs/$jobId/overview': typeof DashboardJobsCapacityTaggingJobsJobIdOverviewRouteRoute
  '/dashboard/jobs/capacity-tagging/schedule/$scheduledJobId/inputs': typeof DashboardJobsCapacityTaggingScheduleScheduledJobIdInputsRouteRoute
  '/dashboard/jobs/capacity-tagging/schedule/$scheduledJobId/overview': typeof DashboardJobsCapacityTaggingScheduleScheduledJobIdOverviewRouteRoute
  '/dashboard/jobs/capacity-tagging/schedule/$scheduledJobId/schedule': typeof DashboardJobsCapacityTaggingScheduleScheduledJobIdScheduleRouteRoute
  '/dashboard/jobs/catalog-upload/jobs/$jobId/devices': typeof DashboardJobsCatalogUploadJobsJobIdDevicesRouteRoute
  '/dashboard/jobs/catalog-upload/jobs/$jobId/labels': typeof DashboardJobsCatalogUploadJobsJobIdLabelsRouteRoute
  '/dashboard/jobs/catalog-upload/jobs/$jobId/overview': typeof DashboardJobsCatalogUploadJobsJobIdOverviewRouteRoute
  '/dashboard/jobs/catalog-upload/schedule/$scheduledJobId/labels': typeof DashboardJobsCatalogUploadScheduleScheduledJobIdLabelsRouteRoute
  '/dashboard/jobs/catalog-upload/schedule/$scheduledJobId/overview': typeof DashboardJobsCatalogUploadScheduleScheduledJobIdOverviewRouteRoute
  '/dashboard/jobs/catalog-upload/schedule/$scheduledJobId/schedule': typeof DashboardJobsCatalogUploadScheduleScheduledJobIdScheduleRouteRoute
  '/dashboard/jobs/config/jobs/$jobId/devices': typeof DashboardJobsConfigJobsJobIdDevicesRouteRoute
  '/dashboard/jobs/config/jobs/$jobId/overview': typeof DashboardJobsConfigJobsJobIdOverviewRouteRoute
  '/dashboard/jobs/config/schedule/$scheduledJobId/overview': typeof DashboardJobsConfigScheduleScheduledJobIdOverviewRouteRoute
  '/dashboard/jobs/config/schedule/$scheduledJobId/schedule': typeof DashboardJobsConfigScheduleScheduledJobIdScheduleRouteRoute
  '/dashboard/jobs/delete-samples/jobs/$jobId/devices': typeof DashboardJobsDeleteSamplesJobsJobIdDevicesRouteRoute
  '/dashboard/jobs/delete-samples/jobs/$jobId/overview': typeof DashboardJobsDeleteSamplesJobsJobIdOverviewRouteRoute
  '/dashboard/jobs/delete-samples/schedule/$scheduledJobId/inputs': typeof DashboardJobsDeleteSamplesScheduleScheduledJobIdInputsRouteRoute
  '/dashboard/jobs/delete-samples/schedule/$scheduledJobId/overview': typeof DashboardJobsDeleteSamplesScheduleScheduledJobIdOverviewRouteRoute
  '/dashboard/jobs/delete-samples/schedule/$scheduledJobId/schedule': typeof DashboardJobsDeleteSamplesScheduleScheduledJobIdScheduleRouteRoute
  '/dashboard/jobs/delete-videos/jobs/$jobId/devices': typeof DashboardJobsDeleteVideosJobsJobIdDevicesRouteRoute
  '/dashboard/jobs/delete-videos/jobs/$jobId/overview': typeof DashboardJobsDeleteVideosJobsJobIdOverviewRouteRoute
  '/dashboard/jobs/delete-videos/schedule/$scheduledJobId/inputs': typeof DashboardJobsDeleteVideosScheduleScheduledJobIdInputsRouteRoute
  '/dashboard/jobs/delete-videos/schedule/$scheduledJobId/overview': typeof DashboardJobsDeleteVideosScheduleScheduledJobIdOverviewRouteRoute
  '/dashboard/jobs/delete-videos/schedule/$scheduledJobId/schedule': typeof DashboardJobsDeleteVideosScheduleScheduledJobIdScheduleRouteRoute
  '/dashboard/jobs/deployments/jobs/$jobId/devices': typeof DashboardJobsDeploymentsJobsJobIdDevicesRouteRoute
  '/dashboard/jobs/deployments/jobs/$jobId/overview': typeof DashboardJobsDeploymentsJobsJobIdOverviewRouteRoute
  '/dashboard/jobs/deployments/schedule/$scheduledJobId/overview': typeof DashboardJobsDeploymentsScheduleScheduledJobIdOverviewRouteRoute
  '/dashboard/jobs/deployments/schedule/$scheduledJobId/schedule': typeof DashboardJobsDeploymentsScheduleScheduledJobIdScheduleRouteRoute
  '/dashboard/jobs/head-blur-images/jobs/$jobId/devices': typeof DashboardJobsHeadBlurImagesJobsJobIdDevicesRouteRoute
  '/dashboard/jobs/head-blur-images/jobs/$jobId/overview': typeof DashboardJobsHeadBlurImagesJobsJobIdOverviewRouteRoute
  '/dashboard/jobs/head-blur-images/schedule/$scheduledJobId/inputs': typeof DashboardJobsHeadBlurImagesScheduleScheduledJobIdInputsRouteRoute
  '/dashboard/jobs/head-blur-images/schedule/$scheduledJobId/overview': typeof DashboardJobsHeadBlurImagesScheduleScheduledJobIdOverviewRouteRoute
  '/dashboard/jobs/head-blur-images/schedule/$scheduledJobId/schedule': typeof DashboardJobsHeadBlurImagesScheduleScheduledJobIdScheduleRouteRoute
  '/dashboard/jobs/head-blur-videos/jobs/$jobId/devices': typeof DashboardJobsHeadBlurVideosJobsJobIdDevicesRouteRoute
  '/dashboard/jobs/head-blur-videos/jobs/$jobId/overview': typeof DashboardJobsHeadBlurVideosJobsJobIdOverviewRouteRoute
  '/dashboard/jobs/head-blur-videos/schedule/$scheduledJobId/inputs': typeof DashboardJobsHeadBlurVideosScheduleScheduledJobIdInputsRouteRoute
  '/dashboard/jobs/head-blur-videos/schedule/$scheduledJobId/overview': typeof DashboardJobsHeadBlurVideosScheduleScheduledJobIdOverviewRouteRoute
  '/dashboard/jobs/head-blur-videos/schedule/$scheduledJobId/schedule': typeof DashboardJobsHeadBlurVideosScheduleScheduledJobIdScheduleRouteRoute
  '/dashboard/jobs/models/jobs/$jobId/devices': typeof DashboardJobsModelsJobsJobIdDevicesRouteRoute
  '/dashboard/jobs/models/jobs/$jobId/overview': typeof DashboardJobsModelsJobsJobIdOverviewRouteRoute
  '/dashboard/jobs/models/schedule/$scheduledJobId/overview': typeof DashboardJobsModelsScheduleScheduledJobIdOverviewRouteRoute
  '/dashboard/jobs/models/schedule/$scheduledJobId/schedule': typeof DashboardJobsModelsScheduleScheduledJobIdScheduleRouteRoute
  '/dashboard/jobs/recovery-estimates/jobs/$jobId/overview': typeof DashboardJobsRecoveryEstimatesJobsJobIdOverviewRouteRoute
  '/dashboard/jobs/recovery-estimates/schedule/$scheduledJobId/inputs': typeof DashboardJobsRecoveryEstimatesScheduleScheduledJobIdInputsRouteRoute
  '/dashboard/jobs/recovery-estimates/schedule/$scheduledJobId/overview': typeof DashboardJobsRecoveryEstimatesScheduleScheduledJobIdOverviewRouteRoute
  '/dashboard/jobs/recovery-estimates/schedule/$scheduledJobId/schedule': typeof DashboardJobsRecoveryEstimatesScheduleScheduledJobIdScheduleRouteRoute
  '/dashboard/jobs/restarts/jobs/$jobId/devices': typeof DashboardJobsRestartsJobsJobIdDevicesRouteRoute
  '/dashboard/jobs/restarts/jobs/$jobId/overview': typeof DashboardJobsRestartsJobsJobIdOverviewRouteRoute
  '/dashboard/jobs/restarts/schedule/$scheduledJobId/overview': typeof DashboardJobsRestartsScheduleScheduledJobIdOverviewRouteRoute
  '/dashboard/jobs/restarts/schedule/$scheduledJobId/schedule': typeof DashboardJobsRestartsScheduleScheduledJobIdScheduleRouteRoute
  '/dashboard/jobs/sample-upload/jobs/$jobId/devices': typeof DashboardJobsSampleUploadJobsJobIdDevicesRouteRoute
  '/dashboard/jobs/sample-upload/jobs/$jobId/overview': typeof DashboardJobsSampleUploadJobsJobIdOverviewRouteRoute
  '/dashboard/jobs/sample-upload/schedule/$scheduledJobId/inputs': typeof DashboardJobsSampleUploadScheduleScheduledJobIdInputsRouteRoute
  '/dashboard/jobs/sample-upload/schedule/$scheduledJobId/overview': typeof DashboardJobsSampleUploadScheduleScheduledJobIdOverviewRouteRoute
  '/dashboard/jobs/sample-upload/schedule/$scheduledJobId/schedule': typeof DashboardJobsSampleUploadScheduleScheduledJobIdScheduleRouteRoute
  '/dashboard/jobs/sync-samples/jobs/$jobId/devices': typeof DashboardJobsSyncSamplesJobsJobIdDevicesRouteRoute
  '/dashboard/jobs/sync-samples/jobs/$jobId/overview': typeof DashboardJobsSyncSamplesJobsJobIdOverviewRouteRoute
  '/dashboard/jobs/sync-samples/schedule/$scheduledJobId/inputs': typeof DashboardJobsSyncSamplesScheduleScheduledJobIdInputsRouteRoute
  '/dashboard/jobs/sync-samples/schedule/$scheduledJobId/overview': typeof DashboardJobsSyncSamplesScheduleScheduledJobIdOverviewRouteRoute
  '/dashboard/jobs/sync-samples/schedule/$scheduledJobId/schedule': typeof DashboardJobsSyncSamplesScheduleScheduledJobIdScheduleRouteRoute
  '/dashboard/jobs/training/jobs/$jobId/devices': typeof DashboardJobsTrainingJobsJobIdDevicesRouteRoute
  '/dashboard/jobs/training/jobs/$jobId/labels': typeof DashboardJobsTrainingJobsJobIdLabelsRouteRoute
  '/dashboard/jobs/training/jobs/$jobId/metrics': typeof DashboardJobsTrainingJobsJobIdMetricsRouteRoute
  '/dashboard/jobs/training/jobs/$jobId/overview': typeof DashboardJobsTrainingJobsJobIdOverviewRouteRoute
  '/dashboard/jobs/training/schedule/$scheduledJobId/inputs': typeof DashboardJobsTrainingScheduleScheduledJobIdInputsRouteRoute
  '/dashboard/jobs/training/schedule/$scheduledJobId/overview': typeof DashboardJobsTrainingScheduleScheduledJobIdOverviewRouteRoute
  '/dashboard/jobs/training/schedule/$scheduledJobId/schedule': typeof DashboardJobsTrainingScheduleScheduledJobIdScheduleRouteRoute
  '/dashboard/jobs/video-upload/jobs/$jobId/devices': typeof DashboardJobsVideoUploadJobsJobIdDevicesRouteRoute
  '/dashboard/jobs/video-upload/jobs/$jobId/overview': typeof DashboardJobsVideoUploadJobsJobIdOverviewRouteRoute
  '/dashboard/jobs/video-upload/schedule/$scheduledJobId/inputs': typeof DashboardJobsVideoUploadScheduleScheduledJobIdInputsRouteRoute
  '/dashboard/jobs/video-upload/schedule/$scheduledJobId/overview': typeof DashboardJobsVideoUploadScheduleScheduledJobIdOverviewRouteRoute
  '/dashboard/jobs/video-upload/schedule/$scheduledJobId/schedule': typeof DashboardJobsVideoUploadScheduleScheduledJobIdScheduleRouteRoute
  '/dashboard/jobs/worker-jobs/jobs/$jobId/devices': typeof DashboardJobsWorkerJobsJobsJobIdDevicesRouteRoute
  '/dashboard/jobs/worker-jobs/jobs/$jobId/overview': typeof DashboardJobsWorkerJobsJobsJobIdOverviewRouteRoute
  '/dashboard/jobs/worker-jobs/schedule/$scheduledJobId/inputs': typeof DashboardJobsWorkerJobsScheduleScheduledJobIdInputsRouteRoute
  '/dashboard/jobs/worker-jobs/schedule/$scheduledJobId/overview': typeof DashboardJobsWorkerJobsScheduleScheduledJobIdOverviewRouteRoute
  '/dashboard/jobs/worker-jobs/schedule/$scheduledJobId/schedule': typeof DashboardJobsWorkerJobsScheduleScheduledJobIdScheduleRouteRoute
  '/dashboard/resources/devices/$deviceId/data/samples': typeof DashboardResourcesDevicesDeviceIdDataSamplesRouteRouteWithChildren
  '/dashboard/resources/devices/$deviceId/data/sessions': typeof DashboardResourcesDevicesDeviceIdDataSessionsRouteRouteWithChildren
  '/dashboard/resources/devices/$deviceId/data/text-json': typeof DashboardResourcesDevicesDeviceIdDataTextJsonRouteRoute
  '/dashboard/resources/devices/$deviceId/diagnostics/classifier': typeof DashboardResourcesDevicesDeviceIdDiagnosticsClassifierRouteRoute
  '/dashboard/resources/devices/$deviceId/diagnostics/custom': typeof DashboardResourcesDevicesDeviceIdDiagnosticsCustomRouteRoute
  '/dashboard/resources/devices/$deviceId/diagnostics/object-detection': typeof DashboardResourcesDevicesDeviceIdDiagnosticsObjectDetectionRouteRoute
  '/dashboard/resources/devices/$deviceId/version-history/agent': typeof DashboardResourcesDevicesDeviceIdVersionHistoryAgentRouteRoute
  '/dashboard/resources/devices/$deviceId/version-history/detector': typeof DashboardResourcesDevicesDeviceIdVersionHistoryDetectorRouteRoute
  '/dashboard/resources/devices/$deviceId/version-history/models': typeof DashboardResourcesDevicesDeviceIdVersionHistoryModelsRouteRoute
  '/dashboard/resources/devices/$deviceId/version-history/on-screen-app': typeof DashboardResourcesDevicesDeviceIdVersionHistoryOnScreenAppRouteRoute
  '/dashboard/resources/devices/$deviceId/version-history/trainer': typeof DashboardResourcesDevicesDeviceIdVersionHistoryTrainerRouteRoute
  '/dashboard/resources/devices/$deviceId/version-history/zebra-adapter': typeof DashboardResourcesDevicesDeviceIdVersionHistoryZebraAdapterRouteRoute
  '/dashboard/resources/sites/$siteId/version-history/agent': typeof DashboardResourcesSitesSiteIdVersionHistoryAgentRouteRoute
  '/dashboard/resources/sites/$siteId/version-history/detector': typeof DashboardResourcesSitesSiteIdVersionHistoryDetectorRouteRoute
  '/dashboard/resources/sites/$siteId/version-history/on-screen-app': typeof DashboardResourcesSitesSiteIdVersionHistoryOnScreenAppRouteRoute
  '/dashboard/resources/sites/$siteId/version-history/trainer': typeof DashboardResourcesSitesSiteIdVersionHistoryTrainerRouteRoute
  '/dashboard/resources/sites/$siteId/version-history/zebra-adapter': typeof DashboardResourcesSitesSiteIdVersionHistoryZebraAdapterRouteRoute
  '/dashboard/settings/alert-management/alerts/$alertId/overview': typeof DashboardSettingsAlertManagementAlertsAlertIdOverviewRouteRoute
  '/dashboard/settings/queues/$queueName/failures/$index': typeof DashboardSettingsQueuesQueueNameFailuresIndexRouteRoute
  '/dashboard/settings/queues/$queueName/pending/$index': typeof DashboardSettingsQueuesQueueNamePendingIndexRouteRoute
  '/dashboard/settings/report-subscription/$reportId/$subscriptionId/edit': typeof DashboardSettingsReportSubscriptionReportIdSubscriptionIdEditRouteRoute
  '/dashboard/settings/report-subscription/$reportId/$subscriptionId/overview': typeof DashboardSettingsReportSubscriptionReportIdSubscriptionIdOverviewRouteRoute
  '/dashboard/settings/report-subscription/$reportId/$subscriptionId/review-and-approve': typeof DashboardSettingsReportSubscriptionReportIdSubscriptionIdReviewAndApproveRouteRoute
  '/dashboard/settings/report-subscription/$reportId/$subscriptionId/send-history': typeof DashboardSettingsReportSubscriptionReportIdSubscriptionIdSendHistoryRouteRoute
  '/dashboard/settings/tags-management/catalog/$tagId/details': typeof DashboardSettingsTagsManagementCatalogTagIdDetailsRouteRoute
  '/dashboard/settings/tags-management/clusters/$tagId/details': typeof DashboardSettingsTagsManagementClustersTagIdDetailsRouteRoute
  '/dashboard/settings/tags-management/devices/$tagId/details': typeof DashboardSettingsTagsManagementDevicesTagIdDetailsRouteRoute
  '/dashboard/settings/tags-management/samples/$tagId/details': typeof DashboardSettingsTagsManagementSamplesTagIdDetailsRouteRoute
  '/dashboard/settings/tags-management/sessions/$tagId/details': typeof DashboardSettingsTagsManagementSessionsTagIdDetailsRouteRoute
  '/dashboard/settings/tags-management/sites/$tagId/details': typeof DashboardSettingsTagsManagementSitesTagIdDetailsRouteRoute
  '/admin-dashboard/jobs/service-health-checks/jobs/$jobId/': typeof AdminDashboardJobsServiceHealthChecksJobsJobIdIndexRoute
  '/admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId/': typeof AdminDashboardJobsServiceHealthChecksScheduleScheduledJobIdIndexRoute
  '/dashboard/jobs/camera-calibration/jobs/$jobId/': typeof DashboardJobsCameraCalibrationJobsJobIdIndexRoute
  '/dashboard/jobs/camera-calibration/schedule/$scheduledJobId/': typeof DashboardJobsCameraCalibrationScheduleScheduledJobIdIndexRoute
  '/dashboard/jobs/capacity-tagging/jobs/$jobId/': typeof DashboardJobsCapacityTaggingJobsJobIdIndexRoute
  '/dashboard/jobs/capacity-tagging/schedule/$scheduledJobId/': typeof DashboardJobsCapacityTaggingScheduleScheduledJobIdIndexRoute
  '/dashboard/jobs/catalog-upload/jobs/$jobId/': typeof DashboardJobsCatalogUploadJobsJobIdIndexRoute
  '/dashboard/jobs/catalog-upload/schedule/$scheduledJobId/': typeof DashboardJobsCatalogUploadScheduleScheduledJobIdIndexRoute
  '/dashboard/jobs/config/jobs/$jobId/': typeof DashboardJobsConfigJobsJobIdIndexRoute
  '/dashboard/jobs/config/schedule/$scheduledJobId/': typeof DashboardJobsConfigScheduleScheduledJobIdIndexRoute
  '/dashboard/jobs/delete-samples/jobs/$jobId/': typeof DashboardJobsDeleteSamplesJobsJobIdIndexRoute
  '/dashboard/jobs/delete-samples/schedule/$scheduledJobId/': typeof DashboardJobsDeleteSamplesScheduleScheduledJobIdIndexRoute
  '/dashboard/jobs/delete-videos/jobs/$jobId/': typeof DashboardJobsDeleteVideosJobsJobIdIndexRoute
  '/dashboard/jobs/delete-videos/schedule/$scheduledJobId/': typeof DashboardJobsDeleteVideosScheduleScheduledJobIdIndexRoute
  '/dashboard/jobs/deployments/jobs/$jobId/': typeof DashboardJobsDeploymentsJobsJobIdIndexRoute
  '/dashboard/jobs/deployments/schedule/$scheduledJobId/': typeof DashboardJobsDeploymentsScheduleScheduledJobIdIndexRoute
  '/dashboard/jobs/head-blur-images/jobs/$jobId/': typeof DashboardJobsHeadBlurImagesJobsJobIdIndexRoute
  '/dashboard/jobs/head-blur-images/schedule/$scheduledJobId/': typeof DashboardJobsHeadBlurImagesScheduleScheduledJobIdIndexRoute
  '/dashboard/jobs/head-blur-videos/jobs/$jobId/': typeof DashboardJobsHeadBlurVideosJobsJobIdIndexRoute
  '/dashboard/jobs/head-blur-videos/schedule/$scheduledJobId/': typeof DashboardJobsHeadBlurVideosScheduleScheduledJobIdIndexRoute
  '/dashboard/jobs/models/jobs/$jobId/': typeof DashboardJobsModelsJobsJobIdIndexRoute
  '/dashboard/jobs/models/schedule/$scheduledJobId/': typeof DashboardJobsModelsScheduleScheduledJobIdIndexRoute
  '/dashboard/jobs/recovery-estimates/jobs/$jobId/': typeof DashboardJobsRecoveryEstimatesJobsJobIdIndexRoute
  '/dashboard/jobs/recovery-estimates/schedule/$scheduledJobId/': typeof DashboardJobsRecoveryEstimatesScheduleScheduledJobIdIndexRoute
  '/dashboard/jobs/restarts/jobs/$jobId/': typeof DashboardJobsRestartsJobsJobIdIndexRoute
  '/dashboard/jobs/restarts/schedule/$scheduledJobId/': typeof DashboardJobsRestartsScheduleScheduledJobIdIndexRoute
  '/dashboard/jobs/sample-upload/jobs/$jobId/': typeof DashboardJobsSampleUploadJobsJobIdIndexRoute
  '/dashboard/jobs/sample-upload/schedule/$scheduledJobId/': typeof DashboardJobsSampleUploadScheduleScheduledJobIdIndexRoute
  '/dashboard/jobs/sync-samples/jobs/$jobId/': typeof DashboardJobsSyncSamplesJobsJobIdIndexRoute
  '/dashboard/jobs/sync-samples/schedule/$scheduledJobId/': typeof DashboardJobsSyncSamplesScheduleScheduledJobIdIndexRoute
  '/dashboard/jobs/training/jobs/$jobId/': typeof DashboardJobsTrainingJobsJobIdIndexRoute
  '/dashboard/jobs/training/schedule/$scheduledJobId/': typeof DashboardJobsTrainingScheduleScheduledJobIdIndexRoute
  '/dashboard/jobs/video-upload/jobs/$jobId/': typeof DashboardJobsVideoUploadJobsJobIdIndexRoute
  '/dashboard/jobs/video-upload/schedule/$scheduledJobId/': typeof DashboardJobsVideoUploadScheduleScheduledJobIdIndexRoute
  '/dashboard/jobs/worker-jobs/jobs/$jobId/': typeof DashboardJobsWorkerJobsJobsJobIdIndexRoute
  '/dashboard/jobs/worker-jobs/schedule/$scheduledJobId/': typeof DashboardJobsWorkerJobsScheduleScheduledJobIdIndexRoute
  '/dashboard/resources/devices/$deviceId/data/': typeof DashboardResourcesDevicesDeviceIdDataIndexRoute
  '/dashboard/resources/devices/$deviceId/version-history/': typeof DashboardResourcesDevicesDeviceIdVersionHistoryIndexRoute
  '/dashboard/resources/sites/$siteId/version-history/': typeof DashboardResourcesSitesSiteIdVersionHistoryIndexRoute
  '/dashboard/settings/alert-management/alerts/$alertId/': typeof DashboardSettingsAlertManagementAlertsAlertIdIndexRoute
  '/dashboard/settings/alert-management/metric-alerts/$metricAlertId/': typeof DashboardSettingsAlertManagementMetricAlertsMetricAlertIdIndexRoute
  '/dashboard/settings/report-subscription/$reportId/$subscriptionId/': typeof DashboardSettingsReportSubscriptionReportIdSubscriptionIdIndexRoute
  '/dashboard/settings/tags-management/catalog/$tagId/': typeof DashboardSettingsTagsManagementCatalogTagIdIndexRoute
  '/dashboard/settings/tags-management/clusters/$tagId/': typeof DashboardSettingsTagsManagementClustersTagIdIndexRoute
  '/dashboard/settings/tags-management/devices/$tagId/': typeof DashboardSettingsTagsManagementDevicesTagIdIndexRoute
  '/dashboard/settings/tags-management/samples/$tagId/': typeof DashboardSettingsTagsManagementSamplesTagIdIndexRoute
  '/dashboard/settings/tags-management/sessions/$tagId/': typeof DashboardSettingsTagsManagementSessionsTagIdIndexRoute
  '/dashboard/settings/tags-management/sites/$tagId/': typeof DashboardSettingsTagsManagementSitesTagIdIndexRoute
  '/dashboard/resources/devices/$deviceId/data/samples/$sampleId': typeof DashboardResourcesDevicesDeviceIdDataSamplesSampleIdRouteRouteWithChildren
  '/dashboard/resources/devices/$deviceId/data/sessions/$sessionId': typeof DashboardResourcesDevicesDeviceIdDataSessionsSessionIdRouteRouteWithChildren
  '/dashboard/resources/devices/$deviceId/data/samples/$sampleId/': typeof DashboardResourcesDevicesDeviceIdDataSamplesSampleIdIndexRoute
  '/dashboard/resources/devices/$deviceId/data/sessions/$sessionId/': typeof DashboardResourcesDevicesDeviceIdDataSessionsSessionIdIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin-dashboard'
    | '/dashboard'
    | '/unresponsive'
    | '/login'
    | '/admin-dashboard/accounts-management'
    | '/admin-dashboard/domain-auth-settings'
    | '/admin-dashboard/jobs'
    | '/admin-dashboard/notifications'
    | '/dashboard/alerts'
    | '/dashboard/data'
    | '/dashboard/jobs'
    | '/dashboard/models'
    | '/dashboard/reports'
    | '/dashboard/resources'
    | '/dashboard/settings'
    | '/dashboard/unauthorized'
    | '/dashboard/home'
    | '/dashboard/support'
    | '/next/$'
    | '/admin-dashboard/'
    | '/dashboard/'
    | '/admin-dashboard/accounts-management/$accountId'
    | '/admin-dashboard/jobs/service-health-checks'
    | '/admin-dashboard/notifications/$notificationId'
    | '/dashboard/data/annotations'
    | '/dashboard/data/catalog'
    | '/dashboard/data/datasets'
    | '/dashboard/data/images'
    | '/dashboard/data/json-data'
    | '/dashboard/data/label-distribution'
    | '/dashboard/data/pending'
    | '/dashboard/data/sessions'
    | '/dashboard/home/manager-report'
    | '/dashboard/jobs/camera-calibration'
    | '/dashboard/jobs/capacity-tagging'
    | '/dashboard/jobs/catalog-upload'
    | '/dashboard/jobs/config'
    | '/dashboard/jobs/delete-samples'
    | '/dashboard/jobs/delete-videos'
    | '/dashboard/jobs/deployments'
    | '/dashboard/jobs/head-blur-images'
    | '/dashboard/jobs/head-blur-videos'
    | '/dashboard/jobs/models'
    | '/dashboard/jobs/recovery-estimates'
    | '/dashboard/jobs/restarts'
    | '/dashboard/jobs/sample-upload'
    | '/dashboard/jobs/sync-samples'
    | '/dashboard/jobs/training'
    | '/dashboard/jobs/video-upload'
    | '/dashboard/jobs/worker-jobs'
    | '/dashboard/models/$modelId'
    | '/dashboard/reports/$reportId'
    | '/dashboard/reports/analytics-hub'
    | '/dashboard/reports/companion'
    | '/dashboard/resources/clusters'
    | '/dashboard/resources/devices'
    | '/dashboard/resources/site-groups'
    | '/dashboard/resources/sites'
    | '/dashboard/settings/alert-management'
    | '/dashboard/settings/job-defaults'
    | '/dashboard/settings/overview'
    | '/dashboard/settings/permissions-settings'
    | '/dashboard/settings/permissions-settings-dev'
    | '/dashboard/settings/queues'
    | '/dashboard/settings/regions'
    | '/dashboard/settings/report-settings'
    | '/dashboard/settings/tags-management'
    | '/dashboard/settings/user-management'
    | '/dashboard/[/rest]'
    | '/dashboard/data/'
    | '/dashboard/home/'
    | '/dashboard/jobs/'
    | '/dashboard/reports/'
    | '/dashboard/resources/'
    | '/dashboard/settings/'
    | '/admin-dashboard/accounts-management/$accountId/operational-hours'
    | '/admin-dashboard/accounts-management/$accountId/overview'
    | '/admin-dashboard/accounts-management/$accountId/regions'
    | '/admin-dashboard/jobs/service-health-checks/jobs'
    | '/admin-dashboard/jobs/service-health-checks/schedule'
    | '/admin-dashboard/notifications/$notificationId/overview'
    | '/dashboard/data/catalog/$item'
    | '/dashboard/data/datasets/$datasetId'
    | '/dashboard/data/images/$imageUUID'
    | '/dashboard/data/json-data/$jsonDataUUID'
    | '/dashboard/data/label-distribution/$label'
    | '/dashboard/data/sessions/$sessionId'
    | '/dashboard/home/manager-report/$sessionId'
    | '/dashboard/jobs/camera-calibration/alerts'
    | '/dashboard/jobs/camera-calibration/jobs'
    | '/dashboard/jobs/camera-calibration/schedule'
    | '/dashboard/jobs/capacity-tagging/jobs'
    | '/dashboard/jobs/capacity-tagging/schedule'
    | '/dashboard/jobs/catalog-upload/jobs'
    | '/dashboard/jobs/catalog-upload/schedule'
    | '/dashboard/jobs/config/jobs'
    | '/dashboard/jobs/config/schedule'
    | '/dashboard/jobs/delete-samples/alerts'
    | '/dashboard/jobs/delete-samples/jobs'
    | '/dashboard/jobs/delete-samples/schedule'
    | '/dashboard/jobs/delete-videos/alerts'
    | '/dashboard/jobs/delete-videos/jobs'
    | '/dashboard/jobs/delete-videos/schedule'
    | '/dashboard/jobs/deployments/jobs'
    | '/dashboard/jobs/deployments/schedule'
    | '/dashboard/jobs/head-blur-images/jobs'
    | '/dashboard/jobs/head-blur-images/schedule'
    | '/dashboard/jobs/head-blur-videos/jobs'
    | '/dashboard/jobs/head-blur-videos/schedule'
    | '/dashboard/jobs/models/jobs'
    | '/dashboard/jobs/models/schedule'
    | '/dashboard/jobs/recovery-estimates/jobs'
    | '/dashboard/jobs/recovery-estimates/schedule'
    | '/dashboard/jobs/restarts/jobs'
    | '/dashboard/jobs/restarts/schedule'
    | '/dashboard/jobs/sample-upload/alerts'
    | '/dashboard/jobs/sample-upload/jobs'
    | '/dashboard/jobs/sample-upload/schedule'
    | '/dashboard/jobs/sync-samples/alerts'
    | '/dashboard/jobs/sync-samples/jobs'
    | '/dashboard/jobs/sync-samples/schedule'
    | '/dashboard/jobs/training/jobs'
    | '/dashboard/jobs/training/schedule'
    | '/dashboard/jobs/video-upload/alerts'
    | '/dashboard/jobs/video-upload/jobs'
    | '/dashboard/jobs/video-upload/schedule'
    | '/dashboard/jobs/worker-jobs/jobs'
    | '/dashboard/jobs/worker-jobs/schedule'
    | '/dashboard/models/$modelId/deployment'
    | '/dashboard/models/$modelId/labels'
    | '/dashboard/models/$modelId/matrix'
    | '/dashboard/models/$modelId/overview'
    | '/dashboard/resources/clusters/$clusterId'
    | '/dashboard/resources/devices/$deviceId'
    | '/dashboard/resources/site-groups/$siteGroupId'
    | '/dashboard/resources/sites/$siteId'
    | '/dashboard/settings/alert-management/alert-channels'
    | '/dashboard/settings/alert-management/alerts'
    | '/dashboard/settings/alert-management/metric-alerts'
    | '/dashboard/settings/queues/$queueName'
    | '/dashboard/settings/report-settings/$reportId'
    | '/dashboard/settings/tags-management/catalog'
    | '/dashboard/settings/tags-management/clusters'
    | '/dashboard/settings/tags-management/devices'
    | '/dashboard/settings/tags-management/samples'
    | '/dashboard/settings/tags-management/sessions'
    | '/dashboard/settings/tags-management/sites'
    | '/dashboard/settings/user-management/$userId'
    | '/dashboard/data/[/rest]'
    | '/dashboard/resources/[/rest]'
    | '/dashboard/settings/user-management/thumbnail'
    | '/admin-dashboard/accounts-management/$accountId/'
    | '/admin-dashboard/jobs/service-health-checks/'
    | '/dashboard/home/manager-report/'
    | '/dashboard/jobs/camera-calibration/'
    | '/dashboard/jobs/capacity-tagging/'
    | '/dashboard/jobs/catalog-upload/'
    | '/dashboard/jobs/config/'
    | '/dashboard/jobs/delete-samples/'
    | '/dashboard/jobs/delete-videos/'
    | '/dashboard/jobs/deployments/'
    | '/dashboard/jobs/head-blur-images/'
    | '/dashboard/jobs/head-blur-videos/'
    | '/dashboard/jobs/models/'
    | '/dashboard/jobs/recovery-estimates/'
    | '/dashboard/jobs/restarts/'
    | '/dashboard/jobs/sample-upload/'
    | '/dashboard/jobs/sync-samples/'
    | '/dashboard/jobs/training/'
    | '/dashboard/jobs/video-upload/'
    | '/dashboard/jobs/worker-jobs/'
    | '/dashboard/models/$modelId/'
    | '/dashboard/settings/alert-management/'
    | '/dashboard/settings/queues/'
    | '/dashboard/settings/tags-management/'
    | '/admin-dashboard/jobs/service-health-checks/jobs/$jobId'
    | '/admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId'
    | '/dashboard/data/catalog/$item/details'
    | '/dashboard/data/catalog/$item/labels'
    | '/dashboard/data/catalog/$item/prices'
    | '/dashboard/data/datasets/$datasetId/images'
    | '/dashboard/data/datasets/$datasetId/overview'
    | '/dashboard/data/datasets/$datasetId/sessions'
    | '/dashboard/data/images/$imageUUID/additional'
    | '/dashboard/data/images/$imageUUID/overview'
    | '/dashboard/data/images/$imageUUID/transaction-details'
    | '/dashboard/data/sessions/$sessionId/overview'
    | '/dashboard/home/manager-report/$sessionId/overview'
    | '/dashboard/jobs/camera-calibration/jobs/$jobId'
    | '/dashboard/jobs/camera-calibration/schedule/$scheduledJobId'
    | '/dashboard/jobs/capacity-tagging/jobs/$jobId'
    | '/dashboard/jobs/capacity-tagging/schedule/$scheduledJobId'
    | '/dashboard/jobs/catalog-upload/jobs/$jobId'
    | '/dashboard/jobs/catalog-upload/schedule/$scheduledJobId'
    | '/dashboard/jobs/config/jobs/$jobId'
    | '/dashboard/jobs/config/schedule/$scheduledJobId'
    | '/dashboard/jobs/delete-samples/jobs/$jobId'
    | '/dashboard/jobs/delete-samples/schedule/$scheduledJobId'
    | '/dashboard/jobs/delete-videos/jobs/$jobId'
    | '/dashboard/jobs/delete-videos/schedule/$scheduledJobId'
    | '/dashboard/jobs/deployments/jobs/$jobId'
    | '/dashboard/jobs/deployments/schedule/$scheduledJobId'
    | '/dashboard/jobs/head-blur-images/jobs/$jobId'
    | '/dashboard/jobs/head-blur-images/schedule/$scheduledJobId'
    | '/dashboard/jobs/head-blur-videos/jobs/$jobId'
    | '/dashboard/jobs/head-blur-videos/schedule/$scheduledJobId'
    | '/dashboard/jobs/models/jobs/$jobId'
    | '/dashboard/jobs/models/schedule/$scheduledJobId'
    | '/dashboard/jobs/recovery-estimates/jobs/$jobId'
    | '/dashboard/jobs/recovery-estimates/schedule/$scheduledJobId'
    | '/dashboard/jobs/restarts/jobs/$jobId'
    | '/dashboard/jobs/restarts/schedule/$scheduledJobId'
    | '/dashboard/jobs/sample-upload/jobs/$jobId'
    | '/dashboard/jobs/sample-upload/schedule/$scheduledJobId'
    | '/dashboard/jobs/sync-samples/jobs/$jobId'
    | '/dashboard/jobs/sync-samples/schedule/$scheduledJobId'
    | '/dashboard/jobs/training/jobs/$jobId'
    | '/dashboard/jobs/training/schedule/$scheduledJobId'
    | '/dashboard/jobs/video-upload/jobs/$jobId'
    | '/dashboard/jobs/video-upload/schedule/$scheduledJobId'
    | '/dashboard/jobs/worker-jobs/jobs/$jobId'
    | '/dashboard/jobs/worker-jobs/schedule/$scheduledJobId'
    | '/dashboard/models/$modelId/deployment/clusters'
    | '/dashboard/models/$modelId/deployment/devices'
    | '/dashboard/resources/clusters/$clusterId/devices'
    | '/dashboard/resources/clusters/$clusterId/overview'
    | '/dashboard/resources/devices/$deviceId/camera'
    | '/dashboard/resources/devices/$deviceId/data'
    | '/dashboard/resources/devices/$deviceId/diagnostics'
    | '/dashboard/resources/devices/$deviceId/logs'
    | '/dashboard/resources/devices/$deviceId/overview'
    | '/dashboard/resources/devices/$deviceId/settings'
    | '/dashboard/resources/devices/$deviceId/version-history'
    | '/dashboard/resources/site-groups/$siteGroupId/labels'
    | '/dashboard/resources/site-groups/$siteGroupId/overview'
    | '/dashboard/resources/site-groups/$siteGroupId/sites'
    | '/dashboard/resources/sites/$siteId/devices'
    | '/dashboard/resources/sites/$siteId/overview'
    | '/dashboard/resources/sites/$siteId/version-history'
    | '/dashboard/settings/alert-management/alerts/$alertId'
    | '/dashboard/settings/queues/$queueName/failures'
    | '/dashboard/settings/queues/$queueName/pending'
    | '/dashboard/settings/report-settings/$reportId/overview'
    | '/dashboard/settings/report-settings/$reportId/parameters'
    | '/dashboard/settings/report-settings/$reportId/send-log'
    | '/dashboard/settings/report-settings/$reportId/subscriptions2'
    | '/dashboard/settings/report-subscription/$reportId/$subscriptionId'
    | '/dashboard/settings/tags-management/catalog/$tagId'
    | '/dashboard/settings/tags-management/clusters/$tagId'
    | '/dashboard/settings/tags-management/devices/$tagId'
    | '/dashboard/settings/tags-management/samples/$tagId'
    | '/dashboard/settings/tags-management/sessions/$tagId'
    | '/dashboard/settings/tags-management/sites/$tagId'
    | '/dashboard/settings/user-management/$userId/overview'
    | '/dashboard/data/json-data/$jsonDataUUID/overview'
    | '/dashboard/data/catalog/$item/'
    | '/dashboard/data/images/$imageUUID/'
    | '/dashboard/data/json-data/$jsonDataUUID/'
    | '/dashboard/data/label-distribution/$label/'
    | '/dashboard/data/sessions/$sessionId/'
    | '/dashboard/home/manager-report/$sessionId/'
    | '/dashboard/models/$modelId/deployment/'
    | '/dashboard/resources/clusters/$clusterId/'
    | '/dashboard/resources/devices/$deviceId/'
    | '/dashboard/resources/site-groups/$siteGroupId/'
    | '/dashboard/resources/sites/$siteId/'
    | '/dashboard/settings/queues/$queueName/'
    | '/dashboard/settings/report-settings/$reportId/'
    | '/dashboard/settings/user-management/$userId/'
    | '/admin-dashboard/jobs/service-health-checks/jobs/$jobId/overview'
    | '/admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId/inputs'
    | '/admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId/overview'
    | '/admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId/schedule'
    | '/dashboard/jobs/camera-calibration/jobs/$jobId/devices'
    | '/dashboard/jobs/camera-calibration/jobs/$jobId/overview'
    | '/dashboard/jobs/camera-calibration/schedule/$scheduledJobId/inputs'
    | '/dashboard/jobs/camera-calibration/schedule/$scheduledJobId/overview'
    | '/dashboard/jobs/camera-calibration/schedule/$scheduledJobId/schedule'
    | '/dashboard/jobs/capacity-tagging/jobs/$jobId/overview'
    | '/dashboard/jobs/capacity-tagging/schedule/$scheduledJobId/inputs'
    | '/dashboard/jobs/capacity-tagging/schedule/$scheduledJobId/overview'
    | '/dashboard/jobs/capacity-tagging/schedule/$scheduledJobId/schedule'
    | '/dashboard/jobs/catalog-upload/jobs/$jobId/devices'
    | '/dashboard/jobs/catalog-upload/jobs/$jobId/labels'
    | '/dashboard/jobs/catalog-upload/jobs/$jobId/overview'
    | '/dashboard/jobs/catalog-upload/schedule/$scheduledJobId/labels'
    | '/dashboard/jobs/catalog-upload/schedule/$scheduledJobId/overview'
    | '/dashboard/jobs/catalog-upload/schedule/$scheduledJobId/schedule'
    | '/dashboard/jobs/config/jobs/$jobId/devices'
    | '/dashboard/jobs/config/jobs/$jobId/overview'
    | '/dashboard/jobs/config/schedule/$scheduledJobId/overview'
    | '/dashboard/jobs/config/schedule/$scheduledJobId/schedule'
    | '/dashboard/jobs/delete-samples/jobs/$jobId/devices'
    | '/dashboard/jobs/delete-samples/jobs/$jobId/overview'
    | '/dashboard/jobs/delete-samples/schedule/$scheduledJobId/inputs'
    | '/dashboard/jobs/delete-samples/schedule/$scheduledJobId/overview'
    | '/dashboard/jobs/delete-samples/schedule/$scheduledJobId/schedule'
    | '/dashboard/jobs/delete-videos/jobs/$jobId/devices'
    | '/dashboard/jobs/delete-videos/jobs/$jobId/overview'
    | '/dashboard/jobs/delete-videos/schedule/$scheduledJobId/inputs'
    | '/dashboard/jobs/delete-videos/schedule/$scheduledJobId/overview'
    | '/dashboard/jobs/delete-videos/schedule/$scheduledJobId/schedule'
    | '/dashboard/jobs/deployments/jobs/$jobId/devices'
    | '/dashboard/jobs/deployments/jobs/$jobId/overview'
    | '/dashboard/jobs/deployments/schedule/$scheduledJobId/overview'
    | '/dashboard/jobs/deployments/schedule/$scheduledJobId/schedule'
    | '/dashboard/jobs/head-blur-images/jobs/$jobId/devices'
    | '/dashboard/jobs/head-blur-images/jobs/$jobId/overview'
    | '/dashboard/jobs/head-blur-images/schedule/$scheduledJobId/inputs'
    | '/dashboard/jobs/head-blur-images/schedule/$scheduledJobId/overview'
    | '/dashboard/jobs/head-blur-images/schedule/$scheduledJobId/schedule'
    | '/dashboard/jobs/head-blur-videos/jobs/$jobId/devices'
    | '/dashboard/jobs/head-blur-videos/jobs/$jobId/overview'
    | '/dashboard/jobs/head-blur-videos/schedule/$scheduledJobId/inputs'
    | '/dashboard/jobs/head-blur-videos/schedule/$scheduledJobId/overview'
    | '/dashboard/jobs/head-blur-videos/schedule/$scheduledJobId/schedule'
    | '/dashboard/jobs/models/jobs/$jobId/devices'
    | '/dashboard/jobs/models/jobs/$jobId/overview'
    | '/dashboard/jobs/models/schedule/$scheduledJobId/overview'
    | '/dashboard/jobs/models/schedule/$scheduledJobId/schedule'
    | '/dashboard/jobs/recovery-estimates/jobs/$jobId/overview'
    | '/dashboard/jobs/recovery-estimates/schedule/$scheduledJobId/inputs'
    | '/dashboard/jobs/recovery-estimates/schedule/$scheduledJobId/overview'
    | '/dashboard/jobs/recovery-estimates/schedule/$scheduledJobId/schedule'
    | '/dashboard/jobs/restarts/jobs/$jobId/devices'
    | '/dashboard/jobs/restarts/jobs/$jobId/overview'
    | '/dashboard/jobs/restarts/schedule/$scheduledJobId/overview'
    | '/dashboard/jobs/restarts/schedule/$scheduledJobId/schedule'
    | '/dashboard/jobs/sample-upload/jobs/$jobId/devices'
    | '/dashboard/jobs/sample-upload/jobs/$jobId/overview'
    | '/dashboard/jobs/sample-upload/schedule/$scheduledJobId/inputs'
    | '/dashboard/jobs/sample-upload/schedule/$scheduledJobId/overview'
    | '/dashboard/jobs/sample-upload/schedule/$scheduledJobId/schedule'
    | '/dashboard/jobs/sync-samples/jobs/$jobId/devices'
    | '/dashboard/jobs/sync-samples/jobs/$jobId/overview'
    | '/dashboard/jobs/sync-samples/schedule/$scheduledJobId/inputs'
    | '/dashboard/jobs/sync-samples/schedule/$scheduledJobId/overview'
    | '/dashboard/jobs/sync-samples/schedule/$scheduledJobId/schedule'
    | '/dashboard/jobs/training/jobs/$jobId/devices'
    | '/dashboard/jobs/training/jobs/$jobId/labels'
    | '/dashboard/jobs/training/jobs/$jobId/metrics'
    | '/dashboard/jobs/training/jobs/$jobId/overview'
    | '/dashboard/jobs/training/schedule/$scheduledJobId/inputs'
    | '/dashboard/jobs/training/schedule/$scheduledJobId/overview'
    | '/dashboard/jobs/training/schedule/$scheduledJobId/schedule'
    | '/dashboard/jobs/video-upload/jobs/$jobId/devices'
    | '/dashboard/jobs/video-upload/jobs/$jobId/overview'
    | '/dashboard/jobs/video-upload/schedule/$scheduledJobId/inputs'
    | '/dashboard/jobs/video-upload/schedule/$scheduledJobId/overview'
    | '/dashboard/jobs/video-upload/schedule/$scheduledJobId/schedule'
    | '/dashboard/jobs/worker-jobs/jobs/$jobId/devices'
    | '/dashboard/jobs/worker-jobs/jobs/$jobId/overview'
    | '/dashboard/jobs/worker-jobs/schedule/$scheduledJobId/inputs'
    | '/dashboard/jobs/worker-jobs/schedule/$scheduledJobId/overview'
    | '/dashboard/jobs/worker-jobs/schedule/$scheduledJobId/schedule'
    | '/dashboard/resources/devices/$deviceId/data/samples'
    | '/dashboard/resources/devices/$deviceId/data/sessions'
    | '/dashboard/resources/devices/$deviceId/data/text-json'
    | '/dashboard/resources/devices/$deviceId/diagnostics/classifier'
    | '/dashboard/resources/devices/$deviceId/diagnostics/custom'
    | '/dashboard/resources/devices/$deviceId/diagnostics/object-detection'
    | '/dashboard/resources/devices/$deviceId/version-history/agent'
    | '/dashboard/resources/devices/$deviceId/version-history/detector'
    | '/dashboard/resources/devices/$deviceId/version-history/models'
    | '/dashboard/resources/devices/$deviceId/version-history/on-screen-app'
    | '/dashboard/resources/devices/$deviceId/version-history/trainer'
    | '/dashboard/resources/devices/$deviceId/version-history/zebra-adapter'
    | '/dashboard/resources/sites/$siteId/version-history/agent'
    | '/dashboard/resources/sites/$siteId/version-history/detector'
    | '/dashboard/resources/sites/$siteId/version-history/on-screen-app'
    | '/dashboard/resources/sites/$siteId/version-history/trainer'
    | '/dashboard/resources/sites/$siteId/version-history/zebra-adapter'
    | '/dashboard/settings/alert-management/alerts/$alertId/overview'
    | '/dashboard/settings/queues/$queueName/failures/$index'
    | '/dashboard/settings/queues/$queueName/pending/$index'
    | '/dashboard/settings/report-subscription/$reportId/$subscriptionId/edit'
    | '/dashboard/settings/report-subscription/$reportId/$subscriptionId/overview'
    | '/dashboard/settings/report-subscription/$reportId/$subscriptionId/review-and-approve'
    | '/dashboard/settings/report-subscription/$reportId/$subscriptionId/send-history'
    | '/dashboard/settings/tags-management/catalog/$tagId/details'
    | '/dashboard/settings/tags-management/clusters/$tagId/details'
    | '/dashboard/settings/tags-management/devices/$tagId/details'
    | '/dashboard/settings/tags-management/samples/$tagId/details'
    | '/dashboard/settings/tags-management/sessions/$tagId/details'
    | '/dashboard/settings/tags-management/sites/$tagId/details'
    | '/admin-dashboard/jobs/service-health-checks/jobs/$jobId/'
    | '/admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId/'
    | '/dashboard/jobs/camera-calibration/jobs/$jobId/'
    | '/dashboard/jobs/camera-calibration/schedule/$scheduledJobId/'
    | '/dashboard/jobs/capacity-tagging/jobs/$jobId/'
    | '/dashboard/jobs/capacity-tagging/schedule/$scheduledJobId/'
    | '/dashboard/jobs/catalog-upload/jobs/$jobId/'
    | '/dashboard/jobs/catalog-upload/schedule/$scheduledJobId/'
    | '/dashboard/jobs/config/jobs/$jobId/'
    | '/dashboard/jobs/config/schedule/$scheduledJobId/'
    | '/dashboard/jobs/delete-samples/jobs/$jobId/'
    | '/dashboard/jobs/delete-samples/schedule/$scheduledJobId/'
    | '/dashboard/jobs/delete-videos/jobs/$jobId/'
    | '/dashboard/jobs/delete-videos/schedule/$scheduledJobId/'
    | '/dashboard/jobs/deployments/jobs/$jobId/'
    | '/dashboard/jobs/deployments/schedule/$scheduledJobId/'
    | '/dashboard/jobs/head-blur-images/jobs/$jobId/'
    | '/dashboard/jobs/head-blur-images/schedule/$scheduledJobId/'
    | '/dashboard/jobs/head-blur-videos/jobs/$jobId/'
    | '/dashboard/jobs/head-blur-videos/schedule/$scheduledJobId/'
    | '/dashboard/jobs/models/jobs/$jobId/'
    | '/dashboard/jobs/models/schedule/$scheduledJobId/'
    | '/dashboard/jobs/recovery-estimates/jobs/$jobId/'
    | '/dashboard/jobs/recovery-estimates/schedule/$scheduledJobId/'
    | '/dashboard/jobs/restarts/jobs/$jobId/'
    | '/dashboard/jobs/restarts/schedule/$scheduledJobId/'
    | '/dashboard/jobs/sample-upload/jobs/$jobId/'
    | '/dashboard/jobs/sample-upload/schedule/$scheduledJobId/'
    | '/dashboard/jobs/sync-samples/jobs/$jobId/'
    | '/dashboard/jobs/sync-samples/schedule/$scheduledJobId/'
    | '/dashboard/jobs/training/jobs/$jobId/'
    | '/dashboard/jobs/training/schedule/$scheduledJobId/'
    | '/dashboard/jobs/video-upload/jobs/$jobId/'
    | '/dashboard/jobs/video-upload/schedule/$scheduledJobId/'
    | '/dashboard/jobs/worker-jobs/jobs/$jobId/'
    | '/dashboard/jobs/worker-jobs/schedule/$scheduledJobId/'
    | '/dashboard/resources/devices/$deviceId/data/'
    | '/dashboard/resources/devices/$deviceId/version-history/'
    | '/dashboard/resources/sites/$siteId/version-history/'
    | '/dashboard/settings/alert-management/alerts/$alertId/'
    | '/dashboard/settings/alert-management/metric-alerts/$metricAlertId'
    | '/dashboard/settings/report-subscription/$reportId/$subscriptionId/'
    | '/dashboard/settings/tags-management/catalog/$tagId/'
    | '/dashboard/settings/tags-management/clusters/$tagId/'
    | '/dashboard/settings/tags-management/devices/$tagId/'
    | '/dashboard/settings/tags-management/samples/$tagId/'
    | '/dashboard/settings/tags-management/sessions/$tagId/'
    | '/dashboard/settings/tags-management/sites/$tagId/'
    | '/dashboard/resources/devices/$deviceId/data/samples/$sampleId'
    | '/dashboard/resources/devices/$deviceId/data/sessions/$sessionId'
    | '/dashboard/resources/devices/$deviceId/data/samples/$sampleId/'
    | '/dashboard/resources/devices/$deviceId/data/sessions/$sessionId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/unresponsive'
    | '/login'
    | '/admin-dashboard/accounts-management'
    | '/admin-dashboard/domain-auth-settings'
    | '/admin-dashboard/jobs'
    | '/admin-dashboard/notifications'
    | '/dashboard/alerts'
    | '/dashboard/models'
    | '/dashboard/unauthorized'
    | '/dashboard/support'
    | '/next/$'
    | '/admin-dashboard'
    | '/dashboard'
    | '/admin-dashboard/notifications/$notificationId'
    | '/dashboard/data/annotations'
    | '/dashboard/data/catalog'
    | '/dashboard/data/datasets'
    | '/dashboard/data/images'
    | '/dashboard/data/json-data'
    | '/dashboard/data/label-distribution'
    | '/dashboard/data/pending'
    | '/dashboard/data/sessions'
    | '/dashboard/reports/$reportId'
    | '/dashboard/reports/analytics-hub'
    | '/dashboard/reports/companion'
    | '/dashboard/resources/clusters'
    | '/dashboard/resources/devices'
    | '/dashboard/resources/site-groups'
    | '/dashboard/resources/sites'
    | '/dashboard/settings/job-defaults'
    | '/dashboard/settings/overview'
    | '/dashboard/settings/permissions-settings'
    | '/dashboard/settings/permissions-settings-dev'
    | '/dashboard/settings/regions'
    | '/dashboard/settings/report-settings'
    | '/dashboard/settings/user-management'
    | '/dashboard/[/rest]'
    | '/dashboard/data'
    | '/dashboard/home'
    | '/dashboard/jobs'
    | '/dashboard/reports'
    | '/dashboard/resources'
    | '/dashboard/settings'
    | '/admin-dashboard/accounts-management/$accountId/operational-hours'
    | '/admin-dashboard/accounts-management/$accountId/overview'
    | '/admin-dashboard/accounts-management/$accountId/regions'
    | '/admin-dashboard/jobs/service-health-checks/jobs'
    | '/admin-dashboard/jobs/service-health-checks/schedule'
    | '/admin-dashboard/notifications/$notificationId/overview'
    | '/dashboard/data/datasets/$datasetId'
    | '/dashboard/jobs/camera-calibration/alerts'
    | '/dashboard/jobs/camera-calibration/jobs'
    | '/dashboard/jobs/camera-calibration/schedule'
    | '/dashboard/jobs/capacity-tagging/jobs'
    | '/dashboard/jobs/capacity-tagging/schedule'
    | '/dashboard/jobs/catalog-upload/jobs'
    | '/dashboard/jobs/catalog-upload/schedule'
    | '/dashboard/jobs/config/jobs'
    | '/dashboard/jobs/config/schedule'
    | '/dashboard/jobs/delete-samples/alerts'
    | '/dashboard/jobs/delete-samples/jobs'
    | '/dashboard/jobs/delete-samples/schedule'
    | '/dashboard/jobs/delete-videos/alerts'
    | '/dashboard/jobs/delete-videos/jobs'
    | '/dashboard/jobs/delete-videos/schedule'
    | '/dashboard/jobs/deployments/jobs'
    | '/dashboard/jobs/deployments/schedule'
    | '/dashboard/jobs/head-blur-images/jobs'
    | '/dashboard/jobs/head-blur-images/schedule'
    | '/dashboard/jobs/head-blur-videos/jobs'
    | '/dashboard/jobs/head-blur-videos/schedule'
    | '/dashboard/jobs/models/jobs'
    | '/dashboard/jobs/models/schedule'
    | '/dashboard/jobs/recovery-estimates/jobs'
    | '/dashboard/jobs/recovery-estimates/schedule'
    | '/dashboard/jobs/restarts/jobs'
    | '/dashboard/jobs/restarts/schedule'
    | '/dashboard/jobs/sample-upload/alerts'
    | '/dashboard/jobs/sample-upload/jobs'
    | '/dashboard/jobs/sample-upload/schedule'
    | '/dashboard/jobs/sync-samples/alerts'
    | '/dashboard/jobs/sync-samples/jobs'
    | '/dashboard/jobs/sync-samples/schedule'
    | '/dashboard/jobs/training/jobs'
    | '/dashboard/jobs/training/schedule'
    | '/dashboard/jobs/video-upload/alerts'
    | '/dashboard/jobs/video-upload/jobs'
    | '/dashboard/jobs/video-upload/schedule'
    | '/dashboard/jobs/worker-jobs/jobs'
    | '/dashboard/jobs/worker-jobs/schedule'
    | '/dashboard/models/$modelId/labels'
    | '/dashboard/models/$modelId/matrix'
    | '/dashboard/models/$modelId/overview'
    | '/dashboard/settings/alert-management/alert-channels'
    | '/dashboard/settings/alert-management/alerts'
    | '/dashboard/settings/alert-management/metric-alerts'
    | '/dashboard/settings/tags-management/catalog'
    | '/dashboard/settings/tags-management/clusters'
    | '/dashboard/settings/tags-management/devices'
    | '/dashboard/settings/tags-management/samples'
    | '/dashboard/settings/tags-management/sessions'
    | '/dashboard/settings/tags-management/sites'
    | '/dashboard/data/[/rest]'
    | '/dashboard/resources/[/rest]'
    | '/dashboard/settings/user-management/thumbnail'
    | '/admin-dashboard/accounts-management/$accountId'
    | '/admin-dashboard/jobs/service-health-checks'
    | '/dashboard/home/manager-report'
    | '/dashboard/jobs/camera-calibration'
    | '/dashboard/jobs/capacity-tagging'
    | '/dashboard/jobs/catalog-upload'
    | '/dashboard/jobs/config'
    | '/dashboard/jobs/delete-samples'
    | '/dashboard/jobs/delete-videos'
    | '/dashboard/jobs/deployments'
    | '/dashboard/jobs/head-blur-images'
    | '/dashboard/jobs/head-blur-videos'
    | '/dashboard/jobs/models'
    | '/dashboard/jobs/recovery-estimates'
    | '/dashboard/jobs/restarts'
    | '/dashboard/jobs/sample-upload'
    | '/dashboard/jobs/sync-samples'
    | '/dashboard/jobs/training'
    | '/dashboard/jobs/video-upload'
    | '/dashboard/jobs/worker-jobs'
    | '/dashboard/models/$modelId'
    | '/dashboard/settings/alert-management'
    | '/dashboard/settings/queues'
    | '/dashboard/settings/tags-management'
    | '/dashboard/data/catalog/$item/details'
    | '/dashboard/data/catalog/$item/labels'
    | '/dashboard/data/catalog/$item/prices'
    | '/dashboard/data/datasets/$datasetId/images'
    | '/dashboard/data/datasets/$datasetId/overview'
    | '/dashboard/data/datasets/$datasetId/sessions'
    | '/dashboard/data/images/$imageUUID/additional'
    | '/dashboard/data/images/$imageUUID/overview'
    | '/dashboard/data/images/$imageUUID/transaction-details'
    | '/dashboard/data/sessions/$sessionId/overview'
    | '/dashboard/home/manager-report/$sessionId/overview'
    | '/dashboard/models/$modelId/deployment/clusters'
    | '/dashboard/models/$modelId/deployment/devices'
    | '/dashboard/resources/clusters/$clusterId/devices'
    | '/dashboard/resources/clusters/$clusterId/overview'
    | '/dashboard/resources/devices/$deviceId/camera'
    | '/dashboard/resources/devices/$deviceId/diagnostics'
    | '/dashboard/resources/devices/$deviceId/logs'
    | '/dashboard/resources/devices/$deviceId/overview'
    | '/dashboard/resources/devices/$deviceId/settings'
    | '/dashboard/resources/site-groups/$siteGroupId/labels'
    | '/dashboard/resources/site-groups/$siteGroupId/overview'
    | '/dashboard/resources/site-groups/$siteGroupId/sites'
    | '/dashboard/resources/sites/$siteId/devices'
    | '/dashboard/resources/sites/$siteId/overview'
    | '/dashboard/settings/queues/$queueName/failures'
    | '/dashboard/settings/queues/$queueName/pending'
    | '/dashboard/settings/report-settings/$reportId/overview'
    | '/dashboard/settings/report-settings/$reportId/parameters'
    | '/dashboard/settings/report-settings/$reportId/send-log'
    | '/dashboard/settings/report-settings/$reportId/subscriptions2'
    | '/dashboard/settings/user-management/$userId/overview'
    | '/dashboard/data/json-data/$jsonDataUUID/overview'
    | '/dashboard/data/catalog/$item'
    | '/dashboard/data/images/$imageUUID'
    | '/dashboard/data/json-data/$jsonDataUUID'
    | '/dashboard/data/label-distribution/$label'
    | '/dashboard/data/sessions/$sessionId'
    | '/dashboard/home/manager-report/$sessionId'
    | '/dashboard/models/$modelId/deployment'
    | '/dashboard/resources/clusters/$clusterId'
    | '/dashboard/resources/devices/$deviceId'
    | '/dashboard/resources/site-groups/$siteGroupId'
    | '/dashboard/resources/sites/$siteId'
    | '/dashboard/settings/queues/$queueName'
    | '/dashboard/settings/report-settings/$reportId'
    | '/dashboard/settings/user-management/$userId'
    | '/admin-dashboard/jobs/service-health-checks/jobs/$jobId/overview'
    | '/admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId/inputs'
    | '/admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId/overview'
    | '/admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId/schedule'
    | '/dashboard/jobs/camera-calibration/jobs/$jobId/devices'
    | '/dashboard/jobs/camera-calibration/jobs/$jobId/overview'
    | '/dashboard/jobs/camera-calibration/schedule/$scheduledJobId/inputs'
    | '/dashboard/jobs/camera-calibration/schedule/$scheduledJobId/overview'
    | '/dashboard/jobs/camera-calibration/schedule/$scheduledJobId/schedule'
    | '/dashboard/jobs/capacity-tagging/jobs/$jobId/overview'
    | '/dashboard/jobs/capacity-tagging/schedule/$scheduledJobId/inputs'
    | '/dashboard/jobs/capacity-tagging/schedule/$scheduledJobId/overview'
    | '/dashboard/jobs/capacity-tagging/schedule/$scheduledJobId/schedule'
    | '/dashboard/jobs/catalog-upload/jobs/$jobId/devices'
    | '/dashboard/jobs/catalog-upload/jobs/$jobId/labels'
    | '/dashboard/jobs/catalog-upload/jobs/$jobId/overview'
    | '/dashboard/jobs/catalog-upload/schedule/$scheduledJobId/labels'
    | '/dashboard/jobs/catalog-upload/schedule/$scheduledJobId/overview'
    | '/dashboard/jobs/catalog-upload/schedule/$scheduledJobId/schedule'
    | '/dashboard/jobs/config/jobs/$jobId/devices'
    | '/dashboard/jobs/config/jobs/$jobId/overview'
    | '/dashboard/jobs/config/schedule/$scheduledJobId/overview'
    | '/dashboard/jobs/config/schedule/$scheduledJobId/schedule'
    | '/dashboard/jobs/delete-samples/jobs/$jobId/devices'
    | '/dashboard/jobs/delete-samples/jobs/$jobId/overview'
    | '/dashboard/jobs/delete-samples/schedule/$scheduledJobId/inputs'
    | '/dashboard/jobs/delete-samples/schedule/$scheduledJobId/overview'
    | '/dashboard/jobs/delete-samples/schedule/$scheduledJobId/schedule'
    | '/dashboard/jobs/delete-videos/jobs/$jobId/devices'
    | '/dashboard/jobs/delete-videos/jobs/$jobId/overview'
    | '/dashboard/jobs/delete-videos/schedule/$scheduledJobId/inputs'
    | '/dashboard/jobs/delete-videos/schedule/$scheduledJobId/overview'
    | '/dashboard/jobs/delete-videos/schedule/$scheduledJobId/schedule'
    | '/dashboard/jobs/deployments/jobs/$jobId/devices'
    | '/dashboard/jobs/deployments/jobs/$jobId/overview'
    | '/dashboard/jobs/deployments/schedule/$scheduledJobId/overview'
    | '/dashboard/jobs/deployments/schedule/$scheduledJobId/schedule'
    | '/dashboard/jobs/head-blur-images/jobs/$jobId/devices'
    | '/dashboard/jobs/head-blur-images/jobs/$jobId/overview'
    | '/dashboard/jobs/head-blur-images/schedule/$scheduledJobId/inputs'
    | '/dashboard/jobs/head-blur-images/schedule/$scheduledJobId/overview'
    | '/dashboard/jobs/head-blur-images/schedule/$scheduledJobId/schedule'
    | '/dashboard/jobs/head-blur-videos/jobs/$jobId/devices'
    | '/dashboard/jobs/head-blur-videos/jobs/$jobId/overview'
    | '/dashboard/jobs/head-blur-videos/schedule/$scheduledJobId/inputs'
    | '/dashboard/jobs/head-blur-videos/schedule/$scheduledJobId/overview'
    | '/dashboard/jobs/head-blur-videos/schedule/$scheduledJobId/schedule'
    | '/dashboard/jobs/models/jobs/$jobId/devices'
    | '/dashboard/jobs/models/jobs/$jobId/overview'
    | '/dashboard/jobs/models/schedule/$scheduledJobId/overview'
    | '/dashboard/jobs/models/schedule/$scheduledJobId/schedule'
    | '/dashboard/jobs/recovery-estimates/jobs/$jobId/overview'
    | '/dashboard/jobs/recovery-estimates/schedule/$scheduledJobId/inputs'
    | '/dashboard/jobs/recovery-estimates/schedule/$scheduledJobId/overview'
    | '/dashboard/jobs/recovery-estimates/schedule/$scheduledJobId/schedule'
    | '/dashboard/jobs/restarts/jobs/$jobId/devices'
    | '/dashboard/jobs/restarts/jobs/$jobId/overview'
    | '/dashboard/jobs/restarts/schedule/$scheduledJobId/overview'
    | '/dashboard/jobs/restarts/schedule/$scheduledJobId/schedule'
    | '/dashboard/jobs/sample-upload/jobs/$jobId/devices'
    | '/dashboard/jobs/sample-upload/jobs/$jobId/overview'
    | '/dashboard/jobs/sample-upload/schedule/$scheduledJobId/inputs'
    | '/dashboard/jobs/sample-upload/schedule/$scheduledJobId/overview'
    | '/dashboard/jobs/sample-upload/schedule/$scheduledJobId/schedule'
    | '/dashboard/jobs/sync-samples/jobs/$jobId/devices'
    | '/dashboard/jobs/sync-samples/jobs/$jobId/overview'
    | '/dashboard/jobs/sync-samples/schedule/$scheduledJobId/inputs'
    | '/dashboard/jobs/sync-samples/schedule/$scheduledJobId/overview'
    | '/dashboard/jobs/sync-samples/schedule/$scheduledJobId/schedule'
    | '/dashboard/jobs/training/jobs/$jobId/devices'
    | '/dashboard/jobs/training/jobs/$jobId/labels'
    | '/dashboard/jobs/training/jobs/$jobId/metrics'
    | '/dashboard/jobs/training/jobs/$jobId/overview'
    | '/dashboard/jobs/training/schedule/$scheduledJobId/inputs'
    | '/dashboard/jobs/training/schedule/$scheduledJobId/overview'
    | '/dashboard/jobs/training/schedule/$scheduledJobId/schedule'
    | '/dashboard/jobs/video-upload/jobs/$jobId/devices'
    | '/dashboard/jobs/video-upload/jobs/$jobId/overview'
    | '/dashboard/jobs/video-upload/schedule/$scheduledJobId/inputs'
    | '/dashboard/jobs/video-upload/schedule/$scheduledJobId/overview'
    | '/dashboard/jobs/video-upload/schedule/$scheduledJobId/schedule'
    | '/dashboard/jobs/worker-jobs/jobs/$jobId/devices'
    | '/dashboard/jobs/worker-jobs/jobs/$jobId/overview'
    | '/dashboard/jobs/worker-jobs/schedule/$scheduledJobId/inputs'
    | '/dashboard/jobs/worker-jobs/schedule/$scheduledJobId/overview'
    | '/dashboard/jobs/worker-jobs/schedule/$scheduledJobId/schedule'
    | '/dashboard/resources/devices/$deviceId/data/samples'
    | '/dashboard/resources/devices/$deviceId/data/sessions'
    | '/dashboard/resources/devices/$deviceId/data/text-json'
    | '/dashboard/resources/devices/$deviceId/diagnostics/classifier'
    | '/dashboard/resources/devices/$deviceId/diagnostics/custom'
    | '/dashboard/resources/devices/$deviceId/diagnostics/object-detection'
    | '/dashboard/resources/devices/$deviceId/version-history/agent'
    | '/dashboard/resources/devices/$deviceId/version-history/detector'
    | '/dashboard/resources/devices/$deviceId/version-history/models'
    | '/dashboard/resources/devices/$deviceId/version-history/on-screen-app'
    | '/dashboard/resources/devices/$deviceId/version-history/trainer'
    | '/dashboard/resources/devices/$deviceId/version-history/zebra-adapter'
    | '/dashboard/resources/sites/$siteId/version-history/agent'
    | '/dashboard/resources/sites/$siteId/version-history/detector'
    | '/dashboard/resources/sites/$siteId/version-history/on-screen-app'
    | '/dashboard/resources/sites/$siteId/version-history/trainer'
    | '/dashboard/resources/sites/$siteId/version-history/zebra-adapter'
    | '/dashboard/settings/alert-management/alerts/$alertId/overview'
    | '/dashboard/settings/queues/$queueName/failures/$index'
    | '/dashboard/settings/queues/$queueName/pending/$index'
    | '/dashboard/settings/report-subscription/$reportId/$subscriptionId/edit'
    | '/dashboard/settings/report-subscription/$reportId/$subscriptionId/overview'
    | '/dashboard/settings/report-subscription/$reportId/$subscriptionId/review-and-approve'
    | '/dashboard/settings/report-subscription/$reportId/$subscriptionId/send-history'
    | '/dashboard/settings/tags-management/catalog/$tagId/details'
    | '/dashboard/settings/tags-management/clusters/$tagId/details'
    | '/dashboard/settings/tags-management/devices/$tagId/details'
    | '/dashboard/settings/tags-management/samples/$tagId/details'
    | '/dashboard/settings/tags-management/sessions/$tagId/details'
    | '/dashboard/settings/tags-management/sites/$tagId/details'
    | '/admin-dashboard/jobs/service-health-checks/jobs/$jobId'
    | '/admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId'
    | '/dashboard/jobs/camera-calibration/jobs/$jobId'
    | '/dashboard/jobs/camera-calibration/schedule/$scheduledJobId'
    | '/dashboard/jobs/capacity-tagging/jobs/$jobId'
    | '/dashboard/jobs/capacity-tagging/schedule/$scheduledJobId'
    | '/dashboard/jobs/catalog-upload/jobs/$jobId'
    | '/dashboard/jobs/catalog-upload/schedule/$scheduledJobId'
    | '/dashboard/jobs/config/jobs/$jobId'
    | '/dashboard/jobs/config/schedule/$scheduledJobId'
    | '/dashboard/jobs/delete-samples/jobs/$jobId'
    | '/dashboard/jobs/delete-samples/schedule/$scheduledJobId'
    | '/dashboard/jobs/delete-videos/jobs/$jobId'
    | '/dashboard/jobs/delete-videos/schedule/$scheduledJobId'
    | '/dashboard/jobs/deployments/jobs/$jobId'
    | '/dashboard/jobs/deployments/schedule/$scheduledJobId'
    | '/dashboard/jobs/head-blur-images/jobs/$jobId'
    | '/dashboard/jobs/head-blur-images/schedule/$scheduledJobId'
    | '/dashboard/jobs/head-blur-videos/jobs/$jobId'
    | '/dashboard/jobs/head-blur-videos/schedule/$scheduledJobId'
    | '/dashboard/jobs/models/jobs/$jobId'
    | '/dashboard/jobs/models/schedule/$scheduledJobId'
    | '/dashboard/jobs/recovery-estimates/jobs/$jobId'
    | '/dashboard/jobs/recovery-estimates/schedule/$scheduledJobId'
    | '/dashboard/jobs/restarts/jobs/$jobId'
    | '/dashboard/jobs/restarts/schedule/$scheduledJobId'
    | '/dashboard/jobs/sample-upload/jobs/$jobId'
    | '/dashboard/jobs/sample-upload/schedule/$scheduledJobId'
    | '/dashboard/jobs/sync-samples/jobs/$jobId'
    | '/dashboard/jobs/sync-samples/schedule/$scheduledJobId'
    | '/dashboard/jobs/training/jobs/$jobId'
    | '/dashboard/jobs/training/schedule/$scheduledJobId'
    | '/dashboard/jobs/video-upload/jobs/$jobId'
    | '/dashboard/jobs/video-upload/schedule/$scheduledJobId'
    | '/dashboard/jobs/worker-jobs/jobs/$jobId'
    | '/dashboard/jobs/worker-jobs/schedule/$scheduledJobId'
    | '/dashboard/resources/devices/$deviceId/data'
    | '/dashboard/resources/devices/$deviceId/version-history'
    | '/dashboard/resources/sites/$siteId/version-history'
    | '/dashboard/settings/alert-management/alerts/$alertId'
    | '/dashboard/settings/alert-management/metric-alerts/$metricAlertId'
    | '/dashboard/settings/report-subscription/$reportId/$subscriptionId'
    | '/dashboard/settings/tags-management/catalog/$tagId'
    | '/dashboard/settings/tags-management/clusters/$tagId'
    | '/dashboard/settings/tags-management/devices/$tagId'
    | '/dashboard/settings/tags-management/samples/$tagId'
    | '/dashboard/settings/tags-management/sessions/$tagId'
    | '/dashboard/settings/tags-management/sites/$tagId'
    | '/dashboard/resources/devices/$deviceId/data/samples/$sampleId'
    | '/dashboard/resources/devices/$deviceId/data/sessions/$sessionId'
  id:
    | '__root__'
    | '/'
    | '/admin-dashboard'
    | '/dashboard'
    | '/unresponsive'
    | '/login'
    | '/admin-dashboard/accounts-management'
    | '/admin-dashboard/domain-auth-settings'
    | '/admin-dashboard/jobs'
    | '/admin-dashboard/notifications'
    | '/dashboard/alerts'
    | '/dashboard/data'
    | '/dashboard/jobs'
    | '/dashboard/models'
    | '/dashboard/reports'
    | '/dashboard/resources'
    | '/dashboard/settings'
    | '/dashboard/unauthorized'
    | '/dashboard/home'
    | '/dashboard/support'
    | '/next/$'
    | '/admin-dashboard/'
    | '/dashboard/'
    | '/admin-dashboard/accounts-management/$accountId'
    | '/admin-dashboard/jobs/service-health-checks'
    | '/admin-dashboard/notifications/$notificationId'
    | '/dashboard/data/annotations'
    | '/dashboard/data/catalog'
    | '/dashboard/data/datasets'
    | '/dashboard/data/images'
    | '/dashboard/data/json-data'
    | '/dashboard/data/label-distribution'
    | '/dashboard/data/pending'
    | '/dashboard/data/sessions'
    | '/dashboard/home/manager-report'
    | '/dashboard/jobs/camera-calibration'
    | '/dashboard/jobs/capacity-tagging'
    | '/dashboard/jobs/catalog-upload'
    | '/dashboard/jobs/config'
    | '/dashboard/jobs/delete-samples'
    | '/dashboard/jobs/delete-videos'
    | '/dashboard/jobs/deployments'
    | '/dashboard/jobs/head-blur-images'
    | '/dashboard/jobs/head-blur-videos'
    | '/dashboard/jobs/models'
    | '/dashboard/jobs/recovery-estimates'
    | '/dashboard/jobs/restarts'
    | '/dashboard/jobs/sample-upload'
    | '/dashboard/jobs/sync-samples'
    | '/dashboard/jobs/training'
    | '/dashboard/jobs/video-upload'
    | '/dashboard/jobs/worker-jobs'
    | '/dashboard/models/$modelId'
    | '/dashboard/reports/$reportId'
    | '/dashboard/reports/analytics-hub'
    | '/dashboard/reports/companion'
    | '/dashboard/resources/clusters'
    | '/dashboard/resources/devices'
    | '/dashboard/resources/site-groups'
    | '/dashboard/resources/sites'
    | '/dashboard/settings/alert-management'
    | '/dashboard/settings/job-defaults'
    | '/dashboard/settings/overview'
    | '/dashboard/settings/permissions-settings'
    | '/dashboard/settings/permissions-settings-dev'
    | '/dashboard/settings/queues'
    | '/dashboard/settings/regions'
    | '/dashboard/settings/report-settings'
    | '/dashboard/settings/tags-management'
    | '/dashboard/settings/user-management'
    | '/dashboard/[/rest]'
    | '/dashboard/data/'
    | '/dashboard/home/'
    | '/dashboard/jobs/'
    | '/dashboard/reports/'
    | '/dashboard/resources/'
    | '/dashboard/settings/'
    | '/admin-dashboard/accounts-management/$accountId/operational-hours'
    | '/admin-dashboard/accounts-management/$accountId/overview'
    | '/admin-dashboard/accounts-management/$accountId/regions'
    | '/admin-dashboard/jobs/service-health-checks/jobs'
    | '/admin-dashboard/jobs/service-health-checks/schedule'
    | '/admin-dashboard/notifications/$notificationId/overview'
    | '/dashboard/data/catalog/$item'
    | '/dashboard/data/datasets/$datasetId'
    | '/dashboard/data/images/$imageUUID'
    | '/dashboard/data/json-data/$jsonDataUUID'
    | '/dashboard/data/label-distribution/$label'
    | '/dashboard/data/sessions/$sessionId'
    | '/dashboard/home/manager-report/$sessionId'
    | '/dashboard/jobs/camera-calibration/alerts'
    | '/dashboard/jobs/camera-calibration/jobs'
    | '/dashboard/jobs/camera-calibration/schedule'
    | '/dashboard/jobs/capacity-tagging/jobs'
    | '/dashboard/jobs/capacity-tagging/schedule'
    | '/dashboard/jobs/catalog-upload/jobs'
    | '/dashboard/jobs/catalog-upload/schedule'
    | '/dashboard/jobs/config/jobs'
    | '/dashboard/jobs/config/schedule'
    | '/dashboard/jobs/delete-samples/alerts'
    | '/dashboard/jobs/delete-samples/jobs'
    | '/dashboard/jobs/delete-samples/schedule'
    | '/dashboard/jobs/delete-videos/alerts'
    | '/dashboard/jobs/delete-videos/jobs'
    | '/dashboard/jobs/delete-videos/schedule'
    | '/dashboard/jobs/deployments/jobs'
    | '/dashboard/jobs/deployments/schedule'
    | '/dashboard/jobs/head-blur-images/jobs'
    | '/dashboard/jobs/head-blur-images/schedule'
    | '/dashboard/jobs/head-blur-videos/jobs'
    | '/dashboard/jobs/head-blur-videos/schedule'
    | '/dashboard/jobs/models/jobs'
    | '/dashboard/jobs/models/schedule'
    | '/dashboard/jobs/recovery-estimates/jobs'
    | '/dashboard/jobs/recovery-estimates/schedule'
    | '/dashboard/jobs/restarts/jobs'
    | '/dashboard/jobs/restarts/schedule'
    | '/dashboard/jobs/sample-upload/alerts'
    | '/dashboard/jobs/sample-upload/jobs'
    | '/dashboard/jobs/sample-upload/schedule'
    | '/dashboard/jobs/sync-samples/alerts'
    | '/dashboard/jobs/sync-samples/jobs'
    | '/dashboard/jobs/sync-samples/schedule'
    | '/dashboard/jobs/training/jobs'
    | '/dashboard/jobs/training/schedule'
    | '/dashboard/jobs/video-upload/alerts'
    | '/dashboard/jobs/video-upload/jobs'
    | '/dashboard/jobs/video-upload/schedule'
    | '/dashboard/jobs/worker-jobs/jobs'
    | '/dashboard/jobs/worker-jobs/schedule'
    | '/dashboard/models/$modelId/deployment'
    | '/dashboard/models/$modelId/labels'
    | '/dashboard/models/$modelId/matrix'
    | '/dashboard/models/$modelId/overview'
    | '/dashboard/resources/clusters/$clusterId'
    | '/dashboard/resources/devices/$deviceId'
    | '/dashboard/resources/site-groups/$siteGroupId'
    | '/dashboard/resources/sites/$siteId'
    | '/dashboard/settings/alert-management/alert-channels'
    | '/dashboard/settings/alert-management/alerts'
    | '/dashboard/settings/alert-management/metric-alerts'
    | '/dashboard/settings/queues/$queueName'
    | '/dashboard/settings/report-settings/$reportId'
    | '/dashboard/settings/tags-management/catalog'
    | '/dashboard/settings/tags-management/clusters'
    | '/dashboard/settings/tags-management/devices'
    | '/dashboard/settings/tags-management/samples'
    | '/dashboard/settings/tags-management/sessions'
    | '/dashboard/settings/tags-management/sites'
    | '/dashboard/settings/user-management/$userId'
    | '/dashboard/data/[/rest]'
    | '/dashboard/resources/[/rest]'
    | '/dashboard/settings/user-management/thumbnail'
    | '/admin-dashboard/accounts-management/$accountId/'
    | '/admin-dashboard/jobs/service-health-checks/'
    | '/dashboard/home/manager-report/'
    | '/dashboard/jobs/camera-calibration/'
    | '/dashboard/jobs/capacity-tagging/'
    | '/dashboard/jobs/catalog-upload/'
    | '/dashboard/jobs/config/'
    | '/dashboard/jobs/delete-samples/'
    | '/dashboard/jobs/delete-videos/'
    | '/dashboard/jobs/deployments/'
    | '/dashboard/jobs/head-blur-images/'
    | '/dashboard/jobs/head-blur-videos/'
    | '/dashboard/jobs/models/'
    | '/dashboard/jobs/recovery-estimates/'
    | '/dashboard/jobs/restarts/'
    | '/dashboard/jobs/sample-upload/'
    | '/dashboard/jobs/sync-samples/'
    | '/dashboard/jobs/training/'
    | '/dashboard/jobs/video-upload/'
    | '/dashboard/jobs/worker-jobs/'
    | '/dashboard/models/$modelId/'
    | '/dashboard/settings/alert-management/'
    | '/dashboard/settings/queues/'
    | '/dashboard/settings/tags-management/'
    | '/admin-dashboard/jobs/service-health-checks/jobs/$jobId'
    | '/admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId'
    | '/dashboard/data/catalog/$item/details'
    | '/dashboard/data/catalog/$item/labels'
    | '/dashboard/data/catalog/$item/prices'
    | '/dashboard/data/datasets/$datasetId/images'
    | '/dashboard/data/datasets/$datasetId/overview'
    | '/dashboard/data/datasets/$datasetId/sessions'
    | '/dashboard/data/images/$imageUUID/additional'
    | '/dashboard/data/images/$imageUUID/overview'
    | '/dashboard/data/images/$imageUUID/transaction-details'
    | '/dashboard/data/sessions/$sessionId/overview'
    | '/dashboard/home/manager-report/$sessionId/overview'
    | '/dashboard/jobs/camera-calibration/jobs/$jobId'
    | '/dashboard/jobs/camera-calibration/schedule/$scheduledJobId'
    | '/dashboard/jobs/capacity-tagging/jobs/$jobId'
    | '/dashboard/jobs/capacity-tagging/schedule/$scheduledJobId'
    | '/dashboard/jobs/catalog-upload/jobs/$jobId'
    | '/dashboard/jobs/catalog-upload/schedule/$scheduledJobId'
    | '/dashboard/jobs/config/jobs/$jobId'
    | '/dashboard/jobs/config/schedule/$scheduledJobId'
    | '/dashboard/jobs/delete-samples/jobs/$jobId'
    | '/dashboard/jobs/delete-samples/schedule/$scheduledJobId'
    | '/dashboard/jobs/delete-videos/jobs/$jobId'
    | '/dashboard/jobs/delete-videos/schedule/$scheduledJobId'
    | '/dashboard/jobs/deployments/jobs/$jobId'
    | '/dashboard/jobs/deployments/schedule/$scheduledJobId'
    | '/dashboard/jobs/head-blur-images/jobs/$jobId'
    | '/dashboard/jobs/head-blur-images/schedule/$scheduledJobId'
    | '/dashboard/jobs/head-blur-videos/jobs/$jobId'
    | '/dashboard/jobs/head-blur-videos/schedule/$scheduledJobId'
    | '/dashboard/jobs/models/jobs/$jobId'
    | '/dashboard/jobs/models/schedule/$scheduledJobId'
    | '/dashboard/jobs/recovery-estimates/jobs/$jobId'
    | '/dashboard/jobs/recovery-estimates/schedule/$scheduledJobId'
    | '/dashboard/jobs/restarts/jobs/$jobId'
    | '/dashboard/jobs/restarts/schedule/$scheduledJobId'
    | '/dashboard/jobs/sample-upload/jobs/$jobId'
    | '/dashboard/jobs/sample-upload/schedule/$scheduledJobId'
    | '/dashboard/jobs/sync-samples/jobs/$jobId'
    | '/dashboard/jobs/sync-samples/schedule/$scheduledJobId'
    | '/dashboard/jobs/training/jobs/$jobId'
    | '/dashboard/jobs/training/schedule/$scheduledJobId'
    | '/dashboard/jobs/video-upload/jobs/$jobId'
    | '/dashboard/jobs/video-upload/schedule/$scheduledJobId'
    | '/dashboard/jobs/worker-jobs/jobs/$jobId'
    | '/dashboard/jobs/worker-jobs/schedule/$scheduledJobId'
    | '/dashboard/models/$modelId/deployment/clusters'
    | '/dashboard/models/$modelId/deployment/devices'
    | '/dashboard/resources/clusters/$clusterId/devices'
    | '/dashboard/resources/clusters/$clusterId/overview'
    | '/dashboard/resources/devices/$deviceId/camera'
    | '/dashboard/resources/devices/$deviceId/data'
    | '/dashboard/resources/devices/$deviceId/diagnostics'
    | '/dashboard/resources/devices/$deviceId/logs'
    | '/dashboard/resources/devices/$deviceId/overview'
    | '/dashboard/resources/devices/$deviceId/settings'
    | '/dashboard/resources/devices/$deviceId/version-history'
    | '/dashboard/resources/site-groups/$siteGroupId/labels'
    | '/dashboard/resources/site-groups/$siteGroupId/overview'
    | '/dashboard/resources/site-groups/$siteGroupId/sites'
    | '/dashboard/resources/sites/$siteId/devices'
    | '/dashboard/resources/sites/$siteId/overview'
    | '/dashboard/resources/sites/$siteId/version-history'
    | '/dashboard/settings/alert-management/alerts/$alertId'
    | '/dashboard/settings/queues/$queueName/failures'
    | '/dashboard/settings/queues/$queueName/pending'
    | '/dashboard/settings/report-settings/$reportId/overview'
    | '/dashboard/settings/report-settings/$reportId/parameters'
    | '/dashboard/settings/report-settings/$reportId/send-log'
    | '/dashboard/settings/report-settings/$reportId/subscriptions2'
    | '/dashboard/settings/report-subscription/$reportId/$subscriptionId'
    | '/dashboard/settings/tags-management/catalog/$tagId'
    | '/dashboard/settings/tags-management/clusters/$tagId'
    | '/dashboard/settings/tags-management/devices/$tagId'
    | '/dashboard/settings/tags-management/samples/$tagId'
    | '/dashboard/settings/tags-management/sessions/$tagId'
    | '/dashboard/settings/tags-management/sites/$tagId'
    | '/dashboard/settings/user-management/$userId/overview'
    | '/dashboard/data/json-data/$jsonDataUUID/overview'
    | '/dashboard/data/catalog/$item/'
    | '/dashboard/data/images/$imageUUID/'
    | '/dashboard/data/json-data/$jsonDataUUID/'
    | '/dashboard/data/label-distribution/$label/'
    | '/dashboard/data/sessions/$sessionId/'
    | '/dashboard/home/manager-report/$sessionId/'
    | '/dashboard/models/$modelId/deployment/'
    | '/dashboard/resources/clusters/$clusterId/'
    | '/dashboard/resources/devices/$deviceId/'
    | '/dashboard/resources/site-groups/$siteGroupId/'
    | '/dashboard/resources/sites/$siteId/'
    | '/dashboard/settings/queues/$queueName/'
    | '/dashboard/settings/report-settings/$reportId/'
    | '/dashboard/settings/user-management/$userId/'
    | '/admin-dashboard/jobs/service-health-checks/jobs/$jobId/overview'
    | '/admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId/inputs'
    | '/admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId/overview'
    | '/admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId/schedule'
    | '/dashboard/jobs/camera-calibration/jobs/$jobId/devices'
    | '/dashboard/jobs/camera-calibration/jobs/$jobId/overview'
    | '/dashboard/jobs/camera-calibration/schedule/$scheduledJobId/inputs'
    | '/dashboard/jobs/camera-calibration/schedule/$scheduledJobId/overview'
    | '/dashboard/jobs/camera-calibration/schedule/$scheduledJobId/schedule'
    | '/dashboard/jobs/capacity-tagging/jobs/$jobId/overview'
    | '/dashboard/jobs/capacity-tagging/schedule/$scheduledJobId/inputs'
    | '/dashboard/jobs/capacity-tagging/schedule/$scheduledJobId/overview'
    | '/dashboard/jobs/capacity-tagging/schedule/$scheduledJobId/schedule'
    | '/dashboard/jobs/catalog-upload/jobs/$jobId/devices'
    | '/dashboard/jobs/catalog-upload/jobs/$jobId/labels'
    | '/dashboard/jobs/catalog-upload/jobs/$jobId/overview'
    | '/dashboard/jobs/catalog-upload/schedule/$scheduledJobId/labels'
    | '/dashboard/jobs/catalog-upload/schedule/$scheduledJobId/overview'
    | '/dashboard/jobs/catalog-upload/schedule/$scheduledJobId/schedule'
    | '/dashboard/jobs/config/jobs/$jobId/devices'
    | '/dashboard/jobs/config/jobs/$jobId/overview'
    | '/dashboard/jobs/config/schedule/$scheduledJobId/overview'
    | '/dashboard/jobs/config/schedule/$scheduledJobId/schedule'
    | '/dashboard/jobs/delete-samples/jobs/$jobId/devices'
    | '/dashboard/jobs/delete-samples/jobs/$jobId/overview'
    | '/dashboard/jobs/delete-samples/schedule/$scheduledJobId/inputs'
    | '/dashboard/jobs/delete-samples/schedule/$scheduledJobId/overview'
    | '/dashboard/jobs/delete-samples/schedule/$scheduledJobId/schedule'
    | '/dashboard/jobs/delete-videos/jobs/$jobId/devices'
    | '/dashboard/jobs/delete-videos/jobs/$jobId/overview'
    | '/dashboard/jobs/delete-videos/schedule/$scheduledJobId/inputs'
    | '/dashboard/jobs/delete-videos/schedule/$scheduledJobId/overview'
    | '/dashboard/jobs/delete-videos/schedule/$scheduledJobId/schedule'
    | '/dashboard/jobs/deployments/jobs/$jobId/devices'
    | '/dashboard/jobs/deployments/jobs/$jobId/overview'
    | '/dashboard/jobs/deployments/schedule/$scheduledJobId/overview'
    | '/dashboard/jobs/deployments/schedule/$scheduledJobId/schedule'
    | '/dashboard/jobs/head-blur-images/jobs/$jobId/devices'
    | '/dashboard/jobs/head-blur-images/jobs/$jobId/overview'
    | '/dashboard/jobs/head-blur-images/schedule/$scheduledJobId/inputs'
    | '/dashboard/jobs/head-blur-images/schedule/$scheduledJobId/overview'
    | '/dashboard/jobs/head-blur-images/schedule/$scheduledJobId/schedule'
    | '/dashboard/jobs/head-blur-videos/jobs/$jobId/devices'
    | '/dashboard/jobs/head-blur-videos/jobs/$jobId/overview'
    | '/dashboard/jobs/head-blur-videos/schedule/$scheduledJobId/inputs'
    | '/dashboard/jobs/head-blur-videos/schedule/$scheduledJobId/overview'
    | '/dashboard/jobs/head-blur-videos/schedule/$scheduledJobId/schedule'
    | '/dashboard/jobs/models/jobs/$jobId/devices'
    | '/dashboard/jobs/models/jobs/$jobId/overview'
    | '/dashboard/jobs/models/schedule/$scheduledJobId/overview'
    | '/dashboard/jobs/models/schedule/$scheduledJobId/schedule'
    | '/dashboard/jobs/recovery-estimates/jobs/$jobId/overview'
    | '/dashboard/jobs/recovery-estimates/schedule/$scheduledJobId/inputs'
    | '/dashboard/jobs/recovery-estimates/schedule/$scheduledJobId/overview'
    | '/dashboard/jobs/recovery-estimates/schedule/$scheduledJobId/schedule'
    | '/dashboard/jobs/restarts/jobs/$jobId/devices'
    | '/dashboard/jobs/restarts/jobs/$jobId/overview'
    | '/dashboard/jobs/restarts/schedule/$scheduledJobId/overview'
    | '/dashboard/jobs/restarts/schedule/$scheduledJobId/schedule'
    | '/dashboard/jobs/sample-upload/jobs/$jobId/devices'
    | '/dashboard/jobs/sample-upload/jobs/$jobId/overview'
    | '/dashboard/jobs/sample-upload/schedule/$scheduledJobId/inputs'
    | '/dashboard/jobs/sample-upload/schedule/$scheduledJobId/overview'
    | '/dashboard/jobs/sample-upload/schedule/$scheduledJobId/schedule'
    | '/dashboard/jobs/sync-samples/jobs/$jobId/devices'
    | '/dashboard/jobs/sync-samples/jobs/$jobId/overview'
    | '/dashboard/jobs/sync-samples/schedule/$scheduledJobId/inputs'
    | '/dashboard/jobs/sync-samples/schedule/$scheduledJobId/overview'
    | '/dashboard/jobs/sync-samples/schedule/$scheduledJobId/schedule'
    | '/dashboard/jobs/training/jobs/$jobId/devices'
    | '/dashboard/jobs/training/jobs/$jobId/labels'
    | '/dashboard/jobs/training/jobs/$jobId/metrics'
    | '/dashboard/jobs/training/jobs/$jobId/overview'
    | '/dashboard/jobs/training/schedule/$scheduledJobId/inputs'
    | '/dashboard/jobs/training/schedule/$scheduledJobId/overview'
    | '/dashboard/jobs/training/schedule/$scheduledJobId/schedule'
    | '/dashboard/jobs/video-upload/jobs/$jobId/devices'
    | '/dashboard/jobs/video-upload/jobs/$jobId/overview'
    | '/dashboard/jobs/video-upload/schedule/$scheduledJobId/inputs'
    | '/dashboard/jobs/video-upload/schedule/$scheduledJobId/overview'
    | '/dashboard/jobs/video-upload/schedule/$scheduledJobId/schedule'
    | '/dashboard/jobs/worker-jobs/jobs/$jobId/devices'
    | '/dashboard/jobs/worker-jobs/jobs/$jobId/overview'
    | '/dashboard/jobs/worker-jobs/schedule/$scheduledJobId/inputs'
    | '/dashboard/jobs/worker-jobs/schedule/$scheduledJobId/overview'
    | '/dashboard/jobs/worker-jobs/schedule/$scheduledJobId/schedule'
    | '/dashboard/resources/devices/$deviceId/data/samples'
    | '/dashboard/resources/devices/$deviceId/data/sessions'
    | '/dashboard/resources/devices/$deviceId/data/text-json'
    | '/dashboard/resources/devices/$deviceId/diagnostics/classifier'
    | '/dashboard/resources/devices/$deviceId/diagnostics/custom'
    | '/dashboard/resources/devices/$deviceId/diagnostics/object-detection'
    | '/dashboard/resources/devices/$deviceId/version-history/agent'
    | '/dashboard/resources/devices/$deviceId/version-history/detector'
    | '/dashboard/resources/devices/$deviceId/version-history/models'
    | '/dashboard/resources/devices/$deviceId/version-history/on-screen-app'
    | '/dashboard/resources/devices/$deviceId/version-history/trainer'
    | '/dashboard/resources/devices/$deviceId/version-history/zebra-adapter'
    | '/dashboard/resources/sites/$siteId/version-history/agent'
    | '/dashboard/resources/sites/$siteId/version-history/detector'
    | '/dashboard/resources/sites/$siteId/version-history/on-screen-app'
    | '/dashboard/resources/sites/$siteId/version-history/trainer'
    | '/dashboard/resources/sites/$siteId/version-history/zebra-adapter'
    | '/dashboard/settings/alert-management/alerts/$alertId/overview'
    | '/dashboard/settings/queues/$queueName/failures/$index'
    | '/dashboard/settings/queues/$queueName/pending/$index'
    | '/dashboard/settings/report-subscription/$reportId/$subscriptionId/edit'
    | '/dashboard/settings/report-subscription/$reportId/$subscriptionId/overview'
    | '/dashboard/settings/report-subscription/$reportId/$subscriptionId/review-and-approve'
    | '/dashboard/settings/report-subscription/$reportId/$subscriptionId/send-history'
    | '/dashboard/settings/tags-management/catalog/$tagId/details'
    | '/dashboard/settings/tags-management/clusters/$tagId/details'
    | '/dashboard/settings/tags-management/devices/$tagId/details'
    | '/dashboard/settings/tags-management/samples/$tagId/details'
    | '/dashboard/settings/tags-management/sessions/$tagId/details'
    | '/dashboard/settings/tags-management/sites/$tagId/details'
    | '/admin-dashboard/jobs/service-health-checks/jobs/$jobId/'
    | '/admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId/'
    | '/dashboard/jobs/camera-calibration/jobs/$jobId/'
    | '/dashboard/jobs/camera-calibration/schedule/$scheduledJobId/'
    | '/dashboard/jobs/capacity-tagging/jobs/$jobId/'
    | '/dashboard/jobs/capacity-tagging/schedule/$scheduledJobId/'
    | '/dashboard/jobs/catalog-upload/jobs/$jobId/'
    | '/dashboard/jobs/catalog-upload/schedule/$scheduledJobId/'
    | '/dashboard/jobs/config/jobs/$jobId/'
    | '/dashboard/jobs/config/schedule/$scheduledJobId/'
    | '/dashboard/jobs/delete-samples/jobs/$jobId/'
    | '/dashboard/jobs/delete-samples/schedule/$scheduledJobId/'
    | '/dashboard/jobs/delete-videos/jobs/$jobId/'
    | '/dashboard/jobs/delete-videos/schedule/$scheduledJobId/'
    | '/dashboard/jobs/deployments/jobs/$jobId/'
    | '/dashboard/jobs/deployments/schedule/$scheduledJobId/'
    | '/dashboard/jobs/head-blur-images/jobs/$jobId/'
    | '/dashboard/jobs/head-blur-images/schedule/$scheduledJobId/'
    | '/dashboard/jobs/head-blur-videos/jobs/$jobId/'
    | '/dashboard/jobs/head-blur-videos/schedule/$scheduledJobId/'
    | '/dashboard/jobs/models/jobs/$jobId/'
    | '/dashboard/jobs/models/schedule/$scheduledJobId/'
    | '/dashboard/jobs/recovery-estimates/jobs/$jobId/'
    | '/dashboard/jobs/recovery-estimates/schedule/$scheduledJobId/'
    | '/dashboard/jobs/restarts/jobs/$jobId/'
    | '/dashboard/jobs/restarts/schedule/$scheduledJobId/'
    | '/dashboard/jobs/sample-upload/jobs/$jobId/'
    | '/dashboard/jobs/sample-upload/schedule/$scheduledJobId/'
    | '/dashboard/jobs/sync-samples/jobs/$jobId/'
    | '/dashboard/jobs/sync-samples/schedule/$scheduledJobId/'
    | '/dashboard/jobs/training/jobs/$jobId/'
    | '/dashboard/jobs/training/schedule/$scheduledJobId/'
    | '/dashboard/jobs/video-upload/jobs/$jobId/'
    | '/dashboard/jobs/video-upload/schedule/$scheduledJobId/'
    | '/dashboard/jobs/worker-jobs/jobs/$jobId/'
    | '/dashboard/jobs/worker-jobs/schedule/$scheduledJobId/'
    | '/dashboard/resources/devices/$deviceId/data/'
    | '/dashboard/resources/devices/$deviceId/version-history/'
    | '/dashboard/resources/sites/$siteId/version-history/'
    | '/dashboard/settings/alert-management/alerts/$alertId/'
    | '/dashboard/settings/alert-management/metric-alerts/$metricAlertId/'
    | '/dashboard/settings/report-subscription/$reportId/$subscriptionId/'
    | '/dashboard/settings/tags-management/catalog/$tagId/'
    | '/dashboard/settings/tags-management/clusters/$tagId/'
    | '/dashboard/settings/tags-management/devices/$tagId/'
    | '/dashboard/settings/tags-management/samples/$tagId/'
    | '/dashboard/settings/tags-management/sessions/$tagId/'
    | '/dashboard/settings/tags-management/sites/$tagId/'
    | '/dashboard/resources/devices/$deviceId/data/samples/$sampleId'
    | '/dashboard/resources/devices/$deviceId/data/sessions/$sessionId'
    | '/dashboard/resources/devices/$deviceId/data/samples/$sampleId/'
    | '/dashboard/resources/devices/$deviceId/data/sessions/$sessionId/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminDashboardRouteRoute: typeof AdminDashboardRouteRouteWithChildren
  DashboardRouteRoute: typeof DashboardRouteRouteWithChildren
  UnresponsiveRouteRoute: typeof UnresponsiveRouteRoute
  LoginRouteLazyRoute: typeof LoginRouteLazyRoute
  NextSplatRoute: typeof NextSplatRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminDashboardRouteRoute: AdminDashboardRouteRouteWithChildren,
  DashboardRouteRoute: DashboardRouteRouteWithChildren,
  UnresponsiveRouteRoute: UnresponsiveRouteRoute,
  LoginRouteLazyRoute: LoginRouteLazyRoute,
  NextSplatRoute: NextSplatRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/admin-dashboard",
        "/dashboard",
        "/unresponsive",
        "/login",
        "/next/$"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/admin-dashboard": {
      "filePath": "admin-dashboard/route.tsx",
      "children": [
        "/admin-dashboard/accounts-management",
        "/admin-dashboard/domain-auth-settings",
        "/admin-dashboard/jobs",
        "/admin-dashboard/notifications",
        "/admin-dashboard/"
      ]
    },
    "/dashboard": {
      "filePath": "dashboard/route.tsx",
      "children": [
        "/dashboard/alerts",
        "/dashboard/data",
        "/dashboard/jobs",
        "/dashboard/models",
        "/dashboard/reports",
        "/dashboard/resources",
        "/dashboard/settings",
        "/dashboard/unauthorized",
        "/dashboard/home",
        "/dashboard/support",
        "/dashboard/",
        "/dashboard/[/rest]"
      ]
    },
    "/unresponsive": {
      "filePath": "unresponsive/route.tsx"
    },
    "/login": {
      "filePath": "login/route.lazy.tsx"
    },
    "/admin-dashboard/accounts-management": {
      "filePath": "admin-dashboard/accounts-management/route.tsx",
      "parent": "/admin-dashboard",
      "children": [
        "/admin-dashboard/accounts-management/$accountId"
      ]
    },
    "/admin-dashboard/domain-auth-settings": {
      "filePath": "admin-dashboard/domain-auth-settings/route.tsx",
      "parent": "/admin-dashboard"
    },
    "/admin-dashboard/jobs": {
      "filePath": "admin-dashboard/jobs/route.tsx",
      "parent": "/admin-dashboard",
      "children": [
        "/admin-dashboard/jobs/service-health-checks"
      ]
    },
    "/admin-dashboard/notifications": {
      "filePath": "admin-dashboard/notifications/route.tsx",
      "parent": "/admin-dashboard",
      "children": [
        "/admin-dashboard/notifications/$notificationId"
      ]
    },
    "/dashboard/alerts": {
      "filePath": "dashboard/alerts/route.tsx",
      "parent": "/dashboard"
    },
    "/dashboard/data": {
      "filePath": "dashboard/data/route.tsx",
      "parent": "/dashboard",
      "children": [
        "/dashboard/data/annotations",
        "/dashboard/data/catalog",
        "/dashboard/data/datasets",
        "/dashboard/data/images",
        "/dashboard/data/json-data",
        "/dashboard/data/label-distribution",
        "/dashboard/data/pending",
        "/dashboard/data/sessions",
        "/dashboard/data/",
        "/dashboard/data/[/rest]"
      ]
    },
    "/dashboard/jobs": {
      "filePath": "dashboard/jobs/route.tsx",
      "parent": "/dashboard",
      "children": [
        "/dashboard/jobs/camera-calibration",
        "/dashboard/jobs/capacity-tagging",
        "/dashboard/jobs/catalog-upload",
        "/dashboard/jobs/config",
        "/dashboard/jobs/delete-samples",
        "/dashboard/jobs/delete-videos",
        "/dashboard/jobs/deployments",
        "/dashboard/jobs/head-blur-images",
        "/dashboard/jobs/head-blur-videos",
        "/dashboard/jobs/models",
        "/dashboard/jobs/recovery-estimates",
        "/dashboard/jobs/restarts",
        "/dashboard/jobs/sample-upload",
        "/dashboard/jobs/sync-samples",
        "/dashboard/jobs/training",
        "/dashboard/jobs/video-upload",
        "/dashboard/jobs/worker-jobs",
        "/dashboard/jobs/"
      ]
    },
    "/dashboard/models": {
      "filePath": "dashboard/models/route.tsx",
      "parent": "/dashboard",
      "children": [
        "/dashboard/models/$modelId"
      ]
    },
    "/dashboard/reports": {
      "filePath": "dashboard/reports/route.tsx",
      "parent": "/dashboard",
      "children": [
        "/dashboard/reports/$reportId",
        "/dashboard/reports/analytics-hub",
        "/dashboard/reports/companion",
        "/dashboard/reports/"
      ]
    },
    "/dashboard/resources": {
      "filePath": "dashboard/resources/route.tsx",
      "parent": "/dashboard",
      "children": [
        "/dashboard/resources/clusters",
        "/dashboard/resources/devices",
        "/dashboard/resources/site-groups",
        "/dashboard/resources/sites",
        "/dashboard/resources/",
        "/dashboard/resources/[/rest]"
      ]
    },
    "/dashboard/settings": {
      "filePath": "dashboard/settings/route.tsx",
      "parent": "/dashboard",
      "children": [
        "/dashboard/settings/alert-management",
        "/dashboard/settings/job-defaults",
        "/dashboard/settings/overview",
        "/dashboard/settings/permissions-settings",
        "/dashboard/settings/permissions-settings-dev",
        "/dashboard/settings/queues",
        "/dashboard/settings/regions",
        "/dashboard/settings/report-settings",
        "/dashboard/settings/tags-management",
        "/dashboard/settings/user-management",
        "/dashboard/settings/",
        "/dashboard/settings/report-subscription/$reportId/$subscriptionId"
      ]
    },
    "/dashboard/unauthorized": {
      "filePath": "dashboard/unauthorized/route.tsx",
      "parent": "/dashboard"
    },
    "/dashboard/home": {
      "filePath": "dashboard/home.tsx",
      "parent": "/dashboard",
      "children": [
        "/dashboard/home/manager-report",
        "/dashboard/home/"
      ]
    },
    "/dashboard/support": {
      "filePath": "dashboard/support.tsx",
      "parent": "/dashboard"
    },
    "/next/$": {
      "filePath": "next.$.tsx"
    },
    "/admin-dashboard/": {
      "filePath": "admin-dashboard/index.tsx",
      "parent": "/admin-dashboard"
    },
    "/dashboard/": {
      "filePath": "dashboard/index.tsx",
      "parent": "/dashboard"
    },
    "/admin-dashboard/accounts-management/$accountId": {
      "filePath": "admin-dashboard/accounts-management/$accountId/route.tsx",
      "parent": "/admin-dashboard/accounts-management",
      "children": [
        "/admin-dashboard/accounts-management/$accountId/operational-hours",
        "/admin-dashboard/accounts-management/$accountId/overview",
        "/admin-dashboard/accounts-management/$accountId/regions",
        "/admin-dashboard/accounts-management/$accountId/"
      ]
    },
    "/admin-dashboard/jobs/service-health-checks": {
      "filePath": "admin-dashboard/jobs/service-health-checks/route.tsx",
      "parent": "/admin-dashboard/jobs",
      "children": [
        "/admin-dashboard/jobs/service-health-checks/jobs",
        "/admin-dashboard/jobs/service-health-checks/schedule",
        "/admin-dashboard/jobs/service-health-checks/"
      ]
    },
    "/admin-dashboard/notifications/$notificationId": {
      "filePath": "admin-dashboard/notifications/$notificationId/route.tsx",
      "parent": "/admin-dashboard/notifications",
      "children": [
        "/admin-dashboard/notifications/$notificationId/overview"
      ]
    },
    "/dashboard/data/annotations": {
      "filePath": "dashboard/data/annotations/route.tsx",
      "parent": "/dashboard/data"
    },
    "/dashboard/data/catalog": {
      "filePath": "dashboard/data/catalog/route.tsx",
      "parent": "/dashboard/data",
      "children": [
        "/dashboard/data/catalog/$item"
      ]
    },
    "/dashboard/data/datasets": {
      "filePath": "dashboard/data/datasets/route.tsx",
      "parent": "/dashboard/data",
      "children": [
        "/dashboard/data/datasets/$datasetId"
      ]
    },
    "/dashboard/data/images": {
      "filePath": "dashboard/data/images/route.tsx",
      "parent": "/dashboard/data",
      "children": [
        "/dashboard/data/images/$imageUUID"
      ]
    },
    "/dashboard/data/json-data": {
      "filePath": "dashboard/data/json-data/route.tsx",
      "parent": "/dashboard/data",
      "children": [
        "/dashboard/data/json-data/$jsonDataUUID"
      ]
    },
    "/dashboard/data/label-distribution": {
      "filePath": "dashboard/data/label-distribution/route.tsx",
      "parent": "/dashboard/data",
      "children": [
        "/dashboard/data/label-distribution/$label"
      ]
    },
    "/dashboard/data/pending": {
      "filePath": "dashboard/data/pending/route.tsx",
      "parent": "/dashboard/data"
    },
    "/dashboard/data/sessions": {
      "filePath": "dashboard/data/sessions/route.tsx",
      "parent": "/dashboard/data",
      "children": [
        "/dashboard/data/sessions/$sessionId"
      ]
    },
    "/dashboard/home/manager-report": {
      "filePath": "dashboard/home/manager-report/route.tsx",
      "parent": "/dashboard/home",
      "children": [
        "/dashboard/home/manager-report/$sessionId",
        "/dashboard/home/manager-report/"
      ]
    },
    "/dashboard/jobs/camera-calibration": {
      "filePath": "dashboard/jobs/camera-calibration/route.tsx",
      "parent": "/dashboard/jobs",
      "children": [
        "/dashboard/jobs/camera-calibration/alerts",
        "/dashboard/jobs/camera-calibration/jobs",
        "/dashboard/jobs/camera-calibration/schedule",
        "/dashboard/jobs/camera-calibration/"
      ]
    },
    "/dashboard/jobs/capacity-tagging": {
      "filePath": "dashboard/jobs/capacity-tagging/route.tsx",
      "parent": "/dashboard/jobs",
      "children": [
        "/dashboard/jobs/capacity-tagging/jobs",
        "/dashboard/jobs/capacity-tagging/schedule",
        "/dashboard/jobs/capacity-tagging/"
      ]
    },
    "/dashboard/jobs/catalog-upload": {
      "filePath": "dashboard/jobs/catalog-upload/route.tsx",
      "parent": "/dashboard/jobs",
      "children": [
        "/dashboard/jobs/catalog-upload/jobs",
        "/dashboard/jobs/catalog-upload/schedule",
        "/dashboard/jobs/catalog-upload/"
      ]
    },
    "/dashboard/jobs/config": {
      "filePath": "dashboard/jobs/config/route.tsx",
      "parent": "/dashboard/jobs",
      "children": [
        "/dashboard/jobs/config/jobs",
        "/dashboard/jobs/config/schedule",
        "/dashboard/jobs/config/"
      ]
    },
    "/dashboard/jobs/delete-samples": {
      "filePath": "dashboard/jobs/delete-samples/route.tsx",
      "parent": "/dashboard/jobs",
      "children": [
        "/dashboard/jobs/delete-samples/alerts",
        "/dashboard/jobs/delete-samples/jobs",
        "/dashboard/jobs/delete-samples/schedule",
        "/dashboard/jobs/delete-samples/"
      ]
    },
    "/dashboard/jobs/delete-videos": {
      "filePath": "dashboard/jobs/delete-videos/route.tsx",
      "parent": "/dashboard/jobs",
      "children": [
        "/dashboard/jobs/delete-videos/alerts",
        "/dashboard/jobs/delete-videos/jobs",
        "/dashboard/jobs/delete-videos/schedule",
        "/dashboard/jobs/delete-videos/"
      ]
    },
    "/dashboard/jobs/deployments": {
      "filePath": "dashboard/jobs/deployments/route.tsx",
      "parent": "/dashboard/jobs",
      "children": [
        "/dashboard/jobs/deployments/jobs",
        "/dashboard/jobs/deployments/schedule",
        "/dashboard/jobs/deployments/"
      ]
    },
    "/dashboard/jobs/head-blur-images": {
      "filePath": "dashboard/jobs/head-blur-images/route.tsx",
      "parent": "/dashboard/jobs",
      "children": [
        "/dashboard/jobs/head-blur-images/jobs",
        "/dashboard/jobs/head-blur-images/schedule",
        "/dashboard/jobs/head-blur-images/"
      ]
    },
    "/dashboard/jobs/head-blur-videos": {
      "filePath": "dashboard/jobs/head-blur-videos/route.tsx",
      "parent": "/dashboard/jobs",
      "children": [
        "/dashboard/jobs/head-blur-videos/jobs",
        "/dashboard/jobs/head-blur-videos/schedule",
        "/dashboard/jobs/head-blur-videos/"
      ]
    },
    "/dashboard/jobs/models": {
      "filePath": "dashboard/jobs/models/route.tsx",
      "parent": "/dashboard/jobs",
      "children": [
        "/dashboard/jobs/models/jobs",
        "/dashboard/jobs/models/schedule",
        "/dashboard/jobs/models/"
      ]
    },
    "/dashboard/jobs/recovery-estimates": {
      "filePath": "dashboard/jobs/recovery-estimates/route.tsx",
      "parent": "/dashboard/jobs",
      "children": [
        "/dashboard/jobs/recovery-estimates/jobs",
        "/dashboard/jobs/recovery-estimates/schedule",
        "/dashboard/jobs/recovery-estimates/"
      ]
    },
    "/dashboard/jobs/restarts": {
      "filePath": "dashboard/jobs/restarts/route.tsx",
      "parent": "/dashboard/jobs",
      "children": [
        "/dashboard/jobs/restarts/jobs",
        "/dashboard/jobs/restarts/schedule",
        "/dashboard/jobs/restarts/"
      ]
    },
    "/dashboard/jobs/sample-upload": {
      "filePath": "dashboard/jobs/sample-upload/route.tsx",
      "parent": "/dashboard/jobs",
      "children": [
        "/dashboard/jobs/sample-upload/alerts",
        "/dashboard/jobs/sample-upload/jobs",
        "/dashboard/jobs/sample-upload/schedule",
        "/dashboard/jobs/sample-upload/"
      ]
    },
    "/dashboard/jobs/sync-samples": {
      "filePath": "dashboard/jobs/sync-samples/route.tsx",
      "parent": "/dashboard/jobs",
      "children": [
        "/dashboard/jobs/sync-samples/alerts",
        "/dashboard/jobs/sync-samples/jobs",
        "/dashboard/jobs/sync-samples/schedule",
        "/dashboard/jobs/sync-samples/"
      ]
    },
    "/dashboard/jobs/training": {
      "filePath": "dashboard/jobs/training/route.tsx",
      "parent": "/dashboard/jobs",
      "children": [
        "/dashboard/jobs/training/jobs",
        "/dashboard/jobs/training/schedule",
        "/dashboard/jobs/training/"
      ]
    },
    "/dashboard/jobs/video-upload": {
      "filePath": "dashboard/jobs/video-upload/route.tsx",
      "parent": "/dashboard/jobs",
      "children": [
        "/dashboard/jobs/video-upload/alerts",
        "/dashboard/jobs/video-upload/jobs",
        "/dashboard/jobs/video-upload/schedule",
        "/dashboard/jobs/video-upload/"
      ]
    },
    "/dashboard/jobs/worker-jobs": {
      "filePath": "dashboard/jobs/worker-jobs/route.tsx",
      "parent": "/dashboard/jobs",
      "children": [
        "/dashboard/jobs/worker-jobs/jobs",
        "/dashboard/jobs/worker-jobs/schedule",
        "/dashboard/jobs/worker-jobs/"
      ]
    },
    "/dashboard/models/$modelId": {
      "filePath": "dashboard/models/$modelId/route.tsx",
      "parent": "/dashboard/models",
      "children": [
        "/dashboard/models/$modelId/deployment",
        "/dashboard/models/$modelId/labels",
        "/dashboard/models/$modelId/matrix",
        "/dashboard/models/$modelId/overview",
        "/dashboard/models/$modelId/"
      ]
    },
    "/dashboard/reports/$reportId": {
      "filePath": "dashboard/reports/$reportId/route.tsx",
      "parent": "/dashboard/reports"
    },
    "/dashboard/reports/analytics-hub": {
      "filePath": "dashboard/reports/analytics-hub/route.tsx",
      "parent": "/dashboard/reports"
    },
    "/dashboard/reports/companion": {
      "filePath": "dashboard/reports/companion/route.tsx",
      "parent": "/dashboard/reports"
    },
    "/dashboard/resources/clusters": {
      "filePath": "dashboard/resources/clusters/route.tsx",
      "parent": "/dashboard/resources",
      "children": [
        "/dashboard/resources/clusters/$clusterId"
      ]
    },
    "/dashboard/resources/devices": {
      "filePath": "dashboard/resources/devices/route.tsx",
      "parent": "/dashboard/resources",
      "children": [
        "/dashboard/resources/devices/$deviceId"
      ]
    },
    "/dashboard/resources/site-groups": {
      "filePath": "dashboard/resources/site-groups/route.tsx",
      "parent": "/dashboard/resources",
      "children": [
        "/dashboard/resources/site-groups/$siteGroupId"
      ]
    },
    "/dashboard/resources/sites": {
      "filePath": "dashboard/resources/sites/route.tsx",
      "parent": "/dashboard/resources",
      "children": [
        "/dashboard/resources/sites/$siteId"
      ]
    },
    "/dashboard/settings/alert-management": {
      "filePath": "dashboard/settings/alert-management/route.tsx",
      "parent": "/dashboard/settings",
      "children": [
        "/dashboard/settings/alert-management/alert-channels",
        "/dashboard/settings/alert-management/alerts",
        "/dashboard/settings/alert-management/metric-alerts",
        "/dashboard/settings/alert-management/"
      ]
    },
    "/dashboard/settings/job-defaults": {
      "filePath": "dashboard/settings/job-defaults/route.tsx",
      "parent": "/dashboard/settings"
    },
    "/dashboard/settings/overview": {
      "filePath": "dashboard/settings/overview/route.tsx",
      "parent": "/dashboard/settings"
    },
    "/dashboard/settings/permissions-settings": {
      "filePath": "dashboard/settings/permissions-settings/route.tsx",
      "parent": "/dashboard/settings"
    },
    "/dashboard/settings/permissions-settings-dev": {
      "filePath": "dashboard/settings/permissions-settings-dev/route.tsx",
      "parent": "/dashboard/settings"
    },
    "/dashboard/settings/queues": {
      "filePath": "dashboard/settings/queues/route.tsx",
      "parent": "/dashboard/settings",
      "children": [
        "/dashboard/settings/queues/$queueName",
        "/dashboard/settings/queues/"
      ]
    },
    "/dashboard/settings/regions": {
      "filePath": "dashboard/settings/regions/route.tsx",
      "parent": "/dashboard/settings"
    },
    "/dashboard/settings/report-settings": {
      "filePath": "dashboard/settings/report-settings/route.tsx",
      "parent": "/dashboard/settings",
      "children": [
        "/dashboard/settings/report-settings/$reportId"
      ]
    },
    "/dashboard/settings/tags-management": {
      "filePath": "dashboard/settings/tags-management/route.tsx",
      "parent": "/dashboard/settings",
      "children": [
        "/dashboard/settings/tags-management/catalog",
        "/dashboard/settings/tags-management/clusters",
        "/dashboard/settings/tags-management/devices",
        "/dashboard/settings/tags-management/samples",
        "/dashboard/settings/tags-management/sessions",
        "/dashboard/settings/tags-management/sites",
        "/dashboard/settings/tags-management/"
      ]
    },
    "/dashboard/settings/user-management": {
      "filePath": "dashboard/settings/user-management/route.tsx",
      "parent": "/dashboard/settings",
      "children": [
        "/dashboard/settings/user-management/$userId",
        "/dashboard/settings/user-management/thumbnail"
      ]
    },
    "/dashboard/[/rest]": {
      "filePath": "dashboard/[...rest].tsx",
      "parent": "/dashboard"
    },
    "/dashboard/data/": {
      "filePath": "dashboard/data/index.tsx",
      "parent": "/dashboard/data"
    },
    "/dashboard/home/": {
      "filePath": "dashboard/home/index.tsx",
      "parent": "/dashboard/home"
    },
    "/dashboard/jobs/": {
      "filePath": "dashboard/jobs/index.tsx",
      "parent": "/dashboard/jobs"
    },
    "/dashboard/reports/": {
      "filePath": "dashboard/reports/index.tsx",
      "parent": "/dashboard/reports"
    },
    "/dashboard/resources/": {
      "filePath": "dashboard/resources/index.tsx",
      "parent": "/dashboard/resources"
    },
    "/dashboard/settings/": {
      "filePath": "dashboard/settings/index.tsx",
      "parent": "/dashboard/settings"
    },
    "/admin-dashboard/accounts-management/$accountId/operational-hours": {
      "filePath": "admin-dashboard/accounts-management/$accountId/operational-hours/route.tsx",
      "parent": "/admin-dashboard/accounts-management/$accountId"
    },
    "/admin-dashboard/accounts-management/$accountId/overview": {
      "filePath": "admin-dashboard/accounts-management/$accountId/overview/route.tsx",
      "parent": "/admin-dashboard/accounts-management/$accountId"
    },
    "/admin-dashboard/accounts-management/$accountId/regions": {
      "filePath": "admin-dashboard/accounts-management/$accountId/regions/route.tsx",
      "parent": "/admin-dashboard/accounts-management/$accountId"
    },
    "/admin-dashboard/jobs/service-health-checks/jobs": {
      "filePath": "admin-dashboard/jobs/service-health-checks/jobs/route.tsx",
      "parent": "/admin-dashboard/jobs/service-health-checks",
      "children": [
        "/admin-dashboard/jobs/service-health-checks/jobs/$jobId"
      ]
    },
    "/admin-dashboard/jobs/service-health-checks/schedule": {
      "filePath": "admin-dashboard/jobs/service-health-checks/schedule/route.tsx",
      "parent": "/admin-dashboard/jobs/service-health-checks",
      "children": [
        "/admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId"
      ]
    },
    "/admin-dashboard/notifications/$notificationId/overview": {
      "filePath": "admin-dashboard/notifications/$notificationId/overview/route.tsx",
      "parent": "/admin-dashboard/notifications/$notificationId"
    },
    "/dashboard/data/catalog/$item": {
      "filePath": "dashboard/data/catalog/$item/route.tsx",
      "parent": "/dashboard/data/catalog",
      "children": [
        "/dashboard/data/catalog/$item/details",
        "/dashboard/data/catalog/$item/labels",
        "/dashboard/data/catalog/$item/prices",
        "/dashboard/data/catalog/$item/"
      ]
    },
    "/dashboard/data/datasets/$datasetId": {
      "filePath": "dashboard/data/datasets/$datasetId/route.tsx",
      "parent": "/dashboard/data/datasets",
      "children": [
        "/dashboard/data/datasets/$datasetId/images",
        "/dashboard/data/datasets/$datasetId/overview",
        "/dashboard/data/datasets/$datasetId/sessions"
      ]
    },
    "/dashboard/data/images/$imageUUID": {
      "filePath": "dashboard/data/images/$imageUUID/route.tsx",
      "parent": "/dashboard/data/images",
      "children": [
        "/dashboard/data/images/$imageUUID/additional",
        "/dashboard/data/images/$imageUUID/overview",
        "/dashboard/data/images/$imageUUID/transaction-details",
        "/dashboard/data/images/$imageUUID/"
      ]
    },
    "/dashboard/data/json-data/$jsonDataUUID": {
      "filePath": "dashboard/data/json-data/$jsonDataUUID/route.tsx",
      "parent": "/dashboard/data/json-data",
      "children": [
        "/dashboard/data/json-data/$jsonDataUUID/overview",
        "/dashboard/data/json-data/$jsonDataUUID/"
      ]
    },
    "/dashboard/data/label-distribution/$label": {
      "filePath": "dashboard/data/label-distribution/$label/route.tsx",
      "parent": "/dashboard/data/label-distribution",
      "children": [
        "/dashboard/data/label-distribution/$label/"
      ]
    },
    "/dashboard/data/sessions/$sessionId": {
      "filePath": "dashboard/data/sessions/$sessionId/route.tsx",
      "parent": "/dashboard/data/sessions",
      "children": [
        "/dashboard/data/sessions/$sessionId/overview",
        "/dashboard/data/sessions/$sessionId/"
      ]
    },
    "/dashboard/home/manager-report/$sessionId": {
      "filePath": "dashboard/home/manager-report/$sessionId/route.tsx",
      "parent": "/dashboard/home/manager-report",
      "children": [
        "/dashboard/home/manager-report/$sessionId/overview",
        "/dashboard/home/manager-report/$sessionId/"
      ]
    },
    "/dashboard/jobs/camera-calibration/alerts": {
      "filePath": "dashboard/jobs/camera-calibration/alerts/route.tsx",
      "parent": "/dashboard/jobs/camera-calibration"
    },
    "/dashboard/jobs/camera-calibration/jobs": {
      "filePath": "dashboard/jobs/camera-calibration/jobs/route.tsx",
      "parent": "/dashboard/jobs/camera-calibration",
      "children": [
        "/dashboard/jobs/camera-calibration/jobs/$jobId"
      ]
    },
    "/dashboard/jobs/camera-calibration/schedule": {
      "filePath": "dashboard/jobs/camera-calibration/schedule/route.tsx",
      "parent": "/dashboard/jobs/camera-calibration",
      "children": [
        "/dashboard/jobs/camera-calibration/schedule/$scheduledJobId"
      ]
    },
    "/dashboard/jobs/capacity-tagging/jobs": {
      "filePath": "dashboard/jobs/capacity-tagging/jobs/route.tsx",
      "parent": "/dashboard/jobs/capacity-tagging",
      "children": [
        "/dashboard/jobs/capacity-tagging/jobs/$jobId"
      ]
    },
    "/dashboard/jobs/capacity-tagging/schedule": {
      "filePath": "dashboard/jobs/capacity-tagging/schedule/route.tsx",
      "parent": "/dashboard/jobs/capacity-tagging",
      "children": [
        "/dashboard/jobs/capacity-tagging/schedule/$scheduledJobId"
      ]
    },
    "/dashboard/jobs/catalog-upload/jobs": {
      "filePath": "dashboard/jobs/catalog-upload/jobs/route.tsx",
      "parent": "/dashboard/jobs/catalog-upload",
      "children": [
        "/dashboard/jobs/catalog-upload/jobs/$jobId"
      ]
    },
    "/dashboard/jobs/catalog-upload/schedule": {
      "filePath": "dashboard/jobs/catalog-upload/schedule/route.tsx",
      "parent": "/dashboard/jobs/catalog-upload",
      "children": [
        "/dashboard/jobs/catalog-upload/schedule/$scheduledJobId"
      ]
    },
    "/dashboard/jobs/config/jobs": {
      "filePath": "dashboard/jobs/config/jobs/route.tsx",
      "parent": "/dashboard/jobs/config",
      "children": [
        "/dashboard/jobs/config/jobs/$jobId"
      ]
    },
    "/dashboard/jobs/config/schedule": {
      "filePath": "dashboard/jobs/config/schedule/route.tsx",
      "parent": "/dashboard/jobs/config",
      "children": [
        "/dashboard/jobs/config/schedule/$scheduledJobId"
      ]
    },
    "/dashboard/jobs/delete-samples/alerts": {
      "filePath": "dashboard/jobs/delete-samples/alerts/route.tsx",
      "parent": "/dashboard/jobs/delete-samples"
    },
    "/dashboard/jobs/delete-samples/jobs": {
      "filePath": "dashboard/jobs/delete-samples/jobs/route.tsx",
      "parent": "/dashboard/jobs/delete-samples",
      "children": [
        "/dashboard/jobs/delete-samples/jobs/$jobId"
      ]
    },
    "/dashboard/jobs/delete-samples/schedule": {
      "filePath": "dashboard/jobs/delete-samples/schedule/route.tsx",
      "parent": "/dashboard/jobs/delete-samples",
      "children": [
        "/dashboard/jobs/delete-samples/schedule/$scheduledJobId"
      ]
    },
    "/dashboard/jobs/delete-videos/alerts": {
      "filePath": "dashboard/jobs/delete-videos/alerts/route.tsx",
      "parent": "/dashboard/jobs/delete-videos"
    },
    "/dashboard/jobs/delete-videos/jobs": {
      "filePath": "dashboard/jobs/delete-videos/jobs/route.tsx",
      "parent": "/dashboard/jobs/delete-videos",
      "children": [
        "/dashboard/jobs/delete-videos/jobs/$jobId"
      ]
    },
    "/dashboard/jobs/delete-videos/schedule": {
      "filePath": "dashboard/jobs/delete-videos/schedule/route.tsx",
      "parent": "/dashboard/jobs/delete-videos",
      "children": [
        "/dashboard/jobs/delete-videos/schedule/$scheduledJobId"
      ]
    },
    "/dashboard/jobs/deployments/jobs": {
      "filePath": "dashboard/jobs/deployments/jobs/route.tsx",
      "parent": "/dashboard/jobs/deployments",
      "children": [
        "/dashboard/jobs/deployments/jobs/$jobId"
      ]
    },
    "/dashboard/jobs/deployments/schedule": {
      "filePath": "dashboard/jobs/deployments/schedule/route.tsx",
      "parent": "/dashboard/jobs/deployments",
      "children": [
        "/dashboard/jobs/deployments/schedule/$scheduledJobId"
      ]
    },
    "/dashboard/jobs/head-blur-images/jobs": {
      "filePath": "dashboard/jobs/head-blur-images/jobs/route.tsx",
      "parent": "/dashboard/jobs/head-blur-images",
      "children": [
        "/dashboard/jobs/head-blur-images/jobs/$jobId"
      ]
    },
    "/dashboard/jobs/head-blur-images/schedule": {
      "filePath": "dashboard/jobs/head-blur-images/schedule/route.tsx",
      "parent": "/dashboard/jobs/head-blur-images",
      "children": [
        "/dashboard/jobs/head-blur-images/schedule/$scheduledJobId"
      ]
    },
    "/dashboard/jobs/head-blur-videos/jobs": {
      "filePath": "dashboard/jobs/head-blur-videos/jobs/route.tsx",
      "parent": "/dashboard/jobs/head-blur-videos",
      "children": [
        "/dashboard/jobs/head-blur-videos/jobs/$jobId"
      ]
    },
    "/dashboard/jobs/head-blur-videos/schedule": {
      "filePath": "dashboard/jobs/head-blur-videos/schedule/route.tsx",
      "parent": "/dashboard/jobs/head-blur-videos",
      "children": [
        "/dashboard/jobs/head-blur-videos/schedule/$scheduledJobId"
      ]
    },
    "/dashboard/jobs/models/jobs": {
      "filePath": "dashboard/jobs/models/jobs/route.tsx",
      "parent": "/dashboard/jobs/models",
      "children": [
        "/dashboard/jobs/models/jobs/$jobId"
      ]
    },
    "/dashboard/jobs/models/schedule": {
      "filePath": "dashboard/jobs/models/schedule/route.tsx",
      "parent": "/dashboard/jobs/models",
      "children": [
        "/dashboard/jobs/models/schedule/$scheduledJobId"
      ]
    },
    "/dashboard/jobs/recovery-estimates/jobs": {
      "filePath": "dashboard/jobs/recovery-estimates/jobs/route.tsx",
      "parent": "/dashboard/jobs/recovery-estimates",
      "children": [
        "/dashboard/jobs/recovery-estimates/jobs/$jobId"
      ]
    },
    "/dashboard/jobs/recovery-estimates/schedule": {
      "filePath": "dashboard/jobs/recovery-estimates/schedule/route.tsx",
      "parent": "/dashboard/jobs/recovery-estimates",
      "children": [
        "/dashboard/jobs/recovery-estimates/schedule/$scheduledJobId"
      ]
    },
    "/dashboard/jobs/restarts/jobs": {
      "filePath": "dashboard/jobs/restarts/jobs/route.tsx",
      "parent": "/dashboard/jobs/restarts",
      "children": [
        "/dashboard/jobs/restarts/jobs/$jobId"
      ]
    },
    "/dashboard/jobs/restarts/schedule": {
      "filePath": "dashboard/jobs/restarts/schedule/route.tsx",
      "parent": "/dashboard/jobs/restarts",
      "children": [
        "/dashboard/jobs/restarts/schedule/$scheduledJobId"
      ]
    },
    "/dashboard/jobs/sample-upload/alerts": {
      "filePath": "dashboard/jobs/sample-upload/alerts/route.tsx",
      "parent": "/dashboard/jobs/sample-upload"
    },
    "/dashboard/jobs/sample-upload/jobs": {
      "filePath": "dashboard/jobs/sample-upload/jobs/route.tsx",
      "parent": "/dashboard/jobs/sample-upload",
      "children": [
        "/dashboard/jobs/sample-upload/jobs/$jobId"
      ]
    },
    "/dashboard/jobs/sample-upload/schedule": {
      "filePath": "dashboard/jobs/sample-upload/schedule/route.tsx",
      "parent": "/dashboard/jobs/sample-upload",
      "children": [
        "/dashboard/jobs/sample-upload/schedule/$scheduledJobId"
      ]
    },
    "/dashboard/jobs/sync-samples/alerts": {
      "filePath": "dashboard/jobs/sync-samples/alerts/route.tsx",
      "parent": "/dashboard/jobs/sync-samples"
    },
    "/dashboard/jobs/sync-samples/jobs": {
      "filePath": "dashboard/jobs/sync-samples/jobs/route.tsx",
      "parent": "/dashboard/jobs/sync-samples",
      "children": [
        "/dashboard/jobs/sync-samples/jobs/$jobId"
      ]
    },
    "/dashboard/jobs/sync-samples/schedule": {
      "filePath": "dashboard/jobs/sync-samples/schedule/route.tsx",
      "parent": "/dashboard/jobs/sync-samples",
      "children": [
        "/dashboard/jobs/sync-samples/schedule/$scheduledJobId"
      ]
    },
    "/dashboard/jobs/training/jobs": {
      "filePath": "dashboard/jobs/training/jobs/route.tsx",
      "parent": "/dashboard/jobs/training",
      "children": [
        "/dashboard/jobs/training/jobs/$jobId"
      ]
    },
    "/dashboard/jobs/training/schedule": {
      "filePath": "dashboard/jobs/training/schedule/route.tsx",
      "parent": "/dashboard/jobs/training",
      "children": [
        "/dashboard/jobs/training/schedule/$scheduledJobId"
      ]
    },
    "/dashboard/jobs/video-upload/alerts": {
      "filePath": "dashboard/jobs/video-upload/alerts/route.tsx",
      "parent": "/dashboard/jobs/video-upload"
    },
    "/dashboard/jobs/video-upload/jobs": {
      "filePath": "dashboard/jobs/video-upload/jobs/route.tsx",
      "parent": "/dashboard/jobs/video-upload",
      "children": [
        "/dashboard/jobs/video-upload/jobs/$jobId"
      ]
    },
    "/dashboard/jobs/video-upload/schedule": {
      "filePath": "dashboard/jobs/video-upload/schedule/route.tsx",
      "parent": "/dashboard/jobs/video-upload",
      "children": [
        "/dashboard/jobs/video-upload/schedule/$scheduledJobId"
      ]
    },
    "/dashboard/jobs/worker-jobs/jobs": {
      "filePath": "dashboard/jobs/worker-jobs/jobs/route.tsx",
      "parent": "/dashboard/jobs/worker-jobs",
      "children": [
        "/dashboard/jobs/worker-jobs/jobs/$jobId"
      ]
    },
    "/dashboard/jobs/worker-jobs/schedule": {
      "filePath": "dashboard/jobs/worker-jobs/schedule/route.tsx",
      "parent": "/dashboard/jobs/worker-jobs",
      "children": [
        "/dashboard/jobs/worker-jobs/schedule/$scheduledJobId"
      ]
    },
    "/dashboard/models/$modelId/deployment": {
      "filePath": "dashboard/models/$modelId/deployment/route.tsx",
      "parent": "/dashboard/models/$modelId",
      "children": [
        "/dashboard/models/$modelId/deployment/clusters",
        "/dashboard/models/$modelId/deployment/devices",
        "/dashboard/models/$modelId/deployment/"
      ]
    },
    "/dashboard/models/$modelId/labels": {
      "filePath": "dashboard/models/$modelId/labels/route.tsx",
      "parent": "/dashboard/models/$modelId"
    },
    "/dashboard/models/$modelId/matrix": {
      "filePath": "dashboard/models/$modelId/matrix/route.tsx",
      "parent": "/dashboard/models/$modelId"
    },
    "/dashboard/models/$modelId/overview": {
      "filePath": "dashboard/models/$modelId/overview/route.tsx",
      "parent": "/dashboard/models/$modelId"
    },
    "/dashboard/resources/clusters/$clusterId": {
      "filePath": "dashboard/resources/clusters/$clusterId/route.tsx",
      "parent": "/dashboard/resources/clusters",
      "children": [
        "/dashboard/resources/clusters/$clusterId/devices",
        "/dashboard/resources/clusters/$clusterId/overview",
        "/dashboard/resources/clusters/$clusterId/"
      ]
    },
    "/dashboard/resources/devices/$deviceId": {
      "filePath": "dashboard/resources/devices/$deviceId/route.tsx",
      "parent": "/dashboard/resources/devices",
      "children": [
        "/dashboard/resources/devices/$deviceId/camera",
        "/dashboard/resources/devices/$deviceId/data",
        "/dashboard/resources/devices/$deviceId/diagnostics",
        "/dashboard/resources/devices/$deviceId/logs",
        "/dashboard/resources/devices/$deviceId/overview",
        "/dashboard/resources/devices/$deviceId/settings",
        "/dashboard/resources/devices/$deviceId/version-history",
        "/dashboard/resources/devices/$deviceId/"
      ]
    },
    "/dashboard/resources/site-groups/$siteGroupId": {
      "filePath": "dashboard/resources/site-groups/$siteGroupId/route.tsx",
      "parent": "/dashboard/resources/site-groups",
      "children": [
        "/dashboard/resources/site-groups/$siteGroupId/labels",
        "/dashboard/resources/site-groups/$siteGroupId/overview",
        "/dashboard/resources/site-groups/$siteGroupId/sites",
        "/dashboard/resources/site-groups/$siteGroupId/"
      ]
    },
    "/dashboard/resources/sites/$siteId": {
      "filePath": "dashboard/resources/sites/$siteId/route.tsx",
      "parent": "/dashboard/resources/sites",
      "children": [
        "/dashboard/resources/sites/$siteId/devices",
        "/dashboard/resources/sites/$siteId/overview",
        "/dashboard/resources/sites/$siteId/version-history",
        "/dashboard/resources/sites/$siteId/"
      ]
    },
    "/dashboard/settings/alert-management/alert-channels": {
      "filePath": "dashboard/settings/alert-management/alert-channels/route.tsx",
      "parent": "/dashboard/settings/alert-management"
    },
    "/dashboard/settings/alert-management/alerts": {
      "filePath": "dashboard/settings/alert-management/alerts/route.tsx",
      "parent": "/dashboard/settings/alert-management",
      "children": [
        "/dashboard/settings/alert-management/alerts/$alertId"
      ]
    },
    "/dashboard/settings/alert-management/metric-alerts": {
      "filePath": "dashboard/settings/alert-management/metric-alerts/route.tsx",
      "parent": "/dashboard/settings/alert-management",
      "children": [
        "/dashboard/settings/alert-management/metric-alerts/$metricAlertId/"
      ]
    },
    "/dashboard/settings/queues/$queueName": {
      "filePath": "dashboard/settings/queues/$queueName/route.tsx",
      "parent": "/dashboard/settings/queues",
      "children": [
        "/dashboard/settings/queues/$queueName/failures",
        "/dashboard/settings/queues/$queueName/pending",
        "/dashboard/settings/queues/$queueName/"
      ]
    },
    "/dashboard/settings/report-settings/$reportId": {
      "filePath": "dashboard/settings/report-settings/$reportId/route.tsx",
      "parent": "/dashboard/settings/report-settings",
      "children": [
        "/dashboard/settings/report-settings/$reportId/overview",
        "/dashboard/settings/report-settings/$reportId/parameters",
        "/dashboard/settings/report-settings/$reportId/send-log",
        "/dashboard/settings/report-settings/$reportId/subscriptions2",
        "/dashboard/settings/report-settings/$reportId/"
      ]
    },
    "/dashboard/settings/tags-management/catalog": {
      "filePath": "dashboard/settings/tags-management/catalog/route.tsx",
      "parent": "/dashboard/settings/tags-management",
      "children": [
        "/dashboard/settings/tags-management/catalog/$tagId"
      ]
    },
    "/dashboard/settings/tags-management/clusters": {
      "filePath": "dashboard/settings/tags-management/clusters/route.tsx",
      "parent": "/dashboard/settings/tags-management",
      "children": [
        "/dashboard/settings/tags-management/clusters/$tagId"
      ]
    },
    "/dashboard/settings/tags-management/devices": {
      "filePath": "dashboard/settings/tags-management/devices/route.tsx",
      "parent": "/dashboard/settings/tags-management",
      "children": [
        "/dashboard/settings/tags-management/devices/$tagId"
      ]
    },
    "/dashboard/settings/tags-management/samples": {
      "filePath": "dashboard/settings/tags-management/samples/route.tsx",
      "parent": "/dashboard/settings/tags-management",
      "children": [
        "/dashboard/settings/tags-management/samples/$tagId"
      ]
    },
    "/dashboard/settings/tags-management/sessions": {
      "filePath": "dashboard/settings/tags-management/sessions/route.tsx",
      "parent": "/dashboard/settings/tags-management",
      "children": [
        "/dashboard/settings/tags-management/sessions/$tagId"
      ]
    },
    "/dashboard/settings/tags-management/sites": {
      "filePath": "dashboard/settings/tags-management/sites/route.tsx",
      "parent": "/dashboard/settings/tags-management",
      "children": [
        "/dashboard/settings/tags-management/sites/$tagId"
      ]
    },
    "/dashboard/settings/user-management/$userId": {
      "filePath": "dashboard/settings/user-management/$userId/route.tsx",
      "parent": "/dashboard/settings/user-management",
      "children": [
        "/dashboard/settings/user-management/$userId/overview",
        "/dashboard/settings/user-management/$userId/"
      ]
    },
    "/dashboard/data/[/rest]": {
      "filePath": "dashboard/data/[...rest].tsx",
      "parent": "/dashboard/data"
    },
    "/dashboard/resources/[/rest]": {
      "filePath": "dashboard/resources/[...rest].tsx",
      "parent": "/dashboard/resources"
    },
    "/dashboard/settings/user-management/thumbnail": {
      "filePath": "dashboard/settings/user-management/thumbnail.tsx",
      "parent": "/dashboard/settings/user-management"
    },
    "/admin-dashboard/accounts-management/$accountId/": {
      "filePath": "admin-dashboard/accounts-management/$accountId/index.tsx",
      "parent": "/admin-dashboard/accounts-management/$accountId"
    },
    "/admin-dashboard/jobs/service-health-checks/": {
      "filePath": "admin-dashboard/jobs/service-health-checks/index.tsx",
      "parent": "/admin-dashboard/jobs/service-health-checks"
    },
    "/dashboard/home/manager-report/": {
      "filePath": "dashboard/home/manager-report/index.tsx",
      "parent": "/dashboard/home/manager-report"
    },
    "/dashboard/jobs/camera-calibration/": {
      "filePath": "dashboard/jobs/camera-calibration/index.tsx",
      "parent": "/dashboard/jobs/camera-calibration"
    },
    "/dashboard/jobs/capacity-tagging/": {
      "filePath": "dashboard/jobs/capacity-tagging/index.tsx",
      "parent": "/dashboard/jobs/capacity-tagging"
    },
    "/dashboard/jobs/catalog-upload/": {
      "filePath": "dashboard/jobs/catalog-upload/index.tsx",
      "parent": "/dashboard/jobs/catalog-upload"
    },
    "/dashboard/jobs/config/": {
      "filePath": "dashboard/jobs/config/index.tsx",
      "parent": "/dashboard/jobs/config"
    },
    "/dashboard/jobs/delete-samples/": {
      "filePath": "dashboard/jobs/delete-samples/index.tsx",
      "parent": "/dashboard/jobs/delete-samples"
    },
    "/dashboard/jobs/delete-videos/": {
      "filePath": "dashboard/jobs/delete-videos/index.tsx",
      "parent": "/dashboard/jobs/delete-videos"
    },
    "/dashboard/jobs/deployments/": {
      "filePath": "dashboard/jobs/deployments/index.tsx",
      "parent": "/dashboard/jobs/deployments"
    },
    "/dashboard/jobs/head-blur-images/": {
      "filePath": "dashboard/jobs/head-blur-images/index.tsx",
      "parent": "/dashboard/jobs/head-blur-images"
    },
    "/dashboard/jobs/head-blur-videos/": {
      "filePath": "dashboard/jobs/head-blur-videos/index.tsx",
      "parent": "/dashboard/jobs/head-blur-videos"
    },
    "/dashboard/jobs/models/": {
      "filePath": "dashboard/jobs/models/index.tsx",
      "parent": "/dashboard/jobs/models"
    },
    "/dashboard/jobs/recovery-estimates/": {
      "filePath": "dashboard/jobs/recovery-estimates/index.tsx",
      "parent": "/dashboard/jobs/recovery-estimates"
    },
    "/dashboard/jobs/restarts/": {
      "filePath": "dashboard/jobs/restarts/index.tsx",
      "parent": "/dashboard/jobs/restarts"
    },
    "/dashboard/jobs/sample-upload/": {
      "filePath": "dashboard/jobs/sample-upload/index.tsx",
      "parent": "/dashboard/jobs/sample-upload"
    },
    "/dashboard/jobs/sync-samples/": {
      "filePath": "dashboard/jobs/sync-samples/index.tsx",
      "parent": "/dashboard/jobs/sync-samples"
    },
    "/dashboard/jobs/training/": {
      "filePath": "dashboard/jobs/training/index.tsx",
      "parent": "/dashboard/jobs/training"
    },
    "/dashboard/jobs/video-upload/": {
      "filePath": "dashboard/jobs/video-upload/index.tsx",
      "parent": "/dashboard/jobs/video-upload"
    },
    "/dashboard/jobs/worker-jobs/": {
      "filePath": "dashboard/jobs/worker-jobs/index.tsx",
      "parent": "/dashboard/jobs/worker-jobs"
    },
    "/dashboard/models/$modelId/": {
      "filePath": "dashboard/models/$modelId/index.tsx",
      "parent": "/dashboard/models/$modelId"
    },
    "/dashboard/settings/alert-management/": {
      "filePath": "dashboard/settings/alert-management/index.tsx",
      "parent": "/dashboard/settings/alert-management"
    },
    "/dashboard/settings/queues/": {
      "filePath": "dashboard/settings/queues/index.tsx",
      "parent": "/dashboard/settings/queues"
    },
    "/dashboard/settings/tags-management/": {
      "filePath": "dashboard/settings/tags-management/index.tsx",
      "parent": "/dashboard/settings/tags-management"
    },
    "/admin-dashboard/jobs/service-health-checks/jobs/$jobId": {
      "filePath": "admin-dashboard/jobs/service-health-checks/jobs/$jobId/route.tsx",
      "parent": "/admin-dashboard/jobs/service-health-checks/jobs",
      "children": [
        "/admin-dashboard/jobs/service-health-checks/jobs/$jobId/overview",
        "/admin-dashboard/jobs/service-health-checks/jobs/$jobId/"
      ]
    },
    "/admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId": {
      "filePath": "admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId/route.tsx",
      "parent": "/admin-dashboard/jobs/service-health-checks/schedule",
      "children": [
        "/admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId/inputs",
        "/admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId/overview",
        "/admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId/schedule",
        "/admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId/"
      ]
    },
    "/dashboard/data/catalog/$item/details": {
      "filePath": "dashboard/data/catalog/$item/details/route.tsx",
      "parent": "/dashboard/data/catalog/$item"
    },
    "/dashboard/data/catalog/$item/labels": {
      "filePath": "dashboard/data/catalog/$item/labels/route.tsx",
      "parent": "/dashboard/data/catalog/$item"
    },
    "/dashboard/data/catalog/$item/prices": {
      "filePath": "dashboard/data/catalog/$item/prices/route.tsx",
      "parent": "/dashboard/data/catalog/$item"
    },
    "/dashboard/data/datasets/$datasetId/images": {
      "filePath": "dashboard/data/datasets/$datasetId/images/route.tsx",
      "parent": "/dashboard/data/datasets/$datasetId"
    },
    "/dashboard/data/datasets/$datasetId/overview": {
      "filePath": "dashboard/data/datasets/$datasetId/overview/route.tsx",
      "parent": "/dashboard/data/datasets/$datasetId"
    },
    "/dashboard/data/datasets/$datasetId/sessions": {
      "filePath": "dashboard/data/datasets/$datasetId/sessions/route.tsx",
      "parent": "/dashboard/data/datasets/$datasetId"
    },
    "/dashboard/data/images/$imageUUID/additional": {
      "filePath": "dashboard/data/images/$imageUUID/additional/route.tsx",
      "parent": "/dashboard/data/images/$imageUUID"
    },
    "/dashboard/data/images/$imageUUID/overview": {
      "filePath": "dashboard/data/images/$imageUUID/overview/route.tsx",
      "parent": "/dashboard/data/images/$imageUUID"
    },
    "/dashboard/data/images/$imageUUID/transaction-details": {
      "filePath": "dashboard/data/images/$imageUUID/transaction-details/route.tsx",
      "parent": "/dashboard/data/images/$imageUUID"
    },
    "/dashboard/data/sessions/$sessionId/overview": {
      "filePath": "dashboard/data/sessions/$sessionId/overview/route.tsx",
      "parent": "/dashboard/data/sessions/$sessionId"
    },
    "/dashboard/home/manager-report/$sessionId/overview": {
      "filePath": "dashboard/home/manager-report/$sessionId/overview/route.tsx",
      "parent": "/dashboard/home/manager-report/$sessionId"
    },
    "/dashboard/jobs/camera-calibration/jobs/$jobId": {
      "filePath": "dashboard/jobs/camera-calibration/jobs/$jobId/route.tsx",
      "parent": "/dashboard/jobs/camera-calibration/jobs",
      "children": [
        "/dashboard/jobs/camera-calibration/jobs/$jobId/devices",
        "/dashboard/jobs/camera-calibration/jobs/$jobId/overview",
        "/dashboard/jobs/camera-calibration/jobs/$jobId/"
      ]
    },
    "/dashboard/jobs/camera-calibration/schedule/$scheduledJobId": {
      "filePath": "dashboard/jobs/camera-calibration/schedule/$scheduledJobId/route.tsx",
      "parent": "/dashboard/jobs/camera-calibration/schedule",
      "children": [
        "/dashboard/jobs/camera-calibration/schedule/$scheduledJobId/inputs",
        "/dashboard/jobs/camera-calibration/schedule/$scheduledJobId/overview",
        "/dashboard/jobs/camera-calibration/schedule/$scheduledJobId/schedule",
        "/dashboard/jobs/camera-calibration/schedule/$scheduledJobId/"
      ]
    },
    "/dashboard/jobs/capacity-tagging/jobs/$jobId": {
      "filePath": "dashboard/jobs/capacity-tagging/jobs/$jobId/route.tsx",
      "parent": "/dashboard/jobs/capacity-tagging/jobs",
      "children": [
        "/dashboard/jobs/capacity-tagging/jobs/$jobId/overview",
        "/dashboard/jobs/capacity-tagging/jobs/$jobId/"
      ]
    },
    "/dashboard/jobs/capacity-tagging/schedule/$scheduledJobId": {
      "filePath": "dashboard/jobs/capacity-tagging/schedule/$scheduledJobId/route.tsx",
      "parent": "/dashboard/jobs/capacity-tagging/schedule",
      "children": [
        "/dashboard/jobs/capacity-tagging/schedule/$scheduledJobId/inputs",
        "/dashboard/jobs/capacity-tagging/schedule/$scheduledJobId/overview",
        "/dashboard/jobs/capacity-tagging/schedule/$scheduledJobId/schedule",
        "/dashboard/jobs/capacity-tagging/schedule/$scheduledJobId/"
      ]
    },
    "/dashboard/jobs/catalog-upload/jobs/$jobId": {
      "filePath": "dashboard/jobs/catalog-upload/jobs/$jobId/route.tsx",
      "parent": "/dashboard/jobs/catalog-upload/jobs",
      "children": [
        "/dashboard/jobs/catalog-upload/jobs/$jobId/devices",
        "/dashboard/jobs/catalog-upload/jobs/$jobId/labels",
        "/dashboard/jobs/catalog-upload/jobs/$jobId/overview",
        "/dashboard/jobs/catalog-upload/jobs/$jobId/"
      ]
    },
    "/dashboard/jobs/catalog-upload/schedule/$scheduledJobId": {
      "filePath": "dashboard/jobs/catalog-upload/schedule/$scheduledJobId/route.tsx",
      "parent": "/dashboard/jobs/catalog-upload/schedule",
      "children": [
        "/dashboard/jobs/catalog-upload/schedule/$scheduledJobId/labels",
        "/dashboard/jobs/catalog-upload/schedule/$scheduledJobId/overview",
        "/dashboard/jobs/catalog-upload/schedule/$scheduledJobId/schedule",
        "/dashboard/jobs/catalog-upload/schedule/$scheduledJobId/"
      ]
    },
    "/dashboard/jobs/config/jobs/$jobId": {
      "filePath": "dashboard/jobs/config/jobs/$jobId/route.tsx",
      "parent": "/dashboard/jobs/config/jobs",
      "children": [
        "/dashboard/jobs/config/jobs/$jobId/devices",
        "/dashboard/jobs/config/jobs/$jobId/overview",
        "/dashboard/jobs/config/jobs/$jobId/"
      ]
    },
    "/dashboard/jobs/config/schedule/$scheduledJobId": {
      "filePath": "dashboard/jobs/config/schedule/$scheduledJobId/route.tsx",
      "parent": "/dashboard/jobs/config/schedule",
      "children": [
        "/dashboard/jobs/config/schedule/$scheduledJobId/overview",
        "/dashboard/jobs/config/schedule/$scheduledJobId/schedule",
        "/dashboard/jobs/config/schedule/$scheduledJobId/"
      ]
    },
    "/dashboard/jobs/delete-samples/jobs/$jobId": {
      "filePath": "dashboard/jobs/delete-samples/jobs/$jobId/route.tsx",
      "parent": "/dashboard/jobs/delete-samples/jobs",
      "children": [
        "/dashboard/jobs/delete-samples/jobs/$jobId/devices",
        "/dashboard/jobs/delete-samples/jobs/$jobId/overview",
        "/dashboard/jobs/delete-samples/jobs/$jobId/"
      ]
    },
    "/dashboard/jobs/delete-samples/schedule/$scheduledJobId": {
      "filePath": "dashboard/jobs/delete-samples/schedule/$scheduledJobId/route.tsx",
      "parent": "/dashboard/jobs/delete-samples/schedule",
      "children": [
        "/dashboard/jobs/delete-samples/schedule/$scheduledJobId/inputs",
        "/dashboard/jobs/delete-samples/schedule/$scheduledJobId/overview",
        "/dashboard/jobs/delete-samples/schedule/$scheduledJobId/schedule",
        "/dashboard/jobs/delete-samples/schedule/$scheduledJobId/"
      ]
    },
    "/dashboard/jobs/delete-videos/jobs/$jobId": {
      "filePath": "dashboard/jobs/delete-videos/jobs/$jobId/route.tsx",
      "parent": "/dashboard/jobs/delete-videos/jobs",
      "children": [
        "/dashboard/jobs/delete-videos/jobs/$jobId/devices",
        "/dashboard/jobs/delete-videos/jobs/$jobId/overview",
        "/dashboard/jobs/delete-videos/jobs/$jobId/"
      ]
    },
    "/dashboard/jobs/delete-videos/schedule/$scheduledJobId": {
      "filePath": "dashboard/jobs/delete-videos/schedule/$scheduledJobId/route.tsx",
      "parent": "/dashboard/jobs/delete-videos/schedule",
      "children": [
        "/dashboard/jobs/delete-videos/schedule/$scheduledJobId/inputs",
        "/dashboard/jobs/delete-videos/schedule/$scheduledJobId/overview",
        "/dashboard/jobs/delete-videos/schedule/$scheduledJobId/schedule",
        "/dashboard/jobs/delete-videos/schedule/$scheduledJobId/"
      ]
    },
    "/dashboard/jobs/deployments/jobs/$jobId": {
      "filePath": "dashboard/jobs/deployments/jobs/$jobId/route.tsx",
      "parent": "/dashboard/jobs/deployments/jobs",
      "children": [
        "/dashboard/jobs/deployments/jobs/$jobId/devices",
        "/dashboard/jobs/deployments/jobs/$jobId/overview",
        "/dashboard/jobs/deployments/jobs/$jobId/"
      ]
    },
    "/dashboard/jobs/deployments/schedule/$scheduledJobId": {
      "filePath": "dashboard/jobs/deployments/schedule/$scheduledJobId/route.tsx",
      "parent": "/dashboard/jobs/deployments/schedule",
      "children": [
        "/dashboard/jobs/deployments/schedule/$scheduledJobId/overview",
        "/dashboard/jobs/deployments/schedule/$scheduledJobId/schedule",
        "/dashboard/jobs/deployments/schedule/$scheduledJobId/"
      ]
    },
    "/dashboard/jobs/head-blur-images/jobs/$jobId": {
      "filePath": "dashboard/jobs/head-blur-images/jobs/$jobId/route.tsx",
      "parent": "/dashboard/jobs/head-blur-images/jobs",
      "children": [
        "/dashboard/jobs/head-blur-images/jobs/$jobId/devices",
        "/dashboard/jobs/head-blur-images/jobs/$jobId/overview",
        "/dashboard/jobs/head-blur-images/jobs/$jobId/"
      ]
    },
    "/dashboard/jobs/head-blur-images/schedule/$scheduledJobId": {
      "filePath": "dashboard/jobs/head-blur-images/schedule/$scheduledJobId/route.tsx",
      "parent": "/dashboard/jobs/head-blur-images/schedule",
      "children": [
        "/dashboard/jobs/head-blur-images/schedule/$scheduledJobId/inputs",
        "/dashboard/jobs/head-blur-images/schedule/$scheduledJobId/overview",
        "/dashboard/jobs/head-blur-images/schedule/$scheduledJobId/schedule",
        "/dashboard/jobs/head-blur-images/schedule/$scheduledJobId/"
      ]
    },
    "/dashboard/jobs/head-blur-videos/jobs/$jobId": {
      "filePath": "dashboard/jobs/head-blur-videos/jobs/$jobId/route.tsx",
      "parent": "/dashboard/jobs/head-blur-videos/jobs",
      "children": [
        "/dashboard/jobs/head-blur-videos/jobs/$jobId/devices",
        "/dashboard/jobs/head-blur-videos/jobs/$jobId/overview",
        "/dashboard/jobs/head-blur-videos/jobs/$jobId/"
      ]
    },
    "/dashboard/jobs/head-blur-videos/schedule/$scheduledJobId": {
      "filePath": "dashboard/jobs/head-blur-videos/schedule/$scheduledJobId/route.tsx",
      "parent": "/dashboard/jobs/head-blur-videos/schedule",
      "children": [
        "/dashboard/jobs/head-blur-videos/schedule/$scheduledJobId/inputs",
        "/dashboard/jobs/head-blur-videos/schedule/$scheduledJobId/overview",
        "/dashboard/jobs/head-blur-videos/schedule/$scheduledJobId/schedule",
        "/dashboard/jobs/head-blur-videos/schedule/$scheduledJobId/"
      ]
    },
    "/dashboard/jobs/models/jobs/$jobId": {
      "filePath": "dashboard/jobs/models/jobs/$jobId/route.tsx",
      "parent": "/dashboard/jobs/models/jobs",
      "children": [
        "/dashboard/jobs/models/jobs/$jobId/devices",
        "/dashboard/jobs/models/jobs/$jobId/overview",
        "/dashboard/jobs/models/jobs/$jobId/"
      ]
    },
    "/dashboard/jobs/models/schedule/$scheduledJobId": {
      "filePath": "dashboard/jobs/models/schedule/$scheduledJobId/route.tsx",
      "parent": "/dashboard/jobs/models/schedule",
      "children": [
        "/dashboard/jobs/models/schedule/$scheduledJobId/overview",
        "/dashboard/jobs/models/schedule/$scheduledJobId/schedule",
        "/dashboard/jobs/models/schedule/$scheduledJobId/"
      ]
    },
    "/dashboard/jobs/recovery-estimates/jobs/$jobId": {
      "filePath": "dashboard/jobs/recovery-estimates/jobs/$jobId/route.tsx",
      "parent": "/dashboard/jobs/recovery-estimates/jobs",
      "children": [
        "/dashboard/jobs/recovery-estimates/jobs/$jobId/overview",
        "/dashboard/jobs/recovery-estimates/jobs/$jobId/"
      ]
    },
    "/dashboard/jobs/recovery-estimates/schedule/$scheduledJobId": {
      "filePath": "dashboard/jobs/recovery-estimates/schedule/$scheduledJobId/route.tsx",
      "parent": "/dashboard/jobs/recovery-estimates/schedule",
      "children": [
        "/dashboard/jobs/recovery-estimates/schedule/$scheduledJobId/inputs",
        "/dashboard/jobs/recovery-estimates/schedule/$scheduledJobId/overview",
        "/dashboard/jobs/recovery-estimates/schedule/$scheduledJobId/schedule",
        "/dashboard/jobs/recovery-estimates/schedule/$scheduledJobId/"
      ]
    },
    "/dashboard/jobs/restarts/jobs/$jobId": {
      "filePath": "dashboard/jobs/restarts/jobs/$jobId/route.tsx",
      "parent": "/dashboard/jobs/restarts/jobs",
      "children": [
        "/dashboard/jobs/restarts/jobs/$jobId/devices",
        "/dashboard/jobs/restarts/jobs/$jobId/overview",
        "/dashboard/jobs/restarts/jobs/$jobId/"
      ]
    },
    "/dashboard/jobs/restarts/schedule/$scheduledJobId": {
      "filePath": "dashboard/jobs/restarts/schedule/$scheduledJobId/route.tsx",
      "parent": "/dashboard/jobs/restarts/schedule",
      "children": [
        "/dashboard/jobs/restarts/schedule/$scheduledJobId/overview",
        "/dashboard/jobs/restarts/schedule/$scheduledJobId/schedule",
        "/dashboard/jobs/restarts/schedule/$scheduledJobId/"
      ]
    },
    "/dashboard/jobs/sample-upload/jobs/$jobId": {
      "filePath": "dashboard/jobs/sample-upload/jobs/$jobId/route.tsx",
      "parent": "/dashboard/jobs/sample-upload/jobs",
      "children": [
        "/dashboard/jobs/sample-upload/jobs/$jobId/devices",
        "/dashboard/jobs/sample-upload/jobs/$jobId/overview",
        "/dashboard/jobs/sample-upload/jobs/$jobId/"
      ]
    },
    "/dashboard/jobs/sample-upload/schedule/$scheduledJobId": {
      "filePath": "dashboard/jobs/sample-upload/schedule/$scheduledJobId/route.tsx",
      "parent": "/dashboard/jobs/sample-upload/schedule",
      "children": [
        "/dashboard/jobs/sample-upload/schedule/$scheduledJobId/inputs",
        "/dashboard/jobs/sample-upload/schedule/$scheduledJobId/overview",
        "/dashboard/jobs/sample-upload/schedule/$scheduledJobId/schedule",
        "/dashboard/jobs/sample-upload/schedule/$scheduledJobId/"
      ]
    },
    "/dashboard/jobs/sync-samples/jobs/$jobId": {
      "filePath": "dashboard/jobs/sync-samples/jobs/$jobId/route.tsx",
      "parent": "/dashboard/jobs/sync-samples/jobs",
      "children": [
        "/dashboard/jobs/sync-samples/jobs/$jobId/devices",
        "/dashboard/jobs/sync-samples/jobs/$jobId/overview",
        "/dashboard/jobs/sync-samples/jobs/$jobId/"
      ]
    },
    "/dashboard/jobs/sync-samples/schedule/$scheduledJobId": {
      "filePath": "dashboard/jobs/sync-samples/schedule/$scheduledJobId/route.tsx",
      "parent": "/dashboard/jobs/sync-samples/schedule",
      "children": [
        "/dashboard/jobs/sync-samples/schedule/$scheduledJobId/inputs",
        "/dashboard/jobs/sync-samples/schedule/$scheduledJobId/overview",
        "/dashboard/jobs/sync-samples/schedule/$scheduledJobId/schedule",
        "/dashboard/jobs/sync-samples/schedule/$scheduledJobId/"
      ]
    },
    "/dashboard/jobs/training/jobs/$jobId": {
      "filePath": "dashboard/jobs/training/jobs/$jobId/route.tsx",
      "parent": "/dashboard/jobs/training/jobs",
      "children": [
        "/dashboard/jobs/training/jobs/$jobId/devices",
        "/dashboard/jobs/training/jobs/$jobId/labels",
        "/dashboard/jobs/training/jobs/$jobId/metrics",
        "/dashboard/jobs/training/jobs/$jobId/overview",
        "/dashboard/jobs/training/jobs/$jobId/"
      ]
    },
    "/dashboard/jobs/training/schedule/$scheduledJobId": {
      "filePath": "dashboard/jobs/training/schedule/$scheduledJobId/route.tsx",
      "parent": "/dashboard/jobs/training/schedule",
      "children": [
        "/dashboard/jobs/training/schedule/$scheduledJobId/inputs",
        "/dashboard/jobs/training/schedule/$scheduledJobId/overview",
        "/dashboard/jobs/training/schedule/$scheduledJobId/schedule",
        "/dashboard/jobs/training/schedule/$scheduledJobId/"
      ]
    },
    "/dashboard/jobs/video-upload/jobs/$jobId": {
      "filePath": "dashboard/jobs/video-upload/jobs/$jobId/route.tsx",
      "parent": "/dashboard/jobs/video-upload/jobs",
      "children": [
        "/dashboard/jobs/video-upload/jobs/$jobId/devices",
        "/dashboard/jobs/video-upload/jobs/$jobId/overview",
        "/dashboard/jobs/video-upload/jobs/$jobId/"
      ]
    },
    "/dashboard/jobs/video-upload/schedule/$scheduledJobId": {
      "filePath": "dashboard/jobs/video-upload/schedule/$scheduledJobId/route.tsx",
      "parent": "/dashboard/jobs/video-upload/schedule",
      "children": [
        "/dashboard/jobs/video-upload/schedule/$scheduledJobId/inputs",
        "/dashboard/jobs/video-upload/schedule/$scheduledJobId/overview",
        "/dashboard/jobs/video-upload/schedule/$scheduledJobId/schedule",
        "/dashboard/jobs/video-upload/schedule/$scheduledJobId/"
      ]
    },
    "/dashboard/jobs/worker-jobs/jobs/$jobId": {
      "filePath": "dashboard/jobs/worker-jobs/jobs/$jobId/route.tsx",
      "parent": "/dashboard/jobs/worker-jobs/jobs",
      "children": [
        "/dashboard/jobs/worker-jobs/jobs/$jobId/devices",
        "/dashboard/jobs/worker-jobs/jobs/$jobId/overview",
        "/dashboard/jobs/worker-jobs/jobs/$jobId/"
      ]
    },
    "/dashboard/jobs/worker-jobs/schedule/$scheduledJobId": {
      "filePath": "dashboard/jobs/worker-jobs/schedule/$scheduledJobId/route.tsx",
      "parent": "/dashboard/jobs/worker-jobs/schedule",
      "children": [
        "/dashboard/jobs/worker-jobs/schedule/$scheduledJobId/inputs",
        "/dashboard/jobs/worker-jobs/schedule/$scheduledJobId/overview",
        "/dashboard/jobs/worker-jobs/schedule/$scheduledJobId/schedule",
        "/dashboard/jobs/worker-jobs/schedule/$scheduledJobId/"
      ]
    },
    "/dashboard/models/$modelId/deployment/clusters": {
      "filePath": "dashboard/models/$modelId/deployment/clusters/route.tsx",
      "parent": "/dashboard/models/$modelId/deployment"
    },
    "/dashboard/models/$modelId/deployment/devices": {
      "filePath": "dashboard/models/$modelId/deployment/devices/route.tsx",
      "parent": "/dashboard/models/$modelId/deployment"
    },
    "/dashboard/resources/clusters/$clusterId/devices": {
      "filePath": "dashboard/resources/clusters/$clusterId/devices/route.tsx",
      "parent": "/dashboard/resources/clusters/$clusterId"
    },
    "/dashboard/resources/clusters/$clusterId/overview": {
      "filePath": "dashboard/resources/clusters/$clusterId/overview/route.tsx",
      "parent": "/dashboard/resources/clusters/$clusterId"
    },
    "/dashboard/resources/devices/$deviceId/camera": {
      "filePath": "dashboard/resources/devices/$deviceId/camera/route.tsx",
      "parent": "/dashboard/resources/devices/$deviceId"
    },
    "/dashboard/resources/devices/$deviceId/data": {
      "filePath": "dashboard/resources/devices/$deviceId/data/route.tsx",
      "parent": "/dashboard/resources/devices/$deviceId",
      "children": [
        "/dashboard/resources/devices/$deviceId/data/samples",
        "/dashboard/resources/devices/$deviceId/data/sessions",
        "/dashboard/resources/devices/$deviceId/data/text-json",
        "/dashboard/resources/devices/$deviceId/data/"
      ]
    },
    "/dashboard/resources/devices/$deviceId/diagnostics": {
      "filePath": "dashboard/resources/devices/$deviceId/diagnostics/route.tsx",
      "parent": "/dashboard/resources/devices/$deviceId",
      "children": [
        "/dashboard/resources/devices/$deviceId/diagnostics/classifier",
        "/dashboard/resources/devices/$deviceId/diagnostics/custom",
        "/dashboard/resources/devices/$deviceId/diagnostics/object-detection"
      ]
    },
    "/dashboard/resources/devices/$deviceId/logs": {
      "filePath": "dashboard/resources/devices/$deviceId/logs/route.tsx",
      "parent": "/dashboard/resources/devices/$deviceId"
    },
    "/dashboard/resources/devices/$deviceId/overview": {
      "filePath": "dashboard/resources/devices/$deviceId/overview/route.tsx",
      "parent": "/dashboard/resources/devices/$deviceId"
    },
    "/dashboard/resources/devices/$deviceId/settings": {
      "filePath": "dashboard/resources/devices/$deviceId/settings/route.tsx",
      "parent": "/dashboard/resources/devices/$deviceId"
    },
    "/dashboard/resources/devices/$deviceId/version-history": {
      "filePath": "dashboard/resources/devices/$deviceId/version-history/route.tsx",
      "parent": "/dashboard/resources/devices/$deviceId",
      "children": [
        "/dashboard/resources/devices/$deviceId/version-history/agent",
        "/dashboard/resources/devices/$deviceId/version-history/detector",
        "/dashboard/resources/devices/$deviceId/version-history/models",
        "/dashboard/resources/devices/$deviceId/version-history/on-screen-app",
        "/dashboard/resources/devices/$deviceId/version-history/trainer",
        "/dashboard/resources/devices/$deviceId/version-history/zebra-adapter",
        "/dashboard/resources/devices/$deviceId/version-history/"
      ]
    },
    "/dashboard/resources/site-groups/$siteGroupId/labels": {
      "filePath": "dashboard/resources/site-groups/$siteGroupId/labels/route.tsx",
      "parent": "/dashboard/resources/site-groups/$siteGroupId"
    },
    "/dashboard/resources/site-groups/$siteGroupId/overview": {
      "filePath": "dashboard/resources/site-groups/$siteGroupId/overview/route.tsx",
      "parent": "/dashboard/resources/site-groups/$siteGroupId"
    },
    "/dashboard/resources/site-groups/$siteGroupId/sites": {
      "filePath": "dashboard/resources/site-groups/$siteGroupId/sites/route.tsx",
      "parent": "/dashboard/resources/site-groups/$siteGroupId"
    },
    "/dashboard/resources/sites/$siteId/devices": {
      "filePath": "dashboard/resources/sites/$siteId/devices/route.tsx",
      "parent": "/dashboard/resources/sites/$siteId"
    },
    "/dashboard/resources/sites/$siteId/overview": {
      "filePath": "dashboard/resources/sites/$siteId/overview/route.tsx",
      "parent": "/dashboard/resources/sites/$siteId"
    },
    "/dashboard/resources/sites/$siteId/version-history": {
      "filePath": "dashboard/resources/sites/$siteId/version-history/route.tsx",
      "parent": "/dashboard/resources/sites/$siteId",
      "children": [
        "/dashboard/resources/sites/$siteId/version-history/agent",
        "/dashboard/resources/sites/$siteId/version-history/detector",
        "/dashboard/resources/sites/$siteId/version-history/on-screen-app",
        "/dashboard/resources/sites/$siteId/version-history/trainer",
        "/dashboard/resources/sites/$siteId/version-history/zebra-adapter",
        "/dashboard/resources/sites/$siteId/version-history/"
      ]
    },
    "/dashboard/settings/alert-management/alerts/$alertId": {
      "filePath": "dashboard/settings/alert-management/alerts/$alertId/route.tsx",
      "parent": "/dashboard/settings/alert-management/alerts",
      "children": [
        "/dashboard/settings/alert-management/alerts/$alertId/overview",
        "/dashboard/settings/alert-management/alerts/$alertId/"
      ]
    },
    "/dashboard/settings/queues/$queueName/failures": {
      "filePath": "dashboard/settings/queues/$queueName/failures/route.tsx",
      "parent": "/dashboard/settings/queues/$queueName",
      "children": [
        "/dashboard/settings/queues/$queueName/failures/$index"
      ]
    },
    "/dashboard/settings/queues/$queueName/pending": {
      "filePath": "dashboard/settings/queues/$queueName/pending/route.tsx",
      "parent": "/dashboard/settings/queues/$queueName",
      "children": [
        "/dashboard/settings/queues/$queueName/pending/$index"
      ]
    },
    "/dashboard/settings/report-settings/$reportId/overview": {
      "filePath": "dashboard/settings/report-settings/$reportId/overview/route.tsx",
      "parent": "/dashboard/settings/report-settings/$reportId"
    },
    "/dashboard/settings/report-settings/$reportId/parameters": {
      "filePath": "dashboard/settings/report-settings/$reportId/parameters/route.tsx",
      "parent": "/dashboard/settings/report-settings/$reportId"
    },
    "/dashboard/settings/report-settings/$reportId/send-log": {
      "filePath": "dashboard/settings/report-settings/$reportId/send-log/route.tsx",
      "parent": "/dashboard/settings/report-settings/$reportId"
    },
    "/dashboard/settings/report-settings/$reportId/subscriptions2": {
      "filePath": "dashboard/settings/report-settings/$reportId/subscriptions2/route.tsx",
      "parent": "/dashboard/settings/report-settings/$reportId"
    },
    "/dashboard/settings/report-subscription/$reportId/$subscriptionId": {
      "filePath": "dashboard/settings/report-subscription/$reportId/$subscriptionId/route.tsx",
      "parent": "/dashboard/settings",
      "children": [
        "/dashboard/settings/report-subscription/$reportId/$subscriptionId/edit",
        "/dashboard/settings/report-subscription/$reportId/$subscriptionId/overview",
        "/dashboard/settings/report-subscription/$reportId/$subscriptionId/review-and-approve",
        "/dashboard/settings/report-subscription/$reportId/$subscriptionId/send-history",
        "/dashboard/settings/report-subscription/$reportId/$subscriptionId/"
      ]
    },
    "/dashboard/settings/tags-management/catalog/$tagId": {
      "filePath": "dashboard/settings/tags-management/catalog/$tagId/route.tsx",
      "parent": "/dashboard/settings/tags-management/catalog",
      "children": [
        "/dashboard/settings/tags-management/catalog/$tagId/details",
        "/dashboard/settings/tags-management/catalog/$tagId/"
      ]
    },
    "/dashboard/settings/tags-management/clusters/$tagId": {
      "filePath": "dashboard/settings/tags-management/clusters/$tagId/route.tsx",
      "parent": "/dashboard/settings/tags-management/clusters",
      "children": [
        "/dashboard/settings/tags-management/clusters/$tagId/details",
        "/dashboard/settings/tags-management/clusters/$tagId/"
      ]
    },
    "/dashboard/settings/tags-management/devices/$tagId": {
      "filePath": "dashboard/settings/tags-management/devices/$tagId/route.tsx",
      "parent": "/dashboard/settings/tags-management/devices",
      "children": [
        "/dashboard/settings/tags-management/devices/$tagId/details",
        "/dashboard/settings/tags-management/devices/$tagId/"
      ]
    },
    "/dashboard/settings/tags-management/samples/$tagId": {
      "filePath": "dashboard/settings/tags-management/samples/$tagId/route.tsx",
      "parent": "/dashboard/settings/tags-management/samples",
      "children": [
        "/dashboard/settings/tags-management/samples/$tagId/details",
        "/dashboard/settings/tags-management/samples/$tagId/"
      ]
    },
    "/dashboard/settings/tags-management/sessions/$tagId": {
      "filePath": "dashboard/settings/tags-management/sessions/$tagId/route.tsx",
      "parent": "/dashboard/settings/tags-management/sessions",
      "children": [
        "/dashboard/settings/tags-management/sessions/$tagId/details",
        "/dashboard/settings/tags-management/sessions/$tagId/"
      ]
    },
    "/dashboard/settings/tags-management/sites/$tagId": {
      "filePath": "dashboard/settings/tags-management/sites/$tagId/route.tsx",
      "parent": "/dashboard/settings/tags-management/sites",
      "children": [
        "/dashboard/settings/tags-management/sites/$tagId/details",
        "/dashboard/settings/tags-management/sites/$tagId/"
      ]
    },
    "/dashboard/settings/user-management/$userId/overview": {
      "filePath": "dashboard/settings/user-management/$userId/overview/route.tsx",
      "parent": "/dashboard/settings/user-management/$userId"
    },
    "/dashboard/data/json-data/$jsonDataUUID/overview": {
      "filePath": "dashboard/data/json-data/$jsonDataUUID/overview.tsx",
      "parent": "/dashboard/data/json-data/$jsonDataUUID"
    },
    "/dashboard/data/catalog/$item/": {
      "filePath": "dashboard/data/catalog/$item/index.tsx",
      "parent": "/dashboard/data/catalog/$item"
    },
    "/dashboard/data/images/$imageUUID/": {
      "filePath": "dashboard/data/images/$imageUUID/index.tsx",
      "parent": "/dashboard/data/images/$imageUUID"
    },
    "/dashboard/data/json-data/$jsonDataUUID/": {
      "filePath": "dashboard/data/json-data/$jsonDataUUID/index.tsx",
      "parent": "/dashboard/data/json-data/$jsonDataUUID"
    },
    "/dashboard/data/label-distribution/$label/": {
      "filePath": "dashboard/data/label-distribution/$label/index.tsx",
      "parent": "/dashboard/data/label-distribution/$label"
    },
    "/dashboard/data/sessions/$sessionId/": {
      "filePath": "dashboard/data/sessions/$sessionId/index.tsx",
      "parent": "/dashboard/data/sessions/$sessionId"
    },
    "/dashboard/home/manager-report/$sessionId/": {
      "filePath": "dashboard/home/manager-report/$sessionId/index.tsx",
      "parent": "/dashboard/home/manager-report/$sessionId"
    },
    "/dashboard/models/$modelId/deployment/": {
      "filePath": "dashboard/models/$modelId/deployment/index.tsx",
      "parent": "/dashboard/models/$modelId/deployment"
    },
    "/dashboard/resources/clusters/$clusterId/": {
      "filePath": "dashboard/resources/clusters/$clusterId/index.tsx",
      "parent": "/dashboard/resources/clusters/$clusterId"
    },
    "/dashboard/resources/devices/$deviceId/": {
      "filePath": "dashboard/resources/devices/$deviceId/index.tsx",
      "parent": "/dashboard/resources/devices/$deviceId"
    },
    "/dashboard/resources/site-groups/$siteGroupId/": {
      "filePath": "dashboard/resources/site-groups/$siteGroupId/index.tsx",
      "parent": "/dashboard/resources/site-groups/$siteGroupId"
    },
    "/dashboard/resources/sites/$siteId/": {
      "filePath": "dashboard/resources/sites/$siteId/index.tsx",
      "parent": "/dashboard/resources/sites/$siteId"
    },
    "/dashboard/settings/queues/$queueName/": {
      "filePath": "dashboard/settings/queues/$queueName/index.tsx",
      "parent": "/dashboard/settings/queues/$queueName"
    },
    "/dashboard/settings/report-settings/$reportId/": {
      "filePath": "dashboard/settings/report-settings/$reportId/index.tsx",
      "parent": "/dashboard/settings/report-settings/$reportId"
    },
    "/dashboard/settings/user-management/$userId/": {
      "filePath": "dashboard/settings/user-management/$userId/index.tsx",
      "parent": "/dashboard/settings/user-management/$userId"
    },
    "/admin-dashboard/jobs/service-health-checks/jobs/$jobId/overview": {
      "filePath": "admin-dashboard/jobs/service-health-checks/jobs/$jobId/overview/route.tsx",
      "parent": "/admin-dashboard/jobs/service-health-checks/jobs/$jobId"
    },
    "/admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId/inputs": {
      "filePath": "admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId/inputs/route.tsx",
      "parent": "/admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId"
    },
    "/admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId/overview": {
      "filePath": "admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId/overview/route.tsx",
      "parent": "/admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId"
    },
    "/admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId/schedule": {
      "filePath": "admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId/schedule/route.tsx",
      "parent": "/admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId"
    },
    "/dashboard/jobs/camera-calibration/jobs/$jobId/devices": {
      "filePath": "dashboard/jobs/camera-calibration/jobs/$jobId/devices/route.tsx",
      "parent": "/dashboard/jobs/camera-calibration/jobs/$jobId"
    },
    "/dashboard/jobs/camera-calibration/jobs/$jobId/overview": {
      "filePath": "dashboard/jobs/camera-calibration/jobs/$jobId/overview/route.tsx",
      "parent": "/dashboard/jobs/camera-calibration/jobs/$jobId"
    },
    "/dashboard/jobs/camera-calibration/schedule/$scheduledJobId/inputs": {
      "filePath": "dashboard/jobs/camera-calibration/schedule/$scheduledJobId/inputs/route.tsx",
      "parent": "/dashboard/jobs/camera-calibration/schedule/$scheduledJobId"
    },
    "/dashboard/jobs/camera-calibration/schedule/$scheduledJobId/overview": {
      "filePath": "dashboard/jobs/camera-calibration/schedule/$scheduledJobId/overview/route.tsx",
      "parent": "/dashboard/jobs/camera-calibration/schedule/$scheduledJobId"
    },
    "/dashboard/jobs/camera-calibration/schedule/$scheduledJobId/schedule": {
      "filePath": "dashboard/jobs/camera-calibration/schedule/$scheduledJobId/schedule/route.tsx",
      "parent": "/dashboard/jobs/camera-calibration/schedule/$scheduledJobId"
    },
    "/dashboard/jobs/capacity-tagging/jobs/$jobId/overview": {
      "filePath": "dashboard/jobs/capacity-tagging/jobs/$jobId/overview/route.tsx",
      "parent": "/dashboard/jobs/capacity-tagging/jobs/$jobId"
    },
    "/dashboard/jobs/capacity-tagging/schedule/$scheduledJobId/inputs": {
      "filePath": "dashboard/jobs/capacity-tagging/schedule/$scheduledJobId/inputs/route.tsx",
      "parent": "/dashboard/jobs/capacity-tagging/schedule/$scheduledJobId"
    },
    "/dashboard/jobs/capacity-tagging/schedule/$scheduledJobId/overview": {
      "filePath": "dashboard/jobs/capacity-tagging/schedule/$scheduledJobId/overview/route.tsx",
      "parent": "/dashboard/jobs/capacity-tagging/schedule/$scheduledJobId"
    },
    "/dashboard/jobs/capacity-tagging/schedule/$scheduledJobId/schedule": {
      "filePath": "dashboard/jobs/capacity-tagging/schedule/$scheduledJobId/schedule/route.tsx",
      "parent": "/dashboard/jobs/capacity-tagging/schedule/$scheduledJobId"
    },
    "/dashboard/jobs/catalog-upload/jobs/$jobId/devices": {
      "filePath": "dashboard/jobs/catalog-upload/jobs/$jobId/devices/route.tsx",
      "parent": "/dashboard/jobs/catalog-upload/jobs/$jobId"
    },
    "/dashboard/jobs/catalog-upload/jobs/$jobId/labels": {
      "filePath": "dashboard/jobs/catalog-upload/jobs/$jobId/labels/route.tsx",
      "parent": "/dashboard/jobs/catalog-upload/jobs/$jobId"
    },
    "/dashboard/jobs/catalog-upload/jobs/$jobId/overview": {
      "filePath": "dashboard/jobs/catalog-upload/jobs/$jobId/overview/route.tsx",
      "parent": "/dashboard/jobs/catalog-upload/jobs/$jobId"
    },
    "/dashboard/jobs/catalog-upload/schedule/$scheduledJobId/labels": {
      "filePath": "dashboard/jobs/catalog-upload/schedule/$scheduledJobId/labels/route.tsx",
      "parent": "/dashboard/jobs/catalog-upload/schedule/$scheduledJobId"
    },
    "/dashboard/jobs/catalog-upload/schedule/$scheduledJobId/overview": {
      "filePath": "dashboard/jobs/catalog-upload/schedule/$scheduledJobId/overview/route.tsx",
      "parent": "/dashboard/jobs/catalog-upload/schedule/$scheduledJobId"
    },
    "/dashboard/jobs/catalog-upload/schedule/$scheduledJobId/schedule": {
      "filePath": "dashboard/jobs/catalog-upload/schedule/$scheduledJobId/schedule/route.tsx",
      "parent": "/dashboard/jobs/catalog-upload/schedule/$scheduledJobId"
    },
    "/dashboard/jobs/config/jobs/$jobId/devices": {
      "filePath": "dashboard/jobs/config/jobs/$jobId/devices/route.tsx",
      "parent": "/dashboard/jobs/config/jobs/$jobId"
    },
    "/dashboard/jobs/config/jobs/$jobId/overview": {
      "filePath": "dashboard/jobs/config/jobs/$jobId/overview/route.tsx",
      "parent": "/dashboard/jobs/config/jobs/$jobId"
    },
    "/dashboard/jobs/config/schedule/$scheduledJobId/overview": {
      "filePath": "dashboard/jobs/config/schedule/$scheduledJobId/overview/route.tsx",
      "parent": "/dashboard/jobs/config/schedule/$scheduledJobId"
    },
    "/dashboard/jobs/config/schedule/$scheduledJobId/schedule": {
      "filePath": "dashboard/jobs/config/schedule/$scheduledJobId/schedule/route.tsx",
      "parent": "/dashboard/jobs/config/schedule/$scheduledJobId"
    },
    "/dashboard/jobs/delete-samples/jobs/$jobId/devices": {
      "filePath": "dashboard/jobs/delete-samples/jobs/$jobId/devices/route.tsx",
      "parent": "/dashboard/jobs/delete-samples/jobs/$jobId"
    },
    "/dashboard/jobs/delete-samples/jobs/$jobId/overview": {
      "filePath": "dashboard/jobs/delete-samples/jobs/$jobId/overview/route.tsx",
      "parent": "/dashboard/jobs/delete-samples/jobs/$jobId"
    },
    "/dashboard/jobs/delete-samples/schedule/$scheduledJobId/inputs": {
      "filePath": "dashboard/jobs/delete-samples/schedule/$scheduledJobId/inputs/route.tsx",
      "parent": "/dashboard/jobs/delete-samples/schedule/$scheduledJobId"
    },
    "/dashboard/jobs/delete-samples/schedule/$scheduledJobId/overview": {
      "filePath": "dashboard/jobs/delete-samples/schedule/$scheduledJobId/overview/route.tsx",
      "parent": "/dashboard/jobs/delete-samples/schedule/$scheduledJobId"
    },
    "/dashboard/jobs/delete-samples/schedule/$scheduledJobId/schedule": {
      "filePath": "dashboard/jobs/delete-samples/schedule/$scheduledJobId/schedule/route.tsx",
      "parent": "/dashboard/jobs/delete-samples/schedule/$scheduledJobId"
    },
    "/dashboard/jobs/delete-videos/jobs/$jobId/devices": {
      "filePath": "dashboard/jobs/delete-videos/jobs/$jobId/devices/route.tsx",
      "parent": "/dashboard/jobs/delete-videos/jobs/$jobId"
    },
    "/dashboard/jobs/delete-videos/jobs/$jobId/overview": {
      "filePath": "dashboard/jobs/delete-videos/jobs/$jobId/overview/route.tsx",
      "parent": "/dashboard/jobs/delete-videos/jobs/$jobId"
    },
    "/dashboard/jobs/delete-videos/schedule/$scheduledJobId/inputs": {
      "filePath": "dashboard/jobs/delete-videos/schedule/$scheduledJobId/inputs/route.tsx",
      "parent": "/dashboard/jobs/delete-videos/schedule/$scheduledJobId"
    },
    "/dashboard/jobs/delete-videos/schedule/$scheduledJobId/overview": {
      "filePath": "dashboard/jobs/delete-videos/schedule/$scheduledJobId/overview/route.tsx",
      "parent": "/dashboard/jobs/delete-videos/schedule/$scheduledJobId"
    },
    "/dashboard/jobs/delete-videos/schedule/$scheduledJobId/schedule": {
      "filePath": "dashboard/jobs/delete-videos/schedule/$scheduledJobId/schedule/route.tsx",
      "parent": "/dashboard/jobs/delete-videos/schedule/$scheduledJobId"
    },
    "/dashboard/jobs/deployments/jobs/$jobId/devices": {
      "filePath": "dashboard/jobs/deployments/jobs/$jobId/devices/route.tsx",
      "parent": "/dashboard/jobs/deployments/jobs/$jobId"
    },
    "/dashboard/jobs/deployments/jobs/$jobId/overview": {
      "filePath": "dashboard/jobs/deployments/jobs/$jobId/overview/route.tsx",
      "parent": "/dashboard/jobs/deployments/jobs/$jobId"
    },
    "/dashboard/jobs/deployments/schedule/$scheduledJobId/overview": {
      "filePath": "dashboard/jobs/deployments/schedule/$scheduledJobId/overview/route.tsx",
      "parent": "/dashboard/jobs/deployments/schedule/$scheduledJobId"
    },
    "/dashboard/jobs/deployments/schedule/$scheduledJobId/schedule": {
      "filePath": "dashboard/jobs/deployments/schedule/$scheduledJobId/schedule/route.tsx",
      "parent": "/dashboard/jobs/deployments/schedule/$scheduledJobId"
    },
    "/dashboard/jobs/head-blur-images/jobs/$jobId/devices": {
      "filePath": "dashboard/jobs/head-blur-images/jobs/$jobId/devices/route.tsx",
      "parent": "/dashboard/jobs/head-blur-images/jobs/$jobId"
    },
    "/dashboard/jobs/head-blur-images/jobs/$jobId/overview": {
      "filePath": "dashboard/jobs/head-blur-images/jobs/$jobId/overview/route.tsx",
      "parent": "/dashboard/jobs/head-blur-images/jobs/$jobId"
    },
    "/dashboard/jobs/head-blur-images/schedule/$scheduledJobId/inputs": {
      "filePath": "dashboard/jobs/head-blur-images/schedule/$scheduledJobId/inputs/route.tsx",
      "parent": "/dashboard/jobs/head-blur-images/schedule/$scheduledJobId"
    },
    "/dashboard/jobs/head-blur-images/schedule/$scheduledJobId/overview": {
      "filePath": "dashboard/jobs/head-blur-images/schedule/$scheduledJobId/overview/route.tsx",
      "parent": "/dashboard/jobs/head-blur-images/schedule/$scheduledJobId"
    },
    "/dashboard/jobs/head-blur-images/schedule/$scheduledJobId/schedule": {
      "filePath": "dashboard/jobs/head-blur-images/schedule/$scheduledJobId/schedule/route.tsx",
      "parent": "/dashboard/jobs/head-blur-images/schedule/$scheduledJobId"
    },
    "/dashboard/jobs/head-blur-videos/jobs/$jobId/devices": {
      "filePath": "dashboard/jobs/head-blur-videos/jobs/$jobId/devices/route.tsx",
      "parent": "/dashboard/jobs/head-blur-videos/jobs/$jobId"
    },
    "/dashboard/jobs/head-blur-videos/jobs/$jobId/overview": {
      "filePath": "dashboard/jobs/head-blur-videos/jobs/$jobId/overview/route.tsx",
      "parent": "/dashboard/jobs/head-blur-videos/jobs/$jobId"
    },
    "/dashboard/jobs/head-blur-videos/schedule/$scheduledJobId/inputs": {
      "filePath": "dashboard/jobs/head-blur-videos/schedule/$scheduledJobId/inputs/route.tsx",
      "parent": "/dashboard/jobs/head-blur-videos/schedule/$scheduledJobId"
    },
    "/dashboard/jobs/head-blur-videos/schedule/$scheduledJobId/overview": {
      "filePath": "dashboard/jobs/head-blur-videos/schedule/$scheduledJobId/overview/route.tsx",
      "parent": "/dashboard/jobs/head-blur-videos/schedule/$scheduledJobId"
    },
    "/dashboard/jobs/head-blur-videos/schedule/$scheduledJobId/schedule": {
      "filePath": "dashboard/jobs/head-blur-videos/schedule/$scheduledJobId/schedule/route.tsx",
      "parent": "/dashboard/jobs/head-blur-videos/schedule/$scheduledJobId"
    },
    "/dashboard/jobs/models/jobs/$jobId/devices": {
      "filePath": "dashboard/jobs/models/jobs/$jobId/devices/route.tsx",
      "parent": "/dashboard/jobs/models/jobs/$jobId"
    },
    "/dashboard/jobs/models/jobs/$jobId/overview": {
      "filePath": "dashboard/jobs/models/jobs/$jobId/overview/route.tsx",
      "parent": "/dashboard/jobs/models/jobs/$jobId"
    },
    "/dashboard/jobs/models/schedule/$scheduledJobId/overview": {
      "filePath": "dashboard/jobs/models/schedule/$scheduledJobId/overview/route.tsx",
      "parent": "/dashboard/jobs/models/schedule/$scheduledJobId"
    },
    "/dashboard/jobs/models/schedule/$scheduledJobId/schedule": {
      "filePath": "dashboard/jobs/models/schedule/$scheduledJobId/schedule/route.tsx",
      "parent": "/dashboard/jobs/models/schedule/$scheduledJobId"
    },
    "/dashboard/jobs/recovery-estimates/jobs/$jobId/overview": {
      "filePath": "dashboard/jobs/recovery-estimates/jobs/$jobId/overview/route.tsx",
      "parent": "/dashboard/jobs/recovery-estimates/jobs/$jobId"
    },
    "/dashboard/jobs/recovery-estimates/schedule/$scheduledJobId/inputs": {
      "filePath": "dashboard/jobs/recovery-estimates/schedule/$scheduledJobId/inputs/route.tsx",
      "parent": "/dashboard/jobs/recovery-estimates/schedule/$scheduledJobId"
    },
    "/dashboard/jobs/recovery-estimates/schedule/$scheduledJobId/overview": {
      "filePath": "dashboard/jobs/recovery-estimates/schedule/$scheduledJobId/overview/route.tsx",
      "parent": "/dashboard/jobs/recovery-estimates/schedule/$scheduledJobId"
    },
    "/dashboard/jobs/recovery-estimates/schedule/$scheduledJobId/schedule": {
      "filePath": "dashboard/jobs/recovery-estimates/schedule/$scheduledJobId/schedule/route.tsx",
      "parent": "/dashboard/jobs/recovery-estimates/schedule/$scheduledJobId"
    },
    "/dashboard/jobs/restarts/jobs/$jobId/devices": {
      "filePath": "dashboard/jobs/restarts/jobs/$jobId/devices/route.tsx",
      "parent": "/dashboard/jobs/restarts/jobs/$jobId"
    },
    "/dashboard/jobs/restarts/jobs/$jobId/overview": {
      "filePath": "dashboard/jobs/restarts/jobs/$jobId/overview/route.tsx",
      "parent": "/dashboard/jobs/restarts/jobs/$jobId"
    },
    "/dashboard/jobs/restarts/schedule/$scheduledJobId/overview": {
      "filePath": "dashboard/jobs/restarts/schedule/$scheduledJobId/overview/route.tsx",
      "parent": "/dashboard/jobs/restarts/schedule/$scheduledJobId"
    },
    "/dashboard/jobs/restarts/schedule/$scheduledJobId/schedule": {
      "filePath": "dashboard/jobs/restarts/schedule/$scheduledJobId/schedule/route.tsx",
      "parent": "/dashboard/jobs/restarts/schedule/$scheduledJobId"
    },
    "/dashboard/jobs/sample-upload/jobs/$jobId/devices": {
      "filePath": "dashboard/jobs/sample-upload/jobs/$jobId/devices/route.tsx",
      "parent": "/dashboard/jobs/sample-upload/jobs/$jobId"
    },
    "/dashboard/jobs/sample-upload/jobs/$jobId/overview": {
      "filePath": "dashboard/jobs/sample-upload/jobs/$jobId/overview/route.tsx",
      "parent": "/dashboard/jobs/sample-upload/jobs/$jobId"
    },
    "/dashboard/jobs/sample-upload/schedule/$scheduledJobId/inputs": {
      "filePath": "dashboard/jobs/sample-upload/schedule/$scheduledJobId/inputs/route.tsx",
      "parent": "/dashboard/jobs/sample-upload/schedule/$scheduledJobId"
    },
    "/dashboard/jobs/sample-upload/schedule/$scheduledJobId/overview": {
      "filePath": "dashboard/jobs/sample-upload/schedule/$scheduledJobId/overview/route.tsx",
      "parent": "/dashboard/jobs/sample-upload/schedule/$scheduledJobId"
    },
    "/dashboard/jobs/sample-upload/schedule/$scheduledJobId/schedule": {
      "filePath": "dashboard/jobs/sample-upload/schedule/$scheduledJobId/schedule/route.tsx",
      "parent": "/dashboard/jobs/sample-upload/schedule/$scheduledJobId"
    },
    "/dashboard/jobs/sync-samples/jobs/$jobId/devices": {
      "filePath": "dashboard/jobs/sync-samples/jobs/$jobId/devices/route.tsx",
      "parent": "/dashboard/jobs/sync-samples/jobs/$jobId"
    },
    "/dashboard/jobs/sync-samples/jobs/$jobId/overview": {
      "filePath": "dashboard/jobs/sync-samples/jobs/$jobId/overview/route.tsx",
      "parent": "/dashboard/jobs/sync-samples/jobs/$jobId"
    },
    "/dashboard/jobs/sync-samples/schedule/$scheduledJobId/inputs": {
      "filePath": "dashboard/jobs/sync-samples/schedule/$scheduledJobId/inputs/route.tsx",
      "parent": "/dashboard/jobs/sync-samples/schedule/$scheduledJobId"
    },
    "/dashboard/jobs/sync-samples/schedule/$scheduledJobId/overview": {
      "filePath": "dashboard/jobs/sync-samples/schedule/$scheduledJobId/overview/route.tsx",
      "parent": "/dashboard/jobs/sync-samples/schedule/$scheduledJobId"
    },
    "/dashboard/jobs/sync-samples/schedule/$scheduledJobId/schedule": {
      "filePath": "dashboard/jobs/sync-samples/schedule/$scheduledJobId/schedule/route.tsx",
      "parent": "/dashboard/jobs/sync-samples/schedule/$scheduledJobId"
    },
    "/dashboard/jobs/training/jobs/$jobId/devices": {
      "filePath": "dashboard/jobs/training/jobs/$jobId/devices/route.tsx",
      "parent": "/dashboard/jobs/training/jobs/$jobId"
    },
    "/dashboard/jobs/training/jobs/$jobId/labels": {
      "filePath": "dashboard/jobs/training/jobs/$jobId/labels/route.tsx",
      "parent": "/dashboard/jobs/training/jobs/$jobId"
    },
    "/dashboard/jobs/training/jobs/$jobId/metrics": {
      "filePath": "dashboard/jobs/training/jobs/$jobId/metrics/route.tsx",
      "parent": "/dashboard/jobs/training/jobs/$jobId"
    },
    "/dashboard/jobs/training/jobs/$jobId/overview": {
      "filePath": "dashboard/jobs/training/jobs/$jobId/overview/route.tsx",
      "parent": "/dashboard/jobs/training/jobs/$jobId"
    },
    "/dashboard/jobs/training/schedule/$scheduledJobId/inputs": {
      "filePath": "dashboard/jobs/training/schedule/$scheduledJobId/inputs/route.tsx",
      "parent": "/dashboard/jobs/training/schedule/$scheduledJobId"
    },
    "/dashboard/jobs/training/schedule/$scheduledJobId/overview": {
      "filePath": "dashboard/jobs/training/schedule/$scheduledJobId/overview/route.tsx",
      "parent": "/dashboard/jobs/training/schedule/$scheduledJobId"
    },
    "/dashboard/jobs/training/schedule/$scheduledJobId/schedule": {
      "filePath": "dashboard/jobs/training/schedule/$scheduledJobId/schedule/route.tsx",
      "parent": "/dashboard/jobs/training/schedule/$scheduledJobId"
    },
    "/dashboard/jobs/video-upload/jobs/$jobId/devices": {
      "filePath": "dashboard/jobs/video-upload/jobs/$jobId/devices/route.tsx",
      "parent": "/dashboard/jobs/video-upload/jobs/$jobId"
    },
    "/dashboard/jobs/video-upload/jobs/$jobId/overview": {
      "filePath": "dashboard/jobs/video-upload/jobs/$jobId/overview/route.tsx",
      "parent": "/dashboard/jobs/video-upload/jobs/$jobId"
    },
    "/dashboard/jobs/video-upload/schedule/$scheduledJobId/inputs": {
      "filePath": "dashboard/jobs/video-upload/schedule/$scheduledJobId/inputs/route.tsx",
      "parent": "/dashboard/jobs/video-upload/schedule/$scheduledJobId"
    },
    "/dashboard/jobs/video-upload/schedule/$scheduledJobId/overview": {
      "filePath": "dashboard/jobs/video-upload/schedule/$scheduledJobId/overview/route.tsx",
      "parent": "/dashboard/jobs/video-upload/schedule/$scheduledJobId"
    },
    "/dashboard/jobs/video-upload/schedule/$scheduledJobId/schedule": {
      "filePath": "dashboard/jobs/video-upload/schedule/$scheduledJobId/schedule/route.tsx",
      "parent": "/dashboard/jobs/video-upload/schedule/$scheduledJobId"
    },
    "/dashboard/jobs/worker-jobs/jobs/$jobId/devices": {
      "filePath": "dashboard/jobs/worker-jobs/jobs/$jobId/devices/route.tsx",
      "parent": "/dashboard/jobs/worker-jobs/jobs/$jobId"
    },
    "/dashboard/jobs/worker-jobs/jobs/$jobId/overview": {
      "filePath": "dashboard/jobs/worker-jobs/jobs/$jobId/overview/route.tsx",
      "parent": "/dashboard/jobs/worker-jobs/jobs/$jobId"
    },
    "/dashboard/jobs/worker-jobs/schedule/$scheduledJobId/inputs": {
      "filePath": "dashboard/jobs/worker-jobs/schedule/$scheduledJobId/inputs/route.tsx",
      "parent": "/dashboard/jobs/worker-jobs/schedule/$scheduledJobId"
    },
    "/dashboard/jobs/worker-jobs/schedule/$scheduledJobId/overview": {
      "filePath": "dashboard/jobs/worker-jobs/schedule/$scheduledJobId/overview/route.tsx",
      "parent": "/dashboard/jobs/worker-jobs/schedule/$scheduledJobId"
    },
    "/dashboard/jobs/worker-jobs/schedule/$scheduledJobId/schedule": {
      "filePath": "dashboard/jobs/worker-jobs/schedule/$scheduledJobId/schedule/route.tsx",
      "parent": "/dashboard/jobs/worker-jobs/schedule/$scheduledJobId"
    },
    "/dashboard/resources/devices/$deviceId/data/samples": {
      "filePath": "dashboard/resources/devices/$deviceId/data/samples/route.tsx",
      "parent": "/dashboard/resources/devices/$deviceId/data",
      "children": [
        "/dashboard/resources/devices/$deviceId/data/samples/$sampleId"
      ]
    },
    "/dashboard/resources/devices/$deviceId/data/sessions": {
      "filePath": "dashboard/resources/devices/$deviceId/data/sessions/route.tsx",
      "parent": "/dashboard/resources/devices/$deviceId/data",
      "children": [
        "/dashboard/resources/devices/$deviceId/data/sessions/$sessionId"
      ]
    },
    "/dashboard/resources/devices/$deviceId/data/text-json": {
      "filePath": "dashboard/resources/devices/$deviceId/data/text-json/route.tsx",
      "parent": "/dashboard/resources/devices/$deviceId/data"
    },
    "/dashboard/resources/devices/$deviceId/diagnostics/classifier": {
      "filePath": "dashboard/resources/devices/$deviceId/diagnostics/classifier/route.tsx",
      "parent": "/dashboard/resources/devices/$deviceId/diagnostics"
    },
    "/dashboard/resources/devices/$deviceId/diagnostics/custom": {
      "filePath": "dashboard/resources/devices/$deviceId/diagnostics/custom/route.tsx",
      "parent": "/dashboard/resources/devices/$deviceId/diagnostics"
    },
    "/dashboard/resources/devices/$deviceId/diagnostics/object-detection": {
      "filePath": "dashboard/resources/devices/$deviceId/diagnostics/object-detection/route.tsx",
      "parent": "/dashboard/resources/devices/$deviceId/diagnostics"
    },
    "/dashboard/resources/devices/$deviceId/version-history/agent": {
      "filePath": "dashboard/resources/devices/$deviceId/version-history/agent/route.tsx",
      "parent": "/dashboard/resources/devices/$deviceId/version-history"
    },
    "/dashboard/resources/devices/$deviceId/version-history/detector": {
      "filePath": "dashboard/resources/devices/$deviceId/version-history/detector/route.tsx",
      "parent": "/dashboard/resources/devices/$deviceId/version-history"
    },
    "/dashboard/resources/devices/$deviceId/version-history/models": {
      "filePath": "dashboard/resources/devices/$deviceId/version-history/models/route.tsx",
      "parent": "/dashboard/resources/devices/$deviceId/version-history"
    },
    "/dashboard/resources/devices/$deviceId/version-history/on-screen-app": {
      "filePath": "dashboard/resources/devices/$deviceId/version-history/on-screen-app/route.tsx",
      "parent": "/dashboard/resources/devices/$deviceId/version-history"
    },
    "/dashboard/resources/devices/$deviceId/version-history/trainer": {
      "filePath": "dashboard/resources/devices/$deviceId/version-history/trainer/route.tsx",
      "parent": "/dashboard/resources/devices/$deviceId/version-history"
    },
    "/dashboard/resources/devices/$deviceId/version-history/zebra-adapter": {
      "filePath": "dashboard/resources/devices/$deviceId/version-history/zebra-adapter/route.tsx",
      "parent": "/dashboard/resources/devices/$deviceId/version-history"
    },
    "/dashboard/resources/sites/$siteId/version-history/agent": {
      "filePath": "dashboard/resources/sites/$siteId/version-history/agent/route.tsx",
      "parent": "/dashboard/resources/sites/$siteId/version-history"
    },
    "/dashboard/resources/sites/$siteId/version-history/detector": {
      "filePath": "dashboard/resources/sites/$siteId/version-history/detector/route.tsx",
      "parent": "/dashboard/resources/sites/$siteId/version-history"
    },
    "/dashboard/resources/sites/$siteId/version-history/on-screen-app": {
      "filePath": "dashboard/resources/sites/$siteId/version-history/on-screen-app/route.tsx",
      "parent": "/dashboard/resources/sites/$siteId/version-history"
    },
    "/dashboard/resources/sites/$siteId/version-history/trainer": {
      "filePath": "dashboard/resources/sites/$siteId/version-history/trainer/route.tsx",
      "parent": "/dashboard/resources/sites/$siteId/version-history"
    },
    "/dashboard/resources/sites/$siteId/version-history/zebra-adapter": {
      "filePath": "dashboard/resources/sites/$siteId/version-history/zebra-adapter/route.tsx",
      "parent": "/dashboard/resources/sites/$siteId/version-history"
    },
    "/dashboard/settings/alert-management/alerts/$alertId/overview": {
      "filePath": "dashboard/settings/alert-management/alerts/$alertId/overview/route.tsx",
      "parent": "/dashboard/settings/alert-management/alerts/$alertId"
    },
    "/dashboard/settings/queues/$queueName/failures/$index": {
      "filePath": "dashboard/settings/queues/$queueName/failures/$index/route.tsx",
      "parent": "/dashboard/settings/queues/$queueName/failures"
    },
    "/dashboard/settings/queues/$queueName/pending/$index": {
      "filePath": "dashboard/settings/queues/$queueName/pending/$index/route.tsx",
      "parent": "/dashboard/settings/queues/$queueName/pending"
    },
    "/dashboard/settings/report-subscription/$reportId/$subscriptionId/edit": {
      "filePath": "dashboard/settings/report-subscription/$reportId/$subscriptionId/edit/route.tsx",
      "parent": "/dashboard/settings/report-subscription/$reportId/$subscriptionId"
    },
    "/dashboard/settings/report-subscription/$reportId/$subscriptionId/overview": {
      "filePath": "dashboard/settings/report-subscription/$reportId/$subscriptionId/overview/route.tsx",
      "parent": "/dashboard/settings/report-subscription/$reportId/$subscriptionId"
    },
    "/dashboard/settings/report-subscription/$reportId/$subscriptionId/review-and-approve": {
      "filePath": "dashboard/settings/report-subscription/$reportId/$subscriptionId/review-and-approve/route.tsx",
      "parent": "/dashboard/settings/report-subscription/$reportId/$subscriptionId"
    },
    "/dashboard/settings/report-subscription/$reportId/$subscriptionId/send-history": {
      "filePath": "dashboard/settings/report-subscription/$reportId/$subscriptionId/send-history/route.tsx",
      "parent": "/dashboard/settings/report-subscription/$reportId/$subscriptionId"
    },
    "/dashboard/settings/tags-management/catalog/$tagId/details": {
      "filePath": "dashboard/settings/tags-management/catalog/$tagId/details/route.tsx",
      "parent": "/dashboard/settings/tags-management/catalog/$tagId"
    },
    "/dashboard/settings/tags-management/clusters/$tagId/details": {
      "filePath": "dashboard/settings/tags-management/clusters/$tagId/details/route.tsx",
      "parent": "/dashboard/settings/tags-management/clusters/$tagId"
    },
    "/dashboard/settings/tags-management/devices/$tagId/details": {
      "filePath": "dashboard/settings/tags-management/devices/$tagId/details/route.tsx",
      "parent": "/dashboard/settings/tags-management/devices/$tagId"
    },
    "/dashboard/settings/tags-management/samples/$tagId/details": {
      "filePath": "dashboard/settings/tags-management/samples/$tagId/details/route.tsx",
      "parent": "/dashboard/settings/tags-management/samples/$tagId"
    },
    "/dashboard/settings/tags-management/sessions/$tagId/details": {
      "filePath": "dashboard/settings/tags-management/sessions/$tagId/details/route.tsx",
      "parent": "/dashboard/settings/tags-management/sessions/$tagId"
    },
    "/dashboard/settings/tags-management/sites/$tagId/details": {
      "filePath": "dashboard/settings/tags-management/sites/$tagId/details/route.tsx",
      "parent": "/dashboard/settings/tags-management/sites/$tagId"
    },
    "/admin-dashboard/jobs/service-health-checks/jobs/$jobId/": {
      "filePath": "admin-dashboard/jobs/service-health-checks/jobs/$jobId/index.tsx",
      "parent": "/admin-dashboard/jobs/service-health-checks/jobs/$jobId"
    },
    "/admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId/": {
      "filePath": "admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId/index.tsx",
      "parent": "/admin-dashboard/jobs/service-health-checks/schedule/$scheduledJobId"
    },
    "/dashboard/jobs/camera-calibration/jobs/$jobId/": {
      "filePath": "dashboard/jobs/camera-calibration/jobs/$jobId/index.tsx",
      "parent": "/dashboard/jobs/camera-calibration/jobs/$jobId"
    },
    "/dashboard/jobs/camera-calibration/schedule/$scheduledJobId/": {
      "filePath": "dashboard/jobs/camera-calibration/schedule/$scheduledJobId/index.tsx",
      "parent": "/dashboard/jobs/camera-calibration/schedule/$scheduledJobId"
    },
    "/dashboard/jobs/capacity-tagging/jobs/$jobId/": {
      "filePath": "dashboard/jobs/capacity-tagging/jobs/$jobId/index.tsx",
      "parent": "/dashboard/jobs/capacity-tagging/jobs/$jobId"
    },
    "/dashboard/jobs/capacity-tagging/schedule/$scheduledJobId/": {
      "filePath": "dashboard/jobs/capacity-tagging/schedule/$scheduledJobId/index.tsx",
      "parent": "/dashboard/jobs/capacity-tagging/schedule/$scheduledJobId"
    },
    "/dashboard/jobs/catalog-upload/jobs/$jobId/": {
      "filePath": "dashboard/jobs/catalog-upload/jobs/$jobId/index.tsx",
      "parent": "/dashboard/jobs/catalog-upload/jobs/$jobId"
    },
    "/dashboard/jobs/catalog-upload/schedule/$scheduledJobId/": {
      "filePath": "dashboard/jobs/catalog-upload/schedule/$scheduledJobId/index.tsx",
      "parent": "/dashboard/jobs/catalog-upload/schedule/$scheduledJobId"
    },
    "/dashboard/jobs/config/jobs/$jobId/": {
      "filePath": "dashboard/jobs/config/jobs/$jobId/index.tsx",
      "parent": "/dashboard/jobs/config/jobs/$jobId"
    },
    "/dashboard/jobs/config/schedule/$scheduledJobId/": {
      "filePath": "dashboard/jobs/config/schedule/$scheduledJobId/index.tsx",
      "parent": "/dashboard/jobs/config/schedule/$scheduledJobId"
    },
    "/dashboard/jobs/delete-samples/jobs/$jobId/": {
      "filePath": "dashboard/jobs/delete-samples/jobs/$jobId/index.tsx",
      "parent": "/dashboard/jobs/delete-samples/jobs/$jobId"
    },
    "/dashboard/jobs/delete-samples/schedule/$scheduledJobId/": {
      "filePath": "dashboard/jobs/delete-samples/schedule/$scheduledJobId/index.tsx",
      "parent": "/dashboard/jobs/delete-samples/schedule/$scheduledJobId"
    },
    "/dashboard/jobs/delete-videos/jobs/$jobId/": {
      "filePath": "dashboard/jobs/delete-videos/jobs/$jobId/index.tsx",
      "parent": "/dashboard/jobs/delete-videos/jobs/$jobId"
    },
    "/dashboard/jobs/delete-videos/schedule/$scheduledJobId/": {
      "filePath": "dashboard/jobs/delete-videos/schedule/$scheduledJobId/index.tsx",
      "parent": "/dashboard/jobs/delete-videos/schedule/$scheduledJobId"
    },
    "/dashboard/jobs/deployments/jobs/$jobId/": {
      "filePath": "dashboard/jobs/deployments/jobs/$jobId/index.tsx",
      "parent": "/dashboard/jobs/deployments/jobs/$jobId"
    },
    "/dashboard/jobs/deployments/schedule/$scheduledJobId/": {
      "filePath": "dashboard/jobs/deployments/schedule/$scheduledJobId/index.tsx",
      "parent": "/dashboard/jobs/deployments/schedule/$scheduledJobId"
    },
    "/dashboard/jobs/head-blur-images/jobs/$jobId/": {
      "filePath": "dashboard/jobs/head-blur-images/jobs/$jobId/index.tsx",
      "parent": "/dashboard/jobs/head-blur-images/jobs/$jobId"
    },
    "/dashboard/jobs/head-blur-images/schedule/$scheduledJobId/": {
      "filePath": "dashboard/jobs/head-blur-images/schedule/$scheduledJobId/index.tsx",
      "parent": "/dashboard/jobs/head-blur-images/schedule/$scheduledJobId"
    },
    "/dashboard/jobs/head-blur-videos/jobs/$jobId/": {
      "filePath": "dashboard/jobs/head-blur-videos/jobs/$jobId/index.tsx",
      "parent": "/dashboard/jobs/head-blur-videos/jobs/$jobId"
    },
    "/dashboard/jobs/head-blur-videos/schedule/$scheduledJobId/": {
      "filePath": "dashboard/jobs/head-blur-videos/schedule/$scheduledJobId/index.tsx",
      "parent": "/dashboard/jobs/head-blur-videos/schedule/$scheduledJobId"
    },
    "/dashboard/jobs/models/jobs/$jobId/": {
      "filePath": "dashboard/jobs/models/jobs/$jobId/index.tsx",
      "parent": "/dashboard/jobs/models/jobs/$jobId"
    },
    "/dashboard/jobs/models/schedule/$scheduledJobId/": {
      "filePath": "dashboard/jobs/models/schedule/$scheduledJobId/index.tsx",
      "parent": "/dashboard/jobs/models/schedule/$scheduledJobId"
    },
    "/dashboard/jobs/recovery-estimates/jobs/$jobId/": {
      "filePath": "dashboard/jobs/recovery-estimates/jobs/$jobId/index.tsx",
      "parent": "/dashboard/jobs/recovery-estimates/jobs/$jobId"
    },
    "/dashboard/jobs/recovery-estimates/schedule/$scheduledJobId/": {
      "filePath": "dashboard/jobs/recovery-estimates/schedule/$scheduledJobId/index.tsx",
      "parent": "/dashboard/jobs/recovery-estimates/schedule/$scheduledJobId"
    },
    "/dashboard/jobs/restarts/jobs/$jobId/": {
      "filePath": "dashboard/jobs/restarts/jobs/$jobId/index.tsx",
      "parent": "/dashboard/jobs/restarts/jobs/$jobId"
    },
    "/dashboard/jobs/restarts/schedule/$scheduledJobId/": {
      "filePath": "dashboard/jobs/restarts/schedule/$scheduledJobId/index.tsx",
      "parent": "/dashboard/jobs/restarts/schedule/$scheduledJobId"
    },
    "/dashboard/jobs/sample-upload/jobs/$jobId/": {
      "filePath": "dashboard/jobs/sample-upload/jobs/$jobId/index.tsx",
      "parent": "/dashboard/jobs/sample-upload/jobs/$jobId"
    },
    "/dashboard/jobs/sample-upload/schedule/$scheduledJobId/": {
      "filePath": "dashboard/jobs/sample-upload/schedule/$scheduledJobId/index.tsx",
      "parent": "/dashboard/jobs/sample-upload/schedule/$scheduledJobId"
    },
    "/dashboard/jobs/sync-samples/jobs/$jobId/": {
      "filePath": "dashboard/jobs/sync-samples/jobs/$jobId/index.tsx",
      "parent": "/dashboard/jobs/sync-samples/jobs/$jobId"
    },
    "/dashboard/jobs/sync-samples/schedule/$scheduledJobId/": {
      "filePath": "dashboard/jobs/sync-samples/schedule/$scheduledJobId/index.tsx",
      "parent": "/dashboard/jobs/sync-samples/schedule/$scheduledJobId"
    },
    "/dashboard/jobs/training/jobs/$jobId/": {
      "filePath": "dashboard/jobs/training/jobs/$jobId/index.tsx",
      "parent": "/dashboard/jobs/training/jobs/$jobId"
    },
    "/dashboard/jobs/training/schedule/$scheduledJobId/": {
      "filePath": "dashboard/jobs/training/schedule/$scheduledJobId/index.tsx",
      "parent": "/dashboard/jobs/training/schedule/$scheduledJobId"
    },
    "/dashboard/jobs/video-upload/jobs/$jobId/": {
      "filePath": "dashboard/jobs/video-upload/jobs/$jobId/index.tsx",
      "parent": "/dashboard/jobs/video-upload/jobs/$jobId"
    },
    "/dashboard/jobs/video-upload/schedule/$scheduledJobId/": {
      "filePath": "dashboard/jobs/video-upload/schedule/$scheduledJobId/index.tsx",
      "parent": "/dashboard/jobs/video-upload/schedule/$scheduledJobId"
    },
    "/dashboard/jobs/worker-jobs/jobs/$jobId/": {
      "filePath": "dashboard/jobs/worker-jobs/jobs/$jobId/index.tsx",
      "parent": "/dashboard/jobs/worker-jobs/jobs/$jobId"
    },
    "/dashboard/jobs/worker-jobs/schedule/$scheduledJobId/": {
      "filePath": "dashboard/jobs/worker-jobs/schedule/$scheduledJobId/index.tsx",
      "parent": "/dashboard/jobs/worker-jobs/schedule/$scheduledJobId"
    },
    "/dashboard/resources/devices/$deviceId/data/": {
      "filePath": "dashboard/resources/devices/$deviceId/data/index.tsx",
      "parent": "/dashboard/resources/devices/$deviceId/data"
    },
    "/dashboard/resources/devices/$deviceId/version-history/": {
      "filePath": "dashboard/resources/devices/$deviceId/version-history/index.tsx",
      "parent": "/dashboard/resources/devices/$deviceId/version-history"
    },
    "/dashboard/resources/sites/$siteId/version-history/": {
      "filePath": "dashboard/resources/sites/$siteId/version-history/index.tsx",
      "parent": "/dashboard/resources/sites/$siteId/version-history"
    },
    "/dashboard/settings/alert-management/alerts/$alertId/": {
      "filePath": "dashboard/settings/alert-management/alerts/$alertId/index.tsx",
      "parent": "/dashboard/settings/alert-management/alerts/$alertId"
    },
    "/dashboard/settings/alert-management/metric-alerts/$metricAlertId/": {
      "filePath": "dashboard/settings/alert-management/metric-alerts/$metricAlertId/index.tsx",
      "parent": "/dashboard/settings/alert-management/metric-alerts"
    },
    "/dashboard/settings/report-subscription/$reportId/$subscriptionId/": {
      "filePath": "dashboard/settings/report-subscription/$reportId/$subscriptionId/index.tsx",
      "parent": "/dashboard/settings/report-subscription/$reportId/$subscriptionId"
    },
    "/dashboard/settings/tags-management/catalog/$tagId/": {
      "filePath": "dashboard/settings/tags-management/catalog/$tagId/index.tsx",
      "parent": "/dashboard/settings/tags-management/catalog/$tagId"
    },
    "/dashboard/settings/tags-management/clusters/$tagId/": {
      "filePath": "dashboard/settings/tags-management/clusters/$tagId/index.tsx",
      "parent": "/dashboard/settings/tags-management/clusters/$tagId"
    },
    "/dashboard/settings/tags-management/devices/$tagId/": {
      "filePath": "dashboard/settings/tags-management/devices/$tagId/index.tsx",
      "parent": "/dashboard/settings/tags-management/devices/$tagId"
    },
    "/dashboard/settings/tags-management/samples/$tagId/": {
      "filePath": "dashboard/settings/tags-management/samples/$tagId/index.tsx",
      "parent": "/dashboard/settings/tags-management/samples/$tagId"
    },
    "/dashboard/settings/tags-management/sessions/$tagId/": {
      "filePath": "dashboard/settings/tags-management/sessions/$tagId/index.tsx",
      "parent": "/dashboard/settings/tags-management/sessions/$tagId"
    },
    "/dashboard/settings/tags-management/sites/$tagId/": {
      "filePath": "dashboard/settings/tags-management/sites/$tagId/index.tsx",
      "parent": "/dashboard/settings/tags-management/sites/$tagId"
    },
    "/dashboard/resources/devices/$deviceId/data/samples/$sampleId": {
      "filePath": "dashboard/resources/devices/$deviceId/data/samples/$sampleId/route.tsx",
      "parent": "/dashboard/resources/devices/$deviceId/data/samples",
      "children": [
        "/dashboard/resources/devices/$deviceId/data/samples/$sampleId/"
      ]
    },
    "/dashboard/resources/devices/$deviceId/data/sessions/$sessionId": {
      "filePath": "dashboard/resources/devices/$deviceId/data/sessions/$sessionId/route.tsx",
      "parent": "/dashboard/resources/devices/$deviceId/data/sessions",
      "children": [
        "/dashboard/resources/devices/$deviceId/data/sessions/$sessionId/"
      ]
    },
    "/dashboard/resources/devices/$deviceId/data/samples/$sampleId/": {
      "filePath": "dashboard/resources/devices/$deviceId/data/samples/$sampleId/index.tsx",
      "parent": "/dashboard/resources/devices/$deviceId/data/samples/$sampleId"
    },
    "/dashboard/resources/devices/$deviceId/data/sessions/$sessionId/": {
      "filePath": "dashboard/resources/devices/$deviceId/data/sessions/$sessionId/index.tsx",
      "parent": "/dashboard/resources/devices/$deviceId/data/sessions/$sessionId"
    }
  }
}
ROUTE_MANIFEST_END */
